webpackJsonp([0,9],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    isEmpty = _require.isEmpty;

function TealiumEvent() {
    this.data = {
        event: {
            ScreenName: '',
            Label: '',
            Value: '',
            Name: ''
        },
        trackingType: ''
    };
    this.type = '';
}

function TealiumEventBuilder() {
    this._tealiumEvent = new TealiumEvent();
    this.withEventType = function (eventType) {
        this._tealiumEvent.type = eventType;
        return this;
    };

    this.withEventName = function (eventName) {
        this._tealiumEvent.data.event.Name = eventName;
        return this;
    };

    this.withScreenName = function (screenName) {
        this._tealiumEvent.data.event.ScreenName = screenName;
        return this;
    };

    this.withLabel = function (label) {
        this._tealiumEvent.data.event.Label = label;
        return this;
    };

    this.withValue = function (value) {
        this._tealiumEvent.data.event.Value = value;
        return this;
    };

    this.withAction = function (value) {
        this._tealiumEvent.data.event.Action = value;
        return this;
    };

    this.withTrackingType = function (value) {
        this._tealiumEvent.data.trackingType = value;
        return this;
    };

    this.build = function () {
        if (isEmpty(this._tealiumEvent.type)) {
            console.warn('**ERROR TEALIUM** Must set the Tealium EventType or the event wont fire due to missing mapper!');
        }
        return this._tealiumEvent;
    };
}

module.exports = TealiumEventBuilder;

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0);

var RrPageGroupFeaturePrefix = 'rrShowPlacementsIn';
var RrPageGroupFeatureSuffix = 'Pages';

var RichRelevanceBaseInstrumentationController = function () {
    function RichRelevanceBaseInstrumentationController($scope, $window, featureService, richRelevanceService, config) {
        _classCallCheck(this, RichRelevanceBaseInstrumentationController);

        this.$scope = $scope;
        this.$window = $window;
        this.featureService = featureService;
        this.richRelevanceService = richRelevanceService;

        // attributes from the component.
        // each controller must declare these
        // so we can use them to decide whether to
        // add placement types.
        this.pageGroup = null;
        this.placementIds = null;

        this.initialize(_.extend(this.getDefaultConfig(), config));
    }

    _createClass(RichRelevanceBaseInstrumentationController, [{
        key: 'getDefaultConfig',
        value: function getDefaultConfig() {
            return {
                // when enabled, calls the subclass implementation of
                // sendInstrumentation() when $stateChangeSuccess (ui-router)
                // occurs. Disable this if the state change isn't required or
                // the subclass implements this on its own.
                // eg: category-instrumentaion-component
                instrumentOnStateChange: true
            };
        }
    }, {
        key: 'initialize',
        value: function initialize(config) {
            var _this = this;

            if (config.instrumentOnStateChange) {
                this.$scope.$on('$stateChangeSuccess', function () {
                    // sub class must implement sendInstrumentaton
                    // and perform the RR instrumentation call.
                    _this.sendInstrumentation();
                });
            }
        }
    }, {
        key: 'addPlacementTypesIfEnabled',
        value: function addPlacementTypesIfEnabled() {
            var _this2 = this;

            this.placementTypes().forEach(function (placementId) {
                _this2.$window.R3_COMMON.addPlacementType(placementId);
                _this2.richRelevanceService.recordPlacementsRequested(placementId);
            });
        }
    }, {
        key: 'placementTypes',
        value: function placementTypes() {
            var _this3 = this;

            if (!this.pageGroup || !this.placementIds) {
                return [];
            }

            var featureEnabled = this.pageFeatureEnabled();
            if (!featureEnabled) {
                return [];
            }

            return this.placementIds.split(',').map(function (placementId) {
                return _this3.richRelevanceService.getEffectivePlacementId(placementId.trim());
            });
        }
    }, {
        key: 'pageFeatureEnabled',
        value: function pageFeatureEnabled() {
            // corresponding feature is [prefix][pageGroup][suffix]
            // eg: rrShowPlacementsInHomepagePages
            return this.featureService.isEnabled(this.featureService.features['' + RrPageGroupFeaturePrefix + this.pageGroup + RrPageGroupFeatureSuffix]);
        }
    }]);

    return RichRelevanceBaseInstrumentationController;
}();

module.exports = RichRelevanceBaseInstrumentationController;

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(31);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = "<main id=\"center-panel\" class=\"shop-centerPanel\" tabindex=\"-1\">\r\n    <oly-dynamic-content oly-dc-global-schedule class=\"dynamic-content2-panelTopGlobal\"></oly-dynamic-content>\r\n\r\n    <oly-dynamic-content oly-dc-url-schedule class=\"dynamic-content2-panelTop\"></oly-dynamic-content>\r\n\r\n    <div ui-view=\"center-panel\"></div>\r\n\r\n    <oly-dynamic-content oly-dc-url-schedule=\"bottom\" class=\"dynamic-content2-panelBottom\"></oly-dynamic-content>\r\n</main>\r\n"

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    forEach = _require.forEach,
    remove = _require.remove,
    _require2 = __webpack_require__(32),
    createInspirationTiles = _require2.createInspirationTiles;

function removeAdsFromTiles(tiles) {
    var ads = [];

    remove(tiles, function (tile, index) {
        if (tile.type !== 'product') return false;

        if (tile.data.product.IsSponsoredAd) {
            ads.push({
                index: index,
                tile: tile
            });
        }

        return tile.data.product.IsSponsoredAd;
    });

    return ads;
}

function mergeInspirationTiles(cards, inspirationTiles, _ref) {
    var pageNumber = _ref.pageNumber,
        _ref$pageSize = _ref.pageSize,
        pageSize = _ref$pageSize === undefined ? Number.MAX_VALUE : _ref$pageSize,
        type = _ref.type;
    var enableAdsPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var ads = enableAdsPosition ? removeAdsFromTiles(cards) : []; // Let ads take priority if the feature switch is on
    var pageOffset = pageNumber != null ? pageSize * (pageNumber - 1) : 0;

    // Merge inspiration cards with actual cards
    forEach(inspirationTiles, function (inspTiles, position) {
        position = parseInt(position, 10) - pageOffset;

        if (position < 0 || position >= pageSize) return;

        Array.prototype.splice.apply(cards, [position, 0].concat(createInspirationTiles(inspTiles, type)));
    });

    // Put ads back to tile with correct position if existed
    if (ads.length > 0) {
        forEach(ads, function (ad) {
            Array.prototype.splice.apply(cards, [ad.index, 0, ad.tile]);
        });
    }

    return cards;
}

module.exports = { mergeInspirationTiles: mergeInspirationTiles };

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "<aside id=\"right-panel\" class=\"shop-rightPanel\" tabindex=\"-1\" ng-if=\"$breakpoints.isInGreaterThanMediumFormatLandscape\">\r\n    <wow-cart-offscreen></wow-cart-offscreen>\r\n</aside>\r\n"

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    map = _require.map;

function createRecipeTile(recipe) {
    return {
        id: recipe.ID,
        type: 'recipe',
        data: { recipe: recipe }
    };
}

function createRecipeTiles(recipes) {
    return map(recipes, createRecipeTile);
}

module.exports = {
    createRecipeTile: createRecipeTile,
    createRecipeTiles: createRecipeTiles
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    reduce = _require.reduce;

var categoryLevels = Object.freeze(['department', 'category', 'subcategory']);
var categoryLevelIndexes = Object.freeze(reduce(categoryLevels, function (result, key, val) {
    result[key] = val;
    return result;
}, {}));

module.exports = {
    categoryLevels: categoryLevels,
    categoryLevelIndexes: categoryLevelIndexes
};

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var serverErrors = {};

serverErrors.fillForm = function (form, responseErrors, parentObject) {
    parentObject.serverErrors = {};

    // This is for the way signup is structured only. If possible, use the forEach beneath.
    _.forEach(form, function (n, key) {
        // Check if there exists that key in the error object
        if (responseErrors[key]) {
            // set a server error
            form[key].$setValidity('serverError', false);
        } else if (key[0] !== '$') {
            // Input fields do not start with a $
            // clear any server error
            form[key].$setValidity('serverError', true);
        }
    });

    // Set any remaining messages.
    _.forEach(responseErrors, function (n) {
        // Deal with the fact that some responses come back differently
        if (form[n.FieldName]) {
            form[n.FieldName].$setValidity('serverError', false);
        }
        // Set overall message
        parentObject.serverErrors[n.FieldName] = n.Message;
    });
};

serverErrors.clearForm = function (form, parentObject) {
    parentObject.serverErrors = {};

    _.forEach(form, function (n, key) {
        if (key[0] !== '$') {
            form[key].$setValidity('serverError', true);
        }
    });
};

module.exports = serverErrors;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    map = _require.map;

function createInspirationTile(inspirationTile) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'inspiration';

    return {
        id: inspirationTile.ID,
        type: type,
        data: { inspirationTile: inspirationTile }
    };
}

function createInspirationTiles(inspirationTiles, type) {
    return map(inspirationTiles, function (inspirationTile) {
        return createInspirationTile(inspirationTile, type);
    });
}

module.exports = {
    createInspirationTile: createInspirationTile,
    createInspirationTiles: createInspirationTiles
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trolleyQuantityValidation = {
    INVALID_QUANTITY: 'InvalidQuantity',
    SUPPLY_LIMIT_EXCEEDED: 'QtyIsGreater',
    DELIVERY_PASS_LIMIT_EXCEEDED: 'DeliveryPassLimit'
};

module.exports = { trolleyQuantityValidation: trolleyQuantityValidation };

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    STOCK_CHECKER_DISPLAY_MODE: {
        STOCK_CHECKER: 'StockChecker',
        STORE_SWITCHER: 'StoreSwitcher'
    },
    MHSF: 'MHSF'
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    clone = _require.clone,
    nth = _require.nth,
    last = _require.last,
    some = _require.some;

var CategoriesConstants = __webpack_require__(27);

var CategorySelectionList = function () {
    function CategorySelectionList() {
        var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _classCallCheck(this, CategorySelectionList);

        this.value = clone(categories);
    }

    _createClass(CategorySelectionList, [{
        key: 'popCategory',
        value: function popCategory() {
            this.value = clone(this.value);
            this.value.pop();
        }
    }, {
        key: 'pushCategory',
        value: function pushCategory(category) {
            this.value = clone(this.value);
            this.value.push(category);
        }
    }, {
        key: 'isActive',
        value: function isActive(categoryNodeId) {
            return some(this.value, function (category) {
                return category.NodeId === categoryNodeId;
            });
        }
    }, {
        key: 'clone',
        value: function clone() {
            return new CategorySelectionList(this.value);
        }
    }, {
        key: 'hasSelectedCategories',
        get: function get() {
            return this.value.length > 0;
        }
    }, {
        key: 'department',
        get: function get() {
            return nth(this.value, CategoriesConstants.categoryLevelIndexes.department);
        }
    }, {
        key: 'category',
        get: function get() {
            return nth(this.value, CategoriesConstants.categoryLevelIndexes.category);
        }
    }, {
        key: 'subcategory',
        get: function get() {
            return nth(this.value, CategoriesConstants.categoryLevelIndexes.subcategory);
        }
    }, {
        key: 'current',
        get: function get() {
            return last(this.value);
        }
    }]);

    return CategorySelectionList;
}();

module.exports = CategorySelectionList;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return function () {
        var deliverySaverPlan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (deliverySaverPlan.BillingFrequencyDays === 0) {
            switch (deliverySaverPlan.BillingFrequencyMonths) {
                case 1:
                    return 'Monthly Subscription';
                case 12:
                    return 'Annual Subscription';
            }
        } else if (deliverySaverPlan.BillingFrequencyMonths === 0) {
            switch (deliverySaverPlan.BillingFrequencyDays) {
                case 1:
                    return 'Daily Subscription';
                case 7:
                    return 'Weekly Subscription';
            }
        }
        return deliverySaverPlan.Name;
    };
};

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports) {

/**
 * oclazyload - Load modules on demand (lazy load) with angularJS
 * @version v1.0.9
 * @link https://github.com/ocombe/ocLazyLoad
 * @license MIT
 * @author Olivier Combe <olivier.combe@gmail.com>
 */
(function (angular, window) {
    'use strict';

    var regModules = ['ng', 'oc.lazyLoad'],
        regInvokes = {},
        regConfigs = [],
        modulesToLoad = [],
        // modules to load from angular.module or other sources
    realModules = [],
        // real modules called from angular.module
    recordDeclarations = [],
        broadcast = angular.noop,
        runBlocks = {},
        justLoaded = [];

    var ocLazyLoad = angular.module('oc.lazyLoad', ['ng']);

    ocLazyLoad.provider('$ocLazyLoad', ["$controllerProvider", "$provide", "$compileProvider", "$filterProvider", "$injector", "$animateProvider", function ($controllerProvider, $provide, $compileProvider, $filterProvider, $injector, $animateProvider) {
        var modules = {},
            providers = {
            $controllerProvider: $controllerProvider,
            $compileProvider: $compileProvider,
            $filterProvider: $filterProvider,
            $provide: $provide, // other things (constant, decorator, provider, factory, service)
            $injector: $injector,
            $animateProvider: $animateProvider
        },
            debug = false,
            events = false,
            moduleCache = [],
            modulePromises = {};

        moduleCache.push = function (value) {
            if (this.indexOf(value) === -1) {
                Array.prototype.push.apply(this, arguments);
            }
        };

        this.config = function (config) {
            // If we want to define modules configs
            if (angular.isDefined(config.modules)) {
                if (angular.isArray(config.modules)) {
                    angular.forEach(config.modules, function (moduleConfig) {
                        modules[moduleConfig.name] = moduleConfig;
                    });
                } else {
                    modules[config.modules.name] = config.modules;
                }
            }

            if (angular.isDefined(config.debug)) {
                debug = config.debug;
            }

            if (angular.isDefined(config.events)) {
                events = config.events;
            }
        };

        /**
         * Get the list of existing registered modules
         * @param element
         */
        this._init = function _init(element) {
            // this is probably useless now because we override angular.bootstrap
            if (modulesToLoad.length === 0) {
                var elements = [element],
                    names = ['ng:app', 'ng-app', 'x-ng-app', 'data-ng-app'],
                    NG_APP_CLASS_REGEXP = /\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,
                    append = function append(elm) {
                    return elm && elements.push(elm);
                };

                angular.forEach(names, function (name) {
                    names[name] = true;
                    append(document.getElementById(name));
                    name = name.replace(':', '\\:');
                    if (typeof element[0] !== 'undefined' && element[0].querySelectorAll) {
                        angular.forEach(element[0].querySelectorAll('.' + name), append);
                        angular.forEach(element[0].querySelectorAll('.' + name + '\\:'), append);
                        angular.forEach(element[0].querySelectorAll('[' + name + ']'), append);
                    }
                });

                angular.forEach(elements, function (elm) {
                    if (modulesToLoad.length === 0) {
                        var className = ' ' + element.className + ' ';
                        var match = NG_APP_CLASS_REGEXP.exec(className);
                        if (match) {
                            modulesToLoad.push((match[2] || '').replace(/\s+/g, ','));
                        } else {
                            angular.forEach(elm.attributes, function (attr) {
                                if (modulesToLoad.length === 0 && names[attr.name]) {
                                    modulesToLoad.push(attr.value);
                                }
                            });
                        }
                    }
                });
            }

            if (modulesToLoad.length === 0 && !((window.jasmine || window.mocha) && angular.isDefined(angular.mock))) {
                console.error('No module found during bootstrap, unable to init ocLazyLoad. You should always use the ng-app directive or angular.boostrap when you use ocLazyLoad.');
            }

            var addReg = function addReg(moduleName) {
                if (regModules.indexOf(moduleName) === -1) {
                    // register existing modules
                    regModules.push(moduleName);
                    var mainModule = angular.module(moduleName);

                    // register existing components (directives, services, ...)
                    _invokeQueue(null, mainModule._invokeQueue, moduleName);
                    _invokeQueue(null, mainModule._configBlocks, moduleName); // angular 1.3+

                    angular.forEach(mainModule.requires, addReg);
                }
            };

            angular.forEach(modulesToLoad, function (moduleName) {
                addReg(moduleName);
            });

            modulesToLoad = []; // reset for next bootstrap
            recordDeclarations.pop(); // wait for the next lazy load
        };

        /**
         * Like JSON.stringify but that doesn't throw on circular references
         * @param obj
         */
        var stringify = function stringify(obj) {
            try {
                return JSON.stringify(obj);
            } catch (e) {
                var cache = [];
                return JSON.stringify(obj, function (key, value) {
                    if (angular.isObject(value) && value !== null) {
                        if (cache.indexOf(value) !== -1) {
                            // Circular reference found, discard key
                            return;
                        }
                        // Store value in our collection
                        cache.push(value);
                    }
                    return value;
                });
            }
        };

        var hashCode = function hashCode(str) {
            var hash = 0,
                i,
                chr,
                len;
            if (str.length == 0) {
                return hash;
            }
            for (i = 0, len = str.length; i < len; i++) {
                chr = str.charCodeAt(i);
                hash = (hash << 5) - hash + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        };

        function _register(providers, registerModules, params) {
            if (registerModules) {
                var k,
                    moduleName,
                    moduleFn,
                    tempRunBlocks = [];
                for (k = registerModules.length - 1; k >= 0; k--) {
                    moduleName = registerModules[k];
                    if (!angular.isString(moduleName)) {
                        moduleName = getModuleName(moduleName);
                    }
                    if (!moduleName || justLoaded.indexOf(moduleName) !== -1 || modules[moduleName] && realModules.indexOf(moduleName) === -1) {
                        continue;
                    }
                    // new if not registered
                    var newModule = regModules.indexOf(moduleName) === -1;
                    moduleFn = ngModuleFct(moduleName);
                    if (newModule) {
                        regModules.push(moduleName);
                        _register(providers, moduleFn.requires, params);
                    }
                    if (moduleFn._runBlocks.length > 0) {
                        // new run blocks detected! Replace the old ones (if existing)
                        runBlocks[moduleName] = [];
                        while (moduleFn._runBlocks.length > 0) {
                            runBlocks[moduleName].push(moduleFn._runBlocks.shift());
                        }
                    }
                    if (angular.isDefined(runBlocks[moduleName]) && (newModule || params.rerun)) {
                        tempRunBlocks = tempRunBlocks.concat(runBlocks[moduleName]);
                    }
                    _invokeQueue(providers, moduleFn._invokeQueue, moduleName, params.reconfig);
                    _invokeQueue(providers, moduleFn._configBlocks, moduleName, params.reconfig); // angular 1.3+
                    broadcast(newModule ? 'ocLazyLoad.moduleLoaded' : 'ocLazyLoad.moduleReloaded', moduleName);
                    registerModules.pop();
                    justLoaded.push(moduleName);
                }
                // execute the run blocks at the end
                var instanceInjector = providers.getInstanceInjector();
                angular.forEach(tempRunBlocks, function (fn) {
                    instanceInjector.invoke(fn);
                });
            }
        }

        function _registerInvokeList(args, moduleName) {
            var invokeList = args[2][0],
                type = args[1],
                newInvoke = false;
            if (angular.isUndefined(regInvokes[moduleName])) {
                regInvokes[moduleName] = {};
            }
            if (angular.isUndefined(regInvokes[moduleName][type])) {
                regInvokes[moduleName][type] = {};
            }
            var onInvoke = function onInvoke(invokeName, invoke) {
                if (!regInvokes[moduleName][type].hasOwnProperty(invokeName)) {
                    regInvokes[moduleName][type][invokeName] = [];
                }
                if (checkHashes(invoke, regInvokes[moduleName][type][invokeName])) {
                    newInvoke = true;
                    regInvokes[moduleName][type][invokeName].push(invoke);
                    broadcast('ocLazyLoad.componentLoaded', [moduleName, type, invokeName]);
                }
            };

            function checkHashes(potentialNew, invokes) {
                var isNew = true,
                    newHash;
                if (invokes.length) {
                    newHash = signature(potentialNew);
                    angular.forEach(invokes, function (invoke) {
                        isNew = isNew && signature(invoke) !== newHash;
                    });
                }
                return isNew;
            }

            function signature(data) {
                if (angular.isArray(data)) {
                    // arrays are objects, we need to test for it first
                    return hashCode(data.toString());
                } else if (angular.isObject(data)) {
                    // constants & values for example
                    return hashCode(stringify(data));
                } else {
                    if (angular.isDefined(data) && data !== null) {
                        return hashCode(data.toString());
                    } else {
                        // null & undefined constants
                        return data;
                    }
                }
            }

            if (angular.isString(invokeList)) {
                onInvoke(invokeList, args[2][1]);
            } else if (angular.isObject(invokeList)) {
                angular.forEach(invokeList, function (invoke, key) {
                    if (angular.isString(invoke)) {
                        // decorators for example
                        onInvoke(invoke, invokeList[1]);
                    } else {
                        // components registered as object lists {"componentName": function() {}}
                        onInvoke(key, invoke);
                    }
                });
            } else {
                return false;
            }
            return newInvoke;
        }

        function _invokeQueue(providers, queue, moduleName, reconfig) {
            if (!queue) {
                return;
            }

            var i, len, args, provider;
            for (i = 0, len = queue.length; i < len; i++) {
                args = queue[i];
                if (angular.isArray(args)) {
                    if (providers !== null) {
                        if (providers.hasOwnProperty(args[0])) {
                            provider = providers[args[0]];
                        } else {
                            throw new Error('unsupported provider ' + args[0]);
                        }
                    }
                    var isNew = _registerInvokeList(args, moduleName);
                    if (args[1] !== 'invoke') {
                        if (isNew && angular.isDefined(provider)) {
                            provider[args[1]].apply(provider, args[2]);
                        }
                    } else {
                        // config block
                        var callInvoke = function callInvoke(fct) {
                            var invoked = regConfigs.indexOf(moduleName + '-' + fct);
                            if (invoked === -1 || reconfig) {
                                if (invoked === -1) {
                                    regConfigs.push(moduleName + '-' + fct);
                                }
                                if (angular.isDefined(provider)) {
                                    provider[args[1]].apply(provider, args[2]);
                                }
                            }
                        };
                        if (angular.isFunction(args[2][0])) {
                            callInvoke(args[2][0]);
                        } else if (angular.isArray(args[2][0])) {
                            for (var j = 0, jlen = args[2][0].length; j < jlen; j++) {
                                if (angular.isFunction(args[2][0][j])) {
                                    callInvoke(args[2][0][j]);
                                }
                            }
                        }
                    }
                }
            }
        }

        function getModuleName(module) {
            var moduleName = null;
            if (angular.isString(module)) {
                moduleName = module;
            } else if (angular.isObject(module) && module.hasOwnProperty('name') && angular.isString(module.name)) {
                moduleName = module.name;
            }
            return moduleName;
        }

        function moduleExists(moduleName) {
            if (!angular.isString(moduleName)) {
                return false;
            }
            try {
                return ngModuleFct(moduleName);
            } catch (e) {
                if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
                    return false;
                }
            }
        }

        this.$get = ["$log", "$rootElement", "$rootScope", "$cacheFactory", "$q", function ($log, $rootElement, $rootScope, $cacheFactory, $q) {
            var instanceInjector,
                filesCache = $cacheFactory('ocLazyLoad');

            if (!debug) {
                $log = {};
                $log['error'] = angular.noop;
                $log['warn'] = angular.noop;
                $log['info'] = angular.noop;
            }

            // Make this lazy because when $get() is called the instance injector hasn't been assigned to the rootElement yet
            providers.getInstanceInjector = function () {
                return instanceInjector ? instanceInjector : instanceInjector = $rootElement.data('$injector') || angular.injector();
            };

            broadcast = function broadcast(eventName, params) {
                if (events) {
                    $rootScope.$broadcast(eventName, params);
                }
                if (debug) {
                    $log.info(eventName, params);
                }
            };

            function reject(e) {
                var deferred = $q.defer();
                $log.error(e.message);
                deferred.reject(e);
                return deferred.promise;
            }

            return {
                _broadcast: broadcast,

                _$log: $log,

                /**
                 * Returns the files cache used by the loaders to store the files currently loading
                 * @returns {*}
                 */
                _getFilesCache: function getFilesCache() {
                    return filesCache;
                },

                /**
                 * Let the service know that it should monitor angular.module because files are loading
                 * @param watch boolean
                 */
                toggleWatch: function toggleWatch(watch) {
                    if (watch) {
                        recordDeclarations.push(true);
                    } else {
                        recordDeclarations.pop();
                    }
                },

                /**
                 * Let you get a module config object
                 * @param moduleName String the name of the module
                 * @returns {*}
                 */
                getModuleConfig: function getModuleConfig(moduleName) {
                    if (!angular.isString(moduleName)) {
                        throw new Error('You need to give the name of the module to get');
                    }
                    if (!modules[moduleName]) {
                        return null;
                    }
                    return angular.copy(modules[moduleName]);
                },

                /**
                 * Let you define a module config object
                 * @param moduleConfig Object the module config object
                 * @returns {*}
                 */
                setModuleConfig: function setModuleConfig(moduleConfig) {
                    if (!angular.isObject(moduleConfig)) {
                        throw new Error('You need to give the module config object to set');
                    }
                    modules[moduleConfig.name] = moduleConfig;
                    return moduleConfig;
                },

                /**
                 * Returns the list of loaded modules
                 * @returns {string[]}
                 */
                getModules: function getModules() {
                    return regModules;
                },

                /**
                 * Let you check if a module has been loaded into Angular or not
                 * @param modulesNames String/Object a module name, or a list of module names
                 * @returns {boolean}
                 */
                isLoaded: function isLoaded(modulesNames) {
                    var moduleLoaded = function moduleLoaded(module) {
                        var isLoaded = regModules.indexOf(module) > -1;
                        if (!isLoaded) {
                            isLoaded = !!moduleExists(module);
                        }
                        return isLoaded;
                    };
                    if (angular.isString(modulesNames)) {
                        modulesNames = [modulesNames];
                    }
                    if (angular.isArray(modulesNames)) {
                        var i, len;
                        for (i = 0, len = modulesNames.length; i < len; i++) {
                            if (!moduleLoaded(modulesNames[i])) {
                                return false;
                            }
                        }
                        return true;
                    } else {
                        throw new Error('You need to define the module(s) name(s)');
                    }
                },

                /**
                 * Given a module, return its name
                 * @param module
                 * @returns {String}
                 */
                _getModuleName: getModuleName,

                /**
                 * Returns a module if it exists
                 * @param moduleName
                 * @returns {module}
                 */
                _getModule: function getModule(moduleName) {
                    try {
                        return ngModuleFct(moduleName);
                    } catch (e) {
                        // this error message really suxx
                        if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
                            e.message = 'The module "' + stringify(moduleName) + '" that you are trying to load does not exist. ' + e.message;
                        }
                        throw e;
                    }
                },

                /**
                 * Check if a module exists and returns it if it does
                 * @param moduleName
                 * @returns {boolean}
                 */
                moduleExists: moduleExists,

                /**
                 * Load the dependencies, and might try to load new files depending on the config
                 * @param moduleName (String or Array of Strings)
                 * @param localParams
                 * @returns {*}
                 * @private
                 */
                _loadDependencies: function _loadDependencies(moduleName, localParams) {
                    var loadedModule,
                        requires,
                        diff,
                        promisesList = [],
                        self = this;

                    moduleName = self._getModuleName(moduleName);

                    if (moduleName === null) {
                        return $q.when();
                    } else {
                        try {
                            loadedModule = self._getModule(moduleName);
                        } catch (e) {
                            return reject(e);
                        }
                        // get unloaded requires
                        requires = self.getRequires(loadedModule);
                    }

                    angular.forEach(requires, function (requireEntry) {
                        // If no configuration is provided, try and find one from a previous load.
                        // If there isn't one, bail and let the normal flow run
                        if (angular.isString(requireEntry)) {
                            var config = self.getModuleConfig(requireEntry);
                            if (config === null) {
                                moduleCache.push(requireEntry); // We don't know about this module, but something else might, so push it anyway.
                                return;
                            }
                            requireEntry = config;
                            // ignore the name because it's probably not a real module name
                            config.name = undefined;
                        }

                        // Check if this dependency has been loaded previously
                        if (self.moduleExists(requireEntry.name)) {
                            // compare against the already loaded module to see if the new definition adds any new files
                            diff = requireEntry.files.filter(function (n) {
                                return self.getModuleConfig(requireEntry.name).files.indexOf(n) < 0;
                            });

                            // If the module was redefined, advise via the console
                            if (diff.length !== 0) {
                                self._$log.warn('Module "', moduleName, '" attempted to redefine configuration for dependency. "', requireEntry.name, '"\n Additional Files Loaded:', diff);
                            }

                            // Push everything to the file loader, it will weed out the duplicates.
                            if (angular.isDefined(self.filesLoader)) {
                                // if a files loader is defined
                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
                                    return self._loadDependencies(requireEntry);
                                }));
                            } else {
                                return reject(new Error('Error: New dependencies need to be loaded from external files (' + requireEntry.files + '), but no loader has been defined.'));
                            }
                            return;
                        } else if (angular.isArray(requireEntry)) {
                            var files = [];
                            angular.forEach(requireEntry, function (entry) {
                                // let's check if the entry is a file name or a config name
                                var config = self.getModuleConfig(entry);
                                if (config === null) {
                                    files.push(entry);
                                } else if (config.files) {
                                    files = files.concat(config.files);
                                }
                            });
                            if (files.length > 0) {
                                requireEntry = {
                                    files: files
                                };
                            }
                        } else if (angular.isObject(requireEntry)) {
                            if (requireEntry.hasOwnProperty('name') && requireEntry['name']) {
                                // The dependency doesn't exist in the module cache and is a new configuration, so store and push it.
                                self.setModuleConfig(requireEntry);
                                moduleCache.push(requireEntry['name']);
                            }
                        }

                        // Check if the dependency has any files that need to be loaded. If there are, push a new promise to the promise list.
                        if (angular.isDefined(requireEntry.files) && requireEntry.files.length !== 0) {
                            if (angular.isDefined(self.filesLoader)) {
                                // if a files loader is defined
                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
                                    return self._loadDependencies(requireEntry);
                                }));
                            } else {
                                return reject(new Error('Error: the module "' + requireEntry.name + '" is defined in external files (' + requireEntry.files + '), but no loader has been defined.'));
                            }
                        }
                    });

                    // Create a wrapper promise to watch the promise list and resolve it once everything is done.
                    return $q.all(promisesList);
                },

                /**
                 * Inject new modules into Angular
                 * @param moduleName
                 * @param localParams
                 * @param real
                 */
                inject: function inject(moduleName) {
                    var localParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
                    var real = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

                    var self = this,
                        deferred = $q.defer();
                    if (angular.isDefined(moduleName) && moduleName !== null) {
                        if (angular.isArray(moduleName)) {
                            var promisesList = [];
                            angular.forEach(moduleName, function (module) {
                                promisesList.push(self.inject(module, localParams, real));
                            });
                            return $q.all(promisesList);
                        } else {
                            self._addToLoadList(self._getModuleName(moduleName), true, real);
                        }
                    }
                    if (modulesToLoad.length > 0) {
                        var res = modulesToLoad.slice(); // clean copy
                        var loadNext = function loadNext(moduleName) {
                            moduleCache.push(moduleName);
                            modulePromises[moduleName] = deferred.promise;
                            self._loadDependencies(moduleName, localParams).then(function success() {
                                try {
                                    justLoaded = [];
                                    _register(providers, moduleCache, localParams);
                                } catch (e) {
                                    self._$log.error(e.message);
                                    deferred.reject(e);
                                    return;
                                }

                                if (modulesToLoad.length > 0) {
                                    loadNext(modulesToLoad.shift()); // load the next in list
                                } else {
                                        deferred.resolve(res); // everything has been loaded, resolve
                                    }
                            }, function error(err) {
                                deferred.reject(err);
                            });
                        };

                        // load the first in list
                        loadNext(modulesToLoad.shift());
                    } else if (localParams && localParams.name && modulePromises[localParams.name]) {
                        return modulePromises[localParams.name];
                    } else {
                        deferred.resolve();
                    }
                    return deferred.promise;
                },

                /**
                 * Get the list of required modules/services/... for this module
                 * @param module
                 * @returns {Array}
                 */
                getRequires: function getRequires(module) {
                    var requires = [];
                    angular.forEach(module.requires, function (requireModule) {
                        if (regModules.indexOf(requireModule) === -1) {
                            requires.push(requireModule);
                        }
                    });
                    return requires;
                },

                /**
                 * Invoke the new modules & component by their providers
                 * @param providers
                 * @param queue
                 * @param moduleName
                 * @param reconfig
                 * @private
                 */
                _invokeQueue: _invokeQueue,

                /**
                 * Check if a module has been invoked and registers it if not
                 * @param args
                 * @param moduleName
                 * @returns {boolean} is new
                 */
                _registerInvokeList: _registerInvokeList,

                /**
                 * Register a new module and loads it, executing the run/config blocks if needed
                 * @param providers
                 * @param registerModules
                 * @param params
                 * @private
                 */
                _register: _register,

                /**
                 * Add a module name to the list of modules that will be loaded in the next inject
                 * @param name
                 * @param force
                 * @private
                 */
                _addToLoadList: _addToLoadList,

                /**
                 * Unregister modules (you shouldn't have to use this)
                 * @param modules
                 */
                _unregister: function _unregister(modules) {
                    if (angular.isDefined(modules)) {
                        if (angular.isArray(modules)) {
                            angular.forEach(modules, function (module) {
                                regInvokes[module] = undefined;
                            });
                        }
                    }
                }
            };
        }];

        // Let's get the list of loaded modules & components
        this._init(angular.element(window.document));
    }]);

    var bootstrapFct = angular.bootstrap;
    angular.bootstrap = function (element, modules, config) {
        // we use slice to make a clean copy
        angular.forEach(modules.slice(), function (module) {
            _addToLoadList(module, true, true);
        });
        return bootstrapFct(element, modules, config);
    };

    var _addToLoadList = function _addToLoadList(name, force, real) {
        if ((recordDeclarations.length > 0 || force) && angular.isString(name) && modulesToLoad.indexOf(name) === -1) {
            modulesToLoad.push(name);
            if (real) {
                realModules.push(name);
            }
        }
    };

    var ngModuleFct = angular.module;
    angular.module = function (name, requires, configFn) {
        _addToLoadList(name, false, true);
        return ngModuleFct(name, requires, configFn);
    };

    // CommonJS package manager support:
    if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
        module.exports = 'oc.lazyLoad';
    }
})(angular, window);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').directive('ocLazyLoad', ["$ocLazyLoad", "$compile", "$animate", "$parse", "$timeout", function ($ocLazyLoad, $compile, $animate, $parse, $timeout) {
        return {
            restrict: 'A',
            terminal: true,
            priority: 1000,
            compile: function compile(element, attrs) {
                // we store the content and remove it before compilation
                var content = element[0].innerHTML;
                element.html('');

                return function ($scope, $element, $attr) {
                    var model = $parse($attr.ocLazyLoad);
                    $scope.$watch(function () {
                        return model($scope) || $attr.ocLazyLoad; // it can be a module name (string), an object, an array, or a scope reference to any of this
                    }, function (moduleName) {
                        if (angular.isDefined(moduleName)) {
                            $ocLazyLoad.load(moduleName).then(function () {
                                // Attach element contents to DOM and then compile them.
                                // This prevents an issue where IE invalidates saved element objects (HTMLCollections)
                                // of the compiled contents when attaching to the parent DOM.
                                $animate.enter(content, $element);
                                // get the new content & compile it
                                $compile($element.contents())($scope);
                            });
                        }
                    }, true);
                };
            }
        };
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", "$window", "$interval", function ($delegate, $q, $window, $interval) {
            var uaCssChecked = false,
                useCssLoadPatch = false,
                anchor = $window.document.getElementsByTagName('head')[0] || $window.document.getElementsByTagName('body')[0];

            /**
             * Load a js/css file
             * @param type
             * @param path
             * @param params
             * @returns promise
             */
            $delegate.buildElement = function buildElement(type, path, params) {
                var deferred = $q.defer(),
                    el,
                    loaded,
                    filesCache = $delegate._getFilesCache(),
                    cacheBuster = function cacheBuster(url) {
                    var dc = new Date().getTime();
                    if (url.indexOf('?') >= 0) {
                        if (url.substring(0, url.length - 1) === '&') {
                            return url + '_dc=' + dc;
                        }
                        return url + '&_dc=' + dc;
                    } else {
                        return url + '?_dc=' + dc;
                    }
                };

                // Store the promise early so the file load can be detected by other parallel lazy loads
                // (ie: multiple routes on one page) a 'true' value isn't sufficient
                // as it causes false positive load results.
                if (angular.isUndefined(filesCache.get(path))) {
                    filesCache.put(path, deferred.promise);
                }

                // Switch in case more content types are added later
                switch (type) {
                    case 'css':
                        el = $window.document.createElement('link');
                        el.type = 'text/css';
                        el.rel = 'stylesheet';
                        el.href = params.cache === false ? cacheBuster(path) : path;
                        break;
                    case 'js':
                        el = $window.document.createElement('script');
                        el.src = params.cache === false ? cacheBuster(path) : path;
                        break;
                    default:
                        filesCache.remove(path);
                        deferred.reject(new Error('Requested type "' + type + '" is not known. Could not inject "' + path + '"'));
                        break;
                }
                el.onload = el['onreadystatechange'] = function (e) {
                    if (el['readyState'] && !/^c|loade/.test(el['readyState']) || loaded) return;
                    el.onload = el['onreadystatechange'] = null;
                    loaded = 1;
                    $delegate._broadcast('ocLazyLoad.fileLoaded', path);
                    deferred.resolve();
                };
                el.onerror = function () {
                    filesCache.remove(path);
                    deferred.reject(new Error('Unable to load ' + path));
                };
                el.async = params.serie ? 0 : 1;

                var insertBeforeElem = anchor.lastChild;
                if (params.insertBefore) {
                    var element = angular.element(angular.isDefined(window.jQuery) ? params.insertBefore : document.querySelector(params.insertBefore));
                    if (element && element.length > 0) {
                        insertBeforeElem = element[0];
                    }
                }
                insertBeforeElem.parentNode.insertBefore(el, insertBeforeElem);

                /*
                 The event load or readystatechange doesn't fire in:
                 - iOS < 6       (default mobile browser)
                 - Android < 4.4 (default mobile browser)
                 - Safari < 6    (desktop browser)
                 */
                if (type == 'css') {
                    if (!uaCssChecked) {
                        var ua = $window.navigator.userAgent.toLowerCase();

                        // iOS < 6
                        if (/iP(hone|od|ad)/.test($window.navigator.platform)) {
                            var v = $window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                            var iOSVersion = parseFloat([parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)].join('.'));
                            useCssLoadPatch = iOSVersion < 6;
                        } else if (ua.indexOf("android") > -1) {
                            // Android < 4.4
                            var androidVersion = parseFloat(ua.slice(ua.indexOf("android") + 8));
                            useCssLoadPatch = androidVersion < 4.4;
                        } else if (ua.indexOf('safari') > -1) {
                            var versionMatch = ua.match(/version\/([\.\d]+)/i);
                            useCssLoadPatch = versionMatch && versionMatch[1] && parseFloat(versionMatch[1]) < 6;
                        }
                    }

                    if (useCssLoadPatch) {
                        var tries = 1000; // * 20 = 20000 miliseconds
                        var interval = $interval(function () {
                            try {
                                el.sheet.cssRules;
                                $interval.cancel(interval);
                                el.onload();
                            } catch (e) {
                                if (--tries <= 0) {
                                    el.onerror();
                                }
                            }
                        }, 20);
                    }
                }

                return deferred.promise;
            };

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * The function that loads new files
             * @param config
             * @param params
             * @returns {*}
             */
            $delegate.filesLoader = function filesLoader(config) {
                var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

                var cssFiles = [],
                    templatesFiles = [],
                    jsFiles = [],
                    promises = [],
                    cachePromise = null,
                    filesCache = $delegate._getFilesCache();

                $delegate.toggleWatch(true); // start watching angular.module calls

                angular.extend(params, config);

                var pushFile = function pushFile(path) {
                    var file_type = null,
                        m;
                    if (angular.isObject(path)) {
                        file_type = path.type;
                        path = path.path;
                    }
                    cachePromise = filesCache.get(path);
                    if (angular.isUndefined(cachePromise) || params.cache === false) {

                        // always check for requirejs syntax just in case
                        if ((m = /^(css|less|html|htm|js)?(?=!)/.exec(path)) !== null) {
                            // Detect file type using preceding type declaration (ala requireJS)
                            file_type = m[1];
                            path = path.substr(m[1].length + 1, path.length); // Strip the type from the path
                        }

                        if (!file_type) {
                            if ((m = /[.](css|less|html|htm|js)?((\?|#).*)?$/.exec(path)) !== null) {
                                // Detect file type via file extension
                                file_type = m[1];
                            } else if (!$delegate.jsLoader.hasOwnProperty('ocLazyLoadLoader') && $delegate.jsLoader.hasOwnProperty('requirejs')) {
                                // requirejs
                                file_type = 'js';
                            } else {
                                $delegate._$log.error('File type could not be determined. ' + path);
                                return;
                            }
                        }

                        if ((file_type === 'css' || file_type === 'less') && cssFiles.indexOf(path) === -1) {
                            cssFiles.push(path);
                        } else if ((file_type === 'html' || file_type === 'htm') && templatesFiles.indexOf(path) === -1) {
                            templatesFiles.push(path);
                        } else if (file_type === 'js' || jsFiles.indexOf(path) === -1) {
                            jsFiles.push(path);
                        } else {
                            $delegate._$log.error('File type is not valid. ' + path);
                        }
                    } else if (cachePromise) {
                        promises.push(cachePromise);
                    }
                };

                if (params.serie) {
                    pushFile(params.files.shift());
                } else {
                    angular.forEach(params.files, function (path) {
                        pushFile(path);
                    });
                }

                if (cssFiles.length > 0) {
                    var cssDeferred = $q.defer();
                    $delegate.cssLoader(cssFiles, function (err) {
                        if (angular.isDefined(err) && $delegate.cssLoader.hasOwnProperty('ocLazyLoadLoader')) {
                            $delegate._$log.error(err);
                            cssDeferred.reject(err);
                        } else {
                            cssDeferred.resolve();
                        }
                    }, params);
                    promises.push(cssDeferred.promise);
                }

                if (templatesFiles.length > 0) {
                    var templatesDeferred = $q.defer();
                    $delegate.templatesLoader(templatesFiles, function (err) {
                        if (angular.isDefined(err) && $delegate.templatesLoader.hasOwnProperty('ocLazyLoadLoader')) {
                            $delegate._$log.error(err);
                            templatesDeferred.reject(err);
                        } else {
                            templatesDeferred.resolve();
                        }
                    }, params);
                    promises.push(templatesDeferred.promise);
                }

                if (jsFiles.length > 0) {
                    var jsDeferred = $q.defer();
                    $delegate.jsLoader(jsFiles, function (err) {
                        if (angular.isDefined(err) && ($delegate.jsLoader.hasOwnProperty("ocLazyLoadLoader") || $delegate.jsLoader.hasOwnProperty("requirejs"))) {
                            $delegate._$log.error(err);
                            jsDeferred.reject(err);
                        } else {
                            jsDeferred.resolve();
                        }
                    }, params);
                    promises.push(jsDeferred.promise);
                }

                if (promises.length === 0) {
                    var deferred = $q.defer(),
                        err = "Error: no file to load has been found, if you're trying to load an existing module you should use the 'inject' method instead of 'load'.";
                    $delegate._$log.error(err);
                    deferred.reject(err);
                    return deferred.promise;
                } else if (params.serie && params.files.length > 0) {
                    return $q.all(promises).then(function () {
                        return $delegate.filesLoader(config, params);
                    });
                } else {
                    return $q.all(promises)['finally'](function (res) {
                        $delegate.toggleWatch(false); // stop watching angular.module calls
                        return res;
                    });
                }
            };

            /**
             * Load a module or a list of modules into Angular
             * @param module Mixed the name of a predefined module config object, or a module config object, or an array of either
             * @param params Object optional parameters
             * @returns promise
             */
            $delegate.load = function (originalModule) {
                var originalParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

                var self = this,
                    config = null,
                    deferredList = [],
                    deferred = $q.defer(),
                    errText;

                // clean copy
                var module = angular.copy(originalModule);
                var params = angular.copy(originalParams);

                // If module is an array, break it down
                if (angular.isArray(module)) {
                    // Resubmit each entry as a single module
                    angular.forEach(module, function (m) {
                        deferredList.push(self.load(m, params));
                    });

                    // Resolve the promise once everything has loaded
                    $q.all(deferredList).then(function (res) {
                        deferred.resolve(res);
                    }, function (err) {
                        deferred.reject(err);
                    });

                    return deferred.promise;
                }

                // Get or Set a configuration depending on what was passed in
                if (angular.isString(module)) {
                    config = self.getModuleConfig(module);
                    if (!config) {
                        config = {
                            files: [module]
                        };
                    }
                } else if (angular.isObject(module)) {
                    // case {type: 'js', path: lazyLoadUrl + 'testModule.fakejs'}
                    if (angular.isDefined(module.path) && angular.isDefined(module.type)) {
                        config = {
                            files: [module]
                        };
                    } else {
                        config = self.setModuleConfig(module);
                    }
                }

                if (config === null) {
                    var moduleName = self._getModuleName(module);
                    errText = 'Module "' + (moduleName || 'unknown') + '" is not configured, cannot load.';
                    $delegate._$log.error(errText);
                    deferred.reject(new Error(errText));
                    return deferred.promise;
                } else {
                    // deprecated
                    if (angular.isDefined(config.template)) {
                        if (angular.isUndefined(config.files)) {
                            config.files = [];
                        }
                        if (angular.isString(config.template)) {
                            config.files.push(config.template);
                        } else if (angular.isArray(config.template)) {
                            config.files.concat(config.template);
                        }
                    }
                }

                var localParams = angular.extend({}, params, config);

                // if someone used an external loader and called the load function with just the module name
                if (angular.isUndefined(config.files) && angular.isDefined(config.name) && $delegate.moduleExists(config.name)) {
                    return $delegate.inject(config.name, localParams, true);
                }

                $delegate.filesLoader(config, localParams).then(function () {
                    $delegate.inject(null, localParams).then(function (res) {
                        deferred.resolve(res);
                    }, function (err) {
                        deferred.reject(err);
                    });
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            };

            // return the patched service
            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * cssLoader function
             * @type Function
             * @param paths array list of css files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters
             * because the user can overwrite cssLoader and it will probably not use promises :(
             */
            $delegate.cssLoader = function (paths, callback, params) {
                var promises = [];
                angular.forEach(paths, function (path) {
                    promises.push($delegate.buildElement('css', path, params));
                });
                $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.cssLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * jsLoader function
             * @type Function
             * @param paths array list of js files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters
             * because the user can overwrite jsLoader and it will probably not use promises :(
             */
            $delegate.jsLoader = function (paths, callback, params) {
                var promises = [];
                angular.forEach(paths, function (path) {
                    promises.push($delegate.buildElement('js', path, params));
                });
                $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.jsLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$templateCache", "$q", "$http", function ($delegate, $templateCache, $q, $http) {
            /**
             * templatesLoader function
             * @type Function
             * @param paths array list of css files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters for $http
             * because the user can overwrite templatesLoader and it will probably not use promises :(
             */
            $delegate.templatesLoader = function (paths, callback, params) {
                var promises = [],
                    filesCache = $delegate._getFilesCache();

                angular.forEach(paths, function (url) {
                    var deferred = $q.defer();
                    promises.push(deferred.promise);
                    $http.get(url, params).success(function (data) {
                        if (angular.isString(data) && data.length > 0) {
                            angular.forEach(angular.element(data), function (node) {
                                if (node.nodeName === 'SCRIPT' && node.type === 'text/ng-template') {
                                    $templateCache.put(node.id, node.innerHTML);
                                }
                            });
                        }
                        if (angular.isUndefined(filesCache.get(url))) {
                            filesCache.put(url, true);
                        }
                        deferred.resolve();
                    }).error(function (err) {
                        deferred.reject(new Error('Unable to load template file "' + url + '": ' + err));
                    });
                });
                return $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.templatesLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
// Array.indexOf polyfill for IE8
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {
        var k;

        // 1. Let O be the result of calling ToObject passing
        //    the this value as the argument.
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }

        var O = Object(this);

        // 2. Let lenValue be the result of calling the Get
        //    internal method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = O.length >>> 0;

        // 4. If len is 0, return -1.
        if (len === 0) {
            return -1;
        }

        // 5. If argument fromIndex was passed let n be
        //    ToInteger(fromIndex); else let n be 0.
        var n = +fromIndex || 0;

        if (Math.abs(n) === Infinity) {
            n = 0;
        }

        // 6. If n >= len, return -1.
        if (n >= len) {
            return -1;
        }

        // 7. If n >= 0, then Let k be n.
        // 8. Else, n<0, Let k be len - abs(n).
        //    If k is less than 0, then let k be 0.
        k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        // 9. Repeat, while k < len
        while (k < len) {
            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the
            //    HasProperty internal method of O with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            //    i.  Let elementK be the result of calling the Get
            //        internal method of O with the argument ToString(k).
            //   ii.  Let same be the result of applying the
            //        Strict Equality Comparison Algorithm to
            //        searchElement and elementK.
            //  iii.  If same is true, return k.
            if (k in O && O[k] === searchElement) {
                return k;
            }
            k++;
        }
        return -1;
    };
}

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);
var ngMessages = __webpack_require__(14);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(4); // eslint-disable-line no-unused-vars

var wowCommonModule = __webpack_require__(5);
var olyCommonModule = __webpack_require__(3);
var analyticsModule = __webpack_require__(8);

var authModuleName = 'wowApp.auth';

angular.module(authModuleName, [analyticsModule, olyCommonModule, wowCommonModule, ngMessages, uiRouter, 'restangular']);

// ------------------------------------------
// Components
// ------------------------------------------
__webpack_require__(48);
__webpack_require__(54);
__webpack_require__(59);
__webpack_require__(67);
__webpack_require__(71);
__webpack_require__(74);

module.exports = authModuleName;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.auth');

// Services
wowApp.service('LoginService', ['$rootScope', '$q', '$window', 'SessionStorageWrapper', 'Restangular', '$state', '$stateParams', 'Settings', 'ShopperAnalyticsService', 'AnalyticsService', 'ShopperService', __webpack_require__(49)]);

// Directives
wowApp.component('wowLoginPage', __webpack_require__(50).loginPageComponentDefinition);
wowApp.component('wowLoginForm', __webpack_require__(52).loginFormComponentDefinition);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var angular = __webpack_require__(1);

var LoginService = function () {
    function LoginService($rootScope, $q, $window, sessionStorage, Restangular, $state, $stateParams, settings, shopperAnalytics, analytics, shopperService) {
        _classCallCheck(this, LoginService);

        this._api = Restangular;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.sessionStorage = sessionStorage;
        this.shopperAnalytics = shopperAnalytics;
        this.analytics = analytics;
        this.shopperService = shopperService;

        // Load login prompt message settings
        if (settings.login) {
            this.LoginToViewCategoryMessage = settings.login.loginToViewCategoryMessage;
            this.LoginToSavetoListMessage = settings.login.loginToSavetoListMessage;
            this.LoginToAddRestrictedProductMessage = settings.login.loginToAddRestrictedProductMessage;
            this.LoginToAddMoreProductsMessage = settings.login.loginToAddMoreProductsMessage;
            this.LoginToContinueMessage = settings.login.loginToContinueMessage;
            this.LoginToContinueWhenRememberedMessage = settings.login.loginToContinueWhenRememberedMessage;
            this.LoginToSetDeliveryOrPickupAddressMessage = settings.login.loginToSetDeliveryOrPickupAddressMessage;
            this.LoginToSetDeliveryWindowMessage = settings.login.loginToSetDeliveryWindowMessage;
            this.LoginSessionHasExpiredMessage = 'Please Login. Your Session Has Expired.';
        }
    }

    /**
     * Login function.
     *
     * @param {string} email
     * @param {string} password
     * @param {bool} rememberMe
     * @param {string} [linkToken]
     * @param {string} [userIdFromAgent]
     * @returns
     */


    _createClass(LoginService, [{
        key: 'login',
        value: function login(email, password, rememberMe, linkToken, userIdFromAgent) {
            var _this = this;

            return this._api.one('Login').post('LoginWithCredential', {
                Email: email,
                Password: password,
                RememberMe: rememberMe,
                LinkToken: linkToken,
                UserIdFromAgent: userIdFromAgent
            }).then(function (loginResult) {
                return loginResult.LoginResult.toLowerCase() === 'success' ? _this.$q.all([loginResult, _this.shopperService.getCurrentShopper(), _this.shopperService.getBasicShopperPreferences()]) : _this.$q.all([loginResult]);
            }).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 1),
                    loginResult = _ref2[0];

                _this.pushAnalyticsLogin(loginResult.LoginResult.toLowerCase() === 'success');
                return loginResult;
            }).then(function (loginResult) {
                return _this.onLogin(loginResult);
            });
        }
    }, {
        key: 'onLogin',
        value: function onLogin(loginResult) {
            this.$rootScope.$broadcast('login:' + loginResult.LoginResult.toLowerCase(), loginResult);

            if (loginResult.LoginResult.toLowerCase() === 'success') {
                this.resolvePromptForLogin(loginResult);
            }

            return loginResult;
        }
    }, {
        key: 'logout',
        value: function logout() {
            var _this2 = this;

            this.$rootScope.$broadcast('logout:start');

            return this._api.one('/').post('Logout').then(function (response) {
                if (response.Success === true) {
                    _this2.invalidateLogin();
                    _this2.$window.location.href = '/';
                }
            });
        }
    }, {
        key: 'invalidateLogin',
        value: function invalidateLogin() {
            if (!this.shopperService.IsGuest) {
                this.shopperService.clearShopper();
            }
        }

        /**
         * Prompt a user for login. Used before performing an action that requires authentication.
         *
         * @param {String} [message] - The message to prompt the user with.
         * @param {State|String} [toState=state.current] - The state which should be navigated to after
         * @param {Object} [toParams=state.params] - The params for the state which should be navigated to after login.
         *  Defaults to the current state params.
         * @param {Object} [stateOptions] - State options for the state which should be navigated to after login.
         * @param {Function} callback - Callback function to call after login success.
         */

    }, {
        key: 'promptForLogin',
        value: function promptForLogin(message) {
            var toState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$state.$current;
            var toParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : angular.copy(this.$stateParams);
            var stateOptions = arguments[3];
            var successCallback = arguments[4];

            var _this3 = this;

            var errorCallback = arguments[5];
            var authCallback = arguments[6];

            if (this.pendingPromptForLogin) {
                // If there is already a prompt pending, we can return the
                // existing promise for the pending prompt.
                this.pendingPromptForLogin.promise.then(function () {
                    if (successCallback) successCallback();
                }).catch(function () {
                    if (errorCallback) errorCallback();
                });
                return;
            }

            this.loginPromptMessage = message;

            var pendingPromptForLogin = this.$q.defer();
            this.pendingPromptForLogin = pendingPromptForLogin;
            this.pendingPromptForLogin.promise.then(function (loginResult) {
                if (successCallback) {
                    successCallback(loginResult);
                }
            }).catch(function (result) {
                if (errorCallback) {
                    errorCallback(result);
                }
            }).finally(function () {
                if (_this3.pendingPromptForLogin === pendingPromptForLogin) {
                    _this3.loginPromptMessage = null;
                    _this3.pendingPromptForLogin = null;
                }
            });

            this.$state.go('shop.authentication.login', {
                toState: toState, toStateParams: toParams, toStateOptions: stateOptions, customCallback: authCallback
            });
        }
    }, {
        key: 'resolvePromptForLogin',
        value: function resolvePromptForLogin(loginResult) {
            if (this.pendingPromptForLogin != null && loginResult.LoginResult.toLowerCase() === 'success') {
                this.pendingPromptForLogin.resolve(loginResult);
            }

            return loginResult;
        }

        /**
         * If there is an action pending which has prompted for login, this will reject the pending login promise.
         */

    }, {
        key: 'rejectPromptForLogin',
        value: function rejectPromptForLogin() {
            if (this.pendingPromptForLogin != null) {
                this.pendingPromptForLogin.reject();
                this.pendingPromptForLogin = null;
            }
        }
    }, {
        key: 'pushAnalyticsLogin',
        value: function pushAnalyticsLogin(isLoginSuccess) {
            this.shopperAnalytics.push(this.shopperService.shopper);
            this.analytics.push({ data: this.shopperService.shopper, type: this.analytics.mapperTypes.account.login });
            if (isLoginSuccess) {
                // flag for pushing user data to analytics when login
                this.sessionStorage.set('shouldTrackLoginEvent', true);
            }
        }
    }]);

    return LoginService;
}();

module.exports = LoginService;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginPageController = function () {
    function LoginPageController($stateParams, $state) {
        _classCallCheck(this, LoginPageController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.isReauthorizing = false;
    }

    _createClass(LoginPageController, [{
        key: 'onSignupClick',
        value: function onSignupClick() {
            this.$state.go('shop.authentication.signup', {
                toState: this.$stateParams.toState,
                toStateParams: this.$stateParams.toStateParams,
                toStateOptions: this.$stateParams.toStateOptions,
                customCallback: this.$stateParams.customCallback
            });
        }
    }]);

    return LoginPageController;
}();

var loginPageComponentDefinition = {
    bindings: {
        authenticationMethod: '=?'
    },
    controller: ['$stateParams', '$state', LoginPageController],
    template: __webpack_require__(51).trim()
};

module.exports = {
    LoginPageController: LoginPageController,
    loginPageComponentDefinition: loginPageComponentDefinition
};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = "<div class=\"secureLogin\">\r\n    <div class=\"secureLogin-padding\">\r\n        <wow-login-form class=\"secureLogin-form\" is-reauthorizing=\"$ctrl.isReauthorizing\" authentication-method=\"$ctrl.authenticationMethod\"></wow-login-form>\r\n    </div>\r\n\r\n    <hr ng-if=\"!$ctrl.isReauthorizing\" class=\"secureLogin-separator\">\r\n\r\n    <a href=\"/shop/signup\"\r\n        ng-if=\"!$ctrl.isReauthorizing\"\r\n        ng-click=\"$event.preventDefault();$ctrl.onSignupClick()\"\r\n        class=\"secureLogin-signUp linkButton\">\r\n        <span class=\"secureLogin-signUpPrompt\">New to Woolworths online?</span> Sign up&nbsp;<i class=\"iconww-ArrowRight secureLogin-chevronIcon\"></i>\r\n    </a>\r\n</div>\r\n"

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fillServerErrors = __webpack_require__(16);

var LoginFormController = function () {
    function LoginFormController($q, $state, loginService, featureService, shopperService, analytics) {
        _classCallCheck(this, LoginFormController);

        this.$q = $q;
        this.$state = $state;
        this.loginService = loginService;
        this.shopperService = shopperService;
        this.analytics = analytics;

        this.rememberMeEnabled = featureService.isEnabled(featureService.features.rememberMe);
        this.loading = false;
    }

    _createClass(LoginFormController, [{
        key: '$onInit',
        value: function $onInit() {
            this.shopper = this.shopperService.refreshShopperDetails();

            this.analyticsEvents = {
                EmailInput: this.analytics.events.LOGIN.FORM_FILL_EMAIL_ADDRESS,
                PasswordInput: this.analytics.events.LOGIN.FORM_FILL_PASSWORD,
                RememberMeInput: this.analytics.events.LOGIN.FORM_FILL_REMEMBER_ME
            };
            this.analytics.pushEvent(this.analytics.events.LOGIN.START);

            this.isReauthorizing = !!(this.shopper.Id && this.authenticationMethod === 'RememberMe');

            if (this.isReauthorizing) {
                this.Email = this.shopper.Email;
                this.loginService.loginPromptMessage = this.loginService.LoginToContinueWhenRememberedMessage;
            }
        }
    }, {
        key: 'setServerErrorValidity',
        value: function setServerErrorValidity(isValid) {
            if (this.loginForm.Email) {
                this.loginForm.Email.$setValidity('loginError', isValid);
            }
            this.loginForm.Password.$setValidity('loginError', isValid);
        }
    }, {
        key: 'login',
        value: function login(email, password, rememberMe) {
            var _this = this;

            fillServerErrors.clearForm(this.loginForm, this);
            this.setServerErrorValidity(true);

            if (!this.loginForm.$valid) {
                // don't submit to server if client side is not valid
                return this.$q.reject();
            }

            this.loading = true;

            return this.loginService.login(email, password, rememberMe).then(function (response) {
                if (response.LoginResult === 'Success') {
                    // this should check the response when it is implemented.
                    _this.AuthenticationErrorMessage = null;
                    _this.analytics.pushEvent(_this.analytics.events.LOGIN.COMPLETED_MANUAL);

                    if (_this.loginService.loginContext === 'checkout') {
                        _this.$state.go('hyf');
                    }
                } else if (response.LoginResult === 'RedirectPasswordRemainder') {
                    _this.analytics.pushEvent(_this.analytics.events.LOGIN.FAILURE);
                    _this.AuthenticationErrorMessage = null;
                    _this.$state.go('shop.authentication.forgotpassword');
                } else if (response.LoginResult === 'ResetPassword') {
                    _this.analytics.pushEvent(_this.analytics.events.LOGIN.FAILURE);
                    _this.AuthenticationErrorMessage = null;
                    _this.$state.go('shop.authentication.resetpassword', { passwordResetToken: response.PasswordResetToken });
                } else {
                    _this.analytics.pushEvent(_this.analytics.events.LOGIN.FAILURE);
                    _this.AuthenticationErrorMessage = response.AuthenticationErrorMessage;
                    _this.analytics.pushError(_this.AuthenticationErrorMessage);
                    _this.setServerErrorValidity(false);
                    _this.loading = false;
                }

                return response;
            }).catch(function (response) {
                fillServerErrors.fillForm(_this.loginForm, response.data.ResponseStatus.Errors, _this);
                _this.setServerErrorValidity(false);
                _this.loading = false;
            });
        }
    }, {
        key: 'logout',
        value: function logout() {
            this.loginService.logout().then(function () {
                window.location.href = '/Shop/SecureLogin';
            });
        }
    }]);

    return LoginFormController;
}();

var loginFormComponentDefinition = {
    bindings: {
        authenticationMethod: '=?',
        isReauthorizing: '='
    },
    controller: ['$q', '$state', 'LoginService', 'FeatureService', 'ShopperService', 'AnalyticsService', LoginFormController],
    template: __webpack_require__(53).trim()
};

module.exports = {
    LoginFormController: LoginFormController,
    loginFormComponentDefinition: loginFormComponentDefinition
};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = "<div ng-switch=\"!!$ctrl.loginService.loginPromptMessage\">\r\n    <h1 class=\"loginForm-heading\">\r\n        <span class=\"loginForm-userIcon\"><i class=\"iconww-Profile\"></i></span>\r\n        <span ng-if=\"$ctrl.isReauthorizing\">Verify&nbsp;</span>Login\r\n    </h1>\r\n\r\n    <p ng-switch-when=\"true\" class=\"alert alert--info loginForm-promptMessage\" oly-grab-focus=\"$ctrl.isReauthorizing\" tabindex=\"-1\">\r\n        {{$ctrl.loginService.loginPromptMessage}}\r\n    </p>\r\n\r\n    <div class=\"hidden-xs loginForm-label\" ng-switch-when=\"false\">\r\n        <wow-setting setting-group=\"Login\" setting-name=\"LoginGenericMessage\">\r\n            Enter your details below to login\r\n        </wow-setting>, or <a ui-sref=\"shop.authentication.signup\">sign up.</a>\r\n    </div>\r\n\r\n    <form id=\"loginForm\" name=\"$ctrl.loginForm\" class=\"loginForm\" ng-submit=\"$ctrl.login($ctrl.Email, $ctrl.Password, $ctrl.rememberMe)\" wow-analytics-form-errors novalidate>\r\n        <oly-form-validation-summary\r\n            user-message=\"The login was not successful.\"\r\n            server-error-message=\"{{$ctrl.AuthenticationErrorMessage}}\">\r\n        </oly-form-validation-summary>\r\n        <wow-input-container ng-if=\"!$ctrl.isReauthorizing\">\r\n            <label>Email address</label>\r\n            <input\r\n                id=\"loginForm-Email\"\r\n                type=\"email\"\r\n                name=\"Email\"\r\n                ng-model=\"$ctrl.Email\"\r\n                analytics-input=\"{{$ctrl.analyticsEvents.EmailInput}}\"\r\n                oly-grab-focus=\"true\"\r\n                wow-email-validator\r\n                required>\r\n            <span ng-messages=\"$ctrl.loginForm.Email.$error\" class=\"wowInput-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">Email address is required.</span>\r\n                <span ng-message=\"email\" class=\"wowInput-error\">Email address is required to be in the format of example@example.com</span>\r\n                <span ng-message=\"serverError\" class=\"wowInput-error\">{{$ctrl.serverErrors.Email}}</span>\r\n            </span>\r\n        </wow-input-container>\r\n\r\n        <div ng-if=\"$ctrl.isReauthorizing\">{{$ctrl.Email}}</div>\r\n        <button ng-if=\"$ctrl.isReauthorizing\" class=\"linkButton loginForm-switchAccount\" ng-click=\"$ctrl.logout()\" type=\"button\">\r\n            Not you? Switch account\r\n        </button>\r\n\r\n        <!-- This ng-if is required in order to fix the order which the controls are registered with the form for the validation <summary></summary> -->\r\n        <wow-input-container ng-if=\"::true\">\r\n            <label>Password</label>\r\n            <input type=\"password\" id=\"loginForm-Password\" name=\"Password\" ng-model=\"$ctrl.Password\" analytics-input=\"{{$ctrl.analyticsEvents.PasswordInput}}\" required />\r\n            <span ng-messages=\"$ctrl.loginForm.Password.$error\" class=\"wowInput-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">Password is required.</span>\r\n                <span ng-message=\"serverError\" class=\"wowInput-error\">{{$ctrl.serverErrors.Password}}</span>\r\n            </span>\r\n        </wow-input-container>\r\n\r\n        <a ui-sref=\"shop.authentication.forgotpassword\" class=\"linkButton loginForm-forgotPassword\" oly-move-focus=\"forgotPasswordForm-email\">\r\n            Forgotten your password?&nbsp;<i class=\"iconww-ArrowRight loginForm-chevronIcon\"></i>\r\n        </a>\r\n\r\n        <div class=\"u-flexSpaceBetween\">\r\n            <div ng-show=\"!$ctrl.isReauthorizing && $ctrl.rememberMeEnabled\" ng-class=\"{'rememberMeEnabled' : $ctrl.rememberMeEnabled}\">\r\n                <input type=\"checkbox\" name=\"rememberMe\" id=\"rememberMe\" class=\"wowCheckbox\" value=\"false\" ng-model=\"$ctrl.rememberMe\" analytics-input=\"{{$ctrl.analyticsEvents.RememberMeInput}}\" />\r\n                <label for=\"rememberMe\" class=\"loginForm-rememberMe\">\r\n                    Remember me\r\n                </label>\r\n            </div>\r\n\r\n            <span class=\"u-flexSpacer\"></span>\r\n\r\n            <oly-button loading=\"{ state: $ctrl.loading, message: 'Processing login, please wait'}\" spinner-button-class=\"loginForm-buttonLoading\" class=\"loginForm-buttonContainer\">\r\n                <button class=\"button button--primary loginForm-button\" type=\"submit\">Login&nbsp;<i class=\"iconww-ArrowRight loginForm-chevronIcon\"></i></button>\r\n            </oly-button>\r\n        </div>\r\n    </form>\r\n</div>\r\n"

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var ShopperService = __webpack_require__(55);
var ShopperAnalyticsService = __webpack_require__(56);

var _require = __webpack_require__(57),
    shopperAccessibilityComponentDefinition = _require.shopperAccessibilityComponentDefinition;

angular.module('wowApp.auth').service('ShopperService', ['Restangular', 'BootstrapService', 'ShopperAnalyticsService', ShopperService]).service('ShopperAnalyticsService', ['AnalyticsService', ShopperAnalyticsService]).component('wowShopperAccessibility', shopperAccessibilityComponentDefinition);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    assign = _require.assign;

var ShopperService = function () {
    function ShopperService(Restangular, bootstrap, shopperAnalytics) {
        _classCallCheck(this, ShopperService);

        this.shopper = {};
        this.IsGuest = false;
        this.api = Restangular.one('shopper');
        this.myAccountApi = Restangular.one('myaccount');
        this.shopperAnalytics = shopperAnalytics;
        this.bootstrap = bootstrap;
        this.assignShopperDetails(bootstrap.getBootstrappedData(bootstrap.bootstrapped.Shopper));
        this.assignShopperPreferences(bootstrap.getBootstrappedData(bootstrap.bootstrapped.ShopperBasicPreferences));
        this.assignShopperLocation(bootstrap.getBootstrappedData(bootstrap.bootstrapped.ShopperDetails));
        this.assignShopperAdditionalDetails(bootstrap.getBootstrappedData(bootstrap.bootstrapped.ShopperDetails));
    }

    _createClass(ShopperService, [{
        key: 'refreshShopperDetails',
        value: function refreshShopperDetails() {
            this.assignShopperDetails(this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.Shopper));

            return this.shopper;
        }
    }, {
        key: 'getCurrentShopperDetails',
        value: function getCurrentShopperDetails() {
            var _this = this;

            return this.api.one('detail').get().then(function (details) {
                return _this.assignShopperAdditionalDetails(details);
            });
        }
    }, {
        key: 'getCurrentShopper',
        value: function getCurrentShopper() {
            var _this2 = this;

            return this.api.get().then(function (shopper) {
                return _this2.assignShopperDetails(shopper);
            });
        }
    }, {
        key: 'getBasicShopperPreferences',
        value: function getBasicShopperPreferences() {
            var _this3 = this;

            return this.myAccountApi.one('BasicShopperPreferences').get().then(function (shopperPref) {
                return _this3.assignShopperPreferences(shopperPref);
            });
        }
    }, {
        key: 'getCurrentShopperPreferences',
        value: function getCurrentShopperPreferences() {
            return this.myAccountApi.one('ShopperPreferences').get();
        }
    }, {
        key: 'updateShopperPersonalDetails',
        value: function updateShopperPersonalDetails(shopper) {
            var _this4 = this;

            return this.myAccountApi.one('PersonalDetails').doPOST(shopper).then(function (details) {
                return _this4.assignShopperAdditionalDetails(details);
            });
        }
    }, {
        key: 'updateShopperBusinessDetails',
        value: function updateShopperBusinessDetails(shopper) {
            var _this5 = this;

            return this.myAccountApi.one('BusinessDetails').doPOST(shopper).then(function (details) {
                return _this5.assignShopperAdditionalDetails(details);
            });
        }
    }, {
        key: 'getDeliveryPassesSummary',
        value: function getDeliveryPassesSummary() {
            return this.myAccountApi.one('DeliveryPasses').get();
        }
    }, {
        key: 'shouldDisplayDeliveryPassNavLink',
        value: function shouldDisplayDeliveryPassNavLink() {
            return this.myAccountApi.one('DeliverySaverNavLinkEnabled').get();
        }
    }, {
        key: 'setPreferenceEnableAccessibility',
        value: function setPreferenceEnableAccessibility(newValue) {
            return this.myAccountApi.one('ShopperPreferences/EnableAccessibleMenu').doPOST({ Value: newValue });
        }
    }, {
        key: 'getAuthenticationMethod',
        value: function getAuthenticationMethod() {
            return this.api.one('AuthenticationMethod').get();
        }
    }, {
        key: 'assignShopperDetails',
        value: function assignShopperDetails(details) {
            this.IsGuest = !details || details.IsGuest;
            assign(this.shopper, details);

            return this.shopper;
        }
    }, {
        key: 'assignShopperPreferences',
        value: function assignShopperPreferences(preferences) {
            this.preferences = {
                EnableAccessibleOptions: preferences ? preferences.EnableAccessibleMenu : false
            };

            assign(this.preferences, preferences);

            return this.preferences;
        }
    }, {
        key: 'assignShopperLocation',
        value: function assignShopperLocation(details) {
            this.location = {};

            if (details) {
                assign(this.location, details.Location);
            }

            return this.location;
        }
    }, {
        key: 'assignRewardsPlusPurchaseInfo',
        value: function assignRewardsPlusPurchaseInfo(rewardsPlusPurchaseInfo) {
            this.rewardsPlus = {};

            if (rewardsPlusPurchaseInfo) {
                assign(this.rewardsPlus, rewardsPlusPurchaseInfo);
            }

            return this.rewardsPlus;
        }
    }, {
        key: 'assignShopperAdditionalDetails',
        value: function assignShopperAdditionalDetails(details) {
            assign(this.shopper, details);
            this.shopperAnalytics.push(this.shopper);

            return this.shopper;
        }
    }, {
        key: 'setMobilePhone',
        value: function setMobilePhone(mobile) {
            var updateApi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            this.shopper.MobilePhone = mobile;
            if (updateApi) {
                return this.updateShopperPersonalDetails(this.shopper);
            }
            return this.shopper;
        }
    }, {
        key: 'clearShopper',
        value: function clearShopper() {
            this.shopper = {};
            this.IsGuest = true;
        }
    }]);

    return ShopperService;
}();

module.exports = ShopperService;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShopperAnalytics = function () {
    function ShopperAnalytics(analytics) {
        _classCallCheck(this, ShopperAnalytics);

        this.analytics = analytics;
    }

    _createClass(ShopperAnalytics, [{
        key: "push",
        value: function push(shopperService) {
            this.analytics.push({ data: { shopperDetails: shopperService }, type: this.analytics.mapperTypes.account.shopper });
        }
    }]);

    return ShopperAnalytics;
}();

module.exports = ShopperAnalytics;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShopperAccessibilityController = function () {
    function ShopperAccessibilityController(analyticsService, bootstrapService, shopperService) {
        _classCallCheck(this, ShopperAccessibilityController);

        this.analyticsService = analyticsService;
        this.shopperService = shopperService;
        this.bootstrap = bootstrapService;
    }

    _createClass(ShopperAccessibilityController, [{
        key: '$onInit',
        value: function $onInit() {
            this.analyticsPush();
        }
    }, {
        key: 'setAccessibilityPreference',
        value: function setAccessibilityPreference() {
            this.shopperService.setPreferenceEnableAccessibility(this.shopperService.preferences.EnableAccessibleOptions);
        }
    }, {
        key: 'analyticsPush',
        value: function analyticsPush() {
            if (this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.ShopperDetails) && this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.Trolley)) {
                this.shopper = this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.ShopperDetails) || {};
                this.address = this.shopper.Address;
                this.rewards = this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.Trolley).WowRewardsSummary;
                this.analyticsService.push({
                    data: {
                        shopperDetails: this.shopper,
                        address: this.address,
                        rewards: this.rewards
                    },
                    type: this.analyticsService.mapperTypes.account.shopperMyAccount
                });
            }
        }
    }]);

    return ShopperAccessibilityController;
}();

ShopperAccessibilityController.$inject = ['AnalyticsService', 'BootstrapService', 'ShopperService'];

var shopperAccessibilityComponentDefinition = {
    controller: ShopperAccessibilityController,
    template: __webpack_require__(58).trim()
};

module.exports = {
    ShopperAccessibilityController: ShopperAccessibilityController,
    shopperAccessibilityComponentDefinition: shopperAccessibilityComponentDefinition
};

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "<h1 class=\"sr-only\">Accessibility</h1>\r\n<div class=\"myaccount-container\">\r\n    <div class=\"myaccount-center-container\">\r\n        <form>\r\n            <fieldset>\r\n                <legend class=\"sr-only\">Accessibility; changes will auto save</legend>\r\n                <div class=\"myaccount-sectionTitle\" aria-hidden=\"true\">\r\n                    <h2>Accessibility</h2>\r\n                </div>\r\n                <div class=\"myaccount-preferencesContainer\">\r\n                    <p>If you are using a screen reader or a keyboard only to navigate the Woolworths website please select the “Accessibility On” checkbox below</p>\r\n                    <input type=\"checkbox\" id=\"accessibleSwitch\" class=\"wowCheckbox\" ng-model=\"$ctrl.shopperService.preferences.EnableAccessibleOptions\" ng-change=\"$ctrl.setAccessibilityPreference()\"/>\r\n                    <label for=\"accessibleSwitch\">Accessibility On</label>\r\n                </div>\r\n            </fieldset>\r\n        </form>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.auth');

var _require = __webpack_require__(60),
    signupPageComponentDefinition = _require.signupPageComponentDefinition,
    _require2 = __webpack_require__(62),
    signupControllerComponentDefinition = _require2.signupControllerComponentDefinition,
    _require3 = __webpack_require__(64),
    signupFulfilmentComponentDefinition = _require3.signupFulfilmentComponentDefinition,
    _require4 = __webpack_require__(66),
    SignupService = _require4.SignupService;

wowApp.service('SignupService', SignupService).component('wowSignupPage', signupPageComponentDefinition).component('wowSignupForm', signupControllerComponentDefinition).component('wowSignupFulfilment', signupFulfilmentComponentDefinition);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SignupPageController = function SignupPageController() {
    _classCallCheck(this, SignupPageController);
};

var signupPageComponentDefinition = {
    controller: SignupPageController,
    template: __webpack_require__(61).trim()
};

module.exports = {
    SignupPageController: SignupPageController,
    signupPageComponentDefinition: signupPageComponentDefinition
};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = "<div class=\"signupPage\">\r\n    <wow-signup-form class=\"signupPage-form\"></wow-signup-form>\r\n</div>\r\n"

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fillServerErrors = __webpack_require__(16),
    _require = __webpack_require__(0),
    forOwn = _require.forOwn,
    forEach = _require.forEach;

var SignupController = function () {
    function SignupController($scope, signupService, paypalService, analytics, settings, moveFocus) {
        _classCallCheck(this, SignupController);

        this.$scope = $scope;
        this.signupService = signupService;
        this.paypalService = paypalService;
        this.analytics = analytics;
        this.settings = settings;
        this.moveFocus = moveFocus;

        this.signup = {
            TypeOfDeliveryMethod: 'Courier'
        };
        this.loading = false;
        this.isLoginWithPaypal = false;
        this.paypal = {};

        this.resetErrorMessages();

        // Settings
        this.signup.IdLikeToReceiveSmsTextsAboutProductsServicesAndPromotions = settings.registration.receiveSmsOfferByDefault;
        this.signup.IdLikeToReceiveEmailsAboutProductsAndServices = settings.registration.receiveEmailsByDefault;
        this.signup.IdLikeToBeSentTheCatalogue = settings.registration.receiveSampleByDefault;

        this.ShowSMSOffer = settings.registration.showSmsOffer;
        if (!this.ShowSMSOffer) {
            this.signup.IdLikeToReceiveSmsTextsAboutProductsServicesAndPromotions = false;
        }

        this.ShowReceiveSample = settings.registration.showReceiveSample;
        if (!this.ShowReceiveSample) {
            this.signup.IdLikeToBeSentTheCatalogue = false;
        }

        this.RewardsCardName = settings.everydayRewards.cardName;
    }

    _createClass(SignupController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.analytics.pushEvent(this.analytics.events.SIGN_UP.START);
            this.showPayPalLoadingSpinner = true;
            this.setupPaypal().finally(function () {
                _this.stopPaypalLoadingSpinner();
            });
        }
    }, {
        key: 'setupPaypal',
        value: function setupPaypal() {
            var _this2 = this;

            return this.paypalService.setup({ enableShippingAddress: true }, function (response) {
                return _this2.paypalCallback(response);
            });
        }
    }, {
        key: 'stopPaypalLoadingSpinner',
        value: function stopPaypalLoadingSpinner() {
            this.showPayPalLoadingSpinner = false;
        }
    }, {
        key: 'updateMobileFromPayPalResponse',
        value: function updateMobileFromPayPalResponse(phone) {
            var phoneNumber = phone.replace(/[-+/() ]/g, '');
            var auPrefix = /^61/g;
            if (auPrefix.test(phoneNumber)) {
                this.signup.MobilePhone = phoneNumber.replace(auPrefix, '0');
            }
        }
    }, {
        key: 'resetErrorMessages',
        value: function resetErrorMessages() {
            this.errors = {
                generalError: false
            };

            this.showErrors = false;
        }
    }, {
        key: 'setErrorMessage',
        value: function setErrorMessage(errorType, message) {
            this.errors[errorType] = message;
            this.showErrors = true;
            this.moveFocus('#errorMessage');
        }
    }, {
        key: 'onEnter',
        value: function onEnter() {}
    }, {
        key: 'getUserMessage',
        value: function getUserMessage() {
            return 'The sign up was not successful.' + (this.signupValidationMessage ? ' ' + this.signupValidationMessage : '');
        }
    }, {
        key: 'paypalLogin',
        value: function paypalLogin(event) {
            event.preventDefault();
            this.paypalService.initAuthFlow();
        }

        // Paypal

    }, {
        key: 'paypalCallback',
        value: function paypalCallback(response) {
            var details = response.details;
            this.signup.firstName = details.firstName;
            this.signup.lastName = details.lastName;
            this.updateMobileFromPayPalResponse(details.phone);
            this.signup.EmailAddress = details.email;
            this.signup.PaypalEmail = details.email;
            this.signup.PaypalNonce = response.nonce;
            this.signup.PaypalDeviceData = this.paypalService.getDeviceData();
            this.isLoginWithPaypal = true;

            // Manual Address
            var address = this.paypalService.resolveAddress(details);
            this.addressFromPayPal = address;

            if (address !== null && address !== undefined) {
                this.initialAddress = {
                    street1: address.extendedAddress !== undefined ? [address.streetAddress.trim(), address.extendedAddress.trim()].join(' ') : address.streetAddress.trim(),
                    postcode: address.postalCode.trim(),
                    suburbName: address.locality.trim()
                };
                this.signup.TypeOfDeliveryMethod = 'Courier';
            }
            this.$scope.$apply();
        }
    }, {
        key: 'cancelPaypalLogin',
        value: function cancelPaypalLogin(event) {
            event.preventDefault();
            this.isLoginWithPaypal = false;
            this.signup.PaypalNonce = null;
        }
    }, {
        key: 'submitSignup',
        value: function submitSignup() {
            var _this3 = this;

            fillServerErrors.clearForm(this.signupForm, this);
            this.resetErrorMessages();

            if (!this.signup.IsBusinessPurchase) {
                delete this.signup.companyName;
                delete this.signup.ABN;
                delete this.signup.TypeOfBusiness;
                delete this.signup.JobTitle;
                delete this.signup.EntityName;
            }
            // don't submit to server if client side is not valid. Set submitted anyway.
            if (!this.signupForm.$valid) {
                this.signupForm.$setSubmitted();
                return;
            }

            this.loading = true;
            this.signupService.signup(this.signup).then(function (res) {
                _this3.loading = false;
                if (res.Success) {
                    _this3.analytics.pushEvent(_this3.analytics.events.SIGN_UP.COMPLETED);
                } else if (!res.HasFieldErrors) {
                    _this3.setErrorMessage('generalError', res.Message);
                    _this3.analytics.pushEvent(_this3.analytics.events.SIGN_UP.FAILURE);
                    _this3.analytics.pushError(res.Message);
                } else {
                    _this3.signupValidationErrors = res.FieldErrors;
                    _this3.signupValidationMessage = res.Message;
                    _this3.analytics.pushEvent(_this3.analytics.events.SIGN_UP.FAILURE);
                    _this3.analytics.pushErrors(_this3.createErrorListFromFieldErrors(res.FieldErrors));

                    fillServerErrors.fillForm(_this3.signupForm, res.FieldErrors, _this3);
                }
            });
        }
    }, {
        key: 'createErrorListFromFieldErrors',
        value: function createErrorListFromFieldErrors(fieldErrors) {
            var errors = [];
            forOwn(fieldErrors, function (fieldError) {
                forEach(fieldError, function (errorItem) {
                    errors.push(errorItem);
                });
            });
            return errors;
        }
    }]);

    return SignupController;
}();

SignupController.$inject = ['$scope', 'SignupService', 'PaypalService', 'AnalyticsService', 'Settings', 'MoveFocus'];

var signupControllerComponentDefinition = {
    controller: SignupController,
    template: __webpack_require__(63).trim()
};

module.exports = {
    SignupController: SignupController,
    signupControllerComponentDefinition: signupControllerComponentDefinition
};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = "<form\r\n    role=\"form\"\r\n    name=\"$ctrl.signupForm\"\r\n    id=\"signupForm\"\r\n    class=\"signupForm\"\r\n    ng-submit=\"$ctrl.submitSignup()\"\r\n    wow-analytics-form-errors\r\n    novalidate\r\n>\r\n    <oly-form-validation-summary\r\n        user-message=\"{{ $ctrl.getUserMessage() }}\"\r\n    ></oly-form-validation-summary>\r\n\r\n    <div\r\n        class=\"alert alert--error\"\r\n        id=\"errorMessage\"\r\n        ng-show=\"$ctrl.showErrors\"\r\n        ng-messages=\"$ctrl.errors\"\r\n        role=\"status\"\r\n        aria-live=\"assertive\"\r\n        aria-atomic=\"true\"\r\n    >\r\n        <p class=\"signupForm-generalError\" ng-message=\"generalError\">\r\n            {{ $ctrl.errors.generalError }}\r\n        </p>\r\n    </div>\r\n\r\n    <!-- Signup header elems -->\r\n    <header class=\"signupForm-header\">\r\n        <div class=\"u-flexCenterCross\">\r\n            <i class=\"signupForm-profileIcon iconww-Profile\"></i>\r\n            <h1 class=\"signupForm-headerTitle\">Sign Up</h1>\r\n            <span\r\n                class=\"signupForm-subHeading signupForm-subHeading--spacer paypal-or\"\r\n                >OR</span\r\n            >\r\n            <oly-button\r\n                class=\"signupForm-headerPaypal\"\r\n                loading=\"{state: $ctrl.showPayPalLoadingSpinner}\"\r\n                spinner-class=\"paypal-loadingSpinner\"\r\n                button-class=\"paypal-signupButton\"\r\n            >\r\n                <a href=\"javascript:;\" ng-click=\"$ctrl.paypalLogin($event)\">\r\n                    <img\r\n                        src=\"/Images/Paypal/paypal-signup-new.png\"\r\n                        alt=\"Sign up with PayPal\"\r\n                    />\r\n                </a>\r\n            </oly-button>\r\n        </div>\r\n        <div\r\n            class=\"signupForm-businessSignup\"\r\n            ng-if=\"$ctrl.settings.business.enableBusiness\"\r\n        >\r\n            <a\r\n                href=\"/business/registerorganisation\"\r\n                class=\"linkButton\"\r\n                target=\"_self\"\r\n            >\r\n                Signing up for a business?\r\n            </a>\r\n        </div>\r\n    </header>\r\n\r\n    <input\r\n        type=\"hidden\"\r\n        id=\"signupForm-Nonce\"\r\n        name=\"Nonce\"\r\n        ng-model=\"$ctrl.signup.PaypalNonce\"\r\n    />\r\n    <input\r\n        type=\"hidden\"\r\n        id=\"signupForm-PaypalEmail\"\r\n        name=\"PaypalEmail\"\r\n        ng-model=\"$ctrl.signup.PaypalEmail\"\r\n    />\r\n    <input\r\n        type=\"hidden\"\r\n        id=\"signupForm-PaypalDeviceData\"\r\n        name=\"PaypalDeviceData\"\r\n        ng-model=\"$ctrl.signup.PaypalDeviceData\"\r\n    />\r\n\r\n    <div class=\"signupForm-subHeading\">* Marks mandatory fields</div>\r\n\r\n    <!-- User Details -->\r\n    <fieldset>\r\n        <legend class=\"sr-only\">\r\n            Personal Details; * Marks mandatory fields\r\n        </legend>\r\n        <div class=\"signupForm-inputWrapper\">\r\n            <wow-input-container class=\"signupForm-inputContainer\">\r\n                <label for=\"signupForm-FirstName\">\r\n                    First name *\r\n                </label>\r\n                <input\r\n                    type=\"text\"\r\n                    id=\"signupForm-FirstName\"\r\n                    name=\"FirstName\"\r\n                    class=\"signupForm-input\"\r\n                    ng-model=\"$ctrl.signup.firstName\"\r\n                    required\r\n                />\r\n                <span\r\n                    ng-messages=\"$ctrl.signupForm.FirstName.$error\"\r\n                    class=\"wowInput-errors\"\r\n                >\r\n                    <span ng-message=\"required\" class=\"wowInput-error\"\r\n                        >First name is required.</span\r\n                    >\r\n                    <span ng-message=\"serverError\" class=\"wowInput-error\">{{\r\n                        $ctrl.signupValidationErrors.FirstName[0]\r\n                    }}</span>\r\n                </span>\r\n            </wow-input-container>\r\n\r\n            <wow-input-container class=\"signupForm-inputContainer\">\r\n                <label for=\"signupForm-LastName\">\r\n                    Last name *\r\n                </label>\r\n                <input\r\n                    type=\"text\"\r\n                    id=\"signupForm-LastName\"\r\n                    name=\"LastName\"\r\n                    class=\"signupForm-input\"\r\n                    ng-model=\"$ctrl.signup.lastName\"\r\n                    required\r\n                />\r\n                <span\r\n                    ng-messages=\"$ctrl.signupForm.LastName.$error\"\r\n                    class=\"wowInput-errors\"\r\n                >\r\n                    <span ng-message=\"required\" class=\"wowInput-error\"\r\n                        >Last name is required.</span\r\n                    >\r\n                    <span ng-message=\"serverError\" class=\"wowInput-error\">{{\r\n                        $ctrl.signupValidationErrors.LastName[0]\r\n                    }}</span>\r\n                </span>\r\n            </wow-input-container>\r\n        </div>\r\n\r\n        <div class=\"signupForm-inputWrapper\">\r\n            <wow-input-container class=\"signupForm-inputContainer\">\r\n                <label for=\"signupForm-EmailAddress\">\r\n                    Email address *\r\n                </label>\r\n                <input\r\n                    type=\"email\"\r\n                    id=\"signupForm-EmailAddress\"\r\n                    name=\"EmailAddress\"\r\n                    class=\"signupForm-input\"\r\n                    ng-model=\"$ctrl.signup.EmailAddress\"\r\n                    wow-email-validator\r\n                    required\r\n                    autocomplete=\"off\"\r\n                />\r\n                <span\r\n                    ng-messages=\"$ctrl.signupForm.EmailAddress.$error\"\r\n                    class=\"wowInput-errors\"\r\n                >\r\n                    <span ng-message=\"required\" class=\"wowInput-error\"\r\n                        >Email address is required.</span\r\n                    >\r\n                    <span ng-message=\"email\" class=\"wowInput-error\"\r\n                        >Email address is required to be in the format of\r\n                        example@example.com</span\r\n                    >\r\n                    <span ng-message=\"serverError\" class=\"wowInput-error\">{{\r\n                        $ctrl.signupValidationErrors.EmailAddress[0]\r\n                    }}</span>\r\n                </span>\r\n            </wow-input-container>\r\n\r\n            <wow-input-container class=\"signupForm-inputContainer has-icon\">\r\n                <label for=\"signupForm-Password\">\r\n                    Create password *\r\n                    <span\r\n                        class=\"sr-only\"\r\n                        wow-html-setting\r\n                        setting-group=\"HandyHint\"\r\n                        setting-name=\"Password\"\r\n                    ></span>\r\n                </label>\r\n                <input\r\n                    type=\"password\"\r\n                    id=\"signupForm-Password\"\r\n                    name=\"Password\"\r\n                    class=\"signupForm-input\"\r\n                    ng-model=\"$ctrl.signup.password\"\r\n                    autocomplete=\"off\"\r\n                    value=\"\"\r\n                    minlength=\"6\"\r\n                    pattern=\".*\\d.*\"\r\n                    required\r\n                />\r\n                <span\r\n                    ng-messages=\"$ctrl.signupForm.Password.$error\"\r\n                    class=\"wowInput-errors\"\r\n                >\r\n                    <span ng-message=\"required\" class=\"wowInput-error\"\r\n                        >Password is required.</span\r\n                    >\r\n                    <span ng-message=\"minlength\" class=\"wowInput-error\">{{\r\n                        $ctrl.settings.handyHint.password\r\n                    }}</span>\r\n                    <span ng-message=\"pattern\" class=\"wowInput-error\">{{\r\n                        $ctrl.settings.handyHint.password\r\n                    }}</span>\r\n                    <span ng-message=\"serverError\" class=\"wowInput-error\">{{\r\n                        $ctrl.signupValidationErrors.Password[0]\r\n                    }}</span>\r\n                </span>\r\n                <!-- password: minlength 6, require 1 number-->\r\n                <oly-questionmark-tooltip\r\n                    message=\"{{ $ctrl.settings.handyHint.password }}\"\r\n                ></oly-questionmark-tooltip>\r\n            </wow-input-container>\r\n        </div>\r\n\r\n        <div class=\"signupForm-inputWrapper\">\r\n            <wow-input-container class=\"signupForm-inputContainer\">\r\n                <label for=\"signupForm-DateOfBirth\">\r\n                    Date of birth<span class=\"sr-only\"\r\n                        >, format: day day / month month / year year year\r\n                        year</span\r\n                    >\r\n                </label>\r\n                <input\r\n                    type=\"tel\"\r\n                    id=\"signupForm-DateOfBirth\"\r\n                    name=\"DateOfBirth\"\r\n                    class=\"signupForm-input\"\r\n                    placeholder=\"DD/MM/YYYY\"\r\n                    ng-model=\"$ctrl.signup.DateOfBirth\"\r\n                    pattern=\"\\d{2}\\/\\d{2}\\/\\d{4}\"\r\n                    wow-mask=\"00/00/0000\"\r\n                />\r\n                <span\r\n                    ng-messages=\"$ctrl.signupForm.DateOfBirth.$error\"\r\n                    class=\"wowInput-errors\"\r\n                >\r\n                    <span ng-message=\"pattern\" class=\"wowInput-error\"\r\n                        >Date of birth must be in the format DD/MM/YYYY.</span\r\n                    >\r\n                    <span ng-message=\"serverError\" class=\"wowInput-error\">{{\r\n                        $ctrl.signupValidationErrors.DateOfBirth[0]\r\n                    }}</span>\r\n                </span>\r\n            </wow-input-container>\r\n\r\n            <wow-input-container class=\"signupForm-inputContainer\">\r\n                <label for=\"signupForm-MobilePhone\">\r\n                    Preferred contact number *\r\n                    <span\r\n                        class=\"sr-only\"\r\n                        wow-html-setting\r\n                        setting-group=\"HandyHint\"\r\n                        setting-name=\"PreferredContactNumberToolTip\"\r\n                    ></span>\r\n                </label>\r\n                <input\r\n                    type=\"tel\"\r\n                    id=\"signupForm-MobilePhone\"\r\n                    name=\"MobilePhone\"\r\n                    class=\"signupForm-input\"\r\n                    ng-model=\"$ctrl.signup.MobilePhone\"\r\n                    pattern=\"^[\\d]+$\"\r\n                    required\r\n                />\r\n                <span\r\n                    ng-messages=\"$ctrl.signupForm.MobilePhone.$error\"\r\n                    class=\"wowInput-errors\"\r\n                >\r\n                    <span ng-message=\"required\" class=\"wowInput-error\"\r\n                        >Phone number is required.</span\r\n                    >\r\n                    <span ng-message=\"pattern\" class=\"wowInput-error\">{{\r\n                        $ctrl.settings.oneSite.otherNumbersValidationMessageText\r\n                    }}</span>\r\n                    <span ng-message=\"serverError\" class=\"wowInput-error\">{{\r\n                        $ctrl.signupValidationErrors.MobilePhone[0]\r\n                    }}</span>\r\n                </span>\r\n                <oly-questionmark-tooltip\r\n                    message=\"{{\r\n                        $ctrl.settings.handyHint.preferredContactNumberToolTip\r\n                    }}\"\r\n                ></oly-questionmark-tooltip>\r\n            </wow-input-container>\r\n        </div>\r\n    </fieldset>\r\n\r\n    <!-- paypal once pseudo linked-->\r\n    <div class=\"signupForm-paypalAccountLink\" ng-show=\"$ctrl.isLoginWithPaypal\">\r\n        <img src=\"/Images/Paypal/paypal_icon.png\" alt=\"Log in with Paypal\" />\r\n        {{ $ctrl.signup.PaypalEmail }}\r\n        <button class=\"linkButton\" ng-click=\"$ctrl.cancelPaypalLogin($event)\">\r\n            Cancel\r\n        </button>\r\n    </div>\r\n\r\n    <!-- business inputs -->\r\n    <fieldset ng-if=\"!$ctrl.settings.business.enableBusiness\">\r\n        <legend class=\"sr-only\">Business Details</legend>\r\n\r\n        <input\r\n            type=\"checkbox\"\r\n            name=\"isBusiness\"\r\n            id=\"signupForm-isBusiness\"\r\n            ng-model=\"$ctrl.signup.IsBusinessPurchase\"\r\n            class=\"wowCheckbox\"\r\n        />\r\n        <label class=\"signupForm-businessBlurb\" for=\"signupForm-isBusiness\"\r\n            >I'm shopping on behalf of a business</label\r\n        >\r\n\r\n        <div\r\n            ng-if=\"$ctrl.signup.IsBusinessPurchase\"\r\n            class=\"signupForm-businessDetailsContainer\"\r\n        >\r\n            <wow-loading-spinner\r\n                class=\"signupForm-loadingSpinner\"\r\n                message=\"Validating ABN, please wait\"\r\n                is-message-sr-only=\"true\"\r\n                ng-show=\"$ctrl.isBusinessDetailsLoading\"\r\n            >\r\n            </wow-loading-spinner>\r\n            <div class=\"signupForm-inputWrapper\">\r\n                <wow-abn\r\n                    form-values=\"$ctrl.signup\"\r\n                    class-modifier=\"wide\"\r\n                    should-grab-focus=\"true\"\r\n                    set-loading=\"$ctrl.isBusinessDetailsLoading = status\"\r\n                    has-submitted=\"$ctrl.signupForm.$submitted\"\r\n                >\r\n                </wow-abn>\r\n\r\n                <wow-input-container class=\"signupForm-inputContainer\">\r\n                    <label for=\"signupForm-EntityName\">\r\n                        Entity Name\r\n                    </label>\r\n                    <input\r\n                        type=\"text\"\r\n                        id=\"signupForm-EntityName\"\r\n                        name=\"EntityName\"\r\n                        class=\"signupForm-input\"\r\n                        ng-model=\"$ctrl.signup.EntityName\"\r\n                        disabled\r\n                    />\r\n                </wow-input-container>\r\n            </div>\r\n\r\n            <div class=\"signupForm-inputWrapper\">\r\n                <wow-input-container class=\"signupForm-inputContainer\">\r\n                    <label for=\"signupForm-CompanyName\">\r\n                        Company Name *\r\n                    </label>\r\n                    <input\r\n                        type=\"text\"\r\n                        id=\"signupForm-CompanyName\"\r\n                        name=\"CompanyName\"\r\n                        class=\"signupForm-input\"\r\n                        ng-model=\"$ctrl.signup.companyName\"\r\n                        required\r\n                    />\r\n                    <span\r\n                        ng-messages=\"$ctrl.signupForm.CompanyName.$error\"\r\n                        class=\"wowInput-errors\"\r\n                    >\r\n                        <span ng-message=\"required\" class=\"wowInput-error\"\r\n                            >Company name is required.</span\r\n                        >\r\n                        <span ng-message=\"serverError\" class=\"wowInput-error\">{{\r\n                            $ctrl.signupValidationErrors.CompanyName[0]\r\n                        }}</span>\r\n                    </span>\r\n                </wow-input-container>\r\n\r\n                <wow-select-container\r\n                    class=\"signupForm-inputContainer\"\r\n                    ng-class=\"{'is-invalid': (!$ctrl.signup.TypeOfBusiness && ($ctrl.signupForm.BusinessType.$dirty || $ctrl.signupForm.$submitted))}\"\r\n                >\r\n                    <label for=\"signupForm-businessType\">Business Type *</label>\r\n                    <select\r\n                        id=\"signupForm-businessType\"\r\n                        class=\"signupForm-input\"\r\n                        name=\"BusinessType\"\r\n                        ng-model=\"$ctrl.signup.TypeOfBusiness\"\r\n                        required\r\n                    >\r\n                        <option value=\"\" disabled>Please select</option>\r\n                        <option\r\n                            ng-repeat=\"type in $ctrl.signupService.businessTypes\"\r\n                            value=\"{{ type }}\"\r\n                            >{{ type }}</option\r\n                        >\r\n                    </select>\r\n                    <span\r\n                        ng-messages=\"$ctrl.signupForm.BusinessType.$error\"\r\n                        class=\"wowInput-errors\"\r\n                    >\r\n                        <span ng-message=\"required\" class=\"wowInput-error\"\r\n                            >Business type is required.</span\r\n                        >\r\n                    </span>\r\n                </wow-select-container>\r\n            </div>\r\n            <div class=\"signupForm-inputWrapper\">\r\n                <wow-input-container class=\"signupForm-inputContainer\">\r\n                    <label for=\"signupForm-jobTitle\">Job Title</label>\r\n                    <input\r\n                        type=\"text\"\r\n                        id=\"signupForm-jobTitle\"\r\n                        name=\"jobTitle\"\r\n                        class=\"signupForm-input\"\r\n                        ng-model=\"$ctrl.signup.JobTitle\"\r\n                        ng-model-options=\"{updateOn: 'submit'}\"\r\n                    />\r\n                </wow-input-container>\r\n            </div>\r\n        </div>\r\n    </fieldset>\r\n\r\n    <hr class=\"signupForm-separator\" />\r\n\r\n    <!-- Edr card details -->\r\n    <fieldset>\r\n        <legend class=\"signupForm-addRewardsCardLink heading4\">\r\n            Add your Rewards card or\r\n            <a\r\n                ng-href=\"{{\r\n                    $ctrl.settings.everydayRewards.maintainEdrRegisterLinkUrl\r\n                }}\"\r\n                target=\"_blank\"\r\n            >\r\n                join now\r\n                <span class=\"sr-only\">Opens in a new window</span>\r\n            </a>\r\n            <span class=\"signupForm-addRewardsCardSubHeading\">(optional)</span>\r\n        </legend>\r\n        <div class=\"signupForm-inputWrapper\">\r\n            <wow-input-container\r\n                class=\"signupForm-inputContainer signupForm-edrContainer\"\r\n            >\r\n                <img\r\n                    class=\"signupForm-edrImage\"\r\n                    alt=\"\"\r\n                    src=\"/Images/Collectionzone/icon-rewards-card.png\"\r\n                />\r\n                <label\r\n                    for=\"signupForm-EdrNumber\"\r\n                    class=\"signupForm-edrContainerEdrNumberLabel\"\r\n                >\r\n                    {{::$ctrl.RewardsCardName\r\n                    }}<span class=\"sr-only\"> (numbers only)</span>\r\n                </label>\r\n                <input\r\n                    type=\"tel\"\r\n                    id=\"signupForm-EdrNumber\"\r\n                    name=\"EdrNumber\"\r\n                    class=\"signupForm-input signupForm-edrContainerEdrNumber\"\r\n                    placeholder=\"Card number\"\r\n                    ng-model=\"$ctrl.signup.EdrNumber\"\r\n                    pattern=\"^[\\d ]+$\"\r\n                />\r\n                <span\r\n                    ng-messages=\"$ctrl.signupForm.EdrNumber.$error\"\r\n                    class=\"wowInput-errors\"\r\n                >\r\n                    <span ng-message=\"pattern\" class=\"wowInput-error\"\r\n                        >Card number must contain only numbers</span\r\n                    >\r\n                    <span ng-message=\"serverError\" class=\"wowInput-error\">{{\r\n                        $ctrl.signupValidationErrors.EdrNumber[0]\r\n                    }}</span>\r\n                </span>\r\n            </wow-input-container>\r\n\r\n            <wow-input-container\r\n                class=\"signupForm-inputContainer has-icon\"\r\n                ng-if=\"$ctrl.settings.everydayRewards.enableEdrPasswordUi\"\r\n            >\r\n                <label for=\"signupForm-EdrPassword\">\r\n                    Password\r\n                    <span ng-if=\"$ctrl.signup.EdrNumber.length\">*</span>\r\n                </label>\r\n                <input\r\n                    type=\"password\"\r\n                    id=\"signupForm-EdrPassword\"\r\n                    name=\"EdrPassword\"\r\n                    class=\"signupForm-input\"\r\n                    autocomplete=\"off\"\r\n                    value=\"\"\r\n                    placeholder=\"Password\"\r\n                    ng-model=\"$ctrl.signup.EdrPassword\"\r\n                    ng-required=\"$ctrl.signup.EdrNumber.length\"\r\n                />\r\n                <span\r\n                    ng-messages=\"$ctrl.signupForm.EdrPassword.$error\"\r\n                    class=\"wowInput-errors\"\r\n                >\r\n                    <span ng-message=\"required\" class=\"wowInput-error\"\r\n                        >Password is required.</span\r\n                    >\r\n                    <span ng-message=\"serverError\" class=\"wowInput-error\">{{\r\n                        $ctrl.signupValidationErrors.EdrPassword[0]\r\n                    }}</span>\r\n                </span>\r\n                <oly-questionmark-tooltip\r\n                    message=\"{{ $ctrl.settings.handyHint.edrPassword }}\"\r\n                ></oly-questionmark-tooltip>\r\n            </wow-input-container>\r\n        </div>\r\n        <a\r\n            ng-href=\"{{\r\n                $ctrl.settings.everydayRewards.forgottenPasswordRewardsLink\r\n            }}\"\r\n            target=\"_blank\"\r\n            class=\"linkButton\"\r\n            ng-if=\"$ctrl.settings.everydayRewards.enableEdrPasswordUi\"\r\n        >\r\n            Forgotten your password?\r\n            <span class=\"sr-only\">, Opens in a new window</span>\r\n        </a>\r\n    </fieldset>\r\n\r\n    <hr class=\"signupForm-separator\" />\r\n\r\n    <wow-signup-fulfilment\r\n        initial-address=\"$ctrl.initialAddress\"\r\n        signup=\"$ctrl.signup\"\r\n    >\r\n    </wow-signup-fulfilment>\r\n\r\n    <hr class=\"signupForm-separator\" />\r\n\r\n    <!-- terms and conditions &amp; EDR -->\r\n    <fieldset class=\"signupForm-commsPane\">\r\n        <legend class=\"heading4 signupForm-sectionLegend\">\r\n            Communication preferences\r\n        </legend>\r\n        <p\r\n            wow-html-setting\r\n            setting-group=\"OneSite\"\r\n            setting-name=\"SignupMyAccountCommunicationPreferencesText\"\r\n        ></p>\r\n\r\n        <div class=\"signupForm-commOptions\" ng-show=\"$ctrl.ShowSMSOffer\">\r\n            <input\r\n                type=\"checkbox\"\r\n                id=\"signupForm-promoSMS\"\r\n                class=\"wowCheckbox\"\r\n                name=\"promoSMS\"\r\n                ng-model=\"$ctrl.signup.IdLikeToReceiveSmsTextsAboutProductsServicesAndPromotions\"\r\n            />\r\n            <label\r\n                for=\"signupForm-promoSMS\"\r\n                wow-html-setting\r\n                setting-name=\"CommunicationPreferencesSMS\"\r\n                setting-group=\"OneSite\"\r\n            ></label>\r\n        </div>\r\n        <div class=\"signupForm-commOptions\">\r\n            <input\r\n                type=\"checkbox\"\r\n                id=\"signupForm-promoEmails\"\r\n                class=\"wowCheckbox\"\r\n                name=\"promoEmails\"\r\n                ng-model=\"$ctrl.signup.IdLikeToReceiveEmailsAboutProductsAndServices\"\r\n            />\r\n            <label\r\n                for=\"signupForm-promoEmails\"\r\n                wow-html-setting\r\n                setting-name=\"CommunicationPreferencesEmail\"\r\n                setting-group=\"OneSite\"\r\n            ></label>\r\n        </div>\r\n        <div ng-show=\"$ctrl.ShowReceiveSample\" class=\"signupForm-commOptions\">\r\n            <input\r\n                type=\"checkbox\"\r\n                id=\"signupForm-promoCatalogue\"\r\n                class=\"wowCheckbox\"\r\n                name=\"promoCatalogue\"\r\n                ng-model=\"$ctrl.signup.IdLikeToBeSentTheCatalogue\"\r\n            />\r\n            <label\r\n                for=\"signupForm-promoCatalogue\"\r\n                wow-html-setting\r\n                setting-name=\"CommunicationPreferencesSample\"\r\n                setting-group=\"OneSite\"\r\n            ></label>\r\n        </div>\r\n    </fieldset>\r\n\r\n    <hr class=\"signupForm-separator\" />\r\n\r\n    <div class=\"signupForm-legalLinkWrapper\">\r\n        <div class=\"signupForm-legalLinks\">\r\n            <a\r\n                class=\"signupForm-legalLink\"\r\n                href=\"/Shop/PrivacyPolicy\"\r\n                target=\"_blank\"\r\n            >\r\n                Privacy <span class=\"sr-only\">, Opens in a new window</span>\r\n            </a>\r\n            <a\r\n                class=\"signupForm-legalLink\"\r\n                href=\"/Shop/TermsAndConditions\"\r\n                target=\"_blank\"\r\n            >\r\n                <abbr title=\"Terms and conditions\">T&amp;Cs</abbr>\r\n                <span class=\"sr-only\">, Opens in a new window</span>\r\n            </a>\r\n            <a\r\n                class=\"signupForm-legalLink\"\r\n                href=\"/Shop/CollectionNotice\"\r\n                target=\"_blank\"\r\n            >\r\n                Collection Notice\r\n                <span class=\"sr-only\">, Opens in a new window</span>\r\n            </a>\r\n            <a\r\n                class=\"signupForm-legalLink\"\r\n                href=\"/Shop/Page/Business\"\r\n                target=\"_blank\"\r\n            >\r\n                Business Orders\r\n                <span class=\"sr-only\">, Opens in a new window</span>\r\n            </a>\r\n        </div>\r\n\r\n        <oly-button\r\n            loading=\"{state: $ctrl.loading, message: 'Processing sign up, please wait'}\"\r\n            class=\"signupForm-signupButtonMain\"\r\n            button-class=\"signupForm-signupButtonContainer\"\r\n        >\r\n            <button\r\n                type=\"submit\"\r\n                id=\"signupForm-SignupButton\"\r\n                class=\"button button--primary signupForm-signupButton\"\r\n            >\r\n                Sign up <i class=\"iconww-ArrowRight\"></i>\r\n            </button>\r\n        </oly-button>\r\n    </div>\r\n</form>\r\n"

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SignupFulfilmentController = function () {
    function SignupFulfilmentController(settings) {
        _classCallCheck(this, SignupFulfilmentController);

        this.settings = settings;
    }

    _createClass(SignupFulfilmentController, [{
        key: '$onInit',
        value: function $onInit() {
            this.signup.TypeOfDeliveryMethod = 'Courier';
            this.canFocusForm = false;
        }
    }, {
        key: 'fulfilmentOptionChanged',
        value: function fulfilmentOptionChanged() {
            this.clearStoreSelection();
            this.canFocusForm = true;
        }
    }, {
        key: 'manualDeliveryAddressSelected',
        value: function manualDeliveryAddressSelected(address) {
            this.signup.TypeOfAddress = 'manual';
            this.signup.AddressStreet1 = address.street1;
            this.signup.AddressStreet2 = address.street2;
            this.signup.AddressSuburbId = address.suburbId;
            this.signup.AddressPostcode = address.postcode;
        }
    }, {
        key: 'autoDeliveryAddressSelected',
        value: function autoDeliveryAddressSelected(address) {
            this.signup.TypeOfAddress = 'auto';
            this.signup.AmasAddressId = address.Id;
        }
    }, {
        key: 'pickupAddressSelected',
        value: function pickupAddressSelected(storeAddress) {
            this.signup.TypeOfAddress = 'auto';
            this.selectedStoreName = storeAddress.AddressText;
            this.signup.AmasPickupStoreAddressId = storeAddress.AddressId;
        }
    }, {
        key: 'autoBillingAddressSelected',
        value: function autoBillingAddressSelected(billingAddress) {
            this.signup.TypeOfAddress = 'auto';
            this.signup.AmasAddressId = billingAddress.Id;
        }
    }, {
        key: 'manualBillingAddressSelected',
        value: function manualBillingAddressSelected(billingAddress) {
            // The signup request reuses the delivery paramters
            // for billing when pickup is selected.
            this.manualDeliveryAddressSelected(billingAddress);
        }
    }, {
        key: 'clearStoreSelection',
        value: function clearStoreSelection() {
            this.selectedStoreName = null;
            this.signup.AmasPickupStoreAddressId = null;
        }
    }]);

    return SignupFulfilmentController;
}();

SignupFulfilmentController.$inject = ['Settings'];

var signupFulfilmentComponentDefinition = {
    controller: SignupFulfilmentController,
    bindings: {
        signup: '<',
        initialAddress: '<'
    },
    template: __webpack_require__(65).trim()
};

module.exports = {
    SignupFulfilmentController: SignupFulfilmentController,
    signupFulfilmentComponentDefinition: signupFulfilmentComponentDefinition
};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = "<fieldset class=\"signupFulfilmentForm\">\r\n    <legend class=\"signupFulfilmentForm-legend heading4\">For a customised experience, tell us how you'd like to receive your groceries</legend>\r\n    <div class=\"signupFulfilmentForm-fulfilmentMethods\">\r\n        <div class=\"signupFulfilmentForm-fulfilmentMethod\">\r\n            <input id=\"signupFulfilmentForm-fulfilmentRadio-Courier\"\r\n                class=\"wowRadio\"\r\n                type=\"radio\"\r\n                ng-model=\"$ctrl.signup.TypeOfDeliveryMethod\"\r\n                ng-change=\"$ctrl.fulfilmentOptionChanged()\"\r\n                ng-value=\"'Courier'\"\r\n                name=\"TypeOfDeliveryMethod\"\r\n                required />\r\n            <label for=\"signupFulfilmentForm-fulfilmentRadio-Courier\"\r\n                class=\"signupFulfilmentForm-fulfilmentMethodLabel\">\r\n                <h4 class=\"signupFulfilmentForm-fulfilmentMethodTitle\">Delivery</h4>\r\n                <p class=\"signupFulfilmentForm-fulfilmentMethodDescription\"> Have your groceries delivered right to your door</p>\r\n            </label>\r\n\r\n            <wow-address-entry-form\r\n                input-id=\"signupDelivery\"\r\n                class=\"signupFulfilmentForm-fulfilmentMethodForm\"\r\n                initial-address=\"$ctrl.initialAddress\"\r\n                ng-if=\"$ctrl.signup.TypeOfDeliveryMethod === 'Courier'\"\r\n                should-focus-initially=\"$ctrl.canFocusForm\"\r\n                show-submit=\"false\"\r\n                on-save-auto-address=\"$ctrl.autoDeliveryAddressSelected(address)\"\r\n                on-manual-address-change=\"$ctrl.manualDeliveryAddressSelected(address)\"\r\n                should-retain-input=\"true\">\r\n            </wow-address-entry-form>\r\n        </div>\r\n        <div class=\"signupFulfilmentForm-fulfilmentMethod\">\r\n            <input id=\"signupFulfilmentForm-fulfilmentRadio-Pickup\"\r\n                    class=\"wowRadio\"\r\n                    type=\"radio\"\r\n                    ng-model=\"$ctrl.signup.TypeOfDeliveryMethod\"\r\n                    ng-change=\"$ctrl.fulfilmentOptionChanged()\"\r\n                    ng-value=\"'Pickup'\"\r\n                    name=\"TypeOfDeliveryMethod\"\r\n                    required />\r\n            <label for=\"signupFulfilmentForm-fulfilmentRadio-Pickup\"\r\n                class=\"signupFulfilmentForm-fulfilmentMethodLabel\">\r\n                <h4 class=\"signupFulfilmentForm-fulfilmentMethodTitle\">{{$ctrl.settings.signUpForm.pickupTitle}}</h4>\r\n                <p class=\"signupFulfilmentForm-fulfilmentMethodDescription\">{{$ctrl.settings.signUpForm.pickupDescription}}</p>\r\n            </label>\r\n            <div ng-if=\"$ctrl.signup.TypeOfDeliveryMethod === 'Pickup'\" class=\"signupFulfilmentForm-fulfilmentMethodForm\" ng-switch=\"!!$ctrl.signup.AmasPickupStoreAddressId\">\r\n                <!-- Billing address -->\r\n                <div ng-switch-when=\"true\">\r\n                    <div>\r\n                        <div>\r\n                            {{$ctrl.selectedStoreName}} <i class=\"iconww-Tick\"></i>\r\n                        </div>\r\n                        <a oly-move-focus=\"{{$ctrl.chooseStoreSelector}}\"\r\n                            href=\"javascript:;\"\r\n                            ng-click=\"$ctrl.clearStoreSelection()\"\r\n                            aria-label=\"edit pickup store {{$ctrl.selectedStoreName}}\">Change store</a>\r\n                    </div>\r\n                    <p>Billing Address*</p>\r\n                    <wow-address-entry-form\r\n                        input-id=\"signupBilling\"\r\n                        show-submit=\"false\"\r\n                        should-focus-initially=\"true\"\r\n                        on-save-auto-address=\"$ctrl.autoBillingAddressSelected(address)\"\r\n                        on-manual-address-change=\"$ctrl.manualBillingAddressSelected(address)\"\r\n                        should-retain-input=\"true\"\r\n                        is-required=\"true\">\r\n                    </wow-address-entry-form>\r\n                </div>\r\n                <!-- Pickup address -->\r\n                <!-- This is deliberately moved below the address entry form so that when the form get focussed, it will not shift the scrolling position. -->\r\n                <wow-pickup-address\r\n                    id=\"signup-pickup-address\"\r\n                    ng-switch-when=\"false\"\r\n                    set-pickup-address=\"$ctrl.pickupAddressSelected(addr)\"\r\n                    is-required=\"true\">\r\n                </wow-pickup-address>\r\n            </div>\r\n        </div>\r\n        <div class=\"signupFulfilmentForm-fulfilmentMethod\">\r\n            <input id=\"signupFulfilmentForm-fulfilmentRadio-DecideLater\"\r\n                    class=\"wowRadio\"\r\n                    type=\"radio\"\r\n                    ng-model=\"$ctrl.signup.TypeOfDeliveryMethod\"\r\n                    ng-change=\"$ctrl.fulfilmentOptionChanged()\"\r\n                    ng-value=\"'DecideLater'\"\r\n                    name=\"TypeOfDeliveryMethod\"\r\n                    required />\r\n            <label for=\"signupFulfilmentForm-fulfilmentRadio-DecideLater\"\r\n                class=\"signupFulfilmentForm-fulfilmentMethodLabel\">\r\n                <h4 class=\"signupFulfilmentForm-fulfilmentMethodTitle\">Or decide later</h4>\r\n            </label>\r\n        </div>\r\n    </div>\r\n</fieldset>\r\n"

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    forEach = _require.forEach;

var SignupService = function () {
    function SignupService($rootScope, $q, Restangular, sessionStorage, loginService, shopperService, analytics, settings) {
        _classCallCheck(this, SignupService);

        this._api = Restangular.one('signup');
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.sessionStorage = sessionStorage;
        this.loginService = loginService;
        this.shopperService = shopperService;
        this.analytics = analytics;
        this.settings = settings;

        this.businessTypes = this.getBusinessTypes();
    }

    _createClass(SignupService, [{
        key: 'signup',
        value: function signup(args) {
            var _this = this;

            var signupPromise = this._api.doPOST(args);

            var shopperPromise = signupPromise.then(function (signupResult) {
                return signupResult.Success ? _this.shopperService.getCurrentShopper() : null;
            });

            return this.$q.all([signupPromise, shopperPromise]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 1),
                    signupResult = _ref2[0];

                if (signupResult.Success) {
                    _this.redirectToAgentUrl = signupResult.RedirectToAgentUrl;
                    _this.analytics.push({ data: { event: 'signup' } });
                    _this.loginService.onLogin(signupResult.LoginModel);
                    _this.$rootScope.$broadcast('signup:success');
                    // flag to push login and signup user detail to analytics
                    _this.sessionStorage.set('shouldTrackSignupEvent', true);
                    _this.sessionStorage.set('shouldTrackLoginEvent', true);
                }

                return signupResult;
            });
        }
    }, {
        key: 'getBusinessTypes',
        value: function getBusinessTypes() {
            if (this.settings.b2B.businessTypeCategoryMapping === null) {
                return [];
            }

            var businessTypes = [];
            var settingLines = this.settings.b2B.businessTypeCategoryMapping.split(/\r\n|\r|\n/g);
            forEach(settingLines, function (line) {
                var businessTypeData = line.split(';');
                if (businessTypeData && businessTypeData.length >= 1) {
                    businessTypes.push(businessTypeData[0].trim());
                }
            });

            return businessTypes.sort();
        }
    }]);

    return SignupService;
}();

SignupService.$inject = ['$rootScope', '$q', 'Restangular', 'SessionStorageWrapper', 'LoginService', 'ShopperService', 'AnalyticsService', 'Settings'];

module.exports = { SignupService: SignupService };

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.auth');

// Services

wowApp.service('ResetPasswordService', ['Restangular', __webpack_require__(68)]);

// Directives
wowApp.component('wowResetPassword', __webpack_require__(69).resetPasswordComponentDefinition);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Provides functions to manipulate user passwords.
 * @class
 * @param {Restangular} Restangular
 */
function ResetPasswordService(Restangular) {
  this._api = Restangular.one('password');
  this._myAccountApi = Restangular.one('MyAccount/Password');
}

/**
 * Tries to send the forgot password email if the user is valid.
 * @param {string} email - The user provided email
 * @returns {Promise}
 */
ResetPasswordService.prototype.forgotPassword = function (email) {
  return this._api.post('ForgotPassword', { email: email });
};

/**
 * Validates the provided password reminder token.
 * @param {string} token
 * @returns {Promise}
 */
ResetPasswordService.prototype.validatePasswordReminderToken = function (token) {
  return this._api.post('ValidateToken', { ReminderToken: token });
};

/**
 * Resets the user's password with a reminder token.
 * @param {string} newPassword
 * @param {string} newPasswordConfirmation
 * @param {string} reminderToken
 * @returns {Promise}
 */
ResetPasswordService.prototype.resetPassword = function (newPassword, newPasswordConfirmation, reminderToken) {
  return this._api.post('ResetPassword', { NewPassword: newPassword, NewPasswordConfirmation: newPasswordConfirmation, ReminderToken: reminderToken });
};

/**
 * Changes the user's password.
 * @param {string} currentPassword
 * @param {string} newPassword
 * @returns {Promise}
 */
ResetPasswordService.prototype.changePassword = function (currentPassword, newPassword) {
  return this._myAccountApi.doPOST({ CurrentPassword: currentPassword, NewPassword: newPassword });
};

module.exports = ResetPasswordService;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0);

var ResetPasswordController = function () {
    function ResetPasswordController($q, resetPasswordService) {
        _classCallCheck(this, ResetPasswordController);

        this.$q = $q;
        this.resetPasswordService = resetPasswordService;

        this.showForm = false;
        this.tokenInvalid = false;
        this.loading = false;

        this.validatePasswordReminderToken();
    }

    _createClass(ResetPasswordController, [{
        key: 'validatePasswordReminderToken',
        value: function validatePasswordReminderToken() {
            var _this = this;

            this.resetPasswordService.validatePasswordReminderToken(this.passwordResetToken).then(function (response) {
                _this.tokenInvalid = !response.Success;
            }).catch(function () {
                _this.tokenInvalid = true;
            }).finally(function () {
                _this.showForm = true;
            });
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this2 = this;

            if (!this.resetPasswordForm.$valid) {
                // don't submit to server if client side is not valid
                return this.$q.reject();
            }

            this.loading = true;
            return this.resetPasswordService.resetPassword(this.resetPassword.password, this.resetPassword.passwordConfirm, this.passwordResetToken).then(function (response) {
                if (response.Success) {
                    window.location.href = '/';
                }
            }).catch(function (repsonse) {
                _this2.resetErrors();
                _.forEach(repsonse.data.ResponseStatus.Errors, function (n) {
                    if (n.FieldName === 'ReminderToken') {
                        _this2.tokenInvalid = true;
                    } else {
                        if (_this2.resetPasswordForm[n.FieldName]) {
                            _this2.resetPasswordForm[n.FieldName].$setValidity('serverError', false);
                        }
                        _this2.serverErrors[n.FieldName] = n.Message;
                    }
                });
            }).finally(function () {
                _this2.loading = false;
            });
        }
    }, {
        key: 'resetErrors',
        value: function resetErrors() {
            this.resetPasswordForm.NewPassword.$setValidity('serverError', true);
            this.resetPasswordForm.NewPasswordConfirmation.$setValidity('serverError', true);
            this.serverErrors = {};
        }
    }]);

    return ResetPasswordController;
}();

var resetPasswordComponentDefinition = {
    bindings: {
        passwordResetToken: '@'
    },
    controller: ['$q', 'ResetPasswordService', ResetPasswordController],
    template: __webpack_require__(70).trim()
};

module.exports = {
    ResetPasswordController: ResetPasswordController,
    resetPasswordComponentDefinition: resetPasswordComponentDefinition
};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = "<div class=\"resetPasswordContainer\" ng-show=\"$ctrl.showForm\">\r\n    <h1 class=\"resetPasswordForm-heading\">Reset password</h1>\r\n    <p class=\"resetPasswordContainer-info\">\r\n        <wow-setting setting-group=\"Messages\" setting-name=\"ResetPasswordForceChangeReason\"></wow-setting>\r\n    </p>\r\n    <div class=\"resetPasswordForm-invalidTokenMessage\" ng-show=\"$ctrl.tokenInvalid\">\r\n        <wow-setting setting-group=\"Messages\" setting-name=\"InvalidPasswordResetTokenMessage\"></wow-setting>\r\n    </div>\r\n    <form name=\"$ctrl.resetPasswordForm\" ng-submit=\"$ctrl.submit()\" ng-show=\"!$ctrl.tokenInvalid\" novalidate>\r\n        <wow-input-container class=\"resetPasswordForm-inputContainer\">\r\n            <label for=\"resetPasswordForm-password\">New password *</label>\r\n            <input type=\"password\" id=\"resetPasswordForm-password\" name=\"NewPassword\" ng-model=\"$ctrl.resetPassword.password\" required minlength=\"6\" pattern=\".*\\d.*\" ng-change=\"$ctrl.resetErrors()\" />\r\n            <span ng-messages=\"$ctrl.resetPasswordForm.NewPassword.$error\" class=\"wowInput-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">This input is required.</span>\r\n                <span ng-message=\"pattern\" class=\"wowInput-error\">\r\n                    <wow-setting setting-group=\"HandyHint\" setting-name=\"Password\"></wow-setting>\r\n                </span>\r\n                <span ng-message=\"minlength\" class=\"wowInput-error\">\r\n                    <wow-setting setting-group=\"HandyHint\" setting-name=\"Password\"></wow-setting>\r\n                </span>\r\n                <span ng-message=\"serverError\" class=\"wowInput-error\">{{$ctrl.serverErrors.NewPassword}}</span>\r\n            </span>\r\n        </wow-input-container>\r\n        <wow-input-container class=\"resetPasswordForm-inputContainer\">\r\n            <label for=\"resetPasswordForm-passwordConfirm\">Re-enter password *</label>\r\n            <input type=\"password\" id=\"resetPasswordForm-passwordConfirm\" name=\"NewPasswordConfirmation\" ng-model=\"$ctrl.resetPassword.passwordConfirm\" required minlength=\"6\" pattern=\".*\\d.*\" ng-change=\"$ctrl.resetErrors()\" />\r\n            <span ng-messages=\"$ctrl.resetPasswordForm.NewPasswordConfirmation.$error\" class=\"wowInput-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">This input is required.</span>\r\n                <span ng-message=\"pattern\" class=\"wowInput-error\">\r\n                    <wow-setting setting-group=\"HandyHint\" setting-name=\"Password\"></wow-setting>\r\n                </span>\r\n                <span ng-message=\"minlength\" class=\"wowInput-error\">\r\n                    <wow-setting setting-group=\"HandyHint\" setting-name=\"Password\"></wow-setting>\r\n                </span>\r\n                <span ng-message=\"serverError\" class=\"wowInput-error\">{{$ctrl.serverErrors.NewPasswordConfirmation}}</span>\r\n            </span>\r\n        </wow-input-container>\r\n        <oly-button class=\"resetPasswordForm-button\" loading=\"{ state: $ctrl.loading, message: 'Processing reset password, please wait'}\">\r\n            <button class=\"button button--primary resetPasswordForm-buttonWidth\" type=\"submit\">Reset password&nbsp;<i class=\"iconww-ArrowRight loginForm-chevronIcon\"></i></button>\r\n        </oly-button>\r\n    </form>\r\n</div>"

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.auth');

wowApp.component('wowLoginForgotPassword', __webpack_require__(72).forgotPasswordComponentDefinition);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fillServerErrors = __webpack_require__(16);

var ForgotPasswordController = function () {
    function ForgotPasswordController(resetPasswordService, settingsService) {
        _classCallCheck(this, ForgotPasswordController);

        this.resetPasswordService = resetPasswordService;
        this.settings = settingsService.settings;
    }

    _createClass(ForgotPasswordController, [{
        key: 'sendResetRequest',
        value: function sendResetRequest() {
            fillServerErrors.clearForm(this.forgotPasswordForm, this);

            if (!this.forgotPasswordForm.$valid) {
                // don't submit to server if client side is not valid
                this.hasSubmittedForm = false;
                return;
            }

            this.resetPasswordService.forgotPassword(this.emailInput);

            this.hasSubmittedForm = true;
        }
    }]);

    return ForgotPasswordController;
}();

var forgotPasswordComponentDefinition = {
    controller: ['ResetPasswordService', 'SettingsService', ForgotPasswordController],
    template: __webpack_require__(73).trim()
};

module.exports = {
    ForgotPasswordController: ForgotPasswordController,
    forgotPasswordComponentDefinition: forgotPasswordComponentDefinition
};

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "<div class=\"forgotPasswordContainer\">\r\n    <h1 class=\"forgotPasswordForm-heading\">Password reset</h1>\r\n    <form id=\"forgotPasswordForm\" name=\"$ctrl.forgotPasswordForm\" novalidate ng-show=\"!$ctrl.hasSubmittedForm\" ng-submit=\"$ctrl.sendResetRequest()\" wow-analytics-form-errors>\r\n        <oly-form-validation-summary user-message=\"The password reset was not successful.\"></oly-form-validation-summary>\r\n\r\n        <p>Please enter the email address that you used to sign up so we can send you an email with your username and a link to reset your password.</p>\r\n\r\n        <wow-input-container>\r\n            <label>Email address</label>\r\n            <input id=\"forgotPasswordForm-email\" type=\"email\" name=\"email\" ng-model=\"$ctrl.emailInput\" wow-email-validator required/>\r\n            <span ng-messages=\"$ctrl.forgotPasswordForm.email.$error\" class=\"wowInput-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">Email address is required.</span>\r\n                <span ng-message=\"email\" class=\"wowInput-error\">Email address is required to be in the format of example@example.com</span>\r\n            </span>\r\n        </wow-input-container>\r\n        <div class=\"forgotPasswordForm-passwordResetButton\">\r\n            <button class=\"button button--primary\" type=\"submit\">\r\n                Send&nbsp;<i class=\"iconww-ArrowRight forgotPasswordForm-chevronIcon\"></i>\r\n            </button>\r\n        </div>\r\n    </form>\r\n\r\n    <p class=\"u-noOutline\" ng-show=\"$ctrl.hasSubmittedForm\" role=\"status\" aria-live=\"polite\">\r\n        <wow-setting setting-group=\"PasswordReminder\" setting-name=\"ReminderResultSent\"></wow-setting>\r\n    </p>\r\n\r\n    <div class=\"forgotPasswordForm-needHelp\">\r\n        If you still need help,\r\n        <a ng-href=\"{{$ctrl.settings.passwordReminder.passwordReminderContactUsLink}}\" target=\"_blank\" id=\"forgotPasswordForm-contactSupport\">\r\n            contact us&nbsp;<i class=\"iconww-ArrowRight forgotPasswordForm-chevronIcon\"></i>\r\n            <span class=\"sr-only\">, Opens in a new window</span>\r\n        </a>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.auth');

var _require = __webpack_require__(75),
    AbnLookupService = _require.AbnLookupService;

var _require2 = __webpack_require__(76),
    AbnComponentDefinition = _require2.AbnComponentDefinition;

var abnValidatorDirective = __webpack_require__(78);

wowApp.service('AbnLookupService', AbnLookupService).component('wowAbn', AbnComponentDefinition).directive('wowAbnValidator', ['$q', '$timeout', 'AbnLookupService', abnValidatorDirective]);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AbnLookupService = function () {
    function AbnLookupService(Restangular) {
        _classCallCheck(this, AbnLookupService);

        this._api = Restangular.one('abn-verification');
    }

    _createClass(AbnLookupService, [{
        key: 'lookupAbn',
        value: function lookupAbn(arg) {
            return this._api.get({ abn: arg });
        }
    }]);

    return AbnLookupService;
}();

AbnLookupService.$inject = ['Restangular'];

module.exports = { AbnLookupService: AbnLookupService };

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AbnComponentController = function () {
    function AbnComponentController(settings) {
        _classCallCheck(this, AbnComponentController);

        this.settings = settings;
    }

    _createClass(AbnComponentController, [{
        key: '$onInit',
        value: function $onInit() {
            this.shouldShowValidation = false;
            this.isLoading = false;
            this.invalidErrorMessage = '';
            this.ABN = this.formValues.ABN;
        }
    }, {
        key: 'onInputBlur',
        value: function onInputBlur() {
            this.shouldShowValidation = this.abnForm.ABN.$dirty;

            if (this.abnForm.$invalid) {
                delete this.formValues.ABN;
                delete this.formValues.EntityName;
            }
        }
    }, {
        key: 'setLoadingStatus',
        value: function setLoadingStatus(status) {
            if (this.setLoading) {
                this.setLoading({ status: this.shouldShowValidation && status });
            }
        }
    }, {
        key: 'getAbnResponse',
        value: function getAbnResponse(res) {
            this.invalidErrorMessage = res.ErrorCode === 'Predicate' ? res.Message : this.settings.abnLookup.errorMessage;

            this.formValues.ABN = res.Success ? this.abnForm.ABN.$viewValue.replace(/[\s]+/g, '') : '';
            this.formValues.EntityName = res.Success ? res.EntityName : '';
        }
    }]);

    return AbnComponentController;
}();

AbnComponentController.$inject = ['Settings'];

var AbnComponentDefinition = {
    bindings: {
        formValues: '<',
        classModifier: '@?',
        setLoading: '&?',
        shouldGrabFocus: '<?',
        hasSubmitted: '<?'
    },
    controller: AbnComponentController,
    template: __webpack_require__(77).trim()
};

module.exports = {
    AbnComponentController: AbnComponentController,
    AbnComponentDefinition: AbnComponentDefinition
};

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<ng-form name=\"$ctrl.abnForm\">\r\n    <wow-input-container\r\n        class=\"abnForm-inputContainer\"\r\n        ng-class=\"{\r\n            'abnForm-inputContainer--{{$ctrl.classModifier}}' : !!$ctrl.classModifier,\r\n            'is-invalid': $ctrl.abnForm.ABN.$error && ($ctrl.hasSubmitted || $ctrl.shouldShowValidation)}\">\r\n        <label for=\"abnForm-ABN\">\r\n            <abbr title=\"Australian Business Number\">ABN</abbr> *<span class=\"sr-only\"> (numbers only)</span>\r\n        </label>\r\n        <input\r\n            type=\"tel\"\r\n            id=\"abnForm-ABN\"\r\n            name=\"ABN\"\r\n            class=\"abnForm-input abnForm-inputRightSide\"\r\n            ng-blur=\"$ctrl.onInputBlur()\"\r\n            ng-model=\"$ctrl.ABN\"\r\n            pattern=\"^[\\d ]+$\"\r\n            wow-abn-validator\r\n            set-loading-status=\"$ctrl.setLoadingStatus(status)\"\r\n            update-response=\"$ctrl.getAbnResponse(res)\"\r\n            oly-grab-focus=\"!!$ctrl.shouldGrabFocus\"\r\n            required />\r\n        <span ng-if=\"$ctrl.abnForm.ABN.$dirty && $ctrl.abnForm.ABN.$valid\" role=\"alert\" class=\"sr-only\">ABN Verification successful</span>\r\n        <span ng-messages=\"$ctrl.abnForm.ABN.$error\" class=\"wowInput-errors\" role=\"alert\" ng-if=\"$ctrl.hasSubmitted || $ctrl.shouldShowValidation\">\r\n            <span ng-message=\"required\" class=\"wowInput-error\">ABN is required.</span>\r\n            <span ng-message=\"pattern\" class=\"wowInput-error\">ABN can only contain digits.</span>\r\n            <span ng-message=\"minlength\" class=\"wowInput-error\">Please enter 11 digit number only</span>\r\n            <span ng-message=\"invalidError\" class=\"wowInput-error\">{{ $ctrl.invalidErrorMessage }}</span>\r\n        </span>\r\n    </wow-input-container>\r\n</ng-form>\r\n"

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($q, $timeout, abnLookupService) {
    return {
        scope: {
            updateResponse: '&',
            setLoadingStatus: '&'
        },
        require: '^ngModel',
        restrict: 'A',
        link: function link(scope, elem, attr, ctrl) {
            ctrl.$asyncValidators.invalidError = function () {
                if (ctrl.$viewValue) {
                    var loadingTimeout = $timeout(function () {
                        return scope.setLoadingStatus({ status: true });
                    }, 1000);
                    return abnLookupService.lookupAbn(ctrl.$viewValue.replace(/[\s]+/g, '')).then(function (res) {
                        scope.updateResponse({ res: res });
                        return res.Success ? $q.resolve() : $q.reject();
                    }, function (err) {
                        scope.updateResponse({ res: err.data.ResponseStatus });
                        return $q.reject();
                    }).finally(function () {
                        $timeout.cancel(loadingTimeout);
                        scope.setLoadingStatus({ status: false });
                    });
                }
                return $q.reject();
            };
        }
    };
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);
var ngAnimate = __webpack_require__(44);
var ngMessages = __webpack_require__(14);
var ngSanitize = __webpack_require__(24);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(4); // eslint-disable-line no-unused-vars
__webpack_require__(21);
var olyDialog = __webpack_require__(22);

var wowCommonModule = __webpack_require__(5);
var olyCommonModule = __webpack_require__(3);
var recipeModule = __webpack_require__(80);
var analyticsModule = __webpack_require__(8);

var shopModuleName = 'wowApp.shop';

angular.module(shopModuleName, [olyCommonModule, wowCommonModule, analyticsModule, recipeModule, ngAnimate, ngMessages, ngSanitize, uiRouter, 'restangular', olyDialog]);

// ------------------------------------------
// Components
// ------------------------------------------
__webpack_require__(105);
__webpack_require__(108);
__webpack_require__(115);
__webpack_require__(126);
__webpack_require__(162);
__webpack_require__(167);
__webpack_require__(172);
__webpack_require__(193);
__webpack_require__(198);
__webpack_require__(206);
__webpack_require__(213);
__webpack_require__(216);
__webpack_require__(218);
__webpack_require__(223);
__webpack_require__(242);
__webpack_require__(245);
__webpack_require__(252);
__webpack_require__(278);
__webpack_require__(281);
__webpack_require__(292);
__webpack_require__(295);
__webpack_require__(312);
__webpack_require__(314);
__webpack_require__(317);
__webpack_require__(329);
__webpack_require__(333);
__webpack_require__(343);
__webpack_require__(349);
__webpack_require__(354);

module.exports = shopModuleName;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);
var ngMessages = __webpack_require__(14);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(4); // eslint-disable-line no-unused-vars
__webpack_require__(21);
var olyDialog = __webpack_require__(22);

var olyCommonModule = __webpack_require__(3);
var wowCommonModule = __webpack_require__(5);
var analyticsModule = __webpack_require__(8);

var _require = __webpack_require__(81),
    recipeTileListComponentDefinition = _require.recipeTileListComponentDefinition;

var _require2 = __webpack_require__(82),
    recipeListTileListComponentDefinition = _require2.recipeListTileListComponentDefinition;

var _require3 = __webpack_require__(83),
    recipeTileComponentDefinition = _require3.recipeTileComponentDefinition;

var recipeModuleName = 'wowApp.recipe';

angular.module(recipeModuleName, [analyticsModule, olyCommonModule, wowCommonModule, ngMessages, uiRouter, 'restangular', olyDialog]).service('RecipeCategoriesService', ['Restangular', '$q', 'BootstrapService', __webpack_require__(85)]).service('RecipeService', ['Restangular', '$templateCache', 'BreakpointsService', __webpack_require__(86)]).service('RecipeListsService', ['Restangular', __webpack_require__(90)]).component('wowRecipeTileList', recipeTileListComponentDefinition).component('wowRecipeListTileList', recipeListTileListComponentDefinition).directive('wowRecipeSavedListNavigation', ['$state', 'RecipeListsService', 'ShopperService', __webpack_require__(91)]).component('wowRecipePrint', __webpack_require__(93).recipePrintComponentDefinition).component('wowRecipeTile', recipeTileComponentDefinition).component('wowRecipeSaveToList', __webpack_require__(95).recipeSaveToListComponentDefinition).component('wowRecipeNavigation', __webpack_require__(97).recipeNavigationComponentDefinition).component('wowRecipeDetail', __webpack_require__(99).recipeDetailComponentDefinition).component('wowRecipeDetailVideo', __webpack_require__(101).recipeDetailVideoComponentDefinition).component('wowRecipeExportOptions', __webpack_require__(103).recipeDetailExportOptionsComponentDefinition);

module.exports = recipeModuleName;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(26),
    createRecipeTiles = _require.createRecipeTiles;

var _require2 = __webpack_require__(0),
    get = _require2.get;

var RecipeTileListController = function () {
    function RecipeTileListController($window, settings, analyticsService, recipeService, sortByKeys) {
        _classCallCheck(this, RecipeTileListController);

        this.$window = $window;
        this.analyticsService = analyticsService;
        this.settings = settings;
        this.recipeService = recipeService;
        this.sortByKeys = sortByKeys;
    }

    _createClass(RecipeTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
        }
    }, {
        key: 'createTiles',
        value: function createTiles(tiles) {
            return {
                items: createRecipeTiles(tiles.items),
                totalRecordCount: tiles.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber, sortType) {
            var _this = this;

            var recipeTilesPromise = this.recipeService.getRecipes(this.currentCategory.aisle.ID, pageSize, pageNumber, sortType).then(function (tiles) {
                return _this.createTiles(tiles);
            });

            if (get(this.currentCategory, 'department.UrlFriendlyName') !== 'fresh-magazine') {
                recipeTilesPromise.then(function (tiles) {
                    return _this.analyticsService.push({
                        data: {
                            currentCategory: _this.currentCategory,
                            resultsCategoryCount: tiles.totalRecordCount,
                            numberOfPage: pageNumber,
                            pageSortBy: sortType,
                            SortTypes: _this.sortOptions.sortTypes,
                            recipes: tiles,
                            homeUrl: _this.$window.location.origin
                        },
                        type: _this.analyticsService.mapperTypes.content.recipeCategory
                    });
                });
            }
            return recipeTilesPromise;
        }
    }]);

    return RecipeTileListController;
}();

RecipeTileListController.$inject = ['$window', 'Settings', 'AnalyticsService', 'RecipeService', 'SortByKeys'];

var recipeTileListComponentDefinition = {
    bindings: {
        currentCategory: '<',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: RecipeTileListController,
    template: '\n        <wow-tile-list\n            list-title="::$ctrl.currentCategory.aisle.Name"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">\n        </wow-tile-list>\n    '
};

module.exports = {
    RecipeTileListController: RecipeTileListController,
    recipeTileListComponentDefinition: recipeTileListComponentDefinition
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(26),
    createRecipeTiles = _require.createRecipeTiles;

var RecipeListTileListController = function () {
    function RecipeListTileListController($window, settings, recipeListsService, sortByKeys, analyticsService) {
        _classCallCheck(this, RecipeListTileListController);

        this.$window = $window;
        this.settings = settings;
        this.recipeListsService = recipeListsService;
        this.sortByKeys = sortByKeys;
        this.analytics = analyticsService;
    }

    _createClass(RecipeListTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
        }
    }, {
        key: 'pushToAnalytics',
        value: function pushToAnalytics(recipes, pageNumber, sortType) {
            this.analytics.push({
                data: {
                    recipes: recipes,
                    numberOfPage: pageNumber,
                    pageSortBy: sortType,
                    SortTypes: this.sortOptions.sortTypes,
                    homeUrl: this.$window.location.origin
                },
                type: this.analytics.mapperTypes.content.recipeCategory
            });
        }
    }, {
        key: 'createTiles',
        value: function createTiles(tiles) {
            return {
                items: createRecipeTiles(tiles.items),
                totalRecordCount: tiles.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber, sortType) {
            var _this = this;

            return this.recipeListsService.getSavedRecipes(pageSize, pageNumber, sortType).then(function (recipes) {
                var analyticsRecipes = { items: !!recipes && !!recipes.items ? recipes.items.map(function (recipe) {
                        return { data: { recipe: recipe } };
                    }) : [] };
                _this.pushToAnalytics(analyticsRecipes, pageNumber, sortType);
                return _this.createTiles(recipes);
            });
        }
    }]);

    return RecipeListTileListController;
}();

RecipeListTileListController.$inject = ['$window', 'Settings', 'RecipeListsService', 'SortByKeys', 'AnalyticsService'];

var recipeListTileListComponentDefinition = {
    bindings: {
        currentCategory: '<',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: RecipeListTileListController,
    template: '\n        <wow-tile-list\n            list-title="::\'My Favourite Recipes\'"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">\n        </wow-tile-list>\n    '
};

module.exports = {
    RecipeListTileListController: RecipeListTileListController,
    recipeListTileListComponentDefinition: recipeListTileListComponentDefinition
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipeTileController = function () {
    function RecipeTileController(analyticsService, recipeService) {
        _classCallCheck(this, RecipeTileController);

        this.analyticsService = analyticsService;
        this.recipeService = recipeService;
    }

    _createClass(RecipeTileController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isJamieRecipe = this.recipe.TemplateName.toLowerCase() !== 'default';
        }
    }, {
        key: 'pushDataToAnalyticsService',
        value: function pushDataToAnalyticsService() {
            var _this = this;

            this.recipeService.getRecipe(this.recipe.ID).then(function (data) {
                _this.analyticsService.push({
                    data: {
                        trackingType: 'link',
                        recipe: data
                    },
                    type: _this.analyticsService.mapperTypes.customEvent.recipeClick
                });
            });
        }
    }]);

    return RecipeTileController;
}();

RecipeTileController.$inject = ['AnalyticsService', 'RecipeService'];

var recipeTileComponentDefinition = {
    bindings: {
        recipe: '<'
    },
    controller: RecipeTileController,
    template: __webpack_require__(84).trim()
};

module.exports = {
    RecipeTileController: RecipeTileController,
    recipeTileComponentDefinition: recipeTileComponentDefinition
};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recipeTile tile\" ng-class=\"::{ 'recipeTile--jamie': $ctrl.isJamieRecipe }\">\r\n    <div class=\"recipeTile-brandImageContainer\" ng-if=\"::$ctrl.isJamieRecipe\">\r\n        <img class=\"recipeTile-brandImage\" src=\"/images/recipedetails/jamiesRecipe.png\" alt=\"jamie oliver recipe\">\r\n    </div>\r\n\r\n    <a\r\n        class=\"recipeTile-imageContainer\"\r\n        ui-sref=\"shop.recipedetail({recipeId: $ctrl.recipe.ID, recipeTitle: $ctrl.recipe.UrlFriendlyTitle})\"\r\n        ng-click=\"$ctrl.pushDataToAnalyticsService()\">\r\n        <img ng-src=\"{{ ::$ctrl.recipe.MediumImageFilename }}\" alt=\"\" class=\"recipeTile-image\" oly-error-src/>\r\n    </a>\r\n\r\n    <a\r\n        class=\"recipeTile-header\"\r\n        ui-sref=\"shop.recipedetail({recipeId: $ctrl.recipe.ID, recipeTitle: $ctrl.recipe.UrlFriendlyTitle})\"\r\n        ng-click=\"$ctrl.pushDataToAnalyticsService()\">\r\n        {{::$ctrl.recipe.Title}} {{::$ctrl.recipe.SubTitle}}\r\n    </a>\r\n\r\n    <span class=\"u-flexSpacer\"></span>\r\n\r\n    <div class=\"recipeTile-body\">\r\n        <div class=\"recipeTile-infoItem\" ng-if=\"::$ctrl.recipe.Servings\">\r\n            <span class=\"recipeTile-infoQty\">{{::$ctrl.recipe.Servings}}</span> <span class=\"recipeTile-infoLabel\">Serves</span>\r\n        </div>\r\n        <div class=\"recipeTile-infoItem\" ng-if=\"::$ctrl.recipe.PreparationDuration && !$ctrl.isJamieRecipe\">\r\n            <span class=\"recipeTile-infoQty\">{{::$ctrl.recipe.PreparationDuration}}</span><span class=\"recipeTile-infoLabel\">Mins prep</span>\r\n        </div>\r\n        <div class=\"recipeTile-infoItem\" ng-if=\"::$ctrl.recipe.CookingDuration && !$ctrl.isJamieRecipe\">\r\n            <span class=\"recipeTile-infoQty\">{{::$ctrl.recipe.CookingDuration}}</span> <span class=\"recipeTile-infoLabel\">Mins cook</span>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"recipeTile-footer\">\r\n        <wow-recipe-save-to-list recipe=\"::$ctrl.recipe\" recipe-id=\"::$ctrl.recipe.ID\"></wow-recipe-save-to-list>\r\n        <a\r\n            ui-sref=\"shop.recipedetail({recipeId: $ctrl.recipe.ID, recipeTitle: $ctrl.recipe.UrlFriendlyTitle})\"\r\n            class=\"button recipeTile-button\"\r\n            ng-click=\"$ctrl.pushDataToAnalyticsService()\">\r\n            View recipe <i class=\"iconww-ArrowRight\"></i>\r\n        </a>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0);

var RecipeCategoriesService = function () {
    function RecipeCategoriesService(restangular, $q, bootstrap) {
        _classCallCheck(this, RecipeCategoriesService);

        this.$q = $q;

        this._api = restangular.all('recipeCategories');

        this.categories = [];
        this.currentCategory = {};

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.RecipeCategories)) {
            this.setAll(bootstrap.getBootstrappedData(bootstrap.bootstrapped.RecipeCategories));
        }
    }

    _createClass(RecipeCategoriesService, [{
        key: 'getAll',
        value: function getAll() {
            if (this.categories.length > 0) {
                return this.$q.when(this.categories);
            }

            return this._api.getList().then(this.setAll.bind(this));
        }
    }, {
        key: 'setAll',
        value: function setAll(categories) {
            this.categories = categories;
            this.resetCurrentCategory();

            return categories;
        }
    }, {
        key: 'resetCurrentCategory',
        value: function resetCurrentCategory() {
            this.currentCategory = {};
        }
    }, {
        key: 'setCategoryByName',
        value: function setCategoryByName(aisleName, categoryName) {
            this.currentCategory = this.getCategoryByName(aisleName, categoryName);
        }
    }, {
        key: 'getCategoryByName',
        value: function getCategoryByName(aisleName, categoryName) {
            var department = _.find(this.categories, function (category) {
                return category.UrlFriendlyName === aisleName;
            });
            var aisle = department ? _.find(department.ChildCategories, function (childCategory) {
                return childCategory.UrlFriendlyName === categoryName;
            }) : {};

            return {
                department: department || {},
                aisle: aisle
            };
        }
    }, {
        key: 'hasCurrentCategory',
        value: function hasCurrentCategory() {
            return !!(this.currentCategory && this.currentCategory.aisle && this.currentCategory.department);
        }
    }]);

    return RecipeCategoriesService;
}();

module.exports = RecipeCategoriesService;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0),
    templates = __webpack_require__(87);

var RecipeService = function () {
    function RecipeService(restangular, $templateCache, _breakpointsService) {
        _classCallCheck(this, RecipeService);

        this.breakpointsService = _breakpointsService;

        this._api = restangular.one('recipes');
        _.forEach(templates, function (template) {
            $templateCache.put(template.id, template.content);
        });

        this.recipeDetailsCache = {};
    }

    _createClass(RecipeService, [{
        key: 'getRecipes',
        value: function getRecipes(recipeCategoryId, pageSize, pageNumber, sortType) {
            return this._api.get({
                recipeCategoryId: recipeCategoryId,
                pageSize: pageSize,
                pageNumber: pageNumber,
                sortType: sortType
            }).then(function (response) {
                return {
                    items: response.Items,
                    totalRecordCount: response.TotalRecordCount
                };
            });
        }
    }, {
        key: 'getRecipe',
        value: function getRecipe(recipeId) {
            if (!(recipeId in this.recipeDetailsCache)) {
                this.recipeDetailsCache[recipeId] = this._api.one('', recipeId).get();
            }

            return this.recipeDetailsCache[recipeId];
        }
    }]);

    return RecipeService;
}();

module.exports = RecipeService;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = [{
    id: 'Default',
    content: __webpack_require__(88).trim()
}, {
    id: 'Jamie_Oliver',
    content: __webpack_require__(89).trim()
}];

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recipeDetail-image\"\r\n    ng-style=\"{'background-image': 'url(' + ($ctrl.breakpointsService.isInSmallFormat ? $ctrl.recipe.MediumImageFilename : $ctrl.recipe.LargeImageFilename) + ')'}\">\r\n    <meta itemprop=\"image\" content=\"{{::$ctrl.recipe.ImageFilename}}\"></meta>\r\n    <meta itemprop=\"description\" content=\"{{::$ctrl.recipe.Description}}\"></meta>\r\n</div>\r\n"

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<!--Jamie's recipe header-->\r\n<div class=\"recipeDetail-jamieSubHeader\">\r\n    <img class=\"recipeDetail-jamieSubHeaderImage\" alt=\"\"\r\n        ng-src=\"{{ $ctrl.breakpointsService.isInSmallFormat ? $ctrl.recipe.MediumImageFilename : $ctrl.recipe.LargeImageFilename }}\"\r\n        itemprop=\"image\"\r\n        oly-error-src/>\r\n\r\n    <div class=\"recipeDetail-jamieSubHeaderContent\">\r\n        <h2 class=\"recipeDetail-jamieSubHeaderTitle hidden-xs\">\r\n            <span class=\"sr-only\"> Jamie's recipe </span>\r\n        </h2>\r\n\r\n        <div class=\"recipeDetail-jamieSubHeaderSubtitle\" ng-if=\"$ctrl.recipe.TextTip && $ctrl.recipe.TextTip.length > 0\">\r\n            <span class=\"sr-only\"> Jamie's tip </span>\r\n        </div>\r\n\r\n        <p class=\"recipeDetail-jamieSubHeaderDescription\" itemprop=\"description\">\r\n            {{ $ctrl.recipe.TextTip }}\r\n        </p>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Private variables
var _api = void 0;

function RecipeListsService(restangular) {
    _api = restangular.all('recipes/lists');

    this.loadingCount = true;
}

RecipeListsService.prototype.getSavedRecipes = function (pageSize, pageNumber, sortType) {
    var _this = this;

    return _api.doGET('', {
        pageSize: pageSize,
        pageNumber: pageNumber,
        sortType: sortType
    }).then(function (response) {
        _this.loadingCount = false;
        _this.keptRecipesCount = response.TotalRecordCount;
        return {
            items: response.Items,
            totalRecordCount: response.TotalRecordCount
        };
    });
};

RecipeListsService.prototype.initialiseCountForGuestUser = function () {
    this.keptRecipesCount = 0;
    this.loadingCount = false;
};

RecipeListsService.prototype.removeSavedRecipe = function (recipeId) {
    var _this2 = this;

    // ideally this will be a delete verb but IIS6...
    return _api.doPOST({ Id: recipeId }).then(function () {
        _this2.keptRecipesCount--;
    });
};

RecipeListsService.prototype.saveRecipeToList = function (recipeId) {
    var _this3 = this;

    return _api.get(recipeId).then(function () {
        _this3.keptRecipesCount++;
    });
};

module.exports = RecipeListsService;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($state, recipeListsService, shopperService) {
    return {
        restrict: 'E',
        scope: {},
        link: function link(scope) {
            scope.count = 0;

            function initialiseKeptRecipeCount() {
                return shopperService.IsGuest ? recipeListsService.initialiseCountForGuestUser() : recipeListsService.getSavedRecipes(1, 1, 'Name');
            }

            // Populate the kept recipes count
            initialiseKeptRecipeCount();

            scope.$watch(function () {
                return recipeListsService.keptRecipesCount;
            }, function () {
                scope.count = recipeListsService.keptRecipesCount;

                scope.url = recipeListsService.keptRecipesCount > 0 ? $state.href('shop.recipes.savedList', null, { inherit: false }) : $state.href('shop.recipes.noSavedRecipes', null, { inherit: false });

                if (scope.count <= 0 && $state.includes('shop.recipes.savedList')) {
                    $state.go('shop.recipes.noSavedRecipes', null, { location: 'replace', inherit: false });
                }

                if (scope.count > 0 && $state.includes('shop.recipes.noSavedRecipes')) {
                    $state.go('shop.recipes.savedList', null, { location: 'replace', inherit: false });
                }
            });
        },

        template: __webpack_require__(92).trim()
    };
};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<a class=\"navigation-link\" ng-href=\"{{url}}\" ui-sref-active=\"is-active\">\r\n    <span>\r\n        My Favourite Recipes\r\n        <span ng-if=\"!recipeListsService.loadingCount\">({{count}})</span>\r\n        <wow-loading-spinner class=\"searchCountSpinner\" ng-if=\"recipeListsService.loadingCount\"></wow-loading-spinner>\r\n    </span>\r\n</a>\r\n"

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipePrintController = function RecipePrintController($timeout) {
    _classCallCheck(this, RecipePrintController);

    $timeout(function () {
        return window.print();
    }, 0);
};

var recipePrintComponentDefinition = {
    bindings: {
        recipe: '<'
    },
    controller: ['$timeout', RecipePrintController],
    template: __webpack_require__(94).trim()
};

module.exports = {
    RecipePrintController: RecipePrintController,
    recipePrintComponentDefinition: recipePrintComponentDefinition
};

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recipeprint recipeprint-wrapper\">\r\n\t<div class=\"recipeprint-container\">\r\n\t\t<img src=\"/images/globalheader/icon-wapple-full.png\" class=\"recipeprint-logo\" alt=\"\" />\r\n\r\n\t\t<div class=\"recipeprint-ingredients\">\r\n\t\t\t<h1 class=\"recipeprint-heading\">{{::$ctrl.recipe.Title}}</h1>\r\n\t\t\t<h3 class=\"recipeprint-subheading\">Ingredients</h3>\r\n\t\t\t<ul>\r\n\t\t\t\t<li ng-repeat=\"ingredient in $ctrl.recipe.Ingredients track by $index\" class=\"recipeprint-ingredient\">\r\n\t\t\t\t\t{{::ingredient.Description}}\r\n\t\t\t\t</li>\r\n\t\t\t</ul>\r\n\r\n\t\t</div>\r\n\t\t<div class=\"recipeprint-panel\">\r\n\t\t\t<figure class=\"recipeprint-panelMiddle\">\r\n\t\t\t\t<img ng-src=\"{{::$ctrl.recipe.SmallImageFilename}}\" alt=\"\" class=\"recipeprint-image\" />\r\n\t\t\t\t<figcaption>\r\n\t\t\t\t\t<span>{{::$ctrl.recipe.Description}}</span><span class=\"recipeprint-serving\">Servings: {{::$ctrl.recipe.Servings}}</span>\r\n\t\t\t\t</figcaption>\r\n\t\t\t</figure>\r\n\t\t</div>\r\n\t\t<div class=\"recipeprint-directions\">\r\n\t\t\t<h3 class=\"recipeprint-subheading\">Directions:</h3>\r\n\t\t\t<p ng-repeat=\"paragraph in ($ctrl.recipe.Instructions | paragraphize) track by $index\" class=\"u-capitalize-first-letter\">{{ (paragraph | sentenceCase).trim() }}</p>\r\n\t\t\t<div class=\"recipe-sent\" ng-if=\"$ctrl.recipe.ContributorName\">\r\n\t\t\t\tThis recipe was sent in by\r\n\t\t\t\t<a ng-href=\"{{::$ctrl.recipe.WebpageLink}}\" target=\"_blank\" ng-if=\"::$ctrl.recipe.WebpageLink\">{{::$ctrl.recipe.ContributorName}}</a>\r\n\t\t\t\t<strong class=\"author\" ng-if=\"::!$ctrl.recipe.WebpageLink\">{{::$ctrl.recipe.ContributorName}}</strong>\r\n\t\t\t\t<span ng-if=\"::$ctrl.recipe.ContributorTown\">of {{::$ctrl.recipe.ContributorTown}}</span>.\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</div>"

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipeSaveToListController = function () {
    function RecipeSaveToListController(recipeListsService, moveFocus, $state, shopperService, loginService, sessionStorage) {
        _classCallCheck(this, RecipeSaveToListController);

        this.recipeListsService = recipeListsService;
        this.moveFocus = moveFocus;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.$state = $state;
        this.sessionStorage = sessionStorage;
    }

    _createClass(RecipeSaveToListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.pendingSaveRecipeStorageKey = 'RecipeSaveToListController:savedRecipeBeforeLogin:' + this.recipe.ID;
            this.guestLoginStorageKey = 'login:trigger';

            var savedRecipeBeforeLogin = this.sessionStorage.getJsonAndRemove(this.pendingSaveRecipeStorageKey);

            if (!this.shopperService.IsGuest && savedRecipeBeforeLogin === this.recipe.ID) {
                this.saveRecipe(savedRecipeBeforeLogin);
            }
        }
    }, {
        key: 'saveRecipe',
        value: function saveRecipe() {
            var _this = this;

            var recipeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.recipe.ID;

            this.recipeListsService.saveRecipeToList(recipeId).then(function () {
                _this.recipe.IsFavouriteRecipe = true;
                _this.srMessage = _this.recipe.Title + ' saved to my favourite recipes';
                _this.moveFocus('#recipe-recipeSaveToList-' + recipeId);
            });
        }
    }, {
        key: 'keepRecipe',
        value: function keepRecipe() {
            var _this2 = this;

            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToSavetoListMessage, undefined, undefined, { reload: false }, function () {
                    _this2.sessionStorage.setJson(_this2.pendingSaveRecipeStorageKey, _this2.recipe.ID);
                    _this2.sessionStorage.set(_this2.guestLoginStorageKey, 'GuestLoginToFavouriteRecipe');
                });
            } else {
                this.saveRecipe(this.recipe.ID);
            }
        }
    }, {
        key: 'removeSavedRecipe',
        value: function removeSavedRecipe() {
            var _this3 = this;

            this.recipeListsService.removeSavedRecipe(this.recipe.ID).then(function () {
                _this3.srMessage = _this3.recipe.Title + ' is removed from my favourite recipes';
                _this3.recipe.IsFavouriteRecipe = false;
                _this3.moveFocus('#recipe-recipeSaveToList-' + _this3.recipe.ID);
            });
        }
    }]);

    return RecipeSaveToListController;
}();

var recipeSaveToListComponentDefinition = {
    bindings: {
        recipe: '<'
    },
    controller: ['RecipeListsService', 'MoveFocus', '$state', 'ShopperService', 'LoginService', 'SessionStorageWrapper', RecipeSaveToListController],
    template: __webpack_require__(96).trim()
};

module.exports = {
    RecipeSaveToListController: RecipeSaveToListController,
    recipeSaveToListComponentDefinition: recipeSaveToListComponentDefinition
};

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<div id=\"recipe-recipeSaveToList-{{::$ctrl.recipe.ID}}\" class=\"recipeSaveToList\" ng-switch=\"$ctrl.recipe.IsFavouriteRecipe\" tabindex=\"-1\">\r\n    <button class=\"button recipeSaveToList-button\" ng-click=\"::$ctrl.keepRecipe()\" ng-switch-when=\"false\">\r\n        <span class=\"sr-only\">Add {{::$ctrl.recipe.Title}} {{::$ctrl.recipe.SubTitle}} to my favourite recipes</span><i class=\"iconww-SaveRecipe\"></i>\r\n    </button>\r\n    <button class=\"button recipeSaveToList-button is-saved\" ng-switch-when=\"true\" ng-click=\"::$ctrl.removeSavedRecipe()\">\r\n        <span class=\"sr-only\">Remove {{::$ctrl.recipe.Title}} {{::$ctrl.recipe.SubTitle}} from my favourite recipes</span><i class=\"iconww-SaveRecipe\"></i>\r\n    </button>\r\n    <oly-sr-notification message=\"{{$ctrl.srMessage}}\"></oly-sr-notification>\r\n</div>"

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipeNavigationController = function () {
    function RecipeNavigationController(recipeCategoriesService, analyticsService) {
        _classCallCheck(this, RecipeNavigationController);

        this.recipeCategoriesService = recipeCategoriesService;
        this.analyticsService = analyticsService;
    }

    _createClass(RecipeNavigationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.recipeCategoriesService.getAll();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges() {
            if (this.currentCategory) {
                this.openCategory = this.currentCategory.department;
            }
        }
    }, {
        key: 'toggleOpen',
        value: function toggleOpen(category) {
            this.openCategory = this.openCategory === category ? null : category;
        }
    }, {
        key: 'pushDataToAnalyticsService',
        value: function pushDataToAnalyticsService() {
            this.analyticsService.push({
                data: {
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.menuClick
            });
        }
    }]);

    return RecipeNavigationController;
}();

var recipeNavigationComponentDefinition = {
    bindings: {
        currentCategory: '<'
    },
    controller: ['RecipeCategoriesService', 'AnalyticsService', RecipeNavigationController],
    template: __webpack_require__(98).trim()
};

module.exports = {
    RecipeNavigationController: RecipeNavigationController,
    recipeNavigationComponentDefinition: recipeNavigationComponentDefinition
};

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navigation treeNavigation\" aria-label=\"Recipes\">\r\n    <ul class=\"navigation-items\">\r\n        <li>\r\n            <wow-recipe-saved-list-navigation></wow-recipe-saved-list-navigation>\r\n        </li>\r\n        <li ng-repeat=\"category in ::$ctrl.recipeCategoriesService.categories track by category.UrlFriendlyName\">\r\n            <button\r\n                id=\"{{ ::category.UrlFriendlyName }}\"\r\n                class=\"linkButton navigation-header navigation-link treeNavigation-parent\"\r\n                aria-expanded=\"{{ $ctrl.openCategory === category }}\"\r\n                aria-controls=\"{{ ::category.UrlFriendlyName }}-children\"\r\n                ng-class=\"{'is-open': $ctrl.openCategory === category}\"\r\n                ng-click=\"$ctrl.toggleOpen(category); $ctrl.pushDataToAnalyticsService()\">\r\n                <span>\r\n                    {{ ::category.Name }}&nbsp;<i class=\"iconww-ArrowDown treeNavigation-expandIcon\"></i><i class=\"iconww-ArrowUp treeNavigation-collapseIcon\"></i>\r\n                </span>\r\n            </button>\r\n\r\n            <ul\r\n                id=\"{{ ::category.UrlFriendlyName }}-children\"\r\n                class=\"navigation-items treeNavigation-children\"\r\n                aria-labelledby=\"{{ ::category.UrlFriendlyName }}\">\r\n\r\n                <li ng-repeat=\"child in ::category.ChildCategories track by child.UrlFriendlyName\">\r\n                    <a\r\n                        class=\"navigation-link\"\r\n                        ui-sref=\"shop.recipes.category.subCategory({ category: category.UrlFriendlyName, subCategory: child.UrlFriendlyName })\"\r\n                        ui-sref-active=\"is-active\"\r\n                        ui-sref-opts=\"{ inherit: false }\"\r\n                        ng-click=\"$ctrl.pushDataToAnalyticsService()\">\r\n\r\n                        <span>{{ ::child.Name }}&nbsp;<i class=\"iconww-ArrowRight\"></i></span>\r\n                    </a>\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</nav>\r\n"

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    map = _require.map,
    property = _require.property,
    every = _require.every,
    filter = _require.filter,
    forEach = _require.forEach;

var RecipeDetailController = function () {
    function RecipeDetailController($state, $window, settings, featureService, analyticsService, breakpointsService, trolleyService) {
        _classCallCheck(this, RecipeDetailController);

        this.$state = $state;
        this.$window = $window;
        this.settings = settings;
        this.featureService = featureService;
        this.analyticsService = analyticsService;
        this.breakpointsService = breakpointsService;
        this.trolleyService = trolleyService;
    }

    _createClass(RecipeDetailController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.recipe && this.recipe.Ingredients) {
                this.recipe.IngredientsProducts = filter(this.recipe.Ingredients, function (r) {
                    return r.Stockcode !== 0;
                });
                this.recipe.Ingredients = this.generateStyleForIngredients(this.recipe.Ingredients);
                var products = map(this.recipe.IngredientsProducts, property('Product'));
                this.shouldDisplayDisclaimer = products && !every(products, function (p) {
                    return p.Stockcode !== 0 && p.IsAvailable && p.IsInStock;
                });
            }

            this.socialMediaEnabled = this.featureService.isEnabled(this.featureService.features.recipeSocialMedia);
            this.printExportEnabled = this.featureService.isEnabled(this.featureService.features.recipePrintExport);
            this.showSubheaderControls = this.socialMediaEnabled || this.printExportEnabled;
            this.analyticsService.push({ data: { recipe: this.recipe }, type: this.analyticsService.mapperTypes.content.recipeDetail });
        }

        // Ideally author information should be coming from the data layer.

    }, {
        key: 'getRecipeAuthor',
        value: function getRecipeAuthor() {
            return this.recipe && this.recipe.TemplateName === 'Jamie_Oliver' ? 'Jamie Oliver' : 'Woolworths';
        }
    }, {
        key: 'generateStyleForIngredients',
        value: function generateStyleForIngredients(ingredients) {
            var ingredientsWithStyles = [];
            var counter = 1;

            forEach(ingredients, function (ingredient) {
                if (ingredient.Stockcode === 0) {
                    ingredient.Style = '-subHeading';
                    counter = 1;
                } else {
                    counter++;

                    // style for Odd row
                    if (counter % 2 !== 0) {
                        ingredient.Style = '-odd';
                    } else if (counter % 2 === 0) {
                        // style for Even row
                        ingredient.Style = '-even';
                    }
                }

                ingredientsWithStyles.push(ingredient);
            });

            return ingredientsWithStyles;
        }
    }, {
        key: 'back',
        value: function back(event) {
            event.preventDefault();
            this.$window.history.back();
        }
    }, {
        key: 'addAllProductsToTrolley',
        value: function addAllProductsToTrolley() {
            var products = map(filter(this.recipe.Ingredients, function (r) {
                return r.Stockcode !== 0;
            }), property('Product'));
            this.trolleyService.addItemsToTrolley(products);
            this.analyticsService.pushEvent(this.analyticsService.events.ADD_ALL);
        }
    }]);

    return RecipeDetailController;
}();

var recipeDetailComponentDefinition = {
    bindings: {
        recipe: '<'
    },
    controller: ['$state', '$window', 'Settings', 'FeatureService', 'AnalyticsService', 'BreakpointsService', 'TrolleyService', 'RecipeService', RecipeDetailController],
    template: __webpack_require__(100).trim()
};

module.exports = {
    RecipeDetailController: RecipeDetailController,
    recipeDetailComponentDefinition: recipeDetailComponentDefinition
};

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recipeDetail {{ ::$ctrl.recipe.TemplateName.toLowerCase() }}\" itemscope itemtype=\"http://schema.org/Recipe\">\r\n    <meta itemprop=\"author\" content=\"{{ ::$ctrl.getRecipeAuthor() }}\">\r\n    <meta itemprop=\"datePublished\" content=\"{{ ::$ctrl.recipe.ValidFrom }}\">\r\n\r\n    <a class=\"recipeDetail-back u-flexCenter linkButton\" href=\"javascript://\" ng-click=\"$ctrl.back($event)\">\r\n        <div class=\"recipeDetail-widthAdjust\">\r\n            <i class=\"iconww-ArrowLeft\"></i> Back\r\n        </div>\r\n    </a>\r\n\r\n    <div class=\"recipeDetail-content\">\r\n        <!--Recipe header-->\r\n        <div class=\"recipeDetail-headerSection u-flexCenter\">\r\n            <div class=\"recipeDetail-widthAdjust\">\r\n                <header class=\"recipeDetail-header heading\">\r\n                    <h1 class=\"recipeDetail-title\" itemprop=\"name\">{{$ctrl.recipe.Title}}</h1>\r\n                    <div class=\"heading3\">{{$ctrl.recipe.SubTitle}}</div>\r\n                </header>\r\n\r\n                <div class=\"recipeDetail-subheaderControls\" ng-if=\"$ctrl.showSubheaderControls\">\r\n                    <wow-social-buttons ng-if=\"::$ctrl.socialMediaEnabled\" url=\"::$ctrl.url\" media=\"::$ctrl.recipe.LargeImageFilename\" description=\"::$ctrl.recipe.Title\"></wow-social-buttons>\r\n\r\n                    <span class=\"u-flexSpacer\"></span>\r\n\r\n                    <wow-recipe-export-options recipe-id=\"{{::$ctrl.recipe.RecipeId}}\" enable-print=\"::$ctrl.printExportEnabled\"></wow-recipe-export-options>\r\n                </div>\r\n\r\n                <!-- Header template -->\r\n                <div class=\"recipeDetail-headerTemplate\" ng-include=\"$ctrl.recipe.TemplateName\"></div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"recipeDetail-info u-flexCenter\">\r\n            <div class=\"recipeDetail-widthAdjust\">\r\n                <div class=\"recipeDetail-infos\">\r\n                    <h2 class=\"sr-only\">Infos</h2>\r\n                    <div class=\"recipeDetail-infoItems\">\r\n                        <div class=\"recipeDetail-infoItem\" ng-if=\"$ctrl.recipe.Servings\">\r\n                            <span class=\"recipeDetail-infoAmount\" itemprop=\"recipeYield\">{{$ctrl.recipe.Servings}}</span> Serves\r\n                        </div>\r\n                        <div class=\"recipeDetail-infoItem\" ng-if=\"$ctrl.recipe.PreparationDuration && $ctrl.recipe.TemplateName !== 'Jamie_Oliver'\">\r\n                            <span class=\"recipeDetail-infoAmount\" itemprop=\"prepTime\" content=\"PT{{$ctrl.recipe.PreparationDuration}}M\">\r\n                                {{$ctrl.recipe.PreparationDuration}}\r\n                            </span> Mins Prep\r\n                        </div>\r\n                        <div class=\"recipeDetail-infoItem\" ng-if=\"$ctrl.recipe.CookingDuration  && $ctrl.recipe.TemplateName !== 'Jamie_Oliver'\">\r\n                            <span class=\"recipeDetail-infoAmount\" itemprop=\"cookTime\" content=\"PT{{$ctrl.recipe.CookingDuration}}M\">\r\n                                {{$ctrl.recipe.CookingDuration}}\r\n                            </span> Mins Cook\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!--Recipe content LF and MF for more than 1 column-->\r\n        <div class=\"u-flexCenter\">\r\n            <div class=\"recipeDetail-widthAdjust recipeDetail-methodIngredients\">\r\n                <div class=\"recipeDetail-ingredients\" ng-if=\"::$ctrl.recipe.Ingredients.length > 0\">\r\n                    <h2 class=\"heading3\">Ingredients</h2>\r\n                    <ul class=\"recipeDetail-ingredientsList\">\r\n                        <li class=\"recipeDetail-ingredient u-capitalize-first-letter\"\r\n                            ng-class=\"::'recipeDetail' + ingredient.Style\"\r\n                            itemprop=\"recipeIngredient\"\r\n                            ng-repeat=\"ingredient in $ctrl.recipe.Ingredients\">\r\n                            {{ ingredient.Description }}\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n\r\n                <div class=\"recipeDetail-method\">\r\n                    <h2 class=\"heading3\">Method</h2>\r\n                    <p\r\n                        class=\"recipeDetail-instructions\"\r\n                        itemprop=\"recipeInstructions\"\r\n                        ng-repeat=\"paragraph in ($ctrl.recipe.Instructions | paragraphize) track by $index\">\r\n                        {{ (paragraph | sentenceCase).trim() }}\r\n                    </p>\r\n\r\n                    <wow-recipe-detail-video ng-repeat=\"video in $ctrl.recipe.Videos track by $index\" url=\"video.Url\" itemprop=\"video\"></wow-recipe-detail-video>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"u-flexCenter\" ng-if=\"::$ctrl.recipe.IngredientsProducts.length > 0\">\r\n            <hr class=\"recipeDetail-widthAdjust recipeDetail-separator\" />\r\n        </div>\r\n\r\n        <div class=\"u-flexCenter\" ng-if=\"::$ctrl.recipe.IngredientsProducts.length > 0\">\r\n            <div class=\"recipeDetail-widthAdjust\">\r\n                <div class=\"recipeDetail-productsHeader\">\r\n                    <h2 class=\"recipeDetail-productsTitle heading3\">Shop the recipe</h2>\r\n                    <button class=\"button button--primary\" ng-click=\"$ctrl.addAllProductsToTrolley()\">Add all ({{ $ctrl.recipe.IngredientsProducts.length }})</button>\r\n                </div>\r\n                <div class=\"recipeDetail-products\">\r\n                    <wow-shelf-product-tile product=\"ingredient.Product\" ng-repeat=\"ingredient in $ctrl.recipe.IngredientsProducts\" class=\"shelfProduct--recipe\"></wow-shelf-product-tile>\r\n                </div>\r\n                <p ng-if=\"::$ctrl.shouldDisplayDisclaimer\" class=\"recipeDetail-disclaimer\">\r\n                    <span class=\"recipeDetail-disclaimerHeader\">Disclaimer: </span>{{ $ctrl.settings.recipe.disclaimerMessageUnavailableProducts }}\r\n                </p>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipeDetailVideoController = function () {
    function RecipeDetailVideoController($sce) {
        _classCallCheck(this, RecipeDetailVideoController);

        this.$sce = $sce;
    }

    _createClass(RecipeDetailVideoController, [{
        key: '$onInit',
        value: function $onInit() {
            this.trustedUrl = this.$sce.trustAsResourceUrl('' + this.url + (this.url.indexOf('?') === -1 ? '?' : '&') + 'showinfo=0&enablejsapi=1');
        }
    }]);

    return RecipeDetailVideoController;
}();

var recipeDetailVideoComponentDefinition = {
    bindings: {
        url: '='
    },
    controller: ['$sce', RecipeDetailVideoController],
    template: __webpack_require__(102).trim()
};

module.exports = {
    RecipeDetailVideoController: RecipeDetailVideoController,
    recipeDetailVideoComponentDefinition: recipeDetailVideoComponentDefinition
};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "<h3 class=\"recipeDetail-videoTitle\">Video</h3>\r\n\r\n<div class=\"recipeDetail-videoContainer\">\r\n    <iframe class=\"recipeDetail-video\" ng-src=\"{{$ctrl.trustedUrl}}\" frameborder=\"0\"></iframe>\r\n</div>\r\n"

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecipeDetailExportOptionsController = function () {
    function RecipeDetailExportOptionsController(moveFocus, analyticsService) {
        _classCallCheck(this, RecipeDetailExportOptionsController);

        this.moveFocus = moveFocus;
        this.analyticsService = analyticsService;
        this.showPrintOption = this.enablePrint === undefined || this.enablePrint;
    }

    _createClass(RecipeDetailExportOptionsController, [{
        key: 'logPrintRecipeClick',
        value: function logPrintRecipeClick() {
            this.analyticsService.pushEvent(this.analyticsService.events.PRINT_RECIPE);
        }
    }]);

    return RecipeDetailExportOptionsController;
}();

var recipeDetailExportOptionsComponentDefinition = {
    bindings: {
        recipeId: '@',
        enablePrint: '=?'
    },
    controller: ['MoveFocus', 'AnalyticsService', RecipeDetailExportOptionsController],
    template: __webpack_require__(104).trim()
};

module.exports = {
    RecipeDetailExportOptionsController: RecipeDetailExportOptionsController,
    recipeDetailExportOptionsComponentDefinition: recipeDetailExportOptionsComponentDefinition
};

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recipeExportOptions-exportOptions\">\r\n    <a class=\"recipeExportOptions-exportOptionLink\" ng-href=\"/Shop/PrintRecipe/{{::$ctrl.recipeId}}\" target=\"_blank\" ng-show=\"::$ctrl.showPrintOption\" ng-click=\"::$ctrl.logPrintRecipeClick()\">\r\n        <i class=\"icon-printer recipeExportOptions-exportOptionIcon\"></i>\r\n        <div class=\"recipeExportOptions-iconLabel\">\r\n            Print <span class=\"sr-only\"> recipe</span>\r\n        </div>\r\n    </a>\r\n</div>\r\n\r\n<dialog name=\"email recipe\" class=\"olyDialog olyDialog--confirmation recipeExportOptions-dialog\" id=\"recipeEmailDialog\">\r\n    <div class=\"recipeExportOptions-dialogContent\" wow-hide-scroll wow-scrollbar>\r\n        <wow-recipe-email-form></wow-recipe-email-form>\r\n    </div>\r\n</dialog>\r\n"

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.shop');

wowApp.directive('wowAccessibilityNavLinks', ['BreakpointsService', __webpack_require__(106)]);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (breakpointsService) {
    return {
        restrict: 'E',
        link: function link($scope) {
            $scope.isSmallFormat = function () {
                return breakpointsService.isSmallFormat();
            };
        },

        template: __webpack_require__(107).trim()
    };
};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<div class=\"navigation\">\r\n    <h2 class=\"sr-only\">My Account Navigation</h2>\r\n    <nav role=\"navigation\" class=\"navigation-items\">\r\n        <a id=\"accessibilityLink\" ui-sref=\"shop.support.accessibility\" ui-sref-active=\"is-active\" class=\"navigation-link\">\r\n            Accessibility\r\n        </a>\r\n    </nav>\r\n</div>\r\n"

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var bannersService = __webpack_require__(109),
    pageBannerStateService = __webpack_require__(110),
    _require = __webpack_require__(111),
    bannerComponentDefinition = _require.bannerComponentDefinition,
    _require2 = __webpack_require__(113),
    tobaccoBannerComponentDefinition = _require2.tobaccoBannerComponentDefinition;


angular.module('wowApp.shop').service('BannersService', bannersService).service('PageBannerStateService', pageBannerStateService).component('wowBanner', bannerComponentDefinition).component('wowTobaccoBanner', tobaccoBannerComponentDefinition);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BannersService = function () {
    function BannersService(restangular) {
        _classCallCheck(this, BannersService);

        this._api = restangular.one('banner');
        this.banners = {};
    }

    _createClass(BannersService, [{
        key: 'getBanners',
        value: function getBanners(_ref) {
            var _this = this;

            var _ref$CategoryId = _ref.CategoryId,
                CategoryId = _ref$CategoryId === undefined ? undefined : _ref$CategoryId,
                _ref$IsSpecialRoot = _ref.IsSpecialRoot,
                IsSpecialRoot = _ref$IsSpecialRoot === undefined ? false : _ref$IsSpecialRoot,
                _ref$SpecialGroupId = _ref.SpecialGroupId,
                SpecialGroupId = _ref$SpecialGroupId === undefined ? undefined : _ref$SpecialGroupId;

            if (CategoryId && !(CategoryId in this.banners)) {
                this._api.get({ CategoryId: CategoryId, IsSpecialRoot: IsSpecialRoot, SpecialGroupId: SpecialGroupId }).then(function (resp) {
                    _this.banners[CategoryId] = resp.BannerResponses;
                });
            }

            return this.banners[CategoryId];
        }
    }]);

    return BannersService;
}();

BannersService.$inject = ['Restangular'];

module.exports = BannersService;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PageBannerStateService = function () {
    function PageBannerStateService($rootScope) {
        var _this = this;

        _classCallCheck(this, PageBannerStateService);

        this._pageStateBanners = {};

        $rootScope.$on('$locationChangeStart', function () {
            _this.clearPageBannersState();
        });
    }

    _createClass(PageBannerStateService, [{
        key: 'setTobaccoBanner',
        value: function setTobaccoBanner(hasTobaccoProduct) {
            this._pageStateBanners.setTobaccoBanner = hasTobaccoProduct;
        }
    }, {
        key: 'getPageBannerState',
        value: function getPageBannerState() {
            return this._pageStateBanners;
        }
    }, {
        key: 'clearPageBannersState',
        value: function clearPageBannersState() {
            this._pageStateBanners = {};
        }
    }]);

    return PageBannerStateService;
}();

PageBannerStateService.$inject = ['$rootScope'];

module.exports = PageBannerStateService;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BannerController = function () {
    function BannerController() {
        _classCallCheck(this, BannerController);
    }

    _createClass(BannerController, [{
        key: 'getLinkTarget',
        value: function getLinkTarget() {
            return this.banner.LinkTarget === 'NewWindow' ? '_blank' : undefined;
        }
    }]);

    return BannerController;
}();

var bannerComponentDefinition = {
    bindings: {
        banner: '<'
    },
    controller: BannerController,
    template: __webpack_require__(112).trim()
};

module.exports = {
    BannerController: BannerController,
    bannerComponentDefinition: bannerComponentDefinition
};

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = "<a class=\"banner banner--imageLink\"\r\n    ng-href=\"{{ ::$ctrl.banner.Link }}\"\r\n    target=\"{{ ::$ctrl.getLinkTarget() }}\"\r\n    ng-if=\"::!$ctrl.banner.InspirationCard && $ctrl.banner.Link\">\r\n\r\n    <img ng-src=\"{{ ::$ctrl.banner.Image }}\"\r\n        alt=\"{{ ::$ctrl.banner.HoverText }}\"\r\n        ng-if=\"::!$ctrl.banner.InspirationCard\"\r\n        width=\"{{ ::$ctrl.banner.Width }}\"\r\n        height=\"{{ ::$ctrl.banner.Height }}\"\r\n        oly-error-src>\r\n</a>\r\n\r\n<img class=\"banner banner--image\"\r\n    ng-src=\"{{ ::$ctrl.banner.Image }}\"\r\n    alt=\"{{ ::$ctrl.banner.HoverText }}\"\r\n    ng-if=\"::!$ctrl.banner.InspirationCard && !$ctrl.banner.Link\"\r\n    width=\"{{ ::$ctrl.banner.Width }}\"\r\n    height=\"{{ ::$ctrl.banner.Height }}\"\r\n    oly-error-src>\r\n\r\n<wow-inspiration-tile class=\"banner banner--inspirationCard\"\r\n    card=\"::$ctrl.banner.InspirationCard\"\r\n    ng-if=\"::$ctrl.banner.InspirationCard\">\r\n</wow-inspiration-tile>\r\n"

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TobaccoBannerController = function () {
    function TobaccoBannerController(settings, breakpointsService) {
        _classCallCheck(this, TobaccoBannerController);

        this.settings = settings;
        this.breakpointsService = breakpointsService;
    }

    _createClass(TobaccoBannerController, [{
        key: '$onInit',
        value: function $onInit() {
            this.imagePath = this.breakpointsService.isSmallFormat() ? this.settings.banners.tobaccoSmall : this.settings.banners.tobaccoDefault;
        }
    }]);

    return TobaccoBannerController;
}();

var tobaccoBannerComponentDefinition = {
    controller: ['Settings', 'BreakpointsService', TobaccoBannerController],
    template: __webpack_require__(114).trim()
};

module.exports = {
    TobaccoBannerController: TobaccoBannerController,
    tobaccoBannerComponentDefinition: tobaccoBannerComponentDefinition
};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tobaccoBanner\">\r\n    <img class=\"tobaccoBanner-image\"\r\n        ng-src=\"{{$ctrl.imagePath}}\"\r\n        alt=\"Quitting Smoking Will Improve Your Health\">\r\n</div>\r\n"

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(116),
    browseTileListComponentDefinition = _require.browseTileListComponentDefinition;

var _require2 = __webpack_require__(118),
    browseLeftPanelComponentDefinition = _require2.browseLeftPanelComponentDefinition;

var _require3 = __webpack_require__(120),
    browseZeroResultsComponentDefinition = _require3.browseZeroResultsComponentDefinition;

var _require4 = __webpack_require__(122),
    myWeeklyPicksExceptionComponentDefinition = _require4.myWeeklyPicksExceptionComponentDefinition;

var _require5 = __webpack_require__(124),
    tokenizedWeeklyPicksExceptionComponentDefinition = _require5.tokenizedWeeklyPicksExceptionComponentDefinition;

angular.module('wowApp.shop').component('wowBrowseTileList', browseTileListComponentDefinition).component('wowBrowseLeftPanel', browseLeftPanelComponentDefinition).component('wowBrowseZeroResults', browseZeroResultsComponentDefinition).component('wowMyWeeklyPicksException', myWeeklyPicksExceptionComponentDefinition).component('wowTokenizedWeeklyPicksException', tokenizedWeeklyPicksExceptionComponentDefinition);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(10),
    createBundleTiles = _require.createBundleTiles,
    _require2 = __webpack_require__(19),
    mergeInspirationTiles = _require2.mergeInspirationTiles,
    _require3 = __webpack_require__(0),
    filter = _require3.filter,
    isUndefined = _require3.isUndefined;

var BrowseTileListController = function () {
    function BrowseTileListController($scope, $timeout, $location, settings, analyticsService, breakpointsService, pageMetadataService, richRelevanceService, shelfProductService, sortByKeys, pageBannerStateService, categoriesService) {
        _classCallCheck(this, BrowseTileListController);

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$location = $location;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.breakpointsService = breakpointsService;
        this.pageMetadataService = pageMetadataService;
        this.richRelevanceService = richRelevanceService;
        this.shelfProductService = shelfProductService;
        this.sortByKeys = sortByKeys;
        this.pageBannerStateService = pageBannerStateService;
        this.categoriesService = categoriesService;
    }

    _createClass(BrowseTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = this.category.IsSortEnabled ? {
                sortTypes: this.settings[this.category.IsSpecial ? 'specials' : 'browse'].sortOptions,
                sortContext: this.category.IsSpecial ? this.sortByKeys.SPECIALS_KEY : this.sortByKeys.BROWSE_KEY
            } : null;
            this.hasToken = !isUndefined(this.token);
            this.breadcrumbs = this.categoriesService.getCategoryPathToToRootByNodeId(this.category.NodeId);
        }
    }, {
        key: 'createTiles',
        value: function createTiles(response, pageSize, pageNumber) {
            return {
                items: mergeInspirationTiles(createBundleTiles(response.Bundles), response.InspirationCards ? response.InspirationCards.Cards : null, { pageSize: pageSize, pageNumber: pageNumber }),
                totalRecordCount: response.TotalRecordCount,
                aggregations: filter(response.Aggregations, function (a) {
                    return a.ShowFilter;
                })
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber, sortType, filters) {
            var _this = this;

            return this.getBrowsePage(pageSize, pageNumber, sortType, filters).then(function (response) {
                return _this.setMetadata(response);
            }).then(function (response) {
                return _this.onPlacementsReceived(response);
            }).then(function (response) {
                return _this.pushAnalytics(pageNumber, sortType, filters, response);
            }).then(function (response) {
                return _this.rewardsCheck(response);
            }).then(function (response) {
                return _this.tobaccoCheck(response);
            }).then(function (response) {
                return _this.createTiles(response, pageSize, pageNumber);
            });
        }
    }, {
        key: 'getBrowsePage',
        value: function getBrowsePage() {
            var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
            var pageNumber = arguments[1];
            var sortType = arguments[2];
            var filters = arguments[3];

            return this.shelfProductService.getBrowsePage({
                categoryId: this.category.IsBundle ? this.category.ParentNodeId : this.category.NodeId,
                pageNumber: pageNumber,
                pageSize: pageSize,
                sortType: sortType,
                url: this.$location.url(),
                location: this.$location.path(),
                formatObject: JSON.stringify({ name: this.category.Description }),
                isSpecial: this.category.IsSpecial,
                isBundle: this.category.IsBundle,
                isMobile: this.breakpointsService.isInSmallFormat,
                filters: filters ? filters.filters : null,
                token: this.token
            });
        }
    }, {
        key: 'setMetadata',
        value: function setMetadata(response) {
            this.pageMetadataService.setMetadata(response.SeoMetaTags);

            return response;
        }
    }, {
        key: 'onPlacementsReceived',
        value: function onPlacementsReceived(response) {
            if (this.richRelevanceService.useServerSideResults(response.RichRelevancePlacement)) {
                this.richRelevanceService.onPlacementsReceived(response.RichRelevancePlacement);
            }

            return response;
        }
    }, {
        key: 'pushAnalytics',
        value: function pushAnalytics(pageNumber, sortType, filters, response) {
            this.analyticsService.push({
                data: {
                    pageNumber: pageNumber,
                    currentCategory: this.category,
                    products: response.Bundles,
                    inspirationCards: response.InspirationCards,
                    totalRecordCount: response.TotalRecordCount,
                    filters: filters,
                    sortType: sortType,
                    sortOptions: this.sortOptions
                },
                type: this.analyticsService.mapperTypes.shop.productCategory
            });

            return response;
        }
    }, {
        key: 'rewardsCheck',
        value: function rewardsCheck(response) {
            // BE logic - hasRewardsCard is true always except for 'Logged in user with no rewards card tagged and navigated to My weekly picks page'.
            this.hasRewardsCard = response.HasRewardsCard;
            this.rewardsSuccess = response.Success;
            return response;
        }
    }, {
        key: 'tobaccoCheck',
        value: function tobaccoCheck(response) {
            this.pageBannerStateService.setTobaccoBanner(response.HasTobaccoItems);

            return response;
        }
    }]);

    return BrowseTileListController;
}();

BrowseTileListController.$inject = ['$scope', '$timeout', '$location', 'Settings', 'AnalyticsService', 'BreakpointsService', 'PageMetadataService', 'RichRelevanceService', 'ShelfProductService', 'SortByKeys', 'PageBannerStateService', 'CategoriesService'];

var browseTileListComponentDefinition = {
    bindings: {
        category: '<',
        pageNumber: '<',
        sortBy: '<',
        filter: '<',
        token: '<'
    },
    controller: BrowseTileListController,
    template: __webpack_require__(117).trim()
};

module.exports = {
    BrowseTileListController: BrowseTileListController,
    browseTileListComponentDefinition: browseTileListComponentDefinition
};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = "<wow-tile-list\r\n    list-title=\"::$ctrl.category.Description\"\r\n    page-number=\"$ctrl.pageNumber\"\r\n    filter=\"$ctrl.filter\"\r\n    sort-by=\"$ctrl.sortBy\"\r\n    sort-options=\"::$ctrl.sortOptions\"\r\n    should-get-inspiration-cards=\"false\"\r\n    get-tiles=\"$ctrl.getTiles(pageSize, pageNumber, sortType, filter)\"\r\n    is-pagination-enabled=\"::$ctrl.category.IsPaginationEnabled\"\r\n    no-results-term=\"::$ctrl.category.Description\"\r\n    breadcrumbs=\"$ctrl.breadcrumbs\">\r\n\r\n    <zero-result>\r\n        <wow-browse-zero-results\r\n            ng-if=\"($ctrl.hasToken && $ctrl.rewardsSuccess) || (!$ctrl.hasToken && $ctrl.hasRewardsCard)\"\r\n            category=\"::$ctrl.category\">\r\n        </wow-browse-zero-results>\r\n\r\n        <wow-tokenized-weekly-picks-exception\r\n            ng-if=\"$ctrl.hasToken && !$ctrl.rewardsSuccess\"\r\n            category=\"::$ctrl.category\">\r\n        </wow-tokenized-weekly-picks-exception>\r\n\r\n        <wow-my-weekly-picks-exception\r\n            ng-if=\"!$ctrl.hasToken && !$ctrl.hasRewardsCard\"\r\n            category=\"::$ctrl.category\">\r\n        </wow-my-weekly-picks-exception>\r\n    </zero-result>\r\n</wow-tile-list>\r\n"

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BrowseLeftPanelController = function () {
    function BrowseLeftPanelController(categoriesService, analyticsService) {
        _classCallCheck(this, BrowseLeftPanelController);

        this.categoriesService = categoriesService;
        this.analyticsService = analyticsService;
    }

    _createClass(BrowseLeftPanelController, [{
        key: 'shouldDisplayBacklink',
        value: function shouldDisplayBacklink() {
            if (this.isSpecial) {
                this.backlinkCategory = this.getBacklinkCategory();
                this.specialCategory = this.categoriesService.getSpecialCategory(this.category);
                return this.backlinkCategory && this.backlinkCategory !== this.specialCategory;
            }

            if (this.isBundle) {
                this.bundleCategory = this.categoriesService.getBundleCategory(this.category);
                return this.departmentCategory !== this.bundleCategory;
            }

            return this.departmentCategory !== this.category;
        }
    }, {
        key: 'getBacklinkCategory',
        value: function getBacklinkCategory() {
            return this.isSpecial && this.departmentCategory.IsSpecial ? this.categoriesService.getFirstSpecialCategory(this.departmentCategory) : this.departmentCategory;
        }
    }, {
        key: 'pushDataToAnalyticsService',
        value: function pushDataToAnalyticsService() {
            this.analyticsService.push({
                data: {
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.menuClick
            });
        }
    }]);

    return BrowseLeftPanelController;
}();

var browseLeftPanelComponentDefinition = {
    bindings: {
        departmentCategory: '<',
        category: '<',
        isSpecial: '<',
        isBundle: '<'
    },
    controller: ['CategoriesService', 'AnalyticsService', BrowseLeftPanelController],
    template: __webpack_require__(119).trim()
};

module.exports = {
    BrowseLeftPanelController: BrowseLeftPanelController,
    browseLeftPanelComponentDefinition: browseLeftPanelComponentDefinition
};

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "<wow-categories-navigation\r\n    class=\"browseLeftPanel\"\r\n    class-modifier=\"leftPanel\"\r\n    category=\"$ctrl.category\"\r\n    should-show-arrow=\"true\"\r\n    should-show-show-all=\"!$ctrl.isBundle\"\r\n    should-show-specials=\"true\"\r\n    should-show-bundles=\"true\">\r\n\r\n    <div class=\"browseLeftPanel-heading\">\r\n        <a class=\"browseLeftPanel-headingLink\"\r\n            ng-if=\"::$ctrl.shouldDisplayBacklink()\"\r\n            wow-category-sref=\"$ctrl.getBacklinkCategory()\"\r\n            ui-sref-opts=\"{ reload: true, inherit: false }\"\r\n            ng-click=\"$ctrl.pushDataToAnalyticsService()\">\r\n\r\n            <span class=\"sr-only\">Back to {{ $ctrl.departmentCategory.Description }}</span>\r\n            <div class=\"browseLeftPanel-headingBack\">\r\n                <i class=\"iconww-ArrowLeft browseLeftPanel-backIcon\"></i>\r\n            </div>\r\n            <h3 class=\"browseLeftPanel-headingText\" ng-if=\"$ctrl.category.Description\">\r\n                {{ $ctrl.category.Description }}\r\n            </h3>\r\n        </a>\r\n        <h3 class=\"browseLeftPanel-headingText\" ng-if=\"$ctrl.category.Description && !$ctrl.shouldDisplayBacklink()\">\r\n            {{ $ctrl.category.Description }}\r\n        </h3>\r\n    </div>\r\n</wow-categories-navigation>\r\n"

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BrowseZeroResultsController = function BrowseZeroResultsController() {
    _classCallCheck(this, BrowseZeroResultsController);
};

var browseZeroResultsComponentDefinition = {
    bindings: {
        category: '<'
    },
    controller: BrowseZeroResultsController,
    template: __webpack_require__(121).trim()
};

module.exports = {
    BrowseZeroResultsController: BrowseZeroResultsController,
    browseZeroResultsComponentDefinition: browseZeroResultsComponentDefinition
};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "<div class=\"browseZeroResults\">\r\n    <h1 class=\"browseZeroResults-header\">Sorry there aren’t any {{$ctrl.category.Description}} available.</h1>\r\n    <div class=\"browseZeroResults-blurb\" ng-if=\"$ctrl.category.IsSpecial\">\r\n        See what else is on <a ui-sref=\"shop.browse.department({department: 'specials'})\">special.</a>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyWeeklyPicksExceptionController = function MyWeeklyPicksExceptionController(shopperService) {
    _classCallCheck(this, MyWeeklyPicksExceptionController);

    this.shopperService = shopperService;
};

var myWeeklyPicksExceptionComponentDefinition = {
    bindings: {
        category: '<'
    },
    controller: ['ShopperService', MyWeeklyPicksExceptionController],
    template: __webpack_require__(123).trim()
};

module.exports = {
    MyWeeklyPicksExceptionController: MyWeeklyPicksExceptionController,
    myWeeklyPicksExceptionComponentDefinition: myWeeklyPicksExceptionComponentDefinition
};

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = "<div class=\"myWeeklyPicksException-container\">\r\n    <div class=\"myWeeklyPicksException\">\r\n        <h1 class=\"myWeeklyPicksException-title\" ng-if=\"$ctrl.category.Description\">{{ $ctrl.category.Description }}</h1>\r\n\r\n        <div class=\"myWeeklyPicksException-wrapper\">\r\n            <h2>Hi {{$ctrl.shopperService.shopper.FirstName}},</h2>\r\n            <p class=\"myWeeklyPicksException-message\">\r\n                <wow-setting setting-group=\"Category\" setting-name=\"MyWeeklyPicksException\"></wow-setting>\r\n            </p>\r\n            <div class=\"myWeeklyPicksException-message u-flex\">\r\n                <img class=\"myWeeklyPicksException-edr\" src=\"/Images/Collectionzone/icon-rewards-card-large.png\"/>\r\n                <a ui-sref=\"shop.myaccount.woolworthsrewards\" class=\"button\">Add Rewards card <i class=\"iconww-ArrowRight\"></i></a>\r\n            </div>\r\n            <div class=\"myWeeklyPicksException-message\">\r\n                Don't have a card?\r\n                <a href=\"https://www.woolworthsrewards.com.au/register.html\" target=\"_blank\">Join Rewards now <i class=\"iconww-ArrowRight\"></i></a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TokenizedWeeklyPicksExceptionController = function () {
    function TokenizedWeeklyPicksExceptionController($window) {
        _classCallCheck(this, TokenizedWeeklyPicksExceptionController);

        this.$window = $window;
    }

    _createClass(TokenizedWeeklyPicksExceptionController, [{
        key: 'reload',
        value: function reload() {
            this.$window.location.reload();
        }
    }]);

    return TokenizedWeeklyPicksExceptionController;
}();

var tokenizedWeeklyPicksExceptionComponentDefinition = {
    controller: ['$window', TokenizedWeeklyPicksExceptionController],
    template: __webpack_require__(125).trim()
};

module.exports = {
    TokenizedWeeklyPicksExceptionController: TokenizedWeeklyPicksExceptionController,
    tokenizedWeeklyPicksExceptionComponentDefinition: tokenizedWeeklyPicksExceptionComponentDefinition
};

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tokenizedWeeklyPicksException-container\">\r\n    <div class=\"tokenizedWeeklyPicksException\">\r\n        <h1>Oops, sorry we couldn't find your Weekly Picks.</h1>\r\n        <p class=\"tokenizedWeeklyPicksException-message\">\r\n            <wow-setting setting-group=\"Category\" setting-name=\"tokenizedWeeklyPicksExceptionMessage\"></wow-setting>\r\n        </p>\r\n\r\n        <div class=\"tokenizedWeeklyPicksException-buttons u-flex\">\r\n            <a class=\"button\" ng-click=\"$ctrl.reload()\">Reload page <i class=\"iconww-ArrowRight\"></i></a>\r\n        </div>\r\n\r\n        <div class=\"tokenizedWeeklyPicksException-divider\"></div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(127),
    cartComponentDefinition = _require.cartComponentDefinition;

var _require2 = __webpack_require__(129),
    cartOffscreenComponentDefinition = _require2.cartOffscreenComponentDefinition;

var _require3 = __webpack_require__(131),
    cartItemComponentDefinition = _require3.cartItemComponentDefinition;

var _require4 = __webpack_require__(133),
    cartItemMessageComponentDefinition = _require4.cartItemMessageComponentDefinition;

var _require5 = __webpack_require__(135),
    CartItemMessageService = _require5.CartItemMessageService;

var _require6 = __webpack_require__(140),
    cartItemGroupComponentDefinition = _require6.cartItemGroupComponentDefinition;

var _require7 = __webpack_require__(142),
    cartControlsComponentDefinition = _require7.cartControlsComponentDefinition;

var _require8 = __webpack_require__(144),
    cartMessageComponentDefinition = _require8.cartMessageComponentDefinition;

var _require9 = __webpack_require__(146),
    cartSaveListComponentDefinition = _require9.cartSaveListComponentDefinition;

var _require10 = __webpack_require__(148),
    cartFilterComponentDefinition = _require10.cartFilterComponentDefinition;

var _require11 = __webpack_require__(150),
    cartLoyaltyComponentDefinition = _require11.cartLoyaltyComponentDefinition;

var _require12 = __webpack_require__(152),
    cartDeliveryFeeComponentDefinition = _require12.cartDeliveryFeeComponentDefinition;

var _require13 = __webpack_require__(154),
    cartDeliveryFeeNotificationComponentDefinition = _require13.cartDeliveryFeeNotificationComponentDefinition;

var _require14 = __webpack_require__(156),
    cartOrderManagementComponentDefinition = _require14.cartOrderManagementComponentDefinition;

var _require15 = __webpack_require__(158),
    cartFreeDeliveryRewardsPlusComponentDefinition = _require15.cartFreeDeliveryRewardsPlusComponentDefinition;

var _require16 = __webpack_require__(160),
    cartBonusPointsRewardsPlusComponentDefinition = _require16.cartBonusPointsRewardsPlusComponentDefinition;

var productDetailConstants = __webpack_require__(34);

var wowApp = angular.module('wowApp.shop');

wowApp.component('wowCart', cartComponentDefinition);
wowApp.component('wowCartOffscreen', cartOffscreenComponentDefinition);
wowApp.component('wowCartItem', cartItemComponentDefinition);
wowApp.component('wowCartItemMessage', cartItemMessageComponentDefinition);
wowApp.service('CartItemMessageService', CartItemMessageService);
wowApp.component('wowCartItemGroup', cartItemGroupComponentDefinition);
wowApp.component('wowCartControls', cartControlsComponentDefinition);
wowApp.component('wowCartMessage', cartMessageComponentDefinition);
wowApp.component('wowCartSaveList', cartSaveListComponentDefinition);
wowApp.component('wowCartFilter', cartFilterComponentDefinition);
wowApp.component('wowCartLoyalty', cartLoyaltyComponentDefinition);
wowApp.component('wowCartDeliveryFee', cartDeliveryFeeComponentDefinition);
wowApp.component('wowCartDeliveryFeeNotification', cartDeliveryFeeNotificationComponentDefinition);
wowApp.component('wowCartOrderManagement', cartOrderManagementComponentDefinition);
wowApp.component('wowCartFreeDeliveryRewardsPlus', cartFreeDeliveryRewardsPlusComponentDefinition);
wowApp.component('wowCartBonusPointsRewardsPlus', cartBonusPointsRewardsPlusComponentDefinition);
wowApp.constant('ProductDetailConstants', productDetailConstants);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartController = function () {
    function CartController($scope, moveFocus, sessionStorage, settings, analyticsService, breakpointsService, trolleyService, addressService, fulfilmentService, shopperService) {
        _classCallCheck(this, CartController);

        this.scope = $scope;
        this.moveFocus = moveFocus;
        this.sessionStorage = sessionStorage;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.breakpointsService = breakpointsService;
        this.trolleyService = trolleyService;
        this.addressService = addressService;
        this.fulfilmentService = fulfilmentService;
        this.shopperService = shopperService;
    }

    _createClass(CartController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var sessionStorageKey = 'wowCart:collectionZoneMessages';
            var savedMessages = this.sessionStorage.getJsonAndRemove(sessionStorageKey);

            if (!this.shopperService.IsGuest && savedMessages) {
                this.cartMessages = savedMessages;
            }

            this.scope.$on('login:success', function (ev, loginResult) {
                if (loginResult.HasCollectionZoneMessages) {
                    // Save collection zone messages to session storage
                    _this.sessionStorage.setJson(sessionStorageKey, loginResult.LoginCollectionZoneMessages);
                }
            });

            this.showClearTrolleyConfirmationMessage = false;

            // push cart data in $onInit when website is in small format
            if (!this.breakpointsService.isInGreaterThanMediumFormatLandscape) {
                this.pushDataToAnalyticsService();
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            // push cart data in when cart is opened in medium and large format. Changes in cart panel is passed as a binding.
            if (this.breakpointsService.isInGreaterThanMediumFormatLandscape && changes.isOpen && changes.isOpen.currentValue) {
                this.pushDataToAnalyticsService();
            }
        }
    }, {
        key: 'getProductsNotAvailableAtLocationMessage',
        value: function getProductsNotAvailableAtLocationMessage() {
            return this.fulfilmentService.selectedFulfilmentMethod === this.fulfilmentService.fulfilmentOptions.delivery ? this.settings.trolley.productsUnavailableAtDeliveryLocation : this.settings.trolley.productsUnavailableAtPickupLocation;
        }
    }, {
        key: 'pushDataToAnalyticsService',
        value: function pushDataToAnalyticsService() {
            this.analyticsService.push({
                data: {
                    products: this.trolleyService.trolleyProducts,
                    savedPrice: this.trolleyService.savedPrice
                },
                type: this.analyticsService.mapperTypes.shop.cart
            });
        }
    }, {
        key: 'showTrolleyConfirmationContainerActions',
        value: function showTrolleyConfirmationContainerActions() {
            this.showClearTrolleyConfirmationMessage = true;
            this.moveFocus('#_cancelRemoveCartItems');
        }
    }, {
        key: 'clearCart',
        value: function clearCart() {
            this.trolleyService.clearTrolley();
            this.showClearTrolleyConfirmationMessage = false;
            this.analyticsService.push({
                data: {
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.trolley.clear
            });
        }
    }, {
        key: 'clearOutOfStock',
        value: function clearOutOfStock() {
            this.trolleyService.clearOutOfStockTrolleyItems();
        }
    }]);

    return CartController;
}();

var cartComponentDefinition = {
    bindings: {
        isOpen: '<?'
    },
    controller: ['$scope', 'MoveFocus', 'SessionStorageWrapper', 'Settings', 'AnalyticsService', 'BreakpointsService', 'TrolleyService', 'AddressService', 'FulfilmentService', 'ShopperService', CartController],
    template: __webpack_require__(128).trim()
};

module.exports = {
    CartController: CartController,
    cartComponentDefinition: cartComponentDefinition
};

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cart\">\r\n\r\n    <div ng-if=\"!$ctrl.shouldShowOrderManagement\">\r\n\r\n        <wow-express-cart-item-count\r\n            ng-if=\"$ctrl.fulfilmentService.isExpress && $ctrl.trolleyService.itemCount > 0\">\r\n        </wow-express-cart-item-count>\r\n\r\n        <div class=\"cart-totalSavings\" ng-if=\"$ctrl.trolleyService.savedPrice\">\r\n            Total saved <span class=\"cart-totalSavingsAmount\">{{$ctrl.trolleyService.savedPrice | wowCurrencyCents }}</span>\r\n        </div>\r\n\r\n        <wow-cart-loyalty>\r\n        </wow-cart-loyalty>\r\n\r\n        <form novalidate>\r\n            <wow-fulfilment-method-wizard\r\n                ng-if=\"!$ctrl.settings.frontendManagement.newFulfilmentMethodSelector\"\r\n                should-show-billing=\"false\"\r\n                allow-decide-later=\"true\"\r\n                is-active=\"!$ctrl.breakpointsService.isInGreaterThanMediumFormatLandscape || $ctrl.isOpen\">\r\n            </wow-fulfilment-method-wizard>\r\n            <wow-fulfilment-method-wizard-v2\r\n                ng-if=\"$ctrl.settings.frontendManagement.newFulfilmentMethodSelector\"\r\n                should-show-billing=\"false\"\r\n                allow-decide-later=\"true\"\r\n                is-active=\"!$ctrl.breakpointsService.isInGreaterThanMediumFormatLandscape || $ctrl.isOpen\">\r\n            </wow-fulfilment-method-wizard-v2>\r\n        </form>\r\n\r\n        <wow-cart-bonus-points-rewards-plus\r\n        ng-if=\"!$ctrl.searchFilter && $ctrl.fulfilmentService.isPickup() && $ctrl.trolleyService.ShouldRecieveBonusPointsRewardsPlus\">\r\n        </wow-cart-bonus-points-rewards-plus>\r\n\r\n        <div class=\"cart-deliveryFeeContainer\"\r\n            ng-if=\"!$ctrl.searchFilter && $ctrl.fulfilmentService.isDelivery() && !$ctrl.addressService.isNonServiced\">\r\n            <wow-cart-delivery-fee\r\n                ng-if=\"!$ctrl.searchFilter && $ctrl.fulfilmentService.isDelivery() && !$ctrl.addressService.isNonServiced\">\r\n            </wow-cart-delivery-fee>\r\n            <wow-cart-free-delivery-rewards-plus\r\n                ng-if=\"!$ctrl.searchFilter && $ctrl.fulfilmentService.isDelivery()\r\n                && !$ctrl.addressService.isNonServiced && $ctrl.trolleyService.ShouldRecieveFreeDeliveryRewardsPlus\"\r\n                price=\"$ctrl.trolleyService.deliveryFee\">\r\n            </wow-cart-free-delivery-rewards-plus>\r\n        </div>\r\n\r\n        <wow-cart-item-group\r\n            ng-if=\"$ctrl.trolleyService.restrictedProducts.length && !$ctrl.searchFilter\"\r\n            items=\"$ctrl.trolleyService.restrictedProducts\"\r\n            group-name=\"Restricted products\",\r\n            is-info=\"false\"\r\n            message=\"{{ ::$ctrl.settings.productRestrictions.restrictedProductsCollectionZoneInlineMessage }}\"\r\n            action-label=\"Change delivery window\"\r\n            on-action=\"$ctrl.fulfilmentService.changeFulfilmentTimeslot()\">\r\n        </wow-cart-item-group>\r\n\r\n        <wow-cart-item-group\r\n            ng-if=\"$ctrl.trolleyService.unavailableProducts.length && !$ctrl.searchFilter\"\r\n            items=\"$ctrl.trolleyService.unavailableProducts\"\r\n            group-name=\"Unavailable or out of stock products\",\r\n            is-info=\"false\"\r\n            message=\"{{ ::$ctrl.getProductsNotAvailableAtLocationMessage() }}\"\r\n            action-label=\"Remove all\"\r\n            on-action=\"$ctrl.clearOutOfStock()\">\r\n        </wow-cart-item-group>\r\n\r\n        <wow-cart-item-group\r\n            ng-if=\"$ctrl.trolleyService.restrictedByDeliveryMethodProducts.length && !$ctrl.searchFilter\"\r\n            items=\"$ctrl.trolleyService.restrictedByDeliveryMethodProducts\"\r\n            group-name=\"Products restricted by delivery method\",\r\n            is-info=\"false\"\r\n            message=\"{{ ::($ctrl.fulfilmentService.isExpress\r\n                ? $ctrl.settings.productRestrictions.restrictedByExpressDeliveryMessage\r\n                : $ctrl.trolleyService.restrictedByDeliveryMethodMessage) }}\"\r\n            action-label=\"Change delivery method\"\r\n            on-action=\"$ctrl.fulfilmentService.changeFulfilmentMethod()\">\r\n        </wow-cart-item-group>\r\n\r\n        <wow-cart-item-group\r\n            ng-if=\"$ctrl.trolleyService.bundleProducts.length && !$ctrl.searchFilter\"\r\n            items=\"$ctrl.trolleyService.bundleProducts\"\r\n            group-name=\"Bundle products\"\r\n            is-info=\"true\"\r\n            message=\"{{ ::$ctrl.settings.productRestrictions.expressQuantityRestrictedByBundlesMessage }}\">\r\n        </wow-cart-item-group>\r\n\r\n        <wow-cart-message\r\n            ng-repeat=\"message in $ctrl.cartMessages\"\r\n            message=\"message\">\r\n        </wow-cart-message>\r\n\r\n        <section aria-label=\"Products in your cart\">\r\n            <wow-cart-item\r\n                oly-move-focus-ondelete\r\n                ng-repeat=\"trolleyItem in $ctrl.trolleyService.trolleyProducts | filter:{ Name: $ctrl.searchFilter } as visibleItems track by trolleyItem.Stockcode\"\r\n                trolley-item=\"trolleyItem\">\r\n            </wow-cart-item>\r\n        </section>\r\n\r\n        <wow-cart-order-management\r\n            ng-if=\"!$ctrl.shopperService.IsGuest\">\r\n        </wow-cart-order-management>\r\n\r\n        <div ng-if=\"$ctrl.trolleyService.trolleyProducts.length\">\r\n            <wow-cart-save-list ng-if=\"!$ctrl.showClearTrolleyConfirmationMessage\">\r\n            </wow-cart-save-list>\r\n\r\n            <button type=\"button\"\r\n                class=\"linkButton cart-clearCart\"\r\n                ng-if=\"!$ctrl.showClearTrolleyConfirmationMessage\"\r\n                ng-click=\"$ctrl.showTrolleyConfirmationContainerActions()\">\r\n                <span class=\"u-flexCenter\">\r\n                    <wow-setting setting-group=\"Cart\" setting-name=\"RemoveAllProductsLinkText\"></wow-setting>\r\n                    <i class=\"iconww-Cross cart-clearCartIcon\"></i>\r\n                </span>\r\n            </button>\r\n\r\n            <div class=\"alert alert--info\"\r\n                ng-if=\"$ctrl.showClearTrolleyConfirmationMessage\"\r\n                role=\"alert\"\r\n                tabindex=\"-1\">\r\n                <wow-setting setting-group=\"Cart\" setting-name=\"ClearTrolleyConfirmationMessage\"></wow-setting>\r\n                <div class=\"cart-confirmationActions\">\r\n                    <button type=\"button\" id=\"_cancelRemoveCartItems\" class=\"linkButton\" ng-click=\"$ctrl.showClearTrolleyConfirmationMessage = false\">No</button>\r\n                    <button type=\"button\" class=\"linkButton\" ng-click=\"$ctrl.clearCart()\">Yes</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"cart-checkout\">\r\n        <i class=\"iconww-Cart cart-checkoutIcon\"></i>\r\n        <p class=\"cart-checkoutTotal\">\r\n            Your order<br>\r\n            <span class=\"cart-checkoutTotalAmount\">{{ $ctrl.trolleyService.salePriceTotal | wowCurrency }}</span>\r\n        </p>\r\n        <span class=\"u-flexSpacer\"></span>\r\n        <a ui-sref=\"hyf\" class=\"button button--primary\" ng-class=\"{'is-disabled': !($ctrl.trolleyService.hasAvailableProducts() || $ctrl.trolleyService.bundleProducts.length > 0) }\">\r\n            Checkout <i class=\"iconww-ArrowRight\"></i>\r\n        </a>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = __webpack_require__(2);

var CartOffscreenConstants = {
    checkoutButtonHeight: 74,
    categoryHeaderHeight: 50,
    navHeights: 100,
    stickyCartOffset: 70
};

var CartOffscreenController = function () {
    function CartOffscreenController($scope, $window, $element, $timeout, shopPageStateService, sessionStorageWrapper, trolleyService, analyticsService, breakpointsService) {
        var _this = this;

        _classCallCheck(this, CartOffscreenController);

        this.$window = $window;
        this.$element = $element;
        this.$timeout = $timeout;
        this.shopPageStateService = shopPageStateService;
        this.sessionStorageWrapper = sessionStorageWrapper;
        this.analyticsService = analyticsService;

        this.isInSmallFormat = breakpointsService.isInSmallFormat;

        $scope.$on('$stateChangeStart', function () {
            return _this.toggleOpen(false);
        });

        $scope.$watch(function () {
            return _this.shopPageStateService.isCartOpen;
        }, function () {
            return _this.toggleOpen(_this.shopPageStateService.isCartOpen);
        });

        $scope.$watch(function () {
            return trolleyService.itemCount;
        }, function (newItemCount, oldItemCount) {
            if (oldItemCount === 0 && newItemCount > 0) {
                _this.toggleOpen(true);
            }
        });
    }

    _createClass(CartOffscreenController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            // height to stick to the top
            // this is the height of the corporate header + category header which is
            // 30px + 50px = 80px
            this.stickyHeight = 80;

            this.$timeout(function () {
                _this2.shopPageStateService.isCartOpen = _this2.sessionStorageWrapper.getAndRemove('isCartOpen') === 'true';
            });
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this3 = this;

            this.$cart = this.$element.find('.cartOffscreen');
            this.$mask = this.$element.find('.cartOffscreen-contentMask');
            this.$nav = $(document.body).find('.categoryHeader');

            $(this.$window).on('beforeunload.cartpanel', function () {
                return _this3.sessionStorageWrapper.set('isCartOpen', _this3.shopPageStateService.isCartOpen);
            });

            if (!this.isInSmallFormat) {
                this.onScroll = function () {
                    return requestAnimationFrame(function () {
                        return _this3.setCartHeight();
                    });
                };
                document.addEventListener('scroll', this.onScroll, { passive: true });
                $(this.$window).on('resize', this.setCartHeight.bind(this));
            }
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            $(this.$window).off('beforeunload.cartpanel');

            if (!this.isInSmallFormat) {
                document.removeEventListener('scroll', this.onScroll, { passive: true });
                $(this.$window).off('resize', this.setCartHeight.bind(this));
            }
        }
    }, {
        key: 'toggleClasses',
        value: function toggleClasses() {
            this.$cart.toggleClass('is-open', this.shopPageStateService.isCartOpen);
            this.$mask.toggleClass('is-masked', this.shopPageStateService.isCartOpen);
        }
    }, {
        key: 'toggleOpen',
        value: function toggleOpen() {
            var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.shopPageStateService.isCartOpen;

            // This function sometimes gets called twice. Once by the ng-click from the template
            // and once by the watcher in the constructor. This is for performance reasons - if we always
            // wait for the watcher we have to wait 2 digest cycles which is slower on mobile devices.
            this.shopPageStateService.isCartOpen = open;

            this.shopPageStateService.toggleBodyScroll(!this.shopPageStateService.isCartOpen);
            this.toggleClasses();

            if (this.shopPageStateService.isCartOpen) {
                this.analyticsService.pushEvent(this.analyticsService.events.TOGGLE_PANEL);
            }

            this.setCartHeight();
        }
    }, {
        key: 'setCartHeight',
        value: function setCartHeight() {
            // Position checkout button to bottom of cart slider on desktop. (ckdx-80)
            if (this.isInSmallFormat) {
                return;
            }

            var hasSticky = this.$cart.hasClass('is-sticky');
            var height = 0;
            if (hasSticky) {
                height = this.$window.innerHeight - CartOffscreenConstants.stickyCartOffset;
            } else {
                var navTop = this.$nav.offset().top;
                var padding = this.$nav.offset().top - CartOffscreenConstants.navHeights;
                height = this.$window.innerHeight + document.documentElement.scrollTop - navTop - CartOffscreenConstants.categoryHeaderHeight + padding;
            }

            if (this.shopPageStateService.isCartOpen) {
                height -= CartOffscreenConstants.checkoutButtonHeight;
            }

            this.$cart.height(height);
        }
    }]);

    return CartOffscreenController;
}();

var cartOffscreenComponentDefinition = {
    controller: ['$scope', '$window', '$element', '$timeout', 'ShopPageStateService', 'SessionStorageWrapper', 'TrolleyService', 'AnalyticsService', 'BreakpointsService', CartOffscreenController],
    template: __webpack_require__(130).trim()
};

module.exports = {
    CartOffscreenController: CartOffscreenController,
    cartOffscreenComponentDefinition: cartOffscreenComponentDefinition
};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartOffscreen-contentMask\" ng-click=\"$ctrl.toggleOpen(false)\"></div>\r\n\r\n<div class=\"cartOffscreen\" oly-sticky=\"$ctrl.stickyHeight\">\r\n    <h2 class=\"sr-only\">Trolley</h2>\r\n    <button class=\"cartOffscreen-openButton\" ng-click=\"$ctrl.toggleOpen()\" aria-label=\"{{$ctrl.shopPageStateService.isCartOpen ? 'Hide' : 'Show'}} trolley - visual effect only\">\r\n        <i class=\"iconww-DoubleArrowLeft cartOffscreen-openIcon\" ng-class=\"{ 'is-open': $ctrl.shopPageStateService.isCartOpen }\"></i>\r\n    </button>\r\n\r\n    <div class=\"cartOffscreen-scrollWrapper\">\r\n        <wow-cart is-open=\"$ctrl.shopPageStateService.isCartOpen\"></wow-cart>\r\n        <div class=\"cartOffscreen-cartClosedMask\"\r\n             ng-show=\"!$ctrl.shopPageStateService.isCartOpen\"\r\n             ng-click=\"$ctrl.toggleOpen(true)\"></div>\r\n    </div>\r\n    <span class=\"sr-only\">Trolley end</span>\r\n</div>\r\n"

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartItemController = function () {
    function CartItemController($state, $timeout, config, trolleySource, analyticsService, trolleyService, cartItemMessageService, announcerService) {
        _classCallCheck(this, CartItemController);

        this.$state = $state;
        this.$timeout = $timeout;
        this.config = config;
        this.trolleySource = trolleySource;
        this.analyticsService = analyticsService;
        this.trolleyService = trolleyService;
        this.cartItemMessageService = cartItemMessageService;
        this.announcerService = announcerService;
    }

    _createClass(CartItemController, [{
        key: '$onInit',
        value: function $onInit() {
            this.productUrl = this.trolleyItem.UrlOverride || this.$state.href('shop.productdetails', {
                productId: this.trolleyItem.Stockcode,
                productName: this.trolleyItem.UrlFriendlyName
            });
        }
    }, {
        key: 'onError',
        value: function onError(reason) {
            this.analyticsService.pushError(reason);

            this.error = reason;
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess() {
            this.clearError();
        }
    }, {
        key: 'clearError',
        value: function clearError() {
            this.error = null;

            this.cartItemMessageService.clearErrors(this.trolleyItem.Stockcode);
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this = this;

            this.analyticsService.push({
                data: {
                    trackingType: 'link',
                    product: this.trolleyItem
                },
                type: this.analyticsService.mapperTypes.customEvent.trolley.cartRemove
            });
            this.trolleyService.removeTrolleyItem(this.trolleyItem.Stockcode).then(function () {
                _this.cartItemMessageService.removeItemMessages(_this.trolleyItem.Stockcode);
                _this.announcerService.announce(_this.trolleyItem.Name + ' removed from trolley');
            });
        }
    }, {
        key: 'pushDataToAnalyticsService',
        value: function pushDataToAnalyticsService() {
            this.analyticsService.push({
                data: {
                    trackingType: 'link',
                    product: this.trolleyItem
                },
                type: this.analyticsService.mapperTypes.customEvent.productClick
            });
        }
    }]);

    return CartItemController;
}();

var cartItemComponentDefinition = {
    bindings: {
        trolleyItem: '<',
        classModifier: '@?'
    },
    controller: ['$state', '$timeout', 'config', 'TrolleySource', 'AnalyticsService', 'TrolleyService', 'CartItemMessageService', 'AnnouncerService', CartItemController],
    template: __webpack_require__(132).trim()
};

module.exports = {
    CartItemController: CartItemController,
    cartItemComponentDefinition: cartItemComponentDefinition
};

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartItem\" ng-class=\"$ctrl.classModifier\">\r\n    <div class=\"cartItem-product\">\r\n        <div class=\"cartItem-thumb\">\r\n            <a ng-href=\"{{::$ctrl.productUrl}}\">\r\n                <img ng-src=\"{{ ::$ctrl.trolleyItem.SmallImageFile }}\" alt=\"\" class=\"cartItem-image\" title=\"{{ ::$ctrl.trolleyItem.Name + ' ' + $ctrl.trolleyItem.PackageSize }}\" oly-error-src=\"{{ ::$ctrl.config.DefaultProductImage }}\">\r\n            </a>\r\n\r\n            <p class=\"cartItem-quantity\">\r\n                <span class=\"cartItem-quantityAmount\">{{ $ctrl.trolleyItem.QuantityInTrolley }}</span>\r\n                <span ng-if=\"::($ctrl.trolleyItem.Unit === 'KG')\">kg</span>\r\n                <br>in cart\r\n            </p>\r\n        </div>\r\n\r\n        <div class=\"cartItem-details\" ng-switch=\"::$ctrl.trolleyItem.IsAvailable\">\r\n            <h3>\r\n                <a ng-href=\"{{::$ctrl.productUrl}}\" class=\"cartItem-name\" ng-click=\"$ctrl.pushDataToAnalyticsService()\">\r\n                    {{ ::$ctrl.trolleyItem.Name + ' ' + $ctrl.trolleyItem.PackageSize }}\r\n                </a>\r\n            </h3>\r\n\r\n            <button type=\"button\" class=\"cartItem-removeButton\" ng-click=\"$ctrl.remove()\">\r\n                <span class=\"sr-only\">Remove from trolley.</span>\r\n                <i class=\"iconww-Cross\"></i>\r\n            </button>\r\n\r\n            <div class=\"cartItem-cartControlsPrice\" ng-switch-when=\"true\">\r\n                <wow-cart-controls\r\n                    trolley-product=\"$ctrl.trolleyItem\"\r\n                    on-error=\"$ctrl.onError(reason)\"\r\n                    on-success=\"$ctrl.onSuccess()\"\r\n                    source=\"{{ ::$ctrl.trolleySource.collectionZone }}\"\r\n                    class-modifier=\"cartControls--compact\">\r\n                </wow-cart-controls>\r\n                <wow-price\r\n                    price=\"$ctrl.trolleyItem.SalePrice\"\r\n                    price-class-modifier=\"price--compact\">\r\n                </wow-price>\r\n            </div>\r\n\r\n            <div class=\"cartItem-cartControlsPrice\" ng-switch-when=\"false\">\r\n                <p class=\"button button--secondaryLight is-disabled\">\r\n                    <span class=\"sr-only\">This item is </span>Unavailable<span class=\"sr-only\"> or out of stock </span>\r\n                </p>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <wow-setting class=\"cartItem-meatStockLoss\" ng-show=\"$ctrl.trolleyItem.IsMeatStockLoss\"\r\n        setting-group=\"Cart\" setting-name=\"MeatStockLossMessage\"></wow-setting>\r\n\r\n    <wow-cart-item-message\r\n        trolley-item=\"$ctrl.trolleyItem\"\r\n        error=\"$ctrl.error\"\r\n        on-dismiss-error=\"$ctrl.clearError()\">\r\n    </wow-cart-item-message>\r\n</div>\r\n"

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find;

var CartItemMessageController = function () {
    function CartItemMessageController(cartItemMessageService) {
        _classCallCheck(this, CartItemMessageController);

        this.cartItemMessageService = cartItemMessageService;
    }

    _createClass(CartItemMessageController, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.itemMessages = this.cartItemMessageService.buildItemMessages(this.trolleyItem, this.error);

            this.inlineMessage = this.nextMessage(this.itemMessages);
        }
    }, {
        key: 'onDismiss',
        value: function onDismiss(itemMessages, inlineMessage) {
            this.dismissMessage(itemMessages, inlineMessage);

            this.inlineMessage = this.nextMessage(itemMessages);
        }
    }, {
        key: 'dismissMessage',
        value: function dismissMessage(itemMessages, inlineMessage) {
            inlineMessage.isDismissed = true;

            if (inlineMessage === itemMessages.errorMessage) {
                this.onDismissError();
            }
        }
    }, {
        key: 'nextMessage',
        value: function nextMessage(itemMessages) {
            return find([itemMessages.errorMessage, itemMessages.matchedPromotionMessage, itemMessages.missedPromotionMessage], function (message) {
                return message && !message.isDismissed;
            });
        }
    }]);

    return CartItemMessageController;
}();

var cartItemMessageComponentDefinition = {
    bindings: {
        trolleyItem: '<',
        error: '<',
        onDismissError: '&'
    },
    controller: ['CartItemMessageService', CartItemMessageController],
    template: __webpack_require__(134).trim()
};

module.exports = {
    CartItemMessageController: CartItemMessageController,
    cartItemMessageComponentDefinition: cartItemMessageComponentDefinition
};

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"'cartItemMessage cartItemMessage--' + $ctrl.inlineMessage.class\" ng-if=\"$ctrl.inlineMessage && !$ctrl.inlineMessage.isDismissed\">\r\n    <i class=\"cartItemMessage-icon\" ng-class=\"$ctrl.inlineMessage.iconClass\"></i>\r\n    <div class=\"cartItemMessage-content\" ng-include=\"$ctrl.inlineMessage.templateId\"></div>\r\n\r\n    <!-- Dismiss button-->\r\n    <button type=\"button\" ng-click=\"$ctrl.onDismiss($ctrl.itemMessages, $ctrl.inlineMessage)\" class=\"linkButton cartItemMessage-close\">\r\n        <i class=\"iconww-Cross\"></i><span class=\"sr-only\">Dismiss message</span>\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    isUndefined = _require.isUndefined,
    _require2 = __webpack_require__(136),
    cartItemMessageTemplates = _require2.cartItemMessageTemplates,
    _require3 = __webpack_require__(33),
    trolleyQuantityValidation = _require3.trolleyQuantityValidation;

var CartItemMessages = function CartItemMessages(stockcode) {
    _classCallCheck(this, CartItemMessages);

    this.stockcode = stockcode;

    this.errorMessage = null;
    this.matchedPromotionMessage = null;
    this.missedPromotionMessage = null;
};

var CartItemMessageService = function () {
    function CartItemMessageService($templateCache, $sce, settings, currencyCentsFilter) {
        _classCallCheck(this, CartItemMessageService);

        this.$sce = $sce;
        this.currencyCentsFilter = currencyCentsFilter;

        cartItemMessageTemplates.forEach(function (template) {
            $templateCache.put(template.id, template.content);
        });

        this.itemLimitReachedMessage = settings.trolley.itemLimitReached;
        this.itemNotUpdatedMessage = settings.trolley.itemNotUpdated;
        this.deliveryPassLimitMessage = settings.deliveryPass.exceededMaxActiveDeliveryPassesMessage;

        this.itemMessages = {};
    }

    _createClass(CartItemMessageService, [{
        key: 'getItemMessages',
        value: function getItemMessages(stockcode) {
            if (!(stockcode in this.itemMessages)) {
                this.itemMessages[stockcode] = new CartItemMessages(stockcode);
            }

            return this.itemMessages[stockcode];
        }
    }, {
        key: 'removeItemMessages',
        value: function removeItemMessages(stockcode) {
            delete this.itemMessages[stockcode];
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors(stockcode) {
            this.getItemMessages(stockcode).errorMessage = null;
        }
    }, {
        key: 'buildItemMessages',
        value: function buildItemMessages(trolleyItem, error) {
            var itemMessages = this.getItemMessages(trolleyItem.Stockcode);

            if ((!trolleyItem.MatchedPromotions || !trolleyItem.MatchedPromotions.length) && (!trolleyItem.MissedPromotions || !trolleyItem.MissedPromotions.length) && !error && !itemMessages.errorMessage) {
                return new CartItemMessages(trolleyItem.Stockcode);
            }

            // Error may be null even though the error has not been acknowledged.
            // This can happen when using the trolley filter as the trolley items which do not match are destroyed,
            // and their local state is lost.
            //
            // Therefore, we keep the old error message even if error is not set. Error messages are cleared
            // by the cart-item when the quantity is successfully updated or the error is manually dismissed.
            itemMessages.errorMessage = error ? this.buildErrorMessages(trolleyItem, error, itemMessages.errorMessage) : itemMessages.errorMessage;

            itemMessages.matchedPromotionMessage = trolleyItem.MatchedPromotions && trolleyItem.MatchedPromotions.length ? this.buildMatchedPromotionMessage(trolleyItem, itemMessages.matchedPromotionMessage) : null;

            itemMessages.missedPromotionMessage = trolleyItem.MissedPromotions && trolleyItem.MissedPromotions.length ? this.buildMissedPromotionMessage(trolleyItem, itemMessages.missedPromotionMessage) : null;

            return itemMessages;
        }
    }, {
        key: 'buildErrorMessages',
        value: function buildErrorMessages(trolleyItem, errorType, previousErrorMessage) {
            var message = void 0;

            switch (errorType) {
                case trolleyQuantityValidation.INVALID_QUANTITY:
                    message = this.itemNotUpdatedMessage;
                    break;
                case trolleyQuantityValidation.SUPPLY_LIMIT_EXCEEDED:
                    message = this.itemLimitReachedMessage.replace('{itemLimit}', trolleyItem.SupplyLimit);
                    break;
                case trolleyQuantityValidation.DELIVERY_PASS_LIMIT_EXCEEDED:
                    message = this.deliveryPassLimitMessage;
                    break;
                default:
                    break;
            }

            if (previousErrorMessage && previousErrorMessage.key === message) {
                return previousErrorMessage;
            }

            return !message ? null : {
                key: message,
                class: 'errorQuantity alert alert--error',
                templateId: 'error-quantity',
                isDismissed: false,
                iconClass: 'iconww-QtyDeliveryLimit cartItemMessage-iconQuantityLimit',
                message: { errorMessage: this.$sce.trustAsHtml(message) }
            };
        }
    }, {
        key: 'buildMatchedPromotionMessage',
        value: function buildMatchedPromotionMessage(trolleyItem, previousMatchedPromotionMessage) {
            var matchedPromotion = find(trolleyItem.MatchedPromotions, function (promotion) {
                return promotion.IsMultiBuy || promotion.IsPackagePrice || promotion.IsBonusOffer || promotion.IsProductGroupPercentageOff || promotion.IsDeferred || promotion.IsR1Promotion;
            });

            var message = matchedPromotion && (matchedPromotion.IsDeferred || matchedPromotion.IsR1Promotion) ? matchedPromotion.Description : 'You\'ve saved ' + this.currencyCentsFilter(trolleyItem.ListPrice * trolleyItem.QuantityInTrolley - trolleyItem.SalePrice);

            if (previousMatchedPromotionMessage && previousMatchedPromotionMessage.key === message) {
                return previousMatchedPromotionMessage;
            }

            return {
                key: message,
                class: 'matchedPromotion alert alert--success',
                templateId: 'matched-promotion',
                isDismissed: false,
                iconClass: this.getPromotionIconClass(matchedPromotion),
                message: {
                    promotionDescription: this.$sce.trustAsHtml(message)
                }
            };
        }
    }, {
        key: 'buildMissedPromotionMessage',
        value: function buildMissedPromotionMessage(trolleyItem, previousMissedPromotionMessage) {
            var missedPromotion = find(trolleyItem.MissedPromotions, function (promotion) {
                return promotion.IsMultiBuy || promotion.IsPackagePrice || promotion.IsBonusOffer || promotion.IsProductGroupPercentageOff;
            });

            if (isUndefined(missedPromotion)) {
                return null;
            }

            if (previousMissedPromotionMessage && previousMissedPromotionMessage.key === missedPromotion.Description) {
                return previousMissedPromotionMessage;
            }

            return {
                key: missedPromotion.Description,
                class: 'missedPromotion alert alert--info',
                templateId: 'missed-promotion',
                isDismissed: false,
                iconClass: this.getPromotionIconClass(missedPromotion),
                message: {
                    promotionDescription: missedPromotion.Description,
                    promotionLink: missedPromotion.Link
                }
            };
        }
    }, {
        key: 'getPromotionIconClass',
        value: function getPromotionIconClass(promotion) {
            return promotion && (promotion.IsDeferred || promotion.IsR1Promotion) ? 'iconww-RewardPointsEarned cartItemMessage-iconRewardPointsEarned' : 'iconww-TrolleySaver cartItemMessage-iconTrolleySaver';
        }
    }]);

    return CartItemMessageService;
}();

CartItemMessageService.$inject = ['$templateCache', '$sce', 'Settings', 'wowCurrencyCentsFilter'];

module.exports = {
    CartItemMessageService: CartItemMessageService,
    CartItemMessages: CartItemMessages
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cartItemMessageTemplates = [{
    id: 'matched-promotion',
    content: __webpack_require__(137).trim()
}, {
    id: 'missed-promotion',
    content: __webpack_require__(138).trim()
}, {
    id: 'error-quantity',
    content: __webpack_require__(139).trim()
}];

module.exports = { cartItemMessageTemplates: cartItemMessageTemplates };

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = "<span class=\"cartItemMessage--matchedPromotion-description\" ng-bind-html=\"$ctrl.inlineMessage.message.promotionDescription\"></span>\r\n"

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartItemMessage--missedPromotion-heading\">\r\n    <wow-setting setting-group=\"Trolley\" setting-name=\"ProductPromoMessage\"></wow-setting>\r\n</div>\r\n<a ng-href=\"{{$ctrl.inlineMessage.message.promotionLink}}\" class=\"cartItemMessage--missedPromotion-description\">\r\n    {{$ctrl.inlineMessage.message.promotionDescription}}\r\n</a>\r\n"

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = "<span class=\"cartItemMessage--errorQuanity\" ng-bind-html=\"$ctrl.inlineMessage.message.errorMessage\"></span>\r\n"

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartItemGroupController = function CartItemGroupController() {
    _classCallCheck(this, CartItemGroupController);
};

var cartItemGroupComponentDefinition = {
    bindings: {
        items: '<',
        groupName: '@',
        isInfo: '@',
        message: '@',
        actionLabel: '@',
        onAction: '&'
    },
    controller: CartItemGroupController,
    template: __webpack_require__(141).trim()
};

module.exports = {
    CartItemGroupController: CartItemGroupController,
    cartItemGroupComponentDefinition: cartItemGroupComponentDefinition
};

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = "<section aria-label=\"{{ ::$ctrl.groupName }}\" class=\"cartItemGroup\">\r\n    <div class=\"cartItemGroup-container alert alert--info\" role=\"alert\">\r\n        <i ng-class=\"$ctrl.isInfo=='true'\r\n        ? 'icon-alert-starburst cartItemGroup-iconInfo'\r\n        : 'iconww-ProductNa'\"\r\n        class=\"cartItemGroup-icon\"></i>\r\n        <div class=\"cartItemGroup-message\">\r\n            <p ng-class=\"{'cartItemGroup-text': $ctrl.isInfo=='true'}\">{{ ::$ctrl.message }}</p>\r\n\r\n            <button type=\"button\" class=\"cartItemGroup-action linkButton\" ng-click=\"$ctrl.onAction()\">\r\n                {{ ::$ctrl.actionLabel }}\r\n            </button>\r\n        </div>\r\n    </div>\r\n\r\n    <wow-cart-item\r\n        ng-repeat=\"trolleyItem in $ctrl.items track by trolleyItem.Stockcode\"\r\n        trolley-item=\"trolleyItem\"\r\n        class-modifier=\"{{ $last ? 'cartItemGroup-lastItem' : '' }}\">\r\n    </wow-cart-item>\r\n</section>\r\n"

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0);

var CartControlsController = function () {
    function CartControlsController($element, $timeout, $q, $state, moveFocus, trolleyService, analyticsService, inStoreProductService, settings, productDetailConstants) {
        _classCallCheck(this, CartControlsController);

        this.$element = $element;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$state = $state;
        this.moveFocus = moveFocus;
        this.trolleyService = trolleyService;
        this.analyticsService = analyticsService;
        this.inStoreProductService = inStoreProductService;
        this.settings = settings;
        this.updateInTrolley = _.debounce(this.updateInTrolley, 500);
        this.productDetailConstants = productDetailConstants;
    }

    _createClass(CartControlsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.product = this.trolleyProduct ? this.trolleyProduct : this.shelfProduct;
            this.isInKilograms = this.product.Unit === 'KG';
            this.defaultQuantity = this.isInKilograms ? this.product.MinimumQuantity : 1;

            this.buttonPostfix = this.isInKilograms ? ' quantity by ' + this.product.MinimumQuantity + ' kg.' : ' quantity.';

            this.showInTrolleyMessage = this.showInTrolleyMessage === undefined ? false : this.showInTrolleyMessage;
            this.showInstoreProduct = this.showInstoreProduct === undefined ? false : this.showInstoreProduct;
            this.addToCartLabel = this.showInstoreProduct === true ? 'Buy Online' : 'Add to cart';
        }
    }, {
        key: '$onChanges',
        value: function $onChanges() {
            this.product = this.trolleyProduct ? this.trolleyProduct : this.shelfProduct;

            if (this.shelfProduct) {
                this.shelfProduct.IsInTrolley = !!this.trolleyProduct;
            }
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            if (this.product.IsDeliveryPass) {
                this.trolleyService.deliveryPassLimitReached[this.product.Stockcode] = false;
                this.trolleyService.showDCPdeliveryPassLimitReachedMsg = false;
            }
        }

        /**
         * Performs validation of the new quantity and performs the quantity update
         * if validation succeeds. This method is the entry point and is the only
         * method which should be used to add/update/remove an item in the cart.
         *
         * @param {number} newQuantity
         * @param {boolean} [allowRemove=false] Indicates whether the product can be removed.
         *  When true, if the new quantity is zero, the product is removed from the trolley.
         * @returns {Promise<any>}
         *
         * @memberOf CartControlsController
         */

    }, {
        key: 'validateAndUpdateQuantity',
        value: function validateAndUpdateQuantity(newQuantity) {
            var _this = this;

            var allowRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


            if (newQuantity == null) {
                // The user has backspaced, we must wait for more input.
                return this.$q.reject();
            }

            this.pushBuyOnlineTracking();

            // For google merchant hosted store front if the product is already in trolley
            // then don't add the product until user is directed to the normal product details page
            if (this.isInMHSFMode() && this.product.IsInTrolley) {
                newQuantity = this.product.QuantityInTrolley;
            }

            newQuantity = this.correctRoundingErrors(newQuantity);

            if (allowRemove && newQuantity === 0) {
                this.product.QuantityInTrolley = newQuantity;
                return this.removeFromTrolley(this.product);
            }

            return this.$q.all({
                validationResult: this.validateQuantity(newQuantity),
                updateResponse: this.updateQuantity(newQuantity)
            }).then(function (result) {
                return _this.onValidateAndUpdate(result);
            });
        }
    }, {
        key: 'onValidateAndUpdate',
        value: function onValidateAndUpdate(_ref) {
            var _this2 = this;

            var validationResult = _ref.validationResult,
                updateResponse = _ref.updateResponse;

            if (updateResponse) {
                this.checkForMessages(updateResponse.Message);
            }

            if (this.onError && !validationResult.isValid) {
                this.$timeout(function () {
                    return _this2.onError({ reason: validationResult.reason });
                });
            } else if (this.onSuccess && validationResult.isValid) {
                this.$timeout(function () {
                    return _this2.onSuccess();
                });
            }
        }
    }, {
        key: 'validateQuantity',
        value: function validateQuantity(newQuantity) {
            var _this3 = this;

            return this.validateDeliveryPassLimit(this.product, newQuantity).then(function () {
                return _this3.trolleyService.validateQuantity(_this3.product, newQuantity);
            });
        }
    }, {
        key: 'updateQuantity',
        value: function updateQuantity(newQuantity) {
            // This is a dangerous hack that prevents the trolley response
            // coming back and resetting the quantity while the user is still
            // clicking the plus button. It will make the trolley service
            // throw away responses from previous update requests.
            this.trolleyService.updateRequestCount++;

            var updatePromise = this.product.IsInTrolley ? this.updateInTrolley(this.product, newQuantity) : this.addToTrolley(this.product, newQuantity);

            // Optimistically update the quantity.
            this.product.QuantityInTrolley = newQuantity;

            return updatePromise;
        }
    }, {
        key: 'updateInTrolley',
        value: function updateInTrolley(product, quantity) {
            // For google merchant hosted store front, we make an exception to trigger alternative flow
            if (this.isInMHSFMode()) {
                var storeCode = this.getStoreCode();

                if (storeCode) {
                    return this.inStoreProductService.triggerMhsfProduct(this.shelfProduct.InstorePrice, product.Stockcode, storeCode, quantity, this.source, this.$state.params.searchTerm, true);
                }
            }

            this.analyticsPush(product, product.Quantity > quantity);
            return this.trolleyService.updateTrolleyItem(product, quantity, this.source, product.Quantity > quantity);
        }
    }, {
        key: 'addToTrolley',
        value: function addToTrolley(product, quantity) {
            var _this4 = this;

            // For google merchant hosted store front, we make an exception to trigger alternative flow
            if (this.isInMHSFMode()) {
                var storeCode = this.getStoreCode();

                if (storeCode) {
                    return this.inStoreProductService.triggerMhsfProduct(product.InstorePrice, product.Stockcode, storeCode, quantity, this.source, this.$state.params.searchTerm, false);
                }
            }

            this.analyticsPush(product);
            this.product.IsInTrolley = true;
            this.moveFocus(function () {
                return _this4.$element.find('._inTrolleyFocus');
            });
            return this.trolleyService.addItemToTrolley(product, quantity, this.source, this.$state.params.searchTerm);
        }
    }, {
        key: 'analyticsPush',
        value: function analyticsPush(product) {
            var isRemoving = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this.analyticsService.push({
                data: {
                    trackingType: 'link',
                    product: product
                },
                type: isRemoving ? this.analyticsService.mapperTypes.customEvent.trolley.cartRemove : this.analyticsService.mapperTypes.customEvent.trolley.cartAdd
            });
        }
    }, {
        key: 'removeFromTrolley',
        value: function removeFromTrolley(product) {
            var _this5 = this;

            this.analyticsPush(product, true);
            if (this.onRemove) {
                this.onRemove();
            }
            // If there are any pending debounced quantity updates (e.g. from the user decrementing)
            // we want to cancel those since the product is being removed.
            this.updateInTrolley.cancel();
            this.product.IsInTrolley = false;
            this.moveFocus(function () {
                return _this5.$element.find('._outOfTrolleyFocus');
            });
            return this.trolleyService.removeTrolleyItem(product.Stockcode);
        }
    }, {
        key: 'correctRoundingErrors',
        value: function correctRoundingErrors(quantity) {
            // correct for floating point rounding errors
            return this.isInKilograms ? parseFloat(quantity.toFixed(2)) : quantity;
        }
    }, {
        key: 'validateDeliveryPassLimit',
        value: function validateDeliveryPassLimit(product, quantity) {
            var _this6 = this;

            if (!product.IsDeliveryPass) {
                return this.$q.when(true);
            }

            this.trolleyService.deliveryPassLimitReached[product.Stockcode] = false;
            this.trolleyService.showDCPdeliveryPassLimitReachedMsg = false;

            return this.trolleyService.validateDeliveryPassLimit(product, quantity).then(function (response) {
                return _this6.onDeliveryPassLimitValidation(product, quantity, response.NewQuantity);
            });
        }
    }, {
        key: 'onDeliveryPassLimitValidation',
        value: function onDeliveryPassLimitValidation(product, newQuantity, validatedQuantity) {
            if (newQuantity === validatedQuantity) {
                return;
            }

            this.trolleyService.deliveryPassLimitReached[product.Stockcode] = true;
            this.trolleyService.showDCPdeliveryPassLimitReachedMsg = !!this.shelfProduct;

            product.QuantityInTrolley = validatedQuantity;
            product.IsInTrolley = validatedQuantity > 0;
        }
    }, {
        key: 'checkForMessages',
        value: function checkForMessages(message) {
            // If the response has a message, show a dialog with the message.
            if (message && !this.$state.is('checkout')) {
                this.modalMessage = message;
                this.analyticsService.pushError(message);
            }
        }
    }, {
        key: 'resetModalMessage',
        value: function resetModalMessage() {
            this.modalMessage = null;
            this.moveFocus(this.$element.find('._inTrolleyFocus'));
        }
    }, {
        key: 'pushBuyOnlineTracking',
        value: function pushBuyOnlineTracking() {
            if (this.showInstoreProduct) {
                this.analyticsService.push({
                    data: {
                        event: {
                            category: 'ecommerce',
                            label: 'Buy Online',
                            name: 'link_click',
                            value: this.productDetailConstants.MHSF
                        },
                        trackingType: 'link',
                        product: this.product
                    },
                    type: this.analyticsService.mapperTypes.customEvent.linkClick
                });
            }
        }
    }, {
        key: 'isInMHSFMode',
        value: function isInMHSFMode() {
            return this.$state.params.googleshop && this.$state.params.store_code;
        }
    }, {
        key: 'getStoreCode',
        value: function getStoreCode() {
            return this.$state.params.store_code && this.$state.params.store_code.includes(this.settings.googleSem.storeCodeParamPrefix) ? this.$state.params.store_code.replace(this.settings.googleSem.storeCodeParamPrefix, '') : this.settings.googleSem.defaultBasePriceStoreCode;
        }

        // Controls whether the trolley control with plus/minus/numeric symbols is visible

    }, {
        key: 'shouldShowTrolleyControl',
        value: function shouldShowTrolleyControl() {
            return this.product.IsInTrolley && !this.showInstoreProduct;
        }

        // Controls whether the whole cart control is visible

    }, {
        key: 'shouldShowCartControl',
        value: function shouldShowCartControl() {
            return this.product.IsAvailable || this.showInstoreProduct;
        }
    }]);

    return CartControlsController;
}();

CartControlsController.$inject = ['$element', '$timeout', '$q', '$state', 'MoveFocus', 'TrolleyService', 'AnalyticsService', 'InStoreProductService', 'Settings', 'ProductDetailConstants'];

var cartControlsComponentDefinition = {
    bindings: {
        trolleyProduct: '<',
        shelfProduct: '<?',
        source: '@',
        classModifier: '@?',
        onSuccess: '&?',
        onError: '&?',
        onRemove: '&?',
        showInTrolleyMessage: '<?',
        showInstoreProduct: '<?'
    },
    controller: CartControlsController,
    template: __webpack_require__(143).trim()
};

module.exports = {
    CartControlsController: CartControlsController,
    cartControlsComponentDefinition: cartControlsComponentDefinition
};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = "<div ng-switch=\"::$ctrl.shouldShowCartControl()\">\r\n    <div class=\"cartControls\"\r\n        ng-class=\"::$ctrl.classModifier\"\r\n        ng-switch-when=\"true\"\r\n        ng-switch=\"$ctrl.shouldShowTrolleyControl()\">\r\n        <button\r\n            type=\"button\"\r\n            class=\"cartControls-addButton button button--primary _outOfTrolleyFocus\"\r\n            ng-click=\"$ctrl.validateAndUpdateQuantity($ctrl.defaultQuantity)\"\r\n            ng-switch-when=\"false\">\r\n\r\n            <span class=\"cartControls-addCart\">{{::$ctrl.addToCartLabel}}\r\n                <i class=\"cartControls-cartIcon iconww-Cart\" ng-if=\"!$ctrl.showInstoreProduct\" aria-hidden=\"true\"></i>\r\n                <i class=\"cartControls-buyOnlineIcon icon-chevron_next\" ng-if=\"$ctrl.showInstoreProduct\" aria-hidden=\"true\"></i>\r\n            </span>\r\n        </button>\r\n\r\n        <div ng-switch-when=\"true\" class=\"cartControls-inTrolleyWrapper\">\r\n            <div class=\"cartControls-inTrolley _inTrolleyFocus\">\r\n                <button\r\n                    type=\"button\"\r\n                    class=\"button button--primary cartControls-quantityButton cartControls-decrementButton\"\r\n                    ng-click=\"$ctrl.validateAndUpdateQuantity($ctrl.product.QuantityInTrolley - $ctrl.defaultQuantity, true)\">\r\n\r\n                    <span class=\"sr-only\">Decrease {{::$ctrl.buttonPostfix}}</span>\r\n                    <i class=\"iconww-Minus\"></i>\r\n                </button>\r\n\r\n                <input\r\n                    type=\"number\"\r\n                    step=\"{{ ::$ctrl.defaultQuantity }}\"\r\n                    min=\"0\"\r\n                    max=\"{{ ::$ctrl.product.SupplyLimit }}\"\r\n                    aria-label=\"Order quantity\"\r\n                    class=\"cartControls-quantityInput\"\r\n                    ng-class=\"::{ 'is-kilograms': $ctrl.isInKilograms }\"\r\n                    ng-model=\"$ctrl.product.QuantityInTrolley\"\r\n                    ng-model-options=\"::{ allowInvalid: true }\"\r\n                    ng-change=\"$ctrl.validateAndUpdateQuantity($ctrl.product.QuantityInTrolley, !$ctrl.isInKilograms)\" />\r\n\r\n                <span ng-if=\"::$ctrl.isInKilograms\" class=\"cartControls-kgLabel\">kg</span>\r\n\r\n                <button\r\n                    type=\"button\"\r\n                    class=\"button button--primary cartControls-quantityButton cartControls-incrementButton\"\r\n                    ng-click=\"$ctrl.validateAndUpdateQuantity($ctrl.product.QuantityInTrolley + $ctrl.defaultQuantity)\"\r\n                    ng-disabled=\"$ctrl.product.QuantityInTrolley >= $ctrl.product.SupplyLimit || $ctrl.trolleyService.deliveryPassLimitReached[$ctrl.product.Stockcode]\">\r\n\r\n                    <span class=\"sr-only\">Increase {{::$ctrl.buttonPostfix}}</span>\r\n                    <i class=\"iconww-Plus\"></i>\r\n                </button>\r\n            </div>\r\n            <p class=\"cartControls-inTrolleyText\" ng-if=\"::$ctrl.showInTrolleyMessage\">in your cart</p>\r\n        </div>\r\n\r\n        <wow-dialog\r\n            ng-if=\"$ctrl.modalMessage\"\r\n            dialog-name=\"restricted window\"\r\n            message=\"{{ $ctrl.modalMessage }}\"\r\n            on-dismiss=\"::$ctrl.resetModalMessage()\">\r\n        </wow-dialog>\r\n    </div>\r\n\r\n    <div class=\"cartControls\" ng-switch-when=\"false\">\r\n        <button type=\"button\" class=\"cartControls-addButton cartControls-addCart button button--secondaryLight\" disabled>\r\n            Unavailable\r\n        </button>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var cartMessageController = function () {
    function cartMessageController() {
        _classCallCheck(this, cartMessageController);

        this.isDismissed = false;
    }

    _createClass(cartMessageController, [{
        key: 'dismissMessage',
        value: function dismissMessage() {
            this.isDismissed = true;
        }
    }]);

    return cartMessageController;
}();

var cartMessageComponentDefinition = {
    controller: cartMessageController,
    bindings: {
        message: '<'
    },
    template: __webpack_require__(145).trim()
};

module.exports = {
    cartMessageController: cartMessageController,
    cartMessageComponentDefinition: cartMessageComponentDefinition
};

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartMessage\" ng-if=\"!$ctrl.isDismissed\" role=\"status\" aria-live=\"polite\" aria-atomic=\"true\">\r\n    <p class=\"cartMessage-heading heading4\">Cart Updated</p>\r\n    <p class=\"cartMessage-text\">\r\n        {{$ctrl.message}}\r\n    </p>\r\n    <button class=\"cartMessage-closeText linkButton\" ng-click=\"$ctrl.dismissMessage()\">Ok thanks<span class=\"sr-only\">, close message</span></button>\r\n    <button class=\"cartMessage-closeButton\" ng-click=\"$ctrl.dismissMessage()\">\r\n        <span class=\"sr-only\">Close this dialog.</span>\r\n        <i class=\"iconww-Cross\"></i>\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var steps = {
    INITIAL: 'INITIAL',
    SAVING: 'SAVING',
    SAVED: 'SAVED'
};

var CartSaveListController = function () {
    function CartSaveListController($timeout, $rootScope, $sanitize, moveFocus, sessionStorage, analyticsService, trolleyService, shopperService, loginService, shopPageStateService, savedListsService) {
        _classCallCheck(this, CartSaveListController);

        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$sanitize = $sanitize;

        this.moveFocus = moveFocus;
        this.sessionStorage = sessionStorage;
        this.analyticsService = analyticsService;
        this.trolleyService = trolleyService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.shopPageStateService = shopPageStateService;
        this.savedListsService = savedListsService;

        this.steps = steps;
    }

    _createClass(CartSaveListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.step = this.steps.INITIAL;
            this.saving = false;

            this.pendingSaveAsListStorageKey = 'CartSaveListController:pendingSaveAsList';

            if (!this.shopperService.IsGuest) {
                this.savePendingList(this.sessionStorage.getJsonAndRemove(this.pendingSaveAsListStorageKey));
            }
        }
    }, {
        key: 'savePendingList',
        value: function savePendingList(listName) {
            var _this = this;

            if (!listName) return;

            this.newListName = listName;
            this.step = this.steps.SAVING;
            this.shopPageStateService.isCartOpen = true;

            // Waiting for cart to open and the step to change
            this.$timeout(function () {
                _this.saveForm.$setSubmitted();
                _this.save(_this.newListName);
            });
        }
    }, {
        key: 'promptForLogin',
        value: function promptForLogin(listName) {
            var _this2 = this;

            return this.loginService.promptForLogin('Please login to save your trolley as a list.', undefined, undefined, { reload: false }, function () {
                _this2.sessionStorage.setJson(_this2.pendingSaveAsListStorageKey, listName);
            });
        }
    }, {
        key: 'save',
        value: function save(listName) {
            var _this3 = this;

            listName = this.$sanitize(listName).trim();

            this.setServerErrors(null);
            this.saving = true;

            if (this.shopperService.IsGuest) {
                return this.promptForLogin(listName);
            }

            return this.trolleyService.saveTrolleyAsList(listName).then(function (response) {
                return _this3.onSaved(response.plain());
            }).finally(function () {
                _this3.saving = false;
            });
        }
    }, {
        key: 'onSaved',
        value: function onSaved(response) {
            if (response.Success) {
                this.step = this.steps.SAVED;

                // $broadcast needed to tell My Lists to refresh it's contents
                this.savedListsService.invalidateCache();
                this.$rootScope.$broadcast('saveTrolleyAsList:ListSuccessful');

                // Push to Tealium
                this.analyticsService.push({
                    data: {
                        trackingType: 'link',
                        products: this.trolleyService.trolleyProducts
                    },
                    type: this.analyticsService.mapperTypes.customEvent.trolley.save
                });
            } else {
                this.setServerErrors(response.Message);
            }
        }
    }, {
        key: 'setServerErrors',
        value: function setServerErrors(message) {
            if (this.saveForm) {
                this.saveForm.newListName.$setValidity('server', !message);
            }

            this.serverErrorMessage = message;
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.newListName = '';
            this.setServerErrors(null);

            if (this.saveForm) {
                this.saveForm.$setPristine();
            }
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.clear();
            this.step = this.steps.INITIAL;

            this.moveFocus('._saveCartListInitial');
        }
    }]);

    return CartSaveListController;
}();

var cartSaveListComponentDefinition = {
    controller: ['$timeout', '$rootScope', '$sanitize', 'MoveFocus', 'SessionStorageWrapper', 'AnalyticsService', 'TrolleyService', 'ShopperService', 'LoginService', 'ShopPageStateService', 'SavedListsService', CartSaveListController],
    template: __webpack_require__(147).trim()
};

module.exports = {
    CartSaveListController: CartSaveListController,
    cartSaveListComponentDefinition: cartSaveListComponentDefinition
};

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartSaveList\" ng-switch=\"$ctrl.step\">\r\n    <button ng-switch-when=\"INITIAL\" class=\"linkButton cartSaveList-button _saveCartListInitial\" ng-click=\"$ctrl.step = $ctrl.steps.SAVING\" >\r\n        <wow-setting setting-group=\"Trolley\" setting-name=\"SaveTrolleyAsListLinkText\"></wow-setting>\r\n        <i class=\"iconww-List-2 cartSaveList-buttonIcon\"></i>\r\n    </button>\r\n\r\n    <div class=\"cartSaveList-saving\" ng-switch-when=\"SAVING\">\r\n        <form name=\"$ctrl.saveForm\" class=\"cartSaveList-form\" ng-submit=\"$ctrl.saveForm.$valid && $ctrl.save($ctrl.newListName)\" novalidate autocomplete=\"off\">\r\n            <wow-input-container class=\"cartSaveList-inputContainer\">\r\n                <label for=\"cartSaveList-input\">Enter a name for this list</label>\r\n                <input\r\n                    type=\"text\"\r\n                    name=\"newListName\"\r\n                    id=\"cartSaveList-input\"\r\n                    class=\"cartSaveList-input\"\r\n                    required\r\n                    ng-model=\"$ctrl.newListName\"\r\n                    ng-change=\"$ctrl.setServerErrors(null)\"\r\n                    oly-grab-focus=\"true\">\r\n\r\n                <span ng-messages=\"$ctrl.saveForm.newListName.$error\" class=\"wowInput-errors\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\">\r\n                    <span ng-message=\"required\" class=\"wowInput-error\">List name is required.</span>\r\n                    <span ng-message=\"server\" class=\"wowInput-error\">{{ $ctrl.serverErrorMessage }}</span>\r\n                </span>\r\n            </wow-input-container>\r\n\r\n            <button type=\"button\" class=\"cartSaveList-clearInput linkButton\" ng-show=\"$ctrl.newListName.length > 0\" ng-click=\"$ctrl.clear()\" oly-move-focus=\"cartSaveList-input\">\r\n                <i class=\"iconww-Cross\"></i>\r\n                <span class=\"sr-only\">Clear list name</span>\r\n            </button>\r\n\r\n            <oly-button class=\"cartSaveList-saveLoadingButton\" loading=\"{state: $ctrl.saving, message: 'Please wait, saving your cart as a list'}\" child-spinner-class=\"cartSaveList-savingSpinner\">\r\n                <button type=\"submit\" class=\"button button--primary cartSaveList-saveButton\">\r\n                    Save <span class=\"sr-only\">your trolley as a list</span>\r\n                </button>\r\n            </oly-button>\r\n        </form>\r\n\r\n        <button type=\"button\" class=\"linkButton cartSaveList-cancelButton\" ng-click=\"$ctrl.reset()\">Cancel</button>\r\n    </div>\r\n\r\n    <div class=\"cartSaveList-saved\" ng-switch-when=\"SAVED\">\r\n        <p class=\"cartSaveList-savedMessage\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\">\r\n            List saved\r\n            <i class=\"iconww-Tick cartSaveList-savedTick\"></i>\r\n        </p>\r\n\r\n        <button type=\"button\" class=\"linkButton cartSaveList-closeSavedButton\" ng-click=\"$ctrl.reset()\" oly-grab-focus=\"true\">\r\n            Close <span class=\"sr-only\"> and reset save to list form.</span>\r\n        </button>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartFilterController = function CartFilterController() {
    _classCallCheck(this, CartFilterController);
};

var cartFilterComponentDefinition = {
    bindings: {
        searchFilter: '=',
        itemCount: '='
    },
    controller: CartFilterController,
    template: __webpack_require__(149).trim()
};

module.exports = {
    CartFilterController: CartFilterController,
    cartFilterComponentDefinition: cartFilterComponentDefinition
};

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = "<form action=\".\" class=\"cartFilter\" novalidate autocomplete=\"off\" ng-submit=\"$event.preventDefault()\" ng-switch=\"!!$ctrl.searchFilter\">\r\n    <wow-input-container class=\"cartFilter-inputContainer has-control\">\r\n        <label for=\"cart-filter\">\r\n            <wow-setting setting-group=\"Trolley\" setting-name=\"SearchFilterMessage\"></wow-setting>\r\n            <span class=\"sr-only\">; type here to auto filter your trolley matching entered text</span>\r\n        </label>\r\n        <input id=\"cart-filter\" type=\"search\" ng-model=\"$ctrl.searchFilter\" ng-model-options=\"{ debounce: 500 }\" aria-controls=\"cartFilter-status\" />\r\n        <button class=\"wowInput-control\" ng-switch-when=\"false\" oly-move-focus=\"cart-filter\">\r\n            <span class=\"sr-only\">Search</span>\r\n            <i class=\"iconww-Search\" aria-hidden=\"true\"></i>\r\n        </button>\r\n        <button type=\"reset\" class=\"wowInput-control\" ng-switch-when=\"true\" ng-click=\"$ctrl.searchFilter = ''\" oly-move-focus=\"cart-filter\">\r\n            <span>\r\n                <i class=\"iconww-Cross\" aria-hidden=\"true\"></i>\r\n                <span class=\"sr-only\">Clear search text</span>\r\n            </span>\r\n        </button>\r\n    </wow-input-container>\r\n</form>\r\n\r\n<p id=\"cartFilter-status\" class=\"cartFilter-status\" ng-class=\"{'sr-only': !$ctrl.searchFilter}\" role=\"status\" ng-switch=\"!!$ctrl.searchFilter\" aria-atomic=\"true\">\r\n    <span ng-switch-when=\"true\">({{ $ctrl.itemCount }}) Results found for \"{{ $ctrl.searchFilter }}\"</span>\r\n    <span ng-switch-when=\"false\">{{ $ctrl.itemCount }} products in your trolley</span>\r\n</p>\r\n"

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var loyaltyPointsCalculator = __webpack_require__(23);

var CartLoyaltyController = function () {
    function CartLoyaltyController(featureService, settingsService, trolleyService) {
        var _this = this;

        _classCallCheck(this, CartLoyaltyController);

        this.trolleyService = trolleyService;
        this.settingsService = settingsService;
        this.featureService = featureService;
        settingsService.getSettingValue('EverydayRewards', 'CardName').then(function (setting) {
            _this.rewardsCardName = setting;
        });
    }

    _createClass(CartLoyaltyController, [{
        key: 'isOptOutSaveForLaterAndBalanceIsLessThanMinimum',
        value: function isOptOutSaveForLaterAndBalanceIsLessThanMinimum() {
            return !this.shouldShowSaveForLaterPreference() && this.isLowerThanMinimumRedemptionBalance();
        }
    }, {
        key: 'getToSpendImageProperties',
        value: function getToSpendImageProperties() {
            if (!this.shouldShowSaveForLaterPreference()) {
                return { srcName: 'icon-rewards-burn.svg', className: 'cartLoyalty-pointsToSpendIcon' };
            } else if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'QuarterlyQff') {
                return { srcName: 'icon-rewards-qff-plane.svg', className: 'cartLoyalty-pointsQffIcon' };
            } else if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'Christmas') {
                return { srcName: 'icon-rewards-xmas-sock.svg', className: 'cartLoyalty-pointsXmasIcon' };
            }
            return { srcName: 'icon-tospend.png', className: 'cartLoyalty-pointsToSpendIcon' };
        }
    }, {
        key: 'shouldShowSaveForLaterPreference',
        value: function shouldShowSaveForLaterPreference() {
            return this.getSaveForLaterPreference() === 'Christmas' || this.getSaveForLaterPreference() === 'QuarterlyQff';
        }
    }, {
        key: 'getToSpendDisplayMessage',
        value: function getToSpendDisplayMessage() {
            if (this.getSaveForLaterPreference() === 'QuarterlyQff') {
                return this.isLowerThanMinimumRedemptionBalance() ? 'SAVING<br/>FOR QANTAS' : 'SAVED FOR QANTAS';
            }
            if (this.getSaveForLaterPreference() === 'Christmas') {
                return this.isLowerThanMinimumRedemptionBalance() ? 'SAVING<br/>FOR XMAS' : 'SAVED FOR XMAS';
            }
            return 'TO SPEND';
        }
    }, {
        key: 'getScreenReaderMessage',
        value: function getScreenReaderMessage() {
            if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'QuarterlyQff') {
                return 'to save for Qantas';
            }
            if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'Christmas') {
                return 'to save for Christmas';
            }
            return 'to spend';
        }
    }, {
        key: 'getLowerThanMinimumBalanceStyle',
        value: function getLowerThanMinimumBalanceStyle() {
            return this.isLowerThanMinimumRedemptionBalance() ? 'cartLoyalty-pointsTopRowLowerThanMinimumBalance' : '';
        }
    }, {
        key: 'isLowerThanMinimumRedemptionBalance',
        value: function isLowerThanMinimumRedemptionBalance() {
            return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsLessThanMinimumRedemptionBalance;
        }
    }, {
        key: 'getWowRewardsEarned',
        value: function getWowRewardsEarned() {
            return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.WowRewardsEarned;
        }
    }, {
        key: 'getWowRewardsToSpend',
        value: function getWowRewardsToSpend() {
            return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.WowRewardsToSpend;
        }
    }, {
        key: 'getRewardsPoints',
        value: function getRewardsPoints() {
            return loyaltyPointsCalculator(this.getWowRewardsEarned());
        }
    }, {
        key: 'getSaveForLaterPreference',
        value: function getSaveForLaterPreference() {
            return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.SaveForLaterPreference;
        }
    }, {
        key: 'shouldShowWowRewardsSummary',
        value: function shouldShowWowRewardsSummary() {
            var isEnabledGetEdrPointsBalanceOnLogin = this.featureService.isEnabled(this.featureService.features.enableGetEdrPointsBalanceOnLogin);
            var isErrorInGettingWowRewardsBalance = this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsErrorInGettingWowRewardsBalance;
            var isRegisteredWowRewardsCustomer = this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsWowRewardsCardRegistered;

            return isEnabledGetEdrPointsBalanceOnLogin && !isErrorInGettingWowRewardsBalance && isRegisteredWowRewardsCustomer;
        }
    }]);

    return CartLoyaltyController;
}();

var cartLoyaltyComponentDefinition = {
    controller: ['FeatureService', 'SettingsService', 'TrolleyService', CartLoyaltyController],
    template: __webpack_require__(151).trim()
};

module.exports = {
    CartLoyaltyController: CartLoyaltyController,
    cartLoyaltyComponentDefinition: cartLoyaltyComponentDefinition
};

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = "<!--NG IF - HIDE IF FAIL TO GET REDEEMABLE POINTS FROM LMS-->\r\n<div class=\"cartLoyalty-pointsContainer\" ng-if=\"$ctrl.shouldShowWowRewardsSummary()\">\r\n\r\n    <div class=\"cartLoyalty-points cartLoyalty-redeemable cartLoyalty-pointsLeft\"\r\n         ng-if=\"!$ctrl.isOptOutSaveForLaterAndBalanceIsLessThanMinimum()\">\r\n        <img class=\"cartLoyalty-edr\" src=\"/Images/Collectionzone/icon-rewards-card.png\"/>\r\n        <div class=\"cartLoyalty-pointsTopRow\"\r\n             ng-class=\"{'cartLoyalty-pointsTopRowLowerThanMinimumBalance' : $ctrl.isLowerThanMinimumRedemptionBalance() && $ctrl.shouldShowSaveForLaterPreference()}\">\r\n            <span class=\"sr-only\">{{::$ctrl.rewardsCardName}}, {{$ctrl.getScreenReaderMessage()}}</span>\r\n            <div class=\"cartLoyalty-pointsRewardsContainer\">\r\n                <img class=\"cartLoyalty-pointsIcon {{$ctrl.getToSpendImageProperties().className}}\"\r\n                     ng-src=\"/Images/Collectionzone/{{$ctrl.getToSpendImageProperties().srcName}}\"/>\r\n                <span class=\"cartLoyalty-pointsTotal\" ng-if=\"!$ctrl.isLowerThanMinimumRedemptionBalance()\">\r\n                    {{$ctrl.getWowRewardsToSpend() | wowCurrency}}\r\n                </span>\r\n            </div>\r\n            <div aria-hidden=\"true\" class=\"cartLoyalty-pointsTitle\" ng-bind-html=\"$ctrl.getToSpendDisplayMessage() | sanitize\"></div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"cartLoyalty-points cartLoyalty-accrued cartLoyalty-pointsRight\"\r\n         ng-class=\"{'cartLoyalty-pointsWithBalanceLessThanMinimum' : $ctrl.isOptOutSaveForLaterAndBalanceIsLessThanMinimum()}\">\r\n        <span class=\"sr-only\">{{::$ctrl.rewardsCardName}}, You'll Earn</span>\r\n        <img class=\"cartLoyalty-edrLessThanMinimumBalance\"\r\n             src=\"/Images/Collectionzone/icon-rewards-card.png\"\r\n             ng-if=\"$ctrl.isOptOutSaveForLaterAndBalanceIsLessThanMinimum()\"/>\r\n        <div class=\"cartLoyalty-pointsTopRow\">\r\n            <div class=\"cartLoyalty-pointsRewardsContainer\">\r\n                <img class=\"cartLoyalty-pointsIcon cartLoyalty-pointsWoWDollarIcon cartLoyalty-pointsIconWithEarnPoints\"\r\n                     ng-src=\"/Images/Collectionzone/icon-rewards-wow-dollar.svg\"/>\r\n                <span class=\"cartLoyalty-pointsTotal\">{{$ctrl.getWowRewardsEarned() | wowLoyaltyPoints : false}}</span>\r\n                <span class=\"cartLoyalty-pointsEarn\">points</span>\r\n            </div>\r\n            <div aria-hidden=\"true\" class=\"cartLoyalty-pointsTitle\">You'll Earn</div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartDeliveryFeeController = function () {
    function CartDeliveryFeeController($sce, settings, shopperService, trolleyService, deliveryPassService, deliveryFeeService, deliverySaverConstants) {
        _classCallCheck(this, CartDeliveryFeeController);

        this.$sce = $sce;
        this.settings = settings;
        this.shopperService = shopperService;
        this.trolleyService = trolleyService;
        this.deliveryPassService = deliveryPassService;
        this.deliveryFeeService = deliveryFeeService;
        this.deliverySaverConstants = deliverySaverConstants;

        this.deliveryFeeStructure = null;
    }

    _createClass(CartDeliveryFeeController, [{
        key: '$onInit',
        value: function $onInit() {
            this.showDeliveryFeeStructure = false;

            this.deliveryPassService.showShopperDeliveryPassPrompt();
        }
    }, {
        key: 'toggleDeliveryFeeStructure',
        value: function toggleDeliveryFeeStructure() {
            var _this = this;

            this.showDeliveryFeeStructure = !this.showDeliveryFeeStructure;

            if (this.showDeliveryFeeStructure) {
                this.deliveryFeeService.getDeliveryFeeStructure().then(function (response) {
                    _this.deliveryFeeStructure = response;
                });
            }
        }
    }, {
        key: 'showDeliveryPassPrompt',
        value: function showDeliveryPassPrompt() {
            return !this.showDeliveryFeeStructure && !this.settings.deliverySaver.isEnabled && (this.deliveryPassService.deliveryPassPrompt.ContentText || this.deliveryPassService.deliveryPassPrompt.PromptText);
        }
    }, {
        key: 'showDeliveryPlusSuspended',
        value: function showDeliveryPlusSuspended() {
            return this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.SUSPENDED;
        }
    }]);

    return CartDeliveryFeeController;
}();

CartDeliveryFeeController.$inject = ['$sce', 'Settings', 'ShopperService', 'TrolleyService', 'DeliveryPassService', 'DeliveryFeeService', 'DeliverySaverConstants'];

var cartDeliveryFeeComponentDefinition = {
    controller: CartDeliveryFeeController,
    template: __webpack_require__(153).trim()
};

module.exports = {
    CartDeliveryFeeController: CartDeliveryFeeController,
    cartDeliveryFeeComponentDefinition: cartDeliveryFeeComponentDefinition
};

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartDeliveryFee\">\r\n    <div class=\"cartDeliveryFee-row cartDeliveryFee-headerRow\">\r\n        <i class=\"iconww-DeliveryFee cartDeliveryFee-icon\"></i>\r\n        <button\r\n            class=\"text-left linkButton\"\r\n            role=\"button heading\"\r\n            aria-expanded=\"{{ $ctrl.showDeliveryFeeStructure }}\"\r\n            aria-controls=\"cartDeliveryFee-fees\"\r\n            ng-click=\"::$ctrl.toggleDeliveryFeeStructure()\"\r\n            ng-disabled=\"$ctrl.shopperService.IsGuest\">\r\n            {{ $ctrl.deliveryPassService.deliveryPassPrompt.HeaderText }}\r\n            <span ng-if=\"!$ctrl.shopperService.IsGuest\">\r\n                <span class=\"sr-only\">Show {{ $ctrl.deliveryPassService.deliveryPassPrompt.HeaderText }} thresholds</span>\r\n                <i ng-class=\"$ctrl.showDeliveryFeeStructure ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n            </span>\r\n        </button>\r\n        <div class=\"u-flexSpacer\"></div>\r\n        <wow-price\r\n            ng-if=\"!$ctrl.showDeliveryFeeStructure && $ctrl.trolleyService.deliveryFee > 0 && !$ctrl.trolleyService.ShouldRecieveFreeDeliveryRewardsPlus\"\r\n            price=\"$ctrl.trolleyService.deliveryFee\"\r\n            price-class-modifier=\"price--compact\">\r\n        </wow-price>\r\n        <div class=\"cartDeliveryFee-free\"\r\n            ng-if=\"!$ctrl.showDeliveryFeeStructure && $ctrl.trolleyService.ShouldRecieveFreeDeliveryRewardsPlus\">\r\n            FREE\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"cartDeliveryFee-row\" ng-if=\"$ctrl.showDeliveryFeeStructure\" role=\"region\">\r\n        <table class=\"cartDeliveryFee-feeTable\">\r\n            <caption class=\"sr-only\">{{ $ctrl.deliveryPassService.deliveryPassPrompt.HeaderText }} thresholds</caption>\r\n            <thead class=\"sr-only\">\r\n                <tr>\r\n                    <th>Order value</th>\r\n                    <th>Delivery Fee</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr class=\"cartDeliveryFee-feeRow\" ng-repeat=\"deliveryFeeRow in ::$ctrl.deliveryFeeStructure.DeliveryFeeStructureLevels\">\r\n                    <td>{{ ::deliveryFeeRow.OrderValue }}</td>\r\n                    <td class=\"cartDeliveryFee-feeCell\">{{ ::deliveryFeeRow.DeliveryFee }}</td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n        <hr class=\"cartDeliveryFee-divider\"/>\r\n        <p class=\"cartDeliveryFee-note\" ng-if=\"$ctrl.deliveryFeeStructure.ScheduleReservationDeliveryFeeNote\">{{\r\n            ::$ctrl.deliveryFeeStructure.ScheduleReservationDeliveryFeeNote\r\n        }}</p>\r\n    </div>\r\n\r\n    <div class=\"cartDeliveryFee-row\" ng-if=\"$ctrl.showDeliveryPassPrompt()\">\r\n        <p\r\n            class=\"cartDeliveryFee-blurb\"\r\n            ng-class=\"{ 'has-button': $ctrl.deliveryPassService.deliveryPassPrompt.PromptText }\"\r\n            ng-if=\"$ctrl.deliveryPassService.deliveryPassPrompt.ContentText\"\r\n            ng-bind-html=\"$ctrl.$sce.trustAsHtml($ctrl.deliveryPassService.deliveryPassPrompt.ContentText)\">\r\n        </p>\r\n        <a\r\n            class=\"button cartDeliveryFee-promptText\"\r\n            ng-href=\"{{ ::$ctrl.settings.deliveryPass.deliverySaverPageRedirectUrl }}\"\r\n            ng-if=\"$ctrl.deliveryPassService.deliveryPassPrompt.PromptText\">\r\n            {{ $ctrl.deliveryPassService.deliveryPassPrompt.PromptText }}\r\n        </a>\r\n    </div>\r\n\r\n    <div class=\"cartDeliveryFee-row\" ng-if=\"$ctrl.showDeliveryPlusSuspended()\">\r\n        <wow-cart-delivery-fee-notification\r\n            title=\"{{::$ctrl.settings.deliverySaver.suspendedNotificationTitle}}\"\r\n            message=\"{{::$ctrl.settings.deliverySaver.suspendedNotificationText}}\"\r\n            type=\"warning\"\r\n        ></wow-cart-delivery-fee-notification>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartDeliveryFeeNotificationController = function CartDeliveryFeeNotificationController($sce) {
    _classCallCheck(this, CartDeliveryFeeNotificationController);

    this.$sce = $sce;
};

CartDeliveryFeeNotificationController.$inject = ['$sce'];

var cartDeliveryFeeNotificationComponentDefinition = {
    controller: CartDeliveryFeeNotificationController,
    bindings: {
        type: '@', // Type of notification (string. error/info/warning/success)
        title: '@?', // Optional title for the notification. (string)
        message: '@?' // Message to the user regarding the notification (string - trusted HTML).
    },
    template: __webpack_require__(155).trim()
};

module.exports = {
    CartDeliveryFeeNotificationController: CartDeliveryFeeNotificationController,
    cartDeliveryFeeNotificationComponentDefinition: cartDeliveryFeeNotificationComponentDefinition
};

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cartDeliveryFeeNotification\">\r\n    <div class=\"cartDeliveryFeeNotification-iconContainer\">\r\n        <div class=\"cartDeliveryFeeNotification-icon cartDeliveryFeeNotification-icon--{{$ctrl.type}}\" alt=\"{{$ctrl.type}} icon\"></div>\r\n    </div>\r\n    <div class=\"cartDeliveryFeeNotification-content\">\r\n        <strong class=\"cartDeliveryFeeNotification-title\" ng-if=\"$ctrl.title\">{{$ctrl.title}}</strong>\r\n        <p class=\"cartDeliveryFeeNotification-message\" ng-if=\"$ctrl.message\" ng-bind-html=\"$ctrl.$sce.trustAsHtml($ctrl.message)\"></p>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartOrderManagementController = function () {
    function CartOrderManagementController(orderManagementService) {
        _classCallCheck(this, CartOrderManagementController);

        this.orderManagement = orderManagementService;
    }

    _createClass(CartOrderManagementController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.orderManagement.getTotalOrderCount().then(function (response) {
                _this.orderCount = response.OpenOrderCount;
            });
        }
    }]);

    return CartOrderManagementController;
}();

var cartOrderManagementComponentDefinition = {
    controller: ['OrderManagementService', CartOrderManagementController],
    template: __webpack_require__(157).trim()
};

module.exports = {
    CartOrderManagementController: CartOrderManagementController,
    cartOrderManagementComponentDefinition: cartOrderManagementComponentDefinition
};

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = "<a class=\"linkButton\"\r\n        ng-if=\"$ctrl.orderCount > 0\"\r\n        ui-sref=\"shop.myaccount.myorders\"\r\n        wow-event-recorder=\"click\"\r\n        data-er-category=\"Active Orders\"\r\n        data-er-label=\"You have x open orders\">\r\n    <span class=\"cartOrderManagement-linkText u-flexCenter\">\r\n        You have {{::$ctrl.orderCount}} open&nbsp;\r\n        <ng-pluralize\r\n            count=\"::$ctrl.orderCount\"\r\n            when=\"{'1': 'order', 'other': 'orders'}\">\r\n        </ng-pluralize>\r\n    </span>\r\n</a>\r\n"

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartFreeDeliveryRewardsPlusController = function () {
    function CartFreeDeliveryRewardsPlusController(currencyFilter, settings) {
        _classCallCheck(this, CartFreeDeliveryRewardsPlusController);

        this.currencyFilter = currencyFilter;
        this.settings = settings;
    }

    _createClass(CartFreeDeliveryRewardsPlusController, [{
        key: '$onInit',
        value: function $onInit() {
            this.buildDisplayPrice(this.price);
            this.buildMessage();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(change) {
            this.buildDisplayPrice(change.price.currentValue);
            this.buildMessage();
        }
    }, {
        key: 'buildDisplayPrice',
        value: function buildDisplayPrice(price) {
            if (price === undefined) {
                return;
            }
            this.formattedPrice = this.currencyFilter(price);
        }
    }, {
        key: 'buildMessage',
        value: function buildMessage() {
            this.messageParts = this.settings.everydayRewards.rewardsPlusFreeDeliveryMessage.split('{DeliveryFee}');
        }
    }]);

    return CartFreeDeliveryRewardsPlusController;
}();

var cartFreeDeliveryRewardsPlusComponentDefinition = {
    bindings: {
        price: '<'
    },
    controller: ['currencyFilter', 'Settings', CartFreeDeliveryRewardsPlusController],
    template: __webpack_require__(159).trim()
};

module.exports = {
    CartFreeDeliveryRewardsPlusController: CartFreeDeliveryRewardsPlusController,
    cartFreeDeliveryRewardsPlusComponentDefinition: cartFreeDeliveryRewardsPlusComponentDefinition
};

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rewardsplus-container\">\r\n    <div class=\"rewardsplus-iconContainer\">\r\n        <img src=\"/images/trolley/icon-rewards-wow-logo.svg\">\r\n    </div>\r\n    <div class=\"rewardsplus-textContainer\">\r\n        <span class=\"rewardsplus-title\">{{ $ctrl.settings.everydayRewards.rewardsMembershipAppliedMessage }}</span><br>\r\n        <span class=\"rewardsplus-content\">{{ $ctrl.messageParts[0] }}<strong>{{ $ctrl.formattedPrice }}</strong>{{ $ctrl.messageParts[1] }}</span>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartBonusPointsRewardsPlusController = function () {
    function CartBonusPointsRewardsPlusController(trolleyService, settings) {
        _classCallCheck(this, CartBonusPointsRewardsPlusController);

        this.trolleyService = trolleyService;
        this.settings = settings;
    }

    _createClass(CartBonusPointsRewardsPlusController, [{
        key: '$onInit',
        value: function $onInit() {
            this.setMessage();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges() {
            this.setMessage();
        }
    }, {
        key: 'setMessage',
        value: function setMessage() {
            this.renderMessage = this.trolleyService.RewardsPlusBonusPointsMessage;
        }
    }]);

    return CartBonusPointsRewardsPlusController;
}();

var cartBonusPointsRewardsPlusComponentDefinition = {
    bindings: {
        price: '<'
    },
    controller: ['TrolleyService', 'Settings', CartBonusPointsRewardsPlusController],
    template: __webpack_require__(161).trim()
};

module.exports = {
    cartBonusPointsRewardsPlusComponentDefinition: cartBonusPointsRewardsPlusComponentDefinition,
    CartBonusPointsRewardsPlusController: CartBonusPointsRewardsPlusController
};

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rewardsplus-bonus-points-container\">\r\n    <div class=\"rewardsplus-iconContainer\">\r\n        <img src=\"/images/trolley/icon-rewards-wow-logo.svg\">\r\n    </div>\r\n    <div class=\"rewardsplus-textContainer\">\r\n        <span class=\"rewardsplus-title\">{{ $ctrl.settings.everydayRewards.rewardsMembershipAppliedMessage }}</span><br>\r\n        <span class=\"rewardsplus-bonus-points-content\" ng-bind-html=\"$ctrl.renderMessage\"></span>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var CategoriesService = __webpack_require__(163);
var wowCategorySref = __webpack_require__(164);

angular.module('wowApp.shop').service('CategoriesService', CategoriesService).directive('wowCategorySref', ['$state', '$timeout', 'CategoriesService', wowCategorySref]).component('wowCategoriesNavigation', __webpack_require__(165).categoriesNavigationComponentDefinition);

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    concat = _require.concat,
    minBy = _require.minBy,
    filter = _require.filter,
    head = _require.head,
    find = _require.find;

var _require2 = __webpack_require__(27),
    categoryLevels = _require2.categoryLevels;

var CategorySelectionList = __webpack_require__(35);

var CategoryService = function () {
    function CategoryService($q, $state, restangular, bootstrap) {
        _classCallCheck(this, CategoryService);

        this.bootstrap = bootstrap;
        this._api = restangular.all('PiesCategoriesWithSpecials');
        this.categoriesPromise = null;
        this.currentCategories = new CategorySelectionList();
        this.rootCategory = { Children: [] };
        this.$state = $state;

        if (this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.Categories)) {
            this.categoriesPromise = $q.when(this.setupCategories(this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.Categories)));
        } else if (this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.RootCategories)) {
            this.setupCategories(this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.RootCategories));
        }
    }

    _createClass(CategoryService, [{
        key: 'getAll',
        value: function getAll() {
            var _this = this;

            if (!this.categoriesPromise) {
                this.categoriesPromise = this._api.one('').get().then(function (res) {
                    return _this.setupCategories(res);
                });
            }

            return this.categoriesPromise;
        }
    }, {
        key: 'setupCategories',
        value: function setupCategories(res) {
            this.rootCategory = { Children: res.Categories };
            this.categoriesLookup = this._buildCategoriesLookup(res.Categories);
            return res.Categories;
        }
    }, {
        key: 'getById',
        value: function getById(categoryNodeId) {
            return this.categoriesLookup[categoryNodeId];
        }
    }, {
        key: '_buildCategoriesLookup',
        value: function _buildCategoriesLookup(categories) {
            var categoriesLookup = {};
            var remainingCategories = [].concat(_toConsumableArray(categories));

            while (remainingCategories.length) {
                var category = remainingCategories.pop();
                if (!categoriesLookup[category.NodeId]) {
                    categoriesLookup[category.NodeId] = category;
                }
                if (category.Children) {
                    remainingCategories = concat(remainingCategories, category.Children);
                }
            }

            return categoriesLookup;
        }
    }, {
        key: 'getCategoryTree',
        value: function getCategoryTree(categoryId) {
            var tree = [];
            var category = this.getById(categoryId);

            while (category) {
                tree.unshift(category);
                category = this.getById(category.ParentNodeId);
            }

            return tree;
        }
    }, {
        key: 'getCategoryStateInfo',
        value: function getCategoryStateInfo(nodeId) {
            var state = 'shop.browse';
            var params = {};
            var tree = this.getCategoryTree(nodeId);

            for (var i = 0; i < tree.length; ++i) {
                state += '.' + categoryLevels[i];
                params[categoryLevels[i]] = tree[i].UrlFriendlyName;
            }

            return { state: state, params: params };
        }
    }, {
        key: 'getCategorySref',
        value: function getCategorySref(nodeId) {
            var _getCategoryStateInfo = this.getCategoryStateInfo(nodeId),
                state = _getCategoryStateInfo.state,
                params = _getCategoryStateInfo.params;

            return state + '(' + JSON.stringify(params) + ')';
        }
    }, {
        key: 'getSpecialCategory',
        value: function getSpecialCategory(category) {
            return category.IsSpecial ? category : head(filter(category.Children, function (c) {
                return c.IsSpecial;
            }));
        }
    }, {
        key: 'getBundleCategory',
        value: function getBundleCategory(category) {
            return category.IsBundle ? category : head(filter(category.Children, function (c) {
                return c.IsBundle;
            }));
        }
    }, {
        key: 'getFirstSpecialCategory',
        value: function getFirstSpecialCategory(departmentCategory) {
            if (!departmentCategory.Children) return undefined;
            // get the first category in order in the department children
            var firstCategoryInDepartment = minBy(filter(departmentCategory.Children, function (category) {
                return !category.NodeId.match('_SPECIALS');
            }), function (category) {
                return category.DisplayOrder;
            });
            // get the first special category in firstCategoryInDepartment.
            if (firstCategoryInDepartment) {
                return this.getSpecialCategory(firstCategoryInDepartment);
            }

            return undefined;
        }
    }, {
        key: '_findNodeByNodeId',
        value: function _findNodeByNodeId(categoryTree, nodeId) {
            return find(categoryTree, function (categoryNode) {
                return categoryNode.NodeId === nodeId;
            });
        }
    }, {
        key: '_getCategoryPathToRoot',
        value: function _getCategoryPathToRoot(categoryTree, baseNodeId) {
            var links = [];
            var currentNode = find(categoryTree, function (categoryNode) {
                return categoryNode.NodeId === baseNodeId;
            });
            links.unshift({ text: currentNode.Description });
            while (currentNode.ParentNodeId !== null) {
                var parentNode = this._findNodeByNodeId(categoryTree, currentNode.ParentNodeId);
                var categoryState = this.getCategoryStateInfo(parentNode.NodeId);

                links.unshift({ text: parentNode.Description, url: this.$state.href(categoryState.state, categoryState.params, { inherit: false }) });
                currentNode = parentNode;
            }
            links.unshift({ text: 'Home', url: '/' });
            return links;
        }
    }, {
        key: 'getCategoryPathToToRootByNodeId',
        value: function getCategoryPathToToRootByNodeId(nodeId) {
            var categoryTree = this.getCategoryTree(nodeId);
            return this._getCategoryPathToRoot(categoryTree, nodeId);
        }
    }, {
        key: 'currentCategory',
        get: function get() {
            return this.currentCategories.current;
        }
    }]);

    return CategoryService;
}();

CategoryService.$inject = ['$q', '$state', 'Restangular', 'BootstrapService'];

module.exports = CategoryService;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($state, $timeout, categoriesService) {
    return {
        link: function link(scope, elem, attr) {
            var activeClasses = attr.uiSrefActive || attr.uiSrefActiveEq || '';
            var activeEq = !!attr.uiSrefActiveEq;
            var options = scope.$eval(attr.uiSrefOpts);
            var category = scope.$eval(attr.wowCategorySref);

            var stateInfo = void 0;

            function updateClasses() {
                if (!category || !activeClasses) {
                    return;
                }

                var isActive = activeEq ? categoriesService.currentCategories.current && categoriesService.currentCategories.current.NodeId === category.NodeId : categoriesService.currentCategories.isActive(category.NodeId);

                elem.toggleClass(activeClasses, isActive);
            }

            elem.on('click', function (e) {
                var button = e.which || e.button;
                if (stateInfo && !(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || elem.attr('target'))) {
                    // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
                    var transition = $timeout(function () {
                        return $state.go(stateInfo.state, stateInfo.params, options);
                    });
                    e.preventDefault();
                    e.preventDefault = function () {
                        return $timeout.cancel(transition);
                    };
                }
            });

            scope.$watch(attr.wowCategorySref, function (value) {
                category = value;

                if (!category) {
                    attr.href = undefined;
                    stateInfo = null;
                    return;
                }

                stateInfo = categoriesService.getCategoryStateInfo(category.NodeId);
                elem.attr('href', category ? $state.href(stateInfo.state, stateInfo.params, options) : undefined);

                updateClasses();
            });

            scope.$on('$stateChangeSuccess', function () {
                updateClasses();
            });
        }
    };
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find;

var CategoriesNavigationController = function () {
    function CategoriesNavigationController($element, categoriesService, analyticsService) {
        _classCallCheck(this, CategoriesNavigationController);

        this.$element = $element;
        this.categoriesService = categoriesService;
        this.analyticsService = analyticsService;
    }

    _createClass(CategoriesNavigationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.classModifierName = this.classModifier ? 'categoriesNavigation--' + this.classModifier : '';
        }
    }, {
        key: '$onChanges',
        value: function $onChanges() {
            this.specialCategory = this.getSpecialChild();
            this.bundleCategory = this.getBundleChild();
        }
    }, {
        key: 'selectCategory',
        value: function selectCategory(event, category) {
            if (this.onSelect) {
                this.onSelect({ event: event, category: category });
            }
        }
    }, {
        key: 'isCurrentCategory',
        value: function isCurrentCategory(category) {
            var currentCategory = this.categoriesService.currentCategories.current;

            return category && currentCategory && currentCategory.NodeId === category.NodeId;
        }
    }, {
        key: 'isActiveCategory',
        value: function isActiveCategory(category) {
            if (!category) {
                return false;
            }
            return this.selected ? this.selected.NodeId === category.NodeId : this.categoriesService.currentCategories.isActive(category.NodeId);
        }
    }, {
        key: 'getSpecialChild',
        value: function getSpecialChild() {
            if (!(this.category && this.category.Children)) {
                return null;
            }

            if (!this.category.IsSpecial) {
                return find(this.category.Children, function (c) {
                    return c.IsSpecial;
                });
            }

            return null;
        }
    }, {
        key: 'getBundleChild',
        value: function getBundleChild() {
            if (!(this.category && this.category.Children)) {
                return null;
            }

            return find(this.category.Children, function (c) {
                return c.IsBundle;
            });
        }
    }, {
        key: 'shouldDisplay',
        value: function shouldDisplay(canShow) {
            return canShow && this.category && this.category.NodeLevel;
        }
    }, {
        key: 'pushDataToAnalyticsService',
        value: function pushDataToAnalyticsService() {
            this.analyticsService.push({
                data: {
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.menuClick
            });
        }
    }]);

    return CategoriesNavigationController;
}();

/**
 * @ngdoc component
 * @name wowCategoriesNavigation
 *
 * Component which generates a list of navigation links from a given category.
 *
 * @param [classModifier] {string} Custom style class name.
 * @param [category] {Object} Category to render nav items for.
 * @param [selected] {Boolean} Is this category currently selected. Used for styling.
 * @param [shouldShowShowAll] {Boolean} Controls display of show all link.
 * @param [shouldShowSpecials] {Boolean} Controls display of specials link.
 * @param [shouldShowBundles] {Boolean} Controls display of bundles link.
 * @param [shouldShowSeparator] {Boolean} Controls display of a separator element.
 * @param [shouldShowArrow] {Boolean} Determine whether the arrow icon should show at the end of elements.
 * @param [onSelect] {Function} Custom callback function to fire when a link is clicked by the user. If not set, default is to navigate to the categories page.
 */


var categoriesNavigationComponentDefinition = {
    transclude: true,
    bindings: {
        classModifier: '@?',
        category: '<?',
        selected: '<?',
        shouldShowShowAll: '<?',
        shouldShowSpecials: '<?',
        shouldShowBundles: '<?',
        shouldShowSeparator: '<?',
        shouldShowArrow: '<?',
        onSelect: '&?'
    },
    controller: ['$element', 'CategoriesService', 'AnalyticsService', CategoriesNavigationController],
    template: __webpack_require__(166).trim()
};

module.exports = {
    CategoriesNavigationController: CategoriesNavigationController,
    categoriesNavigationComponentDefinition: categoriesNavigationComponentDefinition
};

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"categoriesNavigation\" ng-class=\"::$ctrl.classModifierName\" aria-label=\"Categories\">\r\n    <ng-transclude></ng-transclude>\r\n    <ul class=\"categoriesNavigation-list\">\r\n        <li>\r\n            <a class=\"categoriesNavigation-link categoriesNavigation-linkShowall\"\r\n                ng-if=\"$ctrl.shouldDisplay($ctrl.shouldShowShowAll)\"\r\n                ng-class=\"{ 'is-active': $ctrl.isCurrentCategory($ctrl.category) }\"\r\n                ng-click=\"$ctrl.pushDataToAnalyticsService()\"\r\n                wow-category-sref=\"$ctrl.category\"\r\n                ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n                <span class=\"categoriesNavigation-linkText\">\r\n                    <span>Show All <span class=\"categoriesNavigation-linkShowAllDescription\">{{ $ctrl.category.Description }}</span></span>&nbsp;<i class=\"categoriesNavigation-linkArrow iconww-ArrowRight\" ng-if=\"::$ctrl.shouldShowArrow\" aria-hidden=\"true\"></i>\r\n                </span>\r\n            </a>\r\n        </li>\r\n        <li>\r\n            <a class=\"categoriesNavigation-link is-special\"\r\n                ng-if=\"$ctrl.specialCategory && $ctrl.shouldDisplay($ctrl.shouldShowSpecials)\"\r\n                ng-class=\"{ 'is-active': $ctrl.isCurrentCategory($ctrl.specialCategory) }\"\r\n                ng-click=\"$ctrl.pushDataToAnalyticsService()\"\r\n                wow-category-sref=\"$ctrl.specialCategory\"\r\n                ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n                <span class=\"categoriesNavigation-linkText\">\r\n                    {{ $ctrl.specialCategory.Description }}&nbsp;<i class=\"categoriesNavigation-linkArrow iconww-ArrowRight\" ng-if=\"::$ctrl.shouldShowArrow\" aria-hidden=\"true\"></i>\r\n                </span>\r\n            </a>\r\n        </li>\r\n        <li>\r\n            <a class=\"categoriesNavigation-link\"\r\n                ng-if=\"$ctrl.bundleCategory && $ctrl.shouldDisplay($ctrl.shouldShowBundles)\"\r\n                ng-class=\"{ 'is-active': $ctrl.isCurrentCategory($ctrl.bundleCategory) }\"\r\n                ng-click=\"$ctrl.pushDataToAnalyticsService()\"\r\n                wow-category-sref=\"$ctrl.bundleCategory\"\r\n                ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n                <span class=\"categoriesNavigation-linkText\">\r\n                    {{ $ctrl.bundleCategory.Description }}&nbsp;<i class=\"categoriesNavigation-linkArrow iconww-ArrowRight\" ng-if=\"::$ctrl.shouldShowArrow\" aria-hidden=\"true\"></i>\r\n                </span>\r\n            </a>\r\n        </li>\r\n\r\n        <hr class=\"categoriesNavigation-linkSeparator\" ng-if=\"$ctrl.shouldDisplay($ctrl.shouldShowSeparator)\"></hr>\r\n\r\n        <li ng-repeat=\"category in $ctrl.category.Children | filter:{IsSpecial:$ctrl.category.IsSpecial} | filter:{IsBundle:$ctrl.category.IsBundle} track by category.NodeId\">\r\n            <a class=\"categoriesNavigation-link\"\r\n                ng-class=\"{ 'is-active': $ctrl.isActiveCategory(category), 'is-special': category.IsSpecial && !$ctrl.category.IsSpecial, 'is-bundle': $ctrl.category.IsBundle && !$ctrl.category.IsBundle }\"\r\n                ng-click=\"$ctrl.selectCategory($event, category); $ctrl.pushDataToAnalyticsService()\"\r\n                wow-category-sref=\"::category\"\r\n                ui-sref-opts=\"{ reload: true, inherit: false }\"\r\n                oly-hover-menu-action=\"$ctrl.selectCategory(event, category)\">\r\n                <span class=\"categoriesNavigation-linkText\">\r\n                    {{ ::category.Description }}&nbsp;<i class=\"categoriesNavigation-linkArrow iconww-ArrowRight\" ng-if=\"::$ctrl.shouldShowArrow\" aria-hidden=\"true\"></i>\r\n                </span>\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</nav>\r\n"

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('wowApp.shop').component('wowDynamicSuburbDialog', __webpack_require__(168)).component('wowDynamicSuburbDialogContent', __webpack_require__(170));

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DynamicSuburbDialogController = function DynamicSuburbDialogController() {
    _classCallCheck(this, DynamicSuburbDialogController);
};

module.exports = {
    template: __webpack_require__(169).trim(),
    controller: [DynamicSuburbDialogController]
};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = "<dialog name=\"dynamicSuburb-dialog\" id=\"_dynamicSuburbDialog\" class=\"olyDialog dynamicSuburbDialog\">\r\n    <div class=\"dynamicSuburbDialog-content\">\r\n        <button class=\"dynamicSuburbDialog-buttonClose\" oly-dialog-close>\r\n            <div oly-analytics-on-click=\"dynamic suburbs popup ignored - no window selected\">\r\n                <span class=\"sr-only\">close dialog</span>\r\n                <i class=\"icon-close_x\"></i>\r\n            </div>\r\n        </button>\r\n        <wow-dynamic-suburb-dialog-content></wow-dynamic-suburb-dialog-content>\r\n    </div>\r\n</dialog>\r\n"

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    replace = _require.replace;

var DynamicSuburbDialogContentController = function () {
    function DynamicSuburbDialogContentController(fulfilmentService, settings, shopperService, moveFocus, analytics) {
        _classCallCheck(this, DynamicSuburbDialogContentController);

        this.fulfilmentService = fulfilmentService;
        this.analytics = analytics;

        this.description = replace(settings.deliveryWindows.dynamicSuburbMessageDescription, '{Name}', shopperService.IsGuest ? '' : shopperService.shopper.FirstName);
    }

    _createClass(DynamicSuburbDialogContentController, [{
        key: '$onInit',
        value: function $onInit() {
            this.dialogCtrl.show();
        }
    }, {
        key: 'onTimeSelect',
        value: function onTimeSelect() {
            this.fireEventAndCloseDialog('dynamic suburbs popup acknowledged - window selected');
        }
    }, {
        key: 'onDecideLater',
        value: function onDecideLater() {
            this.fireEventAndCloseDialog('dynamic suburbs popup ignored - no window selected');
        }
    }, {
        key: 'fireEventAndCloseDialog',
        value: function fireEventAndCloseDialog(eventFired) {
            this.analytics.pushEvent(eventFired);
            this.closeDialog();
        }
    }, {
        key: 'closeDialog',
        value: function closeDialog() {
            this.dialogCtrl.close();
        }
    }]);

    return DynamicSuburbDialogContentController;
}();

module.exports = {
    template: __webpack_require__(171).trim(),
    require: { dialogCtrl: '^dialog' },
    controller: ['FulfilmentService', 'Settings', 'ShopperService', 'MoveFocus', 'AnalyticsService', DynamicSuburbDialogContentController]
};

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = "<div class=\"olyDialog-scrollableArea dynamicSuburbDialog-scrollableArea\">\r\n    <div class=\"dynamicSuburbDialog-header\">\r\n        <img src=\"/images/dynamicsuburb/img_dynamicsuburb_truck.svg\" class=\"dynamicSuburbDialog-headerIcon\" />\r\n        <h2 class=\"dynamicSuburbDialog-headerText\" wow-html-setting setting-group=\"DeliveryWindows\" setting-name=\"DynamicSuburbMessageHeader\"></h2>\r\n    </div>\r\n    <div class=\"dynamicSuburbDialog-textWrapper\">\r\n        <p class=\"dynamicSuburbDialog-description\" ng-bind-html=\"$ctrl.description | sanitize\"></p>\r\n        \r\n        <wow-fulfilment-method-wizard\r\n            should-show-billing=\"false\"\r\n            allow-decide-later=\"true\"\r\n            should-get-dynamic-timetable=\"true\">\r\n        </wow-fulfilment-method-wizard>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(173),
    headerComponentDefinition = _require.headerComponentDefinition;

var _require2 = __webpack_require__(175),
    corporateHeaderComponentDefinition = _require2.corporateHeaderComponentDefinition;

var _require3 = __webpack_require__(177),
    coreHeaderComponentDefinition = _require3.coreHeaderComponentDefinition;

var _require4 = __webpack_require__(179),
    coreHeaderNavComponentDefinition = _require4.coreHeaderNavComponentDefinition;

var _require5 = __webpack_require__(181),
    headerSearchComponentDefinition = _require5.headerSearchComponentDefinition;

var _require6 = __webpack_require__(183),
    headerCheckoutComponentDefinition = _require6.headerCheckoutComponentDefinition;

var _require7 = __webpack_require__(185),
    headerSkipLinksComponentDefinition = _require7.headerSkipLinksComponentDefinition;

var _require8 = __webpack_require__(187),
    categoryHeaderComponentDefinition = _require8.categoryHeaderComponentDefinition;

var _require9 = __webpack_require__(189),
    categoryHeaderSmallFormatComponentDefinition = _require9.categoryHeaderSmallFormatComponentDefinition;

var _require10 = __webpack_require__(191),
    categoryHeaderBannersComponentDefinition = _require10.categoryHeaderBannersComponentDefinition;

angular.module('wowApp.shop').component('wowHeader', headerComponentDefinition).component('wowCorporateHeader', corporateHeaderComponentDefinition).component('wowCoreHeader', coreHeaderComponentDefinition).component('wowCoreHeaderNav', coreHeaderNavComponentDefinition).component('wowHeaderSearch', headerSearchComponentDefinition).component('wowHeaderCheckout', headerCheckoutComponentDefinition).component('wowHeaderSkipLinks', headerSkipLinksComponentDefinition).component('wowCategoryHeader', categoryHeaderComponentDefinition).component('wowCategoryHeaderSmallFormat', categoryHeaderSmallFormatComponentDefinition).component('wowCategoryHeaderBanners', categoryHeaderBannersComponentDefinition);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeaderController = function HeaderController($breakpoints) {
    _classCallCheck(this, HeaderController);

    this.$breakpoints = $breakpoints;
};

var headerComponentDefinition = {
    controller: ['BreakpointsService', HeaderController],
    template: __webpack_require__(174).trim()
};

module.exports = {
    HeaderController: HeaderController,
    headerComponentDefinition: headerComponentDefinition
};

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = "<wow-header-skip-links></wow-header-skip-links>\r\n<wow-corporate-header class=\"hidden-xs\" class-modifier=\"corporateHeader--horizontal\"></wow-corporate-header>\r\n<wow-core-header></wow-core-header>\r\n<wow-category-header ng-if=\"!$ctrl.$breakpoints.isInSmallFormat && !$ctrl.$breakpoints.isInMediumFormatPortrait\" class-modifier=\"categoryHeader--horizontal\"></wow-category-header>\r\n<wow-category-header-small-format ng-if=\"$ctrl.$breakpoints.isInSmallFormat || $ctrl.$breakpoints.isInMediumFormatPortrait \"></wow-category-header-small-format>\r\n<wow-small-menu ng-if=\"$ctrl.$breakpoints.isInSmallFormat\"></wow-small-menu>\r\n"

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0);

var CorporateHeaderController = function () {
    function CorporateHeaderController($window, $state, analyticsService, settings) {
        _classCallCheck(this, CorporateHeaderController);

        this.$window = $window;
        this.$state = $state;
        this.analyticsService = analyticsService;
        this.settings = settings;
    }

    /**
     * The shopping link is active at all times EXCEPT for when we
     * are on store locator OR the rewards page in Discover.
     *
     * @returns {boolean}
     *
     * @memberOf CorporateHeaderController
     */


    _createClass(CorporateHeaderController, [{
        key: 'isShoppingActive',
        value: function isShoppingActive() {
            var _this = this;

            var exceptStates = [{ state: 'shop.locator' }, { state: 'shop.inspiration.parent', params: { parent: 'woolworths-rewards' } }];

            return !_.some(exceptStates, function (s) {
                return _this.$state.is(s.state, s.params);
            }) && !this.isBusinessActive();
        }
    }, {
        key: 'pushToAnalytics',
        value: function pushToAnalytics(eventValue, eventLabel) {
            this.analyticsService.push({
                data: {
                    event: {
                        category: 'Header',
                        value: eventValue,
                        label: eventLabel
                    },
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.linkClick
            });
        }
    }, {
        key: 'navigateToBusiness',
        value: function navigateToBusiness() {
            this.$window.location = '/business/accountmanagement';
        }
    }, {
        key: 'isBusinessActive',
        value: function isBusinessActive() {
            return this.$window.location.pathname.includes('business');
        }
    }]);

    return CorporateHeaderController;
}();

var corporateHeaderComponentDefinition = {
    bindings: {
        classModifier: '@?'
    },
    controller: ['$window', '$state', 'AnalyticsService', 'Settings', CorporateHeaderController],
    template: __webpack_require__(176).trim()
};

module.exports = {
    corporateHeaderComponentDefinition: corporateHeaderComponentDefinition,
    CorporateHeaderController: CorporateHeaderController
};

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = "<nav aria-label=\"Corporate\">\r\n    <ul class=\"corporateHeader\" ng-class=\"$ctrl.classModifier\">\r\n        <li>\r\n            <a class=\"corporateHeader-link corporateHeader-link--shopping\"\r\n                href=\"/\" ng-class=\"{'is-active': $ctrl.isShoppingActive()}\" target=\"_self\"\r\n                ng-click=\"$ctrl.pushToAnalytics($ctrl.$window.location.origin, 'Shopping')\">\r\n                Shopping\r\n                <i class=\"corporateHeader-activeLinkIcon iconww-ArrowDown\" aria-hidden=\"true\"></i>\r\n            </a>\r\n        </li>\r\n        <li ng-if=\"$ctrl.settings.business.enableBusiness\">\r\n            <a class=\"corporateHeader-link\"\r\n                href=\"javascript:;\"\r\n                ng-class=\"{'is-active': $ctrl.isBusinessActive()}\"\r\n                ng-click=\"$ctrl.navigateToBusiness()\">\r\n                Business\r\n                <i class=\"corporateHeader-activeLinkIcon iconww-ArrowDown\" aria-hidden=\"true\"></i>\r\n            </a>\r\n        </li>\r\n        <li>\r\n            <a class=\"corporateHeader-link\"\r\n                ui-sref=\"shop.locator\"\r\n                ui-sref-opts=\"{reload: true}\"\r\n                ng-class=\"{'is-active': ('shop.stores' | includedByState)}\"\r\n                ng-click=\"$ctrl.pushToAnalytics('/shop/storelocator/', 'Stores')\">\r\n                <i class=\"corporateHeader-icon iconww-Supermarkets\" aria-hidden=\"true\"></i>\r\n                Stores\r\n                <i class=\"corporateHeader-activeLinkIcon iconww-ArrowDown\" aria-hidden=\"true\"></i>\r\n            </a>\r\n        </li>\r\n        <li>\r\n            <a class=\"corporateHeader-link\"\r\n                href=\"https://insurance.woolworths.com.au/\" target=\"_blank\"\r\n                ng-click=\"$ctrl.pushToAnalytics('https://insurance.woolworths.com.au/', 'Insurance')\">\r\n                <i class=\"corporateHeader-icon iconww-Insurance\" aria-hidden=\"true\"></i>\r\n                Insurance\r\n                <i class=\"corporateHeader-linkNewWindowIcon iconww-NewWindow\" aria-hidden=\"true\"></i>\r\n            </a>\r\n        </li>\r\n        <li>\r\n            <a class=\"corporateHeader-link\"\r\n                href=\"https://mobile.woolworths.com.au/\"  target=\"_blank\"\r\n                ng-click=\"$ctrl.pushToAnalytics('https://mobile.woolworths.com.au/', 'Mobile')\">\r\n                <i class=\"corporateHeader-icon iconww-Mobile\" aria-hidden=\"true\"></i>\r\n                Mobile\r\n                <i class=\"corporateHeader-linkNewWindowIcon iconww-NewWindow\" aria-hidden=\"true\"></i>\r\n            </a>\r\n        </li>\r\n        <li>\r\n            <a class=\"corporateHeader-link\"\r\n                href=\"https://cards.woolworths.com.au\" target=\"_blank\"\r\n                ng-click=\"$ctrl.pushToAnalytics('https://cards.woolworths.com.au/', 'Credit Cards')\">\r\n                <i class=\"corporateHeader-icon iconww-Money\" aria-hidden=\"true\"></i>\r\n                Credit Cards\r\n                <i class=\"corporateHeader-linkNewWindowIcon iconww-NewWindow\" aria-hidden=\"true\"></i>\r\n            </a>\r\n        </li>\r\n        <li>\r\n            <a class=\"corporateHeader-link\"\r\n                href=\"https://www.woolworthsrewards.com.au/\" target=\"_blank\"\r\n                ng-click=\"$ctrl.pushToAnalytics('https://www.woolworthsrewards.com.au/', 'Rewards')\">\r\n                <i class=\"corporateHeader-icon iconww-RewardPointsEarned\" aria-hidden=\"true\"></i>\r\n                Rewards\r\n                <i class=\"corporateHeader-linkNewWindowIcon iconww-NewWindow\" aria-hidden=\"true\"></i>\r\n            </a>\r\n        </li>\r\n        <li>\r\n            <a class=\"corporateHeader-link\"\r\n                href=\"https://cards.woolworths.com.au/woolworths-gift-cards.html\" target=\"_blank\"\r\n                ng-click=\"$ctrl.pushToAnalytics('https://cards.woolworths.com.au/woolworths-gift-cards.html', 'Gift Cards')\">\r\n                <i class=\"corporateHeader-icon iconww-GiftCards\" aria-hidden=\"true\"></i>\r\n                Gift Cards\r\n                <i class=\"corporateHeader-linkNewWindowIcon iconww-NewWindow\" aria-hidden=\"true\"></i>\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</nav>\r\n"

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CoreHeaderController = function () {
    function CoreHeaderController($window, shopperService, shopPageStateService, moveFocus, analyticsService) {
        _classCallCheck(this, CoreHeaderController);

        this.$window = $window;
        this.shopperService = shopperService;
        this.shopPageStateService = shopPageStateService;
        this.moveFocus = moveFocus;
        this.analyticsService = analyticsService;
    }

    _createClass(CoreHeaderController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sfSearchActive = false;
        }
    }, {
        key: 'isMenuOpen',
        value: function isMenuOpen() {
            return this.shopPageStateService.smallFormatMenuOpen;
        }
    }, {
        key: 'toggleOffscreenMenu',
        value: function toggleOffscreenMenu() {
            var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.shopPageStateService.smallFormatMenuOpen;

            this.shopPageStateService.smallFormatMenuOpen = isOpen;

            if (this.shopPageStateService.smallFormatMenuOpen) {
                this.moveFocus('#smallMenu');
            }
        }
    }, {
        key: 'hideMenu',
        value: function hideMenu() {
            if (this.isMenuOpen()) {
                this.toggleOffscreenMenu();
            }
        }
    }, {
        key: 'pushToAnalytics',
        value: function pushToAnalytics() {
            this.analyticsService.push({
                data: {
                    event: {
                        category: 'HomePageIcon',
                        value: this.$window.location.origin,
                        label: 'homepage icon'
                    },
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.linkClick
            });
        }
    }]);

    return CoreHeaderController;
}();

var coreHeaderComponentDefinition = {
    controller: ['$window', 'ShopperService', 'ShopPageStateService', 'MoveFocus', 'AnalyticsService', CoreHeaderController],
    template: __webpack_require__(178).trim()
};

module.exports = {
    CoreHeaderController: CoreHeaderController,
    coreHeaderComponentDefinition: coreHeaderComponentDefinition
};

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = "<header class=\"coreHeader\" oly-sticky=\"'.corporateHeader--horizontal'\">\r\n    <button\r\n        type=\"button\"\r\n        class=\"coreHeader-offscreenToggle visible-xs\"\r\n        ng-class=\"{'is-open': $ctrl.isMenuOpen()}\"\r\n        ng-click=\"$ctrl.toggleOffscreenMenu()\"\r\n        aria-haspopup=\"menu\">\r\n\r\n        <div class=\"coreHeader-offscreenToggleContent\">\r\n            <i class=\"coreHeader-offscreenToggleIcon\" ng-class=\"$ctrl.isMenuOpen() ? 'iconww-Cross' : 'iconww-Menu'\"></i>\r\n            {{ $ctrl.isMenuOpen() ? 'Close' : 'Menu' }}\r\n        </div>\r\n    </button>\r\n\r\n    <div class=\"coreHeader-verticalSeparator visible-xs\"></div>\r\n\r\n    <a href=\"/\" class=\"coreHeader-logoWrapper\" ng-click=\"$ctrl.pushToAnalytics()\">\r\n        <img class=\"coreHeader-logo\" src=\"/Images/GlobalHeader/icon-header-logo.png\" alt=\"Woolworths Online Home\">\r\n    </a>\r\n\r\n    <div class=\"coreHeader-verticalSeparator hidden-xs\"></div>\r\n\r\n    <wow-core-header-nav class=\"hidden-xs coreHeader-nav\" class-modifier=\"coreHeaderNav--horizontal\"></wow-core-header-nav>\r\n\r\n    <span class=\"u-flexSpacer visible-xs\"></span>\r\n\r\n    <wow-header-search class=\"coreHeader-searchPanel\" sf-search-active=\"$ctrl.sfSearchActive\" search-toggled-on=\"$ctrl.hideMenu()\"></wow-header-search>\r\n\r\n    <a ui-sref=\"shop.authentication.login\" ui-sref-opts=\"{reload: true}\" ng-if=\"$ctrl.shopperService.IsGuest\" class=\"coreHeader-profile hidden-xs\">\r\n        <span class=\"sr-only\">Log in or sign up.</span>\r\n        <i class=\"iconww-Profile\"></i>\r\n    </a>\r\n\r\n    <a ui-sref=\"shop.myaccount.details\" ui-sref-opts=\"{reload: true}\" ng-if=\"!$ctrl.shopperService.IsGuest\" class=\"coreHeader-profile is-loggedIn hidden-xs\">\r\n        <span class=\"sr-only\">Visit your account settings.</span>\r\n        <i class=\"iconww-Profile\"></i>\r\n    </a>\r\n\r\n    <wow-header-checkout class=\"coreHeader-checkout\"></wow-header-checkout>\r\n</header>\r\n"

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CoreHeaderNavController = function () {
    function CoreHeaderNavController(shopperService, analyticsService, settingsService, $rootScope, $location) {
        var _this = this;

        _classCallCheck(this, CoreHeaderNavController);

        this.shopperService = shopperService;
        this.analyticsService = analyticsService;
        this.settings = settingsService.settings;
        this.isReorder = false;
        this.isMyList = false;

        //  As part of quick reorder experiment
        $rootScope.$on('$locationChangeStart', function (event, next) {
            _this.updateReorderStatus(next);
        });

        this.updateReorderStatus($location.path());
        //  As part of quick reorder experiment end
    }

    //  As part of quick reorder experiment


    _createClass(CoreHeaderNavController, [{
        key: 'updateReorderStatus',
        value: function updateReorderStatus(currentUrl) {
            this.isReorder = currentUrl.indexOf('/mylists/reorder') >= 0;
            this.isMyList = currentUrl.indexOf('/mylists') >= 0 && !this.isReorder;
        }
    }, {
        key: 'pushDataToAnalyticsService',
        value: function pushDataToAnalyticsService() {
            this.analyticsService.push({
                data: {
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.menuClick
            });
        }
    }]);

    return CoreHeaderNavController;
}();

var coreHeaderNavComponentDefinition = {
    bindings: {
        classModifier: '@?',
        onInspirationSelected: '&?',
        onRecipesSelected: '&?'
    },
    controller: ['ShopperService', 'AnalyticsService', 'SettingsService', '$rootScope', '$location', CoreHeaderNavController],
    template: __webpack_require__(180).trim()
};

module.exports = {
    CoreHeaderNavController: CoreHeaderNavController,
    coreHeaderNavComponentDefinition: coreHeaderNavComponentDefinition
};

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"coreHeaderNav\" ng-class=\"$ctrl.classModifier\">\r\n    <a ui-sref=\"shop.list\" ui-sref-opts=\"{reload: true, inherit: false}\" ui-sref-active=\"is-active\" class=\"coreHeaderNav-link\" ng-if=\"$ctrl.shopperService.IsGuest\" ng-click=\"$ctrl.pushDataToAnalyticsService()\">\r\n        My Lists <i class=\"iconww-ArrowRight visible-xs-inline\"></i>\r\n    </a>\r\n    <a ui-sref=\"{{$ctrl.settings.content.enableQuickReorder ? 'shop.list.reorder' : 'shop.list'}}\" ui-sref-opts=\"{reload: true, inherit: false}\" ng-class=\"{'is-active': $ctrl.isMyList}\" class=\"coreHeaderNav-link\" ng-if=\"!$ctrl.shopperService.IsGuest\" ng-click=\"$ctrl.pushDataToAnalyticsService()\">\r\n        My Lists <i class=\"iconww-ArrowRight visible-xs-inline\"></i>\r\n    </a>\r\n    <a ng-if=\"$ctrl.settings.content.enableQuickReorder && !$ctrl.shopperService.IsGuest\" ui-sref=\"shop.list.reorder\" ui-sref-opts=\"{reload: true, inherit: false}\" ng-class=\"{'is-active': $ctrl.isReorder}\" class=\"coreHeaderNav-link\">\r\n        Quick Reorder <i class=\"iconww-ArrowRight visible-xs-inline\"></i>\r\n    </a>\r\n    <a ui-sref=\"shop.catalogue\" ui-sref-opts=\"{reload: true, inherit: false}\" ui-sref-active=\"is-active\" class=\"coreHeaderNav-link\" ng-click=\"$ctrl.pushDataToAnalyticsService()\">\r\n        Catalogue <i class=\"iconww-ArrowRight visible-xs-inline\"></i>\r\n    </a>\r\n    <a ui-sref=\"shop.recipes\" ui-sref-opts=\"{reload: true, inherit: false}\" ui-sref-active=\"is-active\" class=\"coreHeaderNav-link\" ng-click=\"$ctrl.onRecipesSelected({ $event: $event }); $ctrl.pushDataToAnalyticsService()\">\r\n        Recipes <i class=\"iconww-ArrowRight visible-xs-inline\"></i>\r\n    </a>\r\n    <a ui-sref=\"shop.inspiration\" ui-sref-opts=\"{reload: true, inherit: false}\" ui-sref-active=\"is-active\" class=\"coreHeaderNav-link\" ng-click=\"$ctrl.onInspirationSelected({ $event: $event }); $ctrl.pushDataToAnalyticsService()\">\r\n        Discover <i class=\"iconww-ArrowRight visible-xs-inline\"></i>\r\n    </a>\r\n</nav>\r\n"

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var angular = __webpack_require__(1);

var _require = __webpack_require__(0),
    merge = _require.merge;

var HeaderSearchController = function () {
    function HeaderSearchController($state, $stateParams, $q, $element, breakpointsService, moveFocus, settings, searchService) {
        _classCallCheck(this, HeaderSearchController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.$element = $element;
        this.breakpointsService = breakpointsService;
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.searchService = searchService;
    }

    _createClass(HeaderSearchController, [{
        key: '$onInit',
        value: function $onInit() {
            this.searchText = this.$stateParams.searchTerm || '';
            this.isActive = false;
            this.sfSearchActive = this.sfSearchActive !== undefined ? this.sfSearchActive : false;
        }
    }, {
        key: 'getItems',
        value: function getItems() {
            return this.settings.search.searchSuggestionThrottleTimeout < 0 ? this.$q.when([]) : this.searchService.getSearchSuggestion(this.searchText).then(function (response) {
                return response.SearchSuggestion;
            });
        }
    }, {
        key: 'search',
        value: function search(searchOptions) {
            var options = merge({
                enter: false,
                select: false
            }, searchOptions);
            this.searchService.isHeaderSearch = true;
            this.searchService.isAutocompleteSearch = options.select;
            this.$state.go('shop.search', { searchTerm: this.searchText }, { inherit: false, reload: true });
        }
    }, {
        key: 'toggleSearch',
        value: function toggleSearch() {
            if (this.breakpointsService.isSmallFormat()) {
                this.sfSearchActive = !this.sfSearchActive;
                if (this.sfSearchActive) {
                    if (angular.isFunction(this.searchToggledOn)) {
                        this.searchToggledOn();
                    }

                    // Cannot use movefocus as it uses timeouts internally
                    // iOS only allows focus moving if the control directly says to do so
                    this.$element.find('#searchBox').toggleClass('is-open', true);
                    this.$element.find('#headerSearch').focus();
                }
            }
        }
    }]);

    return HeaderSearchController;
}();

var headerSearchComponentDefinition = {
    bindings: {
        searchToggledOn: '&?',
        sfSearchActive: '=?'
    },
    controller: ['$state', '$stateParams', '$q', '$element', 'BreakpointsService', 'MoveFocus', 'Settings', 'SearchService', HeaderSearchController],
    template: __webpack_require__(182).trim()
};

module.exports = {
    HeaderSearchController: HeaderSearchController,
    headerSearchComponentDefinition: headerSearchComponentDefinition
};

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = "<form class=\"headerSearch\" action=\".\" ng-switch=\"$ctrl.sfSearchActive\">\r\n    <!-- Two buttons which replace each other to prevent Safari from double triggering with run-on-close -->\r\n    <button\r\n       type=\"button\"\r\n       ng-switch-when=\"false\"\r\n       class=\"headerSearch-searchButton headerSearch-toggleSearchButton button button--primary\"\r\n       ng-click=\"$ctrl.toggleSearch()\">\r\n            <i class=\"iconww-Search\"></i>\r\n            <span class=\"sr-only\">Expand search</span>\r\n    </button>\r\n    <button\r\n       type=\"button\"\r\n       ng-switch-when=\"true\"\r\n       class=\"headerSearch-searchButton headerSearch-toggleSearchButton button button--primary\">\r\n            <i class=\"iconww-Search\"></i>\r\n            <span class=\"sr-only\">Collapse search</span>\r\n    </button>\r\n\r\n    <oly-autocomplete\r\n        input-id=\"headerSearch\"\r\n        id=\"searchBox\"\r\n        class=\"headerSearch-searchWrapper\"\r\n        ng-class=\"{'is-open': !$ctrl.breakpointsService.isSmallFormat() || $ctrl.sfSearchActive}\"\r\n        text=\"$ctrl.searchText\"\r\n        placeholder=\"{{::$ctrl.settings.search.searchPromptText}}\"\r\n        items=\"$ctrl.getItems()\"\r\n        throttle=\"$ctrl.settings.search.searchSuggestionThrottleTimeout\"\r\n        is-disabled=\"$ctrl.isActive\"\r\n        persistent-dropdown=\"true\"\r\n        is-dropdown-open=\"$ctrl.isDropdownOpen\"\r\n        search-box-class=\"headerSearch-searchBox {{ $ctrl.searchText ? 'headerSearch-searchBoxClearButtonPadding' : '' }}\"\r\n        dropdown-wrapper-class=\"headerSearch-dropdownWrapper\"\r\n        dropdown-class=\"headerSearch-dropdown\"\r\n        item-class=\"headerSearch-autocompleteItem\"\r\n        item-select-class=\"headerSearch-autocompleteItemSelected\"\r\n        action-button-class=\"headerSearch-actionButton\"\r\n        search-button-class=\"headerSearch-autocompleteSearchButton\"\r\n        clear-button-class=\"headerSearch-searchBoxClearButton\"\r\n        action-button-wrapper-class=\"headerSearch-actionButtonWrapper\"\r\n        show-clear-button=\"true\"\r\n        show-search-button=\"true\"\r\n        min-length=\"2\"\r\n        run-on-select=\"$ctrl.search({select: true, enter: false})\"\r\n        run-on-enter=\"$ctrl.search({select: false, enter: true})\"\r\n        run-on-close=\"$ctrl.toggleSearch()\"\r\n        show-not-found-message=\"false\">\r\n        <autocomplete-item>\r\n            {{ ::item }}\r\n        </autocomplete-item>\r\n        <autocomplete-suffix>\r\n            <wow-multisearch\r\n                ng-if=\"!$ctrl.breakpointsService.isSmallFormat()\"\r\n                search-input=\"$ctrl.searchText\"\r\n                class-modifier=\"headerSearch-multiSearch\"\r\n                is-active=\"$ctrl.isActive\">\r\n            </wow-multisearch>\r\n        </autocomplete-suffix>\r\n    </oly-autocomplete>\r\n</form>\r\n"

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeaderCheckoutController = function () {
    function HeaderCheckoutController(breakpointsService, shopPageStateService, trolleyService) {
        _classCallCheck(this, HeaderCheckoutController);

        this.breakpointsService = breakpointsService;
        this.shopPageStateService = shopPageStateService;
        this.trolleyService = trolleyService;
    }

    _createClass(HeaderCheckoutController, [{
        key: 'back',
        value: function back() {
            window.history.back();
        }
    }, {
        key: 'toggleCartOpen',
        value: function toggleCartOpen() {
            this.shopPageStateService.isCartOpen = !this.shopPageStateService.isCartOpen;
        }
    }]);

    return HeaderCheckoutController;
}();

var headerCheckoutComponentDefinition = {
    controller: ['BreakpointsService', 'ShopPageStateService', 'TrolleyService', HeaderCheckoutController],
    template: __webpack_require__(184).trim()
};

module.exports = {
    HeaderCheckoutController: HeaderCheckoutController,
    headerCheckoutComponentDefinition: headerCheckoutComponentDefinition
};

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = "<button class=\"headerCheckout-toggleCartButton\" ng-click=\"$ctrl.toggleCartOpen()\" ng-if=\"$ctrl.breakpointsService.isInGreaterThanMediumFormatLandscape\">\r\n    <i class=\"iconww-Cart headerCheckout-cartIcon\"></i>\r\n    <span class=\"sr-only\">Toggle cart</span>\r\n</button>\r\n\r\n<a ui-sref=\"hyf\" class=\"headerCheckout-orderHeader\" ng-class=\"{'is-disabled': !$ctrl.trolleyService.hasAvailableProducts()}\">\r\n    <div class=\"headerCheckout-orderTotal\">\r\n        Your order\r\n        <br/>\r\n        <span class=\"headerCheckout-orderAmount\">{{ $ctrl.trolleyService.salePriceTotal | wowCurrency }}</span>\r\n    </div>\r\n\r\n    <button class=\"button button--primary headerCheckout-checkout\" ng-disabled=\"!$ctrl.trolleyService.hasAvailableProducts()\">\r\n        Checkout\r\n        <i class=\"iconww-ArrowRight\"></i>\r\n    </button>\r\n</a>\r\n\r\n<div class=\"headerCheckout-orderHeaderSf\" ui-sref-active=\"is-active\" ng-switch=\"$ctrl.breakpointsService.isInGreaterThanMediumFormatLandscape\">\r\n    <a ng-switch-when=\"false\" ui-sref=\"shop.cart\" class=\"headerCheckout-cartButton headerCheckout-openCartButton\">\r\n        <i class=\"iconww-Cart headerCheckout-cartButtonIcon\"></i>\r\n        <span class=\"sr-only\">Cart</span>\r\n        <span class=\"headerCheckout-cartButtonTotal\">{{ $ctrl.trolleyService.salePriceTotal | wowCurrency }}</span>\r\n    </a>\r\n\r\n    <a ng-switch-when=\"true\" ui-sref=\"hyf\" class=\"headerCheckout-cartButton headerCheckout-openCartButton\">\r\n        <i class=\"iconww-Cart headerCheckout-cartButtonIcon\"></i>\r\n        <span class=\"sr-only\">Cart</span>\r\n        <span class=\"headerCheckout-cartButtonTotal\">{{ $ctrl.trolleyService.salePriceTotal | wowCurrency }}</span>\r\n    </a>\r\n\r\n    <a href=\"javascript://\" ng-click=\"$ctrl.back()\" class=\"headerCheckout-cartButton headerCheckout-closeCartButton\">\r\n        <i class=\"iconww-Cross headerCheckout-cartButtonIcon\"></i>\r\n        Close <span class=\"sr-only\">Cart</span>\r\n    </a>\r\n</div>\r\n"

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = __webpack_require__(2);

var HeaderSkipLinksController = function () {
    function HeaderSkipLinksController($timeout, moveFocus, shopperService, shopPageStateService, loginService) {
        _classCallCheck(this, HeaderSkipLinksController);

        this.$timeout = $timeout;
        this.moveFocus = moveFocus;
        this.shopperService = shopperService;
        this.shopPageStateService = shopPageStateService;
        this.loginService = loginService;

        this.a11yOptionsOpen = false;
    }

    _createClass(HeaderSkipLinksController, [{
        key: '$postLink',
        value: function $postLink() {
            var _this = this;

            // auto hide focus is outside of the panel
            $('._a11yOptions').off('focusout.a11yOptions').on('focusout.a11yOptions', function () {
                // Timeout here because no item has focus yet, the check will now happen after focusin event has fired.
                _this.$timeout(function () {
                    // toggle if focus goes outside of small menu container
                    if ($(document.activeElement).closest('._a11yOptions').length === 0) {
                        _this.a11yOptionsOpen = false;
                    }
                }, 0);
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            $('._a11yOptions').off('focusout.a11yOptions');
        }
    }, {
        key: 'openA11yOptions',
        value: function openA11yOptions() {
            this.a11yOptionsOpen = true;
        }
    }, {
        key: 'updatePreference',
        value: function updatePreference() {
            this.shopperService.setPreferenceEnableAccessibility(this.shopperService.preferences.EnableAccessibleOptions);
        }
    }, {
        key: 'goToTrolley',
        value: function goToTrolley() {
            this.shopPageStateService.isCartOpen = true;
            this.moveFocus('#right-panel');
        }
    }, {
        key: 'goToNavigation',
        value: function goToNavigation() {
            this.moveFocus('#left-panel');
        }
    }]);

    return HeaderSkipLinksController;
}();

var headerSkipLinksComponentDefinition = {
    controller: ['$timeout', 'MoveFocus', 'ShopperService', 'ShopPageStateService', 'LoginService', HeaderSkipLinksController],
    template: __webpack_require__(186).trim()
};

module.exports = {
    HeaderSkipLinksController: HeaderSkipLinksController,
    headerSkipLinksComponentDefinition: headerSkipLinksComponentDefinition
};

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <p class=\"sr-only\" ng-if=\"!$ctrl.shopperService.preferences.EnableAccessibleOptions\" role=\"alert\" aria-live=\"assertive\">\r\n        If you are using a screen reader to navigate the Woolworths website please select the “Accessibility On” switch in accessibility settings.\r\n    </p>\r\n\r\n    <ul class=\"headerSkipLinks-menu\">\r\n        <li class=\"headerSkipLinks-listItem\" ng-switch=\"$ctrl.shopperService.IsGuest\">\r\n            <a ng-switch-when=\"true\" ui-sref=\"shop.authentication.login\" ui-sref-opts=\"{reload: true}\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink\">\r\n                Skip to login page\r\n            </a>\r\n            <button ng-switch-when=\"false\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink linkButton\" ng-click=\"$ctrl.loginService.logout()\">\r\n                Log out\r\n            </button>\r\n        </li>\r\n        <li class=\"headerSkipLinks-listItem\">\r\n            <a href=\"javascript:;\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink\" ng-click=\"$ctrl.goToNavigation()\">\r\n                Skip to content navigation\r\n            </a>\r\n        </li>\r\n        <li class=\"headerSkipLinks-listItem\">\r\n            <a href=\"javascript:;\" oly-move-focus=\"center-panel\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink\">\r\n                Skip to content\r\n            </a>\r\n        </li>\r\n        <li class=\"headerSkipLinks-listItem\">\r\n            <a href=\"javascript:;\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink\" ng-click=\"$ctrl.goToTrolley()\">\r\n                Skip to trolley\r\n            </a>\r\n        </li>\r\n        <li class=\"headerSkipLinks-listItem\">\r\n            <a href=\"javascript:;\" ng-click=\"$ctrl.openA11yOptions()\" oly-move-focus=\"headerSkipLinks-accessibility\" class=\"sr-only sr-only-focusable headerSkipLinks-listItemLink\">\r\n                Accessibility Settings\r\n            </a>\r\n        </li>\r\n    </ul>\r\n    <div class=\"headerSkipLinks-optionsPanel _a11yOptions\" id=\"headerSkipLinks-accessibility\" tabindex=\"-1\" ng-show=\"$ctrl.a11yOptionsOpen\">\r\n        <p>\r\n            If you are using a screen reader or a keyboard only to navigate the Woolworths website please select the “Accessibility On” checkbox below.\r\n        </p>\r\n        <form>\r\n            <input\r\n                type=\"checkbox\"\r\n                id=\"headerSkipLinks-accessibilityOption\"\r\n                class=\"wowCheckbox\"\r\n                name=\"enableAccessibleOptions\"\r\n                ng-model=\"$ctrl.shopperService.preferences.EnableAccessibleOptions\"\r\n                ng-change=\"$ctrl.updatePreference()\" />\r\n            <label for=\"headerSkipLinks-accessibilityOption\">Accessibility On</label>\r\n        </form>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    debounce = _require.debounce;

var CategorySelectionList = __webpack_require__(35);

var CategoryHeaderController = function () {
    function CategoryHeaderController($scope, settings, categoriesService, shopPageStateService, analyticsService, moveFocus) {
        _classCallCheck(this, CategoryHeaderController);

        this.$scope = $scope;
        this.settings = settings;
        this.categoriesService = categoriesService;
        this.shopPageStateService = shopPageStateService;
        this.analyticsService = analyticsService;
        this.moveFocus = moveFocus;
    }

    _createClass(CategoryHeaderController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.categoriesService.getAll();

            this.selectedCategories = new CategorySelectionList();

            this.categoriesLoaded = false;
            this.categoriesService.getAll().then(function () {
                if (_this.selectedCategories.department) {
                    _this.selectDepartment(_this.categoriesService.getById(_this.selectedCategories.department.NodeId));
                }
                _this.categoriesLoaded = true;
            });

            this.$scope.$on('$stateChangeStart', function () {
                return _this.closeMenu();
            });

            this.onMouseEnterDepartment = debounce(function ($event, department) {
                if (_this.checkEvent($event)) {
                    _this.$scope.$apply(function () {
                        return _this.selectDepartment(department);
                    });
                }
            }, this.settings.pies ? this.settings.pies.overlayOnHoverDelay : 150, { leading: false, trailing: true });
        }
    }, {
        key: 'checkEvent',
        value: function checkEvent(event) {
            return event ? event.type === 'click' || event.type.indexOf('mouse') >= 0 && !this.settings.category.disableCategoryMenuHover : true;
        }
    }, {
        key: 'onMouseLeaveDepartment',
        value: function onMouseLeaveDepartment($event) {
            if (this.checkEvent($event)) {
                this.onMouseEnterDepartment.cancel();
            }
        }
    }, {
        key: 'onTouchDepartment',
        value: function onTouchDepartment(department) {
            this.toggleMenu(department);
        }
    }, {
        key: 'selectDepartment',
        value: function selectDepartment(department) {
            // If we are opening the menu for the page we are currently on, we use the
            // selected categories so we can highlight the current page category.
            this.selectedCategories = this.categoriesService.currentCategories.department === department ? this.categoriesService.currentCategories.clone() : new CategorySelectionList(this.categoriesService.getCategoryTree(department.NodeId));

            this.shopPageStateService.toggleBodyScroll(false);

            this.moveFocus('.categoryHeader-menuHeaderTitle');
        }
    }, {
        key: 'selectCategory',
        value: function selectCategory(event, category) {
            if (this.checkEvent(event)) {
                if (event.type === 'click') {
                    event.preventDefault();
                }

                this.selectedCategories = new CategorySelectionList(this.categoriesService.getCategoryTree(category.NodeId));

                this.moveFocus('._subCategoryNav .categoriesNavigation');
            }
        }
    }, {
        key: 'onKeydownHeader',
        value: function onKeydownHeader($event) {
            // escape
            if ($event.which === 27) {
                this.moveFocus('._departmentNav .categoryHeader-navigationLink.is-active', true);
                this.closeMenu();
            }
        }
    }, {
        key: 'toggleMenu',
        value: function toggleMenu(department) {
            if (this.isMenuOpen && this.selectedCategories.department === department) {
                this.closeMenu();
            } else {
                this.selectDepartment(department);
            }
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu($event) {
            if (this.checkEvent($event)) {
                this.selectedCategories = new CategorySelectionList();
                this.shopPageStateService.toggleBodyScroll(true);
            }
        }
    }, {
        key: 'isActiveDepartment',
        value: function isActiveDepartment(department) {
            return department === (this.selectedCategories.department || this.categoriesService.currentCategories.department);
        }
    }, {
        key: 'pushDataToAnalyticsService',
        value: function pushDataToAnalyticsService() {
            this.analyticsService.push({
                data: {
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.menuClick
            });
        }
    }, {
        key: 'isMenuOpen',
        get: function get() {
            return this.selectedCategories.hasSelectedCategories;
        }
    }]);

    return CategoryHeaderController;
}();

CategoryHeaderController.$inject = ['$scope', 'Settings', 'CategoriesService', 'ShopPageStateService', 'AnalyticsService', 'MoveFocus'];

var categoryHeaderComponentDefinition = {
    transclude: true,
    controller: CategoryHeaderController,
    template: __webpack_require__(188).trim()
};

module.exports = {
    CategoryHeaderController: CategoryHeaderController,
    categoryHeaderComponentDefinition: categoryHeaderComponentDefinition
};

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = "<div class=\"categoryHeader\" oly-slideup=\"'.corporateHeader--horizontal'\" ng-mouseleave=\"$ctrl.closeMenu($event)\" ng-keydown=\"$ctrl.onKeydownHeader($event)\">\r\n    <nav class=\"categoryHeader-navigation _departmentNav\" aria-label=\"Departments\">\r\n        <a class=\"categoryHeader-navigationLink\"\r\n            aria-haspopup=\"true\"\r\n            aria-expanded=\"{{ $ctrl.isMenuOpen && $ctrl.isActiveDepartment(department) }}\"\r\n            aria-controls=\"categoryHeader-menu\"\r\n            ng-class=\"{ 'is-active': $ctrl.isActiveDepartment(department), 'is-special': department.IsSpecial }\"\r\n            ng-repeat=\"department in $ctrl.categoriesService.rootCategory.Children track by department.NodeId\"\r\n            wow-category-sref=\"::department\"\r\n            ui-sref-opts=\"{ reload: true, inherit: false }\"\r\n            oly-on-touchend=\"$ctrl.onTouchDepartment(department)\"\r\n            ng-mouseenter=\"$ctrl.onMouseEnterDepartment($event, department)\"\r\n            ng-mouseleave=\"$ctrl.onMouseLeaveDepartment($event)\"\r\n            ng-click=\"$event.preventDefault(); $ctrl.onMouseEnterDepartment($event, department); $ctrl.pushDataToAnalyticsService()\">\r\n            {{ ::department.Description }}\r\n        </a>\r\n    </nav>\r\n\r\n    <div id=\"categoryHeader-menu\"\r\n        class=\"categoryHeader-menu\"\r\n        ng-class=\"{ 'categoryHeader-menuTransition': $ctrl.settings.category.disableCategoryMenuHover }\"\r\n        ng-if=\"$ctrl.isMenuOpen\"\r\n        oly-slideup=\"::$ctrl.megamenuEffectiveOffset\"\r\n        tabindex=\"-1\">\r\n        <div ng-class=\"{ 'categoryHeader-menuHeader' : $ctrl.settings.category.disableCategoryMenuHover }\">\r\n            <div ng-class=\"$ctrl.settings.category.disableCategoryMenuHover ? 'u-flexCenter' : 'categoryHeader-menuHeader'\">\r\n                <h2 class=\"categoryHeader-menuHeaderTitle\">\r\n                    <div class=\"categoryHeader-menuHeaderIconContainer\">\r\n                        <img class=\"categoryHeader-menuHeaderIcon\"\r\n                            ng-src=\"/content/wowpiescategoryimages/{{ $ctrl.selectedCategories.department.UrlFriendlyName }}.svg\"\r\n                            alt=\"\" oly-error-src>\r\n                    </div>\r\n                    {{ $ctrl.selectedCategories.department.Description }}\r\n                </h2>\r\n\r\n                <!-- Ensure All Specials is not being shown due to performance problems (temporary solution) -->\r\n                <nav class=\"categoryHeader-menuHeaderList\" ng-if=\"!$ctrl.selectedCategories.department.IsSpecial\">\r\n                    <span ng-repeat=\"categoryChildren in $ctrl.selectedCategories.department.Children | limitTo:2\">\r\n                        <a ng-if=\"categoryChildren.IsBundle\" class=\"categoryHeader-menuHeaderLink\"\r\n                            wow-category-sref=\"categoryChildren\"\r\n                            ui-sref-active=\"is-active\"\r\n                            ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n                            {{ categoryChildren.Description }}\r\n                            <i class=\"iconww-ArrowRight\" aria-hidden=\"true\"></i>\r\n                        </a>\r\n                        <a ng-if=\"categoryChildren.IsSpecial\" class=\"categoryHeader-menuHeaderLink\"\r\n                            wow-category-sref=\"categoryChildren\"\r\n                            ui-sref-active=\"is-active\"\r\n                            ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n                            {{ categoryChildren.Description }}\r\n                            <i class=\"iconww-ArrowRight\" aria-hidden=\"true\"></i>\r\n                        </a>\r\n                    </span>\r\n                    <a class=\"categoryHeader-menuHeaderLink\"\r\n                        wow-category-sref=\"$ctrl.selectedCategories.department\"\r\n                        ui-sref-active=\"is-active\"\r\n                        ui-sref-opts=\"{ reload: true, inherit: false }\">\r\n                        Show all {{ $ctrl.selectedCategories.department.Description }}\r\n                        <i class=\"iconww-ArrowRight\" aria-hidden=\"true\"></i>\r\n                    </a>\r\n                </nav>\r\n            </div>\r\n\r\n            <button type=\"button\"\r\n                ng-if=\"$ctrl.settings.category.disableCategoryMenuHover\"\r\n                class=\"iconButton u-flexCenter categoryHeader-menuClose\"\r\n                ng-click=\"$ctrl.closeMenu()\">\r\n                    Close <i class=\"iconww-Cross categoryHeader-menuCloseIcon\"></i>\r\n            </button>\r\n        </div>\r\n\r\n        <div class=\"categoryHeader-menuPanel\">\r\n            <div class=\"categoryHeader-menuCategoryNav _categoryNav\" ng-if=\"!$ctrl.categoriesLoaded\" aria-label=\"Loading categories\">\r\n            </div>\r\n            <wow-categories-navigation\r\n                ng-if=\"$ctrl.categoriesLoaded\"\r\n                class=\"categoryHeader-menuCategoryNav _categoryNav\"\r\n                class-modifier=\"category\"\r\n                category=\"$ctrl.selectedCategories.department\"\r\n                selected=\"$ctrl.selectedCategories.category\"\r\n                on-select=\"$ctrl.selectCategory(event, category)\"\r\n                    should-show-arrow=\"true\"\r\n                    oly-hover-menu=\"nav\"\r\n                    oly-hover-menu-dir=\"right\">\r\n                </wow-categories-navigation>\r\n\r\n                <wow-categories-navigation\r\n                    class=\"categoryHeader-menuSubcategoryNav _subCategoryNav\"\r\n                    class-modifier=\"subcategory\"\r\n                    category=\"$ctrl.selectedCategories.category\"\r\n                    should-show-arrow=\"true\"\r\n                    should-show-show-all=\"true\"\r\n                    should-show-specials=\"true\"\r\n                    should-show-bundles=\"true\"\r\n                    should-show-separator=\"!!$ctrl.selectedCategories.category\">\r\n\r\n                    <div ng-if=\"!$ctrl.selectedCategories.category\" class=\"categoryHeader-menuNotSelected\">\r\n                        <div class=\"categoryHeader-menuNotSelectedContent\">\r\n                            <i class=\"iconww-Cart categoryHeader-menuNotSelectedIcon\" aria-hidden=\"true\"></i>\r\n                            <span class=\"categoryHeader-menuNotSelectedText\">Select from the<br />categories on the left.</span>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <p role=\"alert\" class=\"sr-only\">Entered menu. Press escape at any time to exit this menu</p>\r\n                </wow-categories-navigation>\r\n\r\n                <span class=\"u-flexSpacer\"></span>\r\n\r\n                <wow-category-header-banners\r\n                    class=\"categoryHeader-menuBanners\"\r\n                    category=\"$ctrl.selectedCategories.category || $ctrl.selectedCategories.department\">\r\n                </wow-category-header-banners>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"categoryHeader-mask\"\r\n            ng-mouseenter=\"$ctrl.closeMenu($event)\"\r\n            ng-show=\"$ctrl.isMenuOpen\"\r\n            ng-click=\"$ctrl.closeMenu(); $ctrl.pushDataToAnalyticsService()\">\r\n        </div>\r\n    </div>\r\n"

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CategoryHeaderSmallFormatController = function () {
    function CategoryHeaderSmallFormatController($scope, $element, $state, categoriesService, analyticsService, moveFocus) {
        _classCallCheck(this, CategoryHeaderSmallFormatController);

        this.$scope = $scope;
        this.$element = $element;
        this.$state = $state;
        this.categoriesService = categoriesService;
        this.analyticsService = analyticsService;
        this.moveFocus = moveFocus;
    }

    _createClass(CategoryHeaderSmallFormatController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.open = false;

            this.categoriesLoaded = false;
            this.categoriesService.getAll().then(function () {
                _this.categoriesLoaded = true;
            });

            this.$scope.$on('$stateChangeStart', function () {
                return _this.closeMenu();
            });
        }
    }, {
        key: 'onSelectCategory',
        value: function onSelectCategory(event, category) {
            var _this2 = this;

            if (this.categoriesLoaded && !category.Children.length) {
                // Don't do anything if there aren't any children.
                // Instead, just let it navigate.
                return;
            }

            if (event.type === 'click') {
                event.preventDefault();
            }

            this.categoriesService.getAll().then(function () {
                category = _this2.categoriesService.getById(category.NodeId);
                _this2.selectedCategories.pushCategory(category);
                _this2.moveFocus('#categoryHeaderSmallFormat-browseButton');
                _this2.fixIOSMomentumScrolling();
            });
        }
    }, {
        key: 'onBack',
        value: function onBack() {
            this.selectedCategories.popCategory();
            this.fixIOSMomentumScrolling();
        }
    }, {
        key: 'toggleOpen',
        value: function toggleOpen() {
            this.open = !this.open;
            if (this.open) {
                // Set selected categories
                this.selectedCategories = this.categoriesService.currentCategories.clone();
                // Navigate to the parent category
                this.onBack();
            }
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            if (this.open) {
                this.toggleOpen();
            }
        }

        /**
         * On iOS, if the content of a scrollable container with -webkit-overflow-scrolling: scroll
         * is shorter than the height of the container (causing it to not be scrollable) and then
         * changes to become taller (causing it to be scrollable) Safari will not realise this and
         * the container will not be scrollable. This happens when going from a short list of categories
         * to a long list of categories.
         *
         * The fix is to toggle this property to get Safari to check the container again and apply scrolling to it.
         */

    }, {
        key: 'fixIOSMomentumScrolling',
        value: function fixIOSMomentumScrolling() {
            var _this3 = this;

            this.$element.find('.categoryHeaderSmallFormat-list').css('-webkit-overflow-scrolling', 'auto');
            setTimeout(function () {
                return _this3.$element.find('.categoryHeaderSmallFormat-list').css('-webkit-overflow-scrolling', 'touch');
            });
        }
    }, {
        key: 'pushDataToAnalyticsService',
        value: function pushDataToAnalyticsService() {
            this.analyticsService.push({
                data: {
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.menuClick
            });
        }
    }, {
        key: 'rootCategory',
        get: function get() {
            return this.categoriesService.rootCategory;
        }
    }, {
        key: 'currentCategory',
        get: function get() {
            return this.selectedCategories.current || this.rootCategory;
        }
    }]);

    return CategoryHeaderSmallFormatController;
}();

var categoryHeaderSmallFormatComponentDefinition = {
    controller: ['$scope', '$element', '$state', 'CategoriesService', 'AnalyticsService', 'MoveFocus', CategoryHeaderSmallFormatController],
    template: __webpack_require__(190).trim()
};

module.exports = {
    CategoryHeaderSmallFormatController: CategoryHeaderSmallFormatController,
    categoryHeaderSmallFormatComponentDefinition: categoryHeaderSmallFormatComponentDefinition
};

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = "<div class=\"categoryHeaderSmallFormat-mask\" ng-if=\"$ctrl.open\" ng-click=\"$ctrl.closeMenu()\"></div>\r\n\r\n<div role=\"menu\" class=\"categoryHeaderSmallFormat\" oly-sticky=\"'.corporateHeader--horizontal'\">\r\n    <button id=\"categoryHeaderSmallFormat-browseButton\" class=\"categoryHeaderSmallFormat-browseButton\" ng-click=\"$ctrl.toggleOpen(); $ctrl.pushDataToAnalyticsService()\" aria-expanded=\"{{ $ctrl.open }}\">\r\n        <h3 class=\"categoryHeaderSmallFormat-browseButtonText\" ng-switch=\"!!$ctrl.categoriesService.currentCategory\">\r\n            <span ng-switch-when=\"false\">Browse Groceries</span>\r\n            <span ng-switch-when=\"true\">Browsing:  {{ $ctrl.categoriesService.currentCategory.Description }}</span>\r\n        </h3>\r\n        <i class=\"categoryHeaderSmallFormat-browseButtonIcon\" ng-class=\"$ctrl.open ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n    </button>\r\n\r\n    <div class=\"categoryHeaderSmallFormat-list\" ng-if=\"$ctrl.open\">\r\n        <div ng-if=\"$ctrl.selectedCategories.current\">\r\n            <button aria-label=\"Click to browse parent categories\"\r\n                class=\"categoryHeaderSmallFormat-listHeader\"\r\n                ng-click=\"$ctrl.onBack(); $ctrl.pushDataToAnalyticsService()\">\r\n                <i class=\"categoryHeaderSmallFormat-listHeaderBack iconww-ArrowLeft\"></i>\r\n                <h3 class=\"categoryHeaderSmallFormat-listHeaderText\">{{ $ctrl.selectedCategories.current.Description }}</h3>\r\n            </button>\r\n        </div>\r\n\r\n        <wow-categories-navigation\r\n            ng-if=\"!$ctrl.selectedCategories.current\"\r\n            ng-click=\"$ctrl.pushDataToAnalyticsService()\"\r\n            class=\"categoryHeaderSmallFormat-listNav\"\r\n            class-modifier=\"mobile\"\r\n            category=\"$ctrl.rootCategory\"\r\n            on-select=\"$ctrl.onSelectCategory(event, category)\"\r\n            class=\"categoryHeaderSmallFormat-navigation\"\r\n            should-show-arrow=\"true\">\r\n        </wow-categories-navigation>\r\n\r\n        <wow-categories-navigation\r\n            ng-if=\"$ctrl.selectedCategories.department && $ctrl.selectedCategories.department === $ctrl.selectedCategories.current\"\r\n            class=\"categoryHeaderSmallFormat-listNav\"\r\n            class-modifier=\"mobile\"\r\n            category=\"$ctrl.selectedCategories.department\"\r\n            on-select=\"$ctrl.onSelectCategory(event, category)\"\r\n            class=\"categoryHeaderSmallFormat-navigation\"\r\n            should-show-arrow=\"true\"\r\n            should-show-show-all=\"!$ctrl.selectedCategories.department.IsSpecial\"\r\n            should-show-specials=\"true\"\r\n            should-show-bundles=\"true\">\r\n        </wow-categories-navigation>\r\n\r\n        <wow-categories-navigation\r\n            ng-if=\"$ctrl.selectedCategories.category && $ctrl.selectedCategories.category === $ctrl.selectedCategories.current\"\r\n            class=\"categoryHeaderSmallFormat-listNav\"\r\n            class-modifier=\"mobile\"\r\n            category=\"$ctrl.selectedCategories.category\"\r\n            on-select=\"$ctrl.onSelectCategory(event, category)\"\r\n            class=\"categoryHeaderSmallFormat-navigation\"\r\n            should-show-arrow=\"true\"\r\n            should-show-show-all=\"true\"\r\n            should-show-specials=\"true\"\r\n            should-show-bundles=\"true\">\r\n        </wow-categories-navigation>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var categoryHeaderBannersController = function () {
    function categoryHeaderBannersController(bannersService) {
        _classCallCheck(this, categoryHeaderBannersController);

        this.bannersService = bannersService;
    }

    _createClass(categoryHeaderBannersController, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.getBanners();
        }
    }, {
        key: 'getBanners',
        value: function getBanners() {
            this.bannersService.getBanners({
                CategoryId: this.category.NodeId,
                IsSpecialRoot: false
            });
        }
    }]);

    return categoryHeaderBannersController;
}();

var categoryHeaderBannersComponentDefinition = {
    bindings: {
        category: '<'
    },
    controller: ['BannersService', categoryHeaderBannersController],
    template: __webpack_require__(192).trim()
};

module.exports = {
    categoryHeaderBannersController: categoryHeaderBannersController,
    categoryHeaderBannersComponentDefinition: categoryHeaderBannersComponentDefinition
};

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = "<div class=\"categoryHeaderBanners\">\r\n    <wow-banner\r\n        banner=\"banner\"\r\n        ng-repeat=\"banner in $ctrl.bannersService.banners[$ctrl.category.NodeId] track by banner.ID\">\r\n    </wow-banner>\r\n</div>\r\n"

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var NewProductsService = __webpack_require__(194);

var _require = __webpack_require__(195),
    newProductsNavComponentDefinition = _require.newProductsNavComponentDefinition;

var _require2 = __webpack_require__(197),
    newProductsTileListComponentDefinition = _require2.newProductsTileListComponentDefinition;

angular.module('wowApp.shop').service('NewProductsService', ['Restangular', NewProductsService]).component('wowNewProductsNav', newProductsNavComponentDefinition).component('wowNewProductsTileList', newProductsTileListComponentDefinition);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewProductsService = function () {
    function NewProductsService(restangular) {
        _classCallCheck(this, NewProductsService);

        this._api = restangular.one('/Products/New');
        this.isLoading = false;
        this.cache = {};
    }

    _createClass(NewProductsService, [{
        key: 'getProducts',
        value: function getProducts(pageSize, pageNumber, sortType) {
            var _this = this;

            this.isLoading = true;
            var key = [pageSize, pageNumber, sortType].join('.');

            if (!(key in this.cache)) {
                this.cache[key] = this._api.get({ pageSize: pageSize, pageNumber: pageNumber, sortType: sortType });
            }
            return this.cache[key].then(function (response) {
                _this.totalRecordCount = response.TotalRecordCount;
                return response;
            }).finally(function () {
                _this.isLoading = false;
            });
        }
    }]);

    return NewProductsService;
}();

module.exports = NewProductsService;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewProductsNavController = function NewProductsNavController(newProductsService) {
    _classCallCheck(this, NewProductsNavController);

    this.newProducts = newProductsService;
};

NewProductsNavController.$inject = ['NewProductsService'];

var newProductsNavComponentDefinition = {
    controller: NewProductsNavController,
    template: __webpack_require__(196).trim()
};

module.exports = {
    NewProductsNavController: NewProductsNavController,
    newProductsNavComponentDefinition: newProductsNavComponentDefinition
};

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navigation navigation-container\">\r\n    <ul class=\"navigation-items\">\r\n        <li>\r\n            <a ui-sref=\"shop.new\" ui-sref-active=\"is-active\" class=\"navigation-link\">\r\n                <span class=\"navigation-linkText\">New Products\r\n                    <span ng-switch=\"$ctrl.newProducts.isLoading\">\r\n                        <span ng-switch-when=\"true\">\r\n                            <wow-loading-spinner class=\"searchCountSpinner\"></wow-loading-spinner>\r\n                        </span>\r\n                        <span ng-switch-when=\"false\">\r\n                            <span ng-show=\"$ctrl.newProducts.totalRecordCount > 0\">({{$ctrl.newProducts.totalRecordCount}})</span>\r\n                            <i class=\"iconww-ArrowRight\"></i>\r\n                        </span>\r\n                    </span>\r\n                </span>\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</nav>\r\n"

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(10),
    createProductTiles = _require.createProductTiles;

var _require2 = __webpack_require__(0),
    map = _require2.map;

var NewProductsTileListController = function () {
    function NewProductsTileListController(settings, analyticsService, newProductsService, sortByKeys) {
        _classCallCheck(this, NewProductsTileListController);

        this.settings = settings;
        this.analyticsService = analyticsService;
        this.newProductsService = newProductsService;
        this.sortByKeys = sortByKeys;
    }

    _createClass(NewProductsTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = { sortTypes: this.settings.new.sortOptions, sortContext: this.sortByKeys.NEW_KEY };
        }
    }, {
        key: 'createTiles',
        value: function createTiles(response) {
            return {
                items: createProductTiles(response.Items),
                totalRecordCount: response.TotalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber, sortType) {
            var _this = this;

            return this.newProductsService.getProducts(pageSize, pageNumber, sortType).then(function (response) {
                return _this.createTiles(response);
            });
        }
    }, {
        key: 'createAnalyticsData',
        value: function createAnalyticsData(contentData) {
            return {
                pageNumber: contentData.pageNumber,
                currentCategory: { Description: 'New Products' },
                products: map(contentData.items, function (item) {
                    return { Name: item.data.product.Name, Products: [item.data.product] };
                }),
                inspirationCards: { Cards: contentData.inspirationCards },
                totalRecordCount: contentData.totalRecordCount,
                filters: contentData.filters,
                sortType: contentData.sortType ? contentData.sortType.Value : '',
                sortOptions: this.sortOptions
            };
        }
    }, {
        key: 'pushContentDataToAnalytics',
        value: function pushContentDataToAnalytics(contentData) {
            this.analyticsService.push({
                data: this.createAnalyticsData(contentData),
                type: this.analyticsService.mapperTypes.shop.productCategory
            });
        }
    }]);

    return NewProductsTileListController;
}();

NewProductsTileListController.$inject = ['Settings', 'AnalyticsService', 'NewProductsService', 'SortByKeys'];

var newProductsTileListComponentDefinition = {
    bindings: {
        pageNumber: '<',
        sortBy: '<'
    },
    controller: NewProductsTileListController,
    template: '\n        <wow-tile-list\n            list-title="\'New Products\'"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)"\n            push-content-to-analytics="$ctrl.pushContentDataToAnalytics(contentData)">\n\n            <zero-result>\n                <div class="newProductsTileList-zeroResult">\n                    <h1 class="newProductsZeroResult-title">No new products found</h1>\n                    <p>Sorry, no new products were found. Please check back soon.</p>\n                </div>\n            </zero-result>\n        </wow-tile-list>\n    '
};

module.exports = {
    NewProductsTileListController: NewProductsTileListController,
    newProductsTileListComponentDefinition: newProductsTileListComponentDefinition
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var OrderInformationService = __webpack_require__(199);

var _require = __webpack_require__(200),
    orderInformationComponentDefinition = _require.orderInformationComponentDefinition;

var _require2 = __webpack_require__(202),
    orderInformationTipsComponentDefinition = _require2.orderInformationTipsComponentDefinition;

var _require3 = __webpack_require__(204),
    orderInformationCountdownComponentDefinition = _require3.orderInformationCountdownComponentDefinition;

angular.module('wowApp.shop').service('OrderInformationService', OrderInformationService).component('wowOrderInformation', orderInformationComponentDefinition).component('wowOrderInformationTips', orderInformationTipsComponentDefinition).component('wowOrderInformationCountdown', orderInformationCountdownComponentDefinition);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderInformationService = function () {
    function OrderInformationService(settings) {
        _classCallCheck(this, OrderInformationService);

        this.settings = settings;
        this.methodList = {
            unknown: '',
            pickup: 'pickup',
            delivery: 'delivery',
            express: 'express'
        };
    }

    _createClass(OrderInformationService, [{
        key: 'getDeliveryMethod',
        value: function getDeliveryMethod(method) {
            // unify order delivery method because Order Confirmation and TMO are returning different values.
            switch (method) {
                case 'Delivery':
                case 'Courier':
                    return this.methodList.delivery;
                case 'XpressD':
                case 'Express':
                    return this.methodList.express;
                case 'Pickup':
                case 'Hubspok':
                    return this.methodList.pickup;
                default:
                    return this.methodList.unknown;
            }
        }
    }, {
        key: 'getWarningMessage',
        value: function getWarningMessage(_ref) {
            var order = _ref.order,
                deliveryMethod = _ref.deliveryMethod;

            if (!order) return '';

            var orderMethod = this.getDeliveryMethod(deliveryMethod);

            // check restricted products first as it takes precedence.
            if (order.ContainsRestrictedBySignatureAndPhotoId) {
                return orderMethod === this.methodList.pickup ? this.settings.delivery.restrictionWarningPickupSignatureAndPhotoId : this.settings.delivery.restrictionWarningDeliverySignatureAndPhotoId;
            } else if (order.ContainsRestrictedBySignature) {
                return orderMethod === this.methodList.pickup ? this.settings.delivery.restrictionWarningPickupSignature : this.settings.delivery.restrictionWarningDeliverySignature;
            } else if (order.ContainsFrozen && orderMethod === this.methodList.delivery && order.CanLeaveOrderUnattended) {
                return this.settings.delivery.frozenDeliveryWarning;
            }

            return '';
        }
    }]);

    return OrderInformationService;
}();

OrderInformationService.$inject = ['Settings'];

module.exports = OrderInformationService;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var OrderInformationController = function () {
    function OrderInformationController(storeService) {
        _classCallCheck(this, OrderInformationController);

        this.storeService = storeService;
    }

    _createClass(OrderInformationController, [{
        key: '$onInit',
        value: function $onInit() {
            // hub & spoke orders does not have trading hours
            var orderDate = this.dateInfo && this.dateInfo.date ? new Date(this.dateInfo.date) : new Date();

            this.dayOfWeek = DAYS_OF_WEEK[orderDate.getDay()];
        }
    }, {
        key: 'getFormattedAddress',
        value: function getFormattedAddress() {
            return this.addressInfo.street1 + (this.addressInfo.street2 ? ', ' + this.addressInfo.street2 : '') + (this.addressInfo.suburb && this.addressInfo.postcode ? ', ' + this.addressInfo.suburb + ' ' + this.addressInfo.postcode : '');
        }
    }, {
        key: 'getStoreLinkParams',
        value: function getStoreLinkParams() {
            if (!this.storeInfo.details) return {};

            return {
                store: this.storeService.getStoreUrl(this.storeInfo.details),
                storeDetails: this.storeInfo.details
            };
        }
    }]);

    return OrderInformationController;
}();

OrderInformationController.$inject = ['StoreService'];

var orderInformationComponentDefinition = {
    bindings: {
        orderInfo: '<',
        dateInfo: '<',
        addressInfo: '<',
        storeInfo: '<',
        isGuest: '<'
    },
    controller: OrderInformationController,
    template: __webpack_require__(201).trim()
};

module.exports = {
    OrderInformationController: OrderInformationController,
    orderInformationComponentDefinition: orderInformationComponentDefinition
};

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = "<div class=\"orderInformation\" ng-if=\"$ctrl.orderInfo.method === 'Pickup'\">\r\n    <!-- Pickup Orders -->\r\n    <div class=\"orderInformation-container orderInformation-timingContainer\">\r\n        <!-- Delivery/Pickup Window -->\r\n        <h2 class=\"heading4 orderInformation-heading\">\r\n            {{ $ctrl.orderInfo.headerTexts.pickup }}\r\n        </h2>\r\n\r\n        <div ng-if=\"$ctrl.dateInfo\">\r\n            <p class=\"orderInformation-text orderInformation-textDate\"><strong>Date:</strong> {{$ctrl.dateInfo.date | date:'EEEE, dd MMMM yyyy'}}</p>\r\n            <p class=\"orderInformation-text orderInformation-textTime\"><strong>Time:</strong> Between {{$ctrl.dateInfo.startTime}} and {{$ctrl.dateInfo.endTime}}</p>\r\n        </div>\r\n    </div>\r\n\r\n    <!-- Pickup Location -->\r\n    <div class=\"orderInformation-container orderInformation-locationContainer\" ng-if=\"$ctrl.storeInfo\">\r\n        <h4 class=\"heading4 sr-only\">\r\n            <wow-setting setting-group=\"TrackMyOrder\" setting-name=\"PickupLocationLabel\"></wow-setting>\r\n        </h4>\r\n        <p class=\"orderInformation-text orderInformation-store\">\r\n            <span ng-if=\"!$ctrl.storeInfo.details\">{{$ctrl.storeInfo.name}}</span>\r\n            <span ng-if=\"$ctrl.storeInfo.details\">\r\n                <strong>At:</strong>\r\n                <a\r\n                    class=\"orderInformation-pickupAddressLink\"\r\n                    ui-sref=\"shop.locator.store($ctrl.getStoreLinkParams())\">\r\n                    {{$ctrl.storeInfo.name}}&nbsp;<i class=\"iconww-NewWindow\"></i>\r\n                </a>\r\n            </span>\r\n        </p>\r\n        <p class=\"orderInformation-text orderInformation-pickupAddressText\" ng-if=\"$ctrl.addressInfo\">\r\n            {{ $ctrl.getFormattedAddress() }}\r\n        </p>\r\n\r\n        <!-- Trading Hours (Pickup Only, not hubspok, hubspok do not have trading hours) -->\r\n        <div class=\"orderInformation-tradinghoursContainer\"\r\n            ng-if=\"$ctrl.storeInfo.tradingHours && $ctrl.storeInfo.tradingHours.length\">\r\n            <h4 class=\"heading4 orderInformation-subheading\"><wow-setting setting-group=\"TrackMyOrder\" setting-name=\"TradingHoursLabel\"></wow-setting></h4>\r\n            <table class=\"orderInformation-timetable\">\r\n                <tr ng-repeat=\"tradingHour in $ctrl.storeInfo.tradingHours\">\r\n                    <th\r\n                        class=\"orderInformation-tradinghoursCell orderInformation-tradinghoursDay\"\r\n                        ng-class=\"{'orderInformation-tradinghoursToday': $ctrl.dayOfWeek === tradingHour.Day}\">\r\n                        {{tradingHour.Day}}\r\n                    </th>\r\n                    <th\r\n                        class=\"orderInformation-tradinghoursCell\"\r\n                        ng-class=\"{'orderInformation-tradinghoursToday': $ctrl.dayOfWeek === tradingHour.Day}\">\r\n                        {{tradingHour.OpenHour}}\r\n                    </th>\r\n                </tr>\r\n            </table>\r\n        </div>\r\n    </div>\r\n\r\n    <!-- store instructions -->\r\n    <div class=\"orderInformation-container\" ng-if=\"$ctrl.orderInfo.instructions\">\r\n        <h4>Instructions for your Pick up store:</h4>\r\n        <p>{{ $ctrl.orderInfo.instructions }}</p>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"orderInformation\"\r\n    ng-if=\"$ctrl.orderInfo.method === 'Courier' || $ctrl.orderInfo.method === 'Delivery'\">\r\n    <!-- Delivery Orders -->\r\n    <div class=\"orderInformation-container orderInformation-timingContainer\">\r\n        <!-- Delivery Window -->\r\n        <h2 class=\"heading4 orderInformation-heading\">\r\n            {{ $ctrl.orderInfo.headerTexts.delivery }}\r\n        </h2>\r\n\r\n        <div ng-if=\"$ctrl.dateInfo\">\r\n            <p class=\"orderInformation-text orderInformation-textDate\"><strong>Date:</strong> {{$ctrl.dateInfo.date | date:'EEEE, dd MMMM yyyy'}}</p>\r\n            <p class=\"orderInformation-text orderInformation-textTime\"><strong>Time:</strong> Between {{$ctrl.dateInfo.startTime}} and {{$ctrl.dateInfo.endTime}}</p>\r\n            <p class=\"orderInformation-text orderInformation-textEta\" ng-if=\"$ctrl.dateInfo.eta\">\r\n                <strong>Estimated arrival*: </strong>\r\n                Between {{$ctrl.dateInfo.eta.startTime | date:'hh:mma' | lowercase}} and {{$ctrl.dateInfo.eta.endTime | date:'hh:mma' | lowercase}}\r\n            </p>\r\n        </div>\r\n    </div>\r\n\r\n    <!-- Delivery Location (Do not show if Delivery And Guest) -->\r\n    <div class=\"orderInformation-container orderInformation-locationContainer\" ng-if=\"!$ctrl.isGuest\">\r\n        <h4 class=\"heading4 sr-only\">\r\n            <wow-setting setting-group=\"TrackMyOrder\" setting-name=\"DeliveryLocationLabel\"></wow-setting>\r\n        </h4>\r\n        <p class=\"orderInformation-text orderInformation-pickupAddressText\" ng-if=\"$ctrl.addressInfo\">\r\n            <strong>To: </strong>{{ $ctrl.getFormattedAddress() }}\r\n        </p>\r\n    </div>\r\n\r\n    <!-- driver instructions -->\r\n    <div class=\"orderInformation-container\" ng-if=\"$ctrl.orderInfo.instructions || $ctrl.orderInfo.canLeaveUnattended\">\r\n        <span ng-if=\"$ctrl.orderInfo.instructions\">\r\n            <h4>Instructions for the driver:</h4>\r\n            <p>{{ $ctrl.orderInfo.instructions }}</p>\r\n        </span>\r\n        <p ng-if=\"$ctrl.orderInfo.canLeaveUnattended\">\r\n            <i class=\"iconww-Tick orderInformation-iconTick\"></i>Authorisation to leave order unattended\r\n        </p>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"orderInformation\"\r\n    ng-if=\"$ctrl.orderInfo.method === 'XpressD' || $ctrl.orderInfo.method === 'Express'\">\r\n    <!-- Express Delivery Orders -->\r\n    <div class=\"orderInformation-container orderInformation-timingContainer\" ng-if=\"$ctrl.addressInfo\">\r\n        <!-- Delivery Window -->\r\n        <h2 class=\"heading4 orderInformation-heading\">\r\n            {{ $ctrl.orderInfo.headerTexts.express }}\r\n        </h2>\r\n\r\n        <div class=\"orderInformation-etaContainer\">\r\n            <p class=\"orderInformation-text orderInformation-deliveryAddressText\" ng-if=\"$ctrl.addressInfo && !$ctrl.isGuest\">\r\n                <strong>To: </strong>{{ $ctrl.getFormattedAddress() }}\r\n            </p>\r\n            <p class=\"orderInformation-text\" ng-if=\"$ctrl.dateInfo\">\r\n                <div ng-if=\"$ctrl.dateInfo.minutesRemainingUntilExpressDelivery != null\">\r\n                    <wow-order-information-countdown\r\n                    update-frequency=\"1000\"\r\n                    minutes-left=\"$ctrl.dateInfo.minutesRemainingUntilExpressDelivery\">\r\n               </wow-order-information-countdown>\r\n            </div>\r\n            <div ng-if=\"$ctrl.dateInfo.minutesRemainingUntilExpressDelivery == null\">\r\n                    <strong>Estimated arrival: </strong>\r\n                    Between {{$ctrl.dateInfo.startTime}} and {{$ctrl.dateInfo.endTime}}\r\n            </div>\r\n            </p>\r\n        </div>\r\n    </div>\r\n\r\n    <!-- Express delivery Trace your order note for customers -->\r\n    <div class=\"orderInformation-container orderInformation-locationContainer\">\r\n        <h4 class=\"heading4 orderInformation-heading\">\r\n            Track your order\r\n        </h4>\r\n        <p class=\"orderInformation-text orderInformation-trackYourOrder\">\r\n            <wow-setting setting-group=\"TrackMyOrder\" setting-name=\"TrackYourOrderText\">\r\n        </p>\r\n    </div>\r\n\r\n    <!-- driver instructions -->\r\n    <div class=\"orderInformation-container\" ng-if=\"$ctrl.orderInfo.instructions || $ctrl.orderInfo.canLeaveUnattended\">\r\n        <span ng-if=\"$ctrl.orderInfo.instructions\">\r\n            <h4>Instructions for the driver:</h4>\r\n            <p>{{ $ctrl.orderInfo.instructions }}</p>\r\n        </span>\r\n        <p ng-if=\"$ctrl.orderInfo.canLeaveUnattended\">\r\n            <i class=\"iconww-Tick orderInformation-iconTick\"></i>Authorisation to leave order unattended\r\n        </p>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderInformationTipsController = function OrderInformationTipsController(settings) {
    _classCallCheck(this, OrderInformationTipsController);

    this.settings = settings;
};

OrderInformationTipsController.$inject = ['Settings'];

var orderInformationTipsComponentDefinition = {
    bindings: {
        orderMethod: '<'
    },
    controller: OrderInformationTipsController,
    template: __webpack_require__(203).trim()
};

module.exports = {
    OrderInformationTipsController: OrderInformationTipsController,
    orderInformationTipsComponentDefinition: orderInformationTipsComponentDefinition
};

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = "<div class=\"orderInformationTips\">\r\n    <span\r\n        wow-html-setting\r\n        setting-group=\"TrackMyOrder\"\r\n        setting-name=\"DeliveryTips\"\r\n        ng-if=\"$ctrl.orderMethod === 'Delivery' || $ctrl.orderMethod === 'Courier'\r\n            || $ctrl.orderMethod === 'Express' || $ctrl.orderMethod === 'XpressD'\">\r\n    </span>\r\n    <span\r\n        wow-html-setting\r\n        setting-group=\"TrackMyOrder\"\r\n        setting-name=\"PickupTips\"\r\n        ng-if=\"$ctrl.orderMethod === 'Pickup'\">\r\n    </span>\r\n\r\n    <div class=\"orderInformationTips-contactUs\">\r\n        <h3 class=\"header\">Need more information?</h3>\r\n        <p class=\"orderInformationTips-contactUsText\">\r\n            Check out our <a href=\"/shop/page/help-and-support-faq\">Frequently Asked Questions</a>\r\n        </p>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderInformationCountdownController = function () {
    function OrderInformationCountdownController($interval, orderManagementService) {
        _classCallCheck(this, OrderInformationCountdownController);

        this.orderManagementService = orderManagementService;
        this.$interval = $interval;
    }

    _createClass(OrderInformationCountdownController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.updateFrequency = this.updateFrequency || 5000;
            this.minutesLeft = Math.max(0, this.minutesLeft);

            this.intervalPromise = this.$interval(function () {
                _this.setTimeRemaining();
            }, this.updateFrequency);

            this.finalDate = new Date(Date.now() + Math.floor(parseFloat(this.minutesLeft) * 60000));
            this.setTimeRemaining();
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.$interval.cancel(this.intervalPromise);
        }
    }, {
        key: 'setTimeRemaining',
        value: function setTimeRemaining() {
            var msec = this.finalDate.getTime() - Date.now();
            if (msec <= 0) {
                this.$interval.cancel(this.intervalPromise);
                this.orderManagementService.invalidate();
                this.orderManagementService.getOrders();
                msec = 0;
            }

            var hours = Math.floor(msec / 1000 / 60 / 60);
            msec -= hours * 1000 * 60 * 60;
            var mins = Math.floor(msec / 1000 / 60);
            msec -= mins * 1000 * 60;
            var secs = Math.floor(msec / 1000);

            var mm = mins < 10 ? '0' + mins : mins;
            var ss = secs < 10 ? '0' + secs : secs;

            this.hours = '' + hours;
            this.mins = '' + mm;
            this.secs = '' + ss;
            this.srTimeString = hours + ' hours, ' + mins + ' minutes, and ' + secs + ' seconds';
            this.minutesLeft -= this.updateFrequency / 60000;
            if (this.minutesLeft <= 0) {
                this.minutesLeft = 0;
            }
        }
    }]);

    return OrderInformationCountdownController;
}();

var orderInformationCountdownComponentDefinition = {
    bindings: {
        minutesLeft: '=',
        updateFrequency: '=?',
        classModifier: '@?'
    },
    controller: ['$interval', 'OrderManagementService', OrderInformationCountdownController],
    template: __webpack_require__(205).trim()
};

module.exports = {
    OrderInformationCountdownController: OrderInformationCountdownController,
    orderInformationCountdownComponentDefinition: orderInformationCountdownComponentDefinition
};

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = "<div class=\"orderInformationItem-timer\" aria-hidden=\"true\">\r\n    <div class=\"orderInformationItem-timerMessage\">\r\n        <div>\r\n            <img src=\"/images/express/icon-express-delivery-truck.png\" alt=\"Express delivery icon\">\r\n        </div>\r\n        Estimated Time of Arrival\r\n    </div>\r\n\r\n    <div class=\"orderInformationItem-timerCounter\">\r\n        {{$ctrl.hours}} : {{$ctrl.mins}} : {{$ctrl.secs}}\r\n    </div>\r\n\r\n    <div class=\"orderInformationItem-timerUnit\">\r\n        <div>Hour</div>\r\n        <div>Minutes</div>\r\n        <div>Seconds</div>\r\n    </div>\r\n</div>\r\n\r\n<span class=\"sr-only\">{{$ctrl.srTimeString}}</span>\r\n"

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var PartnerService = __webpack_require__(207);
var partnerDirectiveDefinition = __webpack_require__(208);
var partnerSmallFormatDirectiveDefinition = __webpack_require__(210);

var _require = __webpack_require__(212),
    conveniencePackTileListComponentDefinition = _require.conveniencePackTileListComponentDefinition;

angular.module('wowApp.shop').service('PartnerService', ['Restangular', PartnerService]).directive('wowPartner', ['AddressService', 'PartnerService', '$state', partnerDirectiveDefinition]).directive('wowPartnerSmallFormat', [partnerSmallFormatDirectiveDefinition]).component('wowConveniencePackTileList', conveniencePackTileListComponentDefinition);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function PartnerService(restangular) {
    this._api = restangular.one('partners');
}

PartnerService.prototype.getPartner = _.memoize(function (id) {
    return this._api.one(id).get();
});

PartnerService.prototype.getBranch = _.memoize(function (id) {
    return this._api.one('branches', id).get();
});

module.exports = PartnerService;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

module.exports = function (addressService, partnerService, $state) {
    return {
        restrict: 'E',
        scope: {},
        link: function link(scope) {
            scope.statePicker = {};

            scope.selectedBranch = function (branch) {
                addressService.setPartnerDeliveryAddress(branch);
            };

            if ($state.params.id) {
                partnerService.getPartner($state.params.id).then(function (response) {
                    scope.branchAddresses = response.PartnerBranchAddress;

                    scope.states = _.uniq(_.map(scope.branchAddresses, 'State'));
                    scope.statePicker.currentState = scope.states[0];
                });
            }
        },

        template: __webpack_require__(209).trim()
    };
};

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = "<div class=\"partner\" ng-if=\"branchAddresses\">\r\n    <wow-select-container>\r\n        <label for=\"states\">Filter by state</label>\r\n        <select id=\"states\" ng-model=\"statePicker.currentState\" ng-options=\"state for state in states\"></select>\r\n    </wow-select-container>\r\n\r\n    <ul class=\"partner-addressWrapper\" wow-scrollbar wow-hide-scroll>\r\n        <li ng-repeat=\"branch in branchAddresses\" ng-if=\"branch.State == statePicker.currentState\">\r\n            <a class=\"partner-addressLink\" ui-sref=\"shop.partnerbranch({ id: branch.PartnerBranchId })\" ng-click=\"selectedBranch(branch)\">\r\n                <div class=\"partner-addressSuburb\">{{branch.Name}}</div>\r\n                <div class=\"partner-addressStreet\">{{branch.Street1}}</div>\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</div>\r\n"

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return {
        restrict: 'E',
        transclude: true,
        scope: {},
        template: __webpack_require__(211).trim()
    };
};

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports = "<div class=\"partner-smallFormat\" wow-scrollbar wow-hide-scroll>\r\n    <div class=\"partner-smallFormat-content u-xsContentHeight\">\r\n        <oly-dynamic-content class=\"dynamic-content2-panelTop\" oly-dc-url-schedule></oly-dynamic-content>\r\n        <ng-transclude></ng-transclude>\r\n        <oly-dynamic-content class=\"dynamic-content2-panelBottom\" oly-dc-url-schedule=\"bottom\"></oly-dynamic-content>\r\n    </div>\r\n</div>"

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    map = _require.map,
    _require2 = __webpack_require__(10),
    createBundleTiles = _require2.createBundleTiles;

var ConveniencePackTileListController = function () {
    function ConveniencePackTileListController(settings, trolleyService, productGroupService) {
        _classCallCheck(this, ConveniencePackTileListController);

        this.settings = settings;
        this.trolleyService = trolleyService;
        this.productGroupService = productGroupService;
    }

    _createClass(ConveniencePackTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = this.productGroupService.getSortOptions();
        }
    }, {
        key: 'createTiles',
        value: function createTiles(bundles) {
            return {
                items: createBundleTiles(bundles.items),
                totalRecordCount: bundles.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber) {
            var _this = this;

            var sortType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Name';

            return this.productGroupService.selectProductGroup(this.packId).then(function () {
                return _this.productGroupService.getProducts({ pageNumber: pageNumber, pageSize: pageSize, sortType: sortType });
            }).then(function (bundles) {
                return _this.createTiles(bundles);
            });
        }
    }, {
        key: 'addAll',
        value: function addAll() {
            var _this2 = this;

            this.productGroupService.getProducts({ pageNumber: 0, pageSize: this.productGroupService.selectedGroupTotalCount, sortType: 'Name' }).then(function (response) {
                _this2.trolleyService.addItemsToTrolley(map(response.items, function (item) {
                    return item.Products[0];
                }));
            });
        }
    }]);

    return ConveniencePackTileListController;
}();

ConveniencePackTileListController.$inject = ['Settings', 'TrolleyService', 'ProductGroupService'];

var conveniencePackTileListComponentDefinition = {
    bindings: {
        packId: '<',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: ConveniencePackTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.productGroupService.selectedGroup.Name"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">\n\n            <top-right>\n                <button class="button button--primary" ng-click="$ctrl.addAll()">\n                    Add all ({{ $ctrl.productGroupService.selectedGroupTotalCount }})\n                </button>\n            </top-right>\n        </wow-tile-list>\n    '
};

module.exports = {
    ConveniencePackTileListController: ConveniencePackTileListController,
    conveniencePackTileListComponentDefinition: conveniencePackTileListComponentDefinition
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.shop');

wowApp.component('wowPrice', __webpack_require__(214).priceControllerComponentDefinition);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PriceController = function () {
    function PriceController(currencyFilter) {
        _classCallCheck(this, PriceController);

        this.currencyFilter = currencyFilter;
    }

    _createClass(PriceController, [{
        key: '$onInit',
        value: function $onInit() {
            this.buildDisplayPrice(this.price);
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(change) {
            this.buildDisplayPrice(change.price.currentValue);
        }
    }, {
        key: 'buildDisplayPrice',
        value: function buildDisplayPrice(price) {
            if (price === undefined) {
                return;
            }

            var displayPrice = this.currencyFilter(price);

            this.currencySymbol = displayPrice.slice(0, 1);

            var _displayPrice$slice$s = displayPrice.slice(1).split('.');

            var _displayPrice$slice$s2 = _slicedToArray(_displayPrice$slice$s, 2);

            this.priceDollar = _displayPrice$slice$s2[0];
            this.priceCents = _displayPrice$slice$s2[1];
        }
    }]);

    return PriceController;
}();

var priceControllerComponentDefinition = {
    bindings: {
        per: '<?',
        price: '<',
        priceClassModifier: '@?'
    },
    controller: ['currencyFilter', PriceController],
    template: __webpack_require__(215).trim()
};

module.exports = {
    PriceController: PriceController,
    priceControllerComponentDefinition: priceControllerComponentDefinition
};

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = "<div class=\"price\" ng-class=\"::$ctrl.priceClassModifier\">\r\n    <span class=\"price-symbol\">{{ ::$ctrl.currencySymbol }}</span>\r\n    <span class=\"price-dollars\">{{ $ctrl.priceDollar }}</span>\r\n    <div class=\"price-centsPer\">\r\n        <span class=\"price-cents\">{{ $ctrl.priceCents }}</span>\r\n        <span ng-if=\"$ctrl.per\" class=\"price-per\">{{ $ctrl.per }}</span>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.shop');

wowApp.component('wowSimplePrice', __webpack_require__(217).simplePriceControllerComponentDefinition);

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimplePriceController = function () {
    function SimplePriceController(currencyFilter) {
        _classCallCheck(this, SimplePriceController);

        this.currencyFilter = currencyFilter;
    }

    _createClass(SimplePriceController, [{
        key: '$onInit',
        value: function $onInit() {
            this.buildDisplayPrice(this.price);
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(change) {
            this.buildDisplayPrice(change.price.currentValue);
        }
    }, {
        key: 'buildDisplayPrice',
        value: function buildDisplayPrice(price) {
            if (price === undefined) {
                return;
            }

            var displayPrice = this.currencyFilter(price);

            this.currencySymbol = displayPrice.slice(0, 1);

            var _displayPrice$slice$s = displayPrice.slice(1).split('.');

            var _displayPrice$slice$s2 = _slicedToArray(_displayPrice$slice$s, 2);

            this.priceDollar = _displayPrice$slice$s2[0];
            this.priceCents = _displayPrice$slice$s2[1];
        }
    }]);

    return SimplePriceController;
}();

var simplePriceControllerComponentDefinition = {
    bindings: {
        price: '<',
        priceClassModifier: '@?'
    },
    controller: ['currencyFilter', SimplePriceController],
    template: '\n        <div class="simplePrice" ng-class="::$ctrl.priceClassModifier">\n            <span class="simplePrice-dollars">{{ ::$ctrl.currencySymbol }}{{ $ctrl.priceDollar }}.{{ $ctrl.priceCents }}</span>\n        </div>\n    '
};

module.exports = {
    SimplePriceController: SimplePriceController,
    simplePriceControllerComponentDefinition: simplePriceControllerComponentDefinition
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(219),
    ProductGroupService = _require.ProductGroupService;

var _require2 = __webpack_require__(220),
    productGroupNavComponentDefinition = _require2.productGroupNavComponentDefinition;

var _require3 = __webpack_require__(222),
    productGroupTileListComponentDefinition = _require3.productGroupTileListComponentDefinition;

angular.module('wowApp.shop').service('ProductGroupService', ProductGroupService).component('wowProductGroup', productGroupNavComponentDefinition).component('wowProductGroupTileList', productGroupTileListComponentDefinition);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    filter = _require.filter,
    some = _require.some,
    forEach = _require.forEach;

var ProductGroupService = function () {
    function ProductGroupService(restangular, $q, settings, sortByKeys, $location) {
        _classCallCheck(this, ProductGroupService);

        this._productGroupRoute = restangular.one('ProductGroup');
        this.selectedGroup = undefined;
        this.settings = settings;
        this.sortByKeys = sortByKeys;
        this.$q = $q;
        this.$location = $location;

        this.items = [];
        this._groupCache = {};
    }

    _createClass(ProductGroupService, [{
        key: 'selectProductGroup',
        value: function selectProductGroup(id) {
            var _this = this;

            if (!(id in this._groupCache)) {
                this._groupCache[id] = this._productGroupRoute.one(id).get();
            }

            this.productGroupPromise = this._groupCache[id].then(function (response) {
                _this.selectedGroup = response;
                return response;
            });

            return this.productGroupPromise;
        }
    }, {
        key: 'getSelectedProductGroup',
        value: function getSelectedProductGroup() {
            return this.productGroupPromise ? this.productGroupPromise : this.$q.when({});
        }
    }, {
        key: 'listForVisualShopping',
        value: function listForVisualShopping() {
            var _this2 = this;

            return this._productGroupRoute.one('ListForVisualShopping').get().then(function (items) {
                _this2.items = items;
                return items;
            });
        }
    }, {
        key: 'getProducts',
        value: function getProducts(pageSize, pageNumber, sortType, filters) {
            var _this3 = this;

            this.selectedGroupTotalCount = undefined;
            return this._productGroupRoute.one('Products').post(this.selectedGroup.Url, {
                PageNumber: pageNumber,
                PageSize: pageSize || 10,
                SortType: sortType,
                Filters: filters ? filters.filters : [],
                Location: this.$location.url()
            }).then(function (response) {
                _this3.selectedGroupTotalCount = response.TotalRecordCount;
                return {
                    items: response.Items,
                    totalRecordCount: response.TotalRecordCount,
                    aggregations: filter(response.Aggregations, function (a) {
                        return a.ShowFilter;
                    }) // later we will need to accommodate multiple aggregations from this point on
                };
            });
        }
    }, {
        key: 'isGroupEligibleForRanking',
        value: function isGroupEligibleForRanking() {
            return !!(this.selectedGroup && this.selectedGroup.IsEligibleForRanking);
        }
    }, {
        key: 'getSortOptions',
        value: function getSortOptions() {
            var sortGroup = this.isGroupEligibleForRanking() ? 'productGroup' : 'browse';

            return {
                sortTypes: this.settings[sortGroup].sortOptions,
                sortContext: this.sortByKeys.PRODUCT_GROUPS_KEY
            };
        }
    }, {
        key: 'getDepartmentGroup',
        value: function getDepartmentGroup(departments, includedDepartmentIds) {
            var selectedDepartment = 'Other';

            // if a product has multiple departments - we only want to display the department that is part of the main departments (whitelisted)
            // eslint-disable-next-line consistent-return
            forEach(departments, function (department) {
                if (some(includedDepartmentIds, function (departmentId) {
                    return departmentId.toLowerCase() === department.Id.toLowerCase();
                })) {
                    selectedDepartment = department.Description;
                    // this how we exit from the foreach loop in lodash by returning false
                    return false;
                }
            });

            return selectedDepartment;
        }
    }]);

    return ProductGroupService;
}();

ProductGroupService.$inject = ['Restangular', '$q', 'Settings', 'SortByKeys', '$location'];

module.exports = { ProductGroupService: ProductGroupService };

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductGroupNavController = function () {
    function ProductGroupNavController(productGroupService, offerGroupService) {
        _classCallCheck(this, ProductGroupNavController);

        this.productGroupService = productGroupService;
        this.offerGroupService = offerGroupService;
    }

    _createClass(ProductGroupNavController, [{
        key: '$onInit',
        value: function $onInit() {
            this.groupService = this.groupType === 'OfferGroup' ? this.offerGroupService : this.productGroupService;
        }
    }, {
        key: 'isGroupLoading',
        value: function isGroupLoading() {
            return this.groupService.selectedGroup === undefined;
        }
    }, {
        key: 'isCountLoading',
        value: function isCountLoading() {
            return this.groupService.selectedGroupTotalCount === undefined;
        }
    }]);

    return ProductGroupNavController;
}();

ProductGroupNavController.$inject = ['ProductGroupService', 'OfferGroupService'];

var productGroupNavComponentDefinition = {
    bindings: {
        groupType: '='
    },
    controller: ProductGroupNavController,
    template: __webpack_require__(221).trim()
};

module.exports = {
    ProductGroupNavController: ProductGroupNavController,
    productGroupNavComponentDefinition: productGroupNavComponentDefinition
};

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navigation\" ng-if=\"$ctrl.groupService.selectedGroup\">\r\n    <h2 class=\"sr-only\">Product Group Navigation</h2>\r\n\r\n    <a class=\"navigation-link is-active\" ui-sref=\".\" ui-sref-opts=\"{ reload: true }\">\r\n        <span>\r\n            {{ $ctrl.groupService.selectedGroup.Description }}\r\n            <span ng-if=\"$ctrl.groupService.selectedGroupTotalCount\">({{ $ctrl.groupService.selectedGroupTotalCount }})</span>\r\n        </span>\r\n    </a>\r\n</nav>\r\n"

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(10),
    createBundleTiles = _require.createBundleTiles;

var _require2 = __webpack_require__(0),
    map = _require2.map;

var ProductGroupTileListController = function () {
    function ProductGroupTileListController(settings, analyticsService, productGroupService) {
        _classCallCheck(this, ProductGroupTileListController);

        this.settings = settings;
        this.analyticsService = analyticsService;
        this.productGroupService = productGroupService;
    }

    _createClass(ProductGroupTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = this.productGroupService.getSortOptions();
        }
    }, {
        key: 'title',
        value: function title() {
            var description = this.productGroupService.selectedGroup.Description;

            return this.productGroupService.selectedGroupTotalCount != null ? description + ' (' + this.productGroupService.selectedGroupTotalCount + ')' : description;
        }
    }, {
        key: 'createTiles',
        value: function createTiles(products) {
            return {
                items: createBundleTiles(products.items),
                totalRecordCount: products.totalRecordCount,
                aggregations: products.aggregations
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber) {
            var _this = this;

            var sortType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Name';
            var filters = arguments[3];

            return this.productGroupService.selectProductGroup(this.productGroupId).then(function () {
                return _this.productGroupService.getProducts(pageSize, pageNumber, sortType, filters);
            }).then(function (products) {
                return _this.createTiles(products);
            });
        }
    }, {
        key: 'createAnalyticsData',
        value: function createAnalyticsData(contentData) {
            return {
                pageNumber: contentData.pageNumber,
                currentCategory: this.productGroupService.selectedGroup,
                products: map(contentData.items, function (item) {
                    return { Name: item.data.product.Name, Products: [item.data.product] };
                }),
                inspirationCards: { Cards: contentData.inspirationCards },
                totalRecordCount: this.productGroupService.selectedGroupTotalCount,
                filters: contentData.filters,
                sortType: contentData.sortType ? contentData.sortType.Value : '',
                sortOptions: this.sortOptions
            };
        }
    }, {
        key: 'pushContentDataToAnalytics',
        value: function pushContentDataToAnalytics(contentData) {
            this.analyticsService.push({
                data: this.createAnalyticsData(contentData),
                type: this.analyticsService.mapperTypes.shop.productCategory
            });
        }
    }]);

    return ProductGroupTileListController;
}();

ProductGroupTileListController.$inject = ['Settings', 'AnalyticsService', 'ProductGroupService'];

var productGroupTileListComponentDefinition = {
    bindings: {
        productGroupId: '<?',
        pageNumber: '<',
        sortBy: '<',
        filter: '<'
    },
    controller: ProductGroupTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.title()"\n            page-number="$ctrl.pageNumber"\n            total-record-count="$ctrl.productGroupService.selectedGroupTotalCount"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            filter="$ctrl.filter"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType, filter)"\n            push-content-to-analytics="$ctrl.pushContentDataToAnalytics(contentData)">\n        </wow-tile-list>\n    '
};

module.exports = {
    ProductGroupTileListController: ProductGroupTileListController,
    productGroupTileListComponentDefinition: productGroupTileListComponentDefinition
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.shop');

wowApp.service('ShelfProductService', ['Restangular', 'DetailProductService', 'TrolleyService', __webpack_require__(224)]);
wowApp.service('DetailProductService', ['Restangular', '$rootScope', 'BreakpointsService', __webpack_require__(225)]);

wowApp.component('wowShelfBundleTile', __webpack_require__(226).shelfBundleTileComponentDefinition);
wowApp.component('wowShelfProductVariant', __webpack_require__(228).shelfProductVariantComponentDefinition);

wowApp.component('wowShelfProductTile', __webpack_require__(230).shelfProductTileComponentDefinition);
wowApp.component('wowShelfProductList', __webpack_require__(232).shelfProductListComponentDefinition);
wowApp.component('wowShelfProductTileOffer', __webpack_require__(234).shelfProductTileOfferComponentDefinition);
wowApp.component('wowShelfProductListOffer', __webpack_require__(236).shelfProductListOfferComponentDefinition);
wowApp.component('wowShelfProductTagCenter', __webpack_require__(238).shelfProductTagCenterComponentDefinition);
wowApp.component('wowShelfProductTagImage', __webpack_require__(240).shelfProductTagImageComponentDefinition);

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var UrlInfo = __webpack_require__(30);

var _api = void 0,
    _browseApi = void 0,
    _detailProductService = void 0,
    _trolleyService = void 0;

var ShelfProductService = function ShelfProductService(Restangular, detailProductService, trolleyService) {
    _api = Restangular.all('products');
    _detailProductService = detailProductService;
    _trolleyService = trolleyService;
    _browseApi = Restangular.one('browse');
};

/*
 * Calls /products/<stockcode>
 */
ShelfProductService.prototype.getProductDetail = function (stockcode) {
    return _api.get(stockcode);
};

/*
 * Calls /products/<stockcodes>
 */
ShelfProductService.prototype.getProductsByStockcodes = function (stockcodes, excludeUnavailable, source) {
    return _api.get(stockcodes.join(), {
        excludeUnavailable: !!excludeUnavailable,
        source: source
    });
};

/*
 * calls /products?filters
 */
ShelfProductService.prototype.getProducts = function (args) {
    return _api.getList(args).then(function (response) {

        // At the moment we are only adding from Visual Shopping, once we introduce another
        // way to populate the products container this code will need to be re-evaluated.
        _.forEach(response, function (bundle) {
            _.forEach(bundle.Products, function (product) {
                // Set the add to trolley source for analytics.
                product.Source = 'VisualShopping';
            });
        });

        return response;
    });
};

ShelfProductService.prototype.processTrolleyProductTagLink = function (tagLink) {

    // breaks the link with the urlInfo
    var url = new UrlInfo(tagLink);
    var search = url.getSearchObject();
    var path = url.pathname();

    // Only AddToTrolley and AddMultiToTrolley should change,
    // the other tags will follow the link as usual
    if (path.indexOf('AddToTrolley') >= 0 || path.indexOf('AddMultiToTrolley') >= 0) {
        var codes = search.stockcode.split(',');
        for (var i = 0; i < codes.length; i++) {
            this.addItemToTrolley(codes[i], search.quantity, search.source);
        }

        return true;
    }

    return false;
};

ShelfProductService.prototype.addItemToTrolley = function (stockCode, quantity, source) {

    // Quantity is undefined when add multiple items to the trolley
    quantity = quantity !== undefined ? parseInt(quantity) : 1;
    return _detailProductService.getProductDetail(stockCode).then(function (result) {
        var product = result.Product;
        if (product.IsInTrolley) {
            var addQuantity = product.QuantityInTrolley + quantity;
            _trolleyService.updateTrolleyItem(product, addQuantity);
        } else {
            _trolleyService.addItemToTrolley(product, quantity, source);
        }
    });
};

/*
 * calls /browse?filters
 */
ShelfProductService.prototype.getBrowsePage = function (args) {
    return _browseApi.post('category', args);
};

module.exports = ShelfProductService;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    isEmpty = _require.isEmpty;

var ShelfProductDetailService = function ShelfProductDetailService(Restangular, $rootScope, breakpointsService) {
    var _this = this;

    this._api = Restangular.one('product');
    this.breakpointsService = breakpointsService;

    // We invalidate when the trolley updates because product detail
    // objects contain information about quantity in trolley.
    $rootScope.$on('trolley:update', function () {
        _this.invalidate();
    });
};

var detailsCache = {};

ShelfProductDetailService.prototype.getProductDetail = function (productStockcode, aisle, category, validateUrl, storeNo) {
    var key = productStockcode + '_' + (isEmpty(storeNo) ? 'online' : storeNo);
    if (!(key in detailsCache)) {
        detailsCache[key] = this._api.one('detail', productStockcode).get({
            aisle: aisle, category: category, validateUrl: validateUrl, isMobile: this.breakpointsService.isInSmallFormat, storeNo: storeNo
        });
    }

    return detailsCache[key];
};

ShelfProductDetailService.prototype.getGeolocationProductStoreDetail = function (productStockcode, latitude, longitude, max, includeInStockStoreOnly) {
    return this._api.one(productStockcode + '/Stores').get({
        Latitude: latitude,
        Longitude: longitude,
        Max: max || 5,
        IncludeInStockStoreOnly: includeInStockStoreOnly || false
    });
};

ShelfProductDetailService.prototype.getPostcodeProductStoreDetail = function (productStockcode, postcode, max, includeInStockStoreOnly) {
    return this._api.one(productStockcode + '/Stores').get({ Postcode: postcode, Max: max || 5, IncludeInStockStoreOnly: includeInStockStoreOnly || false });
};

ShelfProductDetailService.prototype.invalidate = function () {
    detailsCache = {};
};

module.exports = ShelfProductDetailService;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShelfBundleTileController = function ShelfBundleTileController() {
    _classCallCheck(this, ShelfBundleTileController);
};

var shelfBundleTileComponentDefinition = {
    bindings: {
        bundle: '<'
    },
    controller: ShelfBundleTileController,
    template: __webpack_require__(227).trim()
};

module.exports = {
    ShelfBundleTileController: ShelfBundleTileController,
    shelfBundleTileComponentDefinition: shelfBundleTileComponentDefinition
};

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfBundleTile tile\">\r\n    <div class=\"shelfBundleTile-title\" ng-bind-html=\"::$ctrl.bundle.Name | sanitize\"></div>\r\n\r\n    <ul class=\"shelfBundleTile-list\">\r\n        <li class=\"shelfBundleTile-item\" ng-repeat=\"product in ::$ctrl.bundle.Products | orderBy:'UnitWeightInGrams' track by product.Stockcode\">\r\n            <wow-shelf-product-variant total-variants=\"::$ctrl.bundle.Products.length\" product=\"::product\"></wow-shelf-product-variant>\r\n        </li>\r\n    </ul>\r\n</div>\r\n"

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShelfProductVariantController = function () {
    function ShelfProductVariantController(config, trolleyService, analytics) {
        _classCallCheck(this, ShelfProductVariantController);

        this.config = config;
        this.trolleyService = trolleyService;
        this.analytics = analytics;
    }

    _createClass(ShelfProductVariantController, [{
        key: '$onInit',
        value: function $onInit() {
            this.defaultImagePath = this.config.DefaultProductImageSmall;
        }
    }, {
        key: 'gtmProductClickDataPush',
        value: function gtmProductClickDataPush() {
            this.analytics.push({ data: this.product, type: this.analytics.mapperTypes.customEvent.productClick });
        }
    }]);

    return ShelfProductVariantController;
}();

var shelfProductVariantComponentDefinition = {
    bindings: {
        product: '<',
        totalVariants: '='
    },
    controller: ['config', 'TrolleyService', 'AnalyticsService', ShelfProductVariantController],
    template: __webpack_require__(229).trim()
};

module.exports = {
    ShelfProductVariantController: ShelfProductVariantController,
    shelfProductVariantComponentDefinition: shelfProductVariantComponentDefinition
};

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfProductVariant\" ng-class=\"'shelfProductVariant--' + $ctrl.totalVariants\">\r\n    <a ui-sref=\"shop.productdetails({productId: $ctrl.product.Stockcode, productName: $ctrl.product.UrlFriendlyName})\"\r\n        ng-click=\"::$ctrl.gtmProductClickDataPush()\"\r\n        class=\"shelfProductVariant-product\">\r\n        <div class=\"shelfProductVariant-details\">\r\n            <div class=\"shelfProductVariant-variant\">\r\n                {{::$ctrl.product.PackageSize}}\r\n            </div>\r\n\r\n            <div ng-if=\"::$ctrl.product.IsInStock\">\r\n                <div class=\"shelfProductVariant-price\">\r\n                    {{::$ctrl.product.Price | currency}}\r\n                </div>\r\n\r\n                <div class=\"shelfProductVariant-cup\" ng-if=\"::$ctrl.product.HasCupPrice\">\r\n                    {{::$ctrl.product.CupString}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"shelfProductVariant-imageContainer\">\r\n\r\n            <img class=\"shelfProductVariant-imageTag\"\r\n                ng-if=\"::$ctrl.product.ImageTag.TagContent\"\r\n                ng-src=\"{{::$ctrl.product.ImageTag.TagContent}}\"\r\n                alt=\"{{::$ctrl.product.ImageTag.FallbackText}}\"/>\r\n\r\n            <img class=\"shelfProductVariant-image\"\r\n                ng-class=\"{'shelfProductVariant-imageOpacity' : !$ctrl.product.IsInStock}\"\r\n                alt=\"{{ ::$ctrl.product.Name }}\"\r\n                ng-src=\"{{ ::$ctrl.product.MediumImageFile }}\"\r\n                oly-error-src=\"{{::$ctrl.defaultImagePath}}\"\r\n            />\r\n\r\n            <div class=\"shelfProductVariant-overlay\" ng-if=\"::!$ctrl.product.IsInStock\">Out of stock</div>\r\n        </div>\r\n    </a>\r\n\r\n    <div class=\"shelfProductVariant-controls\">\r\n        <wow-product-save-to-list\r\n            product=\"::$ctrl.product\">\r\n        </wow-product-save-to-list>\r\n\r\n        <wow-cart-controls\r\n            ng-if=\"::$ctrl.product.IsInStock\"\r\n            shelf-product=\"::$ctrl.product\"\r\n            trolley-product=\"$ctrl.trolleyService.trolleyProductsByStockcode[$ctrl.product.Stockcode]\"\r\n            source=\"{{ ::$ctrl.product.Source }}\">\r\n        </wow-cart-controls>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    includes = _require.includes,
    lowerCase = _require.lowerCase,
    round = _require.round;

var restrictionTypes = {
    NONE: 'NONE',
    PM_DELIVERY: 'PM_DELIVERY',
    DELIVERY_ONLY: 'DELIVERY_ONLY',
    COLLECTION_ONLY: 'COLLECTION_ONLY',
    EXPRESS_DELIVERY_ONLY: 'EXPRESS_DELIVERY_ONLY'
};

var ShelfProductTileController = function () {
    function ShelfProductTileController(config, settings, trolleyService, ratingService, analyticsService) {
        _classCallCheck(this, ShelfProductTileController);

        this.config = config;
        this.settings = settings;
        this.trolleyService = trolleyService;
        this.ratingService = ratingService;
        this.analyticsService = analyticsService;
        this.restrictionTypes = restrictionTypes;
    }

    _createClass(ShelfProductTileController, [{
        key: '$onInit',
        value: function $onInit() {
            this.productRestriction = this.getRestriction();
            this.shouldShowSavingsTag = this.product.IsOnSpecial && this.product.HasHeaderTag && this.product.HeaderTag.Promotion !== 'Special' && this.product.SavingsAmount > 0;

            if (this.productRestriction === 'PM_DELIVERY') {
                this.restrictionDelivery = this.product.ProductRestrictionMessage;
            }

            if (this.productRestriction === 'DELIVERY_ONLY') {
                this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionDeliveryOnly;
            }

            if (this.productRestriction === 'COLLECTION_ONLY') {
                this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionPickUpOnly;
            }

            if (this.productRestriction === 'EXPRESS_DELIVERY_ONLY') {
                this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionExpressDeliveryOnly;
            }

            // This is a hack for showing centre tags if the special is a multibuy (multibuys don't have tag content containing the word 'was')
            this.centreTagContainsWas = includes(lowerCase(this.product.CentreTag.TagContent), 'was');

            this.shouldShowCentreTag = this.product.IsCentreTag && !this.product.IsDeliveryPass && (!this.product.IsOnSpecial || !this.centreTagContainsWas);

            this.stars = this.product.Rating && this.product.Rating.Average ? this.ratingService.populateStars(round(this.product.Rating.Average, 1)) : [];
            this.hasRating = !!this.product.Rating && this.product.Rating.RatingCount >= this.settings.ratingreview.minRatingCount;
        }
    }, {
        key: 'getRestriction',
        value: function getRestriction() {
            if (this.product.IsPmDelivery) {
                return this.restrictionTypes.PM_DELIVERY;
            } else if (this.product.IsForCollection && !this.product.IsForDelivery && !this.product.IsForExpress) {
                return this.restrictionTypes.COLLECTION_ONLY;
            } else if (!this.product.IsForCollection && this.product.IsForDelivery && !this.product.IsForExpress) {
                return this.restrictionTypes.DELIVERY_ONLY;
            } else if (!this.product.IsForCollection && !this.product.IsForDelivery && this.product.IsForExpress) {
                return this.restrictionTypes.EXPRESS_DELIVERY_ONLY;
            }

            return this.restrictionTypes.NONE;
        }
    }, {
        key: 'pushStarRatingClickEventToAnalytics',
        value: function pushStarRatingClickEventToAnalytics() {
            this.analyticsService.push({
                data: {
                    event: {
                        category: 'Ratings&Reviews',
                        label: 'Star Ratings'
                    },
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.linkClick
            });
        }
    }, {
        key: 'pushProductClickEventToAnalytics',
        value: function pushProductClickEventToAnalytics() {
            this.analyticsService.push({
                data: {
                    trackingType: 'link',
                    product: this.product
                },
                type: this.analyticsService.mapperTypes.customEvent.productClick
            });
        }
    }]);

    return ShelfProductTileController;
}();

var shelfProductTileComponentDefinition = {
    bindings: {
        product: '<'
    },
    controller: ['config', 'Settings', 'TrolleyService', 'RatingService', 'AnalyticsService', ShelfProductTileController],
    template: __webpack_require__(231).trim()
};

module.exports = {
    ShelfProductTileController: ShelfProductTileController,
    shelfProductTileComponentDefinition: shelfProductTileComponentDefinition
};

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfProductTile tile\" ng-class=\"{'has-header': $ctrl.product.HeaderTag.Content, 'is-inTrolley' : $ctrl.product.IsInTrolley}\">\r\n    <div class=\"shelfProductTile-content\">\r\n        <a class=\"shelfProductTile-imageWrapper\" ui-sref=\"shop.productdetails({productId: $ctrl.product.Stockcode, productName: $ctrl.product.UrlFriendlyName, product: $ctrl.product})\" ui-sref-opts=\"{ inherit: false }\">\r\n            <div tab-index=\"0\" class=\"shelfProductTile-ratingBlock\"\r\n                ng-class=\"{'has-rating': $ctrl.hasRating}\"\r\n                ng-if=\"$ctrl.hasRating\"\r\n                ng-click=\"$ctrl.pushStarRatingClickEventToAnalytics();\"\r\n                ui-sref-opts=\"{ inherit: false }\">\r\n                <div aria-hidden=\"true\" class=\"shelfProductTile-stars\">\r\n                    <wow-star\r\n                        ng-repeat=\"star in $ctrl.stars track by $index\"\r\n                        star=\"star\">\r\n                    </wow-star>\r\n                </div>\r\n                <span class=\"sr-only\">Average product rating out of 5: {{ ::$ctrl.product.Rating.Average }}. Product score is based on {{ ::$ctrl.product.Rating.RatingCount }} ratings</span>\r\n                <span aria-hidden=\"true\" class=\"shelfProductTile-ratingCount\">({{ ::$ctrl.product.Rating.RatingCount }})</span>\r\n            </div>\r\n\r\n            <span class=\"sr-only\">{{ ::$ctrl.product.FullDescription }} {{ ::$ctrl.product.PackageSize }}</span>\r\n            <img class=\"shelfProductTile-image\"\r\n                ng-class=\"{'shelfProductTile-imageOpacity' : !$ctrl.product.IsPurchasable, 'shelfProductTile-image has-rating': $ctrl.hasRating}\"\r\n                ng-click=\"$ctrl.pushProductClickEventToAnalytics()\"\r\n                ng-src=\"{{ ::$ctrl.product.MediumImageFile }}\"\r\n                alt=\"\" oly-error-src=\"{{ ::$ctrl.config.DefaultProductImage }}\">\r\n\r\n            <div class=\"shelfProductTile-sponsored\" ng-if=\"$ctrl.product.IsSponsoredAd\">\r\n                <span class=\"shelfProductTile-sponsoredText\">\r\n                    {{ $ctrl.settings.sponsoredAds.sponsoredProductText }}\r\n                </span>\r\n            </div>\r\n\r\n            <div class=\"shelfProductTile-exception visible-xs\" ng-if=\"!$ctrl.product.IsPurchasable\">\r\n                <wow-setting ng-if=\"::!$ctrl.product.IsRanged\" setting-group=\"ProductTileAvailability\" setting-name=\"NotRangedMobile\"></wow-setting>\r\n                <wow-setting ng-if=\"::$ctrl.product.IsRanged && !$ctrl.product.IsInStock\" setting-group=\"ProductTileAvailability\" setting-name=\"OutOfStockMobile\"></wow-setting>\r\n            </div>\r\n            <div class=\"shelfProductTile-overlay hidden-xs\" ng-if=\"!$ctrl.product.IsPurchasable\">\r\n                <wow-setting ng-if=\"::!$ctrl.product.IsRanged\" setting-group=\"ProductTileAvailability\" setting-name=\"NotRanged\"></wow-setting>\r\n                <wow-setting ng-if=\"::$ctrl.product.IsRanged && !$ctrl.product.IsInStock\" setting-group=\"ProductTileAvailability\" setting-name=\"OutOfStock\"></wow-setting>\r\n            </div>\r\n        </a>\r\n\r\n        <div class=\"shelfProductTile-information\">\r\n            <h3 class=\"shelfProductTile-description\">\r\n                <a\r\n                    class=\"shelfProductTile-descriptionLink\"\r\n                    ng-click=\"$ctrl.pushProductClickEventToAnalytics()\"\r\n                    ui-sref=\"shop.productdetails({productId: $ctrl.product.Stockcode, productName: $ctrl.product.UrlFriendlyName, product: $ctrl.product})\"\r\n                    ui-sref-opts=\"{reload: false, inherit: false}\">\r\n                    {{ ::$ctrl.product.FullDescription }} {{ ::$ctrl.product.PackageSize }}\r\n                </a>\r\n            </h3>\r\n\r\n            <div ng-if=\"::$ctrl.product.IsPurchasable\">\r\n                <wow-shelf-product-tag-image product=\"::$ctrl.product\"></wow-shelf-product-tag-image>\r\n\r\n                <wow-shelf-product-tile-offer\r\n                    header-tag=\"::$ctrl.product.HeaderTag\">\r\n                </wow-shelf-product-tile-offer>\r\n\r\n                <div class=\"shelfProductTile-ribbonWrapper\">\r\n                    <div class=\"shelfProductTile-ribbon\" ng-if=\"::$ctrl.product.IsNew\">\r\n                        New\r\n                    </div>\r\n                </div>\r\n\r\n                <wow-shelf-product-tag-center product=\"::$ctrl.product\" ng-if=\"::$ctrl.shouldShowCentreTag\">\r\n                </wow-shelf-product-tag-center>\r\n\r\n                <div class=\"shelfProductTile-savings\" ng-if=\"::$ctrl.shouldShowSavingsTag\">\r\n                    <p class=\"shelfProductTile-savingsText\">\r\n                        Save {{ ::$ctrl.product.SavingsAmount | wowCurrencyCents }}\r\n                    </p>\r\n                </div>\r\n\r\n                <div class=\"shelfProductTile-price\">\r\n                    <div>\r\n                        <wow-price price=\"::$ctrl.product.Price\"></wow-price>\r\n\r\n                        <div class=\"shelfProductTile-wasPrice\" ng-if=\"::($ctrl.product.IsOnSpecial && !$ctrl.product.HideWasSavedPrice)\">\r\n                            Was {{ ::($ctrl.product.WasPrice | currency) }}\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"shelfProductTile-cupPrice\" ng-if=\"::$ctrl.product.HasCupPrice\">\r\n                        {{ ::$ctrl.product.CupString }}\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <span class=\"u-flexSpacer\"></span>\r\n\r\n    <a ng-href=\"{{::$ctrl.product.HeaderTag.TagLink}}\" ng-if=\"::($ctrl.product.HasHeaderTag && $ctrl.productRestriction === 'NONE' && $ctrl.product.HeaderTag.TagLink)\" class=\"shelfProductTile-offerLink\">\r\n        View all products in this offer</span>\r\n    </a>\r\n\r\n    <div class=\"shelfProductTile-restriction\" ng-if=\"::($ctrl.productRestriction !== 'NONE' && !$ctrl.product.HeaderTag.TagLink)\">{{$ctrl.restrictionDelivery}}</div>\r\n\r\n    <span class=\"u-flexSpacer\"></span>\r\n\r\n    <div ng-class=\"{ true : 'shelfProductTile-controlsLink', false : 'shelfProductTile-controls' }[$ctrl.settings.shelfProductTile.showSaveToListAsLink]\">\r\n        <wow-product-save-to-list\r\n            class=\"shelfProductTile-saveToList\"\r\n            product=\"::$ctrl.product\"\r\n            show-link=\"true\"\r\n            class-modifier=\"shelfProduct\">\r\n        </wow-product-save-to-list>\r\n\r\n        <wow-cart-controls\r\n            ng-if=\"::$ctrl.product.IsPurchasable && $ctrl.settings.shelfProductTile.showSaveToListAsLink\"\r\n            shelf-product=\"::$ctrl.product\"\r\n            trolley-product=\"$ctrl.trolleyService.trolleyProductsByStockcode[$ctrl.product.Stockcode]\"\r\n            source=\"{{ ::$ctrl.product.Source }}\"\r\n            show-in-trolley-message=\"false\"\r\n            class-modifier=\"shelfProduct-cartControls\">\r\n        </wow-cart-controls>\r\n\r\n        <wow-cart-controls\r\n            ng-if=\"::$ctrl.product.IsPurchasable && !$ctrl.settings.shelfProductTile.showSaveToListAsLink\"\r\n            shelf-product=\"::$ctrl.product\"\r\n            trolley-product=\"$ctrl.trolleyService.trolleyProductsByStockcode[$ctrl.product.Stockcode]\"\r\n            source=\"{{ ::$ctrl.product.Source }}\"\r\n            show-in-trolley-message=\"true\">\r\n        </wow-cart-controls>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    includes = _require.includes,
    lowerCase = _require.lowerCase,
    round = _require.round;

var restrictionTypes = {
    NONE: 'NONE',
    PM_DELIVERY: 'PM_DELIVERY',
    DELIVERY_ONLY: 'DELIVERY_ONLY',
    COLLECTION_ONLY: 'COLLECTION_ONLY',
    EXPRESS_DELIVERY_ONLY: 'EXPRESS_DELIVERY_ONLY'
};

var ShelfProductListController = function () {
    function ShelfProductListController(config, settings, trolleyService, ratingService, analyticsService) {
        _classCallCheck(this, ShelfProductListController);

        this.config = config;
        this.settings = settings;
        this.trolleyService = trolleyService;
        this.ratingService = ratingService;
        this.analyticsService = analyticsService;
        this.restrictionTypes = restrictionTypes;
    }

    _createClass(ShelfProductListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.productRestriction = this.getRestriction();
            this.shouldShowSavingsTag = this.product.IsOnSpecial && this.product.HasHeaderTag && this.product.SavingsAmount > 0;

            if (this.productRestriction === 'PM_DELIVERY') {
                this.restrictionDelivery = this.product.ProductRestrictionMessage;
            }

            if (this.productRestriction === 'DELIVERY_ONLY') {
                this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionDeliveryOnly;
            }

            if (this.productRestriction === 'COLLECTION_ONLY') {
                this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionPickUpOnly;
            }

            if (this.productRestriction === 'EXPRESS_DELIVERY_ONLY') {
                this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionExpressDeliveryOnly;
            }

            // This is a hack for showing centre tags if the special is a multibuy (multibuys don't have tag content containing the word 'was')
            this.centreTagContainsWas = includes(lowerCase(this.product.CentreTag.TagContent), 'was');

            this.shouldShowCentreTag = this.product.IsCentreTag && !this.product.IsDeliveryPass && (!this.product.IsOnSpecial || !this.centreTagContainsWas);

            this.stars = this.product.Rating && this.product.Rating.Average ? this.ratingService.populateStars(round(this.product.Rating.Average, 1)) : [];
            this.hasRating = !!this.product.Rating && this.product.Rating.RatingCount >= this.settings.ratingreview.minRatingCount;
        }
    }, {
        key: 'getRestriction',
        value: function getRestriction() {
            if (this.product.IsPmDelivery) {
                return this.restrictionTypes.PM_DELIVERY;
            } else if (this.product.IsForCollection && !this.product.IsForDelivery && !this.product.IsForExpress) {
                return this.restrictionTypes.COLLECTION_ONLY;
            } else if (!this.product.IsForCollection && this.product.IsForDelivery && !this.product.IsForExpress) {
                return this.restrictionTypes.DELIVERY_ONLY;
            } else if (!this.product.IsForCollection && !this.product.IsForDelivery && this.product.IsForExpress) {
                return this.restrictionTypes.EXPRESS_DELIVERY_ONLY;
            }

            return this.restrictionTypes.NONE;
        }
    }, {
        key: 'pushStarRatingClickEventToAnalytics',
        value: function pushStarRatingClickEventToAnalytics() {
            this.analyticsService.push({
                data: {
                    event: {
                        category: 'Ratings&Reviews',
                        label: 'Star Ratings'
                    },
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.linkClick
            });
        }
    }, {
        key: 'pushProductClickEventToAnalytics',
        value: function pushProductClickEventToAnalytics() {
            this.analyticsService.push({
                data: {
                    trackingType: 'link',
                    product: this.product
                },
                type: this.analyticsService.mapperTypes.customEvent.productClick
            });
        }
    }]);

    return ShelfProductListController;
}();

var shelfProductListComponentDefinition = {
    bindings: {
        product: '<'
    },
    controller: ['config', 'Settings', 'TrolleyService', 'RatingService', 'AnalyticsService', ShelfProductListController],
    template: __webpack_require__(233).trim()
};

module.exports = {
    ShelfProductListController: ShelfProductListController,
    shelfProductListComponentDefinition: shelfProductListComponentDefinition
};

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfProductList\" ng-class=\"{'is-inTrolley' : $ctrl.product.IsInTrolley}\">\r\n    <div class=\"shelfProductList-content\">\r\n        <a class=\"shelfProductList-imageWrapper\" ui-sref=\"shop.productdetails({productId: $ctrl.product.Stockcode, productName: $ctrl.product.UrlFriendlyName, product: $ctrl.product})\" ui-sref-opts=\"{ inherit: false }\">\r\n\r\n            <span class=\"sr-only\">{{ ::$ctrl.product.FullDescription }} {{ ::$ctrl.product.PackageSize }}</span>\r\n            <img class=\"shelfProductList-image\" ng-class=\"{'shelfProductList-imageOpacity' : !$ctrl.product.IsPurchasable, 'shelfProductList-image has-rating': $ctrl.hasRating}\" ng-click=\"$ctrl.pushProductClickEventToAnalytics()\" ng-src=\"{{ ::$ctrl.product.SmallImageFile }}\" alt=\"\" oly-error-src=\"{{ ::$ctrl.config.DefaultProductImage }}\">\r\n        </a>\r\n\r\n        <div class=\"shelfProductList-information\">\r\n            <h3 class=\"shelfProductList-description\">\r\n                <a class=\"shelfProductList-descriptionLink\" ng-click=\"$ctrl.pushProductClickEventToAnalytics()\" ui-sref=\"shop.productdetails({productId: $ctrl.product.Stockcode, productName: $ctrl.product.UrlFriendlyName, product: $ctrl.product})\">\r\n                    {{ ::$ctrl.product.FullDescription }} {{ ::$ctrl.product.PackageSize }}\r\n                </a>\r\n            </h3>\r\n            <div class=\"shelfProductList-details\">\r\n                <div class=\"shelfProductList-detailsWrapper\">\r\n                    <div class=\"shelfProductList-cupPrice\" ng-if=\"::$ctrl.product.HasCupPrice && $ctrl.product.IsPurchasable\">\r\n                        {{ ::$ctrl.product.CupString }}\r\n                    </div>\r\n                    <wow-shelf-product-list-offer ng-if=\"::$ctrl.product.IsPurchasable\" product=\"::$ctrl.product\">\r\n                    </wow-shelf-product-list-offer>\r\n\r\n                    <div class=\"shelfProductList-overlay\" ng-if=\"!$ctrl.product.IsPurchasable\">\r\n                        <wow-setting class=\"shelfProductList-overlay-text\" ng-if=\"::!$ctrl.product.IsRanged\" setting-group=\"ProductTileAvailability\" setting-name=\"NotRanged\"></wow-setting>\r\n                        <wow-setting class=\"shelfProductList-overlay-text\" ng-if=\"::$ctrl.product.IsRanged && !$ctrl.product.IsInStock\" setting-group=\"ProductTileAvailability\" setting-name=\"OutOfStock\"></wow-setting>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"shelfProductList-price\" ng-if=\"::$ctrl.product.IsPurchasable\">\r\n            <wow-simple-price price=\"::$ctrl.product.Price\"></wow-simple-price>\r\n\r\n            <div class=\"shelfProductList-wasPrice\" ng-if=\"::($ctrl.product.IsOnSpecial && !$ctrl.product.HideWasSavedPrice)\">\r\n                Was {{ ::($ctrl.product.WasPrice | currency) }}\r\n            </div>\r\n        </div>\r\n        <div class=\"shelfProductList-controlsLink\">\r\n            <wow-cart-controls ng-if=\"::$ctrl.product.IsPurchasable\" shelf-product=\"::$ctrl.product\" trolley-product=\"$ctrl.trolleyService.trolleyProductsByStockcode[$ctrl.product.Stockcode]\" source=\"{{ ::$ctrl.product.Source }}\" show-in-trolley-message=\"false\" class-modifier=\"shelfProduct-cartControls\">\r\n            </wow-cart-controls>\r\n            <wow-product-save-to-list-new product=\"::$ctrl.product\" show-link=\"true\" class-modifier=\"shelfProductList-save\" show-inline=\"false\" action-text=\"Copy\">\r\n            </wow-product-save-to-list-new>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShelfProductTileOfferController = function () {
    function ShelfProductTileOfferController($sce) {
        _classCallCheck(this, ShelfProductTileOfferController);

        this.$sce = $sce;
    }

    _createClass(ShelfProductTileOfferController, [{
        key: '$onInit',
        value: function $onInit() {
            this.getTagStyles();
        }
    }, {
        key: 'getTagStyles',
        value: function getTagStyles() {
            if (!this.headerTag) {
                return;
            }

            if (this.headerTag.BorderColor) {
                this.containerStyle = { border: '2px solid ' + this.headerTag.BorderColor };
            }

            this.tagStyle = {
                background: this.headerTag.BackgroundColor,
                'border-bottom-color': this.headerTag.BorderColor,
                color: this.headerTag.TextColor
            };
        }
    }]);

    return ShelfProductTileOfferController;
}();

var shelfProductTileOfferComponentDefinition = {
    bindings: {
        headerTag: '<'
    },
    controller: ['$sce', ShelfProductTileOfferController],
    template: __webpack_require__(235).trim()
};

module.exports = {
    ShelfProductTileOfferController: ShelfProductTileOfferController,
    shelfProductTileOfferComponentDefinition: shelfProductTileOfferComponentDefinition
};

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfProductTileOffer\" ng-style=\"::$ctrl.containerStyle\">\r\n    <p\r\n        class=\"shelfProductTileOffer-text\"\r\n        ng-style=\"::$ctrl.tagStyle\"\r\n        ng-bind-html=\"::$ctrl.$sce.trustAsHtml($ctrl.headerTag.Content)\">\r\n    </p>\r\n</div>\r\n"

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    includes = _require.includes,
    lowerCase = _require.lowerCase;

var ShelfProductListOfferController = function () {
    function ShelfProductListOfferController($sce) {
        _classCallCheck(this, ShelfProductListOfferController);

        this.$sce = $sce;
    }

    _createClass(ShelfProductListOfferController, [{
        key: '$onInit',
        value: function $onInit() {
            this.getHeaderTagStyles();

            // This is a hack for showing centre tags if the special is a multibuy (multibuys don't have tag content containing the word 'was')
            this.centreTagContainsWas = includes(lowerCase(this.product.CentreTag.TagContent), 'was');

            this.shouldShowCentreTag = this.product.IsCentreTag && !this.product.IsDeliveryPass && (!this.product.IsOnSpecial || !this.centreTagContainsWas);
        }
    }, {
        key: 'getHeaderTagStyles',
        value: function getHeaderTagStyles() {
            if (this.product.HasHeaderTag) {
                this.headerTagStyle = {
                    background: this.product.HeaderTag.BackgroundColor,
                    borderColor: this.product.HeaderTag.BorderColor,
                    color: this.product.HeaderTag.TextColor
                };
            }
        }
    }, {
        key: 'getTagContent',
        value: function getTagContent() {
            var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.product.CentreTag;

            return tag.TagType === 'Html' ? this.$sce.trustAsHtml(tag.TagContent) : tag.TagContent;
        }
    }, {
        key: 'tagClick',
        value: function tagClick(event) {
            // addToTrolley or addMultipleToTrolley are not links anymore
            // they prevent the link to follow href
            if (this.shelfProductService.processTrolleyProductTagLink(this.tag.TagLink)) {
                event.preventDefault();
            }
            this.analytics.push({ data: this.product, type: this.analytics.mapperTypes.customEvent.productClick });
        }
    }, {
        key: 'htmlTagClick',
        value: function htmlTagClick(event) {
            // Same as above, however we need to extract the tag link before processing the link
            var regex = /href="(.*?)"|href='(.*?)'/gm;
            var tagLink = this.tag.TagContent.match(regex);
            if (tagLink && this.shelfProductService.processTrolleyProductTagLink(tagLink[0])) {
                event.preventDefault();
            }
        }
    }, {
        key: 'staticTextOnProductPush',
        value: function staticTextOnProductPush() {
            this.analytics.pushEvent('staticTextOnProductFooterClick');
        }
    }, {
        key: 'staticTextClick',
        value: function staticTextClick(event) {
            return this.product.CentreTag.TagType === 'Html' ? this.htmlTagClick(event) : this.staticTextOnProductPush();
        }
    }]);

    return ShelfProductListOfferController;
}();

var shelfProductListOfferComponentDefinition = {
    bindings: {
        product: '<'
    },
    controller: ['$sce', ShelfProductListOfferController],
    template: __webpack_require__(237).trim()
};

module.exports = {
    ShelfProductListOfferController: ShelfProductListOfferController,
    shelfProductListOfferComponentDefinition: shelfProductListOfferComponentDefinition
};

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfProductListOffer\" ng-if=\"$ctrl.product.HasHeaderTag\" >\r\n    <p\r\n        class=\"shelfProductListOffer-text\"\r\n        ng-style=\"::$ctrl.headerTagStyle\"\r\n        ng-bind-html=\"::$ctrl.$sce.trustAsHtml($ctrl.product.HeaderTag.Content)\">\r\n    </p>\r\n</div>\r\n\r\n<div class=\"shelfProductListTagCenter\" ng-if=\"::$ctrl.shouldShowCentreTag\">\r\n    <a\r\n        class=\"shelfProductListTagCenter-link\"\r\n        ng-if=\"::$ctrl.product.CentreTag.TagLink\"\r\n        ng-href=\"{{::$ctrl.product.CentreTag.TagLink}}\"\r\n        ng-click=\"::$ctrl.tagClick($event)\"\r\n        ng-bind-html=\"::$ctrl.getTagContent()\">\r\n    </a>\r\n    <p\r\n        class=\"shelfProductListTagCenter-text\"\r\n        ng-if=\"::!$ctrl.product.CentreTag.TagLink\"\r\n        ng-click=\"::$ctrl.staticTextClick($event)\"\r\n        ng-bind-html=\"::$ctrl.getTagContent()\">\r\n    </p>\r\n</div>\r\n"

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShelfProductTagCenterController = function () {
    function ShelfProductTagCenterController($sce, shelfProductService, analytics) {
        _classCallCheck(this, ShelfProductTagCenterController);

        this.$sce = $sce;
        this.shelfProductService = shelfProductService;
        this.analytics = analytics;

        this.product.CentreTag.displayContent = this.getTagContent(this.product.CentreTag);
        this.tag = this.product.CentreTag;
    }

    _createClass(ShelfProductTagCenterController, [{
        key: 'getTagContent',
        value: function getTagContent() {
            var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.product.CentreTag;

            return tag.TagType === 'Html' ? this.$sce.trustAsHtml(tag.TagContent) : tag.TagContent;
        }
    }, {
        key: 'tagClick',
        value: function tagClick(event) {
            // addToTrolley or addMultipleToTrolley are not links anymore
            // they prevent the link to follow href
            if (this.shelfProductService.processTrolleyProductTagLink(this.tag.TagLink)) {
                event.preventDefault();
            }
            this.analytics.push({ data: this.product, type: this.analytics.mapperTypes.customEvent.productClick });
        }
    }, {
        key: 'htmlTagClick',
        value: function htmlTagClick(event) {
            // Same as above, however we need to extract the tag link before processing the link
            var regex = /href="(.*?)"|href='(.*?)'/gm;
            var tagLink = this.tag.TagContent.match(regex);
            if (tagLink && this.shelfProductService.processTrolleyProductTagLink(tagLink[0])) {
                event.preventDefault();
            }
        }
    }, {
        key: 'staticTextOnProductPush',
        value: function staticTextOnProductPush() {
            this.analytics.pushEvent('staticTextOnProductFooterClick');
        }
    }, {
        key: 'staticTextClick',
        value: function staticTextClick(event) {
            return this.product.CentreTag.TagType === 'Html' ? this.htmlTagClick(event) : this.staticTextOnProductPush();
        }
    }]);

    return ShelfProductTagCenterController;
}();

var shelfProductTagCenterComponentDefinition = {
    bindings: {
        product: '<'
    },
    controller: ['$sce', 'ShelfProductService', 'AnalyticsService', ShelfProductTagCenterController],
    template: __webpack_require__(239).trim()
};

module.exports = {
    ShelfProductTagCenterController: ShelfProductTagCenterController,
    shelfProductTagCenterComponentDefinition: shelfProductTagCenterComponentDefinition
};

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = "<div class=\"shelfProductTagCenter\">\r\n    <a ng-if=\"::$ctrl.product.CentreTag.TagLink\" ng-href=\"{{::$ctrl.product.CentreTag.TagLink}}\" ng-click=\"::$ctrl.tagClick($event)\">\r\n        <span ng-bind-html=\"::$ctrl.getTagContent()\"></span>\r\n    </a>\r\n    <span ng-if=\"::!$ctrl.product.CentreTag.TagLink\" ng-click=\"::$ctrl.staticTextClick($event)\" ng-bind-html=\"::$ctrl.getTagContent()\"></span>\r\n</div>"

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShelfProductTagImageController = function () {
    function ShelfProductTagImageController(shelfProductService, analytics) {
        _classCallCheck(this, ShelfProductTagImageController);

        this.shelfProductService = shelfProductService;
        this.analytics = analytics;
    }

    _createClass(ShelfProductTagImageController, [{
        key: 'tagClick',
        value: function tagClick(event) {
            // addToTrolley or addMultipleToTrolley are not links anymore
            // they prevent the link to follow href
            if (this.shelfProductService.processTrolleyProductTagLink(this.product.ImageTag.TagLink)) {
                event.preventDefault();
            }

            this.analytics.push({ data: this.product, type: this.analytics.mapperTypes.customEvent.productClick });
        }
    }, {
        key: 'gtmStaticTagClickPush',
        value: function gtmStaticTagClickPush() {
            this.analytics.pushEvent('staticTagImageClick');
        }
    }]);

    return ShelfProductTagImageController;
}();

var shelfProductTagImageComponentDefinition = {
    bindings: {
        product: '<'
    },
    controller: ['ShelfProductService', 'AnalyticsService', ShelfProductTagImageController],
    template: __webpack_require__(241).trim()
};

module.exports = {
    ShelfProductTagImageController: ShelfProductTagImageController,
    shelfProductTagImageComponentDefinition: shelfProductTagImageComponentDefinition
};

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = "<div ng-switch=\"::(!!$ctrl.product.ImageTag.TagLink)\">\r\n    <a ng-switch-when=\"true\" ng-href=\"{{::$ctrl.product.ImageTag.TagLink}}\" class=\"shelfProductTagImage-tag\" ng-click=\"::$ctrl.tagClick($event)\">\r\n        <img ng-show=\"::($ctrl.product.ImageTag && $ctrl.product.ImageTag.TagContent)\" ng-src=\"{{::$ctrl.product.ImageTag.TagContent}}\"\r\n            alt=\"{{::$ctrl.product.ImageTag.FallbackText}}\" class=\"shelfProductTagImage-image\" oly-error-src />\r\n    </a>\r\n    <span ng-switch-when=\"false\" class=\"shelfProductTagImage-tag u-noPointerEvents\" ng-click=\"::$ctrl.gtmStaticTagClickPush()\">\r\n        <img ng-show=\"::($ctrl.product.ImageTag && $ctrl.product.ImageTag.TagContent)\" ng-src=\"{{::$ctrl.product.ImageTag.TagContent}}\" alt=\"{{::$ctrl.product.ImageTag.FallbackText}}\" class=\"shelfProductTagImage-image\" oly-error-src />\r\n    </span>\r\n</div>"

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1).module('wowApp.shop').service('StoreService', ['Restangular', 'StoreFilterService', 'LocationService', 'Settings', __webpack_require__(243)]).service('StoreFilterService', [__webpack_require__(244)]);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0);

var StoreService = function () {
    function StoreService(restangular, storeFilterService, locationService, settings) {
        var _this = this;

        _classCallCheck(this, StoreService);

        this._storeLocatorApi = restangular.one('StoreLocator');
        this._suburbsApi = this._storeLocatorApi.one('Suburbs');
        this._storesApi = this._storeLocatorApi.one('Stores');
        this.settings = settings;

        this.filterService = storeFilterService;
        this.locationService = locationService;
        this.isGeolocationEnabled = false;
        this.isStoreDetailDisplayed = false;

        locationService.getCurrentLocation().then(function (isEnabled) {
            _this.isGeolocationEnabled = isEnabled;
        });
    }

    _createClass(StoreService, [{
        key: 'getDefaultLocation',
        value: function getDefaultLocation() {
            return this._storeLocatorApi.one('DefaultLanding').get();
        }
    }, {
        key: 'searchStoresByRoute',
        value: function searchStoresByRoute(route) {
            return this._storesApi.get({
                RoutePoint: route.overview_polyline,
                Division: this.filterService.getDivisionCodes().join(','),
                Facility: this.filterService.getFacilityCodes().join(',')
            }).then(function (response) {
                return response && response.Stores ? response.Stores : [];
            });
        }
    }, {
        key: 'getStoreCode',
        value: function getStoreCode($stateParams) {
            return $stateParams.store_code && $stateParams.store_code.includes(this.settings.googleSem.storeCodeParamPrefix) ? $stateParams.store_code.replace(this.settings.googleSem.storeCodeParamPrefix, '') : this.settings.googleSem.defaultBasePriceStoreCode;
        }
    }, {
        key: 'searchStoresByCoordinates',
        value: function searchStoresByCoordinates(coordinates) {
            var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
            var divisions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.filterService.getSelectedDivisions();
            var facilities = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.filterService.getSelectedFacilities();

            return this._storesApi.get(_.assign({}, coordinates, {
                Division: this.filterService.getDivisionCodes(divisions).join(','),
                Facility: this.filterService.getFacilityCodes(facilities).join(','),
                Max: max
            })).then(function (response) {
                return response && response.Stores ? response.Stores : [];
            });
        }
    }, {
        key: 'searchStoresByPostcode',
        value: function searchStoresByPostcode(postcode) {
            var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
            var divisions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.filterService.getSelectedDivisions();
            var facilities = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.filterService.getSelectedFacilities();

            return this._storesApi.get({
                PostCode: postcode,
                Division: this.filterService.getDivisionCodes(divisions).join(','),
                Facility: this.filterService.getFacilityCodes(facilities).join(','),
                Max: max
            }).then(function (response) {
                return response && response.Stores ? response.Stores : [];
            });
        }
    }, {
        key: 'searchSuburbs',
        value: function searchSuburbs(searchTerm) {
            return this._suburbsApi.get({
                SearchTerm: searchTerm
            }).then(function (response) {
                return response && response.Suburbs ? response.Suburbs : [];
            });
        }
    }, {
        key: 'getStore',
        value: function getStore(storeNo, division) {
            return this._storeLocatorApi.one('Store').get({ StoreNo: storeNo, Division: division }).then(function (response) {
                return response.plain();
            });
        }
    }, {
        key: 'getStoreWithDistance',
        value: function getStoreWithDistance(storeNo, lat, lon, division) {
            return this._storeLocatorApi.one('Distance').get({
                StoreNo: storeNo, Lat: lat, Lon: lon, Division: division
            }).then(function (response) {
                return response.plain();
            });
        }

        /**
        * Gets a unique identifier for a store. (Store numbers are not unique).
        * @param {any} store
        */

    }, {
        key: 'getStoreKey',
        value: function getStoreKey(store) {
            return '' + store.Division + store.AddressLine1;
        }
    }, {
        key: 'getStoreUrl',
        value: function getStoreUrl(store) {
            var url = store.State.trim() + ' ' + store.Suburb.trim() + ' ' + store.StoreNo.trim();

            if (store.Division !== 'SUPERMARKETS') {
                url = url + '-' + store.Division;
            }

            return url.replace(/[^a-zA-Z0-9]/g, ' ').replace(/\s+/g, '-').toLowerCase();
        }
    }, {
        key: 'getStoreInfoFromUrlParams',
        value: function getStoreInfoFromUrlParams(storeParam) {
            var storeInfo = void 0;
            var params = storeParam.split('-');
            var lastIndexOfParams = params.length - 1;
            var division = null;

            // check that we have enough parameters
            if (params.length >= 3) {
                // parse store number
                var storeNo = parseInt(params[lastIndexOfParams], 10);

                // if the last parameter is not a number, then it is the division
                if (_.isNaN(storeNo)) {
                    storeNo = parseInt(params[lastIndexOfParams - 1], 10);
                    division = params[lastIndexOfParams];
                }

                // only continue if storeNo is a valid number
                if (storeNo) {
                    // get the suburb
                    var suburbArray = params.slice(1, division ? lastIndexOfParams - 1 : lastIndexOfParams);

                    storeInfo = {
                        storeNo: storeNo,
                        suburb: suburbArray.join(' '),
                        state: params[0],
                        division: division || 'SUPERMARKETS'
                    };
                }
            }

            return storeInfo;
        }
    }, {
        key: 'urlParametersValid',
        value: function urlParametersValid(store, parameters) {
            return store.State.localeCompare(parameters.state, 'en', { sensitivity: 'base' }) === 0 && store.Suburb.localeCompare(parameters.suburb, 'en', { sensitivity: 'base' }) === 0 && parseInt(store.StoreNo) === parameters.storeNo;
        }
    }, {
        key: 'setSelectedStore',
        value: function setSelectedStore(store) {
            this.selectedStore = store;
        }
    }, {
        key: 'isStoreEqual',
        value: function isStoreEqual(store1, store2) {
            return this.getStoreKey(store1) === this.getStoreKey(store2);
        }
    }, {
        key: 'isSelectedStore',
        value: function isSelectedStore(store) {
            return !!(this.selectedStore && this.isStoreEqual(this.selectedStore, store));
        }
    }, {
        key: 'getFormattedAddress',
        value: function getFormattedAddress(store) {
            if (!store) return '';
            var addressLine1 = !store.AddressLine1 || store.AddressLine1 === '' ? '' : store.AddressLine1 + ', ';
            var suburb = !store.Suburb || store.Suburb === '' ? '' : store.Suburb + ', ';
            var state = !store.State || store.State === '' ? '' : store.State + ', ';
            var postcode = !store.Postcode || store.Postcode === '' ? '' : store.Postcode + ', ';
            return '' + addressLine1 + suburb + state + postcode + 'Australia';
        }
    }]);

    return StoreService;
}();

module.exports = StoreService;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0);

var StoreFilterService = function () {
    function StoreFilterService() {
        _classCallCheck(this, StoreFilterService);
    }

    _createClass(StoreFilterService, [{
        key: 'setDivisions',
        value: function setDivisions(divisions) {
            this.divisions = divisions;
        }
    }, {
        key: 'setFacilities',
        value: function setFacilities(facilities) {
            this.facilities = facilities;
        }
    }, {
        key: 'getSelectedDivisions',
        value: function getSelectedDivisions() {
            var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.divisions;

            return _.filter(divisions, 'Selected');
        }
    }, {
        key: 'getDivisionCodes',
        value: function getDivisionCodes() {
            var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelectedDivisions();

            return _.map(divisions, 'Division');
        }
    }, {
        key: 'getSelectedFacilities',
        value: function getSelectedFacilities() {
            var facilities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.facilities;

            return _.filter(facilities, 'Selected');
        }
    }, {
        key: 'getFacilityCodes',
        value: function getFacilityCodes() {
            var facilities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelectedFacilities();

            return _.map(facilities, 'Facility');
        }
    }, {
        key: 'isStoreMatching',
        value: function isStoreMatching(store) {
            var isInDivision = _.includes(this.getDivisionCodes(), store.Division);

            var selectedFacilityLabels = _.map(this.getSelectedFacilities(), 'Label');
            var hasAllFacilities = !selectedFacilityLabels.length || _.intersection(selectedFacilityLabels, store.Facilities).length >= selectedFacilityLabels.length;

            return isInDivision && hasAllFacilities;
        }
    }]);

    return StoreFilterService;
}();

module.exports = StoreFilterService;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(246),
    productSaveToListComponentDefinition = _require.productSaveToListComponentDefinition;

var _require2 = __webpack_require__(248),
    productSaveToListLegacyComponentDefinition = _require2.productSaveToListLegacyComponentDefinition;

var _require3 = __webpack_require__(250),
    productSaveToListNewComponentDefinition = _require3.productSaveToListNewComponentDefinition;

angular.module('wowApp.shop').component('wowProductSaveToList', productSaveToListComponentDefinition).component('wowProductSaveToListLegacy', productSaveToListLegacyComponentDefinition).component('wowProductSaveToListNew', productSaveToListNewComponentDefinition);

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isUndefined = _require.isUndefined;

var ProductSaveToListController = function () {
    function ProductSaveToListController(settings, breakpointsService) {
        _classCallCheck(this, ProductSaveToListController);

        this.settings = settings;
        this.breakpointsService = breakpointsService;
    }

    _createClass(ProductSaveToListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.showLink = isUndefined(this.showLink) ? false : this.showLink;
            this.showInline = isUndefined(this.showInline) ? this.breakpointsService.isInSmallFormat : this.showInline;
        }
    }]);

    return ProductSaveToListController;
}();

ProductSaveToListController.$inject = ['Settings', 'BreakpointsService'];

var productSaveToListComponentDefinition = {
    bindings: {
        product: '<',
        showLink: '<?',
        classModifier: '@?',
        showInline: '<?'
    },
    controller: ProductSaveToListController,
    template: __webpack_require__(247).trim()
};

module.exports = {
    ProductSaveToListController: ProductSaveToListController,
    productSaveToListComponentDefinition: productSaveToListComponentDefinition
};

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = "<wow-product-save-to-list-new\r\n    ng-if=\"::$ctrl.settings.shelfProductTile.showSaveToListAsLink\"\r\n    product=\"::$ctrl.product\"\r\n    show-link=\"::$ctrl.showLink\"\r\n    class-modifier=\"::$ctrl.classModifier\"\r\n    show-inline=\"$ctrl.showInline\">\r\n</wow-product-save-to-list-new>\r\n\r\n<wow-product-save-to-list-legacy\r\n    ng-if=\"::!$ctrl.settings.shelfProductTile.showSaveToListAsLink\"\r\n    product=\"::$ctrl.product\">\r\n</wow-product-save-to-list-legacy>\r\n"

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    cloneDeep = _require.cloneDeep;

var buttonState = {
    DEFAULT: 'DEFAULT',
    SAVED: 'SAVED'
};

var ProductSaveToListLegacyController = function () {
    function ProductSaveToListLegacyController($scope, $element, $state, $timeout, sessionStorage, analyticsService, savedListsService, shopperService, loginService, moveFocus) {
        _classCallCheck(this, ProductSaveToListLegacyController);

        this.$scope = $scope;
        this.$element = $element;
        this.$state = $state;
        this.$timeout = $timeout;
        this.sessionStorage = sessionStorage;
        this.analyticsService = analyticsService;
        this.savedListsService = savedListsService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.moveFocus = moveFocus;
    }

    _createClass(ProductSaveToListLegacyController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.showDropdown = false;
            this.lastSavedList = '';
            this.buttonStates = buttonState;
            this.buttonState = buttonState.DEFAULT;
            this.pendingSaveToListStorageKey = 'ProductSaveToListController:pendingSaveToList:' + this.product.Stockcode;

            this.getSavedLists().then(function () {
                if (!_this.savedListsService.getIsServiceAvailable()) {
                    _this.showServiceError();
                }
                _this.savePendingProductToList();
                if (!_this.shopperService.IsGuest) {
                    _this.savedListsService.getDefaultList().then(function (defaultList) {
                        _this.defaultListId = defaultList.ListId;
                    });
                }
            });

            // Event listener for Saving Trolley as a list
            // This is needed when the user is on the Saved Lists page and the user adds a new list
            // This then needs to refresh the list of saved lists
            this.$scope.$on('savedLists:AddNewList', function () {
                return _this.$timeout(function () {
                    return _this.getSavedLists();
                });
            });
        }
    }, {
        key: 'getSavedLists',
        value: function getSavedLists() {
            var _this2 = this;

            return this.savedListsService.getAllSavedLists().then(function (savedLists) {
                _this2.savedLists = cloneDeep(savedLists);
            });
        }
    }, {
        key: 'savePendingProductToList',
        value: function savePendingProductToList() {
            var _this3 = this;

            if (this.shopperService.IsGuest) {
                return;
            }

            this.savedListsService.getAllSavedLists().then(function () {
                var _ref = _this3.sessionStorage.getJsonAndRemove(_this3.pendingSaveToListStorageKey) || {},
                    stockcode = _ref.stockcode;

                if (stockcode === _this3.product.Stockcode) {
                    _this3.save();
                    _this3.moveFocus(_this3.$element.find('._saveToListButton'));
                }
            });
        }
    }, {
        key: 'getButtonSrMessage',
        value: function getButtonSrMessage() {
            return this.buttonState === buttonState.SAVED ? 'Choose a list to save ' + this.product.Name : 'Save ' + this.product.Name + ' to default list';
        }
    }, {
        key: 'save',
        value: function save() {
            if (this.shopperService.IsGuest) {
                this.promptForGuest();
                return;
            }

            if (this.lastSavedList === '' && !this.showErrorMessage) {
                this.saveToList({}, false, true); // save to default list
            } else {
                this.toggleDropdown(true);
            }
        }
    }, {
        key: 'saveToList',
        value: function saveToList(list, shouldCloseDropdown, shouldSaveToDefault) {
            var _this4 = this;

            this.savedListsService.getDefaultList().then(function (defaultList) {
                if (shouldSaveToDefault) {
                    list = defaultList;
                }

                _this4.lastSavedList = list.ListId === defaultList.ListId ? 'Default' : list.Name;
                _this4.buttonState = buttonState.SAVED;

                _this4.savedListsService.addListItem(list.ListId, _this4.product.Stockcode, _this4.product.DisplayQuantity, _this4.product.Source).then(function () {
                    _this4.srMessage = _this4.product.Name + ' has been saved to ' + _this4.lastSavedList;
                    _this4.toggleDropdown(shouldCloseDropdown);
                });

                // push to tealium
                _this4.analyticsService.push({
                    data: {
                        trackingType: 'link',
                        list: list,
                        product: [_this4.product]
                    },
                    type: _this4.analyticsService.mapperTypes.customEvent.list.Add
                });
            });
        }
    }, {
        key: 'showServiceError',
        value: function showServiceError() {
            this.showErrorMessage = true;
            this.showDropdown = false;
        }
    }, {
        key: 'promptForGuest',
        value: function promptForGuest() {
            var _this5 = this;

            this.loginService.promptForLogin(this.loginService.LoginToSavetoListMessage, undefined, undefined, { reload: false }, function () {
                _this5.sessionStorage.setJson(_this5.pendingSaveToListStorageKey, { stockcode: _this5.product.Stockcode });
            });
        }
    }, {
        key: 'toggleDropdown',
        value: function toggleDropdown(shouldMoveFocus) {
            var _this6 = this;

            this.showDropdown = !this.showDropdown;

            if (this.showDropdown) {
                if (shouldMoveFocus) {
                    this.moveFocus(function () {
                        return _this6.$element.find('.productSaveToListLegacy-listItem > label').first();
                    });
                }
                $('body').on('click.productSaveToListLegacy', function (e) {
                    return _this6.closeDropdownOnOutsideClick(e);
                });
            }
        }
    }, {
        key: 'closeDropdownOnOutsideClick',
        value: function closeDropdownOnOutsideClick(event) {
            if (!($(event.target).closest('wow-product-save-to-list-legacy')[0] === this.$element[0])) {
                this.showDropdown = false;
                this.$scope.$apply();
                $('body').off(event);
            }
        }
    }, {
        key: 'isDefaultList',
        value: function isDefaultList(listId) {
            return this.defaultListId === listId;
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            $('body').off('click.productSaveToListLegacy');
        }
    }]);

    return ProductSaveToListLegacyController;
}();

ProductSaveToListLegacyController.$inject = ['$scope', '$element', '$state', '$timeout', 'SessionStorageWrapper', 'AnalyticsService', 'SavedListsService', 'ShopperService', 'LoginService', 'MoveFocus'];

var productSaveToListLegacyComponentDefinition = {
    bindings: {
        product: '<'
    },
    controller: ProductSaveToListLegacyController,
    template: __webpack_require__(249).trim()
};

module.exports = {
    ProductSaveToListLegacyController: ProductSaveToListLegacyController,
    productSaveToListLegacyComponentDefinition: productSaveToListLegacyComponentDefinition
};

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports = "<div class=\"productSaveToListLegacy\">\r\n    <div ng-if=\"!!$ctrl.showDropdown\" class=\"productSaveToListLegacy-list\">\r\n        <span class=\"productSaveToListLegacy-listItem productSaveToListLegacy-listHeader\">\r\n            Add to a list\r\n        </span>\r\n\r\n        <ul class=\"productSaveToListLegacy-listItems\" ng-if=\"!$ctrl.showErrorMessage\">\r\n            <li ng-repeat=\"list in $ctrl.savedLists track by list.ListId\" class=\"productSaveToListLegacy-listItem\">\r\n                <input\r\n                    type=\"radio\"\r\n                    id=\"productSaveToList-list-{{::$ctrl.product.Stockcode}}-{{list.ListId}}\"\r\n                    class=\"wowRadio\"\r\n                    name=\"productSaveToList{{::$ctrl.product.Stockcode}}\"\r\n                    ng-value=\"::$ctrl.isDefaultList(list.ListId) ? 'Default' : list.Name\"\r\n                    ng-model=\"$ctrl.lastSavedList\"\r\n                    ng-click=\"::$ctrl.saveToList(list, true)\"\r\n                    tabindex=\"-1\" />\r\n                <label class=\"productSaveToListLegacy-listItemLabel\" for=\"productSaveToList-list-{{::$ctrl.product.Stockcode}}-{{list.ListId}}\" >\r\n                    <span class=\"sr-only\">Save to </span>{{::$ctrl.isDefaultList(list.ListId) ? 'Default' : list.Name}}\r\n                </label>\r\n            </li>\r\n        </ul>\r\n        <ul class=\"productSaveToListLegacy-listItems\" ng-if=\"$ctrl.showErrorMessage\">\r\n            <li class=\"productSaveToListLegacy-listItem _productSaveToListError\" wow-html-setting setting-group=\"Lists\" setting-name=\"NoListsShortErrorMessage\"></li>\r\n        </ul>\r\n    </div>\r\n    <oly-sr-notification message=\"{{$ctrl.srMessage}}\"></oly-sr-notification>\r\n    <button class=\"button productSaveToListLegacy-button _saveToListButton\" ng-click=\"$ctrl.save()\"\r\n        ng-class=\"{'is-saved': $ctrl.buttonState === $ctrl.buttonStates.SAVED}\"\r\n        title=\"Save to list\">\r\n        <span class=\"sr-only\">{{$ctrl.getButtonSrMessage()}}</span><i class=\"iconww-List-2\"></i>\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    cloneDeep = _require.cloneDeep,
    assign = _require.assign,
    map = _require.map,
    filter = _require.filter,
    unionBy = _require.unionBy,
    find = _require.find,
    mapValues = _require.mapValues;

var buttonState = {
    DEFAULT: 'DEFAULT',
    SAVED: 'SAVED'
};

var ProductSaveToListNewController = function () {
    function ProductSaveToListNewController($scope, $element, $state, $timeout, sessionStorage, analyticsService, savedListsService, shopperService, loginService, announcerService, moveFocus) {
        _classCallCheck(this, ProductSaveToListNewController);

        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.sessionStorage = sessionStorage;
        this.analyticsService = analyticsService;
        this.savedListsService = savedListsService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.announcerService = announcerService;
        this.moveFocus = moveFocus;
    }

    _createClass(ProductSaveToListNewController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.showDropdown = false;
            this.buttonStates = buttonState;
            this.buttonState = buttonState.DEFAULT;
            this.pendingSaveToListStorageKey = 'ProductSaveToListController:pendingSaveToList:' + this.product.Stockcode;
            this.savedToLists = [];
            this.createListView = false;
            this.newListName = '';
            this.createListErrorMessage = '';

            this.errorFlags = {
                showListLoadError: false,
                showCreateListError: false
            };

            this.getSavedLists().then(function () {
                if (!_this.savedListsService.getIsServiceAvailable()) {
                    _this.showLoadListError();
                }
                _this.savePendingProductToList();
                if (!_this.shopperService.IsGuest) {
                    _this.savedListsService.getDefaultList().then(function (defaultList) {
                        _this.defaultListId = defaultList.ListId;
                    });
                }
            });
            this.actionText = this.actionText ? this.actionText : 'Save';
            this.actionedText = this.getPastTenseAction();

            // Event listener for Saving Trolley as a list
            // This is needed when the user is on the Saved Lists page and the user adds a new list
            // This then needs to refresh the list of saved lists
            this.$scope.$on('savedLists:AddNewList', function () {
                return _this.$timeout(function () {
                    return _this.getSavedLists();
                });
            });
        }
    }, {
        key: 'getPastTenseAction',
        value: function getPastTenseAction() {
            switch (this.actionText) {
                case 'Add':
                    {
                        return 'Added';
                    }
                case 'Copy':
                    {
                        return 'Copied';
                    }
                default:
                    {
                        return 'Saved';
                    }
            }
        }
    }, {
        key: 'getSavedLists',
        value: function getSavedLists() {
            var _this2 = this;

            return this.savedListsService.getAllSavedLists().then(function (savedLists) {
                _this2.savedLists = unionBy(_this2.savedToLists, map(cloneDeep(savedLists), function (list) {
                    return assign(list, { isSelected: false });
                }), 'ListId');
            });
        }
    }, {
        key: 'savePendingProductToList',
        value: function savePendingProductToList() {
            var _this3 = this;

            if (this.shopperService.IsGuest) {
                return;
            }

            this.savedListsService.getAllSavedLists().then(function () {
                var _ref = _this3.sessionStorage.getJsonAndRemove(_this3.pendingSaveToListStorageKey) || {},
                    stockcode = _ref.stockcode;

                if (stockcode === _this3.product.Stockcode) {
                    _this3.save();
                    _this3.moveFocus(_this3.$element.find('._saveToListButton'));
                }
            });
        }
    }, {
        key: 'save',
        value: function save() {
            if (this.shopperService.IsGuest) {
                this.promptForGuest();
                return;
            }
            this.toggleDropdown(true, true);
        }
    }, {
        key: 'saveToList',
        value: function saveToList(list, showDropdown) {
            var _this4 = this;

            this.savedListsService.getDefaultList().then(function (defaultList) {
                _this4.buttonState = buttonState.SAVED;

                if (list.isSelected) {
                    _this4.savedListsService.addListItem(list.ListId, _this4.product.Stockcode, _this4.product.DisplayQuantity, _this4.product.Source).then(function () {
                        _this4.announcerService.announce(_this4.product.Name + ' has been saved to ' + (list.ListId === defaultList.ListId ? 'Default' : list.Name));
                        _this4.toggleDropdown(showDropdown, false);
                        _this4.savedToLists = filter(_this4.savedLists, function (savedList) {
                            return savedList.isSelected;
                        });
                    });

                    // push to tealium
                    _this4.analyticsService.push({
                        data: {
                            trackingType: 'link',
                            list: list,
                            product: [_this4.product]
                        },
                        type: _this4.analyticsService.mapperTypes.customEvent.list.Add
                    });
                } else {
                    _this4.savedListsService.deleteListItem(list.ListId, _this4.product.Stockcode).then(function () {
                        _this4.announcerService.announce(_this4.product.Name + ' has been deleted from ' + (list.ListId === defaultList.ListId ? 'Default' : list.Name));
                        _this4.toggleDropdown(showDropdown, false);
                        _this4.savedToLists = filter(_this4.savedLists, function (savedList) {
                            return savedList.isSelected;
                        });
                    });
                }
            });
        }
    }, {
        key: 'resetErrorFlags',
        value: function resetErrorFlags() {
            this.errorFlags = mapValues(this.errorFlags, function () {
                return false;
            });
        }
    }, {
        key: 'showCreateListError',
        value: function showCreateListError() {
            this.resetErrorFlags();
            this.errorFlags.showCreateListError = true;
        }
    }, {
        key: 'showLoadListError',
        value: function showLoadListError() {
            this.resetErrorFlags();
            this.errorFlags.showListLoadError = true;
        }
    }, {
        key: 'focusError',
        value: function focusError() {
            var _this5 = this;

            this.toggleDropdown(true);
            this.moveFocus(function () {
                return _this5.$element.find('._productSaveToListError');
            });
        }
    }, {
        key: 'promptForGuest',
        value: function promptForGuest() {
            var _this6 = this;

            this.loginService.promptForLogin(this.loginService.LoginToSavetoListMessage, undefined, undefined, { reload: false }, function () {
                _this6.sessionStorage.setJson(_this6.pendingSaveToListStorageKey, { stockcode: _this6.product.Stockcode });
            });
        }
    }, {
        key: 'toggleDropdown',
        value: function toggleDropdown(showDropdown, shouldMoveFocus) {
            var _this7 = this;

            this.showDropdown = showDropdown;

            if (this.showDropdown && shouldMoveFocus) {
                this.moveFocus(function () {
                    return _this7.$element.find('.productSaveToList-listItem > span').first();
                });
                $('body').on('click.productSaveToList', function (e) {
                    return _this7.closeDropdownOnOutsideClick(e);
                });
            }
        }
    }, {
        key: 'closeDropdownOnOutsideClick',
        value: function closeDropdownOnOutsideClick(event) {
            if (!($(event.target).closest('wow-product-save-to-list-new')[0] === this.$element[0])) {
                this.showDropdown = false;
                this.$scope.$apply();
                $('body').off(event);
            }
        }
    }, {
        key: 'isDefaultList',
        value: function isDefaultList(listId) {
            return this.defaultListId === listId;
        }
    }, {
        key: 'saveNewList',
        value: function saveNewList() {
            var _this8 = this;

            if (!this.newListName.length) {
                return;
            }

            this.savedListsService.saveNewList(this.newListName.trim()).then(function () {
                _this8.getSavedLists().then(function () {
                    _this8.announcerService.announce('List ' + _this8.newListName + ' has been created');
                    // save item to created list
                    var newList = find(_this8.savedLists, { ListId: _this8.savedListsService.newListData.ListId });
                    newList.isSelected = true;
                    _this8.saveToList(newList, true);
                    _this8.toggleCreateView(false);
                });
            }).catch(function (response) {
                _this8.createListErrorMessage = response.Message;
                _this8.showCreateListError();
                _this8.analyticsService.pushError(response.Message);
            });
        }
    }, {
        key: 'clearListName',
        value: function clearListName() {
            this.newListName = '';
        }
    }, {
        key: 'toggleCreateView',
        value: function toggleCreateView(showCreateView) {
            var _this9 = this;

            this.$timeout(function () {
                _this9.newListName = '';
                _this9.createListView = showCreateView;
                _this9.errorFlags.showCreateListError = false;
                var element = _this9.createListView ? '.productSaveToList-listItem > button' : '.productSaveToList-listItem > span';
                _this9.moveFocus(function () {
                    return _this9.$element.find(element).first();
                });
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            $('body').off('click.productSaveToList');
        }
    }]);

    return ProductSaveToListNewController;
}();

ProductSaveToListNewController.$inject = ['$scope', '$element', '$state', '$timeout', 'SessionStorageWrapper', 'AnalyticsService', 'SavedListsService', 'ShopperService', 'LoginService', 'AnnouncerService', 'MoveFocus'];

var productSaveToListNewComponentDefinition = {
    bindings: {
        product: '<',
        showLink: '<?',
        classModifier: '@?',
        showInline: '<?',
        actionText: '@?'
    },
    controller: ProductSaveToListNewController,
    template: __webpack_require__(251).trim()
};

module.exports = {
    ProductSaveToListNewController: ProductSaveToListNewController,
    productSaveToListNewComponentDefinition: productSaveToListNewComponentDefinition
};

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = "<div class=\"productSaveToList\" ng-class=\"{ '{{$ctrl.classModifier}}' : $ctrl.showLink }\">\r\n    <div ng-if=\"!!$ctrl.showDropdown\" class=\"productSaveToList-list\">\r\n        <div class=\"productSaveToList-listHeader\" ng-class=\"{ 'productSaveToList-listHeaderBorder' : $ctrl.createListView }\">\r\n            <span ng-if=\"!$ctrl.createListView\" tabindex=\"0\">{{$ctrl.actionText}} to list\r\n                <span class=\"sr-only\">Popup open </span>\r\n            </span>\r\n            <button ng-if=\"$ctrl.createListView\"\r\n                class=\"linkButton\"\r\n                ng-click=\"$ctrl.toggleCreateView(false)\">\r\n                <i class=\"iconww-ArrowLeft\"></i>&nbsp;Back\r\n            </button>\r\n            <button class=\"iconButton productSaveToList-listHeaderClose\" ng-click=\"$ctrl.toggleDropdown(false); $ctrl.toggleCreateView(false);\" title=\"Close Dialog\">\r\n                <i class=\"iconww-Delete\"><span class=\"sr-only\">Close popup</span></i>\r\n            </button>\r\n        </div>\r\n\r\n        <div ng-switch=\"!$ctrl.errorFlags.showListLoadError && !$ctrl.errorFlags.showCreateListError\" class=\"productSaveToList-content\">\r\n            <div ng-switch-when=\"true\" ng-switch=\"$ctrl.createListView\">\r\n                <div ng-switch-when=\"false\">\r\n                    <ul class=\"productSaveToList-listItems\">\r\n                        <li ng-repeat=\"list in $ctrl.savedLists track by list.ListId\" class=\"productSaveToList-listItem\">\r\n                            <input\r\n                                type=\"checkbox\"\r\n                                id=\"productSaveToList-list-{{::$ctrl.product.Stockcode}}-{{list.ListId}}\"\r\n                                class=\"wowCheckbox productSaveToList-listItemCheckbox\"\r\n                                name=\"productSaveToList{{::$ctrl.product.Stockcode}}\"\r\n                                ng-value=\"::$ctrl.isDefaultList(list.ListId) ? 'Default' : list.Name\"\r\n                                ng-model=\"list.isSelected\"\r\n                                ng-click=\"::$ctrl.saveToList(list, true)\"/>\r\n                            <label class=\"productSaveToList-listItemLabel\" for=\"productSaveToList-list-{{::$ctrl.product.Stockcode}}-{{list.ListId}}\">\r\n                                <span class=\"sr-only\">{{$ctrl.actionText}} to </span>{{::$ctrl.isDefaultList(list.ListId) ? 'Default' : list.Name}}\r\n                            </label>\r\n                        </li>\r\n                    </ul>\r\n\r\n                    <button class=\"linkButton productSaveToList-createList\" ng-click=\"$ctrl.toggleCreateView(true)\">\r\n                        <div class=\"productSaveToList-createListTitle\">Create a new list</div>\r\n                        <i class=\"iconww-ArrowRight\"></i>\r\n                    </button>\r\n                </div>\r\n\r\n                <div ng-switch-when=\"true\">\r\n                    <h3 class=\"productSaveToList-createHeader\">Create a new list</h3>\r\n                    <form\r\n                        name=\"$ctrl.newListSaveForm\"\r\n                        ng-submit=\"$ctrl.saveNewList()\"\r\n                        class=\"productSaveToList-createContainer\">\r\n                        <wow-input-container>\r\n                            <label for=\"newListSaveInput\" class=\"productSaveToList-createLabel\">e.g. Dinner Party</label>\r\n                            <input id=\"productSaveToList-input\" aria-label=\"Create new list input\" type=\"text\" name=\"newListSaveInput\" ng-model=\"$ctrl.newListName\" maxlength=\"127\" class=\"productSaveToList-createInput\">\r\n                            <button type=\"button\" class=\"productSaveToList-createClear linkButton\" ng-show=\"$ctrl.newListName.length\" ng-click=\"$ctrl.clearListName()\" oly-move-focus=\"saveList-input\">\r\n                                <i class=\"iconww-Cross\"></i>\r\n                                <span class=\"sr-only\">Clear list name</span>\r\n                            </button>\r\n                        </wow-input-container>\r\n                        <button type=\"submit\" class=\"button productSaveToList-createButton\" ng-disabled=\"$ctrl.newListName.length < 1\">\r\n                            Create list <i class=\"iconww-ArrowRight productSaveToList-createButtonIcon\"></i>\r\n                        </button>\r\n                    </form>\r\n                </div>\r\n            </div>\r\n\r\n            <ul class=\"productSaveToList-listItems\" ng-switch-when=\"false\">\r\n                <li ng-if=\"$ctrl.errorFlags.showListLoadError\" class=\"productSaveToList-listItem _productSaveToListError\">\r\n                    <p role=\"alert\" wow-html-setting setting-group=\"Lists\" setting-name=\"NoListsShortErrorMessage\"></p>\r\n                </li>\r\n                <li ng-if=\"$ctrl.errorFlags.showCreateListError\" class=\"productSaveToList-listItem _productSaveToListError\">\r\n                    <p role=\"alert\">{{$ctrl.createListErrorMessage}}</p>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n    </div>\r\n    <div ng-class=\"{ true : 'productSaveToList-showLinkInline', false : 'productSaveToList-showLink' }[$ctrl.showInline]\"\r\n        ng-switch=\"::$ctrl.showLink\">\r\n        <button ng-switch-when=\"false\"\r\n            class=\"button productSaveToList-button _saveToListButton\"\r\n            ng-click=\"$ctrl.save()\"\r\n            ng-class=\"{'is-saved': $ctrl.buttonState === $ctrl.buttonStates.SAVED}\"\r\n            title=\"{{$ctrl.actionText}} to list\">\r\n            <span class=\"sr-only\">Choose a list to {{$ctrl.actionText}} {{$ctrl.product.Name}}</span><i class=\"iconww-List-2\"></i>\r\n        </button>\r\n        <div ng-switch-when=\"true\"\r\n            ng-switch=\"$ctrl.savedToLists.length > 0\" class=\"productSaveToList-buttonContainer\">\r\n            <button ng-switch-when=\"false\"\r\n                class=\"linkButton productSaveToList-buttonLink\"\r\n                ng-class=\"{ 'productSaveToList-buttonLinkText' : $ctrl.showDropdown }\"\r\n                ng-click=\"$ctrl.save()\">\r\n                {{$ctrl.actionText}} to list &nbsp;<i class=\"iconww-Plus-2 productSaveToList-buttonLinkIcon\"></i>\r\n            </button>\r\n            <div ng-switch-when=\"true\">\r\n                <div class=\"productSaveToList-savedToList\" ng-if=\"!$ctrl.showInline\">\r\n                    <strong class=\"productSaveToList-savedList\">\r\n                        <i class=\"iconww-Tick productSaveToList-savedListIcon\"></i>\r\n                        &nbsp;<span ng-switch=\"$ctrl.savedToLists.length > 1\" tabindex=\"0\">{{$ctrl.actionedText}} to\r\n                            <span ng-switch-when=\"true\">{{$ctrl.savedToLists.length}} lists</span>\r\n                            <span ng-switch-when=\"false\" class=\"productSaveToList-savedListName\">\r\n                                '{{$ctrl.isDefaultList($ctrl.savedToLists[0].ListId) ? 'Default' : $ctrl.savedToLists[0].Name}}'\r\n                            </span>\r\n                        </span>\r\n                    </strong>\r\n                    <button class=\"linkButton productSaveToList-editLink\"\r\n                        ng-click=\"$ctrl.save()\"\r\n                        title=\"Change list selection\">\r\n                        Edit\r\n                    </button>\r\n                </div>\r\n                <div class=\"productSaveToList-savedToListInline\" ng-if=\"$ctrl.showInline\">\r\n                    <strong class=\"productSaveToList-savedListInlineIcon\">\r\n                        <i class=\"iconww-Tick productSaveToList-savedListInlineIcon\"></i>\r\n                    </strong>\r\n                    <div class=\"productSaveToList-savedListInline\">\r\n                        <span tabindex=\"0\">{{$ctrl.actionedText}} to <span ng-pluralize count=\"$ctrl.savedToLists.length\" when=\"{1: 'list', other: 'lists'}\"></span></span>\r\n                        <button class=\"linkButton productSaveToList-editLink\"\r\n                            ng-click=\"$ctrl.save()\"\r\n                            title=\"Change list selection\">\r\n                            Edit\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(253),
    sortByKeys = _require.sortByKeys;

var _require2 = __webpack_require__(254),
    tileListViewLayout = _require2.tileListViewLayout;

var _require3 = __webpack_require__(255),
    ghostTileComponentDefinition = _require3.ghostTileComponentDefinition;

var _require4 = __webpack_require__(257),
    ghostListComponentDefinition = _require4.ghostListComponentDefinition;

var _require5 = __webpack_require__(259),
    tileListComponentDefinition = _require5.tileListComponentDefinition;

var _require6 = __webpack_require__(261),
    tileListWithContentComponentDefinition = _require6.tileListWithContentComponentDefinition;

var _require7 = __webpack_require__(263),
    tileComponentDefinition = _require7.tileComponentDefinition;

var _require8 = __webpack_require__(265),
    productFilterComponentDefinition = _require8.productFilterComponentDefinition;

var _require9 = __webpack_require__(267),
    stringFilterComponentDefinition = _require9.stringFilterComponentDefinition;

var _require10 = __webpack_require__(269),
    selectedFiltersComponentDefinition = _require10.selectedFiltersComponentDefinition;

var _require11 = __webpack_require__(271),
    ProductFilterService = _require11.ProductFilterService;

var _require12 = __webpack_require__(272),
    zeroFilterResultsComponentDefinition = _require12.zeroFilterResultsComponentDefinition;

var _require13 = __webpack_require__(274),
    tileListViewComponentDefinition = _require13.tileListViewComponentDefinition;

var _require14 = __webpack_require__(276),
    listComponentDefinition = _require14.listComponentDefinition;

angular.module('wowApp.shop').constant('SortByKeys', sortByKeys).constant('TileListViewLayout', tileListViewLayout).service('ProductFilterService', ProductFilterService).component('wowGhostTile', ghostTileComponentDefinition).component('wowGhostList', ghostListComponentDefinition).component('wowTileList', tileListComponentDefinition).component('wowTileListView', tileListViewComponentDefinition).component('wowTileListWithContent', tileListWithContentComponentDefinition).component('wowTile', tileComponentDefinition).component('wowList', listComponentDefinition).component('wowProductFilter', productFilterComponentDefinition).component('wowStringFilter', stringFilterComponentDefinition).component('wowSelectedFilters', selectedFiltersComponentDefinition).component('wowZeroFilterResults', zeroFilterResultsComponentDefinition);

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sortByKeys = Object.freeze({
    DEFAULT_KEY: 'sortByPreference',
    SPECIALS_KEY: 'sortByPreference_specials',
    SEARCH_RESULTS_KEY: 'sortByPreference_search',
    BROWSE_KEY: 'sortByPreference_browse',
    LISTS_KEY: 'sortByPreference_lists',
    PRODUCT_GROUPS_KEY: 'sortByPreference_productGroups',
    NEW_KEY: 'sortByPreference_new',
    RECIPE_KEY: 'sortByPreference_recipe',
    REVIEW_KEY: 'sortByPreference_review'
});

module.exports = {
    sortByKeys: sortByKeys
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tileListViewLayout = Object.freeze({
    TILE_VIEW: 'Tile',
    LIST_VIEW: 'List'
});

module.exports = {
    tileListViewLayout: tileListViewLayout
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GhostTileController = function GhostTileController(breakpointsService) {
    _classCallCheck(this, GhostTileController);

    this.breakpointsService = breakpointsService;
};

GhostTileController.$inject = ['BreakpointsService'];

var ghostTileComponentDefinition = {
    controller: GhostTileController,
    template: __webpack_require__(256).trim()
};

module.exports = {
    GhostTileController: GhostTileController,
    ghostTileComponentDefinition: ghostTileComponentDefinition
};

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tile\">\r\n    <div class=\"ghostTile ghostTile-animation\" ng-switch=\"$ctrl.breakpointsService.isInSmallFormat\">\r\n        <div class=\"ghostTile ghostTile-lf\" ng-switch-when=\"false\">\r\n            <!-- Top Header -->\r\n            <div class=\"ghostTile-background ghostTile-lf-topBottomMargin\"></div>\r\n            <!-- Image -->\r\n            <div class=\"ghostTile-lf-image\">\r\n                <div class=\"ghostTile-background ghostTile-lf-leftRightMargin\"></div>\r\n                <div class=\"ghostTile-background ghostTile-lf-leftRightMargin\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-lf-imageProductTextSpacing\"></div>\r\n            <!-- Product Text Line 1 -->\r\n            <div class=\"ghostTile-lf-productTextLine\">\r\n                <div class=\"ghostTile-background ghostTile-lf-leftRightMargin\"></div>\r\n                <div class=\"ghostTile-background ghostTile-lf-productTextLineAfter1\"></div>\r\n            </div>\r\n            <!-- Spacing between lines -->\r\n            <div class=\"ghostTile-background ghostTile-lf-productTextLineSpacing\"></div>\r\n            <!-- Product Text Line 2 -->\r\n            <div class=\"ghostTile-lf-productTextLine\">\r\n                <div class=\"ghostTile-background ghostTile-lf-leftRightMargin\"></div>\r\n                <div class=\"ghostTile-background ghostTile-lf-productTextLineAfter2\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-lf-productTextPriceSpacing\"></div>\r\n            <!-- Pricing -->\r\n            <div class=\"ghostTile-lf-price\">\r\n                <div class=\"ghostTile-background ghostTile-lf-leftRightMargin\"></div>\r\n                <div class=\"ghostTile-background ghostTile-lf-priceAfter\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-lf-priceControlSpacing\"></div>\r\n            <!-- Controls -->\r\n            <div class=\"ghostTile-lf-control\">\r\n                <div class=\"ghostTile-background ghostTile-lf-controlHeight ghostTile-lf-leftRightMargin\"></div>\r\n                <div class=\"ghostTile-background ghostTile-lf-controlHeight ghostTile-lf-leftRightMargin\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-lf-topBottomMargin\"></div>\r\n        </div>\r\n\r\n        <div class=\"ghostTile ghostTile-sf\" ng-switch-when=\"true\">\r\n            <!-- Top Header -->\r\n            <div class=\"ghostTile-background ghostTile-sf-topBottomMargin\"></div>\r\n            <!-- Content -->\r\n            <div class=\"ghostTile-sf-content\">\r\n                <div class=\"ghostTile-background ghostTile-sf-leftRightMargin\"></div>\r\n                <!-- Image -->\r\n                <div class=\"ghostTile-sf-contentImage\"></div>\r\n                <div class=\"ghostTile-background ghostTile-sf-contentImageTextSpacer\"></div>\r\n                <div class=\"ghostTile-sf-contentTextWrapper\">\r\n                    <!-- Product Text -->\r\n                    <div class=\"ghostTile-sf-contentProductText\"></div>\r\n                    <div class=\"ghostTile-background ghostTile-sf-contentProductTextPriceSpacer\"></div>\r\n                    <!-- Pricing -->\r\n                    <div class=\"ghostTile-sf-priceWrapper\">\r\n                        <div class=\"ghostTile-sf-priceText\"></div>\r\n                        <div class=\"ghostTile-background ghostTile-sf-priceAfter\"></div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"ghostTile-background ghostTile-sf-leftRightMargin\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-sf-spacer\"></div>\r\n            <!-- Controls -->\r\n            <div class=\"ghostTile-sf-controlWrapper\">\r\n                <div class=\"ghostTile-background ghostTile-sf-controlBefore\"></div>\r\n                <div class=\"ghostTile-sf-controlAddtocart\"></div>\r\n                <div class=\"ghostTile-background ghostTile-sf-leftRightMargin\"></div>\r\n            </div>\r\n            <div class=\"ghostTile-background ghostTile-sf-topBottomMargin\"></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GhostListController = function GhostListController(breakpointsService) {
    _classCallCheck(this, GhostListController);

    this.breakpointsService = breakpointsService;
};

GhostListController.$inject = ['BreakpointsService'];

var ghostListComponentDefinition = {
    controller: GhostListController,
    template: __webpack_require__(258).trim()
};

module.exports = {
    GhostListController: GhostListController,
    ghostListComponentDefinition: ghostListComponentDefinition
};

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ghostListContainer\">\r\n        <div class=\"ghostList ghostList-animation\" >\r\n            <div class=\"ghostList ghostList-sf\" >\r\n                <!-- Top Header -->\r\n                <div class=\"ghostList-background ghostList-sf-topBottomMargin\"></div>\r\n                <!-- Content -->\r\n                <div class=\"ghostList-sf-content\">\r\n                    <div class=\"ghostList-background ghostList-sf-leftRightMargin\"></div>\r\n                    <!-- Image -->\r\n                    <div class=\"ghostList-sf-contentImage\"></div>\r\n                    <div class=\"ghostList-background ghostList-sf-contentImageTextSpacer\"></div>\r\n                    <div class=\"ghostList-sf-contentTextWrapper\">\r\n                        <!-- Product Text -->\r\n                        <div class=\"ghostList-sf-contentProductText\"></div>\r\n                        <div class=\"ghostList-background ghostList-sf-contentProductTextPriceSpacer\"></div>\r\n                        <!-- Pricing -->\r\n                        <div class=\"ghostList-sf-priceWrapper\">\r\n                            <div class=\"ghostList-sf-priceText\"></div>\r\n                            <div class=\"ghostList-background ghostList-sf-priceAfter\"></div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"ghostList-background ghostList-sf-leftRightMargin\"></div>\r\n                    <div class=\"ghostList-sf-controlAddtocart\"></div>\r\n                    <div class=\"ghostList-background ghostList-sf-leftRightMargin\"></div>\r\n                </div>\r\n                <div class=\"ghostList-background ghostList-sf-spacer\"></div>\r\n                <!-- Controls -->\r\n                <!-- <div class=\"ghostList-sf-controlWrapper\">\r\n                    <div class=\"ghostList-background ghostList-sf-controlBefore\"></div>\r\n                    <div class=\"ghostList-sf-controlAddtocart\"></div>\r\n                    <div class=\"ghostList-background ghostList-sf-leftRightMargin\"></div>\r\n                </div> -->\r\n                <div class=\"ghostList-background ghostList-sf-topBottomMargin\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n"

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    fill = _require.fill,
    get = _require.get,
    remove = _require.remove,
    isUndefined = _require.isUndefined;

var _require2 = __webpack_require__(19),
    mergeInspirationTiles = _require2.mergeInspirationTiles;

var GHOST_TILE_ITEM = {
    type: 'ghost'
};

var TileListController = function () {
    function TileListController($q, $timeout, $location, $transclude, $state, serializeAsync, localStorageWrapper, moveFocus, settingsByBreakpointService, shopPageStateService, inspirationService, sortByKeys, settings) {
        _classCallCheck(this, TileListController);

        this.$q = $q;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$transclude = $transclude;
        this.$state = $state;
        this.localStorageWrapper = localStorageWrapper;
        this.moveFocus = moveFocus;
        this.settingsByBreakpointService = settingsByBreakpointService;
        this.shopPageStateService = shopPageStateService;
        this.inspirationService = inspirationService;
        this.sortByKeys = sortByKeys;
        this.settings = settings;

        this.loadTilesSerialized = serializeAsync(this.loadTiles, this);
    }

    _createClass(TileListController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            var _this = this;

            this.shouldRememberSort = isUndefined(this.shouldRememberSort) ? true : this.shouldRememberSort;

            if ((changes.sortBy || changes.sortOptions) && this.sortOptions != null) {
                this.sortType = this.getSortType();
            }

            if (changes.filter && !changes.filter.isFirstChange() || changes.sortBy && !changes.sortBy.isFirstChange() || changes.pageNumber && !changes.pageNumber.isFirstChange()) {
                this.update().then(function () {
                    return _this.focusOnFirstTile();
                });
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.isPaginationEnabled = isUndefined(this.isPaginationEnabled) ? true : this.isPaginationEnabled;

            this.pageSize = this.settingsByBreakpointService.getSettingValueByBreakpoint('OneSite', {
                largeFormat: 'LargeFormatPageSize',
                mediumFormat: 'MediumFormatPageSize',
                smallFormat: 'SmallFormatPageSize'
            });

            if (this.sortOptions) {
                this.sortOptions.sortContext = this.sortOptions.sortContext === undefined ? this.sortByKeys.DEFAULT_KEY : this.sortOptions.sortContext;
            }

            this.items = [];
            this.shouldGetInspirationCards = this.shouldGetInspirationCards !== false;
            this.update();
        }
    }, {
        key: 'getSortType',
        value: function getSortType() {
            // Priority: URL -> Local Storage -> First one in list
            return this.shouldRememberSort ? find(this.sortOptions.sortTypes, { Value: this.sortBy }) || find(this.sortOptions.sortTypes, { Value: this.localStorageWrapper.get(this.sortOptions.sortContext) }) || this.sortOptions.sortTypes[0] : find(this.sortOptions.sortTypes, { Value: this.sortBy }) || this.sortOptions.sortTypes[0];
        }
    }, {
        key: 'update',
        value: function update() {
            var _this2 = this;

            var isAlreadyLoadingTiles = this.isLoadingTiles;
            var isAdsTakePositionPriority = this.settings.sponsoredAds.enableMerchOrAdPositionPriority;
            this.isLoadingTiles = true;

            return this.loadTilesSerialized(!isAlreadyLoadingTiles).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    _ref2$ = _ref2[0],
                    items = _ref2$.items,
                    totalRecordCount = _ref2$.totalRecordCount,
                    aggregations = _ref2$.aggregations,
                    inspiration = _ref2[1].Cards;

                _this2.items = mergeInspirationTiles(items, inspiration, { pageNumber: _this2.pageNumber, pageSize: _this2.pageSize }, isAdsTakePositionPriority);
                _this2.totalRecordCount = totalRecordCount;
                _this2.availableFilters = aggregations;
                _this2.filter = _this2.$state.params && _this2.$state.params.filter ? _this2.$state.params.filter : { filters: [] };
                _this2.isFilterApplied = _this2.$state.params && _this2.$state.params.filter;
                _this2.pushContentToAnalytics({
                    contentData: {
                        items: _this2.items,
                        totalRecordCount: _this2.totalRecordCount,
                        sortType: _this2.sortType,
                        inspirationCards: inspiration || [],
                        pageNumber: _this2.pageNumber,
                        filters: _this2.filter
                    }
                });
            }).finally(function () {
                _this2.isLoadingTiles = false;
                _this2.shouldShowControlBar = _this2.totalRecordCount > 0 && (_this2.sortOptions || _this2.$transclude.isSlotFilled('topRightSlot'));
            });
        }
    }, {
        key: 'loadTiles',
        value: function loadTiles() {
            var shouldGenerateGhostTiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            return this.$q.all([this.getTiles({
                pageSize: this.pageSize, pageNumber: this.pageNumber, sortType: get(this.sortType, 'Value'), filter: this.filter
            }), this.shouldGetInspirationCards ? this.inspirationService.getCardsForUrl(this.$location.pathAndSearch()) : { Cards: [] }, shouldGenerateGhostTiles ? this.generateGhostTiles() : null]);
        }
    }, {
        key: 'generateGhostTiles',
        value: function generateGhostTiles() {
            var _this3 = this;

            // -1 from the page size is more aesthetically pleasing
            var amountOfGhostTiles = this.totalRecordCount ? Math.min(this.totalRecordCount, this.pageSize - 1) : this.pageSize - 1;

            // The timeout is needed to ensure that the animations run
            this.items = [];
            return this.$timeout(function () {
                _this3.items = fill(Array(amountOfGhostTiles), GHOST_TILE_ITEM);
            });
        }
    }, {
        key: 'onSortByChanged',
        value: function onSortByChanged(option) {
            this.sortBy = option.Value;
            if (this.shouldRememberSort) {
                this.localStorageWrapper.set(this.sortOptions.sortContext, this.sortBy);
            }
            this.pageNumber = 1;
            this.$state.go('.', { sortBy: option.Value, pageNumber: undefined });
        }
    }, {
        key: 'onPageSelected',
        value: function onPageSelected() {
            this.shopPageStateService.resetCenterPanelScroll();
        }
    }, {
        key: 'focusOnFirstTile',
        value: function focusOnFirstTile() {
            return this.moveFocus('.tileList-tile:first-child');
        }
    }, {
        key: 'onRemove',
        value: function onRemove(item) {
            var _this4 = this;

            var removeItemPromise = this.onRemoveItem ? this.onRemoveItem({ item: item }) : this.$q.when();

            remove(this.items, item);

            if (this.items.length === 0 && this.pageNumber > 1) {
                removeItemPromise.then(function () {
                    _this4.$state.go('.', { pageNumber: _this4.pageNumber - 1 }, { reload: true });
                });
            }
        }
    }, {
        key: 'hasFilters',
        get: function get() {
            return this.availableFilters && this.availableFilters.length > 0;
        }
    }]);

    return TileListController;
}();

TileListController.$inject = ['$q', '$timeout', '$location', '$transclude', '$state', 'serializeAsync', 'LocalStorageWrapper', 'MoveFocus', 'SettingsByBreakpointService', 'ShopPageStateService', 'InspirationService', 'SortByKeys', 'Settings'];

var tileListComponentDefinition = {
    bindings: {
        listTitle: '<?',
        pageNumber: '<?',
        filter: '<?',
        totalRecordCount: '<',
        sortBy: '<?',
        sortOptions: '<?',
        shouldGetInspirationCards: '<?',
        isEditing: '<?',
        onRemoveItem: '&?',
        getTiles: '&',
        isPaginationEnabled: '<?',
        shouldRememberSort: '<?',
        pushContentToAnalytics: '&',
        noResultsTerm: '<?',
        breadcrumbs: '<?'
    },
    controller: TileListController,
    transclude: {
        topRightSlot: '?topRight',
        zeroResultSlot: '?zeroResult',
        controlSlot: '?control'
    },
    template: __webpack_require__(260).trim()
};

module.exports = {
    TileListController: TileListController,
    tileListComponentDefinition: tileListComponentDefinition
};

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tileList-container\" ng-show=\"$ctrl.totalRecordCount !== 0 || $ctrl.isLoadingTiles || $ctrl.isFilterApplied\">\r\n    <div class=\"tileList\">\r\n        <div class=\"tileList-headerContainer\" ng-show=\"$ctrl.breadcrumbs\">\r\n            <wow-breadcrumbs links=\"$ctrl.breadcrumbs\"></wow-breadcrumbs>\r\n        </div>\r\n        <h1 class=\"tileList-title\" ng-if=\"$ctrl.listTitle\">{{ $ctrl.listTitle }}</h1>\r\n\r\n        <wow-product-filter\r\n            ng-if=\"$ctrl.hasFilters\"\r\n            available-filters=\"$ctrl.availableFilters\"\r\n            selected-filters=\"$ctrl.filter\"\r\n            total-record-count=\"$ctrl.totalRecordCount\">\r\n        </wow-product-filter>\r\n\r\n        <div class=\"tileList-controls\" ng-if=\"$ctrl.shouldShowControlBar\">\r\n            <div class=\"tileList-sortBy\" ng-if=\"::$ctrl.sortOptions\">\r\n                <div class=\"tileList-sortByLabel\">Sort by:</div>\r\n                <oly-inline-dropdown\r\n                    label-key=\"Text\"\r\n                    ng-model=\"$ctrl.sortType\"\r\n                    options=\"$ctrl.sortOptions.sortTypes\"\r\n                    on-change=\"$ctrl.onSortByChanged(option)\">\r\n                </oly-inline-dropdown>\r\n            </div>\r\n\r\n            <div ng-transclude=\"topRightSlot\"></div>\r\n        </div>\r\n\r\n        <div class=\"tileList-tiles\">\r\n            <wow-tile\r\n                class=\"tileList-repeatAnimation\"\r\n                ng-repeat=\"item in $ctrl.items track by item.id || $index\"\r\n                item=\"item\"\r\n                on-remove=\"$ctrl.onRemove(item)\"\r\n                is-editing=\"$ctrl.isEditing\">\r\n            </wow-tile>\r\n        </div>\r\n\r\n        <oly-paging\r\n            ng-if=\"$ctrl.isPaginationEnabled && !$ctrl.isLoadingTiles && $ctrl.totalRecordCount > 0 && $ctrl.pageNumber\"\r\n            page-size=\"$ctrl.pageSize\"\r\n            total-count=\"$ctrl.totalRecordCount\"\r\n            current-page=\"$ctrl.pageNumber\"\r\n            on-page-select=\"$ctrl.onPageSelected()\">\r\n        </oly-paging>\r\n    </div>\r\n\r\n    <div ng-transclude=\"controlSlot\"></div>\r\n</div>\r\n\r\n<div class=\"zeroResult-container\" ng-if=\"$ctrl.totalRecordCount === 0 && $ctrl.isFilterApplied\">\r\n    <wow-zero-filter-results term=\"$ctrl.noResultsTerm\"></wow-zero-filter-results>\r\n</div >\r\n\r\n<div ng-transclude=\"zeroResultSlot\" ng-if=\"$ctrl.totalRecordCount === 0 && !$ctrl.isFilterApplied\" class=\"zeroResult-container\"></div>\r\n"

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TileListWithContentController = function TileListWithContentController(pageBannerStateService) {
    _classCallCheck(this, TileListWithContentController);

    this.pageBannerStateService = pageBannerStateService;
};

var tileListWithContentComponentDefinition = {
    transclude: true,
    controller: ['PageBannerStateService', TileListWithContentController],
    template: __webpack_require__(262).trim()
};

module.exports = {
    TileListWithContentController: TileListWithContentController,
    tileListWithContentComponentDefinition: tileListWithContentComponentDefinition
};

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = "<wow-tobacco-banner ng-if=\"$ctrl.pageBannerStateService.getPageBannerState().setTobaccoBanner\"></wow-tobacco-banner>\r\n\r\n<ng-transclude></ng-transclude>\r\n\r\n<wow-tobacco-banner ng-if=\"$ctrl.pageBannerStateService.getPageBannerState().setTobaccoBanner\"></wow-tobacco-banner>\r\n"

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TileController = function TileController() {
    _classCallCheck(this, TileController);
};

var tileComponentDefinition = {
    bindings: {
        item: '<',
        isEditing: '<?',
        onRemove: '&?'
    },
    controller: TileController,
    template: __webpack_require__(264).trim()
};

module.exports = {
    TileController: TileController,
    tileComponentDefinition: tileComponentDefinition
};

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tile-container {{'tile-' + $ctrl.item.type}}\" ng-switch=\"$ctrl.item.type\"\r\n    ng-class=\"{ 'tile-extraMargin' : $ctrl.item.type !== 'ghost' && $ctrl.isEditing }\">\r\n    <wow-ghost-tile ng-switch-when=\"ghost\"></wow-ghost-tile>\r\n    <wow-shelf-product-tile product=\"::$ctrl.item.data.product\" ng-switch-when=\"product\"></wow-shelf-product-tile>\r\n    <wow-shelf-bundle-tile bundle=\"::$ctrl.item.data.bundle\" ng-switch-when=\"bundle\"></wow-shelf-bundle-tile>\r\n    <wow-recipe-tile recipe=\"::$ctrl.item.data.recipe\" ng-switch-when=\"recipe\"></wow-recipe-tile>\r\n    <wow-inspiration-tile card=\"::$ctrl.item.data.inspirationTile\" ng-switch-when=\"inspiration\"></wow-inspiration-tile>\r\n    <wow-inspiration-detail-tile card=\"::$ctrl.item.data.inspirationTile\" ng-switch-when=\"inspirationdetail\"></wow-inspiration-detail-tile>\r\n\r\n    <button type=\"button\" class=\"iconButton tile-remove\" ng-if=\"$ctrl.item.type !== 'ghost' && $ctrl.isEditing\" ng-click=\"$ctrl.onRemove({item: $ctrl.item})\">\r\n        <span class=\"sr-only\">Remove this product from list.</span>\r\n        <i class=\"iconww-Delete\"></i>\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    remove = _require.remove,
    cloneDeep = _require.cloneDeep,
    last = _require.last,
    filter = _require.filter,
    isEqual = _require.isEqual;

var ProductFilterController = function () {
    function ProductFilterController($state, settings, breakpointsService, productFilterService) {
        _classCallCheck(this, ProductFilterController);

        this.$state = $state;
        this.settings = settings;
        this.breakpointsService = breakpointsService;
        this.productFilterService = productFilterService;
    }

    _createClass(ProductFilterController, [{
        key: '$onInit',
        value: function $onInit() {
            this.openContent = this.$state.params.filterOpen === undefined ? this.settings.filter.showFiltersOpen : this.$state.params.filterOpen;
            this.productFilterService.setupLocationChangeEvent();
            this.updateOptionsLevel(false);
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            var _this = this;

            this.selectedFilters = this.selectedFilters || { filters: [] };
            this.filtersToBeApplied = cloneDeep(this.selectedFilters);
            this.productFilterService.updateAnalytics(this.selectedFilters);
            if (changes.availableFilters && this.availableFilters && this.availableFilters.length > 0) {
                this.clonedAvailableFilters = cloneDeep(this.availableFilters);
                // removed category filter from selected filters object
                this.selectedFiltersWithoutCategory = this.selectedFilters.filters && this.selectedFilters.filters.length > 0 ? filter(this.selectedFilters.filters, function (selectedFilter) {
                    return selectedFilter.Key !== 'Category';
                }) : [];
                var filterFromState = this.$state.params.openFilter ? find(this.availableFilters, function (availableFilter) {
                    return availableFilter.Name === _this.$state.params.openFilter;
                }) : null;

                if (filterFromState != null) {
                    this.setCurrentAvailableFilter(filterFromState);
                } else {
                    // made last selection as current filter based on filter param in url
                    this.setCurrentAvailableFilter(this.selectedFiltersWithoutCategory.length > 0 ? find(this.availableFilters, function (availableFilter) {
                        return availableFilter.Name === last(_this.selectedFiltersWithoutCategory).Key;
                    }) : this.availableFilters[0]);
                }
            }
        }
    }, {
        key: 'setCurrentAvailableFilter',
        value: function setCurrentAvailableFilter(currentAvailableFilter) {
            if (this.currentAvailableFilter !== currentAvailableFilter) {
                this.currentAvailableFilter = currentAvailableFilter;
                this.applyFilter();
            }
        }
    }, {
        key: 'onFilterToggled',
        value: function onFilterToggled(filterName, filterTerm) {
            var applyFilterOnSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var filterParam = find(this.filtersToBeApplied.filters, { Key: filterName });

            if (!filterParam) {
                filterParam = { Key: filterName, Items: [] };
                this.filtersToBeApplied.filters.push(filterParam);
            }

            var term = find(filterParam.Items, { Term: filterTerm });
            if (!term) {
                filterParam.Items.push({ Term: filterTerm });
            } else {
                remove(filterParam.Items, { Term: filterTerm });
            }

            if (applyFilterOnSelection) {
                this.applyFilter();
            }
        }
    }, {
        key: 'applyFilter',
        value: function applyFilter() {
            if (!isEqual(this.selectedFilters, this.filtersToBeApplied)) {
                this.selectedFilters = this.filtersToBeApplied;
                this.updateState(this.openContent);
                this.toggleOverlay(false);
            }
        }
    }, {
        key: 'clearAllFilters',
        value: function clearAllFilters() {
            this.availableFilters = this.clonedAvailableFilters;
            this.setCurrentAvailableFilter(this.availableFilters[0]);
            this.filtersToBeApplied.filters = [];
            this.toggleOverlay(true);
            this.$state.go('.', { filter: null });
        }
    }, {
        key: 'updateState',
        value: function updateState(filterOpen) {
            this.$state.go('.', {
                filter: this.selectedFilters, filterOpen: filterOpen, pageNumber: undefined, openFilter: this.currentAvailableFilter.Name
            }, { reload: false });
        }
    }, {
        key: 'toggleOverlay',
        value: function toggleOverlay(value) {
            this.showContent = value;
            this.updateOptionsLevel(false);
        }
    }, {
        key: 'updateOptionsLevel',
        value: function updateOptionsLevel(value) {
            this.optionsLevel = value;
        }
    }, {
        key: 'toggleContent',
        value: function toggleContent() {
            this.openContent = !this.openContent;
            this.updateState(this.openContent);
        }
    }]);

    return ProductFilterController;
}();

ProductFilterController.$inject = ['$state', 'Settings', 'BreakpointsService', 'ProductFilterService'];

var productFilterComponentDefinition = {
    bindings: {
        availableFilters: '<',
        selectedFilters: '<',
        totalRecordCount: '<'
    },
    controller: ProductFilterController,
    template: __webpack_require__(266).trim()
};

module.exports = {
    ProductFilterController: ProductFilterController,
    productFilterComponentDefinition: productFilterComponentDefinition
};

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports = "<div class=\"productFilter\">\r\n    <div ng-switch=\"$ctrl.breakpointsService.isInLargeFormat\">\r\n        <button ng-switch-when=\"true\" type=\"button\" class=\"productFilter-expandButton\" ng-click=\"$ctrl.toggleContent()\" aria-expanded=\"{{$ctrl.openContent}}\">\r\n            <h2 class=\"productFilter-title\">\r\n                Filter your search\r\n                <i class=\"productFilter-titleIcon\" ng-class=\"$ctrl.openContent? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n            </h2>\r\n        </button>\r\n\r\n        <button ng-switch-when=\"false\" type=\"button\" class=\"productFilter-expandButton\" ng-click=\"$ctrl.toggleOverlay(true)\" oly-move-focus=\".productFilter-navItem\">\r\n            <h2 class=\"productFilter-title\">Show filters</h2>\r\n            <i class=\"productFilter-titleIcon iconww-ArrowRight\"></i>\r\n        </button>\r\n    </div>\r\n\r\n    <div ng-if=\"$ctrl.breakpointsService.isInLargeFormat && $ctrl.openContent\">\r\n        <div class=\"productFilter-content\">\r\n            <ul class=\"productFilter-nav navigation navigation-items\">\r\n                <li ng-repeat=\"filter in $ctrl.availableFilters track by $index\">\r\n                    <button class=\"linkButton navigation-link productFilter-contentFilterName\"\r\n                        ng-class = \"{ 'is-active' : $ctrl.currentAvailableFilter.Name === filter.Name }\"\r\n                        ng-click=\"$ctrl.setCurrentAvailableFilter(filter)\"\r\n                        oly-move-focus=\".productFilter-filterOptions\">\r\n                        <span>{{filter.DisplayName}} <i class=\"iconww-ArrowRight\"></i></span>\r\n                    </button>\r\n                </li>\r\n            </ul>\r\n\r\n            <wow-string-filter\r\n                class=\"productFilter-filterOptions\"\r\n                tabindex=\"-1\"\r\n                filter=\"$ctrl.currentAvailableFilter\"\r\n                on-toggle-filter=\"$ctrl.onFilterToggled(filterName, filterTerm)\"\r\n                is-large-format=\"true\">\r\n            </wow-string-filter>\r\n        </div>\r\n\r\n        <div class=\"productFilter-footer\">\r\n            <button class=\"button button--primary productFilter-footerResultButton\"\r\n                ng-click=\"$ctrl.applyFilter()\"\r\n                ng-disabled=\"!$ctrl.filtersToBeApplied.filters.length\">\r\n                See results <i class=\"productFilter-footerIcon iconww-ArrowRight\"></i>\r\n            </button>\r\n        </div>\r\n    </div>\r\n\r\n    <aside class=\"productFilter-overlay\" aria-labelledby=\"filterHeader\"\r\n        ng-if=\"!$ctrl.breakpointsService.isInLargeFormat\"\r\n        ng-class=\"$ctrl.showContent ? 'productFilter-showOverlay' : 'productFilter-hideOverlay'\">\r\n        <h3 id=\"filterHeader\" class=\"productFilter-header productFilter-title\" ng-class=\"{'productFilter-optionsLevelHeader' : $ctrl.optionsLevel}\" ng-switch=\"$ctrl.optionsLevel\">\r\n            <div ng-switch-when=\"false\">\r\n                <button ng-click=\"$ctrl.toggleOverlay(false)\" class=\"iconButton productFilter-headingIcon\"\r\n                    oly-move-focus=\".productFilter-expandButton\">\r\n                    <i class=\"iconww-Cross\"></i><span class=\"sr-only\">Close filters</span>\r\n                </button>\r\n                All filters\r\n            </div>\r\n            <div ng-switch-when=\"true\">\r\n                <button ng-click=\"$ctrl.updateOptionsLevel(false)\" class=\"iconButton productFilter-headingIcon productFilter-backIcon\"\r\n                    oly-move-focus=\".productFilter-navItem\">\r\n                    <i class=\"iconww-ArrowLeft\"></i>\r\n                </button>\r\n                {{$ctrl.currentAvailableFilter.DisplayName}}\r\n            </div>\r\n        </h3>\r\n\r\n        <div class=\"productFilter-filters\" ng-switch=\"$ctrl.optionsLevel\">\r\n            <ul class=\"productFilter-nav navigation navigation-items\" ng-switch-when=\"false\">\r\n                <li ng-repeat=\"filter in $ctrl.availableFilters track by $index\">\r\n                    <button class=\"productFilter-navItem linkButton is-active\"\r\n                        ng-click=\"$ctrl.setCurrentAvailableFilter(filter); $ctrl.updateOptionsLevel(true);\"\r\n                        oly-move-focus=\".productFilter-filterOptions\">\r\n                        <span class=\"productFilter-navItemTitle\">{{filter.DisplayName}}</span>\r\n                        <i class=\"iconww-ArrowRight\"></i>\r\n                    </button>\r\n                </li>\r\n            </ul>\r\n\r\n            <wow-string-filter ng-switch-when=\"true\"\r\n                class=\"productFilter-filterOptions\"\r\n                tabindex=\"-1\"\r\n                filter=\"$ctrl.currentAvailableFilter\"\r\n                on-toggle-filter=\"$ctrl.onFilterToggled(filterName, filterTerm)\"\r\n                is-large-format=\"false\">\r\n            </wow-string-filter>\r\n        </div>\r\n\r\n        <div class=\"productFilter-footer\">\r\n            <button class=\"productFilter-clear linkButton\"\r\n                ng-disabled=\"!$ctrl.filtersToBeApplied.filters.length\"\r\n                ng-click=\"$ctrl.clearAllFilters()\">\r\n                Clear filters\r\n            </button>\r\n\r\n            <button class=\"button button--primary\"\r\n                ng-disabled=\"!$ctrl.filtersToBeApplied.filters.length\"\r\n                ng-click=\"$ctrl.applyFilter()\"\r\n                oly-move-focus=\".productFilter-expandButton\">\r\n                See results <i class=\"productFilter-footerIcon iconww-ArrowRight\"></i>\r\n            </button>\r\n        </div>\r\n    </aside>\r\n</div>\r\n\r\n<div class=\"productFilter-controls\">\r\n    <wow-selected-filters\r\n        class=\"productFilter-selectedFilters\"\r\n        total-record-count=\"$ctrl.totalRecordCount\"\r\n        selected-filters=\"$ctrl.selectedFilters\"\r\n        available-filters=\"$ctrl.availableFilters\"\r\n        on-toggle-filter=\"$ctrl.onFilterToggled(filterName, filterTerm, applyFilterOnSelection)\"\r\n        clear-all-filters=\"$ctrl.clearAllFilters()\"\r\n        show-selected-tags=\"$ctrl.breakpointsService.isInLargeFormat\">\r\n    </wow-selected-filters>\r\n</div>\r\n"

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    flatten = _require.flatten,
    filter = _require.filter,
    find = _require.find;

var KEY_CODES = {
    LEFT: 37,
    RIGHT: 39
};

var StringFilterController = function () {
    function StringFilterController($state, moveFocus) {
        _classCallCheck(this, StringFilterController);

        this.$state = $state;
        this.moveFocus = moveFocus;
    }

    _createClass(StringFilterController, [{
        key: '$onInit',
        value: function $onInit() {
            // TODO: account for other screen sizes
            this.howManyFiltersToShowWhenCollapsed = this.isLargeFormat ? 9 : 8;
            this.howManyFiltersToShow = this.howManyFiltersToShowWhenCollapsed;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            var _this = this;

            if (changes.filter && this.filter != null) {
                this.filterName = this.filter.Name;
                this.filterGroups = [this.getAllFilters(this.filter.ResultsGrouped)].concat(_toConsumableArray(this.filter.ResultsGrouped));
                this.selectableFilterGroups = this.filterGroups.filter(function (fg) {
                    return _this.isSelectable(fg);
                });

                var currentlySelectedFilterGroup = find(this.filterGroups, function (fg) {
                    return fg.Alphabet === _this.selectedAlphabet;
                });

                if (!currentlySelectedFilterGroup || !this.isSelectable(currentlySelectedFilterGroup)) {
                    this.selectFilterGroup(find(this.filterGroups, function (fg) {
                        return _this.isSelectable(fg);
                    }));
                }
            }
        }
    }, {
        key: 'getAllFilters',
        value: function getAllFilters(filters) {
            return { Alphabet: 'All', Filters: flatten(this.filterUnavailbleStringFilters(filters).map(function (f) {
                    return f.Filters;
                })) };
        }
    }, {
        key: 'filterUnavailbleStringFilters',
        value: function filterUnavailbleStringFilters(filters) {
            return filters && filters.length > 0 ? filter(filters, function (f) {
                return f.Filters && f.Filters.length > 0;
            }) : [];
        }
    }, {
        key: 'toggleSelection',
        value: function toggleSelection(filterName, filterTerm) {
            var selectedFilter = find(find(this.filterGroups, function (fg) {
                return fg.Alphabet === 'All';
            }).Filters, function (ft) {
                return ft.Name === filterTerm;
            });
            selectedFilter.Applied = !selectedFilter.Applied;

            this.onToggleFilter({ filterName: filterName, filterTerm: filterTerm });
        }
    }, {
        key: 'onAlphabetKeydown',
        value: function onAlphabetKeydown($event, filterGroupIndex) {
            if ($event.which === KEY_CODES.LEFT) {
                for (var i = Math.max(filterGroupIndex - 1, 0); i >= 0; i--) {
                    if (this.trySelectFilterGroup(this.filterGroups[i])) break;
                }
            } else if ($event.which === KEY_CODES.RIGHT) {
                for (var _i = Math.min(filterGroupIndex + 1, this.filterGroups.length); _i < this.filterGroups.length; _i++) {
                    if (this.trySelectFilterGroup(this.filterGroups[_i])) break;
                }
            }
        }
    }, {
        key: 'trySelectFilterGroup',
        value: function trySelectFilterGroup(filterGroup) {
            if (this.isSelectable(filterGroup)) {
                this.selectFilterGroup(filterGroup);

                return true;
            }

            return false;
        }
    }, {
        key: 'selectFilterGroup',
        value: function selectFilterGroup(filterGroup) {
            this.howManyFiltersToShow = this.howManyFiltersToShowWhenCollapsed;
            this.selectedAlphabet = filterGroup.Alphabet;

            this.moveFocus('#' + filterGroup.Alphabet + 'Tab', true);
        }
    }, {
        key: 'isSelected',
        value: function isSelected(filterGroup) {
            return filterGroup.Alphabet === this.selectedAlphabet;
        }
    }, {
        key: 'isSelectable',
        value: function isSelectable(filterGroup) {
            return filterGroup && filterGroup.Filters && filterGroup.Filters.length > 0;
        }
    }, {
        key: 'toggleExpanded',
        value: function toggleExpanded() {
            this.howManyFiltersToShow = this.isExpanded ? this.howManyFiltersToShowWhenCollapsed : null;
        }
    }, {
        key: 'isExpandable',
        value: function isExpandable(filters) {
            return filters && filters.length > this.howManyFiltersToShowWhenCollapsed;
        }
    }, {
        key: 'toggleContent',
        value: function toggleContent() {
            this.openContent = !this.openContent;
        }
    }, {
        key: 'isExpanded',
        get: function get() {
            return this.howManyFiltersToShow !== this.howManyFiltersToShowWhenCollapsed;
        }
    }]);

    return StringFilterController;
}();

StringFilterController.$inject = ['$state', 'MoveFocus'];

var stringFilterComponentDefinition = {
    bindings: {
        filter: '<',
        onToggleFilter: '&',
        isLargeFormat: '<'
    },
    controller: StringFilterController,
    template: __webpack_require__(268).trim()
};

module.exports = {
    StringFilterController: StringFilterController,
    stringFilterComponentDefinition: stringFilterComponentDefinition
};

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = "<div class=\"stringFilter\">\r\n    <div class=\"stringFilter-alphabet\" role=\"tablist\" aria-label=\"{{ $ctrl.filterName }} filter groups\">\r\n\r\n        <button class=\"stringFilter-alphabetTitle\" ng-if=\"!$ctrl.isLargeFormat\" ng-click=\"$ctrl.toggleContent()\">\r\n            <span class=\"stringFilter-alphabetTitleText\">{{$ctrl.selectedAlphabet}}</span>\r\n            <i ng-class=\"$ctrl.openContent? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n        </button>\r\n\r\n        <button ng-if=\"$ctrl.isLargeFormat || $ctrl.openContent\"\r\n            type=\"button\"\r\n            role=\"tab\"\r\n            id=\"{{ filterGroup.Alphabet + 'Tab' }}\"\r\n            aria-selected=\"{{ $ctrl.isSelected(filterGroup) }}\"\r\n            aria-controls=\"{{ filterGroup.Alphabet + 'TabPanel' }}\"\r\n            class=\"linkButton stringFilter-letter\"\r\n            ng-repeat=\"filterGroup in $ctrl.filterGroups track by filterGroup.Alphabet\"\r\n            ng-class=\"{ 'is-active': $ctrl.isSelected(filterGroup) }\"\r\n            ng-disabled=\"!$ctrl.isSelectable(filterGroup)\"\r\n            ng-click=\"$ctrl.selectFilterGroup(filterGroup)\"\r\n            ng-keydown=\"$ctrl.onAlphabetKeydown($event, $index)\"\r\n            tabindex=\"{{ $ctrl.isSelected(filterGroup) ? 0 : -1 }}\">\r\n\r\n            {{ ::filterGroup.Alphabet }}\r\n        </button>\r\n    </div>\r\n    <div class=\"stringFilter-statement\" ng-if=\"$ctrl.filter.Statement !== null\">\r\n        <div class=\"stringFilter-statementHeader\">\r\n            <i class=\"iconww-information stringFilter-statementIcon\"></i><span class=\"stringFilter-statementHeaderInfo\">This filter is provided as a guide only.</span>\r\n        </div>\r\n        <span class=\"stringFilter-statementContent\" ng-bind-html=\"$ctrl.filter.Statement\"></span>\r\n    </div>\r\n    <div\r\n        role=\"tabpanel\"\r\n        id=\"{{ filterGroup.Alphabet + 'TabPanel' }}\"\r\n        class=\"stringFilter-tabPanel\"\r\n        aria-labelledby=\"{{ filterGroup.Alphabet + 'Tab' }}\"\r\n        ng-repeat=\"filterGroup in $ctrl.selectableFilterGroups track by filterGroup.Alphabet\"\r\n        ng-show=\"$ctrl.isSelected(filterGroup)\">\r\n\r\n        <ul class=\"stringFilter-options\" ng-if=\"$ctrl.isSelected(filterGroup)\">\r\n            <li class=\"stringFilter-option\" ng-repeat=\"filter in filterGroup.Filters | limitTo: $ctrl.howManyFiltersToShow track by $index\">\r\n                <input\r\n                    type=\"checkbox\"\r\n                    id=\"{{ 'Filter' + $index}}\"\r\n                    class=\"wowCheckbox stringFilter-optionCheckbox\"\r\n                    name=\"{{ $ctrl.filterName }}\"\r\n                    value=\"{{ filter.Name }}\"\r\n                    ng-checked=\"filter.Applied\"\r\n                    ng-click=\"$ctrl.toggleSelection($ctrl.filterName, filter.Name)\">\r\n\r\n                <label for=\"{{ 'Filter' + $index }}\" class=\"stringFilter-optionLabel\" title=\"{{ filter.Name }}\">\r\n                    {{ filter.Name }}&nbsp;({{ filter.Count }})\r\n                </label>\r\n            </li>\r\n        </ul>\r\n\r\n        <div class=\"stringFilter-expandButton\">\r\n            <button\r\n                type=\"button\"\r\n                class=\"linkButton stringFilter-expandButtonSelector\"\r\n                ng-if=\"$ctrl.isSelected(filterGroup)\"\r\n                ng-show=\"$ctrl.isExpandable(filterGroup.Filters)\"\r\n                ng-click=\"$ctrl.toggleExpanded()\"\r\n                ng-switch=\"$ctrl.isExpanded\"\r\n                aria-expanded=\"{{ $ctrl.isExpanded }}\">\r\n\r\n                <span ng-switch-when=\"true\">\r\n                    Show less <i class=\"iconww-ArrowUp\"></i>\r\n                </span>\r\n\r\n                <span ng-switch-when=\"false\">\r\n                    Show more ({{ filterGroup.Filters.length - $ctrl.howManyFiltersToShow }})<i class=\"iconww-ArrowDown stringFilter-expandButtonShowmore\"></i>\r\n                </span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    filter = _require.filter,
    find = _require.find;

var SelectedFiltersController = function () {
    function SelectedFiltersController() {
        _classCallCheck(this, SelectedFiltersController);

        this.selectedFiltersWithoutCategory = [];
    }

    _createClass(SelectedFiltersController, [{
        key: '$onInit',
        value: function $onInit() {
            this.showSelectedTags = this.showSelectedTags === undefined ? true : this.showSelectedTags;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges() {
            var _this = this;

            if (this.selectedFilters) {
                // removed category filter from selected filters object to remove category filter from selected filter tags
                this.selectedFiltersWithoutCategory = this.selectedFilters.filters && this.selectedFilters.filters.length > 0 ? filter(this.selectedFilters.filters, function (selectedFilter) {
                    return selectedFilter.Key !== 'Category';
                }) : [];
            }
            if (this.availableFilters) {
                this.selectedFiltersWithoutCategory.forEach(function (selectedFilter) {
                    selectedFilter.Items.forEach(function (filterOption) {
                        filterOption.Count = 0;
                    });
                    var matchingAvailableFacet = find(_this.availableFilters, function (availableFilter) {
                        return availableFilter.Name === selectedFilter.Key;
                    });

                    if (matchingAvailableFacet != null) {
                        selectedFilter.Items.forEach(function (filterOption) {
                            matchingAvailableFacet.ResultsGrouped.some(function (resultGroup) {
                                var matchingFilterOption = find(resultGroup.Filters, function (availableFilter) {
                                    return availableFilter.Term === filterOption.Term;
                                });
                                if (matchingFilterOption != null) {
                                    filterOption.Count = matchingFilterOption.Count;
                                }
                                return matchingFilterOption != null;
                            });
                        });
                    }
                });
            }
        }
    }]);

    return SelectedFiltersController;
}();

var selectedFiltersComponentDefinition = {
    bindings: {
        totalRecordCount: '<',
        selectedFilters: '<',
        availableFilters: '<',
        onToggleFilter: '&',
        clearAllFilters: '&',
        showSelectedTags: '<?'
    },
    controller: SelectedFiltersController,
    template: __webpack_require__(270).trim()
};

module.exports = {
    SelectedFiltersController: SelectedFiltersController,
    selectedFiltersComponentDefinition: selectedFiltersComponentDefinition
};

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = "<div class=\"selectedFilters\">\r\n    <div\r\n        class=\"selectedFilters-count\"\r\n        ng-pluralize\r\n        count=\"$ctrl.totalRecordCount\"\r\n        when=\"{'1': '{} Product', 'other': '{} Products'}\">\r\n    </div>\r\n\r\n    <div ng-if=\"$ctrl.showSelectedTags && $ctrl.selectedFiltersWithoutCategory.length > 0\"\r\n        ng-repeat=\"selectedFilter in $ctrl.selectedFiltersWithoutCategory\">\r\n        <button\r\n            type=\"button\"\r\n            class=\"button selectedFilters-displayItem\"\r\n            ng-if=\"selectedFilter.Items.length > 0\"\r\n            ng-repeat=\"filteritem in selectedFilter.Items track by filteritem.Term\"\r\n            ng-click=\"$ctrl.onToggleFilter({ filterName: selectedFilter.Key, filterTerm: filteritem.Term, applyFilterOnSelection: true })\">\r\n\r\n            <span class=\"sr-only\">Remove filter for </span>{{filteritem.Term}}&nbsp;({{ filteritem.Count }})\r\n            <i class=\"iconww-Cross selectedFilters-displayItemIcon\"></i>\r\n        </button>\r\n    </div>\r\n\r\n    <button\r\n        type=\"button\"\r\n        class=\"selectedFilters-clear linkButton\"\r\n        ng-if=\"$ctrl.selectedFiltersWithoutCategory.length > 0\"\r\n        ng-click=\"$ctrl.clearAllFilters()\">\r\n        Clear Filters\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductFilterService = function () {
    function ProductFilterService($rootScope, analyticsService) {
        _classCallCheck(this, ProductFilterService);

        this.$rootScope = $rootScope;
        this.analyticsService = analyticsService;
    }

    _createClass(ProductFilterService, [{
        key: 'setupLocationChangeEvent',
        value: function setupLocationChangeEvent() {
            var _this = this;

            this.$rootScope.$on('$locationChangeSuccess', function () {
                _this.analyticsService.push({ data: { filters: [] }, type: _this.analyticsService.mapperTypes.search.filter });
            });
        }
    }, {
        key: 'updateAnalytics',
        value: function updateAnalytics(filters) {
            this.analyticsService.push({ data: filters, type: this.analyticsService.mapperTypes.search.filter });
        }
    }]);

    return ProductFilterService;
}();

ProductFilterService.$inject = ['$rootScope', 'AnalyticsService'];

module.exports = { ProductFilterService: ProductFilterService };

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ZeroFilterResultsComponentController = function ZeroFilterResultsComponentController() {
    _classCallCheck(this, ZeroFilterResultsComponentController);
};

var zeroFilterResultsComponentDefinition = {
    bindings: {
        term: '<?'
    },
    controller: ZeroFilterResultsComponentController,
    template: __webpack_require__(273).trim()
};

module.exports = {
    ZeroFilterResultsComponentController: ZeroFilterResultsComponentController,
    zeroFilterResultsComponentDefinition: zeroFilterResultsComponentDefinition
};

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = "<div class=\"zero-filter-results\">\r\n    <h1 class=\"zero-filter-results-header\">There are no products matching your filters.</h1>\r\n    <div class=\"zero-filter-results-blurb\">\r\n        Please try a different combination or disable your filters above to see all{{ !!$ctrl.term ? ' ' + $ctrl.term + ' ' : ' ' }}products.\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    fill = _require.fill,
    get = _require.get,
    remove = _require.remove,
    isUndefined = _require.isUndefined,
    groupBy = _require.groupBy,
    map = _require.map,
    filter = _require.filter,
    isNull = _require.isNull;

var _require2 = __webpack_require__(19),
    mergeInspirationTiles = _require2.mergeInspirationTiles;

var GHOST_TILE_ITEM = {
    type: 'ghost'
};

var TealiumEventBuilder = __webpack_require__(9);

var TileListViewController = function () {
    function TileListViewController($q, $timeout, $location, $transclude, $state, serializeAsync, localStorageWrapper, moveFocus, settingsByBreakpointService, shopPageStateService, inspirationService, sortByKeys, userPreferenceService, tileListViewLayout, trolleyService, categoriesService, analyticsService, productGroupService, settings) {
        _classCallCheck(this, TileListViewController);

        this.$q = $q;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$transclude = $transclude;
        this.$state = $state;
        this.localStorageWrapper = localStorageWrapper;
        this.moveFocus = moveFocus;
        this.settingsByBreakpointService = settingsByBreakpointService;
        this.shopPageStateService = shopPageStateService;
        this.inspirationService = inspirationService;
        this.sortByKeys = sortByKeys;
        this.userPreferenceService = userPreferenceService;
        this.tileListViewLayout = tileListViewLayout;
        this.trolleyService = trolleyService;
        this.categoriesService = categoriesService;
        this.analyticsService = analyticsService;
        this.productGroupService = productGroupService;
        this.settings = settings;

        this.loadTilesSerialized = serializeAsync(this.loadTiles, this);
    }

    _createClass(TileListViewController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.isPaginationEnabled = isUndefined(this.isPaginationEnabled) ? true : this.isPaginationEnabled;
            this.isListViewGroupByEnabled = isUndefined(this.isListViewGroupByEnabled) ? false : this.isListViewGroupByEnabled;
            this.isListViewLayoutEnabled = isUndefined(this.isListViewLayoutEnabled) ? false : this.isListViewLayoutEnabled;

            this.listViewGroupBy = false;
            this.listViewLayout = this.tileListViewLayout.LIST_VIEW;
            this.listViewVisited = true;
            this.listViewGroupByVisited = true;

            if (this.isListViewGroupByEnabled) {
                this.groupToggleState = {};
            }

            this.defaultPageSize = this.settingsByBreakpointService.getSettingValueByBreakpoint('OneSite', {
                largeFormat: 'LargeFormatPageSize',
                mediumFormat: 'MediumFormatPageSize',
                smallFormat: 'SmallFormatPageSize'
            });

            if (this.sortOptions) {
                this.sortOptions.sortContext = this.sortOptions.sortContext === undefined ? this.sortByKeys.DEFAULT_KEY : this.sortOptions.sortContext;
            }

            this.items = [];
            this.shouldGetInspirationCards = this.shouldGetInspirationCards !== false;
            this.categoryOrder = map(this.categoriesService.rootCategory.Children, 'Description');
            this.categoryOrder.push('Bundles');
            this.categoryOrder.push('Other');

            if (this.isListViewLayoutEnabled || this.isListViewGroupByEnabled) {
                this.userPreferenceService.getUserPreference().then(function (userPreferences) {
                    if (_this.isListViewLayoutEnabled === true) {
                        _this.listViewLayout = userPreferences.ListViewLayout;
                        _this.listViewVisited = userPreferences.ListViewVisited;
                        if (isNull(_this.listViewLayout) || _this.listViewLayout === '') {
                            _this.listViewLayout = _this.tileListViewLayout.LIST_VIEW;
                        }
                        if (_this.listViewVisited === false) {
                            _this.userPreferenceService.setListViewVisited(true);
                        }
                    }

                    if (_this.isListViewGroupByEnabled === true) {
                        _this.listViewGroupBy = userPreferences.ListViewGroupBy;
                        _this.listViewGroupByVisited = userPreferences.ListViewGroupByVisited;
                        if (_this.listViewGroupByVisited === false) {
                            _this.userPreferenceService.setListViewGroupByVisited(true);
                        }
                    }

                    _this.update();
                });
            } else {
                this.update();
            }
        }
    }, {
        key: 'isMobile',
        value: function isMobile() {
            var x = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
            return x < 850 && x > 767 || x < 600;
        }
    }, {
        key: 'pageSize',
        value: function pageSize() {
            return this.listViewGroupBy ? 100 : this.defaultPageSize;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            var _this2 = this;

            this.shouldRememberSort = isUndefined(this.shouldRememberSort) ? true : this.shouldRememberSort;

            if ((changes.sortBy || changes.sortOptions) && this.sortOptions != null) {
                this.sortType = this.getSortType();
            }

            if (changes.filter && !changes.filter.isFirstChange() || changes.sortBy && !changes.sortBy.isFirstChange() || changes.pageNumber && !changes.pageNumber.isFirstChange()) {
                this.update().then(function () {
                    return _this2.focusOnFirstTile();
                });
            }
        }
    }, {
        key: 'saveListViewGroupBy',
        value: function saveListViewGroupBy(value) {
            this.userPreferenceService.setListViewGroupBy(value);
            this.listViewGroupByVisited = true;
            var event = new TealiumEventBuilder().withEventName('link_click').withLabel('List Grouping').withValue(value ? 'Group' : 'Ungroup').withEventType(this.analyticsService.mapperTypes.shop.userPreference).withTrackingType('link').build();
            this.analyticsService.push(event);
            this.pageNumber = 1;
            this.$state.go('.', { pageNumber: 1 });
            this.update();
        }
    }, {
        key: 'saveListViewLayout',
        value: function saveListViewLayout(value) {
            this.userPreferenceService.setListViewLayout(value);
            this.listViewVisited = true;
            this.listViewLayout = value;
            var event = new TealiumEventBuilder().withEventName('link_click').withLabel('List View Type').withValue(value === 'Tile' ? 'Grid' : 'List').withEventType(this.analyticsService.mapperTypes.shop.userPreference).withTrackingType('link').build();
            this.analyticsService.push(event);
            this.pageNumber = 1;
            this.$state.go('.', { pageNumber: 1 });
            this.update();
        }
    }, {
        key: 'requireListViewLayout',
        value: function requireListViewLayout() {
            if (!this.isListViewLayoutEnabled) {
                return false;
            }

            if (isNull(this.listViewLayout)) {
                return true;
            }

            if (this.isMobile()) {
                return false;
            }

            return this.listViewLayout === this.tileListViewLayout.LIST_VIEW;
        }
    }, {
        key: 'addGroup',
        value: function addGroup(groupName) {
            var group = find(this.groupedItems, ['key', groupName]);
            var products = map(group.purchasable, 'data.product');
            this.trolleyService.addItemsToTrolley(products);
            var event = new TealiumEventBuilder().withEventName('link_click').withLabel('Add ' + groupName + ' Group').withEventType(this.analyticsService.mapperTypes.shop.userPreference).withTrackingType('link').build();
            this.analyticsService.push(event);
        }
    }, {
        key: 'initializeGroupToggleState',
        value: function initializeGroupToggleState() {
            var _this3 = this;

            this.groupedKeys.forEach(function (key) {
                if (_this3.groupToggleState[key] == null) {
                    _this3.groupToggleState[key] = true;
                }
            });
        }
    }, {
        key: 'toggleGroup',
        value: function toggleGroup(groupKey) {
            this.groupToggleState[groupKey] = !this.groupToggleState[groupKey];
        }
    }, {
        key: 'isGroupExpanded',
        value: function isGroupExpanded(groupKey) {
            return this.groupToggleState[groupKey];
        }
    }, {
        key: 'getSortType',
        value: function getSortType() {
            // Priority: URL -> Local Storage -> First one in list
            return this.shouldRememberSort ? find(this.sortOptions.sortTypes, { Value: this.sortBy }) || find(this.sortOptions.sortTypes, { Value: this.localStorageWrapper.get(this.sortOptions.sortContext) }) || this.sortOptions.sortTypes[0] : find(this.sortOptions.sortTypes, { Value: this.sortBy }) || this.sortOptions.sortTypes[0];
        }
    }, {
        key: 'getGroupType',
        value: function getGroupType(item) {
            if (item.data.product.IsBundle) {
                return 'Bundles';
            }

            var department = this.productGroupService.getDepartmentGroup(JSON.parse(item.data.product.AdditionalAttributes.PiesProductDepartmentsjson), this.settings.lists.includedDepartmentIds);

            return department;
        }
    }, {
        key: 'groupItems',
        value: function groupItems() {
            var _this4 = this;

            var groupedObjects = groupBy(this.items, function (b) {
                return _this4.getGroupType(b);
            });
            this.groupedKeys = Object.keys(groupedObjects);
            this.groupedItems = this.groupedKeys.map(function (key) {
                return { key: key, value: groupedObjects[key], purchasable: filter(groupedObjects[key], function (t) {
                        return t.data.product.IsPurchasable;
                    }) };
            });
            // order the category groupings the same as the navigation header.
            this.groupedItems = this.groupedItems.sort(function (a, b) {
                return _this4.categoryOrder.indexOf(a.key) - _this4.categoryOrder.indexOf(b.key);
            });
        }
    }, {
        key: 'update',
        value: function update() {
            var _this5 = this;

            var isAlreadyLoadingTiles = this.isLoadingTiles;
            this.isLoadingTiles = true;

            return this.loadTilesSerialized(!isAlreadyLoadingTiles).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    _ref2$ = _ref2[0],
                    items = _ref2$.items,
                    totalRecordCount = _ref2$.totalRecordCount,
                    aggregations = _ref2$.aggregations,
                    inspiration = _ref2[1].Cards;

                _this5.items = mergeInspirationTiles(items, inspiration, { pageNumber: _this5.pageNumber, pageSize: _this5.pageSize() });
                if (_this5.isListViewGroupByEnabled) {
                    if (_this5.listViewGroupBy) {
                        _this5.groupItems();
                        _this5.initializeGroupToggleState();
                    }
                }
                _this5.totalRecordCount = totalRecordCount;
                _this5.availableFilters = aggregations;
                _this5.filter = _this5.$state.params && _this5.$state.params.filter ? _this5.$state.params.filter : { filters: [] };
                _this5.isFilterApplied = _this5.$state.params && _this5.$state.params.filter;
                _this5.pushContentToAnalytics({
                    contentData: {
                        items: _this5.items,
                        totalRecordCount: _this5.totalRecordCount,
                        sortType: _this5.sortType,
                        inspirationCards: inspiration || [],
                        pageNumber: _this5.pageNumber,
                        filters: _this5.filter,
                        viewType: _this5.listViewLayout,
                        groupType: _this5.listViewGroupBy ? 'Grouped' : 'Ungrouped'
                    }
                });
            }).finally(function () {
                _this5.isLoadingTiles = false;
                _this5.shouldShowControlBar = _this5.sortOptions || _this5.$transclude.isSlotFilled('topRightSlot');
            });
        }
    }, {
        key: 'loadTiles',
        value: function loadTiles() {
            var shouldGenerateGhostTiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            return this.$q.all([this.getTiles({
                pageSize: this.pageSize(), pageNumber: this.pageNumber, sortType: get(this.sortType, 'Value'), filter: this.filter
            }), this.shouldGetInspirationCards ? this.inspirationService.getCardsForUrl(this.$location.pathAndSearch()) : { Cards: [] }, shouldGenerateGhostTiles ? this.generateGhostTiles() : null]);
        }
    }, {
        key: 'generateGhostTiles',
        value: function generateGhostTiles() {
            var _this6 = this;

            // -1 from the page size is more aesthetically pleasing
            var amountOfGhostTiles = this.totalRecordCount ? Math.min(this.totalRecordCount, this.pageSize() - 1) : this.pageSize() - 1;

            // The timeout is needed to ensure that the animations run
            this.items = [];
            return this.$timeout(function () {
                _this6.items = fill(Array(amountOfGhostTiles), GHOST_TILE_ITEM);
            });
        }
    }, {
        key: 'onSortByChanged',
        value: function onSortByChanged(option) {
            this.sortBy = option.Value;
            if (this.shouldRememberSort) {
                this.localStorageWrapper.set(this.sortOptions.sortContext, this.sortBy);
            }
            this.pageNumber = 1;
            this.$state.go('.', { sortBy: option.Value, pageNumber: undefined });
        }
    }, {
        key: 'onPageSelected',
        value: function onPageSelected() {
            this.shopPageStateService.resetCenterPanelScroll();
        }
    }, {
        key: 'focusOnFirstTile',
        value: function focusOnFirstTile() {
            return this.moveFocus('.tileList-tile:first-child');
        }
    }, {
        key: 'onRemove',
        value: function onRemove(item) {
            var _this7 = this;

            var removeItemPromise = this.onRemoveItem ? this.onRemoveItem({ item: item }) : this.$q.when();

            remove(this.items, item);
            if (this.isListViewGroupByEnabled) {
                if (this.listViewGroupBy) {
                    this.groupItems();
                    this.initializeGroupToggleState();
                }
            }

            if (this.items.length === 0 && this.pageNumber > 1) {
                removeItemPromise.then(function () {
                    _this7.$state.go('.', { pageNumber: _this7.pageNumber - 1 }, { reload: true });
                });
            }
        }
    }, {
        key: 'hasFilters',
        get: function get() {
            return this.availableFilters && this.availableFilters.length > 0;
        }
    }]);

    return TileListViewController;
}();

TileListViewController.$inject = ['$q', '$timeout', '$location', '$transclude', '$state', 'serializeAsync', 'LocalStorageWrapper', 'MoveFocus', 'SettingsByBreakpointService', 'ShopPageStateService', 'InspirationService', 'SortByKeys', 'UserPreferenceService', 'TileListViewLayout', 'TrolleyService', 'CategoriesService', 'AnalyticsService', 'ProductGroupService', 'Settings'];

var tileListViewComponentDefinition = {
    bindings: {
        listTitle: '<?',
        pageNumber: '<?',
        filter: '<?',
        totalRecordCount: '<',
        sortBy: '<?',
        sortOptions: '<?',
        shouldGetInspirationCards: '<?',
        isEditing: '<?',
        onRemoveItem: '&?',
        getTiles: '&',
        isPaginationEnabled: '<?',
        shouldRememberSort: '<?',
        pushContentToAnalytics: '&',
        noResultsTerm: '<?',
        breadcrumbs: '<?',
        isListViewGroupByEnabled: '<?',
        isListViewLayoutEnabled: '<?'
    },
    controller: TileListViewController,
    transclude: {
        topRightSlot: '?topRight',
        zeroResultSlot: '?zeroResult',
        controlSlot: '?control'
    },
    template: __webpack_require__(275).trim()
};

module.exports = {
    TileListViewController: TileListViewController,
    tileListViewComponentDefinition: tileListViewComponentDefinition
};

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"$ctrl.requireListViewLayout() ? 'tileListView-containerList' : 'tileListView-container'\">\r\n    <div class=\"tileListView\">\r\n        <div class=\"tileListView-headerContainer\">\r\n            <wow-breadcrumbs links=\"$ctrl.breadcrumbs\"></wow-breadcrumbs>\r\n        </div>\r\n        <div class=\"tileListView-controlsHeader\">\r\n            <h1 class=\"tileListView-title\" ng-if=\"$ctrl.listTitle\">{{ $ctrl.listTitle }}</h1>\r\n            <div class=\"tileListView-desktopSlot\" ng-transclude=\"topRightSlot\"></div>\r\n        </div>\r\n        <wow-product-filter \r\n            ng-if=\"$ctrl.hasFilters\"\r\n            available-filters=\"$ctrl.availableFilters\"\r\n            selected-filters=\"$ctrl.filter\"\r\n            total-record-count=\"$ctrl.totalRecordCount\">\r\n        </wow-product-filter>\r\n\r\n        <div class=\"tileListView-controls\" ng-if=\"$ctrl.shouldShowControlBar\">\r\n            <div class=\"tileListView-controlsLeft\">\r\n                <div class=\"tileListView-groupToggle\" ng-if=\"$ctrl.isListViewGroupByEnabled\" tooltips tooltip-template=\"NEW! Try me\" tooltip-show=\"{{!$ctrl.listViewGroupByVisited}}\" tooltip-side=\"bottom right\" tooltip-show-trigger=\"none\" tooltip-hide-trigger=\"none\" tooltip-class=\"tileListView-TooltipGroup\">\r\n                    <input ng-if=\"$ctrl.isListViewGroupByEnabled\" type=\"checkbox\" id=\"savedListGroupBy\" class=\"wowCheckbox label-before tileListView-controlsCheckbox\" ng-model=\"$ctrl.listViewGroupBy\" ng-change=\"$ctrl.saveListViewGroupBy($ctrl.listViewGroupBy)\" />\r\n                    <label ng-if=\"$ctrl.isListViewGroupByEnabled\" for=\"savedListGroupBy\">{{$ctrl.settings.lists.groupByName}}:</label>\r\n                </div>\r\n                <div class=\"tileListView-sortBy\" ng-if=\"::$ctrl.sortOptions\">\r\n                    <div class=\"tileListView-sortByLabel\">Sort by:</div>\r\n                    <oly-inline-dropdown label-key=\"Text\" ng-model=\"$ctrl.sortType\" options=\"$ctrl.sortOptions.sortTypes\" on-change=\"$ctrl.onSortByChanged(option)\">\r\n                    </oly-inline-dropdown>\r\n                </div>\r\n            </div>\r\n\r\n            <div ng-if=\"!$ctrl.isMobile()\" class=\"tileListView-view\" ng-if=\"$ctrl.isListViewLayoutEnabled\" tooltips tooltip-template=\"NEW! Try me\" tooltip-show=\"{{!$ctrl.listViewVisited && !$ctrl.isMobile()}}\" tooltip-side=\"top left\" tooltip-show-trigger=\"none\" tooltip-hide-trigger=\"none\" tooltip-class=\"tileListView-TooltipView\">\r\n                <label class=\"tileListView-viewLabel\" for=\"savedListTileView\">View: </label>\r\n                <button class=\"button\" id=\"savedListListView\" ng-class=\"$ctrl.requireListViewLayout() ? 'tileListView-controls-listViewSelectedIcon' : 'tileListView-controls-listViewIcon'\" ng-click=\"$ctrl.saveListViewLayout($ctrl.tileListViewLayout.LIST_VIEW)\">\r\n                    <span class=\"sr-only\">List View</span>\r\n                </button>\r\n                <button class=\"button\" id=\"savedListTileView\" ng-class=\"!$ctrl.requireListViewLayout() ? 'tileListView-controls-tileViewSelectedIcon' : 'tileListView-controls-tileViewIcon'\" ng-click=\"$ctrl.saveListViewLayout($ctrl.tileListViewLayout.TILE_VIEW)\">\r\n                    <span class=\"sr-only\">Tile View</span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <div ng-if=\"$ctrl.listViewGroupBy\">\r\n            <div class=\"tileListView-group\" ng-repeat=\"group in $ctrl.groupedItems\">\r\n                <hr class=\"tileListView-separator\" />\r\n                <wow-list-group group-name=\"{{ group.key }} ({{group.value.length}})\" expanded=\"$ctrl.groupToggleState[group.key]\">\r\n                    <wow-list-group-cta>\r\n                        <button class=\"button button--primary tileListView-groupControlsAddToCart\" ng-click=\"$ctrl.addGroup(group.key)\" ng-if=\"group.purchasable.length > 0\">\r\n                            Add ({{ group.purchasable.length }}) to cart\r\n                        </button>\r\n                    </wow-list-group-cta>\r\n                    <wow-list-group-content>\r\n                            <div class=\"tileListView-list\" ng-if=\"$ctrl.requireListViewLayout()\">\r\n                                <wow-list class=\"tileListView-repeatAnimation\" ng-repeat=\"item in group.value track by item.id || $index\" item=\"item\" on-remove=\"$ctrl.onRemove(item)\" is-editing=\"$ctrl.isEditing\">\r\n                                </wow-list>\r\n                            </div>\r\n                            <div class=\"tileListView-tiles\" ng-if=\"!$ctrl.requireListViewLayout()\">\r\n                                <wow-tile class=\"tileListView-repeatAnimation\" ng-repeat=\"item in group.value track by item.id || $index\" item=\"item\" on-remove=\"$ctrl.onRemove(item)\" is-editing=\"$ctrl.isEditing\">\r\n                                </wow-tile>\r\n                            </div>\r\n                    </wow-list-group-content>\r\n                </wow-list-group>\r\n            </div>\r\n            <hr class=\"tileListView-separator\" />\r\n        </div>\r\n\r\n        <div ng-if=\"!$ctrl.listViewGroupBy\">\r\n            <hr class=\"tileListView-separator\" />\r\n            <div class=\"tileListView-list\" ng-if=\"$ctrl.requireListViewLayout()\">\r\n                <wow-list class=\"tileListView-repeatAnimation\" ng-repeat=\"item in $ctrl.items track by item.id || $index\" item=\"item\" on-remove=\"$ctrl.onRemove(item)\" is-editing=\"$ctrl.isEditing\">\r\n                </wow-list>\r\n                <div ng-transclude=\"controlSlot\"></div>\r\n            </div>\r\n            <div class=\"tileListView-tiles\" ng-if=\"!$ctrl.requireListViewLayout()\">\r\n                <wow-tile class=\"tileListView-repeatAnimation\" ng-repeat=\"item in $ctrl.items track by item.id || $index\" item=\"item\" on-remove=\"$ctrl.onRemove(item)\" is-editing=\"$ctrl.isEditing\">\r\n                </wow-tile>\r\n                <div ng-transclude=\"controlSlot\"></div>\r\n            </div>\r\n            <hr class=\"tileListView-separator\" />\r\n        </div>\r\n\r\n        <oly-paging ng-if=\"$ctrl.isPaginationEnabled && !$ctrl.isLoadingTiles && $ctrl.totalRecordCount > 0 && $ctrl.pageNumber\" page-size=\"$ctrl.pageSize()\" total-count=\"$ctrl.totalRecordCount\" current-page=\"$ctrl.pageNumber\" on-page-select=\"$ctrl.onPageSelected()\">\r\n        </oly-paging>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"tileListView-mobileSlot\">\r\n    <div ng-transclude=\"topRightSlot\"></div>\r\n</div>\r\n\r\n<div class=\"zeroResult-container\" ng-if=\"$ctrl.totalRecordCount === 0 && $ctrl.isFilterApplied\">\r\n    <wow-zero-filter-results term=\"$ctrl.noResultsTerm\"></wow-zero-filter-results>\r\n</div>\r\n\r\n<div ng-transclude=\"zeroResultSlot\" ng-if=\"$ctrl.totalRecordCount === 0 && !$ctrl.isFilterApplied\" class=\"zeroResult-container\"></div>\r\n"

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ListController = function ListController() {
    _classCallCheck(this, ListController);
};

var listComponentDefinition = {
    bindings: {
        item: '<',
        isEditing: '<?',
        onRemove: '&?'
    },
    controller: ListController,
    template: __webpack_require__(277).trim()
};

module.exports = {
    ListController: ListController,
    listComponentDefinition: listComponentDefinition
};

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = "<div class=\"list-container {{'list-' + $ctrl.item.type}}\" ng-switch=\"$ctrl.item.type\"\r\n    ng-class=\"{ 'list-extraMargin' : $ctrl.item.type !== 'ghost' && $ctrl.isEditing }\">\r\n    <wow-ghost-list ng-switch-when=\"ghost\"></wow-ghost-list>\r\n    <wow-shelf-product-list product=\"::$ctrl.item.data.product\" ng-switch-when=\"product\" ></wow-shelf-product-list>\r\n\r\n    <button type=\"button\" class=\"iconButton list-remove\" ng-if=\"$ctrl.item.type !== 'ghost' && $ctrl.isEditing\" ng-click=\"$ctrl.onRemove({item: $ctrl.item})\">\r\n        <span class=\"sr-only\">Remove this product from list.</span>\r\n        <i class=\"iconww-Delete\"></i>\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

angular.module('wowApp.shop').service('TrolleyService', ['$rootScope', 'Restangular', '$q', '$state', 'BootstrapService', 'LoginService', 'ShopperService', 'SettingsService', 'DeliveryPassService', 'InspirationService', 'TrolleySource', 'BreakpointsService', 'RichRelevanceService', 'FeatureService', 'AnalyticsService', __webpack_require__(279)]).constant('TrolleySource', __webpack_require__(280));

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _ = __webpack_require__(0),
    _require = __webpack_require__(33),
    trolleyQuantityValidation = _require.trolleyQuantityValidation;

var _shopperService = void 0;
var _trolleySourceCz = void 0;
var _breakpointsService = void 0;
var _analytics = void 0;
var _settingsService = void 0;

/* This service contains combined changes from
 * story WOS-2279 (move filtering to server side)
 * and story WOS-2281 (reduce client side watchers)
 */

var TrolleyService = function TrolleyService($rootScope, restangular, $q, $state, bootstrap, loginService, shopperService, settingsService, deliveryPassService, inspirationService, trolleySource, breakpointsService, richRelevanceService, featureService, analyticsService) {
    var _this = this;

    /*
     * Service for interacting with the trolley.
     * Supports actions like adding, removing, updating, and clearing.
     * Depends on Restangular.
     */
    var trolleyRoute = restangular.one('Trolley');
    this._trolleyRoute = trolleyRoute;

    this._trolleyRoute.postSequential = function (route, params) {
        var requestCallback = function requestCallback() {
            return trolleyRoute.post(route, params);
        };

        if (this.pendingRequest) {
            this.pendingRequest = this.pendingRequest.then(requestCallback, requestCallback);
        } else {
            this.pendingRequest = requestCallback();
        }

        return this.pendingRequest;
    };

    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$state = $state;
    this._loginService = loginService;
    _shopperService = shopperService;
    _trolleySourceCz = trolleySource.collectionZone;
    _analytics = analyticsService;
    _settingsService = settingsService;
    this.inspirationService = inspirationService;
    this.guestTrolleyLoginReminderShown = false;
    // The items
    this.trolleyProducts = [];

    // Products that are being added or removed on user action for analytics
    this.recentlyChangedItems = [];

    // Totals information
    this.salePriceTotal = 0;
    this.listPriceTotal = 0;
    this.deliveryFee = 0;
    this.savedPrice = 0;

    // Rewards Plus flags
    this.ShouldRecieveFreeDeliveryRewardsPlus = false;
    this.ShouldRecieveBonusPointsRewardsPlus = false;
    this.RewardsPlusBonusPointsMessage = '';

    this.isTotalReady = false;
    this.wowRewardsSummary = {};

    this.srMessage = ''; // this is for sr (Screen Reader) only.

    this.deliveryPassService = deliveryPassService;

    // First initialization
    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.Trolley)) {
        this._updateTrolley(bootstrap.getBootstrappedData(bootstrap.bootstrapped.Trolley));
    }

    this.deliveryPassLimitReached = {};

    this.showDCPdeliveryPassLimitReachedMsg = false;

    this.maxItemsAllowedForGuestUser = 5; // default value

    settingsService.getSettingValue('Trolley', 'GuestUserMaxItemCount').then(function (response) {
        _this.maxItemsAllowedForGuestUser = parseInt(response);
    });

    this.updateRequestCount = 0;

    _breakpointsService = breakpointsService;

    this.richRelevanceService = richRelevanceService;

    this.featureService = featureService;

    this.$rootScope.$on('trolley:invalidatePricing', function () {
        _this._invalidatePricing();
    });
};

TrolleyService.prototype._invalidatePricing = function () {
    this.getTrolley();
};

function getAllProducts() {
    return _.compact(_.concat(this.trolleyProducts, this.unavailableProducts, this.restrictedProducts, this.restrictedByDeliveryMethodProducts, this.restrictedProductsByDeliPlatters, this.bundleProducts));
}

TrolleyService.prototype._updateTrolley = function (response) {
    this.trolleyProducts = response.AvailableItems;
    this.bundleProducts = response.BundleItems;
    this.unavailableProducts = response.UnavailableItems;
    this.restrictedByDeliveryMethodProducts = response.RestrictedByDeliveryMethodItems;
    this.restrictedByDeliveryMethodMessage = response.RestrictedByDeliveryMethodMessage;
    this.restrictedProductsByDeliPlatters = response.RestrictedByDeliPlattersItems;
    this.restrictedProducts = _.concat(response.RestrictedItems, response.RestrictedByDeliPlattersItems);
    this.trolleyProductsByStockcode = _.keyBy(getAllProducts.call(this), function (i) {
        return i.Stockcode;
    });
    this.itemCount = response.TrolleyItemCount;
    this.totalItemQuantity = response.TotalTrolleyItemQuantity;
    this.maximumOrderQuantity = response.MaximumOrderQuantity;
    if (this.deliveryPassService) {
        this.deliveryPassService.deliveryPassPrompt = response.ShopperDeliveryPassPromptResponse;
    }
    // Update Totals
    this.salePriceTotal = response.Totals.Total;
    this.savedPrice = response.Totals.TotalSavings;
    this.deliveryFee = response.DeliveryFee.Total;
    this.wowRewardsSummary = response.WowRewardsSummary;
    this.isTotalReady = true;

    // Update Waive Fee Setting
    this.ShouldRecieveFreeDeliveryRewardsPlus = response.ShouldRecieveFreeDeliveryRewardsPlus;

    // Update Rewards Plus settings
    this.ShouldRecieveBonusPointsRewardsPlus = response.ShouldRecieveBonusPointsRewardsPlus;
    this.RewardsPlusBonusPointsMessage = response.RewardsPlusBonusPointsMessage;

    // refresh dtm data layer
    this._pushTrolleyDataToDtm(response);
    // tealium push
    return response;
};

TrolleyService.prototype.validateDeliveryPassLimit = function (product, quantity) {
    return this._trolleyRoute.postSequential('ValidateDeliveryPass', {
        Stockcode: product.Stockcode,
        Quantity: quantity
    });
};

TrolleyService.prototype.validateQuantity = function (product, quantity) {
    if (quantity === '' || isNaN(quantity)) {
        return { isValid: false, reason: trolleyQuantityValidation.INVALID_QUANTITY };
    }

    if (this.deliveryPassLimitReached[product.Stockcode]) {
        return { isValid: false, reason: trolleyQuantityValidation.DELIVERY_PASS_LIMIT_EXCEEDED };
    }

    if (quantity > product.SupplyLimit) {
        return { isValid: false, reason: trolleyQuantityValidation.SUPPLY_LIMIT_EXCEEDED };
    }

    if (quantity < product.MinimumQuantity) {
        return { isValid: false, reason: trolleyQuantityValidation.INVALID_QUANTITY };
    }

    return { isValid: true, reason: '' };
};

TrolleyService.prototype._manageErrorMessage = function (product, errorType) {
    var trolleyItem = this.trolleyProductsByStockcode[product.Stockcode];

    if (!this.errors) {
        this.errors = {};
    }

    this.errors[product.Stockcode] = errorType;

    if (trolleyItem != null) {
        trolleyItem.HasError = errorType;
    }
};

TrolleyService.prototype._setScreenReaderMessage = function (stockcode, state) {
    var item = this.getTrolleyItem(stockcode);
    if (!item) {
        // If the item is no longer in the trolley for some reason, shortcut the method.
        // This can happen when trying to add too many delivery passes to the trolley.
        return;
    }

    switch (state) {
        case 'add':
            this.srMessage = item.Name + ' ' + item.PackageSize + ' added to trolley. Quantity: ' + item.Quantity;
            break;
        case 'update':
            this.srMessage = item.Name + ' ' + item.PackageSize + ' quantity in trolley has been updated to ' + item.Quantity;
            break;
        case 'remove':
            this.srMessage = item.Name + ' ' + item.PackageSize + ' removed from trolley';
            break;
        case 'clear':
            this.srMessage = 'All products have been removed from the trolley.';
            break;
        case 'clearOOS':
            this.srMessage = 'All out of stock products have been removed from the trolley.';
            break;
    }
};

TrolleyService.prototype.getTrolley = function () {
    this.isTotalReady = false;

    return this._trolleyRoute.get().then(this._updateTrolley.bind(this));
};

TrolleyService.prototype.getTrolleyItem = function (stockcode) {
    var product = null;

    if (this.trolleyProductsByStockcode) {
        product = this.trolleyProductsByStockcode[stockcode];
    }

    if (!product) {
        product = _.find(this.trolleyProducts, { Stockcode: stockcode });
    }

    if (!product) {
        product = _.find(this.restrictedProducts, { Stockcode: stockcode });
    }

    if (!product) {
        product = _.find(this.unavailableProducts, { Stockcode: stockcode });
    }

    return product;
};

TrolleyService.prototype._pushAddOrRemoveItemToDtm = function (response, isRemovingItemFromTrolley) {
    if (isRemovingItemFromTrolley) {
        _analytics.pushEvent(_analytics.events.REMOVE_FROM_CART);
        this._pushTrolleyDataToDtm(response);
    } else {
        _analytics.pushEvent(_analytics.events.ADD_TO_CART);
        this._pushTrolleyDataToDtm(response);
    }
};

TrolleyService.prototype._pushTrolleyDataToDtm = function (response) {
    var rewardsPointsConversionBase = 1;
    if (_settingsService.settings && _settingsService.settings.loyalty && _settingsService.settings.loyalty.rewardsConversionBase) {
        rewardsPointsConversionBase = _settingsService.settings.loyalty.rewardsConversionBase;
    }
    _analytics.push({
        data: { Trolley: response, cartChange: this.recentlyChangedItems, rewardsPointsConversionBase: rewardsPointsConversionBase },
        type: _analytics.mapperTypes.shop.trolley
    });
};

function appendAdIdToSourceIfExist(source, product) {
    if ('IsSponsoredAd' in product && product.IsSponsoredAd && product.AdID) {
        return source + '.AdID.' + product.AdID;
    }

    return source;
}

function formatTrolleyProductSource(source) {
    if (_breakpointsService.isInSmallFormat) {
        return 'SF.' + source;
    }
    if (_breakpointsService.isInMediumFormat) {
        return 'MF.' + source;
    }
    if (_breakpointsService.isInLargeFormat) {
        return 'LF.' + source;
    }

    return '';
}

/**
 * Rejects promises for trolley updates if a later update has been made.
 *
 * Since most trolley API calls return the entire trolley aggregate, it is a waste of resources and also
 * disruptful to the UI to update the trolley when we get a response that has been superseded by a later call.
 *
 * @param {Promise} promise - This promise will be rejected (even if the network call was successful)
 *  if a later request is made (even if the later request fails).
 * @param {boolean} [shouldSerialize=true] - Bypasses the serialization behaviour for
 *  deployment switch purposes.
 * @returns {Promise}
 */
TrolleyService.prototype._rejectIfLaterUpdate = function (promise) {
    var _this2 = this;

    var shouldSerialize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!shouldSerialize) {
        return promise;
    }

    this.updateRequestCount++;
    var requestVersion = this.updateRequestCount;

    return promise.then(function (response) {
        return requestVersion >= _this2.updateRequestCount ? response : _this2.$q.reject('superseded');
    });
};

function postToTrolley(product, quantity, source, searchTerm) {
    var _this3 = this;

    this.isTotalReady = false;

    return this._rejectIfLaterUpdate(this._trolleyRoute.postSequential('Items', {
        stockcode: product.Stockcode, quantity: quantity, source: appendAdIdToSourceIfExist(formatTrolleyProductSource(source), product), searchTerm: searchTerm, diagnostics: product.Diagnostics
    })).then(function (response) {
        _this3._updateTrolley(response);
        _this3._setScreenReaderMessage(product.Stockcode, 'add');
        return response;
    }).then(function (response) {
        _this3.$rootScope.$broadcast('trolley:update');

        // TODO: may merge this push to the next push
        var cardId = _this3.inspirationService.getContentCardId();
        if (cardId && source !== _trolleySourceCz) {
            _analytics.push({ data: cardId, type: _analytics.mapperTypes.customEvent.content.dynamicContent });
        }
        var gtmItems = response.RecentlyAddedItems[0];
        gtmItems.Source = product.Source;
        _analytics.push({ data: gtmItems, type: _analytics.mapperTypes.customEvent.trolley.productClick });
        _analytics.push({ data: gtmItems, type: _analytics.mapperTypes.customEvent.trolley.addTo });

        _this3.recentlyChangedItems = [_this3.getTrolleyItem(product.Stockcode)];
        _this3._pushAddOrRemoveItemToDtm(response, false);
        if (_this3.featureService.isEnabled(_this3.featureService.features.enableRichRelevanceRecommendations)) {
            _this3.richRelevanceService.addToTrolleyRequest(product, _this3.trolleyProducts);
        }

        return response;
    });
}

TrolleyService.prototype.addItemToTrolley = function (product, quantity, source, searchTerm) {
    var _this4 = this;

    if (!this.validateQuantity(product, quantity).isValid) {
        return this.$q.reject('Invalid');
    }

    var shouldShowLoginReminderForMaxItems = this.itemCount === this.maxItemsAllowedForGuestUser - 1 && !this.guestTrolleyLoginReminderShown;
    if (_shopperService.IsGuest && (product.AgeRestricted || shouldShowLoginReminderForMaxItems)) {
        var loginMessage = void 0;
        if (product.AgeRestricted) {
            loginMessage = this._loginService.LoginToAddRestrictedProductMessage;
        } else if (shouldShowLoginReminderForMaxItems) {
            loginMessage = this._loginService.LoginToAddMoreProductsMessage;
        } else {
            loginMessage = undefined;
        }

        this.guestTrolleyLoginReminderShown = true;
        return this._loginService.promptForLogin(loginMessage, null, null, null, function () {
            if (_shopperService.shopper.AllowRestrictedDepartment) {
                postToTrolley.call(_this4, product, quantity, source, searchTerm);
            }
        });
    }

    // While we're waiting for the trolley response, use the shelf product for now
    // so the user can see the item in the trolley immediately.
    this.trolleyProducts.unshift(product);

    return postToTrolley.call(this, product, quantity, source, searchTerm);
};

TrolleyService.prototype.updateTrolleyItem = function (product, quantity, updateSource, isRemovingItemFromTrolley) {
    var _this5 = this;

    this.isTotalReady = false;

    // copy the updated product and set the quantity to be the amount added or removed. Store this for analytics later.
    var changedProduct = this.getTrolleyItem(product.Stockcode);

    // The product may not be in the trolley yet (waiting on a network response)
    if (changedProduct) {
        var deltaProduct = _.extend({}, changedProduct, { Quantity: Math.abs(changedProduct.Quantity - quantity) });
        this.recentlyChangedItems = [deltaProduct];
    }

    return this._rejectIfLaterUpdate(this._trolleyRoute.postSequential('UpdateItem', { stockcode: product.Stockcode, quantity: quantity })).then(function (response) {
        _this5._updateTrolley(response);
        _this5._setScreenReaderMessage(product.Stockcode, 'update');
        return response;
    }).then(function (response) {
        _this5.$rootScope.$broadcast('trolley:update');

        // TODO: may merge this push to the next push
        var cardId = _this5.inspirationService.getContentCardId();
        if (cardId && updateSource !== _trolleySourceCz) {
            _analytics.push({ data: cardId, type: _analytics.mapperTypes.customEvent.content.dynamicContent });
        }
        var gtmItems = response.RecentlyAddedItems[0];
        gtmItems.Source = updateSource;

        _analytics.push({ data: gtmItems, type: _analytics.mapperTypes.customEvent.trolley.productClick });
        _analytics.push({ data: gtmItems, type: _analytics.mapperTypes.customEvent.trolley.addTo });
        _this5._pushAddOrRemoveItemToDtm(response, isRemovingItemFromTrolley);
        return response;
    });
};

TrolleyService.prototype.removeTrolleyItem = function (stockcode) {
    var _this6 = this;

    this.isTotalReady = false;

    // Immediately remove the product from the trolley products list so the UI
    // can update while we wait for the trolley response.
    this.recentlyChangedItems = [].concat(_toConsumableArray(_.remove(this.trolleyProducts, { Stockcode: stockcode })), _toConsumableArray(_.remove(this.unavailableProducts, { Stockcode: stockcode })), _toConsumableArray(_.remove(this.restrictedByDeliveryMethodProducts, { Stockcode: stockcode })), _toConsumableArray(_.remove(this.bundleProducts, { Stockcode: stockcode })), _toConsumableArray(_.remove(this.restrictedProducts, { Stockcode: stockcode })));

    return this._rejectIfLaterUpdate(this._trolleyRoute.postSequential('Remove', { Stockcode: stockcode })).then(function (response) {
        _this6._setScreenReaderMessage(stockcode, 'remove');
        _this6._updateTrolley(response);
        _this6._pushAddOrRemoveItemToDtm(response, true);
        _this6.$rootScope.$broadcast('trolley:update');
        _this6.$rootScope.$broadcast('trolley:removeItem');
        return response;
    });
};

TrolleyService.prototype.removeItems = function (stockcodes) {
    var _this7 = this;

    this.isTotalReady = false;

    this.recentlyChangedItems = _.filter(getAllProducts.call(this), function (product) {
        return _.includes(stockcodes, product.Stockcode);
    });

    return this._rejectIfLaterUpdate(this._trolleyRoute.postSequential('RemoveItems', { Stockcodes: stockcodes })).then(function (response) {
        _this7._updateTrolley(response);
        _this7._pushAddOrRemoveItemToDtm(response, true);
        _this7.$rootScope.$broadcast('trolley:update');
        _this7.$rootScope.$broadcast('trolley:removeItem');
    });
};

TrolleyService.prototype.clearOutOfStockTrolleyItems = function () {
    var _this8 = this;

    this.isTotalReady = false;
    this.getTrolley().then(function () {
        var outOfStockItemsStockcodes = _.map(_this8.unavailableProducts, 'Stockcode');
        _this8.removeItems(outOfStockItemsStockcodes).then(function (response) {
            _this8._setScreenReaderMessage('', 'clearOOS');
            return response;
        });
    });
};

TrolleyService.prototype.clearTrolley = function () {
    var _this9 = this;

    this.isTotalReady = false;

    this.recentlyChangedItems = getAllProducts.call(this);
    return this._rejectIfLaterUpdate(this._trolleyRoute.postSequential('Clear', {})).then(function (response) {
        _this9._updateTrolley(response);
        _this9._pushAddOrRemoveItemToDtm(response, true);
        _this9.$rootScope.$broadcast('trolley:update');
        _this9._setScreenReaderMessage('', 'clear');
    });
};

TrolleyService.prototype.addItemsToTrolley = function (items) {
    var _this10 = this;

    this.isTotalReady = false;
    var mappedProducts = _.map(_.filter(items, function (product) {
        return product.IsAvailable === true && product.DisplayQuantity > 0;
    }), function (item) {
        var newQty = item.QuantityInTrolley !== 0 ? item.QuantityInTrolley + item.DisplayQuantity : item.DisplayQuantity;
        return { stockcode: item.Stockcode, quantity: newQty, source: item.Source };
    });

    return this._rejectIfLaterUpdate(this._trolleyRoute.postSequential('AddItems', { products: mappedProducts })).then(function (response) {
        _this10._updateTrolley(response);
        _this10._setScreenReaderMessage('', 'items added');
        return response;
    }).then(function (response) {
        _this10.$rootScope.$broadcast('trolley:update');

        // TODO: may merge this push to the next push
        var cardId = _this10.inspirationService.getContentCardId();
        if (cardId) {
            _analytics.push({ data: cardId, type: _analytics.mapperTypes.customEvent.content.dynamicContent });
        }

        response.RecentlyAddedItems.Source = mappedProducts[0].source === undefined ? null : mappedProducts[0].source;
        _analytics.push({ data: response.RecentlyAddedItems, type: _analytics.mapperTypes.customEvent.trolley.productClickAddAllTo });
        _analytics.push({ data: response.RecentlyAddedItems, type: _analytics.mapperTypes.customEvent.trolley.addAllTo });

        // We need to find the item within the response for full product details
        var addedStockcodes = _.map(items, 'stockcode');
        _this10.recentlyChangedItems = _.filter(getAllProducts.call(_this10), function (product) {
            return _.includes(addedStockcodes, product.Stockcode);
        });
        // We push to analytics directly because adding multiple items is separate from adding a single item
        // The caller of addItemsToTrolley should specify an event to push
        _this10._pushTrolleyDataToDtm(response);
        return response;
    });
};

TrolleyService.prototype.saveTrolleyAsList = function (name) {
    _analytics.pushEvent(_analytics.events.SAVE_TROLLEY_LIST);
    return this._trolleyRoute.one('SaveAsList').doPOST({ Name: name });
};

TrolleyService.prototype.hasAvailableProducts = function () {
    return this.trolleyProducts.length > 0;
};

module.exports = TrolleyService;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    collectionZone: 'Collection Zone'
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var TrackMyOrderService = __webpack_require__(282);

var _require = __webpack_require__(283),
    trackMyOrderComponentDefinition = _require.trackMyOrderComponentDefinition;

var _require2 = __webpack_require__(285),
    trackMyOrderInformationComponentDefinition = _require2.trackMyOrderInformationComponentDefinition;

var _require3 = __webpack_require__(286),
    trackMyOrderProcessComponentDefinition = _require3.trackMyOrderProcessComponentDefinition;

var _require4 = __webpack_require__(288),
    trackMyOrderProcessNodeComponentDefinition = _require4.trackMyOrderProcessNodeComponentDefinition;

var _require5 = __webpack_require__(290),
    trackMyOrderGuestFormComponentDefinition = _require5.trackMyOrderGuestFormComponentDefinition;

angular.module('wowApp.shop').service('TrackMyOrderService', TrackMyOrderService).component('wowTrackMyOrder', trackMyOrderComponentDefinition).component('wowTrackMyOrderInformation', trackMyOrderInformationComponentDefinition).component('wowTrackMyOrderProcess', trackMyOrderProcessComponentDefinition).component('wowTrackMyOrderProcessNode', trackMyOrderProcessNodeComponentDefinition).component('wowTrackmyorderGuestForm', trackMyOrderGuestFormComponentDefinition);

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TrackMyOrderService = function () {
    function TrackMyOrderService(restangular) {
        _classCallCheck(this, TrackMyOrderService);

        this.api = restangular.one('TrackMyOrder');
        this.restangular = restangular;
    }

    _createClass(TrackMyOrderService, [{
        key: 'getOrders',
        value: function getOrders() {
            return this.api.get();
        }
    }, {
        key: 'getOrderInfo',
        value: function getOrderInfo(orderId) {
            return this.restangular.one('TrackMyOrder', orderId).get().then(function (response) {
                return response;
            });
        }
    }]);

    return TrackMyOrderService;
}();

TrackMyOrderService.$inject = ['Restangular'];

module.exports = TrackMyOrderService;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TrackMyOrderController = function () {
    function TrackMyOrderController(settings, shopperService, storeService, orderInformationService) {
        _classCallCheck(this, TrackMyOrderController);

        this.settings = settings;
        this.shopperService = shopperService;
        this.storeService = storeService;
        this.orderInformationService = orderInformationService;
    }

    _createClass(TrackMyOrderController, [{
        key: '$onChanges',
        value: function $onChanges(data) {
            if (!data.tmoInfo || data.tmoInfo && !data.tmoInfo.currentValue) return;

            this.orderWarningMessage = this.orderInformationService.getWarningMessage({
                order: this.tmoInfo,
                deliveryMethod: this.tmoInfo.DeliveryMethod
            });

            this.updateStore();
        }
    }, {
        key: 'updateStore',
        value: function updateStore() {
            this.store = this.tmoInfo && this.tmoInfo.DeliveryMethod === this.settings.trackMyOrderDeliveryMethod.pickup ? this.tmoInfo.Store : undefined;
            if (!this.store) return;

            this.url = this.storeService.getStoreUrl(this.store);
        }
    }, {
        key: 'getPickupMessageSetting',
        value: function getPickupMessageSetting() {
            return this.shopperService.shopper.EmailOptIn ? 'pickupMessageWithEmailInfo' : 'pickupMessage';
        }
    }]);

    return TrackMyOrderController;
}();

TrackMyOrderController.$inject = ['Settings', 'ShopperService', 'StoreService', 'OrderInformationService'];

var trackMyOrderComponentDefinition = {
    controller: TrackMyOrderController,
    template: __webpack_require__(284).trim(),
    bindings: {
        tmoInfo: '<'
    }
};

module.exports = {
    TrackMyOrderController: TrackMyOrderController,
    trackMyOrderComponentDefinition: trackMyOrderComponentDefinition
};

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tmo\" ng-if=\"$ctrl.tmoInfo\">\r\n    <!-- Order Process Diagram -->\r\n    <wow-track-my-order-process class=\"tmo-spacing tmo-spacing--wideTop\"\r\n        ng-if=\"$ctrl.tmoInfo.DeliveryMethod !== $ctrl.settings.trackMyOrderDeliveryMethod.notretrieved\"\r\n        tmo-info=\"$ctrl.tmoInfo\">\r\n    </wow-track-my-order-process>\r\n\r\n    <!-- Disclaimer -->\r\n    <div class=\"tmo-spacing\"\r\n        ng-if=\"$ctrl.tmoInfo.DeliveryMethod !== $ctrl.settings.trackMyOrderDeliveryMethod.notretrieved\">\r\n        <wow-setting\r\n            ng-if=\"$ctrl.tmoInfo.DeliveryMethod === $ctrl.settings.trackMyOrderDeliveryMethod.delivery\r\n                && $ctrl.tmoInfo.EtaInfo\r\n                && $ctrl.tmoInfo.EtaInfo.IsUnavailable\"\r\n            setting-group=\"TrackMyOrder\"\r\n            setting-name=\"DeliveryMessage\">\r\n        </wow-setting>\r\n        <wow-setting\r\n            ng-if=\"$ctrl.tmoInfo.DeliveryMethod === $ctrl.settings.trackMyOrderDeliveryMethod.express\"\r\n            setting-group=\"TrackMyOrder\"\r\n            setting-name=\"ExpressDeliveryMessage\">\r\n        </wow-setting>\r\n        <wow-setting\r\n            ng-if=\"$ctrl.tmoInfo.DeliveryMethod === $ctrl.settings.trackMyOrderDeliveryMethod.pickup\r\n                && $ctrl.tmoInfo.Status !== $ctrl.settings.trackMyOrderProgress.dispatched\"\r\n            setting-group=\"TrackMyOrder\"\r\n            setting-name=\"{{ $ctrl.getPickupMessageSetting() }}\">\r\n        </wow-setting>\r\n    </div>\r\n\r\n    <!-- Warnings and Errors -->\r\n    <div\r\n        class=\"tmo-status tmo-spacing alert alert--info\"\r\n        ng-if=\"$ctrl.tmoInfo.InfoMessage || $ctrl.tmoInfo.ErrorMessage\"\r\n        ng-class=\"{'tmo-statusWarning': $ctrl.tmoInfo.InfoMessage,\r\n                'tmo-statusError': $ctrl.tmoInfo.ErrorMessage }\"\r\n        tabindex=\"-1\"\r\n        role=\"alert\">\r\n        <div class=\"tmo-statusWarningIcon\">\r\n            <img ng-src=\"/images/order/iconww-message-alert.svg\" ng-if=\"$ctrl.tmoInfo.InfoMessage\" alt=\"Alert\"/>\r\n        </div>\r\n        {{$ctrl.tmoInfo.InfoMessage || $ctrl.tmoInfo.ErrorMessage}}\r\n    </div>\r\n\r\n    <div\r\n        class=\"tmo-status tmo-statusWarning tmo-spacing alert alert--info\"\r\n        ng-if=\"$ctrl.orderWarningMessage\"\r\n        tabindex=\"-1\"\r\n        role=\"alert\">\r\n        <div class=\"tmo-statusWarningIcon\">\r\n            <img ng-src=\"/images/order/iconww-message-alert.svg\" alt=\"Alert\"/>\r\n        </div>\r\n        <span ng-bind-html=\"$ctrl.orderWarningMessage | sanitize\"></span>\r\n    </div>\r\n\r\n    <wow-track-my-order-information\r\n        tmo-info=\"$ctrl.tmoInfo\"\r\n        store=\"$ctrl.store\"\r\n        is-guest=\"$ctrl.shopperService.IsGuest\">\r\n    </wow-track-my-order-information>\r\n\r\n    <!-- Disclaimer -->\r\n    <div class=\"tmo-disclaimer tmo-spacing\">\r\n        <wow-setting\r\n            ng-if=\"$ctrl.tmoInfo.DeliveryMethod === $ctrl.settings.trackMyOrderDeliveryMethod.delivery\r\n                && $ctrl.tmoInfo.EtaInfo\r\n                && !$ctrl.tmoInfo.EtaInfo.IsUnavailable\"\r\n            setting-group=\"TrackMyOrder\"\r\n            setting-name=\"DeliveryEtaDisclaimer\">\r\n        </wow-setting>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TrackMyOrderInformationComponentController = function () {
    function TrackMyOrderInformationComponentController(settings) {
        _classCallCheck(this, TrackMyOrderInformationComponentController);

        this.settings = settings;
    }

    _createClass(TrackMyOrderInformationComponentController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.tmoInfo.DeliveryMethod === 'NotRetrieved') return;

            this.orderInfo = this.getOrderInfo();
            this.dateInfo = this.getDateInfo();
            this.addressInfo = this.getAddressInfo();
            this.storeInfo = this.getStoreInfo();
        }
    }, {
        key: 'getOrderInfo',
        value: function getOrderInfo() {
            return {
                method: this.tmoInfo.DeliveryMethod,
                headerTexts: this.getHeaderTexts(),
                canLeaveUnattended: this.tmoInfo.CanLeaveOrderUnattended,
                instructions: this.tmoInfo.DeliveryInstructions
            };
        }
    }, {
        key: 'getHeaderTexts',
        value: function getHeaderTexts() {
            return {
                delivery: this.settings.trackMyOrder.deliveryWindowLabel,
                express: this.settings.trackMyOrder.expressDeliveryWindowLabel,
                pickup: this.settings.trackMyOrder.pickupWindowLabel
            };
        }
    }, {
        key: 'getAddressInfo',
        value: function getAddressInfo() {
            if (this.tmoInfo.DeliveryMethod === 'Pickup' && !this.tmoInfo.Store) return null;
            if (this.tmoInfo.DeliveryMethod === 'Pickup') {
                return {
                    street1: this.tmoInfo.DeliveryInfo.AddressLine2,
                    suburb: this.tmoInfo.Store.State,
                    postcode: this.tmoInfo.Store.Postcode
                };
            }
            return {
                street1: this.tmoInfo.DeliveryInfo.AddressLine1,
                street2: this.tmoInfo.DeliveryInfo.AddressLine2
            };
        }
    }, {
        key: 'getDateInfo',
        value: function getDateInfo() {
            var deliveryTime = this.tmoInfo.DeliveryWindowInfo.TimeSpan.split(' - ');
            var dateInfo = {
                date: this.tmoInfo.DeliveryWindowInfo.Date,
                startTime: deliveryTime[0],
                endTime: deliveryTime[1]
            };

            if (this.tmoInfo.EtaInfo && !this.tmoInfo.EtaInfo.IsUnavailable) {
                dateInfo.eta = {
                    startTime: this.tmoInfo.EtaInfo.HourStart,
                    endTime: this.tmoInfo.EtaInfo.HourEnd
                };
            }

            return dateInfo;
        }
    }, {
        key: 'getStoreInfo',
        value: function getStoreInfo() {
            if (this.tmoInfo.DeliveryMethod !== 'Pickup') return null;

            return {
                name: this.tmoInfo.DeliveryInfo.AddressLine1,
                tradingHours: this.tmoInfo.TradingHours,
                details: this.tmoInfo.Store
            };
        }
    }]);

    return TrackMyOrderInformationComponentController;
}();

TrackMyOrderInformationComponentController.$inject = ['Settings'];

var trackMyOrderInformationComponentDefinition = {
    bindings: {
        tmoInfo: '<',
        store: '<',
        isGuest: '<'
    },
    controller: TrackMyOrderInformationComponentController,
    template: '\n        <wow-order-information\n            order-info="::$ctrl.orderInfo"\n            address-info="::$ctrl.addressInfo"\n            date-info="::$ctrl.dateInfo"\n            store-info="::$ctrl.storeInfo"\n            is-guest="::$ctrl.isGuest">\n        </wow-order-information>\n        <wow-order-information-tips\n            order-method="::$ctrl.orderInfo.method">\n        </wow-order-information-tips>\n    '
};

module.exports = {
    TrackMyOrderInformationComponentController: TrackMyOrderInformationComponentController,
    trackMyOrderInformationComponentDefinition: trackMyOrderInformationComponentDefinition
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TrackMyOrderProcessController = function () {
    function TrackMyOrderProcessController(settings) {
        _classCallCheck(this, TrackMyOrderProcessController);

        this.settings = settings;
    }

    _createClass(TrackMyOrderProcessController, [{
        key: 'headingText',
        get: function get() {
            if (this.tmoInfo.DeliveryMethod === this.settings.trackMyOrderDeliveryMethod.pickup) {
                return 'Pick Up';
            }
            if (this.tmoInfo.DeliveryMethod === this.settings.trackMyOrderDeliveryMethod.delivery) {
                return 'Delivery';
            }
            if (this.tmoInfo.DeliveryMethod === this.settings.trackMyOrderDeliveryMethod.express) {
                return 'Delivery Now';
            }
            return '';
        }
    }]);

    return TrackMyOrderProcessController;
}();

TrackMyOrderProcessController.$inject = ['Settings'];

var trackMyOrderProcessComponentDefinition = {
    controller: TrackMyOrderProcessController,
    template: __webpack_require__(287).trim(),
    bindings: {
        tmoInfo: '<'
    }
};

module.exports = {
    TrackMyOrderProcessController: TrackMyOrderProcessController,
    trackMyOrderProcessComponentDefinition: trackMyOrderProcessComponentDefinition
};

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tmoProcess\">\r\n    <h2 class=\"heading4 tmoProcess-header\">{{ $ctrl.headingText }} Order progress</h2>\r\n\r\n    <div class=\"tmoProcess-container\">\r\n        <!-- Step 1 -->\r\n        <wow-track-my-order-process-node\r\n            is-step-completed=\"$ctrl.tmoInfo.Status === $ctrl.settings.trackMyOrderProgress.placed\r\n                            || $ctrl.tmoInfo.Status === $ctrl.settings.trackMyOrderProgress.dispatched\"\r\n            label=\"{{$ctrl.settings.trackMyOrder.placedText}}\">\r\n        </wow-track-my-order-process-node>\r\n\r\n        <div class=\"tmoProcess-divider\"></div>\r\n\r\n        <!-- Step 2: Delivery Only -->\r\n        <wow-track-my-order-process-node\r\n            ng-if=\"$ctrl.tmoInfo.DeliveryMethod === $ctrl.settings.trackMyOrderDeliveryMethod.delivery\r\n                || $ctrl.tmoInfo.DeliveryMethod === $ctrl.settings.trackMyOrderDeliveryMethod.express\"\r\n            is-step-completed=\"$ctrl.tmoInfo.Status === $ctrl.settings.trackMyOrderProgress.dispatched\"\r\n            label=\"{{$ctrl.settings.trackMyOrder.dispatchedText}}\">\r\n        </wow-track-my-order-process-node>\r\n\r\n        <!-- Step 2: Pickup Only -->\r\n        <wow-track-my-order-process-node\r\n            ng-if=\"$ctrl.tmoInfo.DeliveryMethod === $ctrl.settings.trackMyOrderDeliveryMethod.pickup\"\r\n            is-step-completed=\"$ctrl.tmoInfo.Status === $ctrl.settings.trackMyOrderProgress.dispatched\"\r\n            label=\"{{$ctrl.settings.trackMyOrder.readyText}}\">\r\n        </wow-track-my-order-process-node>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trackMyOrderProcessNodeComponentDefinition = {
    template: __webpack_require__(289).trim(),
    bindings: {
        label: '@',
        isStepCompleted: '<'
    }
};

module.exports = {
    trackMyOrderProcessNodeComponentDefinition: trackMyOrderProcessNodeComponentDefinition
};

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = "<div\r\n    class=\"tmoProcessNode tmoProcessNode-container\"\r\n    ng-class=\"{'tmoProcessNode-containerCompleted': $ctrl.isStepCompleted}\">\r\n    <!-- Tick -->\r\n    <i ng-if=\"$ctrl.isStepCompleted\" class=\"iconww-Tick tmoProcessNode-tick\"></i>\r\n\r\n    <!-- Label -->\r\n    <span>\r\n        {{$ctrl.label}}\r\n        <span class=\"sr-only\">{{$ctrl.isStepCompleted ? 'completed' : 'pending'}}</span>\r\n    </span>\r\n</div>\r\n"

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    each = _require.each,
    map = _require.map;

var TrackMyOrderGuestFormController = function () {
    function TrackMyOrderGuestFormController($timeout, trackMyOrderService, analyticsService) {
        _classCallCheck(this, TrackMyOrderGuestFormController);

        this.$timeout = $timeout;
        this.trackMyOrderService = trackMyOrderService;
        this.analyticsService = analyticsService;
    }

    _createClass(TrackMyOrderGuestFormController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.tmoInfo = null;

            // Attempt to load, a small delay is needed to wait for form load
            this.$timeout(function () {
                if (_this.orderNumber) {
                    _this.submit();
                }
            });
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this2 = this;

            // Reset
            this.isLoading = true;
            this.tmoInfo = null;
            this.tmoForm.OrderNumber.$setValidity('serverError', 'true');

            if (!this.tmoForm.$valid) {
                this.isLoading = false;
                return;
            }

            this.trackMyOrderService.getOrderInfo(this.orderNumber).then(function (response) {
                _this2.tmoInfo = response;
            }).catch(function (response) {
                _this2.isLoading = false;
                _this2.serverErrors = {};
                if (response.data && response.data.ResponseStatus) {
                    each(response.data.ResponseStatus.Errors, function (n) {
                        if (_this2.tmoForm[n.FieldName]) {
                            _this2.tmoForm[n.FieldName].$setValidity('serverError', false);
                            _this2.tmoForm.$invalid = true;
                        }
                        _this2.serverErrors[n.FieldName] = n.Message;
                    });
                    _this2.analyticsService.pushErrors(map(response.data.ResponseStatus.Errors, 'Message'));
                }
            }).finally(function () {
                _this2.isLoading = false;
            });
        }
    }]);

    return TrackMyOrderGuestFormController;
}();

TrackMyOrderGuestFormController.$inject = ['$timeout', 'TrackMyOrderService', 'AnalyticsService'];

var trackMyOrderGuestFormComponentDefinition = {
    controller: TrackMyOrderGuestFormController,
    template: __webpack_require__(291).trim(),
    bindings: {
        orderNumber: '<'
    }
};

module.exports = {
    TrackMyOrderGuestFormController: TrackMyOrderGuestFormController,
    trackMyOrderGuestFormComponentDefinition: trackMyOrderGuestFormComponentDefinition
};

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = "<div class=\"trackMyOrderGuestForm\" id=\"trackMyOrderGuestForm\" tabindex=\"-1\">\r\n    <div class=\"trackMyOrderGuestForm-header\">\r\n        <h1 class=\"trackMyOrderGuestForm-headerTitle heading2\">\r\n            <span class=\"trackMyOrderGuestForm-deliveryIcon\"><i class=\"iconww-Delivery\"></i></span>\r\n            Track my order\r\n        </h1>\r\n    </div>\r\n\r\n    <!-- Order Input Box -->\r\n    <form id=\"tmoForm\" name=\"$ctrl.tmoForm\" ng-submit=\"$ctrl.submit()\" wow-analytics-form-errors novalidate>\r\n        <wow-input-container>\r\n            <label>Order number *</label>\r\n            <input id=\"tmoForm-orderNumber\" type=\"number\" pattern=\"\\d*\" name=\"OrderNumber\" ng-model=\"$ctrl.orderNumber\" required/>\r\n            <span role=\"alert\" ng-messages=\"$ctrl.tmoForm.OrderNumber.$error\" class=\"wowInput-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">Order number is required.</span>\r\n                <span ng-message=\"number\" class=\"wowInput-error\">Order number must be numeric</span>\r\n                <span ng-message=\"serverError\" class=\"wowInput-error\">{{ $ctrl.serverErrors.OrderNumber }}</span>\r\n            </span>\r\n        </wow-input-container>\r\n\r\n        <div class=\"trackMyOrderGuestForm-submit\">\r\n            <button type=\"submit\" class=\"button button--primary\">View Order</button>\r\n        </div>\r\n    </form>\r\n\r\n    <!-- Loading Spinner -->\r\n    <wow-loading-spinner ng-if=\"$ctrl.isLoading\"></wow-loading-spinner>\r\n\r\n    <!-- Track My Order Common Component -->\r\n    <wow-track-my-order\r\n        ng-if=\"!$ctrl.isLoading\"\r\n        tmo-info=\"$ctrl.tmoInfo\">\r\n    </wow-track-my-order>\r\n</div>\r\n"

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var OfferGroupService = __webpack_require__(293);

var _require = __webpack_require__(294),
    offerGroupTileListComponentDefinition = _require.offerGroupTileListComponentDefinition;

angular.module('wowApp.shop').service('OfferGroupService', ['Restangular', '$q', 'Settings', 'SortByKeys', OfferGroupService]).component('wowOfferGroupTileList', offerGroupTileListComponentDefinition);

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferGroupService = function () {
    function OfferGroupService(restangular, $q, settings, sortByKeys) {
        _classCallCheck(this, OfferGroupService);

        this._offerGroupRoute = restangular.one('OfferGroup');
        this.selectedGroup = undefined;
        this.settings = settings;
        this.sortByKeys = sortByKeys;
        this.$q = $q;
        this._groupCache = {};
    }

    _createClass(OfferGroupService, [{
        key: 'selectOfferGroup',
        value: function selectOfferGroup(id) {
            var _this = this;

            if (!(id in this._groupCache)) {
                this._groupCache[id] = this._offerGroupRoute.one(id).get();
            }
            this.offerGroupPromise = this._groupCache[id].then(function (response) {
                _this.selectedGroup = response;
                return response;
            });
            return this.offerGroupPromise;
        }
    }, {
        key: 'getSelectedOfferGroup',
        value: function getSelectedOfferGroup() {
            return this.offerGroupPromise ? this.offerGroupPromise : this.$q.when(null);
        }
    }, {
        key: 'getProducts',
        value: function getProducts(args) {
            var _this2 = this;

            this.selectedGroupTotalCount = undefined;
            return this._offerGroupRoute.one('Products').one(this.selectedGroup.Url).get(this.createArgs(args)).then(function (response) {
                _this2.selectedGroupTotalCount = response.TotalRecordCount;
                return {
                    items: response.Items,
                    totalRecordCount: response.TotalRecordCount
                };
            });
        }
    }, {
        key: 'getSortOptions',
        value: function getSortOptions() {
            return {
                sortTypes: this.settings.browse.sortOptions,
                sortContext: this.sortByKeys.BROWSE_KEY
            };
        }
    }, {
        key: 'createArgs',
        value: function createArgs(args) {
            return {
                pageNumber: args.pageNumber,
                pageSize: args.pageSize || 10,
                sortType: args.sortType
            };
        }
    }]);

    return OfferGroupService;
}();

module.exports = OfferGroupService;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(10),
    createBundleTiles = _require.createBundleTiles;

var _require2 = __webpack_require__(0),
    map = _require2.map;

var OfferGroupTileListController = function () {
    function OfferGroupTileListController(settings, analyticsService, offerGroupService) {
        _classCallCheck(this, OfferGroupTileListController);

        this.settings = settings;
        this.analyticsService = analyticsService;
        this.offerGroupService = offerGroupService;
    }

    _createClass(OfferGroupTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = this.offerGroupService.getSortOptions();
        }
    }, {
        key: 'title',
        value: function title() {
            var description = this.offerGroupService.selectedGroup.Description;

            return this.offerGroupService.selectedGroupTotalCount != null ? description + ' (' + this.offerGroupService.selectedGroupTotalCount + ')' : description;
        }
    }, {
        key: 'createTiles',
        value: function createTiles(products) {
            return {
                items: createBundleTiles(products.items),
                totalRecordCount: products.totalRecordCount
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber) {
            var _this = this;

            var sortType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Name';

            return this.offerGroupService.selectOfferGroup(this.offerGroupId).then(function () {
                return _this.offerGroupService.getProducts({ pageSize: pageSize, pageNumber: pageNumber, sortType: sortType });
            }).then(function (products) {
                return _this.createTiles(products);
            });
        }
    }, {
        key: 'createAnalyticsData',
        value: function createAnalyticsData(contentData) {
            return {
                pageNumber: contentData.pageNumber,
                currentCategory: this.offerGroupService.selectedGroup,
                products: map(contentData.items, function (item) {
                    return { Name: item.data.product.Name, Products: [item.data.product] };
                }),
                inspirationCards: { Cards: contentData.inspirationCards },
                totalRecordCount: this.offerGroupService.selectedGroupTotalCount,
                filters: contentData.filters,
                sortType: contentData.sortType ? contentData.sortType.Value : '',
                sortOptions: this.sortOptions
            };
        }
    }, {
        key: 'pushContentDataToAnalytics',
        value: function pushContentDataToAnalytics(contentData) {
            this.analyticsService.push({
                data: this.createAnalyticsData(contentData),
                type: this.analyticsService.mapperTypes.shop.productCategory
            });
        }
    }]);

    return OfferGroupTileListController;
}();

OfferGroupTileListController.$inject = ['Settings', 'AnalyticsService', 'OfferGroupService'];

var offerGroupTileListComponentDefinition = {
    bindings: {
        offerGroupId: '<?',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: OfferGroupTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.title()"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)"\n            push-content-to-analytics="$ctrl.pushContentDataToAnalytics(contentData)">\n        </wow-tile-list>\n    '
};

module.exports = {
    OfferGroupTileListController: OfferGroupTileListController,
    offerGroupTileListComponentDefinition: offerGroupTileListComponentDefinition
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

angular.module('wowApp.shop')
// Service
.service('RichRelevanceService', ['Restangular', '$window', '$q', '$rootScope', '$http', '$timeout', 'config', 'ShopperService', 'FeatureService', 'Settings', 'BreakpointsService', 'AnalyticsService', 'ProductRecommendationService', __webpack_require__(296)])

// Showing Placements
.component('wowRrPlacementCallback', __webpack_require__(297).richRelevancePlacementCallbackComponentDefinition).component('wowRrProducts', __webpack_require__(298).richRelevanceProductsComponentDefinition)

// Instrumentation
.component('wowRrHomeInstrumentation', __webpack_require__(300).richRelevanceHomeInstrumentationComponentDefinition).component('wowRrCategoryInstrumentation', __webpack_require__(301).richRelevanceCategoryInstrumentationComponentDefinition).component('wowRrWishlistInstrumentation', __webpack_require__(302).richRelevanceWishlistInstrumentationComponentDefinition).component('wowRrMypageInstrumentation', __webpack_require__(303).richRelevanceMypageInstrumentationComponentDefinition).component('wowRrErrorInstrumentation', __webpack_require__(304).richRelevanceErrorInstrumentationComponentDefinition).component('wowRrSearchInstrumentation', __webpack_require__(305).richRelevanceSearchInstrumentationComponentDefinition).component('wowRrGenericInstrumentation', __webpack_require__(306).richRelevanceGenericInstrumentationComponentDefinition).component('wowRrCartInstrumentation', __webpack_require__(307).richRelevanceCartInstrumentationComponentDefinition).component('wowRrItemInstrumentation', __webpack_require__(308).richRelevanceItemInstrumentationComponentDefinition).component('wowRrPurchasedInstrumentation', __webpack_require__(309).richRelevancePurchasedInstrumentationComponentDefinition).component('wowRrCarousel', __webpack_require__(310).rrCarouselComponentDefinition);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    keys = _require.keys,
    find = _require.find,
    forEach = _require.forEach,
    endsWith = _require.endsWith,
    union = _require.union;

var RichRelevanceService = function () {
    function RichRelevanceService(restangular, $window, $q, rootScope, $http, $timeout, config, shopperService, featureService, settings, breakpointsService, analyticsService, productRecommendationService) {
        var _this = this;

        _classCallCheck(this, RichRelevanceService);

        this._api = restangular.one('RichRelevance');
        this.placementCallbacks = {};
        this.placementsCache = {};
        this.$window = $window;
        this.config = config;
        this.shopperService = shopperService;
        this.shopper = this.shopperService.shopper;
        this.$q = $q;
        this.$http = $http;
        this.$timeout = $timeout;
        this.features = featureService;
        this.settings = settings;
        this.breakpointsService = breakpointsService;
        this.analyticsService = analyticsService;
        this.productRecommendationService = productRecommendationService;
        this.currentProducts = [];
        this.placementTimeouts = {};
        this.maxPlacementDisplayDelay = 0;
        this.homepagePlacement = 'home_page.carousel';
        this.quickReOrderPlacement = 'generic_page.quick_reorder';
        this.specialsGroupPlacement = 'category_page.specials_group';
        this.mySpecialsPlacement = 'category_page.trader_myspecials';
        this.mySpecialsPlacementMobile = 'category_page.trader_myspecials_mobile';
        this.categoryPlacement = 'category_page.vs_category';
        this.categoryLevelOne = 'category_page.category_level1';
        this.categoryLevelTwo = 'category_page.category_level2';
        this.categoryLevelThree = 'category_page.category_level3';
        this.itemPageRankOne = 'item_page.rank1';
        this.itemPageRankTwo = 'item_page.rank2';
        this.itemPageRankThree = 'item_page.rank3';
        this.itemPageRankFour = 'item_page.rank4';
        this.itemPageRankFive = 'item_page.rank5';
        this.mySpecialsGroupId = 'specialsgroup.-1';
        this.rrSourceName = 'RR';
        this.daasSourceName = productRecommendationService.daasSourceName;

        this.initPromise = null;

        this.serverSideApiPlacements = [this.homepagePlacement, this.quickReOrderPlacement, this.categoryPlacement, this.specialsGroupPlacement, this.mySpecialsPlacement, this.categoryLevelOne, this.categoryLevelTwo, this.categoryLevelThree, this.itemPageRankOne, this.itemPageRankTwo, this.homepagePlacement + '_mobile', this.quickReOrderPlacement + '_mobile', this.categoryPlacement + '_mobile', this.specialsGroupPlacement + '_mobile', this.mySpecialsPlacement + '_mobile', this.categoryLevelOne + '_mobile', this.categoryLevelTwo + '_mobile', this.categoryLevelThree + '_mobile', this.itemPageRankOne + '_mobile', this.itemPageRankTwo + '_mobile', this.itemPageRankThree + '_mobile', this.itemPageRankFour + '_mobile', this.itemPageRankFive + '_mobile'];

        rootScope.$on('$stateChangeSuccess', function () {
            // when the stateChange happens,
            // placements in cache are no longer valid.
            _this.placementCallbacks = {};
            _this.placementsCache = {};
            _this.currentProducts = [];
            _this.placementTimeouts = {};
        });
    }

    _createClass(RichRelevanceService, [{
        key: 'getInformation',
        value: function getInformation() {
            var _this2 = this;

            if (!this.features.isEnabled(this.features.features.enableRichRelevanceRecommendations) || !this.$window.RR) {
                return this.$q.reject('rr is disabled');
            }

            this.cleanupR3();

            var promise = this.shopper.RichRelevanceSessionId !== undefined && this.shopper.FulfilmentStoreId !== undefined ? this.$q.all({ RichRelevanceSessionId: this.shopper.RichRelevanceSessionId, FulfilmentStoreId: this.shopper.FulfilmentStoreId }) : this.shopperService.getCurrentShopper();

            return promise.then(function (response) {
                window.R3_COMMON = new _this2.$window.r3_common(); // eslint-disable-line new-cap
                _this2.$window.R3_COMMON.setApiKey(_this2.config.RichRelevanceApiKey);
                _this2.$window.R3_COMMON.setBaseUrl(window.location.protocol + _this2.config.RichRelevanceRequestUrl);
                _this2.$window.R3_COMMON.setClickthruServer(window.location.protocol + '//' + window.location.host);
                _this2.$window.R3_COMMON.setSessionId(response.RichRelevanceSessionId);
                _this2.$window.R3_COMMON.setUserId(_this2.shopperService.IsGuest ? '' : _this2.shopper.Id); // if no user ID is available, please leave this blank
                _this2.$window.R3_COMMON.setRegionId(response.FulfilmentStoreId);

                return _this2.$window.R3_COMMON;
            });
        }
    }, {
        key: 'recordPlacementsRequested',
        value: function recordPlacementsRequested(placementId) {
            this.placementTimeouts[placementId] = new Date().getTime() + this.settings.richRelevance.maxPlacementDisplayDelay * 1000;
        }
    }, {
        key: 'onPlacementsReceived',
        value: function onPlacementsReceived(placements) {
            var _this3 = this;

            var useDaasData = this.productRecommendationService.shouldBindDaasDataToPage();

            // if server side api is on and placement has products, add callbacks.
            if (this.useServerSideResults(placements)) {
                if (!placements || !placements.Products) {
                    return;
                }

                var currentPlacementkeys = keys(this.placementCallbacks);

                if (placements && currentPlacementkeys) {
                    // only fire callback function when placement name is in both serverSideApiPlacements and placementCallbacks keys
                    if (this.serverSideApiPlacements.indexOf(placements.placement_name) >= 0 && currentPlacementkeys.indexOf(placements.placement_name) >= 0) {
                        this.currentProducts = union(this.currentProducts, placements.Items);
                        this.placementCallbacks[placements.placement_name](placements);
                    }
                }
                return;
            }

            if (placements.productSource && placements.productSource === this.rrSourceName && useDaasData) {
                // this state will occur on a forced page refresh or when navigating for another angular page
                this.productRecommendationService.fetchAndBindDaasData();
            } else {
                var receiveTime = new Date().getTime();
                forEach(placements, function (placement) {
                    if (!placement || placement == null || placement.items == null || placement.items.length === 0) return;
                    placement.productSource = placements.productSource;
                    var timeout = _this3.placementTimeouts[placement.placement_name];
                    if (placement.placement_name in _this3.placementCallbacks) {
                        if (!timeout || timeout >= receiveTime) {
                            _this3.placementCallbacks[placement.placement_name](placement);
                            _this3.currentProducts = _this3.currentProducts.concat(placement.items);
                            _this3.placementsCache[placement.placement_name] = placement;
                        }
                        if (timeout) {
                            _this3.analyticsService.push({
                                data: {
                                    event: 'richRelevanceResponse',
                                    eventCategory: 'RichRelevance',
                                    eventLabel: 'CarouselDisplay',
                                    eventValue: timeout >= receiveTime ? 'Y' : 'N'
                                },
                                type: _this3.analyticsService.mapperTypes.seo.pageMetadata
                            });
                            if (timeout < receiveTime) {
                                _this3.analyticsService.pushEvent(_this3.analyticsService.events.RICH_RELEVANCE_TIMEOUT);
                            }
                        }
                    }
                    _this3.placementTimeouts[placement.placement_name] = null;
                });
            }
        }

        // registers a callback to be called when placements are received.
        // Callback must handle being called with no data or null, as this can happen
        // if placements are cleared. see clearPlacements();

    }, {
        key: 'registerPlacementCallback',
        value: function registerPlacementCallback(placement, callback) {
            this.placementCallbacks[placement] = callback;
            if (this.placementsCache[placement]) {
                callback(this.placementsCache[placement]);
            } else if (this.placementsCache[this.getOriginalPlacementId(placement)]) {
                // When change LF to SF or SF to LF, make sure call callback method, even if placement has changed.
                callback(this.placementsCache[this.getOriginalPlacementId(placement)]);
            }
        }
    }, {
        key: 'addToTrolleyRequest',
        value: function addToTrolleyRequest(product, trolleyProducts) {
            var _this4 = this;

            this.getInformation().then(function () {
                var addToCartRequest = _this4.$timeout(function () {
                    _this4.getInformation().then(function () {
                        _this4.rrAddToCartPageRequest(product.Stockcode, product.Source);
                    });
                }, 100);

                addToCartRequest.then(function () {
                    _this4.$timeout(function () {
                        _this4.getInformation().then(function () {
                            _this4.rrCartPageRequest(trolleyProducts);
                        });
                    }, 100);
                });
            });
        }
    }, {
        key: 'rrCartPageRequest',
        value: function rrCartPageRequest(trolleyProducts) {
            var _this5 = this;

            if (!trolleyProducts || !trolleyProducts.length) {
                return;
            }

            this.$window.R3_CART = new this.$window.r3_cart(); // eslint-disable-line new-cap

            forEach(trolleyProducts, function (product) {
                _this5.$window.R3_CART.addItemId(product.Stockcode.toString());
            });

            this.$window.rr_flush_onload();
            this.$window.r3();
        }
    }, {
        key: 'rrItemPageRequest',
        value: function rrItemPageRequest(product) {
            this.$window.R3_ITEM = new window.r3_item(); // eslint-disable-line new-cap
            this.$window.R3_ITEM.setId(product.Stockcode.toString()); // This must pass a string value, as RR calls indexOf() on this internally, possibly to URL encode it.
            this.$window.R3_ITEM.setName(product.Name);

            this.$window.rr_flush_onload();
            this.$window.r3();
        }
    }, {
        key: 'rrItemDetailsPageRequest',
        value: function rrItemDetailsPageRequest(stockcode, source) {
            var product = find(this.currentProducts, { id: stockcode.toString() });
            var isRRitem = (source || '').indexOf(this.rrSourceName) !== -1;
            var isDaasItem = (source || '').indexOf(this.daasSourceName) !== -1;
            if (product && product.linkURL && (isRRitem || isDaasItem)) {
                if (this.productRecommendationService.shouldBindDaasDataToPage()) {
                    this.productRecommendationService.fetchAndBindDaasData();
                } else {
                    this.$http.get(product.linkURL);
                }
            }
        }
    }, {
        key: 'rrAddToCartPageRequest',
        value: function rrAddToCartPageRequest(stockcode, source) {
            this.$window.R3_ADDTOCART = new window.r3_addtocart(); // eslint-disable-line new-cap
            this.$window.R3_ADDTOCART.addItemIdToCart(stockcode);

            this.$window.rr_flush_onload();
            this.$window.r3();

            this.rrItemDetailsPageRequest(stockcode, source);
        }
    }, {
        key: 'clearPlacements',
        value: function clearPlacements() {
            forEach(this.placementCallbacks, function (callback) {
                // call each callback with null;
                callback(null);
            });
        }
    }, {
        key: 'cleanupR3',
        value: function cleanupR3() {
            // RR script checks for the existance of these objects
            // to decide what to send to their server.
            // They use the typeof operator
            // eg: if (typeof window.R3_COMMON !== "undefined" )
            // rather than if (!window.R3_*) so null or false would not work.

            // R3_COMMON also needs to be cleared, as placement
            // types are registered on it. (R3_COMMON.addPlacementType(...))
            // So when the page changes R3_COMMON needs to be reinitialized
            // to not have the old placements.

            // Unregistering all page types including common
            window.RR.unregisterAllPageType(true);

            window.R3_COMMON = undefined;
            window.R3_HOME = undefined;
            window.R3_ADDTOCART = undefined;
            window.R3_BRAND = undefined;
            window.R3_CATEGORY = undefined;
            window.R3_GENERIC = undefined;
            window.R3_ITEM = undefined;
            window.R3_PURCHASED = undefined;
            window.R3_WISHLIST = undefined;
            window.R3_ADDTOREGISTRY = undefined;
            window.R3_CART = undefined;
            window.R3_ERROR = undefined;
            window.R3_PERSONAL = undefined;
            window.R3_SEARCH = undefined;
        }
    }, {
        key: 'invalidate',
        value: function invalidate() {
            this.initPromise = null;
        }
    }, {
        key: 'refreshPlacements',
        value: function refreshPlacements() {
            var _this6 = this;

            forEach(this.placementsCache, function (placements, placementId) {
                var callback = _this6.placementCallbacks[placementId];
                if (callback) {
                    callback(placements);
                }
            });
        }
    }, {
        key: 'getEffectivePlacementId',
        value: function getEffectivePlacementId(placementId) {
            return this.breakpointsService.isInSmallFormat && !endsWith(placementId, '_mobile') ? placementId + '_mobile' : placementId;
        }
    }, {
        key: 'getOriginalPlacementId',
        value: function getOriginalPlacementId(placementId) {
            return this.breakpointsService.isInSmallFormat ? placementId.replace('_mobile', '') : placementId + '_mobile';
        }
    }, {
        key: 'getPlacementIdsForSpecialsGroup',
        value: function getPlacementIdsForSpecialsGroup(category) {
            var placementIds = this.specialsGroupPlacement;
            // When products count is less than minimum count and bank page, don't show recommendation.
            if (category.ProductCount < this.settings.richRelevance.minimumRequiredProductsInSpecialsGroup || category.Url) {
                placementIds = undefined;
            }
            return placementIds;
        }
    }, {
        key: 'getPlacementByCategoryLevel',
        value: function getPlacementByCategoryLevel(categoryLevel) {
            if (!categoryLevel) {
                return null;
            }
            switch (categoryLevel) {
                case 1:
                    return this.categoryLevelOne;
                case 2:
                    return this.categoryLevelTwo;
                case 3:
                    return this.categoryLevelThree;
                default:
                    return null;
            }
        }
    }, {
        key: 'useServerSideResults',
        value: function useServerSideResults(placements) {
            return this.settings.richRelevance.removeDuplicatedProducts || placements && (placements.placement_name === this.mySpecialsPlacement || placements.placement_name === this.mySpecialsPlacementMobile);
        }
    }]);

    return RichRelevanceService;
}();

module.exports = RichRelevanceService;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RichRelevancePlacementCallbackController = function RichRelevancePlacementCallbackController(richRelevanceService, $window) {
    _classCallCheck(this, RichRelevancePlacementCallbackController);

    if ($window.RR && $window.RR.jsonCallback) {
        $window.RR.jsonCallback = function () {
            if ($window.RR.data.JSON.placements && $window.RR.data.JSON.placements.length > 0) {
                if (!$window.RR.data.JSON.placements.productSource) {
                    $window.RR.data.JSON.placements.productSource = 'RR';
                }
                richRelevanceService.onPlacementsReceived($window.RR.data.JSON.placements);
            }
        };
    }
};

var richRelevancePlacementCallbackComponentDefinition = {
    controller: ['RichRelevanceService', '$window', RichRelevancePlacementCallbackController]
};

module.exports = {
    RichRelevancePlacementCallbackController: RichRelevancePlacementCallbackController,
    richRelevancePlacementCallbackComponentDefinition: richRelevancePlacementCallbackComponentDefinition
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0);

var RichRelevanceProductsController = function () {
    function RichRelevanceProductsController(richRelevanceService, shelfProductService, settingsService, breakpointsService) {
        _classCallCheck(this, RichRelevanceProductsController);

        this.products = [];
        this.title = '';
        this.richRelevanceService = richRelevanceService;
        this.shelfProductService = shelfProductService;
        this.settingsService = settingsService;
        this.breakpointsService = breakpointsService;

        if (_.isNil(this.showTitle)) {
            // by default we show the title
            this.showTitle = true;
        }
    }

    _createClass(RichRelevanceProductsController, [{
        key: 'refreshProducts',
        value: function refreshProducts() {
            var _this = this;

            // this.placementId is from the directive attribute
            this.richRelevanceService.registerPlacementCallback(this.richRelevanceService.getEffectivePlacementId(this.placementId), function (placements) {

                if (!placements) {
                    _this.products = null;
                    _this.title = null;
                    return;
                }

                _this.title = placements.message;

                _this.shelfProductService.getProductsByStockcodes(_.map(placements.items, 'id'), true).then(function (wowProducts) {
                    _this.products = wowProducts;
                    if (_this.onProductsLoaded) {
                        _this.onProductsLoaded();
                    }
                });
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.refreshProducts();
        }
    }]);

    return RichRelevanceProductsController;
}();

var richRelevanceProductsComponentDefinition = {
    bindings: {
        placementId: '@', // defines which placement ID the controller should use to get RR products.
        showTitle: '=', // provide a true, when the directive displays RR title.
        onProductsLoaded: '&' // call back method for after product load.
    },
    controller: ['RichRelevanceService', 'ShelfProductService', 'SettingsService', 'BreakpointsService', RichRelevanceProductsController],
    controllerAs: 'richRelevanceProductsCtrl',
    template: __webpack_require__(299).trim()
};

module.exports = {
    RichRelevanceProductsController: RichRelevanceProductsController,
    richRelevanceProductsComponentDefinition: richRelevanceProductsComponentDefinition
};

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = "<wow-card-list>\r\n    <h2 class=\"cardList-header hidden-xs\" ng-if=\"richRelevanceProductsCtrl.showTitle\">{{richRelevanceProductsCtrl.title}}</h2>\r\n    <wow-shelf-product-tile ng-repeat=\"product in richRelevanceProductsCtrl.products\" product=\"product\"></wow-shelf-product-tile>\r\n</wow-card-list>\r\n"

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(12);

var RichRelevanceHomeInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceHomeInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceHomeInstrumentationController($scope, $window, featureService, richRelevanceService, restangular, settings) {
        _classCallCheck(this, RichRelevanceHomeInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceHomeInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceHomeInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService));

        _this._api = restangular.one('RichRelevance');
        _this.richRelevanceService = richRelevanceService;
        _this.settings = settings;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceHomeInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            this.richRelevanceService.getInformation().then(function () {
                if (_this2.settings.richRelevance.removeDuplicatedProducts) {
                    var placementIdArray = _this2.placementTypes();

                    if (!placementIdArray || !placementIdArray.length) {
                        return;
                    }

                    _this2.sendServerInstrumentation(placementIdArray).then(function (placement) {
                        _this2.richRelevanceService.onPlacementsReceived(placement);
                    });
                } else {
                    _this2.$window.R3_HOME = new _this2.$window.r3_home(); // eslint-disable-line new-cap
                    _this2.addPlacementTypesIfEnabled();
                    _this2.$window.rr_flush_onload();
                    _this2.$window.r3();
                }
            });
        }
    }, {
        key: 'sendServerInstrumentation',
        value: function sendServerInstrumentation(placementId) {
            // Send request to Trader server
            return this._api.several('Placements', placementId).doGET();
        }
    }]);

    return RichRelevanceHomeInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceHomeInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', 'Restangular', 'Settings', RichRelevanceHomeInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@'
    }
};

module.exports = {
    RichRelevanceHomeInstrumentationController: RichRelevanceHomeInstrumentationController,
    richRelevanceHomeInstrumentationComponentDefinition: richRelevanceHomeInstrumentationComponentDefinition
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(12);
var _ = __webpack_require__(0);

var RichRelevanceCategoryInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceCategoryInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceCategoryInstrumentationController($scope, $window, featureService, richRelevanceService, settings) {
        _classCallCheck(this, RichRelevanceCategoryInstrumentationController);

        // opt-out from state change notifications.
        // category changes are handled using scope changes.
        var baseControllerConfig = {
            instrumentOnStateChange: false
        };

        var _this = _possibleConstructorReturn(this, (RichRelevanceCategoryInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceCategoryInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService, baseControllerConfig));

        _this.richRelevanceService = richRelevanceService;
        _this.selectedCategory = {};
        _this.lastInstrumentedPageNumber = -1; // will be updated on first show.
        _this.settings = settings;
        return _this;
    }

    _createClass(RichRelevanceCategoryInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            this.setAisleOrCategory(this.currentCategory);
        }
    }, {
        key: 'setAisleOrCategory',
        value: function setAisleOrCategory(currentCategory) {
            // If we're requesting placements server-side, don't send the p13n call on Browse except specials category.
            if (this.settings.richRelevance.removeDuplicatedProducts && currentCategory && !currentCategory.IsSpecial) {
                return;
            }
            // current category is reinitialized when user clicks on items (view item details) .etc.
            // we dont want to send instrumentation if the actual values didn't change.
            if (!currentCategory || _.isEqual(currentCategory, this.selectedCategory) && this.lastInstrumentedPageNumber === this.pageNumber) {
                return;
            }
            this.selectedCategory = currentCategory;
            this.setCategoryIdAndName(currentCategory);
        }
    }, {
        key: 'setCategoryIdAndName',
        value: function setCategoryIdAndName(category) {
            var _this2 = this;

            this.richRelevanceService.clearPlacements();

            this.richRelevanceService.getInformation().then(function () {
                if (category.NodeId && !category.IsSpecial) {
                    window.R3_CATEGORY = new window.r3_category(); // eslint-disable-line new-cap
                    window.R3_CATEGORY.setId(category.NodeId); // category ID must match a category id as passed in catalog feed
                    window.R3_CATEGORY.setName(category.Description); // category name as it should be displayed to customers, overrides the value provided in the catalog feed for this category ID
                } else if (category.RichRelevanceId) {
                    window.R3_CATEGORY = new window.r3_category(); // eslint-disable-line new-cap
                    window.R3_CATEGORY.setId(category.RichRelevanceId);
                    window.R3_CATEGORY.setName(category.Description);
                } else {
                    // if there is no category id or it's a special category, call generic page request.
                    window.R3_GENERIC = new window.r3_generic(); // eslint-disable-line new-cap
                }
                if (!_this2.settings.richRelevance.removeDuplicatedProducts && (_this2.pageNumber === undefined || _this2.pageNumber < 2)) {
                    // only add placements if it's infinite scroll (pageNumber === undefined)
                    // or page 1 (pageNumber === 1)
                    _this2.addPlacementTypesIfEnabled();
                }
                _this2.lastInstrumentedPageNumber = _this2.pageNumber;
                window.rr_flush_onload();
                window.r3();
            });
        }
    }, {
        key: 'setPlacementIdsForSpecialsGroup',
        value: function setPlacementIdsForSpecialsGroup(category) {
            this.placementIds = this.richRelevanceService.getPlacementIdsForSpecialsGroup(category);
        }
    }, {
        key: 'setPlacementIdsForCategory',
        value: function setPlacementIdsForCategory(category) {
            if (category && category.NodeLevel) {
                this.placementIds = this.richRelevanceService.getPlacementByCategoryLevel(category.NodeLevel);
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {

            if (changes.currentCategory || changes.pageNumber && changes.pageNumber.currentValue !== this.lastInstrumentedPageNumber) {
                var category = changes.currentCategory ? changes.currentCategory.currentValue : this.selectedCategory;

                if (category && category.RichRelevanceId) {
                    this.setPlacementIdsForSpecialsGroup(category);
                } else if (category && category.NodeId === this.richRelevanceService.mySpecialsGroupId) {
                    this.placementIds = this.richRelevanceService.mySpecialsPlacement;
                } else {
                    this.setPlacementIdsForCategory(category);
                }
                this.setAisleOrCategory(category);
            }
        }
    }]);

    return RichRelevanceCategoryInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceCategoryInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', 'Settings', RichRelevanceCategoryInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@',
        currentCategory: '<',
        pageNumber: '<',
        isSpecialsGroup: '='
    }
};

module.exports = {
    RichRelevanceCategoryInstrumentationController: RichRelevanceCategoryInstrumentationController,
    richRelevanceCategoryInstrumentationComponentDefinition: richRelevanceCategoryInstrumentationComponentDefinition
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(12);

var RichRelevanceWishlistInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceWishlistInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceWishlistInstrumentationController($scope, $window, featureService, richRelevanceService) {
        _classCallCheck(this, RichRelevanceWishlistInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceWishlistInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceWishlistInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService));

        _this.richRelevanceService = richRelevanceService;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceWishlistInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            this.richRelevanceService.getInformation().then(function () {
                _this2.$window.R3_WISHLIST = new _this2.$window.r3_wishlist(); // eslint-disable-line new-cap
                _this2.$window.rr_flush_onload();

                _this2.$window.r3();
            });
        }
    }]);

    return RichRelevanceWishlistInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceWishlistInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceWishlistInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@'
    }
};

module.exports = {
    RichRelevanceWishlistInstrumentationController: RichRelevanceWishlistInstrumentationController,
    richRelevanceWishlistInstrumentationComponentDefinition: richRelevanceWishlistInstrumentationComponentDefinition
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(12);

var RichRelevanceMypageInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceMypageInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceMypageInstrumentationController($scope, $window, featureService, richRelevanceService) {
        _classCallCheck(this, RichRelevanceMypageInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceMypageInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceMypageInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService));

        _this.richRelevanceService = richRelevanceService;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceMypageInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            this.richRelevanceService.getInformation().then(function () {
                _this2.$window.R3_PERSONAL = new _this2.$window.r3_personal(); // eslint-disable-line new-cap
                _this2.$window.rr_flush_onload();

                _this2.$window.r3();
            });
        }
    }]);

    return RichRelevanceMypageInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceMypageInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceMypageInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@'
    }
};

module.exports = {
    RichRelevanceMypageInstrumentationController: RichRelevanceMypageInstrumentationController,
    richRelevanceMypageInstrumentationComponentDefinition: richRelevanceMypageInstrumentationComponentDefinition
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RichRelevanceErrorInstrumentationController = function RichRelevanceErrorInstrumentationController($window, richRelevanceService) {
    _classCallCheck(this, RichRelevanceErrorInstrumentationController);

    richRelevanceService.getInformation().then(function () {
        $window.R3_ERROR = new $window.r3_error(); // eslint-disable-line new-cap
        $window.rr_flush_onload();

        $window.r3();
    });
};

var richRelevanceErrorInstrumentationComponentDefinition = {
    controller: ['$window', 'RichRelevanceService', RichRelevanceErrorInstrumentationController]
};

module.exports = {
    RichRelevanceErrorInstrumentationController: RichRelevanceErrorInstrumentationController,
    richRelevanceErrorInstrumentationComponentDefinition: richRelevanceErrorInstrumentationComponentDefinition
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(12);

var RichRelevanceSearchInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceSearchInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceSearchInstrumentationController($scope, $window, featureService, richRelevanceService, settings) {
        _classCallCheck(this, RichRelevanceSearchInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceSearchInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceSearchInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService));

        _this.richRelevanceService = richRelevanceService;
        _this.settings = settings;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceSearchInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            // If we're requesting placements server-side, don't send the p13n call on Search.
            if (this.settings.richRelevance.removeDuplicatedProducts) {
                return;
            }
            this.richRelevanceService.getInformation().then(function () {
                _this2.$window.R3_SEARCH = new _this2.$window.r3_search(); // eslint-disable-line new-cap
                _this2.$window.R3_SEARCH.setTerms(_this2.searchTerm);

                _this2.$window.rr_flush_onload();
                _this2.$window.r3();
            });
        }
    }]);

    return RichRelevanceSearchInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceSearchInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', 'Settings', RichRelevanceSearchInstrumentationController],
    bindings: {
        searchTerm: '<',
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@'
    }
};

module.exports = {
    RichRelevanceSearchInstrumentationController: RichRelevanceSearchInstrumentationController,
    richRelevanceSearchInstrumentationComponentDefinition: richRelevanceSearchInstrumentationComponentDefinition
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(12);

var RichRelevanceGenericInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceGenericInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceGenericInstrumentationController($scope, $window, featureService, richRelevanceService) {
        _classCallCheck(this, RichRelevanceGenericInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceGenericInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceGenericInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService));

        _this.richRelevanceService = richRelevanceService;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceGenericInstrumentationController, [{
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            this.richRelevanceService.getInformation().then(function () {
                _this2.$window.R3_GENERIC = new _this2.$window.r3_generic(); // eslint-disable-line new-cap
                _this2.addPlacementTypesIfEnabled();
                _this2.$window.rr_flush_onload();
                _this2.$window.r3();
            });
        }
    }]);

    return RichRelevanceGenericInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceGenericInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceGenericInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@'
    }
};

module.exports = {
    RichRelevanceGenericInstrumentationController: RichRelevanceGenericInstrumentationController,
    richRelevanceGenericInstrumentationComponentDefinition: richRelevanceGenericInstrumentationComponentDefinition
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RichRelevanceCartInstrumentationController = function RichRelevanceCartInstrumentationController($window, richRelevanceService) {
    var _this = this;

    _classCallCheck(this, RichRelevanceCartInstrumentationController);

    richRelevanceService.getInformation().then(function () {
        $window.R3_CART = new $window.r3_cart(); // eslint-disable-line new-cap

        _this.products.forEach(function (product) {
            $window.R3_CART.addItemId(product.Stockcode);
        });

        $window.rr_flush_onload();
        $window.r3();
    });
};

var richRelevanceCartInstrumentationComponentDefinition = {
    controller: ['$window', 'RichRelevanceService', RichRelevanceCartInstrumentationController],
    bindings: {
        products: '<'
    }
};

module.exports = {
    RichRelevanceCartInstrumentationController: RichRelevanceCartInstrumentationController,
    richRelevanceCartInstrumentationComponentDefinition: richRelevanceCartInstrumentationComponentDefinition
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichRelevanceBaseInstrumentationController = __webpack_require__(12);

var RichRelevanceItemInstrumentationController = function (_RichRelevanceBaseIns) {
    _inherits(RichRelevanceItemInstrumentationController, _RichRelevanceBaseIns);

    function RichRelevanceItemInstrumentationController($scope, $window, featureService, richRelevanceService) {
        _classCallCheck(this, RichRelevanceItemInstrumentationController);

        var _this = _possibleConstructorReturn(this, (RichRelevanceItemInstrumentationController.__proto__ || Object.getPrototypeOf(RichRelevanceItemInstrumentationController)).call(this, $scope, $window, featureService, richRelevanceService, { instrumentOnStateChange: false }));

        _this.richRelevanceService = richRelevanceService;
        _this.$window = $window;
        return _this;
    }

    _createClass(RichRelevanceItemInstrumentationController, [{
        key: '$onInit',
        value: function $onInit() {
            // we handle this manually since this is instantiated after
            // $stateChangeSuccess on product details page.
            this.sendInstrumentation();
        }
    }, {
        key: 'sendInstrumentation',
        value: function sendInstrumentation() {
            var _this2 = this;

            this.richRelevanceService.getInformation().then(function () {
                _this2.$window.R3_ITEM = new _this2.$window.r3_item(); // eslint-disable-line new-cap
                _this2.$window.R3_ITEM.setId(_this2.itemId.toString()); // This must pass a string value, as RR calls indexOf() on this internally, possibly to URL encode it.
                _this2.$window.R3_ITEM.setName(_this2.itemName);
                _this2.addPlacementTypesIfEnabled();
                _this2.$window.rr_flush_onload();
                _this2.$window.r3();
            });
        }
    }]);

    return RichRelevanceItemInstrumentationController;
}(RichRelevanceBaseInstrumentationController);

var richRelevanceItemInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceItemInstrumentationController],
    bindings: {
        itemId: '<',
        itemName: '<',
        pageGroup: '@',
        placementIds: '<'
    }
};

module.exports = {
    RichRelevanceItemInstrumentationController: RichRelevanceItemInstrumentationController,
    richRelevanceItemInstrumentationComponentDefinition: richRelevanceItemInstrumentationComponentDefinition
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RichRelevancePurchasedInstrumentationController = function () {
    function RichRelevancePurchasedInstrumentationController($window, richRelevanceService) {
        var _this = this;

        _classCallCheck(this, RichRelevancePurchasedInstrumentationController);

        this.$window = $window;
        richRelevanceService.getInformation().then(function () {

            $window.R3_PURCHASED = new $window.r3_purchased(); // eslint-disable-line new-cap

            $window.R3_PURCHASED.setOrderNumber(_this.order.OrderId);
            _this.order.Products.forEach(function (product) {
                _this.addProduct(product);
            });

            $window.rr_flush_onload();
            $window.r3();
        });
    }

    _createClass(RichRelevancePurchasedInstrumentationController, [{
        key: 'addProduct',
        value: function addProduct(product) {
            // WOS-5077 RichRelevance cannot accept decimal quantity and doesn't want to boost product by loose items and B2B customers quantity.
            // Therefore, we always send the qunatity as 1 and price should be line total.
            this.$window.R3_PURCHASED.addItemIdPriceQuantity(product.Stockcode, product.Subtotal, 1);
        }
    }]);

    return RichRelevancePurchasedInstrumentationController;
}();

var richRelevancePurchasedInstrumentationComponentDefinition = {
    controller: ['$window', 'RichRelevanceService', RichRelevancePurchasedInstrumentationController],
    bindings: {
        order: '<'
    }
};

module.exports = {
    RichRelevancePurchasedInstrumentationController: RichRelevancePurchasedInstrumentationController,
    richRelevancePurchasedInstrumentationComponentDefinition: richRelevancePurchasedInstrumentationComponentDefinition
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SCROLLSTOP_TIMEOUT_MS = 150;

var _require = __webpack_require__(0),
    debounce = _require.debounce,
    map = _require.map,
    isUndefined = _require.isUndefined,
    $ = __webpack_require__(2),
    scrollSize = __webpack_require__(25);

var globalClassName = 'productCarousel-hides-cardlist-header'; // This is a CSS Feature class. See _features.less

var RrCarouselController = function () {
    function RrCarouselController($scope, $element, $timeout, $q, shelfProductService, richRelevanceService, settings) {
        var _this = this;

        _classCallCheck(this, RrCarouselController);

        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$q = $q;
        this.shelfProductService = shelfProductService;
        this.richRelevanceService = richRelevanceService;
        this.settings = settings;

        if (!this.placementId) {
            this.placementId = this.dynamicPlacementId;
        }

        $scope.$on('$destroy', function () {
            return _this.removeGlobalClass();
        });
        $scope.$on('window:widthResize', function () {
            return _this.initLayout();
        });
    }

    _createClass(RrCarouselController, [{
        key: '$onInit',
        value: function $onInit() {
            this.showCarousel = isUndefined(this.showCarousel) ? true : this.showCarousel;
            this.showTitle = isUndefined(this.showTitle) ? true : this.showTitle;
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this2 = this;

            // We do this in postLink rather than onInit because it triggers DOM manipulation.
            // DOM manipulation is not safe before $postLink has fired.
            this.richRelevanceService.registerPlacementCallback(this.richRelevanceService.getEffectivePlacementId(this.placementId), function (placement) {
                _this2.removeGlobalClass();
                _this2.products = null;
                _this2.title = null;

                if (placement) {
                    _this2.onPlacement(placement);
                }
            });

            // if a product rich relevance placment object being passed in it requires onPlacementsReceived being called
            if (this.rrPlacement) {
                this.richRelevanceService.onPlacementsReceived(this.rrPlacement);
            }
        }
    }, {
        key: 'onPlacement',
        value: function onPlacement(placement) {
            var _this3 = this;

            this.title = placement.message;

            var productsPromise = this.richRelevanceService.useServerSideResults(placement) && placement.Products ? this.$q.when(placement.Products) : this.shelfProductService.getProductsByStockcodes(map(placement.items, 'id'), true, placement.productSource);

            productsPromise.then(function (products) {
                _this3.products = products;
            }).then(function () {
                return _this3.$timeout(function () {
                    return _this3.getCarouselElements();
                }, 0, false);
            }).then(function () {
                return _this3.initLayout();
            });
        }
    }, {
        key: 'getCarouselElements',
        value: function getCarouselElements() {
            this.$scrollWrapper = this.$element.find('._productCarousel-scrollWrapper');
            this.$scrollContainer = this.$element.find('._productCarousel-scrollContainer');
            this.$items = this.$element.find('._productCarousel-item');
        }
    }, {
        key: 'initLayout',
        value: function initLayout() {
            var _this4 = this;

            if (!this.products || this.products.length === 0) return;

            if (!this.showCarousel) return;

            this.$scrollWrapper.height(this.$scrollContainer.outerHeight() - scrollSize());

            this.carouselScrollWidth = this.$scrollContainer.get(0).scrollWidth;
            this.carouselOffsetWidth = this.$scrollContainer.width();
            this.itemWidth = this.$items.width();

            this.addGlobalClass();
            this.displayArrowExecute();

            this.displayArrow = debounce(this.displayArrowExecute, SCROLLSTOP_TIMEOUT_MS);

            this.$scrollContainer.off('scroll').on('scroll', function () {
                _this4.displayArrow();
            });
        }
    }, {
        key: 'addGlobalClass',
        value: function addGlobalClass() {
            // we add a class to html tag which will be used to hide
            // the extra space between the carousel and the card list
            // in category spaces. (Done in css).  This space is used
            // to move down the  card list to prevent overlapping with
            // the sliding panel  arrows, which is no longer the case
            // when carousel is at  the top.
            $('html').addClass(globalClassName);
        }
    }, {
        key: 'removeGlobalClass',
        value: function removeGlobalClass() {
            $('html').removeClass(globalClassName);
        }

        /**
         * Decides whether or not the carousel should display arrows.
         *
         * @param {Number} [carouselOffsetWidth=this.carouselOffsetWidth]
         * @param {Number} [carouselScrollWidth=this.carouselScrollWidth]
         *
         * @memberOf RrCarouselController
         */

    }, {
        key: 'displayArrowExecute',
        value: function displayArrowExecute() {
            var carouselOffsetWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.carouselOffsetWidth;
            var carouselScrollWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.carouselScrollWidth;

            this.isScrollable = carouselScrollWidth >= carouselOffsetWidth;

            if (this.isScrollable) {
                this.updateArrow();
            }
        }

        /**
         * Toggles enabled state of left and right arrows based on current scroll position.
         *
         * @param {Number} [scrollLeft=this.carouselScrollLeft]
         * @param {Number} [carouselScrollWidth=this.carouselScrollWidth]
         * @param {Number} [carouselOffsetWidth=this.carouselOffsetWidth]
         *
         * @memberOf RrCarouselController
         */

    }, {
        key: 'updateArrow',
        value: function updateArrow() {
            var scrollLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.carouselScrollLeft;

            var _this5 = this;

            var carouselScrollWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.carouselScrollWidth;
            var carouselOffsetWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.carouselOffsetWidth;

            this.$timeout(function () {
                _this5.isLeftArrowDisabled = scrollLeft <= 0;
                _this5.isRightArrowDisabled = scrollLeft >= carouselScrollWidth - carouselOffsetWidth;
            });
        }

        /**
         * Calculates the new leftScroll value after scrolling left or right.
         * Scrolls by one viewport width.
         *
         * @param {Boolean} right
         * @param {Number} [itemWidth=this.itemWidth]
         * @param {Number} [scrollLeft=this.carouselScrollLeft]
         * @param {Number} [carouselWidth=this.carouselOffsetWidth]
         * @returns {Number}
         *
         * @memberOf RrCarouselController
         */

    }, {
        key: 'calculateNewScrollPosition',
        value: function calculateNewScrollPosition(right) {
            var itemWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.itemWidth;
            var scrollLeft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.carouselScrollLeft;
            var carouselWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.carouselOffsetWidth;

            var numItemsViewable = carouselWidth / itemWidth;

            var targetScroll = 0;

            if (right) {
                // move the carousel one viewport to the right
                targetScroll = scrollLeft + numItemsViewable * itemWidth;
                // round to the nearest visible card.
                targetScroll = Math.floor(targetScroll / itemWidth) * itemWidth; // anchor to left corner of card
            } else {
                // move the carousel one viewport to the left
                targetScroll = scrollLeft - numItemsViewable * itemWidth;
                // round to the nearest fully visible card
                targetScroll = Math.ceil(targetScroll / itemWidth) * itemWidth;
            }

            return targetScroll;
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            this.animateScrolling(this.calculateNewScrollPosition(false));
        }
    }, {
        key: 'scrollRight',
        value: function scrollRight() {
            this.animateScrolling(this.calculateNewScrollPosition(true));
        }
    }, {
        key: 'animateScrolling',
        value: function animateScrolling(targetScroll) {
            this.$scrollContainer.animate({
                scrollLeft: targetScroll
            }, 200);
            this.$scrollWrapper.hide().show(0);
        }
    }, {
        key: 'carouselScrollLeft',
        get: function get() {
            return this.$scrollContainer.scrollLeft();
        }
    }]);

    return RrCarouselController;
}();

var rrCarouselComponentDefinition = {
    bindings: {
        placementId: '@',
        dynamicPlacementId: '=',
        rrPlacement: '=?',
        showCarousel: '<?',
        showTitle: '<?'
    },
    controller: ['$scope', '$element', '$timeout', '$q', 'ShelfProductService', 'RichRelevanceService', 'Settings', RrCarouselController],
    template: __webpack_require__(311).trim()
};

module.exports = {
    RrCarouselController: RrCarouselController,
    rrCarouselComponentDefinition: rrCarouselComponentDefinition
};

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "<div class=\"productCarousel tileList-container\" ng-if=\"$ctrl.products && $ctrl.products.length\">\r\n\t<h2 class=\"productCarousel-header\" ng-show=\"$ctrl.title && $ctrl.showTitle\">\r\n\t\t{{$ctrl.title}}\r\n\t</h2>\r\n\r\n    <div class=\"productCarousel-buttonWrapper\" ng-if=\"$ctrl.showCarousel\">\r\n        <button type=\"button\" class=\"productCarousel-nav productCarousel-leftArrow\" ng-show=\"$ctrl.isScrollable\" ng-click=\"$ctrl.scrollLeft()\" ng-disabled=\"$ctrl.isLeftArrowDisabled\">\r\n            <i class=\"iconww-ArrowLeft productCarousel-navIcon\" aria-hidden=\"true\"></i>\r\n            <span class=\"sr-only\">Previous - for visual effect only</span>\r\n        </button>\r\n\r\n        <div class=\"productCarousel-panel _productCarousel-scrollWrapper\"> <!-- This div hides the scrollbar -->\r\n            <div class=\"productCarousel-items _productCarousel-scrollContainer\"> <!-- This is the scrollable div -->\r\n                <wow-shelf-product-tile\r\n                    class=\"_productCarousel-item\"\r\n                    product=\"product\"\r\n                    ng-repeat=\"product in $ctrl.products track by $index\">\r\n                </wow-shelf-product-tile>\r\n            </div>\r\n        </div>\r\n\r\n        <button type=\"button\" class=\"productCarousel-nav productCarousel-rightArrow\" ng-show=\"$ctrl.isScrollable\" ng-click=\"$ctrl.scrollRight()\" ng-disabled=\"$ctrl.isRightArrowDisabled\">\r\n            <i class=\"iconww-ArrowRight productCarousel-navIcon\" aria-hidden=\"true\"></i>\r\n            <span class=\"sr-only\">Next - for visual effect only</span>\r\n        </button>\r\n    </div>\r\n\r\n    <div ng-if=\"!$ctrl.showCarousel\">\r\n        <wow-shelf-product-tile\r\n            class=\"_productCarousel-item\"\r\n            product=\"product\"\r\n            ng-repeat=\"product in $ctrl.products track by $index\">\r\n        </wow-shelf-product-tile>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

angular.module('wowApp.shop')
// Service
.service('ProductRecommendationService', ['RestangularV3', '$window', 'Settings', 'BreakpointsService', __webpack_require__(313)]);

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    endsWith = _require.endsWith;

var ProductRecommendationService = function () {
    function ProductRecommendationService(restangularV3, $window, settings, breakpointsService) {
        _classCallCheck(this, ProductRecommendationService);

        this._daasApi = restangularV3.one('ProductRecommendation');
        this.$window = $window;
        this.settings = settings;
        this.breakpointsService = breakpointsService;
        this.daasSourceName = 'DAAS';
    }

    _createClass(ProductRecommendationService, [{
        key: 'createStrategyPlacement',
        value: function createStrategyPlacement(index, products, strategy) {
            return {
                message: strategy.title,
                strategy: strategy.code,
                placement_name: strategy.placement_type,
                items: products.map(this.createProductPlacement)
            };
        }
    }, {
        key: 'createProductPlacement',
        value: function createProductPlacement(product) {
            return {
                id: product.id
            };
        }
    }, {
        key: 'lookupStrategyForPlacements',
        value: function lookupStrategyForPlacements(strategies, placement) {
            return strategies.find(function (x) {
                return x.id === placement.strategy_id;
            });
        }
    }, {
        key: 'preparePlacements',
        value: function preparePlacements(data) {
            var _this = this;

            return data.placements.map(function (placement, i) {
                return _this.createStrategyPlacement(i, placement.items, _this.lookupStrategyForPlacements(data.strategies, placement));
            });
        }
    }, {
        key: 'getEffectivePlacementId',
        value: function getEffectivePlacementId(placementId) {
            return this.breakpointsService.isInSmallFormat && !endsWith(placementId, '_mobile') ? placementId + '_mobile' : placementId;
        }
    }, {
        key: 'fetchAndBindDaasData',
        value: function fetchAndBindDaasData() {
            var _this2 = this;

            var productId = '0';
            if (this.$window.R3_ITEM) {
                productId = this.$window.R3_ITEM.id;
            }

            this._daasApi.one(productId).get().then(function (json) {
                var daasPlacements = _this2.preparePlacements(json);
                daasPlacements.forEach(function (placement, index) {
                    placement.placement_name = _this2.getEffectivePlacementId(placement.placement_name);
                    _this2.$window.RR.data.JSON.placements[index] = placement;
                });

                _this2.$window.RR.data.JSON.placements.productSource = _this2.daasSourceName;
                if (_this2.$window.RR.jsonCallback) {
                    _this2.$window.RR.jsonCallback();
                }
            });
        }
    }, {
        key: 'shouldBindDaasDataToPage',
        value: function shouldBindDaasDataToPage() {
            if (
            // product details
            location.pathname.startsWith('/shop/productdetails') && this.settings.productDetailsAdditionalAttributes.enableDaasProductDetails ||
            // quick reorder
            location.pathname.startsWith('/shop/mylists/reorder') && this.settings.quickReorder.enableDaasQuickReorder) {
                return true;
            }
            return false;
        }
    }]);

    return ProductRecommendationService;
}();

module.exports = ProductRecommendationService;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(315),
    notificationPanelComponentDefinition = _require.notificationPanelComponentDefinition;

__webpack_require__(1).module('wowApp.shop').component('wowNotificationPanel', notificationPanelComponentDefinition);

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var onBoardingSessionStorageKey = 'pendingOnBoardingPopup';
var sessionStorageKey = 'pendingDynamicSuburbsPopup';
var merchantHostedStorageKey = 'pendingMerchantHostedLogic';

var NotificationPanelController = function () {
    function NotificationPanelController($window, $rootScope, $scope, $state, sessionStorage, settings, expressService, shopperService, loginService, analytics, trolleyService, userPreferenceService, inStoreProductService) {
        _classCallCheck(this, NotificationPanelController);

        this.$window = $window;
        this.$scope = $scope;
        this.$state = $state;
        this.sessionStorage = sessionStorage;
        this.settings = settings;
        this.expressService = expressService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.analytics = analytics;
        this.trolleyService = trolleyService;
        this.userPreferenceService = userPreferenceService;
        this.inStoreProductService = inStoreProductService;
        this.$rootScope = $rootScope;
    }

    _createClass(NotificationPanelController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.shouldDisplayDynamicSuburbDialog = false;
            this.shouldDisplayExpressSelectedDialog = false;
            this.shouldDisplayFulfillmentSelectorDialog = false;
            this.shouldDisplayOnboardingDialog = false;

            this.$scope.$on('login:success', function () {
                _this.sessionStorage.set(sessionStorageKey, true);
            });

            this.$scope.$on('session:timeout', function () {
                _this.shouldDisplayDynamicSuburbDialog = false;
                _this.shouldDisplayExpressSelectedDialog = false;
                _this.shouldDisplayFulfillmentSelectorDialog = false;
                _this.shouldDisplayOnboardingDialog = false;
            });

            if (this.sessionStorage.getAndRemove(sessionStorageKey)) {
                this.showDynamicSuburbsDialog();

                // Feature switch for onboarding
                if (this.settings.content.enableFulfilmentSelectorModal) {
                    this.sessionStorage.set(onBoardingSessionStorageKey, true);
                }
            }

            this.showExpressSelectedDialog();

            this.shouldShowFMS = this.inStoreProductService.shouldShowFMS();

            // Show onboarding screen
            if ((this.sessionStorage.getAndRemove(onBoardingSessionStorageKey) || this.shouldShowFMS) && !this.shouldDisplayDynamicSuburbDialog && !this.shouldDisplayExpressSelectedDialog) {
                switch (this.$state.current.name) {
                    case 'shop.confirmation':
                    case 'shop.myaccount.trackmyorder':
                        {
                            break;
                        }
                    case 'shop.inspiration.parent.child':
                        {
                            if (this.$state.params.parent !== 'meals-at-woolworths' && this.$state.params.child !== 'meal-planner') {
                                this.showOnboardingDialog();
                            }
                            break;
                        }
                    default:
                        {
                            this.defaultShouldShowOnboarding();
                            break;
                        }
                }
            }
            this.$rootScope.$on('FMS:close', function () {
                if (_this.sessionStorage.get(merchantHostedStorageKey)) {
                    _this.$window.location.reload();
                } else {
                    _this.inStoreProductService.addSavedProductToCart();
                }
            });

            if (this.sessionStorage.getAndRemove(merchantHostedStorageKey)) {
                this.inStoreProductService.addSavedProductToCart();
            }
        }
    }, {
        key: 'defaultShouldShowOnboarding',
        value: function defaultShouldShowOnboarding() {
            var loginTrigger = this.sessionStorage.getAndRemove('login:trigger');
            switch (loginTrigger) {
                case 'GuestLoginToSaveAddress':
                case 'GuestLoginToFavouriteRecipe':
                    {
                        break;
                    }
                default:
                    {
                        this.showOnboardingDialog(); // all other cases, show FMS/onboarding
                        break;
                    }
            }
        }
    }, {
        key: 'shouldShowfulfilmentSelector',
        value: function shouldShowfulfilmentSelector(date1, date2, callback) {
            if (this.shouldShowFMS || !date1 || !date2) {
                callback();
                return;
            }
            date1.setHours(0, 0, 0, 0);
            date2.setHours(0, 0, 0, 0);
            if (date1.getTime() !== date2.getTime()) {
                callback();
            }
        }
    }, {
        key: 'closeOnBoardingDialog',
        value: function closeOnBoardingDialog() {
            var _this2 = this;

            this.userPreferenceService.getUserPreference().then(function (result) {
                var lastSeen = new Date(result.LastViewFulfilmentSelector);
                var today = new Date();
                _this2.shouldShowfulfilmentSelector(lastSeen, today, function () {
                    _this2.showFulfilmentSelectorDialog();
                    _this2.userPreferenceService.setLastViewFulfilmentMethodSelector(today);
                });
            });
        }
    }, {
        key: 'showOnboardingDialog',
        value: function showOnboardingDialog() {
            var _this3 = this;

            this.userPreferenceService.getUserPreference().then(function (result) {
                if (!result.HasDoneOnboarding) {
                    _this3.shouldDisplayOnboardingDialog = true;
                } else {
                    _this3.closeOnBoardingDialog();
                }
            });
        }
    }, {
        key: 'showFulfilmentSelectorDialog',
        value: function showFulfilmentSelectorDialog() {
            this.shouldDisplayFulfillmentSelectorDialog = this.settings.content.enableFulfilmentSelectorModal && !this.shouldDisplayDynamicSuburbDialog && !this.shouldDisplayExpressSelectedDialog;
        }
    }, {
        key: 'showDynamicSuburbsDialog',
        value: function showDynamicSuburbsDialog() {
            this.shouldDisplayDynamicSuburbDialog = !this.shopperService.IsGuest && this.shopperService.shopper.ShouldShowDeliveryWindowDialog && this.loginService.loginContext !== 'checkout';

            if (this.shouldDisplayDynamicSuburbDialog) {
                this.analytics.pushEvent('dynamic suburbs popup presented');
            }
        }
    }, {
        key: 'showExpressSelectedDialog',
        value: function showExpressSelectedDialog() {
            this.shouldDisplayExpressSelectedDialog = this.expressService.shouldShowExpressSelectedDialog() && this.$state.current.name === 'root';
        }
    }]);

    return NotificationPanelController;
}();

NotificationPanelController.$inject = ['$window', '$rootScope', '$scope', '$state', 'SessionStorageWrapper', 'Settings', 'ExpressService', 'ShopperService', 'LoginService', 'AnalyticsService', 'TrolleyService', 'UserPreferenceService', 'InStoreProductService'];

var notificationPanelComponentDefinition = {
    controller: NotificationPanelController,
    template: __webpack_require__(316).trim()
};

module.exports = {
    NotificationPanelController: NotificationPanelController,
    notificationPanelComponentDefinition: notificationPanelComponentDefinition
};

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "<wow-dynamic-suburb-dialog ng-if=\"$ctrl.shouldDisplayDynamicSuburbDialog\"></wow-dynamic-suburb-dialog>\r\n<wow-express-selected-dialog ng-if=\"::$ctrl.shouldDisplayExpressSelectedDialog\"></wow-express-selected-dialog>\r\n<wow-fulfilment-selector-dialog ng-if=\"$ctrl.shouldDisplayFulfillmentSelectorDialog\"></wow-fulfilment-selector-dialog>\r\n<wow-on-boarding-dialog  ng-if=\"$ctrl.shouldDisplayOnboardingDialog\" on-dismiss=\"$ctrl.closeOnBoardingDialog()\"></wow-on-boarding-dialog>\r\n"

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var ExpressService = __webpack_require__(318);

var _require = __webpack_require__(319),
    expressAddressPanelControllerComponentDefinition = _require.expressAddressPanelControllerComponentDefinition;

var _require2 = __webpack_require__(321),
    expressAddressAvailabilityControllerComponentDefinition = _require2.expressAddressAvailabilityControllerComponentDefinition;

var _require3 = __webpack_require__(323),
    expressCartItemCountControllerComponentDefinition = _require3.expressCartItemCountControllerComponentDefinition;

var _require4 = __webpack_require__(325),
    expressSelectedDialogControllerComponentDefinition = _require4.expressSelectedDialogControllerComponentDefinition;

var _require5 = __webpack_require__(327),
    expressSelectedDialogContentControllerComponentDefinition = _require5.expressSelectedDialogContentControllerComponentDefinition;

angular.module('wowApp.shop').component('wowExpressAddressPanel', expressAddressPanelControllerComponentDefinition).component('wowExpressAddressAvailability', expressAddressAvailabilityControllerComponentDefinition).component('wowExpressCartItemCount', expressCartItemCountControllerComponentDefinition).component('wowExpressSelectedDialog', expressSelectedDialogControllerComponentDefinition).component('wowExpressSelectedDialogContent', expressSelectedDialogContentControllerComponentDefinition).service('ExpressService', ['Restangular', 'LocalStorageWrapper', ExpressService]);

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpressService = function () {
    function ExpressService(restangular, localStorageWrapper) {
        _classCallCheck(this, ExpressService);

        this.localStorageWrapper = localStorageWrapper;

        this.api = restangular.one('/Delivery/Express');
    }

    _createClass(ExpressService, [{
        key: 'getExpressStoreInfo',
        value: function getExpressStoreInfo(addressId, suburbName, postalCode) {
            return this.api.one('StoreInfo').get({ addressId: addressId, suburbName: suburbName, postalCode: postalCode });
        }
    }, {
        key: 'getExpressDeliveryAddress',
        value: function getExpressDeliveryAddress(shopperId, amasLookUpAddressId) {
            return this.api.one('DeliveryAddress').get({ shopperId: shopperId, amasLookUpAddressId: amasLookUpAddressId });
        }
    }, {
        key: 'getExpressManualAddress',
        value: function getExpressManualAddress(shopperId, street1, street2, suburb, postcode) {
            return this.api.one('ManualAddress').get({
                shopperId: shopperId, street1: street1, street2: street2, suburb: suburb, postcode: postcode
            });
        }
    }, {
        key: 'shouldShowExpressSelectedDialog',
        value: function shouldShowExpressSelectedDialog() {
            return this.localStorageWrapper.get('ShowExpressSelectedDialog') && this.localStorageWrapper.get('ShowExpressSelectedDialog') === 'show';
        }
    }, {
        key: 'setShowExpressDialogInStorage',
        value: function setShowExpressDialogInStorage() {
            this.localStorageWrapper.set('ShowExpressSelectedDialog', 'show');
        }
    }, {
        key: 'setHideExpressDialogInStorage',
        value: function setHideExpressDialogInStorage() {
            this.localStorageWrapper.set('ShowExpressSelectedDialog', 'hide');
        }
    }]);

    return ExpressService;
}();

ExpressService.$inject = ['Restangular', 'LocalStorageWrapper'];

module.exports = ExpressService;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpressAddressPanelController = function () {
    function ExpressAddressPanelController($sce, $window, $state, moveFocus, settings, loginService, shopperService, fulfilmentService, expressService) {
        _classCallCheck(this, ExpressAddressPanelController);

        this.$sce = $sce;
        this.$window = $window;
        this.$state = $state;
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.loginService = loginService;
        this.shopperService = shopperService;
        this.fulfilmentService = fulfilmentService;
        this.expressService = expressService;
    }

    _createClass(ExpressAddressPanelController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isRequiredFieldsEntered = false;
            this.isValidForExpress = false;
            this.isAddressValidated = false;
            this.isDeliveryWindowClosed = false;
            this.isEtaEnabled = this.settings.expressLandingPage.expressETAEnabled;
            this.isEtaValid = false;
            this.expressAddressPanelHeaderMessage = this.$sce.trustAsHtml(this.settings.expressLandingPage.expressValueProposition);
            this.errorMessage = null;
        }
    }, {
        key: 'manualAddressMode',
        value: function manualAddressMode() {
            if (this.isOnManualAddressValidation) {
                return 'SEARCH';
            }
            if (this.isExpressAvailableNow) {
                return 'SHOP';
            }
            return '';
        }
    }, {
        key: 'onSaveAutoAddress',
        value: function onSaveAutoAddress(address) {
            var _this = this;

            this.isAddressValidated = false;
            this.expressService.getExpressStoreInfo(address.Id, null, null).then(function (response) {
                _this.isValidForExpress = response.IsExpress;
                _this.isAddressValidated = true;
                _this.isRequiredFieldsEntered = true;
                _this.isDeliveryWindowClosed = response.IsDeliveryWindowClosed;
                _this.etaDisplayString = response.EtaDisplayString;
                _this.isEtaValid = _this.etaDisplayString !== '';
                _this.errorMessage = response.ErrorMessage;
                _this.mapFulfilmentStoreDetails(response);
                if (_this.onAddressLookUp) {
                    _this.onAddressLookUp({ response: response });
                }
            });
        }
    }, {
        key: 'onManualAddressChange',
        value: function onManualAddressChange(address) {
            this.isAddressValidated = false;
            if (address.street1 && this.isValidSuburbValue(address.suburb) && address.postcode) {
                this.isRequiredFieldsEntered = true;
                this.street1 = address.street1;
                this.street2 = address.street2;
                this.suburb = address.suburb;
                this.postcode = address.postcode;
                this.moveFocus('#validateAddressManually');
            } else {
                this.isRequiredFieldsEntered = false;
            }

            if (this.onAddressLookUp) {
                this.onAddressLookUp(null);
            }
            this.isEtaValid = false;
            this.isValidForExpress = false;
            this.isDeliveryWindowClosed = null;
        }
    }, {
        key: 'manualDeliveryAddressChanged',
        value: function manualDeliveryAddressChanged() {
            var _this2 = this;

            if (this.postcode && this.suburb) {
                this.isAddressValidated = false;
                this.expressService.getExpressStoreInfo(null, this.suburb, this.postcode).then(function (response) {
                    _this2.mapFulfilmentStoreDetails(response);
                });
            } else {
                this.isValidForExpress = false;
                this.isDeliveryWindowClosed = null;
            }
        }
    }, {
        key: 'mapFulfilmentStoreDetails',
        value: function mapFulfilmentStoreDetails(response) {
            if (response.IsExpress) {
                this.deliveryWindowId = response.DeliveryWindowId;
                this.addressId = response.AddressId;

                if (this.addressEntryMode === 'MANUAL') {
                    this.moveFocus('#manualModeshopExpress');
                } else {
                    this.moveFocus('#autoModeshopExpress');
                }
            } else {
                this.moveFocus('#continueShoping');
            }

            this.etaDisplayString = response.EtaDisplayString;
            this.isEtaValid = this.etaDisplayString !== '';
            this.isValidForExpress = response.IsExpress;
            this.isAddressValidated = true;
            this.isDeliveryWindowClosed = response.IsDeliveryWindowClosed;

            this.errorMessage = response.ErrorMessage;
            if (this.onAddressLookUp) {
                this.onAddressLookUp({ response: response });
            }
        }
    }, {
        key: 'setAutoAddressValidationInfo',
        value: function setAutoAddressValidationInfo() {
            var _this3 = this;

            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToContinueMessage, undefined, undefined, undefined, undefined, undefined, function () {
                    _this3.validateExpressAddress(_this3.shopperService.shopper.Id, _this3.addressId);
                });
            } else {
                this.validateExpressAddress(this.shopperService.shopper.Id, this.addressId);
            }
        }
    }, {
        key: 'setManualAddressValidationInfo',
        value: function setManualAddressValidationInfo() {
            var _this4 = this;

            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToContinueMessage, undefined, undefined, undefined, undefined, undefined, function () {
                    _this4.validateManualAddress(_this4.shopperService.shopper.Id, _this4.street1, _this4.street2, _this4.suburb, _this4.postcode);
                });
            } else {
                this.validateManualAddress(this.shopperService.shopper.Id, this.street1, this.street2, this.suburb, this.postcode);
            }
        }
    }, {
        key: 'isOnManualSearchMode',
        value: function isOnManualSearchMode() {
            return this.addressEntryMode === 'MANUAL' && !this.isAddressValidated;
        }
    }, {
        key: 'onSetEntryMode',
        value: function onSetEntryMode(mode) {
            this.addressEntryMode = mode;
            this.isRequiredFieldsEntered = false;
            this.isEtaValid = false;
            this.isValidForExpress = false;
            this.isAddressValidated = false;

            if (this.onAddressLookUp) {
                this.onAddressLookUp(null);
            }
        }
    }, {
        key: 'refreshPage',
        value: function refreshPage() {
            if (this.isExpressAvailableNow) {
                this.expressService.setShowExpressDialogInStorage();
            }

            this.$window.location.href = '/';
        }
    }, {
        key: 'validateExpressAddress',
        value: function validateExpressAddress(shopperId, addressId) {
            var _this5 = this;

            this.expressService.getExpressDeliveryAddress(shopperId, addressId).then(function (response) {
                _this5.saveFulfilment(response.AddressId).then(function () {
                    _this5.refreshPage();
                });
            });
        }
    }, {
        key: 'validateManualAddress',
        value: function validateManualAddress(shopperId, street1, street2, suburb, postcode) {
            var _this6 = this;

            this.expressService.getExpressManualAddress(shopperId, street1, street2, suburb, postcode).then(function (response) {
                _this6.saveFulfilment(response.AddressId).then(function () {
                    _this6.refreshPage();
                });
            });
        }
    }, {
        key: 'saveFulfilment',
        value: function saveFulfilment(addressId) {
            var currentDate = new Date();
            var truncatedCurrentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            return this.fulfilmentService.saveFulfilment({
                fulfilmentMethod: 'Courier',
                address: { AddressId: addressId },
                fulfilmentWindow: { time: { Id: this.deliveryWindowId }, date: { Date: truncatedCurrentDate } }
            });
        }
    }, {
        key: 'isValidSuburbValue',
        value: function isValidSuburbValue(suburb) {
            return suburb && !suburb.startsWith('(0) Suburbs found for') || false;
        }
    }, {
        key: 'isAddressValidForExpressOrNotValidated',
        get: function get() {
            return this.isAddressValidated && this.isValidForExpress && this.isRequiredFieldsEntered && !this.isDeliveryWindowClosed || !this.isAddressValidated;
        }
    }, {
        key: 'isExpressAvailableNow',
        get: function get() {
            return this.isValidForExpress && !this.isDeliveryWindowClosed;
        }
    }, {
        key: 'isExpressUnavailable',
        get: function get() {
            return this.isAddressValidated && !this.isValidForExpress;
        }
    }, {
        key: 'shouldShowEtaValueProposition',
        get: function get() {
            return this.isAddressValidForExpressOrNotValidated && !this.isEtaValid && this.isEtaEnabled;
        }
    }, {
        key: 'shouldShowExpressValueProposition',
        get: function get() {
            return this.isAddressValidForExpressOrNotValidated && !this.isEtaValid && !this.isEtaEnabled;
        }
    }, {
        key: 'isExpressWindowClosedNow',
        get: function get() {
            return this.isAddressValidated && this.isDeliveryWindowClosed;
        }
    }, {
        key: 'isOnManualAddressValidation',
        get: function get() {
            return this.addressEntryMode === 'MANUAL' && (!this.isValidForExpress || this.isDeliveryWindowClosed);
        }
    }, {
        key: 'isAutoAddressValidated',
        get: function get() {
            return !this.isValidForExpress || this.isValidForExpress && this.isDeliveryWindowClosed;
        }
    }, {
        key: 'isIneligibleForExpressOrWindowClosed',
        get: function get() {
            return this.isAddressValidated && (!this.isValidForExpress || this.isDeliveryWindowClosed);
        }
    }]);

    return ExpressAddressPanelController;
}();

ExpressAddressPanelController.$inject = ['$sce', '$window', '$state', 'MoveFocus', 'Settings', 'LoginService', 'ShopperService', 'FulfilmentService', 'ExpressService'];

var expressAddressPanelControllerComponentDefinition = {
    bindings: {
        onAddressLookUp: '&?'
    },
    controller: ExpressAddressPanelController,
    template: __webpack_require__(320).trim()
};

module.exports = {
    ExpressAddressPanelController: ExpressAddressPanelController,
    expressAddressPanelControllerComponentDefinition: expressAddressPanelControllerComponentDefinition
};

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "<div class=\"expressAddressPanel\">\r\n    <div class=\"expressAddressPanel-title\" role=\"alert\">\r\n        <span class=\"expressAddressPanel-titleMessage\" ng-show=\"$ctrl.shouldShowEtaValueProposition\" >\r\n              <span wow-html-setting setting-group=\"expressLandingPage\" setting-name=\"etaValueProposition\"></span>\r\n        </span>\r\n        <span class=\"expressAddressPanel-titleMessage\" ng-show=\"$ctrl.shouldShowExpressValueProposition\" >\r\n            <span wow-html-setting setting-group=\"expressLandingPage\" setting-name=\"expressValueProposition\"></span>\r\n        </span>\r\n        <span class=\"expressAddressPanel-titleMessage\" ng-show=\"$ctrl.isAddressValidForExpressOrNotValidated && $ctrl.isEtaValid\" >\r\n            <span class=\"expressAddressPanel-titleMessage\" ng-bind-html=\"$ctrl.etaDisplayString\"></span>\r\n        </span>\r\n        <div class=\"expressAddressPanel-titleIneligible\" ng-if=\"$ctrl.isIneligibleForExpressOrWindowClosed\">\r\n            <div class=expressAddressPanel-titleIneligibleMessage>\r\n                {{$ctrl.errorMessage}}\r\n            </div>\r\n\r\n            <button id=\"continueShoping\" class=\"expressAddressPanel-titleIneligibleButton button button--primary\"\r\n                ng-click=\"$ctrl.refreshPage()\">\r\n                CONTINUE SHOPPING\r\n                <i class=\"iconww-ArrowRight\"></i>\r\n            </button>\r\n        </div>\r\n        <span class=\"expressAddressPanel-titleAlternateMessage\" ng-if=\"$ctrl.isIneligibleForExpressOrWindowClosed\"> Or search for a new address </span>\r\n    </div>\r\n    <div class=\"expressAddressPanel-address\">\r\n        <wow-address-entry-form input-id=\"signupDelivery\"\r\n            should-retain-input=\"true\"\r\n            on-set-entry-mode=\"$ctrl.onSetEntryMode(mode)\"\r\n            on-save-auto-address=\"$ctrl.onSaveAutoAddress(address)\"\r\n            on-manual-address-change=\"$ctrl.onManualAddressChange(address)\"\r\n            should-reset-mode=\"false\"\r\n            class=\"expressAddressPanel-addressForm\"\r\n            is-for-express=\"true\"\r\n            is-express-unavailable=\"$ctrl.isIneligibleForExpressOrWindowClosed\"\r\n            manual-address-mode=\"{{$ctrl.manualAddressMode()}}\"\r\n            on-validate-manual-address-for-express=\"$ctrl.manualDeliveryAddressChanged()\"\r\n            on-shop-manual-address-for-express=\"$ctrl.setManualAddressValidationInfo()\">\r\n        </wow-address-entry-form>\r\n        <div ng-if=\"$ctrl.addressEntryMode==='SEARCH'\" class=\"expressAddressPanel-addressConfirmation\">\r\n            <button type=\"button\" class=\"expressAddressPanel-addressConfirmationButton button button--primary\"\r\n            ng-disabled=\"$ctrl.isAutoAddressValidated\"\r\n            ng-click=\"$ctrl.setAutoAddressValidationInfo()\">\r\n                SHOP NOW\r\n                <i class=\"iconww-ArrowRight\"></i>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var expressAddressAvailabilityController = function () {
    function expressAddressAvailabilityController($window, moveFocus, settings) {
        _classCallCheck(this, expressAddressAvailabilityController);

        this.$window = $window;
        this.moveFocus = moveFocus;
        this.settings = settings;
    }

    _createClass(expressAddressAvailabilityController, [{
        key: 'mapFulfilmentStoreDetails',
        value: function mapFulfilmentStoreDetails(response) {
            this.isValidated = false;
            this.isExpress = false;
            this.isDeliveryWindowClosed = false;

            if (response && response.IsExpress != null) {
                this.isValidated = true;
                this.isExpress = response.IsExpress;
                this.isDeliveryWindowClosed = response.IsDeliveryWindowClosed;

                if (response.IsExpress && !response.IsDeliveryWindowClosed) {
                    this.storeName = response.StoreName;
                    this.bannerMessage = this.settings.expressLandingPage.expressAvailabilityMessage;
                    this.dayCode = response.DayCode;
                    this.timeLimit = response.TimeLimit;
                    this.amPmValue = response.AmPmValue;
                    this.moveFocus('#statusMessageBannerAvailable');
                } else {
                    this.moveFocus('#statusMessageBannerUnavailable');
                    this.bannerMessage = response.IsDeliveryWindowClosed ? this.settings.expressLandingPage.expressWindowClosedMessage : this.settings.expressLandingPage.expressNonAvailabilityMessage;
                }
            }

            // MoveFocus “works” but the banner is in the way essentially
            this.$window.scrollTo(0, 0);
        }
    }, {
        key: 'isExpressAvailable',
        get: function get() {
            return this.isValidated && this.isExpress && !this.isDeliveryWindowClosed;
        }
    }]);

    return expressAddressAvailabilityController;
}();

var expressAddressAvailabilityControllerComponentDefinition = {
    controller: ['$window', 'MoveFocus', 'Settings', expressAddressAvailabilityController],
    template: __webpack_require__(322).trim()
};

module.exports = {
    expressAddressAvailabilityController: expressAddressAvailabilityController,
    expressAddressAvailabilityControllerComponentDefinition: expressAddressAvailabilityControllerComponentDefinition
};

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "<div class=\"expressAddressAvailability\" style=\"background-image: url({{ $ctrl.settings.expressLandingPage.backgroundImagePath }});\">\r\n    <div class=\"expressAddressAvailability-banner\" ng-class=\"{ 'is-validated': $ctrl.isValidated }\">\r\n        <h1 class=\"expressAddressAvailability-bannerDefaultMessage\" ng-if=\"!$ctrl.isValidated\">\r\n            <span class=\"expressAddressAvailability-bannerDefaultMessageWelcome\">Welcome to Delivery Now</span>\r\n        </h1>\r\n        <h1 class=\"expressAddressAvailability-bannerAvailable\" ng-show=\"$ctrl.isExpressAvailable\" role=\"alert\"  id=\"statusMessageBannerAvailable\">\r\n            <img src=\"/images/express/icon-banner-time-info.svg\" class=\"expressAddressAvailability-bannerAvailableIcon\" alt=\"Delivery Now available icon\" oly-error-src />\r\n            <div class=\"expressAddressAvailability-bannerAvailableMessage\">\r\n                <div class=\"expressAddressAvailability-bannerAvailableMessageContainer\">\r\n                    <span class=\"expressAddressAvailability-bannerAvailableMessageContainerStore\">{{$ctrl.storeName}} &nbsp;</span>\r\n                    <span class=\"expressAddressAvailability-bannerAvailableMessageContainerTrading\">{{$ctrl.bannerMessage}}</span>\r\n                </div>\r\n                <span class=\"expressAddressAvailability-bannerAvailableMessageGrayBox\">\r\n                    <span class=\"expressAddressAvailability-bannerAvailableMessageGrayBoxDayCode\">{{$ctrl.dayCode}}</span>\r\n                    {{$ctrl.timeLimit}}\r\n                    <span class=\"expressAddressAvailability-bannerAvailableMessageGrayBoxAmPm\">{{$ctrl.amPmValue}}</span>\r\n                </span>\r\n            </div>\r\n        </h1>\r\n\r\n        <h1 class=\"expressAddressAvailability-bannerUnavailable\" ng-show=\"$ctrl.isValidated && !$ctrl.isExpressAvailable\" role=\"alert\" id=\"statusMessageBannerUnavailable\">\r\n            <img src=\"/images/express/icon-banner-warning.svg\" class=\"expressAddressAvailability-bannerUnavailableIcon\" alt=\"Delivery Now unavailable icon\" oly-error-src />\r\n            <span class=\"expressAddressAvailability-bannerUnavailableMessage\">\r\n                {{$ctrl.bannerMessage}}\r\n            </span>\r\n        </h1>\r\n    </div>\r\n\r\n    <wow-express-address-panel on-address-look-up=\"$ctrl.mapFulfilmentStoreDetails(response)\" class=\"expressAddressAvailability-panel\">\r\n    </wow-express-address-panel>\r\n</div>\r\n"

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    round = _require.round;

var ExpressCartItemCountController = function () {
    function ExpressCartItemCountController($scope, shopPageStateService, settings, trolleyService) {
        var _this = this;

        _classCallCheck(this, ExpressCartItemCountController);

        this.trolleyService = trolleyService;
        this.settings = settings;
        this.shopPageStateService = shopPageStateService;

        $scope.$watch(function () {
            return _this.trolleyService.totalItemQuantity;
        }, function () {
            return _this.updateItemCounts();
        });
    }

    _createClass(ExpressCartItemCountController, [{
        key: '$onInit',
        value: function $onInit() {
            // default values
            this.remainingItems = 0;
            this.exceededItems = 0;
            this.hasExceededLimit = false;

            this.orderLimitExceededWarningError = this.settings.deliveryWindowAlerts.orderLimitExceededWarningError;
        }
    }, {
        key: 'updateItemCounts',
        value: function updateItemCounts() {
            this.remainingItems = round(this.trolleyService.maximumOrderQuantity - this.trolleyService.totalItemQuantity, 1);
            this.exceededItems = round(this.trolleyService.totalItemQuantity - this.trolleyService.maximumOrderQuantity, 1);
            this.hasExceededLimit = this.exceededItems > 0;

            if (this.hasExceededLimit && !this.shopPageStateService.isCartOpen) {
                this.shopPageStateService.isCartOpen = true;
            }
        }
    }]);

    return ExpressCartItemCountController;
}();

var expressCartItemCountControllerComponentDefinition = {
    controller: ['$scope', 'ShopPageStateService', 'Settings', 'TrolleyService', ExpressCartItemCountController],
    template: __webpack_require__(324).trim()
};

module.exports = {
    ExpressCartItemCountController: ExpressCartItemCountController,
    expressCartItemCountControllerComponentDefinition: expressCartItemCountControllerComponentDefinition
};

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "<div class=\"expressCartItemCount\">\r\n    <div class=\"expressCartItemCount-valid\" ng-if=\"!$ctrl.hasExceededLimit\">\r\n        <div class=\"expressCartItemCount-validDisplay\">\r\n            <i class=\"expressCartItemCount-validDisplayIcon iconww-Cart\"></i>\r\n            <p class=\"expressCartItemCount-validDisplayCount\">\r\n                <ng-pluralize\r\n                    count=\"$ctrl.trolleyService.totalItemQuantity\"\r\n                    when=\"{'one': '{} item', 'other': '{} items'}\">\r\n                </ng-pluralize>\r\n            </p>\r\n        </div>\r\n        <div class=\"expressCartItemCount-validMessage\">\r\n            <p class=\"expressCartItemCount-validMessageCount\">You have\r\n                <ng-pluralize\r\n                    count=\"$ctrl.trolleyService.totalItemQuantity\"\r\n                    when=\"{'one': '{} item', 'other': '{} items'}\">\r\n                </ng-pluralize>\r\n                in your cart\r\n            </p>\r\n            <p class=\"expressCartItemCount-validMessageRemaining\">\r\n                You can add\r\n                <ng-pluralize\r\n                    count=\"$ctrl.remainingItems\"\r\n                    when=\"{'one': '{} more item', 'other': '{} more items'}\">\r\n                </ng-pluralize>\r\n                for delivery now\r\n            </p>\r\n        </div>\r\n    </div>\r\n    <div class=\"expressCartItemCount-invalid alert alert--error\" ng-if=\"$ctrl.hasExceededLimit\">\r\n        <div class=\"expressCartItemCount-invalidDisplay\">\r\n            <i class=\"expressCartItemCount-invalidDisplayIcon iconww-Cart\"></i>\r\n            <p class=\"expressCartItemCount-invalidDisplayCount\">\r\n                <ng-pluralize\r\n                    count=\"$ctrl.trolleyService.totalItemQuantity\"\r\n                    when=\"{'one': '{} item', 'other': '{} items'}\">\r\n                </ng-pluralize>\r\n            </p>\r\n        </div>\r\n        <div class=\"expressCartItemCount-invalidMessage\">\r\n            <p class=\"expressCartItemCount-invalidMessageWarning\">\r\n                {{::$ctrl.orderLimitExceededWarningError}}\r\n            </p>\r\n            <p class=\"expressCartItemCount-invalidMessageExcess\">\r\n                Remove\r\n                <ng-pluralize\r\n                    count=\"$ctrl.exceededItems\"\r\n                    when=\"{'one': '{} item', 'other': '{} items'}\">\r\n                </ng-pluralize>\r\n            </p>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpressSelectedDialogController = function ExpressSelectedDialogController(expressService) {
    _classCallCheck(this, ExpressSelectedDialogController);

    this.expressService = expressService;
};

ExpressSelectedDialogController.$inject = ['ExpressService'];

var expressSelectedDialogControllerComponentDefinition = {
    template: __webpack_require__(326).trim(),
    controller: ExpressSelectedDialogController
};

module.exports = {
    ExpressSelectedDialogController: ExpressSelectedDialogController,
    expressSelectedDialogControllerComponentDefinition: expressSelectedDialogControllerComponentDefinition
};

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = "<dialog name=\"express-selected-dialog\" id=\"_expressSelectedDialog\" class=\"olyDialog expressSelectedDialog\">\r\n    <div class=\"expressSelectedDialog-content\">\r\n        <button class=\"expressSelectedDialog-buttonClose\" oly-dialog-close>\r\n            <div>\r\n                <span class=\"sr-only\">close dialog</span>\r\n                <i class=\"icon-close_x expressSelectedDialog-buttonCloseIcon\"></i>\r\n            </div>\r\n        </button>\r\n        <wow-express-selected-dialog-content></wow-express-selected-dialog-content>\r\n    </div>\r\n</dialog>\r\n"

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpressSelectedDialogContentController = function () {
    function ExpressSelectedDialogContentController(settings, expressService) {
        _classCallCheck(this, ExpressSelectedDialogContentController);

        this.settings = settings;
        this.expressService = expressService;
    }

    _createClass(ExpressSelectedDialogContentController, [{
        key: '$onInit',
        value: function $onInit() {
            this.dialogCtrl.show();
            this.expressService.setHideExpressDialogInStorage();
            this.isETAEnabled = this.settings.expressLandingPage.expressETAEnabled;
        }
    }]);

    return ExpressSelectedDialogContentController;
}();

ExpressSelectedDialogContentController.$inject = ['Settings', 'ExpressService'];

var expressSelectedDialogContentControllerComponentDefinition = {
    template: __webpack_require__(328).trim(),
    require: { dialogCtrl: '^dialog' },
    controller: ExpressSelectedDialogContentController
};

module.exports = {
    ExpressSelectedDialogContentController: ExpressSelectedDialogContentController,
    expressSelectedDialogContentControllerComponentDefinition: expressSelectedDialogContentControllerComponentDefinition
};

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = "<div class=\"expressSelectedDialogContent\">\r\n    <img ng-src=\"{{ ::$ctrl.settings.expressLandingPage.expressImagesPath + 'icon-express-delivery-tick.svg' }}\"\r\n        class=\"expressSelectedDialogContent-icon\"\r\n        alt=\"Delivery Now selected icon\" />\r\n    <h3 class=\"expressSelectedDialogContent-mainText\">\r\n        {{ $ctrl.settings.expressLandingPage.expressSuccessfullySelectedMessage }}\r\n    </h3>\r\n    <p class=\"expressSelectedDialogContent-subText\" ng-show=\"!$ctrl.isETAEnabled\">\r\n        {{ $ctrl.settings.expressLandingPage.expressSuccessfullySelectedSubMessage }}\r\n    </p>\r\n    <p class=\"expressSelectedDialogContent-subText\" ng-show=\"$ctrl.isETAEnabled\">\r\n        <span wow-html-setting setting-group=\"expressLandingPage\" setting-name=\"expressETASuccessfullySelectedSubMessage\"></span>\r\n    </p>\r\n</div>\r\n"

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var RecommendationProductsService = __webpack_require__(330);

var _require = __webpack_require__(331),
    recommendationProductsControllerComponentDefinition = _require.recommendationProductsControllerComponentDefinition;

angular.module('wowApp.shop').component('wowRecommendationProducts', recommendationProductsControllerComponentDefinition).service('RecommendationProductsService', ['Restangular', RecommendationProductsService]);

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecommendationProductsService = function () {
    function RecommendationProductsService(restangular) {
        _classCallCheck(this, RecommendationProductsService);

        this._api = restangular.one('/Recommendation');
    }

    _createClass(RecommendationProductsService, [{
        key: 'getRecommendationPlacements',
        value: function getRecommendationPlacements(shouldBeSpecial, isInSmallFormat, message) {

            return this._api.get({
                isSpecial: shouldBeSpecial,
                isMobile: isInSmallFormat,
                recommendationMessage: message
            });
        }
    }]);

    return RecommendationProductsService;
}();

module.exports = RecommendationProductsService;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecommendationProductsController = function () {
    function RecommendationProductsController(breakpointsService, recommendationProductsService) {
        _classCallCheck(this, RecommendationProductsController);

        this.breakpointsService = breakpointsService;
        this.recommendationProductsService = recommendationProductsService;
    }

    _createClass(RecommendationProductsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.getPlacements();
        }
    }, {
        key: 'getPlacements',
        value: function getPlacements() {
            var _this = this;

            var isInSmallFormat = this.breakpointsService.isInSmallFormat;
            var carouselSignedInMessage = this.message ? this.message : '';

            this.recommendationProductsService.getRecommendationPlacements(false, isInSmallFormat, carouselSignedInMessage).then(function (placement) {
                _this.placement = {
                    message: placement.message,
                    Products: placement.Products,
                    placement_name: placement.placement_name
                };
            });
        }
    }]);

    return RecommendationProductsController;
}();

RecommendationProductsController.$inject = ['BreakpointsService', 'RecommendationProductsService'];

var recommendationProductsControllerComponentDefinition = {
    bindings: {
        message: '@?'
    },
    controller: RecommendationProductsController,
    template: __webpack_require__(332).trim()
};

module.exports = {
    RecommendationProductsController: RecommendationProductsController,
    recommendationProductsControllerComponentDefinition: recommendationProductsControllerComponentDefinition
};

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = "<div class=\"recommendationProducts\">\r\n    <wow-rr-carousel ng-if=\"$ctrl.placement\" rr-placement=\"$ctrl.placement\" dynamic-placement-id=\"$ctrl.placement.placement_name\"></wow-rr-carousel>\r\n</div>\r\n"

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(334),
    RatingService = _require.RatingService;

var _require2 = __webpack_require__(335),
    starComponentDefinition = _require2.starComponentDefinition;

var _require3 = __webpack_require__(337),
    ratingComponentDefinition = _require3.ratingComponentDefinition;

var _require4 = __webpack_require__(339),
    ratingDetailComponentDefinition = _require4.ratingDetailComponentDefinition;

var _require5 = __webpack_require__(341),
    ratingBarComponentDefinition = _require5.ratingBarComponentDefinition;

angular.module('wowApp.shop').service('RatingService', RatingService).component('wowStar', starComponentDefinition).component('wowRating', ratingComponentDefinition).component('wowRatingDetail', ratingDetailComponentDefinition).component('wowRatingBar', ratingBarComponentDefinition);

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    times = _require.times;

var $ = __webpack_require__(2);

var RatingService = function () {
    function RatingService(settings, $window, $timeout, moveFocus) {
        _classCallCheck(this, RatingService);

        this.settings = settings;
        this.$window = $window;
        this.$timeout = $timeout;
        this.moveFocus = moveFocus;
    }

    _createClass(RatingService, [{
        key: 'populateStars',
        value: function populateStars(averageRating) {
            var maxRating = this.settings.ratingreview.maxRating;
            if (!maxRating || averageRating > maxRating) return [];

            return times(maxRating, function (key) {
                var currentStar = key + 1;
                if (averageRating >= currentStar) {
                    return { filled: true };
                }
                if (Math.ceil(averageRating) < currentStar) {
                    return { empty: true };
                }
                return averageRating - parseInt(averageRating) >= 0.5 ? { half: true } : { empty: true };
            });
        }
    }, {
        key: 'scrollToTargetAndFocus',
        value: function scrollToTargetAndFocus() {
            var _this = this;

            var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '._ratingReviewSummary';

            var preScrollHeight = this.$window.pageYOffset;
            this.moveFocus(target);
            this.$timeout(function () {
                var ratingReviewSection = $(target)[0];
                if (ratingReviewSection) {
                    ratingReviewSection.scrollIntoView();
                    _this.$timeout(function () {
                        var postScrollHeight = _this.$window.pageYOffset;
                        var isCategoryMenuVisible = $('.categoryHeader.is-scrolled-down')[0] || $('.categoryHeader.is-default')[0];
                        var categoryMenuHeight = 40,
                            mainNavHeight = 70;

                        if (preScrollHeight >= postScrollHeight || isCategoryMenuVisible) {
                            _this.$window.scrollBy(0, -categoryMenuHeight - mainNavHeight);
                        } else {
                            _this.$window.scrollBy(0, -mainNavHeight);
                        }
                    }, 250); // A 250ms timeout is needed to ensure any animations finish
                }
            });
        }
    }]);

    return RatingService;
}();

RatingService.$inject = ['Settings', '$window', '$timeout', 'MoveFocus'];

module.exports = { RatingService: RatingService };

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StarController = function StarController() {
    _classCallCheck(this, StarController);
};

var starComponentDefinition = {
    controller: StarController,
    template: __webpack_require__(336).trim(),
    bindings: {
        star: '<'
    }
};

module.exports = {
    StarController: StarController,
    starComponentDefinition: starComponentDefinition
};

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = "<div class=\"star\">\r\n    <svg class=\"star-img\"\r\n        viewBox=\"-1 -1 35 35\"\r\n        ng-class=\"{ 'is-filled': $ctrl.star.filled, 'is-half': $ctrl.star.half, 'is-empty': $ctrl.star.empty }\">\r\n        <defs>\r\n            <linearGradient id=\"_halfStar\">\r\n                <stop offset=\"50%\" stop-color=\"rgba(229,195,0,1)\"/>\r\n                <stop offset=\"50%\" stop-color=\"transparent\" stop-opacity=\"1\" />\r\n            </linearGradient>\r\n        </defs>\r\n        <path d=\"M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118 l11.547-1.2L16.026,0.6L20.388,10.918z\"/>\r\n    </svg>\r\n</div>\r\n"

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    round = _require.round;

var RatingController = function () {
    function RatingController(ratingService, analyticsService) {
        _classCallCheck(this, RatingController);

        this.ratingService = ratingService;
        this.analyticsService = analyticsService;
    }

    _createClass(RatingController, [{
        key: '$onInit',
        value: function $onInit() {
            this.average = round(this.rating.Average, 1).toFixed(1);
            this.stars = this.ratingService.populateStars(this.average);
        }
    }, {
        key: 'onRatingClickEvent',
        value: function onRatingClickEvent() {
            this.onRatingClick();
        }
    }]);

    return RatingController;
}();

RatingController.$inject = ['RatingService', 'AnalyticsService'];

var ratingComponentDefinition = {
    controller: RatingController,
    template: __webpack_require__(338).trim(),
    bindings: {
        rating: '<',
        shouldShowTotal: '<?',
        onRatingClick: '&'
    }
};

module.exports = {
    RatingController: RatingController,
    ratingComponentDefinition: ratingComponentDefinition
};

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = "<div class=\"rating\">\r\n    <div class=\"rating-starContainer\">\r\n        <span class=\"sr-only\">Average product rating is {{ ::$ctrl.average }} out of 5.</span>\r\n        <span aria-hidden=\"true\" class=\"rating-average\">{{ ::$ctrl.average }}</span>\r\n        <wow-star ng-repeat=\"star in $ctrl.stars track by $index\" star=\"star\"></wow-star>\r\n    </div>\r\n    <div class=\"rating-totalContainer\">\r\n        <button\r\n            class=\"rating-total linkButton\"\r\n            ng-if=\"$ctrl.shouldShowTotal\"\r\n            ng-click=\"$ctrl.ratingService.scrollToTargetAndFocus();$ctrl.onRatingClickEvent()\">\r\n            <span class=\"sr-only\">\r\n                This button leads to the rating and reviews section lower down the page. Product score is based on {{ ::$ctrl.rating.RatingCount }} ratings\r\n            </span>\r\n            <span aria-hidden=\"true\">{{ ::$ctrl.rating.RatingCount }} Ratings</span>\r\n        </button>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RatingDetailController = function () {
    function RatingDetailController($stateParams, $window, $timeout, shopPageStateService) {
        _classCallCheck(this, RatingDetailController);

        this.$stateParams = $stateParams;
        this.$window = $window;
        this.$timeout = $timeout;
        this.shopPageStateService = shopPageStateService;
    }

    _createClass(RatingDetailController, [{
        key: '$onInit',
        value: function $onInit() {
            this.starData = [{ star: 5, count: this.rating.FiveStarCount, percentage: this.rating.FiveStarPercentage }, { star: 4, count: this.rating.FourStarCount, percentage: this.rating.FourStarPercentage }, { star: 3, count: this.rating.ThreeStarCount, percentage: this.rating.ThreeStarPercentage }, { star: 2, count: this.rating.TwoStarCount, percentage: this.rating.TwoStarPercentage }, { star: 1, count: this.rating.OneStarCount, percentage: this.rating.OneStarPercentage }];
        }
    }]);

    return RatingDetailController;
}();

RatingDetailController.$inject = ['$stateParams', '$window', '$timeout', 'ShopPageStateService'];

var ratingDetailComponentDefinition = {
    controller: RatingDetailController,
    template: __webpack_require__(340).trim(),
    bindings: {
        rating: '<'
    }
};

module.exports = {
    RatingDetailController: RatingDetailController,
    ratingDetailComponentDefinition: ratingDetailComponentDefinition
};

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ratingDetail\" itemprop=\"aggregateRating\" itemscope itemtype=\"http://schema.org/AggregateRating\">\r\n    <h2>Ratings and Reviews</h2>\r\n    <h3>Ratings ({{::$ctrl.rating.RatingCount}})</h3>\r\n    <meta itemprop=\"ratingValue\" content=\"{{::$ctrl.rating.Average}}\">\r\n    <meta itemprop=\"reviewCount\" content=\"{{::$ctrl.rating.ReviewCount}}\">\r\n    <wow-rating rating=\"::$ctrl.rating\" should-show-total=\"false\"></wow-rating>\r\n    <wow-rating-bar ng-repeat=\"data in $ctrl.starData track by data.star\" star-data=\"data\"></wow-rating-bar>\r\n</div>\r\n"

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RatingBarController = function () {
    function RatingBarController() {
        _classCallCheck(this, RatingBarController);
    }

    _createClass(RatingBarController, [{
        key: '$onInit',
        value: function $onInit() {
            this.ratingCountText = this.starData.count || '-';
        }
    }]);

    return RatingBarController;
}();

var ratingBarComponentDefinition = {
    controller: RatingBarController,
    template: __webpack_require__(342).trim(),
    bindings: {
        starData: '<'
    }
};

module.exports = {
    RatingBarController: RatingBarController,
    ratingBarComponentDefinition: ratingBarComponentDefinition
};

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ratingBar\">\r\n    <span class=\"sr-only\">There are {{::$ctrl.starData.count}} {{$ctrl.starData.star}} star ratings.</span>\r\n    <span aria-hidden=\"true\">{{$ctrl.starData.star}}</span>\r\n    <svg class=\"ratingBar-star\" viewBox=\"3 0 30 30\"><path d=\"M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118 l11.547-1.2L16.026,0.6L20.388,10.918z\"/></svg>\r\n    <svg class=\"ratingBar-bar\">\r\n        <defs>\r\n            <mask id=\"_starMask{{$ctrl.starData.star}}\" x=\"0\" y=\"0\">\r\n                <rect x=\"0\" y=\"0\" ng-attr-width=\"{{$ctrl.starData.percentage}}%\" height=\"8\"/>\r\n            </mask>\r\n        </defs>\r\n        <rect class=\"ratingBar-rectangle\" x=\"0\" y=\"0\" width=\"100%\" height=\"8\" rx=\"3\"/>\r\n        <rect x=\"0\" y=\"0\" width=\"100%\" height=\"8\" rx=\"3\" mask=\"url(#_starMask{{$ctrl.starData.star}})\"/>\r\n    </svg>\r\n    <span class=\"ratingBar-count\">\r\n        <span aria-hidden=\"true\">{{::$ctrl.starData.count}}</span>\r\n    </span>\r\n</div>\r\n"

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(344),
    ReviewService = _require.ReviewService;

var _require2 = __webpack_require__(345),
    reviewListComponentDefinition = _require2.reviewListComponentDefinition;

var _require3 = __webpack_require__(347),
    reviewComponentDefinition = _require3.reviewComponentDefinition;

angular.module('wowApp.shop').service('ReviewService', ReviewService).component('wowReviewList', reviewListComponentDefinition).component('wowReview', reviewComponentDefinition);

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isEmpty = _require.isEmpty,
    trim = _require.trim,
    replace = _require.replace,
    find = _require.find,
    toLower = _require.toLower,
    map = _require.map;

var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'September', 'August', 'October', 'November', 'December'];

var ReviewService = function () {
    function ReviewService(restangular) {
        _classCallCheck(this, ReviewService);

        this._api = restangular.one('Product/Review');
    }

    _createClass(ReviewService, [{
        key: 'getOrdinalSuffix',
        value: function getOrdinalSuffix(date) {
            var dayOfMonth = date.getDate();
            var dayNumber = dayOfMonth % 10;

            if (dayNumber === 1 && dayOfMonth !== 11) {
                return dayOfMonth + 'st';
            }
            if (dayNumber === 2 && dayOfMonth !== 12) {
                return dayOfMonth + 'nd';
            }
            if (dayNumber === 3 && dayOfMonth !== 13) {
                return dayOfMonth + 'rd';
            }

            return dayOfMonth + 'th';
        }
    }, {
        key: 'getScreenReaderDate',
        value: function getScreenReaderDate(date) {
            date = new Date(date);
            return 'the ' + this.getOrdinalSuffix(date) + ' of ' + months[date.getMonth()] + ', ' + date.getFullYear();
        }
    }, {
        key: 'getFirstCharacter',
        value: function getFirstCharacter(name) {
            return !isEmpty(name) ? name[0] : '';
        }
    }, {
        key: 'getHtmlContent',
        value: function getHtmlContent(body) {
            if (isEmpty(trim(body))) return '';
            return replace(body, /<[^>]+>/g, '');
        }
    }, {
        key: 'getReviewSource',
        value: function getReviewSource(reviewSource, source) {
            if (!reviewSource || !source) return '';
            var sourceText = find(reviewSource, { key: trim(toLower(source)) });
            return sourceText.value || '';
        }
    }, {
        key: 'mapItems',
        value: function mapItems(reviews) {
            var _this = this;

            return map(reviews, function (r) {
                return {
                    Body: r.Body,
                    ScreenReaderCreatedDate: _this.getScreenReaderDate(r.CreatedDate),
                    IsoCreatedDate: new Date(r.CreatedDate).toISOString().slice(0, 10),
                    CreatedDate: new Date(r.CreatedDate).toLocaleDateString('en-AU'),
                    Member: r.Member,
                    Rating: r.Rating,
                    Source: r.Source
                };
            });
        }
    }, {
        key: 'getReviews',
        value: function getReviews(stockcode, pageNumber, pageSize, sortType) {
            var _this2 = this;

            return this._api.get({
                stockcode: stockcode,
                pageNumber: pageNumber,
                pageSize: pageSize,
                sortType: sortType
            }).then(function (response) {
                return {
                    items: _this2.mapItems(response.Reviews),
                    totalRecordCount: response.TotalCount
                };
            });
        }
    }]);

    return ReviewService;
}();

ReviewService.$inject = ['Restangular'];

module.exports = { ReviewService: ReviewService };

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    trim = _require.trim,
    find = _require.find,
    toLower = _require.toLower,
    map = _require.map;

var ReviewListController = function () {
    function ReviewListController(settings) {
        _classCallCheck(this, ReviewListController);

        this.settings = settings;
    }

    _createClass(ReviewListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.reviewSource = map(this.settings.ratingreview.reviewSource, function (source) {
                return {
                    key: trim(toLower(source[0])),
                    value: source[1]
                };
            });
            this.pageSize = this.settings.ratingreview && this.settings.ratingreview.pageSize ? this.settings.ratingreview.pageSize : null;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if ((changes.sortBy || changes.sortOptions) && this.sortOptions != null) {
                this.sortType = this.getSortType();
            }
            if (changes.totalRecordCount && this.pageSize) {
                this.numberOfPages = Math.ceil(this.totalRecordCount / this.pageSize) || 1;
            }
        }
    }, {
        key: 'getSortType',
        value: function getSortType() {
            return find(this.sortOptions.sortTypes, { Value: this.sortBy }) || this.sortOptions.sortTypes[0];
        }
    }, {
        key: 'onSortByChangedEvent',
        value: function onSortByChangedEvent(option) {
            var _this = this;

            this.sortBy = option.Value;
            this.pageNumber = 1;
            this.onSortByChanged({ value: option.Value, text: option.Text }).then(function (items) {
                _this.items = items;
            });
        }
    }, {
        key: 'onPageSelectedEvent',
        value: function onPageSelectedEvent(pageNumber) {
            var _this2 = this;

            this.pageNumber = pageNumber;
            this.onPageSelected({ value: pageNumber }).then(function (items) {
                _this2.items = items;
            });
        }
    }]);

    return ReviewListController;
}();

ReviewListController.$inject = ['Settings'];

var reviewListComponentDefinition = {
    controller: ReviewListController,
    template: __webpack_require__(346).trim(),
    bindings: {
        pageNumber: '<',
        sortBy: '<',
        sortOptions: '<',
        items: '<',
        totalRecordCount: '<',
        error: '<?',
        isLoading: '<?',
        onSortByChanged: '&',
        onPageSelected: '&',
        setSpinnerFocused: '&'
    }
};

module.exports = {
    ReviewListController: ReviewListController,
    reviewListComponentDefinition: reviewListComponentDefinition
};

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = "<div class=\"reviewList\"\r\n    ng-class=\"{'has-noPaging':\r\n                $ctrl.settings.ratingreview &&\r\n                $ctrl.settings.ratingreview.pageSize &&\r\n                $ctrl.totalRecordCount <= $ctrl.settings.ratingreview.pageSize}\">\r\n    <h3 aria-hidden=\"true\">Reviews ({{$ctrl.totalRecordCount || 0}})</h3>\r\n    <h3 class=\"sr-only\"> {{$ctrl.totalRecordCount || 0}} reviews available, viewing page {{$ctrl.pageNumber || 1}} out of {{$ctrl.numberOfPages}}.</h3>\r\n    <div class=\"reviewList-sortBy\" ng-if=\"::$ctrl.sortOptions\">\r\n        <span class=\"reviewList-sortByLabel\">Sort by:</span>\r\n        <oly-inline-dropdown\r\n            label-key=\"Text\"\r\n            ng-model=\"$ctrl.sortType\"\r\n            options=\"$ctrl.sortOptions.sortTypes\"\r\n            on-change=\"$ctrl.onSortByChangedEvent(option)\">\r\n        </oly-inline-dropdown>\r\n    </div>\r\n    <div class=\"reviewList-spinner\"\r\n        ng-if=\"$ctrl.isLoading\"\r\n        tabindex=\"0\"\r\n        ng-focus=\"$ctrl.setSpinnerFocused({value: true})\"\r\n        ng-blur=\"$ctrl.setSpinnerFocused({value: false})\">\r\n            <wow-loading-spinner\r\n                message=\"Loading reviews, please wait\"\r\n                is-message-sr-only=\"true\">\r\n            </wow-loading-spinner>\r\n    </div>\r\n    <wow-review\r\n        ng-if=\"!$ctrl.error && !$ctrl.isLoading\"\r\n        ng-repeat=\"review in $ctrl.items track by $index\"\r\n        is-first-review=\"$index == 0\"\r\n        data=\"review\"\r\n        review-source=\"$ctrl.reviewSource\">\r\n    </wow-review>\r\n    <oly-paging\r\n        ng-if=\"$ctrl.totalRecordCount &&\r\n               $ctrl.pageNumber &&\r\n               $ctrl.settings.ratingreview &&\r\n               $ctrl.settings.ratingreview.pageSize &&\r\n               $ctrl.totalRecordCount > $ctrl.settings.ratingreview.pageSize &&\r\n               !$ctrl.error &&\r\n               !$ctrl.isLoading\"\r\n        page-size=\"$ctrl.settings.ratingreview.pageSize\"\r\n        total-count=\"$ctrl.totalRecordCount\"\r\n        current-page=\"$ctrl.pageNumber\"\r\n        on-page-select=\"$ctrl.onPageSelectedEvent(pageNumber)\">\r\n    </oly-paging>\r\n    <div class=\"reviewList-errorMessage\"\r\n        ng-if=\"$ctrl.error\"\r\n        wow-html-setting\r\n        setting-group=\"ratingreview\"\r\n        setting-name=\"errorReviewMessage\">\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReviewController = function () {
    function ReviewController(ratingService, reviewService, settings) {
        _classCallCheck(this, ReviewController);

        this.ratingService = ratingService;
        this.reviewService = reviewService;
        this.settings = settings;
    }

    _createClass(ReviewController, [{
        key: '$onInit',
        value: function $onInit() {
            this.stars = this.data.Rating ? this.ratingService.populateStars(this.data.Rating) : [];
            this.reviewBody = this.reviewService.getHtmlContent(this.data.Body);
            this.source = this.reviewService.getReviewSource(this.reviewSource, this.data.Source);

            this.screenReaderRatingText = this.data.Rating + ' out of ' + this.settings.ratingreview.maxRating + ' stars.';

            this.screenReaderSummaryText = 'Review submitted by ' + this.data.Member + ' on\n                                        ' + this.data.ScreenReaderCreatedDate + '.\n                                        ' + this.screenReaderRatingText + '.\n                                        ' + this.source + '.\n                                        ' + this.reviewBody + '.';
        }
    }]);

    return ReviewController;
}();

ReviewController.$inject = ['RatingService', 'ReviewService', 'Settings'];

var reviewComponentDefinition = {
    controller: ReviewController,
    template: __webpack_require__(348).trim(),
    bindings: {
        data: '<',
        reviewSourceLinks: '<',
        reviewSource: '<',
        isFirstReview: '<'
    }
};

module.exports = {
    ReviewController: ReviewController,
    reviewComponentDefinition: reviewComponentDefinition
};

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"{'is-firstReview' : $ctrl.isFirstReview}\" class=\"review\" itemprop=\"review\" itemscope itemtype=\"http://schema.org/Review\">\r\n    <span aria-hidden=\"true\" class=\"review-column review-column--left\">\r\n        <div class=\"review-img\">\r\n            <span class=\"review-firstCharacter\">{{::$ctrl.reviewService.getFirstCharacter($ctrl.data.Member)}}</span>\r\n        </div>\r\n    </span>\r\n    <span class=\"review-column review-column--right\">\r\n        <div class=\"review-stars\" itemprop=\"reviewRating\" itemscope itemtype=\"http://schema.org/Rating\">\r\n            <meta itemprop=\"worstRating\" content=\"1\">\r\n            <meta itemprop=\"ratingValue\" content=\"{{::$ctrl.data.Rating}}\">\r\n            <meta itemprop=\"bestRating\" content=\"5\">\r\n            <wow-star aria-hidden=\"true\" ng-repeat=\"star in $ctrl.stars track by $index\" star=\"star\"></wow-star>\r\n        </div>\r\n        <span class=\"sr-only\">The following review was submitted by: {{::$ctrl.data.Member}} who gave this product {{::$ctrl.screenReaderRatingText}}</span>\r\n        <h4 class=\"review-displayName\" itemprop=\"author\" content=\"{{::$ctrl.data.Member}}\" aria-hidden=\"true\">{{::$ctrl.data.Member}}</h4>\r\n        <oly-view-more\r\n            class=\"review-body\"\r\n            char-count=\"$ctrl.settings.ratingreview.reviewCharCountBeforeViewMoreCutoff\"\r\n            full-text=\"$ctrl.reviewService.getHtmlContent($ctrl.data.Body)\"\r\n            custom-expando-class=\"review-expando\"\r\n            itemprop=\"description\"\r\n            content=\"{{$ctrl.data.Body}}\">>\r\n        </oly-view-more>\r\n        <span class=\"review-dateSourceBlock\">\r\n            <span itemprop=\"datePublished\" content=\"{{::$ctrl.data.IsoCreatedDate}}\" aria-hidden=\"true\">{{::$ctrl.data.CreatedDate}}</span>\r\n            <span class=\"sr-only\">{{$ctrl.data.ScreenReaderCreatedDate}}</span>\r\n            <span aria-hidden=\"true\">\r\n                &ensp;&#8226;&ensp;\r\n            </span>\r\n            {{::$ctrl.reviewService.getReviewSource($ctrl.reviewSource, $ctrl.data.Source)}}\r\n        </span>\r\n    </span>\r\n</div>\r\n"

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(350),
    onBoardingComponentDefinition = _require.onBoardingComponentDefinition;

var _require2 = __webpack_require__(352),
    onBoardingContentComponentDefinition = _require2.onBoardingContentComponentDefinition;

angular.module('wowApp.shop').component('wowOnBoardingDialog', onBoardingComponentDefinition).component('wowOnBoardingContentDialog', onBoardingContentComponentDefinition);

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TealiumEventBuilder = __webpack_require__(9);

var OnBoardingController = function () {
    function OnBoardingController(dialogRegistry, settings, analyticsService, userPreferenceService) {
        _classCallCheck(this, OnBoardingController);

        this.dialogRegistry = dialogRegistry;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.userPreferenceService = userPreferenceService;
        this.screenName = 'On Boarding';
    }

    _createClass(OnBoardingController, [{
        key: '$onInit',
        value: function $onInit() {
            var builder = new TealiumEventBuilder().withScreenName(this.screenName).withEventType(this.analyticsService.mapperTypes.shop.onBoardingDialog).withTrackingType('link').build();
            this.analyticsService.push(builder);

            this.subscribeEscPushAnalytics();
        }
    }, {
        key: 'dismissOnBoarding',
        value: function dismissOnBoarding() {
            // push to tealium
            var builder = new TealiumEventBuilder().withScreenName(this.screenName).withLabel('Button/link click').withValue('Next').withEventType(this.analyticsService.mapperTypes.shop.onBoardingDialog).withEventName('modal_interaction').withTrackingType('link').build();
            this.analyticsService.push(builder);

            this.userPreferenceService.setOnboardingPreference(true);

            if (this.onDismiss) {
                this.onDismiss();
            }

            var dialog = this.dialogRegistry.getDialog('onBoarding dialog');
            if (dialog) {
                dialog.close();
            }
        }
    }, {
        key: 'subscribeEscPushAnalytics',
        value: function subscribeEscPushAnalytics() {
            var _this = this;

            this.unsubscribeEsc();

            $(document).on('keyup', function (evt) {
                if (evt.keyCode === 27) {
                    // push to tealium
                    _this.analyticsService.push(new TealiumEventBuilder().withScreenName(_this.screenName).withLabel('ESC Button').withEventName('modal_interaction').withEventType(_this.analyticsService.mapperTypes.shop.onBoardingDialog).build());
                }
            });
            this.currentlySubscribedToEsc = this.screenName;
        }
    }, {
        key: 'unsubscribeEsc',
        value: function unsubscribeEsc() {
            if (this.currentlySubscribedToEsc === this.screenName) $(document).off('keyup');
        }
    }]);

    return OnBoardingController;
}();

var onBoardingComponentDefinition = {
    bindings: {
        onDismiss: '&'
    },
    controller: ['DialogRegistry', 'Settings', 'AnalyticsService', 'UserPreferenceService', OnBoardingController],
    template: __webpack_require__(351).trim()
};

module.exports = {
    OnBoardingController: OnBoardingController,
    onBoardingComponentDefinition: onBoardingComponentDefinition
};

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports = "<dialog name=\"onBoarding dialog\" id=\"_onBoardingDialog\" on-dismiss=\"closeDialog()\" class=\"olyDialog onBoardingDialog\">\r\n    <wow-on-boarding-content-dialog></wow-on-boarding-content-dialog>\r\n    <div class=\"olyDialog-buttons ng-scope onBoardingDialog-buttonContainer\">\r\n        <button ng-click=\"$ctrl.dismissOnBoarding()\" class=\"button button--primary olyDialog-buttonsConfirm ng-isolate-scope onBoardingDialog-button\">\r\n            NEXT<span class=\"sr-only\">, dismiss onboarding screen</span><i class=\"iconww-ArrowRight onBoardingDialog-arrow\"></i>\r\n        </button>\r\n    </div>\r\n</dialog>\r\n"

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OnBoardingContentController = function () {
    function OnBoardingContentController(settings, analyticsService) {
        _classCallCheck(this, OnBoardingContentController);

        this.settings = settings;
        this.analyticsService = analyticsService;
    }

    _createClass(OnBoardingContentController, [{
        key: '$onInit',
        value: function $onInit() {
            this.bannerUrl = this.settings.onBoarding.bannerImageUrl;
            this.content = this.settings.onBoarding.content;
            this.dialogCtrl.show();
        }
    }]);

    return OnBoardingContentController;
}();

var onBoardingContentComponentDefinition = {
    controller: ['Settings', 'AnalyticsService', OnBoardingContentController],
    require: { dialogCtrl: '^dialog' },
    template: __webpack_require__(353).trim()
};

module.exports = {
    OnBoardingContentController: OnBoardingContentController,
    onBoardingContentComponentDefinition: onBoardingContentComponentDefinition
};

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = "<div class=\"onBoardingDialog-bannerContainer\">\r\n    <!-- title message -->\r\n    <img class=\"onBoardingDialog-banner\" ng-src=\"{{$ctrl.bannerUrl}}\" />\r\n</div>\r\n<div class=\"onBoardingDialog-content\" ng-bind-html=\"$ctrl.content | sanitize\">\r\n</div>\r\n"

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(355),
    notificationMessageComponentDefinition = _require.notificationMessageComponentDefinition;

angular.module('wowApp.shop').component('wowNotificationMessage', notificationMessageComponentDefinition);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var angular = __webpack_require__(1);

var NotificationMessageController = function () {
    function NotificationMessageController($timeout, analyticsService, $sce, $scope) {
        _classCallCheck(this, NotificationMessageController);

        this.$scope = $scope;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.analyticsService = analyticsService;
    }

    _createClass(NotificationMessageController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.$sce = this.$sce;
            var visibility = this.isVisible !== undefined ? this.isVisible : true;
            this.isVisible = false;
            this.containerClasses = this.containerClasses !== undefined ? this.containerClasses : '';
            this.isDismissible = this.isDismissible !== undefined ? this.isDismissible : true;
            this.linkTitle = this.linkTitle !== undefined ? this.linkTitle : this.link;
            this.$timeout(function () {
                _this.isVisible = visibility;
            }, 1);
        }
    }, {
        key: 'dismissClicked',
        value: function dismissClicked() {
            var _this2 = this;

            this.isVisible = false;
            if (angular.isFunction(this.onDismiss)) {
                this.$timeout(function () {
                    return _this2.onDismiss();
                });
            }
        }
    }, {
        key: 'messageClicked',
        value: function messageClicked(event) {
            if (angular.isFunction(this.onMessageClicked)) {
                this.onMessageClicked({ event: event });
            }
        }
    }]);

    return NotificationMessageController;
}();

NotificationMessageController.$inject = ['$timeout', 'AnalyticsService', '$sce', '$scope'];

var notificationMessageComponentDefinition = {
    controller: NotificationMessageController,
    bindings: {
        type: '@', // Type of notification (string. error/info)
        isVisible: '=?', // Get or set the current visibility of the notification - will trigger animations. (bool)
        title: '@?', // Optional title for the notification. (string)
        message: '@', // Message to the user regarding the notification (string - trusted HTML).
        isDismissible: '<?', // Show the close button to dismiss the notification, defaults to true. (bool)
        onDismiss: '&?', // Triggered if the user dismisses the notification. (Func)
        containerClasses: '@?',
        onMessageClicked: '&?' // click event when message body clicked
    },
    template: __webpack_require__(356).trim()
};

module.exports = {
    NotificationMessageController: NotificationMessageController,
    notificationMessageComponentDefinition: notificationMessageComponentDefinition
};

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports = "<div class=\"notificationMessage-container animate-show-hide\" ng-class=\"$ctrl.containerClasses\" ng-show=\"$ctrl.isVisible\" role=\"alert\">\r\n    <div class=\"notificationMessage-innerContainer notificationMessage-innerContainer--{{$ctrl.type}}\">\r\n        <div class=\"notificationMessage-iconContainer\">\r\n            <div class=\"notificationMessage-icon notificationMessage-icon--{{$ctrl.type}}\" alt=\"{{$ctrl.type}} icon\"></div>\r\n        </div>\r\n        <div class=\"notificationMessage-content\">\r\n            <strong class=\"notificationMessage-title\" ng-if=\"$ctrl.title\">{{$ctrl.title}}</strong>\r\n            <p class=\"notificationMessage-message\" ng-if=\"$ctrl.message\" ng-bind-html=\"$sce.trustAsHtml($ctrl.message)\" ng-click=\"$ctrl.messageClicked($event)\"></p>\r\n            <button class=\"notificationMessage-close\" ng-if=\"$ctrl.isDismissible\" ng-click=\"$ctrl.dismissClicked()\" aria-label=\"Dismiss this notification\" type=\"button\"></button>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);
var uiRouter = __webpack_require__(6);

var olyCommonModule = __webpack_require__(3);
var wowCommonModule = __webpack_require__(5);
var analyticsModule = __webpack_require__(8);
var digitalPayModule = __webpack_require__(358);

var DeliverySaverConstants = __webpack_require__(359);

var _require = __webpack_require__(360),
    DeliverySaverComingSoonComponentDefinition = _require.DeliverySaverComingSoonComponentDefinition;

var _require2 = __webpack_require__(362),
    DeliverySaverPlanSelectionComponentDefinition = _require2.DeliverySaverPlanSelectionComponentDefinition;

var _require3 = __webpack_require__(364),
    DeliverySaverPlanGroupComponentDefinition = _require3.DeliverySaverPlanGroupComponentDefinition;

var _require4 = __webpack_require__(366),
    DeliverySaverPlanComponentDefinition = _require4.DeliverySaverPlanComponentDefinition;

var _require5 = __webpack_require__(368),
    DeliverySaverPlanDetailComponentDefinition = _require5.DeliverySaverPlanDetailComponentDefinition;

var _require6 = __webpack_require__(370),
    DeliverySaverSubscriptionDetailComponentDefinition = _require6.DeliverySaverSubscriptionDetailComponentDefinition;

var _require7 = __webpack_require__(372),
    DeliverySaverPlanTagComponentDefinition = _require7.DeliverySaverPlanTagComponentDefinition;

var _require8 = __webpack_require__(374),
    DeliverySaverPaymentSetupComponentDefinition = _require8.DeliverySaverPaymentSetupComponentDefinition;

var _require9 = __webpack_require__(376),
    DeliverySaverConfirmationComponentDefinition = _require9.DeliverySaverConfirmationComponentDefinition;

var _require10 = __webpack_require__(378),
    DeliverySaverPaymentUpdateComponentDefinition = _require10.DeliverySaverPaymentUpdateComponentDefinition;

var _require11 = __webpack_require__(380),
    DeliverySaverBillingAddressComponentDefinition = _require11.DeliverySaverBillingAddressComponentDefinition;

var _require12 = __webpack_require__(382),
    MyDeliverySaverComponentDefinition = _require12.MyDeliverySaverComponentDefinition;

var _require13 = __webpack_require__(384),
    MyDeliverySaverManagementComponentDefinition = _require13.MyDeliverySaverManagementComponentDefinition;

var _require14 = __webpack_require__(386),
    MyDeliverySaverPanelComponentDefinition = _require14.MyDeliverySaverPanelComponentDefinition;

var _require15 = __webpack_require__(388),
    MyDeliverySaverPaymentMethodComponentDefinition = _require15.MyDeliverySaverPaymentMethodComponentDefinition;

var _require16 = __webpack_require__(390),
    MyDeliverySaverPaymentsComponentDefinition = _require16.MyDeliverySaverPaymentsComponentDefinition;

var DeliverySaverBillingFrequency = __webpack_require__(392);
var DeliverySaverBillingFrequencyUnit = __webpack_require__(393);
var DeliverySaverPaymentAmountHeading = __webpack_require__(394);
var DeliverySaverShortName = __webpack_require__(36);
var DeliverySaverTypeName = __webpack_require__(395);
var DeliverySaverFullTypeName = __webpack_require__(396);

var _require17 = __webpack_require__(397),
    DeliverySaverService = _require17.DeliverySaverService;

var _require18 = __webpack_require__(398),
    MyDeliverySaverService = _require18.MyDeliverySaverService;

var _require19 = __webpack_require__(399),
    DeliverySaverAnalytics = _require19.DeliverySaverAnalytics;

var deliverySaverModuleName = 'wowApp.deliverysaver';

angular.module(deliverySaverModuleName, [olyCommonModule, wowCommonModule, analyticsModule, digitalPayModule, uiRouter]).constant('DeliverySaverConstants', DeliverySaverConstants).component('wowDeliverySaverComingSoon', DeliverySaverComingSoonComponentDefinition).component('wowDeliverySaverPlanTag', DeliverySaverPlanTagComponentDefinition).component('wowDeliverySaverPlanSelection', DeliverySaverPlanSelectionComponentDefinition).component('wowDeliverySaverPlanGroup', DeliverySaverPlanGroupComponentDefinition).component('wowDeliverySaverPlanDetail', DeliverySaverPlanDetailComponentDefinition).component('wowDeliverySaverSubscriptionDetail', DeliverySaverSubscriptionDetailComponentDefinition).component('wowDeliverySaverPlan', DeliverySaverPlanComponentDefinition).component('wowDeliverySaverPaymentSetup', DeliverySaverPaymentSetupComponentDefinition).component('wowDeliverySaverConfirmation', DeliverySaverConfirmationComponentDefinition).component('wowDeliverySaverPaymentUpdate', DeliverySaverPaymentUpdateComponentDefinition).component('wowDeliverySaverBillingAddress', DeliverySaverBillingAddressComponentDefinition).component('wowMyDeliverySaver', MyDeliverySaverComponentDefinition).component('wowMyDeliverySaverManagement', MyDeliverySaverManagementComponentDefinition).component('wowMyDeliverySaverPanel', MyDeliverySaverPanelComponentDefinition).component('wowMyDeliverySaverPaymentMethod', MyDeliverySaverPaymentMethodComponentDefinition).component('wowMyDeliverySaverPayments', MyDeliverySaverPaymentsComponentDefinition).filter('deliverySaverBillingFrequency', DeliverySaverBillingFrequency).filter('deliverySaverBillingFrequencyUnit', DeliverySaverBillingFrequencyUnit).filter('deliverySaverPaymentAmountHeading', DeliverySaverPaymentAmountHeading).filter('deliverySaverShortName', DeliverySaverShortName).filter('deliverySaverTypeName', DeliverySaverTypeName).filter('deliverySaverFullTypeName', DeliverySaverFullTypeName).service('DeliverySaverService', DeliverySaverService).service('MyDeliverySaverService', MyDeliverySaverService).service('DeliverySaverAnalytics', DeliverySaverAnalytics);

module.exports = deliverySaverModuleName;

/***/ }),
/* 358 */,
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    PANEL_EXPANDED_EMIT_EVENT: 'deliverySaver:panelExpanded',
    PANEL_EXPANDED_BROADCAST_EVENT: 'deliverySaver:panelExpandedBroadcast',
    PANEL_EXPAND: 'deliverySaver:expand',
    SUBSCRIPTION_STATUS: {
        ACTIVE: 'Active',
        SUSPENDED: 'Suspended',
        CANCELLED: 'Cancelled'
    }
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DeliverySaverComingSoonComponentDefinition = {
    template: __webpack_require__(361).trim()
};

module.exports = { DeliverySaverComingSoonComponentDefinition: DeliverySaverComingSoonComponentDefinition };

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = "<div class=\"deliverySaverComingSoon\">\r\n    <h1 class=\"deliverySaverComingSoon-title\"><wow-setting setting-group=\"DeliverySaver\" setting-name=\"ComingSoonTitle\"></wow-setting></h1>\r\n    <p class=\"deliverySaverComingSoon-text\"><wow-setting setting-group=\"DeliverySaver\" setting-name=\"ComingSoonText\"></wow-setting></p>\r\n    <a ui-sref=\"shop.myaccount.preferences\" class=\"button button--primary button--large\">\r\n        Update my account preferences&nbsp;<i class=\"iconww-ArrowRight\"></i>\r\n    </a>\r\n</div>\r\n"

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    filter = _require.filter,
    isEmpty = _require.isEmpty;

var DeliverySaverPlanSelectionController = function () {
    function DeliverySaverPlanSelectionController($q, $location, $state, settings, deliverySaverService, shopperService, deliverySaverAnalytics) {
        _classCallCheck(this, DeliverySaverPlanSelectionController);

        this.$q = $q;
        this.$location = $location;
        this.$state = $state;
        this.settings = settings;
        this.deliverySaverService = deliverySaverService;
        this.shopperService = shopperService;
        this.deliverySaverAnalytics = deliverySaverAnalytics;
    }

    _createClass(DeliverySaverPlanSelectionController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (!(this.settings.deliverySaver && this.settings.deliverySaver.isEnabled && this.settings.payment && this.settings.payment.enableDigitalPay)) {
                this.$state.go('shop.deliveryplus.comingsoon');
                return;
            }

            this.isLoading = true;
            this.selectedPlanId = -1;
            this.hasLoadPlansError = false;

            this.hasActiveDeliveryPass = false;
            this.hasActiveDeliverySaver = false;
            this.hasSuspendedDeliverySaver = false;
            this.isBusinessAccount = false;
            this.showBusinessPlans = false;
            this.isEligibleForDeliverySaver = true;

            this.anyDayConsumerPlans = [];
            this.midweekConsumerPlans = [];
            this.anyDayBusinessPlans = [];
            this.midweekBusinessPlans = [];

            this.$q.all([this.getEligibility(), this.getPlans()]).then(function () {
                _this.isLoading = false;
            });
        }
    }, {
        key: 'getPlans',
        value: function getPlans() {
            var _this2 = this;

            return this.deliverySaverService.listPlans().then(function (response) {
                _this2.anyDayConsumerPlans = filter(response.Plans, function (p) {
                    return p.IsAnyDay && !(p.Metadata && p.Metadata.IsBusinessToBusiness);
                });
                _this2.midweekConsumerPlans = filter(response.Plans, function (p) {
                    return p.IsMidweek && !(p.Metadata && p.Metadata.IsBusinessToBusiness);
                });
                _this2.anyDayBusinessPlans = filter(response.Plans, function (p) {
                    return p.IsAnyDay && p.Metadata && p.Metadata.IsBusinessToBusiness;
                });
                _this2.midweekBusinessPlans = filter(response.Plans, function (p) {
                    return p.IsMidweek && p.Metadata && p.Metadata.IsBusinessToBusiness;
                });
                if (response.Plans[0] && response.Plans[0].Metadata.SessionGroup) {
                    _this2.deliverySaverAnalytics.push({ sessionGroup: response.Plans[0].Metadata.SessionGroup });
                }
            }).catch(function () {
                _this2.hasLoadPlansError = true;
            });
        }
    }, {
        key: 'getEligibility',
        value: function getEligibility() {
            var _this3 = this;

            return this.deliverySaverService.getEligibility().then(function (response) {
                _this3.dateEligibleForDeliverySaver = response.DateEligibleForDeliverySaver;
                _this3.hasActiveDeliveryPass = response.HasActiveDeliveryPass;
                _this3.hasActiveDeliverySaver = response.HasActiveDeliverySaver;
                _this3.hasSuspendedDeliverySaver = response.HasSuspendedDeliverySaver;
                _this3.isBusinessAccount = response.IsBusinessAccount;
                _this3.showBusinessPlans = response.IsBusinessAccount;
                _this3.isEligibleForDeliverySaver = response.IsEligibleForDeliverySaver;
            });
        }
    }, {
        key: 'isPersonalAccount',
        value: function isPersonalAccount() {
            return !this.shopperService.IsGuest && !this.isBusinessAccount;
        }
    }, {
        key: 'hasPlans',
        value: function hasPlans() {
            return !this.showBusinessPlans && !(isEmpty(this.anyDayConsumerPlans) && isEmpty(this.midweekConsumerPlans)) || this.showBusinessPlans && !(isEmpty(this.anyDayBusinessPlans) && isEmpty(this.midweekBusinessPlans));
        }
    }]);

    return DeliverySaverPlanSelectionController;
}();

DeliverySaverPlanSelectionController.$inject = ['$q', '$location', '$state', 'Settings', 'DeliverySaverService', 'ShopperService', 'DeliverySaverAnalytics'];

var DeliverySaverPlanSelectionComponentDefinition = {
    controller: DeliverySaverPlanSelectionController,
    template: __webpack_require__(363).trim()
};

module.exports = {
    DeliverySaverPlanSelectionController: DeliverySaverPlanSelectionController,
    DeliverySaverPlanSelectionComponentDefinition: DeliverySaverPlanSelectionComponentDefinition
};

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = "<div class=\"deliverySaverPlanSelection\">\r\n    <div ng-switch=\"$ctrl.isLoading\">\r\n        <wow-loading-spinner\r\n            ng-switch-when=\"true\"\r\n            message=\"Loading Delivery Plus plans, please wait\"\r\n            is-message-sr-only=\"true\">\r\n        </wow-loading-spinner>\r\n        <div ng-switch-when=\"false\">\r\n            <section class=\"deliverySaverPlanSelection-notifications\">\r\n                <wow-notification-message\r\n                    ng-if=\"$ctrl.hasLoadPlansError\"\r\n                    is-dismissible=\"false\"\r\n                    type=\"error\"\r\n                    title=\"{{ ::$ctrl.settings.deliverySaver.errorLoadingPlansNotificationTitle }}\"\r\n                    message=\"{{ ::$ctrl.settings.deliverySaver.errorLoadingPlansNotificationText }}\"\r\n                    class=\"deliverySaverPlanSelection-notification\"\r\n                />\r\n                <wow-notification-message\r\n                    ng-if=\"$ctrl.hasActiveDeliverySaver\"\r\n                    is-dismissible=\"false\"\r\n                    type=\"info\"\r\n                    title=\"{{ ::$ctrl.settings.deliverySaver.activeNotificationTitle }}\"\r\n                    message=\"{{ ::$ctrl.settings.deliverySaver.activeNotificationText }}\"\r\n                    class=\"deliverySaverPlanSelection-notification\"\r\n                />\r\n                <wow-notification-message\r\n                    ng-if=\"$ctrl.hasSuspendedDeliverySaver\"\r\n                    is-dismissible=\"false\"\r\n                    type=\"warning\"\r\n                    title=\"{{ ::$ctrl.settings.deliverySaver.suspendedNotificationTitle }}\"\r\n                    message=\"{{ ::$ctrl.settings.deliverySaver.suspendedNotificationText }}\"\r\n                    class=\"deliverySaverPlanSelection-notification\"\r\n                />\r\n                <wow-notification-message\r\n                    ng-if=\"$ctrl.hasActiveDeliveryPass\"\r\n                    is-dismissible=\"false\"\r\n                    type=\"warning\"\r\n                    title=\"Delivery Saver pass active\"\r\n                    message=\"Looks like you already have a Delivery Saver pass. You can subscribe to Delivery Plus on {{$ctrl.dateEligibleForDeliverySaver | date: 'd MMMM, yyyy'}}.\"\r\n                    class=\"deliverySaverPlanSelection-notification\"\r\n                />\r\n                <wow-notification-message\r\n                    ng-if=\"$ctrl.isPersonalAccount() && $ctrl.showBusinessPlans\"\r\n                    is-dismissible=\"false\"\r\n                    type=\"warning\"\r\n                    title=\"Business subscription pricing\"\r\n                    message='You are currently logged into a personal account, &lt;a href=\"/shop/securelogin?redirect={{$ctrl.$location.path()}}\"&gt;log in with your business account&lt;/a&gt; to subscribe with below prices.'\r\n                    class=\"deliverySaverPlanSelection-notification\"\r\n                />\r\n                <wow-notification-message\r\n                    ng-if=\"$ctrl.isBusinessAccount && !$ctrl.showBusinessPlans\"\r\n                    is-dismissible=\"false\"\r\n                    type=\"warning\"\r\n                    title=\"Personal subscription pricing\"\r\n                    message='You are currently logged into a business account, &lt;a href=\"/shop/securelogin?redirect={{$ctrl.$location.path()}}\"&gt;log in with your personal account&lt;/a&gt; to subscribe with below prices.'\r\n                    class=\"deliverySaverPlanSelection-notification\"\r\n                />\r\n            </section>\r\n            <section class=\"deliverySaverPlanSelection-accountType\">\r\n                <h2>Get Started</h2>\r\n                <fieldset>\r\n                    <legend class=\"deliverySaverPlanSelection-accountTypeMessage\">My online shopping account is:</legend>\r\n                    <wow-toggle-button-group>\r\n                        <wow-toggle-button\r\n                            label=\"Personal\"\r\n                            name=\"showBusinessPlans\"\r\n                            value=\"false\"\r\n                            model=\"$ctrl.showBusinessPlans\"\r\n                            event-recorder=\"click\"\r\n                            event-label=\"Get Started: Account Type Toggle\"\r\n                            event-name=\"link_click\"\r\n                            event-category=\"Delivery Plus\"\r\n                        />\r\n                        <wow-toggle-button\r\n                            label=\"Business\"\r\n                            name=\"showBusinessPlans\"\r\n                            value=\"true\"\r\n                            model=\"$ctrl.showBusinessPlans\"\r\n                            event-recorder=\"click\"\r\n                            event-label=\"Get Started: Account Type Toggle\"\r\n                            event-name=\"link_click\"\r\n                            event-category=\"Delivery Plus\"\r\n                        />\r\n                    </wow-toggle-button-group>\r\n                </fieldset>\r\n            </section>\r\n            <section ng-switch=\"$ctrl.hasPlans()\">\r\n                <p ng-switch-when=\"false\" class=\"deliverySaverPlanSelection-noPlans\">No plans available</p>\r\n                <div ng-switch-when=\"true\" ng-switch=\"$ctrl.showBusinessPlans\">\r\n                    <div ng-switch-when=\"false\" class=\"deliverySaverPlanSelection-planGroups\">\r\n                        <wow-delivery-saver-plan-group\r\n                            class=\"deliverySaverPlanSelection-planGroup\"\r\n                            ng-if=\"$ctrl.anyDayConsumerPlans.length > 0\"\r\n                            group-heading=\"Delivery Plus Any Day\"\r\n                            is-plan-group-disabled=\"!$ctrl.isEligibleForDeliverySaver || $ctrl.isBusinessAccount\"\r\n                            plans=\"$ctrl.anyDayConsumerPlans\"\r\n                            selected-plan-id=\"$ctrl.selectedPlanId\"\r\n                        ></wow-delivery-saver-plan-group>\r\n                        <wow-delivery-saver-plan-group\r\n                            class=\"deliverySaverPlanSelection-planGroup\"\r\n                            ng-if=\"$ctrl.midweekConsumerPlans.length > 0\"\r\n                            group-heading=\"Delivery Plus Midweek\"\r\n                            is-plan-group-disabled=\"!$ctrl.isEligibleForDeliverySaver || $ctrl.isBusinessAccount\"\r\n                            plans=\"$ctrl.midweekConsumerPlans\"\r\n                            selected-plan-id=\"$ctrl.selectedPlanId\"\r\n                        ></wow-delivery-saver-plan-group>\r\n                    </div>\r\n                    <div ng-switch-when=\"true\" class=\"deliverySaverPlanSelection-planGroups\">\r\n                        <wow-delivery-saver-plan-group\r\n                            class=\"deliverySaverPlanSelection-planGroup\"\r\n                            ng-if=\"$ctrl.anyDayBusinessPlans.length > 0\"\r\n                            group-heading=\"Delivery Plus Any Day\"\r\n                            is-plan-group-disabled=\"!$ctrl.isEligibleForDeliverySaver || $ctrl.isPersonalAccount()\"\r\n                            plans=\"$ctrl.anyDayBusinessPlans\"\r\n                            selected-plan-id=\"$ctrl.selectedPlanId\"\r\n                        ></wow-delivery-saver-plan-group>\r\n                        <wow-delivery-saver-plan-group\r\n                            class=\"deliverySaverPlanSelection-planGroup\"\r\n                            ng-if=\"$ctrl.midweekBusinessPlans.length > 0\"\r\n                            group-heading=\"Delivery Plus Midweek\"\r\n                            is-plan-group-disabled=\"!$ctrl.isEligibleForDeliverySaver || $ctrl.isPersonalAccount()\"\r\n                            plans=\"$ctrl.midweekBusinessPlans\"\r\n                            selected-plan-id=\"$ctrl.selectedPlanId\"\r\n                        ></wow-delivery-saver-plan-group>\r\n                    </div>\r\n                </div>\r\n            </section>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    get = _require.get,
    some = _require.some,
    isUndefined = _require.isUndefined;

var DeliverySaverPlanGroupController = function () {
    function DeliverySaverPlanGroupController($state) {
        _classCallCheck(this, DeliverySaverPlanGroupController);

        this.$state = $state;
    }

    _createClass(DeliverySaverPlanGroupController, [{
        key: '$onInit',
        value: function $onInit() {
            this.planInclusions = get(this.plans, '[0].Metadata.Inclusions', []);
            this.disclaimer = get(this.plans, '[0].Metadata.Disclaimer');

            if (isUndefined(this.isPlanGroupDisabled)) {
                this.isPlanGroupDisabled = false;
            }
        }
    }, {
        key: 'isSelectedPlanInGroup',
        value: function isSelectedPlanInGroup() {
            var _this = this;

            return some(this.plans, function (p) {
                return p.Id === _this.selectedPlanId;
            });
        }
    }, {
        key: 'isSubscribeDisabled',
        value: function isSubscribeDisabled() {
            return this.isPlanGroupDisabled || !this.isSelectedPlanInGroup();
        }
    }, {
        key: 'selectDeliverySaverPlan',
        value: function selectDeliverySaverPlan() {
            this.$state.go('shop.deliveryplus.paymentsetup', { planId: this.selectedPlanId });
        }
    }, {
        key: 'getSelectedPlan',
        value: function getSelectedPlan() {
            var _this2 = this;

            return this.plans.find(function (x) {
                return x.Id === _this2.selectedPlanId;
            });
        }
    }]);

    return DeliverySaverPlanGroupController;
}();

DeliverySaverPlanGroupController.$inject = ['$state'];

var DeliverySaverPlanGroupComponentDefinition = {
    controller: DeliverySaverPlanGroupController,
    template: __webpack_require__(365).trim(),
    bindings: {
        groupHeading: '@',
        isPlanGroupDisabled: '<',
        plans: '<',
        selectedPlanId: '='
    }
};

module.exports = {
    DeliverySaverPlanGroupComponentDefinition: DeliverySaverPlanGroupComponentDefinition,
    DeliverySaverPlanGroupController: DeliverySaverPlanGroupController
};

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = "<h3 class=\"deliverySaverPlanSelection-planGroupHeading\">{{ ::$ctrl.groupHeading }}</h3>\r\n<ul ng-if=\"::$ctrl.planInclusions.length > 0\" class=\"deliverySaverPlanSelection-inclusions\">\r\n    <li ng-repeat=\"inclusion in $ctrl.planInclusions\" class=\"deliverySaverPlanSelection-inclusion\">{{ ::inclusion }}</li>\r\n</ul>\r\n<p class=\"deliverySaverPlanSelection-disclaimer\">{{ ::$ctrl.disclaimer }}</p>\r\n<form ng-submit=\"$ctrl.selectDeliverySaverPlan()\">\r\n    <ul>\r\n        <li ng-repeat=\"plan in $ctrl.plans | orderBy:'DisplayOrder'\">\r\n            <input\r\n                type=\"radio\"\r\n                name=\"planId\"\r\n                ng-value=\"::plan.Id\"\r\n                ng-model=\"$ctrl.selectedPlanId\"\r\n                ng-disabled=\"$ctrl.isPlanGroupDisabled\"\r\n                class=\"wowRadio\"\r\n                id=\"deliverySaverPlanSelection-plan{{::plan.Id}}\"\r\n                wow-event-recorder=\"click\"\r\n                data-er-category=\"Delivery Plus\"\r\n                data-er-label=\"{{ ::$ctrl.groupHeading }}: Subscription Selection\"\r\n                data-er-value=\"{{ ::plan | deliverySaverShortName }}\"\r\n                data-er-name=\"link_click\"\r\n            />\r\n            <label for=\"deliverySaverPlanSelection-plan{{::plan.Id}}\" class=\"deliverySaverPlanSelection-plan\">\r\n                <wow-delivery-saver-plan plan=\"::plan\"/>\r\n            </label>\r\n        </li>\r\n    </ul>\r\n    <button\r\n        type=\"submit\"\r\n        class=\"button button--primary button--large u-uppercase deliverySaverPlanSelection-submitButton\"\r\n        ng-disabled=\"$ctrl.isSubscribeDisabled()\"\r\n        wow-event-recorder=\"click\"\r\n        data-er-category=\"Delivery Plus\"\r\n        data-er-label=\"Subscribe\"\r\n        data-er-value=\"{{ ::$ctrl.groupHeading }}: {{ ::$ctrl.getSelectedPlan() | deliverySaverShortName }}\"\r\n        data-er-name=\"link_click\"\r\n    >\r\n        Subscribe\r\n        <span class=\"sr-only\">to {{ ::$ctrl.groupHeading }}</span>\r\n        &nbsp;<i class=\"iconww-ArrowRight\"></i>\r\n    </button>\r\n</form>\r\n"

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DeliverySaverPlanComponentDefinition = {
    template: __webpack_require__(367).trim(),
    bindings: {
        plan: '<'
    }
};

module.exports = {
    DeliverySaverPlanComponentDefinition: DeliverySaverPlanComponentDefinition
};

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = "<wow-delivery-saver-plan-tag ng-if=\"::$ctrl.plan.Metadata.Tag\" tag=\"::$ctrl.plan.Metadata.Tag\" />\r\n<div class=\"u-flex u-flexSpaceBetween u-flexCenterCross\">\r\n    <h2 class=\"deliverySaverPlan-name\">{{ ::$ctrl.plan | deliverySaverShortName }}</h2>\r\n    <wow-price price=\"::$ctrl.plan.Price\" per=\"::$ctrl.plan | deliverySaverBillingFrequencyUnit\" price-class-modifier=\"price--withPer\" />\r\n</div>\r\n"

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DeliverySaverPlanDetailComponentDefinition = {
    template: __webpack_require__(369).trim(),
    bindings: {
        plan: '<'
    }
};

module.exports = {
    DeliverySaverPlanDetailComponentDefinition: DeliverySaverPlanDetailComponentDefinition
};

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports = "<div class=\"u-flex u-flexSpaceBetween u-flexColumn deliverySaverPlanDetail-container\">\r\n    <wow-delivery-saver-plan-tag  tag=\"::$ctrl.plan.Metadata.Tag\" />\r\n    <div>\r\n        <h2 class=\"deliverySaverPlanDetail-sectionHeader\">{{ ::$ctrl.plan | deliverySaverTypeName }}</h2>\r\n    </div>\r\n    <div class=\"deliverySaverPlanDetail-inclusionsSection\" ng-if=\"$ctrl.plan.Metadata.Inclusions\">\r\n        <span ng-click=\"showInclusions = !showInclusions\" class=\"u-underlineLinks deliverySaverPlanDetail-inclusionsLink\">\r\n            <a href=\"\">{{ showInclusions ? 'Hide Inclusions' : 'Show Inclusions' }}</a>\r\n            &nbsp;<i ng-class=\"showInclusions ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n        </span>\r\n        <ul class=\"u-underlineLinks deliverySaverPlanDetail-inclusions\" ng-if=\"showInclusions\" >\r\n            <li ng-repeat=\"inclusion in ::$ctrl.plan.Metadata.Inclusions\">{{ inclusion }}</li>\r\n        </ul>\r\n        <p ng-if=\"showInclusions\" class=\"deliverySaverPlanDetail-disclaimer\">{{ ::$ctrl.plan.Metadata.Disclaimer }}</p>\r\n    </div>\r\n    <div class=\"u-flex u-flexSpaceBetween deliverySaverPlanDetail-priceSection\">\r\n        <h2 class=\"deliverySaverPlanDetail-sectionHeader\">{{ ::$ctrl.plan | deliverySaverShortName }}</h2>\r\n        <wow-price price=\"::$ctrl.plan.Price\" per=\"::$ctrl.plan | deliverySaverBillingFrequencyUnit\" price-class-modifier=\"price--withPer\" />\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeliverySaverSubscriptionDetailController = function () {
    function DeliverySaverSubscriptionDetailController() {
        _classCallCheck(this, DeliverySaverSubscriptionDetailController);
    }

    _createClass(DeliverySaverSubscriptionDetailController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isAnnualPlan = this.plan && this.plan.BillingFrequencyMonths === 12;
        }
    }]);

    return DeliverySaverSubscriptionDetailController;
}();

var DeliverySaverSubscriptionDetailComponentDefinition = {
    controller: DeliverySaverSubscriptionDetailController,
    template: __webpack_require__(371).trim(),
    bindings: {
        plan: '<',
        subscription: '<',
        shortTitle: '<'
    }
};

module.exports = {
    DeliverySaverSubscriptionDetailController: DeliverySaverSubscriptionDetailController,
    DeliverySaverSubscriptionDetailComponentDefinition: DeliverySaverSubscriptionDetailComponentDefinition
};

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <h2 ng-if=\"!!$ctrl.shortTitle\" class=\"deliverySaverSubscriptionDetail-shortTitle\">{{ $ctrl.plan | deliverySaverFullTypeName }}</h2>\r\n    <h2 ng-if=\"!$ctrl.shortTitle\" class=\"deliverySaverSubscriptionDetail-title\">{{ $ctrl.plan | deliverySaverTypeName }}</h2>\r\n    <p ng-if=\"!$ctrl.shortTitle\" class=\"deliverySaverSubscriptionDetail-subTitle\">{{ $ctrl.plan | deliverySaverShortName }}</p>\r\n    <div class=\"deliverySaverSubscriptionDetail-rows\">\r\n        <div class=\"deliverySaverSubscriptionDetail-row\">\r\n            <h3 class=\"deliverySaverSubscriptionDetail-rowHeading\">Start date</h3>\r\n            <div>{{ ::$ctrl.subscription.StartDate | date: \"d MMMM, yyyy\" }}</div>\r\n        </div>\r\n        <div ng-if=\"$ctrl.subscription.WillAutoRenew\" class=\"deliverySaverSubscriptionDetail-row\">\r\n            <h3 class=\"deliverySaverSubscriptionDetail-rowHeading\">{{ ::$ctrl.plan | deliverySaverPaymentAmountHeading }}</h3>\r\n            <div>\r\n                <p class=\"deliverySaverSubscriptionDetail-line\">{{ ::$ctrl.plan.Price | currency }}{{ ::$ctrl.plan | deliverySaverBillingFrequencyUnit }}</p>\r\n                <p ng-if=\"!$ctrl.isAnnualPlan\" class=\"deliverySaverSubscriptionDetail-line\">Cancel anytime</p>\r\n            </div>\r\n        </div>\r\n        <div class=\"deliverySaverSubscriptionDetail-row\">\r\n            <h3 class=\"deliverySaverSubscriptionDetail-rowHeading\">Payment method</h3>\r\n            <div class=\"u-flexCenterCross\">\r\n                <img ng-src=\"/images/checkout/digitalPay/icon-{{::$ctrl.subscription.CardScheme}}.svg\" alt=\"{{::$ctrl.subscription.CardScheme}}\" class=\"myDeliverySaver-planDetailsCardScheme\" />\r\n                <span>&nbsp;{{ $ctrl.subscription.CardSuffix | wowMaskCardNumber }}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"deliverySaverSubscriptionDetail-row u-flexWrap u-flexSpaceBetween\">\r\n            <h3 ng-switch=\"$ctrl.subscription.WillAutoRenew\" class=\"deliverySaverSubscriptionDetail-rowHeading\">\r\n                <span ng-switch-when=\"true\">Auto-Renewal date</span>\r\n                <span ng-switch-when=\"false\">End date</span>\r\n            </h3>\r\n            <div>{{ ::$ctrl.subscription.NextBillingDate | date: \"d MMMM, yyyy\" }}</div>\r\n            <p class=\"deliverySaverSubscriptionDetail-line\" ng-if=\"$ctrl.isAnnualPlan\">\r\n                We'll remind you before and you can cancel auto-renewal anytime via your account.\r\n            </p>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DeliverySaverPlanTagComponentDefinition = {
    template: __webpack_require__(373).trim(),
    bindings: {
        tag: '<'
    }
};

module.exports = {
    DeliverySaverPlanTagComponentDefinition: DeliverySaverPlanTagComponentDefinition
};

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports = "<span ng-if=\"::$ctrl.tag\" class=\"deliverySaverPlanTag\" style=\"{{ ::$ctrl.tag.Style }}\">{{ ::$ctrl.tag.Value }}</span>\r\n"

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    filter = _require.filter,
    findLast = _require.findLast,
    get = _require.get,
    isEmpty = _require.isEmpty,
    merge = _require.merge,
    replace = _require.replace;

var SUBSCRIPTION_PROCESSING_STATE_ID = 'SubscriptionProcessing';

/**
 * Delivery Saver Payment Setup Component.
 * Note 1: Avoid adding payment type specific concerns in this component.
 *         i.e. This component does not need to know about specific payment instrument types (e.g. giftCard or Paypal)
 *         All payment type specific logic should be part of the instruments component.
 */

var DeliverySaverPaymentSetupController = function () {
    function DeliverySaverPaymentSetupController($element, $q, $state, $filter, $scope, settings, announcerService, digitalPayPaymentErrorDisplayService, loadingIndicatorService, digitalPayIframeEventHandler, digitalPayPaymentDistributionService, digitalPayPrepaymentActionsService, digitalPayDisablePaymentStateService, digitalPayPaymentErrorStateService, digitalPayErrorMessageGenerator, deliverySaverService, shopperService, dialogRegistry, analytics) {
        _classCallCheck(this, DeliverySaverPaymentSetupController);

        this.$element = $element;
        this.$q = $q;
        this.$state = $state;
        this.$filter = $filter;
        this.$scope = $scope;
        this.settings = settings;
        this.announcerService = announcerService;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        this.loadingIndicatorService = loadingIndicatorService;
        this.iframeEventHandler = digitalPayIframeEventHandler;
        this.paymentDistributionService = digitalPayPaymentDistributionService;
        this.prePaymentActionsService = digitalPayPrepaymentActionsService;
        this.disablePaymentStateService = digitalPayDisablePaymentStateService;
        this.digitalPayPaymentErrorStateService = digitalPayPaymentErrorStateService;
        this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
        this.deliverySaverService = deliverySaverService;
        this.shopperService = shopperService;
        this.dialogRegistry = dialogRegistry;
        this.analytics = analytics;
    }

    _createClass(DeliverySaverPaymentSetupController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.isInitialised = false;
            this.agreeToTncs = false;
            this.agreeToSubscriptionTncs = false;
            this.isCvvDialogEnabled = false;
            this.iframeEventHandler.init();
            this.prePaymentActionsService.init();
            this.disablePaymentStateService.init();
            this.digitalPayPaymentErrorStateService.init();
            this.digitalPayErrorTitle = 'Sorry, we\'ve encountered an issue.';
            this.dialog = {
                PLAN_NOTMATCH: 'SUBSCRIPTION_PLAN_NOT_MATCH'
            };

            this.prePaymentActionDefinitions = {
                addAction: this.prePaymentActionsService.addAction.bind(this.prePaymentActionsService),
                removeAction: this.prePaymentActionsService.removeAction.bind(this.prePaymentActionsService)
            };

            this.paymentStateDefinitions = {
                addDisablePaymentState: this.disablePaymentStateService.addDisablePaymentState.bind(this.disablePaymentStateService),
                removeDisablePaymentState: this.disablePaymentStateService.removeDisablePaymentState.bind(this.disablePaymentStateService)
            };

            this.deliverySaverService.getPlan(this.$state.params.planId).then(function (response) {
                _this.plan = response.Plan;
                _this.verifyPlan(_this.plan);

                if (_this.settings.deliverySaver.paymentSetupDisclaimerText) {
                    var billingFrequency = _this.$filter('deliverySaverBillingFrequency')(_this.plan);
                    _this.paymentSetupDisclaimerTextHtml = _this.settings.deliverySaver.paymentSetupDisclaimerText.replace('{{ BillingFrequency }}', billingFrequency);
                }

                _this.isInitialised = true;
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
            this.iframeEventHandler.dispose();
            this.prePaymentActionsService.removeAllActions();
            this.digitalPayPaymentErrorStateService.clearErrors();
        }

        /**
         * Notifies when child instrument components are in manage mode.
         * @param {*boolean} state
         */

    }, {
        key: 'notifyWhenChildIsInManageMode',
        value: function notifyWhenChildIsInManageMode(state) {
            // The field here is an additional field used for showing the account password textbox
            this.anyChildIsInManageMode = state;
        }
    }, {
        key: 'shouldDisablePayment',
        value: function shouldDisablePayment() {
            return this.disablePaymentStateService.hasDisablePaymentStates() || !this.paymentDistributionService.hasSingleSelectType() || !this.agreeToTncs || !this.agreeToSubscriptionTncs || !this.billingAddress;
        }
    }, {
        key: 'subscribeToDeliverySaver',
        value: function subscribeToDeliverySaver() {
            var _this2 = this;

            // logic from digital-pay-button
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();

            if (this.shouldDisablePayment()) {
                this.announcerService.announce(replace(this.settings.digitalPayScreenReaderMessages.placeOrderInvalidDisableMessage, '{0}', this.disablePaymentStateService.getReasonsWhyDisabled()));
                return;
            }

            this.paymentStateDefinitions.addDisablePaymentState(SUBSCRIPTION_PROCESSING_STATE_ID, this.settings.digitalPayScreenReaderMessages.subscriptionProcessingDisableMessage);
            this.resetPaymentStates();
            var prePaymentActions = this.prePaymentActionsService.getAllActions();

            var prePaymentPromises = [];
            prePaymentActions.forEach(function (action) {
                prePaymentPromises.push(action());
            });

            var subscribePromise = function subscribePromise(paymentInstrument) {
                return _this2.deliverySaverService.subscribe(_this2.$state.params.planId, paymentInstrument).then(function (data) {
                    // Update shopperService.shopper.DeliveryPlusSubscriptionStatus
                    _this2.shopperService.getCurrentShopperDetails();

                    _this2.$state.go('shop.deliveryplus.confirmation', { data: data });
                }).catch(function (response) {
                    return _this2.handleSubscribeFailure(response);
                });
            };

            this.loadingIndicatorService.startLoading(true, 'Processing your payment', false);

            // Once all prepayment promises are resolved make the payment.
            this.$q.all(prePaymentPromises).then(function (prePaymentResults) {
                return _this2.getPaymentInstrument(prePaymentResults);
            }).then(subscribePromise).catch(function (error) {
                _this2.hasPrePaymentActionFailures = true;
                if (error && error.errorMessage) {
                    _this2.digitalPayPaymentErrorDisplayService.pushGlobalError(error.errorMessage);
                }
            }).finally(function () {
                _this2.loadingIndicatorService.finishLoading();
                _this2.paymentStateDefinitions.removeDisablePaymentState(SUBSCRIPTION_PROCESSING_STATE_ID);
            });
        }

        /**
         * Returns a paymentInstrument object
         * which is a merging of all the results for the instrument being used
         * @param {Promise[]} prePaymentResults
         * @returns {Object} paymentInstrument with paymentInstrumentId and stepUpToken
         */

    }, {
        key: 'getPaymentInstrument',
        value: function getPaymentInstrument(prePaymentResults) {
            var paymentInstrumentId = this.paymentDistributionService.getSingleSelectKey();
            if (this.paymentDistributionService.isPayingWithNewCard()) {
                // There should only be one prePaymentResult
                // but double check for a stepUpToken to ensure we use the right one
                paymentInstrumentId = get(findLast(prePaymentResults, function (result) {
                    return result.paymentInstrumentId && result.stepUpToken;
                }), 'paymentInstrumentId');
            }
            if (paymentInstrumentId != null) {
                var paymentInstrumentResults = filter(prePaymentResults, function (result) {
                    return result.paymentInstrumentId === paymentInstrumentId;
                });
                var paymentInstrument = merge.apply(undefined, _toConsumableArray(paymentInstrumentResults));
                if (!isEmpty(paymentInstrument)) {
                    return paymentInstrument;
                }
            }
            return this.$q.reject({ errorMessage: this.settings.deliverySaver.paymentSetupGenericError });
        }

        /**
         * For clearing errors and resetting prepayment states
         */

    }, {
        key: 'resetPaymentStates',
        value: function resetPaymentStates() {
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
            this.hasPrePaymentActionFailures = false;
            this.hasPrePaymentValidationFailure = false;
            this.shouldRemoveNewlyAddedInstruments = false;
            this.digitalPayErrorMessageGenerator.setPaymentErrorMode(false);
        }
    }, {
        key: 'handleSubscribeFailure',
        value: function handleSubscribeFailure(response) {
            var errorMessage = this.settings.deliverySaver.paymentSetupGenericError;
            if (response.status === 400 && response.data.Errors) {
                var errorCodes = response.data.Errors.map(function (error) {
                    return error.ErrorCode;
                });
                if (errorCodes.includes(this.settings.subscriptionsErrorCodes.alreadySubscribed)) {
                    errorMessage = this.settings.deliverySaver.paymentSetupAlreadySubscribedError;
                } else if (errorCodes.includes(this.settings.subscriptionsErrorCodes.planNotFound)) {
                    errorMessage = this.settings.deliverySaver.paymentSetupPlanNotFoundError;
                }
            } else if (response.status === 504) {
                errorMessage = this.settings.deliverySaver.paymentSetupTimeoutError;
            } else if (response.status >= 500) {
                errorMessage = this.settings.deliverySaver.paymentSetupServerError;
            }
            this.digitalPayPaymentErrorDisplayService.pushGlobalError(errorMessage);
            this.shouldRemoveNewlyAddedInstruments = true;
        }
    }, {
        key: 'verifyPlan',
        value: function verifyPlan(plan) {
            // if guest user, skip plan validation, login require will be validated after
            if (this.shopperService.IsGuest) return;

            var shopper = this.shopperService.shopper;

            var isBusinessPlan = plan.Metadata.IsBusinessToBusiness;
            var isBusinessAccount = !!(shopper.IsBusinessAccount || shopper.ABN);

            if (isBusinessAccount === isBusinessPlan) {
                return;
            } else if (isBusinessAccount) {
                this.planAccountTypeValidationFailedTitle = this.settings.deliverySaver.planAccountTypeValidationFailedTitleBusinessAccount;
                this.planAccountTypeValidationFailedText = this.settings.deliverySaver.planAccountTypeValidationFailedTextBusinessAccount;
                this.planAccountTypeValidationContinueButtonText = this.settings.deliverySaver.planAccountTypeValidationContinueButtonTextBusinessAccount;
                this.planAccountTypeValidationChangeAccountText = this.settings.deliverySaver.planAccountTypeValidationChangeAccountTextBusinessAccount;
            } else {
                this.planAccountTypeValidationFailedTitle = this.settings.deliverySaver.planAccountTypeValidationFailedTitlePersonalAccount;
                this.planAccountTypeValidationFailedText = this.settings.deliverySaver.planAccountTypeValidationFailedTextPersonalAccount;
                this.planAccountTypeValidationContinueButtonText = this.settings.deliverySaver.planAccountTypeValidationContinueButtonTextPersonalAccount;
                this.planAccountTypeValidationChangeAccountText = this.settings.deliverySaver.planAccountTypeValidationChangeAccountTextPersonalAccount;
            }

            this.planNotMatchDialog = this.dialogRegistry.getDialog(this.dialog.PLAN_NOTMATCH);
            this.planNotMatchDialog.show();
        }
    }, {
        key: 'onInnerLinkClicked',
        value: function onInnerLinkClicked(event) {
            if (event.target.nodeName.toLowerCase() === 'a') {
                this.analytics.push({
                    data: {
                        event: {
                            category: 'Delivery Plus',
                            label: 'DSS: ' + event.target.innerText,
                            name: 'link_click'
                        },
                        trackingType: 'link'
                    },
                    type: this.analytics.mapperTypes.customEvent.customEvent
                });
            }
        }
    }]);

    return DeliverySaverPaymentSetupController;
}();

DeliverySaverPaymentSetupController.$inject = ['$element', '$q', '$state', '$filter', '$scope', 'Settings', 'AnnouncerService', 'DigitalPayPaymentErrorDisplayService', 'LoadingIndicatorService', 'DigitalPayIframeEventHandler', 'DigitalPayPaymentDistributionService', 'DigitalPayPrepaymentActionsService', 'DigitalPayDisablePaymentStateService', 'DigitalPayPaymentErrorStateService', 'DigitalPayErrorMessageGenerator', 'DeliverySaverService', 'ShopperService', 'DialogRegistry', 'AnalyticsService'];

var DeliverySaverPaymentSetupComponentDefinition = {
    controller: DeliverySaverPaymentSetupController,
    template: __webpack_require__(375).trim()
};

module.exports = {
    DeliverySaverPaymentSetupController: DeliverySaverPaymentSetupController,
    DeliverySaverPaymentSetupComponentDefinition: DeliverySaverPaymentSetupComponentDefinition
};

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports = "<div class=\"deliverySaverPaymentSetup\">\r\n    <a class=\"deliverySaverPaymentSetup-backLink\" ng-href=\"{{::$ctrl.settings.deliverySaver.discoverPageUrl}}\">\r\n        <span><i class=\"iconww-ArrowLeft\"></i>&nbsp; Back</span>\r\n    </a>\r\n    <div class=\"paymentDigitalPay-container\" ng-class=\"{'paymentDigitalPay-container--extendedPassword': $ctrl.listLoaded}\">\r\n        <div class=\"deliverySaverPaymentSetup-section\">\r\n            <h1 class=\"deliverySaverPaymentSetup-header\">\r\n                <wow-setting setting-group=\"DeliverySaver\" setting-name=\"PaymentSetupTitle\"></wow-setting>\r\n            </h1>\r\n            <wow-delivery-saver-plan-detail ng-if=\"$ctrl.plan\" plan=\"$ctrl.plan\" />\r\n        </div>\r\n\r\n        <div class=\"deliverySaverPaymentSetup-section\">\r\n            <h1 class=\"deliverySaverPaymentSetup-header\">Payment details</h1>\r\n            <p><wow-setting setting-group=\"DeliverySaver\" setting-name=\"PaymentSetupDetailText\"></wow-setting></p>\r\n            <p class=\"u-disclaimer\" ng-bind-html=\"$ctrl.paymentSetupDisclaimerTextHtml\" ng-click=\"$ctrl.onInnerLinkClicked($event)\"></p>\r\n            <wow-digital-pay-error-display\r\n                title=\"$ctrl.digitalPayErrorTitle\"\r\n                custom-error-class=\"deliverySaverPaymentSetup-error\"\r\n                error-message=\"$ctrl.digitalPayPaymentErrorDisplayService.getGlobalErrorMessage()\"\r\n                error-list=\"$ctrl.digitalPayPaymentErrorDisplayService.getPaymentErrors()\"\r\n                hide-error-list=\"false\">\r\n            </wow-digital-pay-error-display>\r\n            <form novalidate>\r\n                <div class=\"paymentDigitalPay-methods\">\r\n                    <wow-digital-pay-instruments ng-if=\"$ctrl.isInitialised\"\r\n                        class=\"digitalPayInstrumentsContainer\"\r\n                        has-pre-payment-action-failures=\"$ctrl.hasPrePaymentActionFailures\"\r\n                        has-pre-payment-validation-failure=\"$ctrl.hasPrePaymentValidationFailure\"\r\n                        is-for-payment-agreement=\"true\"\r\n                        on-child-is-in-manage-mode=\"$ctrl.notifyWhenChildIsInManageMode(state)\"\r\n                        payment-error-states=\"$ctrl.digitalPayPaymentErrorStateService.getErrors()\"\r\n                        payment-state-definitions=\"$ctrl.paymentStateDefinitions\"\r\n                        pre-payment-action-definitions=\"$ctrl.prePaymentActionDefinitions\",\r\n                        should-remove-newly-added-instruments=\"$ctrl.shouldRemoveNewlyAddedInstruments\"\r\n                        should-show-paying-amount=\"false\"\r\n                        should-show-paypal-place-order-button=\"false\"\r\n                    />\r\n                </div>\r\n\r\n                <wow-delivery-saver-billing-address class=\"deliverySaverPaymentSetup-address\" billing-address=\"$ctrl.billingAddress\" />\r\n\r\n                <hr class=\"deliverySaverPaymentSetup-separator\"/>\r\n\r\n                <div class=\"u-flex u-flexEnd u-flexWrap u-flexColumn\">\r\n                    <div class=\"deliverySaverPaymentSetup-agreeTncs\">\r\n                        <input type=\"checkbox\" id=\"agree-subscription-tncs-checkbox\" class=\"wowCheckbox\" ng-model=\"$ctrl.agreeToSubscriptionTncs\"/>\r\n                        <label\r\n                            for=\"agree-subscription-tncs-checkbox\"\r\n                            wow-html-setting setting-group=\"DeliverySaver\"\r\n                            setting-name=\"PaymentSetupTncsSubscriptionAgreementHtml\"\r\n                            ng-click=\"$ctrl.onInnerLinkClicked($event)\"\r\n                        ></label>\r\n                    </div>\r\n                    <div class=\"deliverySaverPaymentSetup-agreeTncs\">\r\n                        <input type=\"checkbox\" id=\"agree-tncs-checkbox\" class=\"wowCheckbox\" ng-model=\"$ctrl.agreeToTncs\"/>\r\n                        <label\r\n                            for=\"agree-tncs-checkbox\"\r\n                            wow-html-setting setting-group=\"DeliverySaver\"\r\n                            setting-name=\"PaymentSetupTncsAgreementHtml\"\r\n                            ng-click=\"$ctrl.onInnerLinkClicked($event)\"\r\n                        ></label>\r\n                    </div>\r\n                </div>\r\n                <button\r\n                    class=\"button button--primary button--xLarge u-uppercase deliverySaverPaymentSetup-subscribeButton\"\r\n                    ng-class=\"{'is-disabled': $ctrl.shouldDisablePayment()}\"\r\n                    ng-click=\"$ctrl.subscribeToDeliverySaver()\"\r\n                    wow-event-recorder=\"click\"\r\n                    data-er-category=\"Delivery Plus\"\r\n                    data-er-label=\"Subscribe\"\r\n                    data-er-value=\"{{ $ctrl.plan | deliverySaverTypeName }}: {{ $ctrl.plan | deliverySaverShortName }}\"\r\n                    data-er-name=\"link_click\"\r\n                >\r\n                    Subscribe<i class=\"iconww-ArrowRight dpFooter-iconRightButton\"></i>\r\n                </button>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<dialog name=\"{{::$ctrl.dialog.PLAN_NOTMATCH}}\" class=\"olyDialog olyDialog--confirmation-v2 myDeliverySaver-manageSubscriptionDialog\">\r\n    <div class=\"olyDialog-scrollableArea\" wow-hide-scroll wow-scrollbar>\r\n        <div class=\"olyDialog-wrapper\">\r\n            <h1 class=\"olyDialog-heading\">{{::$ctrl.planAccountTypeValidationFailedTitle }}</h1>\r\n            <div>{{::$ctrl.planAccountTypeValidationFailedText }}</div>\r\n        </div>\r\n    </div>\r\n    <footer class=\"olyDialog-buttons u-flex u-flexColumn\">\r\n        <a ng-href=\"{{::$ctrl.settings.deliverySaver.discoverPageUrl}}\" oly-dialog-close class=\"button button--primary u-flex u-flexCenter\">\r\n            <span>{{::$ctrl.planAccountTypeValidationContinueButtonText }}&nbsp;\r\n                <i class=\"iconww-ArrowRight\"></i>\r\n            </span>\r\n        </a>\r\n        <a ui-sref=\"shop.authentication.login\" class=\"button olyDialog-buttonsCancel u-flex u-flexCenter\">\r\n            <span>\r\n                <i class=\"iconww-ArrowLeft\"></i>\r\n                &nbsp; {{::$ctrl.planAccountTypeValidationChangeAccountText }}\r\n            </span>\r\n        </a>\r\n    </footer>\r\n</dialog>\r\n"

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeliverySaverConfirmationController = function () {
    function DeliverySaverConfirmationController($state, $location, $q, deliverySaverService, settings) {
        _classCallCheck(this, DeliverySaverConfirmationController);

        this.$state = $state;
        this.$location = $location;
        this.$q = $q;
        this.deliverySaverService = deliverySaverService;
        this.settings = settings;
    }

    _createClass(DeliverySaverConfirmationController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.subscription = this.$state.params.data.Subscription;
            this.plan = this.$state.params.data.Plan;
            this.isAnnualPlan = false;

            if (!this.subscription || !this.plan) {
                this.loading = true;
                this.deliverySaverService.getSubscription().then(function (data) {
                    // temporarily solution, will be replaced by new design soon
                    if (!data.Subscription || data.Subscription.Status === 'Cancelled') {
                        return _this.$q.reject();
                    }
                    return data;
                }).then(function (data) {
                    _this.subscription = data.Subscription;
                    _this.plan = data.Plan;
                    _this.isAnnualPlan = _this.plan.BillingFrequencyMonths === 12;
                }).catch(function () {
                    _this.$location.path(_this.settings.deliverySaver.discoverPageUrl);
                }).finally(function () {
                    _this.loading = false;
                });
            }
        }
    }]);

    return DeliverySaverConfirmationController;
}();

DeliverySaverConfirmationController.$inject = ['$state', '$location', '$q', 'DeliverySaverService', 'Settings'];

var DeliverySaverConfirmationComponentDefinition = {
    controller: DeliverySaverConfirmationController,
    template: __webpack_require__(377).trim()
};

module.exports = {
    DeliverySaverConfirmationController: DeliverySaverConfirmationController,
    DeliverySaverConfirmationComponentDefinition: DeliverySaverConfirmationComponentDefinition
};

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports = "<div class=\"deliverySaverConfirmation\">\r\n    <div class=\"text-center\">\r\n        <div class=\"deliverySaverConfirmation-tick\"><i class=\"iconww-Tick\"></i></div>\r\n        <h1>You’re all set!</h1>\r\n        <p>Congratulations, your Delivery Plus is now active and ready to use! </p>\r\n    </div>\r\n    <div class=\"deliverySaverConfirmation-detail\">\r\n        <wow-loading-spinner ng-if=\"$ctrl.loading\" message=\"Loading subscription details\" is-message-sr-only=\"true\" />\r\n        <wow-delivery-saver-subscription-detail ng-if=\"!$ctrl.loading\" plan=\"$ctrl.plan\" subscription=\"$ctrl.subscription\" />\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    filter = _require.filter,
    findLast = _require.findLast,
    get = _require.get,
    isEmpty = _require.isEmpty,
    merge = _require.merge,
    replace = _require.replace;

var SUBSCRIPTION_UPDATING_STATE_ID = 'SubscriptionUpdating';

/**
 * Delivery Saver Payment Setup Component.
 * Note 1: Avoid adding payment type specific concerns in this component.
 *         i.e. This component does not need to know about specific payment instrument types (e.g. giftCard or Paypal)
 *         All payment type specific logic should be part of the instruments component.
 */

var DeliverySaverPaymentUpdateController = function () {
    function DeliverySaverPaymentUpdateController($element, $q, $state, settings, announcerService, digitalPayPaymentErrorDisplayService, loadingIndicatorService, digitalPayIframeEventHandler, digitalPayPaymentDistributionService, digitalPayPrepaymentActionsService, digitalPayDisablePaymentStateService, digitalPayPaymentErrorStateService, digitalPayErrorMessageGenerator, deliverySaverService) {
        _classCallCheck(this, DeliverySaverPaymentUpdateController);

        this.$element = $element;
        this.$q = $q;
        this.$state = $state;
        this.settings = settings;
        this.announcerService = announcerService;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        this.loadingIndicatorService = loadingIndicatorService;
        this.iframeEventHandler = digitalPayIframeEventHandler;
        this.paymentDistributionService = digitalPayPaymentDistributionService;
        this.prePaymentActionsService = digitalPayPrepaymentActionsService;
        this.disablePaymentStateService = digitalPayDisablePaymentStateService;
        this.digitalPayPaymentErrorStateService = digitalPayPaymentErrorStateService;
        this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
        this.deliverySaverService = deliverySaverService;
    }

    _createClass(DeliverySaverPaymentUpdateController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isInitialised = false;
            this.isCvvDialogEnabled = false;
            this.iframeEventHandler.init();
            this.prePaymentActionsService.init();
            this.disablePaymentStateService.init();
            this.digitalPayPaymentErrorStateService.init();

            this.prePaymentActionDefinitions = {
                addAction: this.prePaymentActionsService.addAction.bind(this.prePaymentActionsService),
                removeAction: this.prePaymentActionsService.removeAction.bind(this.prePaymentActionsService)
            };

            this.paymentStateDefinitions = {
                addDisablePaymentState: this.disablePaymentStateService.addDisablePaymentState.bind(this.disablePaymentStateService),
                removeDisablePaymentState: this.disablePaymentStateService.removeDisablePaymentState.bind(this.disablePaymentStateService)
            };

            this.isInitialised = true;
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
            this.iframeEventHandler.dispose();
            this.prePaymentActionsService.removeAllActions();
            this.digitalPayPaymentErrorStateService.clearErrors();
        }

        /**
         * Notifies when child instrument components are in manage mode.
         * @param {*boolean} state
         */

    }, {
        key: 'notifyWhenChildIsInManageMode',
        value: function notifyWhenChildIsInManageMode(state) {
            // The field here is an additional field used for showing the account password textbox
            this.anyChildIsInManageMode = state;
        }
    }, {
        key: 'shouldDisableUpdate',
        value: function shouldDisableUpdate() {
            return this.disablePaymentStateService.hasDisablePaymentStates() || !this.paymentDistributionService.hasSingleSelectType();
        }
    }, {
        key: 'updatePaymentInstrument',
        value: function updatePaymentInstrument() {
            var _this = this;

            // logic from digital-pay-button
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();

            if (this.shouldDisableUpdate()) {
                this.announcerService.announce(replace(this.settings.digitalPayScreenReaderMessages.placeOrderInvalidDisableMessage, '{0}', this.disablePaymentStateService.getReasonsWhyDisabled()));
                return;
            }

            this.paymentStateDefinitions.addDisablePaymentState(SUBSCRIPTION_UPDATING_STATE_ID, this.settings.digitalPayScreenReaderMessages.subscriptionProcessingDisableMessage);
            this.resetPaymentStates();
            var prePaymentActions = this.prePaymentActionsService.getAllActions();

            var prePaymentPromises = [];
            prePaymentActions.forEach(function (action) {
                prePaymentPromises.push(action());
            });

            var paymentUpdatePromise = function paymentUpdatePromise(paymentInstrument) {
                return _this.deliverySaverService.updatePaymentInstrument(paymentInstrument).then(function () {
                    _this.$state.go('shop.myaccount.deliveryplus');
                }).catch(function (response) {
                    return _this.handlePaymentUpdateFailure(response);
                });
            };

            this.loadingIndicatorService.startLoading(true, 'Updating your payment details', false);

            // Once all prepayment promises are resolved update the payment method.
            this.$q.all(prePaymentPromises).then(function (prePaymentResults) {
                return _this.getPaymentInstrument(prePaymentResults);
            }).then(paymentUpdatePromise).catch(function (error) {
                _this.hasPrePaymentActionFailures = true;
                if (error && error.errorMessage) {
                    _this.digitalPayPaymentErrorDisplayService.pushGlobalError(error.errorMessage);
                }
            }).finally(function () {
                _this.loadingIndicatorService.finishLoading();
                _this.paymentStateDefinitions.removeDisablePaymentState(SUBSCRIPTION_UPDATING_STATE_ID);
            });
        }

        /**
         * Returns a paymentInstrument object
         * which is a merging of all the results for the instrument being used
         * @param {Promise[]} prePaymentResults
         * @returns {Object} paymentInstrument with paymentInstrumentId and stepUpToken
         */

    }, {
        key: 'getPaymentInstrument',
        value: function getPaymentInstrument(prePaymentResults) {
            var paymentInstrumentId = this.paymentDistributionService.getSingleSelectKey();
            if (this.paymentDistributionService.isPayingWithNewCard()) {
                // There should only be one prePaymentResult
                // but double check for a stepUpToken to ensure we use the right one
                paymentInstrumentId = get(findLast(prePaymentResults, function (result) {
                    return result.paymentInstrumentId && result.stepUpToken;
                }), 'paymentInstrumentId');
            }
            if (paymentInstrumentId != null) {
                var paymentInstrumentResults = filter(prePaymentResults, function (result) {
                    return result.paymentInstrumentId === paymentInstrumentId;
                });
                var paymentInstrument = merge.apply(undefined, _toConsumableArray(paymentInstrumentResults));
                if (!isEmpty(paymentInstrument)) {
                    return paymentInstrument;
                }
            }
            return this.$q.reject({
                errorMessage: this.settings.deliverySaver.paymentUpdateGenericError
            });
        }

        /**
         * For clearing errors and resetting prepayment states
         */

    }, {
        key: 'resetPaymentStates',
        value: function resetPaymentStates() {
            this.digitalPayPaymentErrorDisplayService.clearGlobalError();
            this.hasPrePaymentActionFailures = false;
            this.hasPrePaymentValidationFailure = false;
            this.shouldRemoveNewlyAddedInstruments = false;
            this.digitalPayErrorMessageGenerator.setPaymentErrorMode(false);
        }
    }, {
        key: 'handlePaymentUpdateFailure',
        value: function handlePaymentUpdateFailure(response) {
            var errorMessage = response.status >= 500 ? this.settings.deliverySaver.paymentUpdateServerError : this.settings.deliverySaver.paymentUpdateGenericError;
            this.digitalPayPaymentErrorDisplayService.pushGlobalError(errorMessage);
            this.shouldRemoveNewlyAddedInstruments = true;
        }
    }]);

    return DeliverySaverPaymentUpdateController;
}();

DeliverySaverPaymentUpdateController.$inject = ['$element', '$q', '$state', 'Settings', 'AnnouncerService', 'DigitalPayPaymentErrorDisplayService', 'LoadingIndicatorService', 'DigitalPayIframeEventHandler', 'DigitalPayPaymentDistributionService', 'DigitalPayPrepaymentActionsService', 'DigitalPayDisablePaymentStateService', 'DigitalPayPaymentErrorStateService', 'DigitalPayErrorMessageGenerator', 'DeliverySaverService'];

var DeliverySaverPaymentUpdateComponentDefinition = {
    controller: DeliverySaverPaymentUpdateController,
    template: __webpack_require__(379).trim()
};

module.exports = {
    DeliverySaverPaymentUpdateController: DeliverySaverPaymentUpdateController,
    DeliverySaverPaymentUpdateComponentDefinition: DeliverySaverPaymentUpdateComponentDefinition
};

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = "<div class=\"deliverySaverPaymentUpdate\">\r\n    <h1>Payment Method</h1>\r\n    <wow-digital-pay-error-display error-message=\"$ctrl.digitalPayPaymentErrorDisplayService.getGlobalErrorMessage()\"\r\n        error-list=\"$ctrl.digitalPayPaymentErrorDisplayService.getPaymentErrors()\"\r\n        hide-error-list=\"false\">\r\n    </wow-digital-pay-error-display>\r\n\r\n    <div class=\"paymentDigitalPay-container\"\r\n        ng-class=\"{'paymentDigitalPay-container--extendedPassword': $ctrl.listLoaded}\">\r\n        <form novalidate ng-submit=\"$ctrl.updatePaymentInstrument()\">\r\n            <div class=\"paymentDigitalPay-methods\">\r\n                <wow-digital-pay-instruments ng-if=\"$ctrl.isInitialised\"\r\n                    class=\"digitalPayInstrumentsContainer\"\r\n                    has-pre-payment-action-failures=\"$ctrl.hasPrePaymentActionFailures\"\r\n                    has-pre-payment-validation-failure=\"$ctrl.hasPrePaymentValidationFailure\"\r\n                    is-for-payment-agreement=\"true\"\r\n                    on-child-is-in-manage-mode=\"$ctrl.notifyWhenChildIsInManageMode(state)\"\r\n                    payment-error-states=\"$ctrl.digitalPayPaymentErrorStateService.getErrors()\"\r\n                    payment-state-definitions=\"$ctrl.paymentStateDefinitions\"\r\n                    pre-payment-action-definitions=\"$ctrl.prePaymentActionDefinitions\",\r\n                    should-remove-newly-added-instruments=\"$ctrl.shouldRemoveNewlyAddedInstruments\"\r\n                    should-show-paying-amount=\"false\"\r\n                    should-show-paypal-place-order-button=\"false\"\r\n                />\r\n            </div>\r\n            <!-- Common button -->\r\n            <button\r\n                class=\"button button--primary button--xLarge u-uppercase deliverySaverPaymentUpdate-submitButton\"\r\n                ng-class=\"{'is-disabled': $ctrl.shouldDisableUpdate()}\"\r\n                role=\"submit\"\r\n                wow-event-recorder=\"click\"\r\n                data-er-category=\"Delivery Plus\"\r\n                data-er-label=\"DSS: Update Payment Method\"\r\n                data-er-name=\"link_click\"\r\n            >\r\n                    Update payment method\r\n            </button>\r\n        </form>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeliverySaverBillingAddressController = function () {
    function DeliverySaverBillingAddressController(addressService) {
        _classCallCheck(this, DeliverySaverBillingAddressController);

        this.addressService = addressService;
    }

    _createClass(DeliverySaverBillingAddressController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.editMode = false;

            this.addressService.getSavedAddresses().then(function () {
                _this.savedAddresses = _this.addressService.savedAddresses;
                _this.billingAddress = _this.addressService.getPrimaryAddress();
                _this.editMode = !_this.billingAddress;
            });
        }
    }, {
        key: 'changeAddress',
        value: function changeAddress() {
            this.editMode = true;
        }
    }, {
        key: 'tryPushNewAddress',
        value: function tryPushNewAddress(address) {
            if (!this.addressService.savedAddresses.find(function (x) {
                return x.AddressId === address.AddressId;
            })) {
                this.addressService.savedAddresses.push(address);
            }
        }
    }, {
        key: 'saveNewManualAddress',
        value: function saveNewManualAddress(address) {
            var _this2 = this;

            this.addressService.saveNewManualAddressForBilling(address).then(function (addressResponse) {
                _this2.billingAddress = addressResponse.Address;
                _this2.tryPushNewAddress(_this2.billingAddress);
                _this2.editMode = false;
            });
        }
    }, {
        key: 'saveNewAutoAddress',
        value: function saveNewAutoAddress(address) {
            var _this3 = this;

            this.addressService.saveNewAutoAddressForBilling(address).then(function (addressResponse) {
                _this3.billingAddress = addressResponse.Address;
                _this3.tryPushNewAddress(_this3.billingAddress);
                _this3.editMode = false;
            });
        }
    }, {
        key: 'savedAddressSelected',
        value: function savedAddressSelected(address) {
            var _this4 = this;

            if (this.billingAddress.AddressId === address.AddressId) {
                this.editMode = false;
                return;
            }

            this.addressService.setSavedAddressAsBilling(address.AddressId).then(function () {
                _this4.billingAddress = address;
                _this4.editMode = false;
            });
        }
    }]);

    return DeliverySaverBillingAddressController;
}();

DeliverySaverBillingAddressController.$inject = ['AddressService'];

var DeliverySaverBillingAddressComponentDefinition = {
    controller: DeliverySaverBillingAddressController,
    template: __webpack_require__(381).trim(),
    bindings: {
        billingAddress: '='
    }
};

module.exports = {
    DeliverySaverBillingAddressController: DeliverySaverBillingAddressController,
    DeliverySaverBillingAddressComponentDefinition: DeliverySaverBillingAddressComponentDefinition
};

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = "<div class=\"deliverySaverBillingAddress u-flex u-flexColumn\" ng-switch=\"$ctrl.editMode\">\r\n    <div class=\"deliverySaverBillingAddress-header\">\r\n        <span class=\"deliverySaverBillingAddress-headerIcon\"><i class=\"icon-appmenu_stores\"></i></span>\r\n        <span class=\"deliverySaverBillingAddress-headerText\">{{ $ctrl.editMode ? 'Enter your billing address:' : 'Billing address:' }}</span>\r\n    </div>\r\n\r\n    <div ng-switch-when=\"false\" class=\"deliverySaverBillingAddress-row\">\r\n        <div class=\"deliverySaverBillingAddress-display\">\r\n            <div>{{ $ctrl.billingAddress.AddressText }}</div>\r\n            <button class=\"linkButton\" ng-click=\"$ctrl.changeAddress()\">Change billing address</button>\r\n        </div>\r\n    </div>\r\n\r\n    <div ng-switch-when=\"true\">\r\n        <wow-loading-spinner ng-if=\"!$ctrl.savedAddresses\" message=\"Loading your saved addresses.\"></wow-loading-spinner>\r\n    </div>\r\n\r\n    <div ng-switch-when=\"true\" ng-if=\"$ctrl.savedAddresses && $ctrl.savedAddresses.length > 0\" class=\"deliverySaverBillingAddress-row\">\r\n        <fieldset class=\"deliverySaverBillingAddress-choices\">\r\n            <legend class=\"deliverySaverBillingAddress-legend\">\r\n                Previously used addresses\r\n            </legend>\r\n\r\n            <div class=\"deliverySaverBillingAddress-savedAddress\"\r\n                ng-repeat=\"address in $ctrl.savedAddresses track by address.AddressId\"\r\n            >\r\n                <input\r\n                    type=\"radio\"\r\n                    name=\"savedAddress\"\r\n                    id=\"address-{{ ::address.AddressId }}\"\r\n                    class=\"wowRadio\"\r\n                    ng-value=\"address.AddressId\"\r\n                    ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.savedAddressSelected(address)\"\r\n                    ng-checked=\"$ctrl.billingAddress.AddressId === address.AddressId\">\r\n                <label\r\n                    for=\"address-{{ ::address.AddressId }}\"\r\n                    ng-click=\"$ctrl.savedAddressSelected(address)\"\r\n                    wow-event-recorder=\"click\"\r\n                    data-er-category=\"Delivery Window\"\r\n                    data-er-label=\"Previously used address selection\">\r\n                    {{ ::address.AddressText }}\r\n                </label>\r\n            </div>\r\n        </fieldset>\r\n    </div>\r\n\r\n    <div ng-switch-when=\"true\" ng-if=\"$ctrl.savedAddresses\" class=\"deliverySaverBillingAddress-row\" >\r\n        <fieldset class=\"deliverySaverBillingAddress-addresses\">\r\n            <legend\r\n                class=\"deliverySaverBillingAddress-legend deliverySaverBillingAddress-search\"\r\n                ng-if=\"$ctrl.savedAddresses && $ctrl.savedAddresses.length > 0\"\r\n            >\r\n                Enter your new billing address\r\n            </legend>\r\n\r\n            <wow-address-entry-form\r\n                input-id=\"savedAddress\"\r\n                on-save-auto-address=\"$ctrl.saveNewAutoAddress(address)\"\r\n                on-save-manual-address=\"$ctrl.saveNewManualAddress(address)\"\r\n                should-focus-initially=\"false\"\r\n                should-reset-mode=\"false\"\r\n                show-submit=\"true\">\r\n            </wow-address-entry-form>\r\n        </fieldset>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyDeliverySaverController = function () {
    function MyDeliverySaverController($state, $scope, myDeliverySaverService, deliverySaverConstants, settings) {
        _classCallCheck(this, MyDeliverySaverController);

        this.$state = $state;
        this.$scope = $scope;
        this.myDeliverySaverService = myDeliverySaverService;
        this.deliverySaverConstants = deliverySaverConstants;
        this.settings = settings;
    }

    _createClass(MyDeliverySaverController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.isLoading = true;

            this.myDeliverySaverService.initalize().then(function () {
                _this.isLoading = false;
                if (_this.myDeliverySaverService.subscription) {
                    _this.cardExpiryReminderNotificationText = _this.settings.deliverySaver.cardExpiryReminderNotificationText.replace('{{ CardSuffix }}', _this.myDeliverySaverService.subscription.CardSuffix);
                }
            }).catch(function () {
                _this.$state.go('shop.deliveryplus', null, { location: 'replace' });
            });

            this.$scope.$on(this.deliverySaverConstants.PANEL_EXPANDED_EMIT_EVENT, function (event, scopeId) {
                return _this.onChildPanelExpanded(event, scopeId);
            });
            this.myCancelledSubscriptionNotificationMessage = this.settings.deliverySaver.myCancelledSubscriptionNotificationMessage.replace('{{ DiscoverPageUrl }}', this.settings.deliverySaver.discoverPageUrl);
        }

        /**
         * To build accordion functionality,
         * catch panelExpanded events from child scopes
         * and broadcast a panelExpanded event to their siblings
         * so that we can avoid using $rootScope
         * @param {*} event
         * @param {number} scopeId The scope ID of the panel that expanded
         */

    }, {
        key: 'onChildPanelExpanded',
        value: function onChildPanelExpanded(event, scopeId) {
            event.stopPropagation();
            this.$scope.$broadcast(this.deliverySaverConstants.PANEL_EXPANDED_BROADCAST_EVENT, scopeId);
        }
    }, {
        key: 'onMessageClicked',
        value: function onMessageClicked(event) {
            var sectionHref = event.target.getAttribute('section-href');
            if (!sectionHref) return;

            var panel = document.querySelector('wow-my-delivery-saver-panel[section="\'' + sectionHref + '\'"]');
            if (!panel) return;

            this.$scope.$broadcast(this.deliverySaverConstants.PANEL_EXPAND, sectionHref);
            panel.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
    }]);

    return MyDeliverySaverController;
}();

MyDeliverySaverController.$inject = ['$state', '$scope', 'MyDeliverySaverService', 'DeliverySaverConstants', 'Settings'];

var MyDeliverySaverComponentDefinition = {
    controller: MyDeliverySaverController,
    template: __webpack_require__(383).trim()
};

module.exports = {
    MyDeliverySaverController: MyDeliverySaverController,
    MyDeliverySaverComponentDefinition: MyDeliverySaverComponentDefinition
};

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports = "<div class=\"myDeliverySaver\">\r\n    <div ng-switch=\"$ctrl.isLoading\">\r\n        <wow-loading-spinner\r\n            ng-switch-when=\"true\"\r\n            message=\"Loading Delivery Plus details, please wait.\"\r\n            is-message-sr-only=\"true\">\r\n        </wow-loading-spinner>\r\n\r\n        <div ng-switch-when=\"false\">\r\n            <h1 class=\"myDeliverySaver-heading1\">My Delivery Plus</h1>\r\n            <div\r\n                ng-if=\"$ctrl.myDeliverySaverService.subscription\"\r\n                class=\"u-flex u-flexSpaceBetween u-flexCenterCross myDeliverySaver-discount\"\r\n            >\r\n                <h3 class=\"myDeliverySaver-discountText\">\r\n                    My <span class=\"hidden-sm\">delivery and packing </span>discounts since {{ $ctrl.myDeliverySaverService.subscription.StartDate | date: \"d MMMM, yyyy\" }}\r\n                </h3>\r\n                <wow-price\r\n                    price=\"$ctrl.myDeliverySaverService.totalDiscount\"\r\n                    price-class-modifier=\"myDeliverySaver-discountPrice\"\r\n                ></wow-price>\r\n            </div>\r\n            <hr ng-if=\"$ctrl.myDeliverySaverService.subscription\" class=\"myDeliverySaver-discountDivider\">\r\n\r\n            <wow-notification-message\r\n                ng-if=\"$ctrl.myDeliverySaverService.subscription.Status === 'Suspended'\"\r\n                is-dismissible=\"false\"\r\n                title=\"{{ $ctrl.settings.deliverySaver.suspendedNotificationTitle }}\"\r\n                type=\"warning\"\r\n                message=\"{{ $ctrl.settings.deliverySaver.suspendedNotificationText }}\"\r\n                on-message-clicked=\"$ctrl.onMessageClicked(event)\"\r\n                class=\"myDeliverySaver-notification\"\r\n            />\r\n\r\n            <wow-notification-message\r\n                ng-if=\"!$ctrl.myDeliverySaverService.subscription\"\r\n                title=\"{{ $ctrl.settings.deliverySaver.myCancelledSubscriptionNotificationTitle }}\"\r\n                is-dismissible=\"false\"\r\n                type=\"error\"\r\n                message=\"{{ $ctrl.myCancelledSubscriptionNotificationMessage }}\"\r\n                class=\"myDeliverySaver-notification\"\r\n            />\r\n\r\n            <wow-notification-message\r\n                ng-if=\"$ctrl.myDeliverySaverService.subscription && !!$ctrl.myDeliverySaverService.eligibility.HasCardExpiryReminder\"\r\n                title=\"{{ $ctrl.settings.deliverySaver.cardExpiryReminderNotificationTitle }}\"\r\n                is-dismissible=\"true\"\r\n                type=\"info\"\r\n                message=\"{{ $ctrl.cardExpiryReminderNotificationText }}\"\r\n                on-message-clicked=\"$ctrl.onMessageClicked(event)\"\r\n                class=\"myDeliverySaver-notification\"\r\n            />\r\n\r\n            <div class=\"myDeliverySaver-panelGroup\">\r\n                <div ng-if=\"$ctrl.myDeliverySaverService.subscription\">\r\n                    <wow-delivery-saver-subscription-detail\r\n                        subscription=\"$ctrl.myDeliverySaverService.subscription\"\r\n                        plan=\"$ctrl.myDeliverySaverService.plan\"\r\n                        short-title=\"true\";\r\n                    />\r\n                    <wow-my-delivery-saver-management />\r\n\r\n                    <wow-my-delivery-saver-panel ng-if=\"$ctrl.myDeliverySaverService.subscription.WillAutoRenew\" section=\"'paymentmethod'\" heading=\"'Update Payment Method'\">\r\n                        <wow-my-delivery-saver-payment-method subscription=\"$ctrl.myDeliverySaverService.subscription\"/>\r\n                    </wow-my-delivery-saver-panel>\r\n                </div>\r\n\r\n                <wow-my-delivery-saver-panel heading=\"'Delivery Plus Invoices'\">\r\n                    <wow-my-delivery-saver-payments payments=\"$ctrl.myDeliverySaverService.payments\"/>\r\n                </wow-my-delivery-saver-panel>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyDeliverySaverManagementController = function () {
    function MyDeliverySaverManagementController($state, $scope, $filter, myDeliverySaverService, dialogRegistry, settings) {
        _classCallCheck(this, MyDeliverySaverManagementController);

        this.$state = $state;
        this.$scope = $scope;
        this.$filter = $filter;
        this.myDeliverySaverService = myDeliverySaverService;
        this.dialogRegistry = dialogRegistry;
        this.settings = settings;
    }

    _createClass(MyDeliverySaverManagementController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loading = false;
            this.dialog = {
                CANCEL_CONFIRM: 'SUBSCRIPTION_CANCEL_CONFIRM',
                CANCEL_CONFIRMED: 'SUBSCRIPTION_CANCEL_CONFIRMED'
            };

            var endDate = this.$filter('date')(this.myDeliverySaverService.subscription.NextBillingDate, 'd MMMM, yyyy');
            var startDate = this.$filter('date')(this.myDeliverySaverService.subscription.StartDate, 'd MMMM, yyyy');
            var totalDiscount = this.$filter('currency')(this.myDeliverySaverService.totalDiscount);

            this.cancelSubscriptionConfirmationModalHtml = this.settings.deliverySaver.cancelSubscriptionConfirmationModalHtml.replace('{{ StartDate }}', startDate).replace('{{ TotalDiscount }}', totalDiscount).replace('{{ EndDate }}', endDate);

            this.cancelSubscriptionConfirmedModalHtml = this.settings.deliverySaver.cancelSubscriptionConfirmedModalHtml.replace('{{ EndDate }}', endDate);
        }
    }, {
        key: 'confirmCancel',
        value: function confirmCancel() {
            this.cancelDialog = this.dialogRegistry.getDialog(this.dialog.CANCEL_CONFIRM);
            this.cancelDialog.show();
        }
    }, {
        key: 'cancelSubscription',
        value: function cancelSubscription() {
            var _this = this;

            this.loading = true;
            this.myDeliverySaverService.cancelSubscription().then(function () {
                _this.loading = false;
                _this.dialogRegistry.getDialog(_this.dialog.CANCEL_CONFIRMED).show();
                _this.cancelDialog.close();
            });
        }
    }]);

    return MyDeliverySaverManagementController;
}();

MyDeliverySaverManagementController.$inject = ['$state', '$scope', '$filter', 'MyDeliverySaverService', 'DialogRegistry', 'Settings'];

var MyDeliverySaverManagementComponentDefinition = {
    controller: MyDeliverySaverManagementController,
    template: __webpack_require__(385).trim()
};

module.exports = {
    MyDeliverySaverManagementController: MyDeliverySaverManagementController,
    MyDeliverySaverManagementComponentDefinition: MyDeliverySaverManagementComponentDefinition
};

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports = "\r\n<wow-my-delivery-saver-panel heading=\"'Manage Subscription'\" ng-if=\"$ctrl.myDeliverySaverService.subscription.WillAutoRenew\" is-expanded=\"true\">\r\n    <div class=\"myDeliverySaver-manageSubscription\">\r\n        <p><wow-setting setting-group=\"DeliverySaver\" setting-name=\"CancelSubscriptionText\"></wow-setting></p>\r\n        <div class=\"myDeliverySaver-manageSubscriptionActions\">\r\n            <button\r\n                class=\"button button--large u-uppercase\"\r\n                ng-click=\"::$ctrl.confirmCancel()\"\r\n                wow-event-recorder=\"click\"\r\n                data-er-category=\"Delivery Plus\"\r\n                data-er-label=\"DSS: Cancel Subscription\"\r\n                data-er-name=\"link_click\"\r\n            >\r\n                Cancel Subscription\r\n                &nbsp;<i class=\"iconww-Cross\"></i>\r\n            </button>\r\n            <a ng-href=\"{{::$ctrl.settings.deliverySaver.tncsUrl}}\">Delivery Plus Terms & Conditions</a>\r\n        </div>\r\n    </div>\r\n</wow-my-delivery-saver-panel>\r\n\r\n<dialog name=\"{{::$ctrl.dialog.CANCEL_CONFIRM}}\" class=\"olyDialog olyDialog--confirmation-v2 myDeliverySaver-manageSubscriptionDialog\">\r\n    <div class=\"olyDialog-scrollableArea\" wow-hide-scroll wow-scrollbar>\r\n        <div class=\"olyDialog-wrapper myDeliverySaver-manageSubscriptionDialogWrapper u-flex u-flexCenter text-center u-flexColumn\">\r\n            <h1 class=\"myDeliverySaver-manageSubscriptionDialogHeading\">Are you sure?</h1>\r\n            <div ng-bind-html=\"$ctrl.cancelSubscriptionConfirmationModalHtml\"></div>\r\n        </div>\r\n    </div>\r\n    <footer class=\"olyDialog-buttons\">\r\n        <button\r\n            ng-disabled=\"$ctrl.loading\"\r\n            class=\"button olyDialog-buttonsCancel\"\r\n            ng-click=\"$ctrl.cancelDialog.close()\"\r\n            wow-event-recorder=\"click\"\r\n            data-er-category=\"Delivery Plus\"\r\n            data-er-label=\"DSS: Cancel Subscription Abort\"\r\n            data-er-name=\"link_click\"\r\n        >\r\n            <span>\r\n                <i class=\"iconww-ArrowLeft\"></i>\r\n                &nbsp;Back To My Account\r\n            </span>\r\n        </button>\r\n        <oly-button loading=\"{ state: $ctrl.loading, message: 'Cancelling subscription, please wait'}\" button-class=\"u-flexGrow\">\r\n            <button\r\n                class=\"button button--primaryDark\"\r\n                ng-click=\"::$ctrl.cancelSubscription()\"\r\n                wow-event-recorder=\"click\"\r\n                data-er-category=\"Delivery Plus\"\r\n                data-er-label=\"DSS: Cancel Subscription Confirm\"\r\n                data-er-name=\"link_click\"\r\n            >\r\n                <span>\r\n                    Cancel Subscription&nbsp;\r\n                    <i class=\"iconww-Cross\"></i>\r\n                </span>\r\n            </button>\r\n        </oly-button>\r\n    </footer>\r\n</dialog>\r\n\r\n<dialog name=\"{{::$ctrl.dialog.CANCEL_CONFIRMED}}\" class=\"olyDialog olyDialog--confirmation-v2 myDeliverySaver-manageSubscriptionDialog\">\r\n    <div class=\"olyDialog-scrollableArea\" wow-hide-scroll wow-scrollbar>\r\n        <div class=\"olyDialog-wrapper myDeliverySaver-manageSubscriptionDialogWrapper u-flex u-flexCenter text-center u-flexColumn\">\r\n            <h1 class=\"myDeliverySaver-manageSubscriptionDialogHeading\">We're sorry to see you go</h1>\r\n            <div ng-bind-html=\"$ctrl.cancelSubscriptionConfirmedModalHtml\"></div>\r\n        </div>\r\n    </div>\r\n    <footer class=\"olyDialog-buttons\">\r\n        <button\r\n            oly-dialog-close\r\n            return=\"true\"\r\n            ng-disabled=\"$ctrl.loading\"\r\n            class=\"button olyDialog-buttonsCancel\"\r\n        >\r\n            <span>\r\n                <i class=\"iconww-ArrowLeft\"></i>\r\n                &nbsp;Back To My Account\r\n            </span>\r\n        </button>\r\n        <a class=\"button button--primary u-flex u-flexCenter\" ui-sref=\"root\">\r\n            <span>\r\n                Start Shopping&nbsp;\r\n                <i class=\"iconww-ArrowRight\"></i>\r\n            </span>\r\n        </a>\r\n    </footer>\r\n</dialog>\r\n"

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyDeliverySaverPanelController = function () {
    function MyDeliverySaverPanelController($scope, deliverySaverConstants) {
        _classCallCheck(this, MyDeliverySaverPanelController);

        this.$scope = $scope;
        this.deliverySaverConstants = deliverySaverConstants;
    }

    _createClass(MyDeliverySaverPanelController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.isExpanded = false;
            this.$scope.$on(this.deliverySaverConstants.PANEL_EXPANDED_BROADCAST_EVENT, function (event, id) {
                return _this.onSiblingPanelExpanded(id);
            });
            this.$scope.$on(this.deliverySaverConstants.PANEL_EXPAND, function (event, section) {
                return _this.onExpandBroadcast(section);
            });
        }
    }, {
        key: 'toggleExpanded',
        value: function toggleExpanded() {
            this.isExpanded = !this.isExpanded;
            if (this.isExpanded) {
                this.$scope.$emit(this.deliverySaverConstants.PANEL_EXPANDED_EMIT_EVENT, this.$scope.$id);
            }
        }
    }, {
        key: 'onExpandBroadcast',
        value: function onExpandBroadcast(section) {
            if (this.section === section && !this.isExpanded) {
                this.isExpanded = true;
            }
        }

        /**
         * Collapse this panel when the parent scope tells me
         * one of my brother scopes has expanded
         * @param {number} scopeId The scope ID of the panel that expanded
         */

    }, {
        key: 'onSiblingPanelExpanded',
        value: function onSiblingPanelExpanded(scopeId) {
            if (scopeId !== this.$scope.$id) {
                this.isExpanded = false;
            }
        }
    }]);

    return MyDeliverySaverPanelController;
}();

MyDeliverySaverPanelController.$inject = ['$scope', 'DeliverySaverConstants'];

var MyDeliverySaverPanelComponentDefinition = {
    bindings: {
        heading: '<',
        isExpanded: '<',
        section: '<'
    },
    transclude: true,
    controller: MyDeliverySaverPanelController,
    template: __webpack_require__(387).trim()
};

module.exports = {
    MyDeliverySaverPanelController: MyDeliverySaverPanelController,
    MyDeliverySaverPanelComponentDefinition: MyDeliverySaverPanelComponentDefinition
};

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports = "<div class=\"myDeliverySaver-panel\" ng-class=\"{'myDeliverySaver-panel--expanded': $ctrl.isExpanded}\">\r\n    <button class=\"myDeliverySaver-panelHeading\" ng-click=\"$ctrl.toggleExpanded()\" aria-expanded=\"{{$ctrl.isExpanded}}\">\r\n        <h2 class=\"myDeliverySaver-panelTitle\">{{$ctrl.heading}}</h2>\r\n        <i ng-class=\"$ctrl.isExpanded ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n    </button>\r\n    <div class=\"myDeliverySaver-panelBody\" ng-class=\"{'collapse': !$ctrl.isExpanded}\" ng-transclude>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyDeliverySaverPaymentMethodController = function () {
    function MyDeliverySaverPaymentMethodController($state, myDeliverySaverService, settings) {
        _classCallCheck(this, MyDeliverySaverPaymentMethodController);

        this.$state = $state;
        this.myDeliverySaverService = myDeliverySaverService;
        this.settings = settings;
    }

    _createClass(MyDeliverySaverPaymentMethodController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loading = false;
            this.isRetrySuccess = false;
            this.isRetryAttempted = false;

            this.lastPayment = this.myDeliverySaverService.lastPayment;
            this.isPaymentFailure = this.lastPayment && this.lastPayment.Status === 'Failure' && this.subscription.Status === 'Suspended';
        }
    }, {
        key: 'retryPayment',
        value: function retryPayment() {
            var _this = this;

            this.loading = true;
            this.isRetryAttempted = false;

            this.myDeliverySaverService.retryPayment().then(function () {
                _this.isRetrySuccess = true;
                _this.isPaymentFailure = false;
            }).catch(function () {
                _this.isRetrySuccess = false;
            }).finally(function () {
                _this.loading = false;
                _this.isRetryAttempted = true;
            });
        }
    }]);

    return MyDeliverySaverPaymentMethodController;
}();

MyDeliverySaverPaymentMethodController.$inject = ['$state', 'MyDeliverySaverService', 'Settings'];

var MyDeliverySaverPaymentMethodComponentDefinition = {
    bindings: {
        subscription: '<'
    },
    controller: MyDeliverySaverPaymentMethodController,
    template: __webpack_require__(389).trim()
};

module.exports = {
    MyDeliverySaverPaymentMethodComponentDefinition: MyDeliverySaverPaymentMethodComponentDefinition
};

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "<wow-notification-message\r\n    class=\"myDeliverySaver-paymentMethodNotification\"\r\n    is-dismissible=\"false\"\r\n    title=\"{{ $ctrl.settings.deliverySaver.paymentRetryFailureNotificationTitle }}\"\r\n    type=\"error\"\r\n    message=\"{{ $ctrl.settings.deliverySaver.paymentRetryFailureNotificationText }}\"\r\n    ng-if=\"$ctrl.isRetryAttempted && !$ctrl.isRetrySuccess\"\r\n/>\r\n\r\n<wow-notification-message\r\n    class=\"myDeliverySaver-paymentMethodNotification\"\r\n    title=\"{{ $ctrl.settings.deliverySaver.paymentRetrySuccessNotificationTitle }}\"\r\n    type=\"success\"\r\n    message=\"{{ $ctrl.settings.deliverySaver.paymentRetrySuccessNotificationText }}\"\r\n    ng-if=\"$ctrl.isRetryAttempted && $ctrl.isRetrySuccess\"\r\n/>\r\n\r\n<div class=\"myDeliverySaver-paymentMethodRow u-flex u-flexSpaceBetween\" ng-if=\"$ctrl.isPaymentFailure\">\r\n    <h3 class=\"myDeliverySaver-paymentMethodRowHeading\">Outstanding Amount</h3>\r\n    <span>{{ $ctrl.lastPayment.Amount | currency }}</span>\r\n</div>\r\n\r\n<div class=\"myDeliverySaver-paymentMethodRow u-flex u-flexSpaceBetween\" ng-if=\"$ctrl.isPaymentFailure\">\r\n    <h3 class=\"myDeliverySaver-paymentMethodRowHeading\">Payment Date</h3>\r\n    <span>{{ $ctrl.lastPayment.PaymentDate | date:'yyyy-MM-dd' }}</span>\r\n</div>\r\n\r\n<div class=\"myDeliverySaver-paymentMethodRow u-flex\">\r\n    <img ng-src=\"/images/checkout/digitalPay/icon-{{::$ctrl.subscription.CardScheme}}.svg\" alt=\"{{$ctrl.subscription.CardScheme}}\" class=\"myDeliverySaver-paymentMethodCardScheme\"/>\r\n    <div>\r\n        <span class=\"myDeliverySaver-paymentMethodCardNumber\">{{ $ctrl.subscription.CardSuffix | wowMaskCardNumber }}</span><br/>\r\n        <span\r\n            class=\"myDeliverySaver-paymentMethodCardExpiry\"\r\n            ng-if=\"$ctrl.subscription.CardExpiryMonth && $ctrl.subscription.CardExpiryYear\">\r\n                Expires {{ ::$ctrl.subscription.CardExpiryMonth }}/{{ ::$ctrl.subscription.CardExpiryYear }}\r\n        </span>\r\n    </div>\r\n</div>\r\n\r\n<a\r\n    ng-if=\"!$ctrl.isPaymentFailure\"\r\n    ui-sref=\"shop.deliveryplus.paymentupdate\"\r\n    class=\"myDeliverySaver-paymentMethodUpdateLink\">\r\n    Update Payment Method\r\n</a>\r\n\r\n<div class=\"myDeliverySaver-paymentMethodRow\" ng-if=\"$ctrl.isPaymentFailure\">\r\n    <h3>{{ $ctrl.settings.deliverySaver.paymentFailureDisclaimerTitle }}</h3>\r\n    <p>{{ $ctrl.settings.deliverySaver.paymentFailureDisclaimerText }}</p>\r\n    <div class=\"u-flex u-flexWrap myDeliverySaver-paymentMethodActions\">\r\n        <oly-button\r\n            loading=\"{ state: $ctrl.loading, message: 'Retrying payment, please wait...'}\"\r\n            button-class=\"u-flexGrow u-flexCenter button button--primaryDark\"\r\n            class=\" myDeliverySaver-paymentMethodActionsButton\"\r\n            ng-click=\"::$ctrl.retryPayment()\"\r\n        >\r\n            Retry payment\r\n        </oly-button>\r\n        <a\r\n            ui-sref=\"shop.deliveryplus.paymentupdate\"\r\n            class=\"button myDeliverySaver-paymentMethodActionsButton\"\r\n        >\r\n            Update payment details\r\n            &nbsp;<i class=\"iconww-ArrowRight\"></i>\r\n        </a>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MyDeliverySaverPaymentsComponentDefinition = {
    bindings: {
        payments: '<'
    },
    template: __webpack_require__(391).trim()
};

module.exports = {
    MyDeliverySaverPaymentsComponentDefinition: MyDeliverySaverPaymentsComponentDefinition
};

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = "<table class=\"myDeliverySaver-payments\">\r\n    <tr ng-repeat=\"payment in $ctrl.payments | filter: { Status: 'Success' } | orderBy: 'PaymentDate':true\">\r\n        <td>{{payment.PaymentDate | date: \"dd/MM/yy\"}}</td>\r\n        <td>{{payment.Amount | currency}}</td>\r\n    </tr>\r\n</table>\r\n"

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * To be used in the context of "Billed and renewed <billingFrequency>"
 */
module.exports = function () {
    return function (deliverySaverPlan) {
        if (deliverySaverPlan) {
            if (deliverySaverPlan.BillingFrequencyDays === 0) {
                switch (deliverySaverPlan.BillingFrequencyMonths) {
                    case 1:
                        return 'monthly';
                    case 12:
                        return 'annually';
                    default:
                        return 'every ' + deliverySaverPlan.BillingFrequencyMonths + ' months';
                }
            } else if (deliverySaverPlan.BillingFrequencyMonths === 0) {
                switch (deliverySaverPlan.BillingFrequencyDays) {
                    case 1:
                        return 'daily';
                    case 7:
                        return 'weekly';
                    default:
                        return 'every ' + deliverySaverPlan.BillingFrequencyDays + ' days';
                }
            }
            var months = deliverySaverPlan.BillingFrequencyMonths === 1 ? 'month' : 'months';
            var days = deliverySaverPlan.BillingFrequencyDays === 1 ? 'day' : 'days';
            return 'every ' + deliverySaverPlan.BillingFrequencyMonths + ' ' + months + ' ' + deliverySaverPlan.BillingFrequencyDays + ' ' + days;
        }
        return '';
    };
};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * To be used in the context of "$XX<billingFrequencyUnit>"
 */
module.exports = function () {
    return function () {
        var deliverySaverPlan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (deliverySaverPlan.BillingFrequencyDays === 0) {
            switch (deliverySaverPlan.BillingFrequencyMonths) {
                case 1:
                    return '/month';
                case 12:
                    return '/year';
                default:
                    return '/' + deliverySaverPlan.BillingFrequencyMonths + ' months';
            }
        } else if (deliverySaverPlan.BillingFrequencyMonths === 0) {
            switch (deliverySaverPlan.BillingFrequencyDays) {
                case 1:
                    return '/day';
                case 7:
                    return '/week';
                default:
                    return '/' + deliverySaverPlan.BillingFrequencyDays + ' days';
            }
        }
        return '';
    };
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return function () {
        var deliverySaverPlan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (deliverySaverPlan.BillingFrequencyDays === 0) {
            switch (deliverySaverPlan.BillingFrequencyMonths) {
                case 1:
                    return 'Monthly payment amount';
                case 12:
                    return 'Annual payment amount';
            }
        } else if (deliverySaverPlan.BillingFrequencyMonths === 0) {
            switch (deliverySaverPlan.BillingFrequencyDays) {
                case 1:
                    return 'Daily payment amount';
                case 7:
                    return 'Weekly payment amount';
            }
        }
        return 'Payment amount';
    };
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    return function () {
        var deliverySaverPlan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (deliverySaverPlan.IsAnyDay) {
            return 'Delivery Plus Anyday';
        } else if (deliverySaverPlan.IsMidweek) {
            return 'Delivery Plus Midweek';
        }
        return 'Delivery Plus';
    };
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deliverySaverShortNameFilter = __webpack_require__(36);

module.exports = function () {
    return function () {
        var deliverySaverPlan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var shortName = deliverySaverShortNameFilter()(deliverySaverPlan);
        if (deliverySaverPlan.IsAnyDay) {
            return 'Anyday, ' + shortName;
        } else if (deliverySaverPlan.IsMidweek) {
            return 'Midweek, ' + shortName;
        }
        return shortName;
    };
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeliverySaverService = function () {
    function DeliverySaverService(RestangularV3) {
        _classCallCheck(this, DeliverySaverService);

        this.api = RestangularV3.one('deliverysaver');
    }

    _createClass(DeliverySaverService, [{
        key: 'getEligibility',
        value: function getEligibility() {
            return this.api.one('eligibility').get();
        }
    }, {
        key: 'listPlans',
        value: function listPlans() {
            return this.api.one('plans').get();
        }
    }, {
        key: 'getPlan',
        value: function getPlan(id) {
            return this.api.one('plans/' + id).get();
        }
    }, {
        key: 'getPayments',
        value: function getPayments() {
            return this.api.one('payments').get();
        }
    }, {
        key: 'getDiscounts',
        value: function getDiscounts() {
            return this.api.one('discounts').get();
        }
    }, {
        key: 'subscribe',
        value: function subscribe(planId, paymentInstrument) {
            return this.api.post('subscription', {
                planId: planId,
                paymentInstrumentId: paymentInstrument.paymentInstrumentId,
                stepUpToken: paymentInstrument.stepUpToken
            });
        }
    }, {
        key: 'getSubscription',
        value: function getSubscription() {
            return this.api.one('subscription').get();
        }
    }, {
        key: 'cancelSubscription',
        value: function cancelSubscription() {
            return this.api.post('subscription/cancel');
        }
    }, {
        key: 'updatePaymentInstrument',
        value: function updatePaymentInstrument(paymentInstrument) {
            return this.api.post('subscription/paymentinstrument', {
                paymentInstrumentId: paymentInstrument.paymentInstrumentId,
                stepUpToken: paymentInstrument.stepUpToken
            });
        }
    }, {
        key: 'UpdateCardExpiryDate',
        value: function UpdateCardExpiryDate(paymentInstrument) {
            return this.api.post('subscription/cardexpirydate', {
                paymentInstrumentId: paymentInstrument.paymentInstrumentId,
                cardExpiryYear: paymentInstrument.cardExpiryYear,
                cardExpiryMonth: paymentInstrument.cardExpiryMonth
            });
        }
    }, {
        key: 'retryPayment',
        value: function retryPayment() {
            return this.api.post('subscription/retrypayment');
        }
    }]);

    return DeliverySaverService;
}();

DeliverySaverService.$inject = ['RestangularV3'];

module.exports = { DeliverySaverService: DeliverySaverService };

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyDeliverySaverService = function () {
    function MyDeliverySaverService($q, deliverySaverService) {
        _classCallCheck(this, MyDeliverySaverService);

        this.$q = $q;
        this.deliverySaverService = deliverySaverService;
    }

    _createClass(MyDeliverySaverService, [{
        key: 'initalize',
        value: function initalize() {
            this.subscription = null;
            this.eligibility = null;
            this.payments = [];
            this.lastPayment = null;
            this.discounts = [];
            this.totalDiscount = 0;
            this.loading = true;

            return this.$q.all([this.loadPayments(), this.loadSubscription(), this.loadDiscounts(), this.loadEligibility()]);
        }
    }, {
        key: 'loadPayments',
        value: function loadPayments() {
            var _this = this;

            return this.deliverySaverService.getPayments().then(function (data) {
                _this.payments = data.Payments;
                _this.lastPayment = _this.payments && _this.payments.sort(function (a, b) {
                    if (a.PaymentDate > b.PaymentDate) return -1;
                    if (a.PaymentDate < b.PaymentDate) return 1;
                    return 0;
                })[0];
            });
        }
    }, {
        key: 'loadDiscounts',
        value: function loadDiscounts() {
            var _this2 = this;

            return this.deliverySaverService.getDiscounts().then(function (data) {
                _this2.discounts = data.Discounts;
                _this2.totalDiscount = _this2.discounts.reduce(function (a, c) {
                    return a + c.TotalDiscount;
                }, 0);
            });
        }
    }, {
        key: 'loadSubscription',
        value: function loadSubscription() {
            var _this3 = this;

            return this.deliverySaverService.getSubscription().then(function (data) {
                if (data.Subscription.Status !== 'Cancelled') {
                    _this3.subscription = data.Subscription;
                    _this3.plan = data.Plan;
                }
            });
        }
    }, {
        key: 'loadEligibility',
        value: function loadEligibility() {
            var _this4 = this;

            return this.deliverySaverService.getEligibility().then(function (data) {
                _this4.eligibility = data;
            });
        }
    }, {
        key: 'retryPayment',
        value: function retryPayment() {
            var _this5 = this;

            return this.deliverySaverService.retryPayment().then(function (updateResponse) {
                _this5.subscription = updateResponse.Subscription;
                return _this5.loadPayments();
            });
        }
    }, {
        key: 'cancelSubscription',
        value: function cancelSubscription() {
            var _this6 = this;

            return this.deliverySaverService.cancelSubscription().then(function (cancelResponse) {
                _this6.subscription = cancelResponse.Subscription;
            });
        }
    }]);

    return MyDeliverySaverService;
}();

MyDeliverySaverService.$inject = ['$q', 'DeliverySaverService'];

module.exports = { MyDeliverySaverService: MyDeliverySaverService };

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeliverySaverAnalytics = function () {
    function DeliverySaverAnalytics(analytics) {
        _classCallCheck(this, DeliverySaverAnalytics);

        this.analytics = analytics;
    }

    _createClass(DeliverySaverAnalytics, [{
        key: 'push',
        value: function push(deliveryPlus) {
            this.analytics.push({ data: deliveryPlus, type: this.analytics.mapperTypes.deliveryPlus });
        }
    }]);

    return DeliverySaverAnalytics;
}();

DeliverySaverAnalytics.$inject = ['AnalyticsService'];

module.exports = { DeliverySaverAnalytics: DeliverySaverAnalytics };

/***/ }),
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($state, $q, loginService, authMethod, loginAuthMessage) {
    $q.when($state.transition).then(function (targetState) {
        if (authMethod !== 'Shopper' && authMethod !== 'Impersonate') {
            loginService.promptForLogin(loginAuthMessage, targetState);
        }
    });
};

/***/ }),
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);
var uiRouter = __webpack_require__(6);
var ocLazyLoad = __webpack_require__(45);
var restangular = __webpack_require__(4); // eslint-disable-line no-unused-vars
var angularToolTip = __webpack_require__(873); // eslint-disable-line no-unused-vars

// General Modules
var olyCommonModule = __webpack_require__(3);
var wowCommonModule = __webpack_require__(5);
var shopModule = __webpack_require__(79);
var analyticsModule = __webpack_require__(8);

// modules that is used acorss the whole site.
var inspirationModule = __webpack_require__(875); // required by shop.
var searchModule = __webpack_require__(954);
var authModule = __webpack_require__(47);
var orderModule = __webpack_require__(971);
var fulfilmentModule = __webpack_require__(999);

// Aplication declaration.
angular.module('wowApp', [olyCommonModule, wowCommonModule, shopModule, analyticsModule, inspirationModule, searchModule, authModule, fulfilmentModule, orderModule, uiRouter, ocLazyLoad, 'restangular', '720kb.tooltips']);

// Application configuration.
__webpack_require__(1055);

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;/*global require,module*/
(function commonJS(require, module) {
  'use strict';

  __webpack_require__(874);

  module.exports = '720kb.tooltips';
}(require, module));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(516)(module)))

/***/ }),
/* 874 */
/***/ (function(module, exports) {

/*
 * angular-tooltips
 * 1.2.2
 * 
 * Angular.js tooltips module.
 * http://720kb.github.io/angular-tooltips
 * 
 * MIT license
 * Tue Jun 20 2017
 */
/*global angular,window*/
(function withAngular(angular, window) {
  'use strict';

  var directiveName = 'tooltips'
  , resizeObserver = (function resizeObserver() {

    var callbacks = []
      , lastTime = 0
      , runCallbacks = function runCallbacks(currentTime) {

        if (currentTime - lastTime >= 15) {

          callbacks.forEach(function iterator(callback) {

            callback();
          });
          lastTime = currentTime;
        } else {

          window.console.log('Skipped!');
        }
      }
      , resizeTimeout
      , resize = function resize() {
        window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(function onResizeTimeout() {
          window.requestAnimationFrame(runCallbacks);
        }, 500);
      }
      , addCallback = function addCallback(callback) {

        if (callback) {

          callbacks.push(callback);
        }
      };

    return {
      'add': function add(callback) {

        if (!callbacks.length) {

          window.addEventListener('resize', resize);
        }
        addCallback(callback);
      },
      'remove': function remove() {
        if (!callbacks.length) {
          window.clearTimeout(resizeTimeout);
          window.removeEventListener('resize', resize);
        }
      }
    };
  }())
  , getAttributesToAdd = function getAttributesToAdd(element) {
    var attributesToAdd = {};

    element.removeAttr(directiveName);
    if (element.attr('tooltip-template') !== undefined) {

      attributesToAdd['tooltip-template'] = element.attr('tooltip-template');
      element.removeAttr('tooltip-template');
    }

    if (element.attr('tooltip-template-url') !== undefined) {

      attributesToAdd['tooltip-template-url'] = element.attr('tooltip-template-url');
      element.removeAttr('tooltip-template-url');
    }

    if (element.attr('tooltip-template-url-cache') !== undefined) {

      attributesToAdd['tooltip-template-url-cache'] = element.attr('tooltip-template-url-cache');
      element.removeAttr('tooltip-template-url-cache');
    }

    if (element.attr('tooltip-controller') !== undefined) {

      attributesToAdd['tooltip-controller'] = element.attr('tooltip-controller');
      element.removeAttr('tooltip-controller');
    }

    if (element.attr('tooltip-side') !== undefined) {

      attributesToAdd['tooltip-side'] = element.attr('tooltip-side');
      element.removeAttr('tooltip-side');
    }

    if (element.attr('tooltip-show-trigger') !== undefined) {

      attributesToAdd['tooltip-show-trigger'] = element.attr('tooltip-show-trigger');
      element.removeAttr('tooltip-show-trigger');
    }

    if (element.attr('tooltip-hide-trigger') !== undefined) {

      attributesToAdd['tooltip-hide-trigger'] = element.attr('tooltip-hide-trigger');
      element.removeAttr('tooltip-hide-trigger');
    }

    if (element.attr('tooltip-smart') !== undefined) {

      attributesToAdd['tooltip-smart'] = element.attr('tooltip-smart');
      element.removeAttr('tooltip-smart');
    }

    if (element.attr('tooltip-class') !== undefined) {

      attributesToAdd['tooltip-class'] = element.attr('tooltip-class');
      element.removeAttr('tooltip-class');
    }

    if (element.attr('tooltip-show') !== undefined) {

      attributesToAdd['tooltip-show'] = element.attr('tooltip-show');
      element.removeAttr('tooltip-show');
    }

    if (element.attr('tooltip-close-button') !== undefined) {

      attributesToAdd['tooltip-close-button'] = element.attr('tooltip-close-button');
      element.removeAttr('tooltip-close-button');
    }

    if (element.attr('tooltip-size') !== undefined) {

      attributesToAdd['tooltip-size'] = element.attr('tooltip-size');
      element.removeAttr('tooltip-size');
    }

    if (element.attr('tooltip-speed') !== undefined) {

      attributesToAdd['tooltip-speed'] = element.attr('tooltip-speed');
      element.removeAttr('tooltip-speed');
    }

    return attributesToAdd;
  }
  , getStyle = function getStyle(anElement) {

    if (window.getComputedStyle) {

      return window.getComputedStyle(anElement, '');
    } else if (anElement.currentStyle) {

      return anElement.currentStyle;
    }
  }
  , getAppendedTip = function getAppendedTip(theTooltipElement) {
    var tipsInBody = window.document.querySelectorAll('._exradicated-tooltip')
      , aTipInBody
      , tipsInBodyIndex = 0
      , tipsInBodyLength = tipsInBody.length
      , angularizedElement;

    for (; tipsInBodyIndex < tipsInBodyLength; tipsInBodyIndex += 1) {

      aTipInBody = tipsInBody.item(tipsInBodyIndex);
      if (aTipInBody) {

        angularizedElement = angular.element(aTipInBody);
        if (angularizedElement.data('_tooltip-parent') &&
          angularizedElement.data('_tooltip-parent') === theTooltipElement) {

          return angularizedElement;
        }
      }
    }
  }
  , removeAppendedTip = function removeAppendedTip(theTooltipElement) {
    var tipElement = getAppendedTip(theTooltipElement);

    if (tipElement) {

      tipElement.remove();
    }
  }
  , isOutOfPage = function isOutOfPage(theTipElement) {

    if (theTipElement) {
      var squarePosition = theTipElement[0].getBoundingClientRect();

      if (squarePosition.top < 0 ||
        squarePosition.top > window.document.body.offsetHeight ||
        squarePosition.left < 0 ||
        squarePosition.left > window.document.body.offsetWidth ||
        squarePosition.bottom < 0 ||
        squarePosition.bottom > window.document.body.offsetHeight ||
        squarePosition.right < 0 ||
        squarePosition.right > window.document.body.offsetWidth) {

        theTipElement.css({
          'top': '',
          'left': '',
          'bottom': '',
          'right': ''
        });
        return true;
      }

      return false;
    }

    throw new Error('You must provide a position');
  }
  , getSideClasses = function getSideClasses(sides) {
    
    return sides.split(' ').map(function mapSideClasses(side) {
      
      return '_' + side;
    }).join(' ');
  }
  , directions = ['_top', '_top _left', '_left', '_bottom _left', '_bottom', '_bottom _right', '_right', '_top _right']
  , smartPosition = function smartPosition(tipElement, tooltipElement, startSide) {
    
    var directionsIndex = directions.indexOf(getSideClasses(startSide))
      , directionsLength = directions.length
      , directionsCount = 0;
    
    for (; directionsCount < directionsLength && isOutOfPage(tipElement); directionsCount += 1) {
      
      directionsIndex += 1;
      if (directionsIndex >= directions.length) {
        
        directionsIndex = 0;
      }
      tooltipElement.removeClass('_top _left _bottom _right');
      tooltipElement.addClass(directions[directionsIndex]);
    }
  }
  , tooltipConfigurationProvider = function tooltipConfigurationProvider() {

    var tooltipConfiguration = {
      'side': 'top',
      'showTrigger': 'mouseenter',
      'hideTrigger': 'mouseleave',
      'class': '',
      'smart': false,
      'closeButton': false,
      'size': '',
      'speed': 'steady',
      'tooltipTemplateUrlCache': false,
      'show': null
    };

    return {
      'configure': function configure(configuration) {
        var configurationKeys = Object.keys(tooltipConfiguration)
          , configurationIndex = 0
          , aConfigurationKey;

        if (configuration) {

          for (; configurationIndex < configurationKeys.length; configurationIndex += 1) {

            aConfigurationKey = configurationKeys[configurationIndex];
            if (aConfigurationKey &&
              configuration[aConfigurationKey]) {

              tooltipConfiguration[aConfigurationKey] = configuration[aConfigurationKey];
            }
          }
        }
      },
      '$get': /*@ngInject*/ function instantiateProvider() {

        return tooltipConfiguration;
      }
    };
  }
  , tooltipDirective = /*@ngInject*/ ['$log', '$http', '$compile', '$timeout', '$controller', '$injector', 'tooltipsConf', '$templateCache', '$q', function tooltipDirective($log, $http, $compile, $timeout, $controller, $injector, tooltipsConf, $templateCache, $q) {

    var linkingFunction = function linkingFunction($scope, $element, $attrs, $controllerDirective, $transcludeFunc) {

      if ($attrs.tooltipTemplate &&
        $attrs.tooltipTemplateUrl) {

        throw new Error('You can not define tooltip-template and tooltip-template-url together');
      }

      if (!($attrs.tooltipTemplateUrl || $attrs.tooltipTemplate) &&
        $attrs.tooltipController) {

        throw new Error('You can not have a controller without a template or templateUrl defined');
      }

      var oldTooltipSide = getSideClasses(tooltipsConf.side)
        , oldTooltipShowTrigger = tooltipsConf.showTrigger
        , oldTooltipHideTrigger = tooltipsConf.hideTrigger
        , oldTooltipClass
        , oldSize = tooltipsConf.size
        , oldSpeed = '_' + tooltipsConf.speed;

      $attrs.tooltipSide = $attrs.tooltipSide || tooltipsConf.side;
      $attrs.tooltipShowTrigger = $attrs.tooltipShowTrigger || tooltipsConf.showTrigger;
      $attrs.tooltipHideTrigger = $attrs.tooltipHideTrigger || tooltipsConf.hideTrigger;
      $attrs.tooltipShow = $attrs.tooltipShow || tooltipsConf.show;
      $attrs.tooltipClass = $attrs.tooltipClass || tooltipsConf.class;
      $attrs.tooltipSmart = $attrs.tooltipSmart === 'true' || tooltipsConf.smart;
      $attrs.tooltipCloseButton = $attrs.tooltipCloseButton || tooltipsConf.closeButton.toString();
      $attrs.tooltipSize = $attrs.tooltipSize || tooltipsConf.size;
      $attrs.tooltipSpeed = $attrs.tooltipSpeed || tooltipsConf.speed;
      $attrs.tooltipAppendToBody = $attrs.tooltipAppendToBody === 'true';

      $transcludeFunc($scope, function onTransclusionDone(element, scope) {
        var attributes = getAttributesToAdd(element)
          , tooltipElement = angular.element(window.document.createElement('tooltip'))
          , tipContElement = angular.element(window.document.createElement('tip-cont'))
          , tipElement = angular.element(window.document.createElement('tip'))
          , tipTipElement = angular.element(window.document.createElement('tip-tip'))
          , closeButtonElement = angular.element(window.document.createElement('span'))
          , tipArrowElement = angular.element(window.document.createElement('tip-arrow'))
          , whenActivateMultilineCalculation = function whenActivateMultilineCalculation() {

            return tipContElement.html();
          }
          , calculateIfMultiLine = function calculateIfMultiLine(newValue) {

            if (newValue !== undefined &&
              tipContElement[0].getClientRects().length > 1) {

              tooltipElement.addClass('_multiline');
            } else {

              tooltipElement.removeClass('_multiline');
            }
          }
          , onTooltipShow = function onTooltipShow(event) {

            if (event && !tooltipElement.hasClass('active')) {
              
              event.stopImmediatePropagation();
            }

            tipElement.addClass('_hidden');
            if ($attrs.tooltipSmart) {

              switch ($attrs.tooltipSide) {
                case 'top':
                case 'left':
                case 'bottom':
                case 'right':
                case 'top left':
                case 'top right':
                case 'bottom left':
                case 'bottom right': {

                  smartPosition(tipElement, tooltipElement, $attrs.tooltipSide);
                  break;
                }
                
                default: {

                  throw new Error('Position not supported');
                }
              }
            }

            if ($attrs.tooltipAppendToBody) {

              var tipTipElementStyle = getStyle(tipTipElement[0])
                , tipArrowElementStyle = getStyle(tipArrowElement[0])
                , tipElementStyle = getStyle(tipElement[0])
                , tipElementBoundingClientRect = tipElement[0].getBoundingClientRect()
                , exradicatedTipElement = angular.copy(tipElement)
                , tipTipStyleIndex = 0
                , tipTipStyleLength = tipTipElementStyle.length
                , tipArrowStyleIndex = 0
                , tipArrowStyleLength = tipArrowElementStyle.length
                , tipStyleIndex = 0
                , tipStyleLength = tipElementStyle.length
                , aStyleKey
                , tipTipCssToSet = {}
                , tipCssToSet = {}
                , tipArrowCssToSet = {}
                , paddingTopValue
                , paddingBottomValue
                , paddingLeftValue
                , paddingRightValue;

              tipElement.removeClass('_hidden');
              exradicatedTipElement.removeClass('_hidden');
              exradicatedTipElement.data('_tooltip-parent', tooltipElement);
              removeAppendedTip(tooltipElement);

              for (; tipTipStyleIndex < tipTipStyleLength; tipTipStyleIndex += 1) {

                aStyleKey = tipTipElementStyle[tipTipStyleIndex];
                if (aStyleKey &&
                  tipTipElementStyle.getPropertyValue(aStyleKey)) {

                  tipTipCssToSet[aStyleKey] = tipTipElementStyle.getPropertyValue(aStyleKey);
                }
              }

              for (; tipArrowStyleIndex < tipArrowStyleLength; tipArrowStyleIndex += 1) {

                aStyleKey = tipArrowElementStyle[tipArrowStyleIndex];
                if (aStyleKey &&
                  tipArrowElementStyle.getPropertyValue(aStyleKey)) {

                  tipArrowCssToSet[aStyleKey] = tipArrowElementStyle.getPropertyValue(aStyleKey);
                }
              }

              for (; tipStyleIndex < tipStyleLength; tipStyleIndex += 1) {

                aStyleKey = tipElementStyle[tipStyleIndex];
                if (aStyleKey &&
                    aStyleKey !== 'position' &&
                    aStyleKey !== 'display' &&
                    aStyleKey !== 'opacity' &&
                    aStyleKey !== 'z-index' &&
                    aStyleKey !== 'bottom' &&
                    aStyleKey !== 'height' &&
                    aStyleKey !== 'left' &&
                    aStyleKey !== 'right' &&
                    aStyleKey !== 'top' &&
                    aStyleKey !== 'width' &&
                  tipElementStyle.getPropertyValue(aStyleKey)) {

                  tipCssToSet[aStyleKey] = tipElementStyle.getPropertyValue(aStyleKey);
                }
              }
              paddingTopValue = window.parseInt(tipElementStyle.getPropertyValue('padding-top'), 10);
              paddingBottomValue = window.parseInt(tipElementStyle.getPropertyValue('padding-bottom'), 10);
              paddingLeftValue = window.parseInt(tipElementStyle.getPropertyValue('padding-left'), 10);
              paddingRightValue = window.parseInt(tipElementStyle.getPropertyValue('padding-right'), 10);

              tipCssToSet.top = tipElementBoundingClientRect.top + window.pageYOffset + 'px';
              tipCssToSet.left = tipElementBoundingClientRect.left + window.pageXOffset + 'px';
              tipCssToSet.height = tipElementBoundingClientRect.height - (paddingTopValue + paddingBottomValue) + 'px';
              tipCssToSet.width = tipElementBoundingClientRect.width - (paddingLeftValue + paddingRightValue) + 'px';

              exradicatedTipElement.css(tipCssToSet);

              exradicatedTipElement.children().css(tipTipCssToSet);
              exradicatedTipElement.children().next().css(tipArrowCssToSet);
              if (event &&
                $attrs.tooltipHidden !== 'true') {

                exradicatedTipElement.addClass('_exradicated-tooltip');
                angular.element(window.document.body).append(exradicatedTipElement);
              }
            } else {

              tipElement.removeClass('_hidden');
              if (event &&
                $attrs.tooltipHidden !== 'true') {

                tooltipElement.addClass('active');
              }
            }
          }
          , onTooltipHide = function onTooltipHide(event) {

            if (event && tooltipElement.hasClass('active')) {
  
              event.stopImmediatePropagation();
            }

            if ($attrs.tooltipAppendToBody) {

              removeAppendedTip(tooltipElement);
            } else {

              tooltipElement.removeClass('active');
            }
          }
          , registerOnScrollFrom = function registerOnScrollFrom(theElement) {
            var parentElement = theElement.parent()
              , timer;

            if (theElement[0] &&
              (theElement[0].scrollHeight > theElement[0].clientHeight ||
              theElement[0].scrollWidth > theElement[0].clientWidth)) {

              theElement.on('scroll', function onScroll() {
                var that = this;

                if (timer) {

                  $timeout.cancel(timer);
                }

                timer = $timeout(function doLater() {

                  var theTipElement = getAppendedTip(tooltipElement)
                    , tooltipBoundingRect = tooltipElement[0].getBoundingClientRect()
                    , thatBoundingRect = that.getBoundingClientRect();

                  if (tooltipBoundingRect.top < thatBoundingRect.top ||
                    tooltipBoundingRect.bottom > thatBoundingRect.bottom ||
                    tooltipBoundingRect.left < thatBoundingRect.left ||
                    tooltipBoundingRect.right > thatBoundingRect.right) {

                    removeAppendedTip(tooltipElement);
                  } else if (theTipElement) {

                    onTooltipShow(true);
                  }
                });
              });
            }

            if (parentElement &&
              parentElement.length) {

              registerOnScrollFrom(parentElement);
            }
          }
          , showTemplate = function showTemplate(template) {
          
            tooltipElement.removeClass('_force-hidden'); //see lines below, this forces to hide tooltip when is empty
            tipTipElement.empty();
            tipTipElement.append(closeButtonElement);
            tipTipElement.append(template);
            $timeout(function doLater() {
              
              onTooltipShow();
            });
          }
          , hideTemplate = function hideTemplate() {
          
            //hide tooltip because is empty
            tipTipElement.empty();
            tooltipElement.addClass('_force-hidden'); //force to be hidden if empty
          }
          , getTemplate = function getTemplate(tooltipTemplateUrl) {
          
            var template = $templateCache.get(tooltipTemplateUrl);

            if (typeof template !== 'undefined') {
              // Wrap template in a Promise so that getTemplate always returns a Promise
              return $q.resolve(template);
            }

            // How should failing to load the template be handled?
            return $http.get(tooltipTemplateUrl).then(function onGetTemplateSuccess(response) {
              $templateCache.put(tooltipTemplateUrl, response.data);

              return response.data;
            });
          }
          , onTooltipTemplateChange = function onTooltipTemplateChange(newValue) {
          
            if (newValue) {
              
              showTemplate(newValue);
            } else {
              
              hideTemplate();
            }
          }
          , onTooltipTemplateUrlChange = function onTooltipTemplateUrlChange(newValue) {
          
            if (newValue && !$attrs.tooltipTemplateUrlCache) {
              
              getTemplate(newValue).then(function onGetTemplateSuccess(template) {
                
                showTemplate($compile(template)(scope));
              }).catch(function onGetTemplateFailure(reason) {
                
                $log.error(reason);
              });
            } else {
              
              hideTemplate();
            }
          }
          , onTooltipTemplateUrlCacheChange = function onTooltipTemplateUrlCacheChange(newValue) {
          
            if (newValue && $attrs.tooltipTemplateUrl) {
              
              getTemplate($attrs.tooltipTemplateUrl).then(function onGetTemplateSuccess(template) {
                
                showTemplate($compile(template)(scope));
              }).catch(function onGetTemplateFailure(reason) {

                $log.error(reason);
              });
            } else {
              
              hideTemplate();
            }
          }
          , onTooltipSideChange = function onTooltipSideChange(newValue) {

            if (newValue) {

              if (oldTooltipSide) {

                tooltipElement.removeClass(oldTooltipSide);
              }
              tooltipElement.addClass(getSideClasses(newValue));
              oldTooltipSide = newValue;
            }
          }
          , onTooltipShowTrigger = function onTooltipShowTrigger(newValue) {

            if (newValue) {

              if (oldTooltipShowTrigger) {

                tooltipElement.off(oldTooltipShowTrigger);
              }
              tooltipElement.on(newValue, onTooltipShow);
              oldTooltipShowTrigger = newValue;
            }
          }
          , onTooltipHideTrigger = function onTooltipHideTrigger(newValue) {

            if (newValue) {

              if (oldTooltipHideTrigger) {

                tooltipElement.off(oldTooltipHideTrigger);
              }
              tooltipElement.on(newValue, onTooltipHide);
              oldTooltipHideTrigger = newValue;
            }
          }
          , onTooltipShowTooltip = function onTooltipShowTooltip(newValue) {

            if (newValue === 'true') {

              tooltipElement.addClass('active');
            } else {
              tooltipElement.removeClass('active');
            }
          }
          , onTooltipClassChange = function onTooltipClassChange(newValue) {

            if (newValue) {

              if (oldTooltipClass) {

                tipElement.removeClass(oldTooltipClass);
              }
              tipElement.addClass(newValue);
              oldTooltipClass = newValue;
            }
          }
          , onTooltipSmartChange = function onTooltipSmartChange() {

            if (typeof $attrs.tooltipSmart !== 'boolean') {

              $attrs.tooltipSmart = $attrs.tooltipSmart === 'true';
            }
          }
          , onTooltipCloseButtonChange = function onTooltipCloseButtonChange(newValue) {
            var enableButton = newValue === 'true';

            if (enableButton) {

              closeButtonElement.on('click', onTooltipHide);
              closeButtonElement.css('display', 'block');
            } else {

              closeButtonElement.off('click');
              closeButtonElement.css('display', 'none');
            }
          }
          , onTooltipTemplateControllerChange = function onTooltipTemplateControllerChange(newValue) {

            if (newValue) {

              var tipController = $controller(newValue, {
                  '$scope': scope
                })
                , newScope = scope.$new(false, scope)
                , indexOfAs = newValue.indexOf('as')
                , controllerName;

              if (indexOfAs >= 0) {

                controllerName = newValue.substr(indexOfAs + 3);
                newScope[controllerName] = tipController;
              } else {

                angular.extend(newScope, tipController);
              }

              tipTipElement.replaceWith($compile(tipTipElement)(newScope));
              /*eslint-disable no-use-before-define*/
              unregisterOnTooltipControllerChange();
              /*eslint-enable no-use-before-define*/
            }
          }
          , onTooltipSizeChange = function onTooltipSizeChange(newValue) {

            if (newValue) {

              if (oldSize) {

                tipTipElement.removeClass('_' + oldSize);
              }
              tipTipElement.addClass('_' + newValue);
              oldSize = newValue;
            }
          }
          , onTooltipSpeedChange = function onTooltipSpeedChange(newValue) {

            if (newValue) {

              if (oldSpeed) {

                tooltipElement.removeClass('_' + oldSpeed);
              }
              tooltipElement.addClass('_' + newValue);
              oldSpeed = newValue;
            }
          }
          , unregisterOnTooltipTemplateChange = $attrs.$observe('tooltipTemplate', onTooltipTemplateChange)
          , unregisterOnTooltipTemplateUrlChange = $attrs.$observe('tooltipTemplateUrl', onTooltipTemplateUrlChange)
          , unregisterOnTooltipTemplateUrlCacheChange = $attrs.$observe('tooltipTemplateUrlCache', onTooltipTemplateUrlCacheChange)
          , unregisterOnTooltipSideChangeObserver = $attrs.$observe('tooltipSide', onTooltipSideChange)
          , unregisterOnTooltipShowTrigger = $attrs.$observe('tooltipShowTrigger', onTooltipShowTrigger)
          , unregisterOnTooltipHideTrigger = $attrs.$observe('tooltipHideTrigger', onTooltipHideTrigger)
          , unregisterOnTooltipShowTooltip = $attrs.$observe('tooltipShow', onTooltipShowTooltip)
          , unregisterOnTooltipClassChange = $attrs.$observe('tooltipClass', onTooltipClassChange)
          , unregisterOnTooltipSmartChange = $attrs.$observe('tooltipSmart', onTooltipSmartChange)
          , unregisterOnTooltipCloseButtonChange = $attrs.$observe('tooltipCloseButton', onTooltipCloseButtonChange)
          , unregisterOnTooltipControllerChange = $attrs.$observe('tooltipController', onTooltipTemplateControllerChange)
          , unregisterOnTooltipSizeChange = $attrs.$observe('tooltipSize', onTooltipSizeChange)
          , unregisterOnTooltipSpeedChange = $attrs.$observe('tooltipSpeed', onTooltipSpeedChange)
          , unregisterTipContentChangeWatcher = scope.$watch(whenActivateMultilineCalculation, calculateIfMultiLine);

        closeButtonElement.addClass('close-button');
        closeButtonElement.html('&times;');

        tipElement.addClass('_hidden');

        tipTipElement.append(closeButtonElement);
        tipTipElement.append($attrs.tooltipTemplate);

        tipElement.append(tipTipElement);
        tipElement.append(tipArrowElement);

        tipContElement.append(element);

        tooltipElement.attr(attributes);
        tooltipElement.addClass('tooltips');

        tooltipElement.append(tipContElement);
        tooltipElement.append(tipElement);
        $element.after(tooltipElement);

        if ($attrs.tooltipAppendToBody) {

          resizeObserver.add(function onResize() {

            registerOnScrollFrom(tooltipElement);
          });
          registerOnScrollFrom(tooltipElement);
        }

        resizeObserver.add(function registerResize() {

          calculateIfMultiLine();
          onTooltipShow();
        });

        $timeout(function doLater() {

          onTooltipShow();
          tipElement.removeClass('_hidden');
          tooltipElement.addClass('_ready');
        });

        scope.$on('$destroy', function unregisterListeners() {

          unregisterOnTooltipTemplateChange();
          unregisterOnTooltipTemplateUrlChange();
          unregisterOnTooltipTemplateUrlCacheChange();
          unregisterOnTooltipSideChangeObserver();
          unregisterOnTooltipShowTrigger();
          unregisterOnTooltipHideTrigger();
          unregisterOnTooltipShowTooltip();
          unregisterOnTooltipClassChange();
          unregisterOnTooltipSmartChange();
          unregisterOnTooltipCloseButtonChange();
          unregisterOnTooltipSizeChange();
          unregisterOnTooltipSpeedChange();
          unregisterTipContentChangeWatcher();
          resizeObserver.remove();
          element.off($attrs.tooltipShowTrigger + ' ' + $attrs.tooltipHideTrigger);
        });
      });
    };

    return {
      'restrict': 'A',
      'transclude': 'element',
      'priority': 1,
      'terminal': true,
      'link': linkingFunction
    };
  }];

  angular.module('720kb.tooltips', [])
  .provider(directiveName + 'Conf', tooltipConfigurationProvider)
  .directive(directiveName, tooltipDirective);
}(angular, window));


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(4); // eslint-disable-line no-unused-vars

var olyCommonModule = __webpack_require__(3);
var wowCommonModule = __webpack_require__(5);
var analyticsModule = __webpack_require__(8);
var deliverySaverModule = __webpack_require__(357);

var InspirationService = __webpack_require__(944);

var _require = __webpack_require__(945),
    inspirationNavigationComponentDefinition = _require.inspirationNavigationComponentDefinition;

var _require2 = __webpack_require__(947),
    inspirationTileComponentDefinition = _require2.inspirationTileComponentDefinition;

var _require3 = __webpack_require__(949),
    inspirationDetailTileComponentDefinition = _require3.inspirationDetailTileComponentDefinition;

var _require4 = __webpack_require__(951),
    inspirationDetailTileListComponentDefinition = _require4.inspirationDetailTileListComponentDefinition;

var _require5 = __webpack_require__(952),
    inspirationDetailComponentDefinition = _require5.inspirationDetailComponentDefinition;

var inspirationModuleName = 'wowApp.inspiration';

angular.module(inspirationModuleName, [analyticsModule, olyCommonModule, wowCommonModule, deliverySaverModule, uiRouter, 'restangular']).service('InspirationService', ['Restangular', '$rootScope', '$window', 'LocalStorageWrapper', InspirationService]).component('wowInspirationNavigation', inspirationNavigationComponentDefinition).component('wowInspirationTile', inspirationTileComponentDefinition).component('wowInspirationDetailTile', inspirationDetailTileComponentDefinition).component('wowInspirationDetailTileList', inspirationDetailTileListComponentDefinition).component('wowInspirationDetail', inspirationDetailComponentDefinition);

module.exports = inspirationModuleName;

/***/ }),
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function InspirationService(Restangular, $rootScope, $window, localStorageWrapper) {
    this._api = Restangular.one('inspiration');
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.localStorageWrapper = localStorageWrapper;
}

InspirationService.prototype.getNavigationItems = function () {
    this._leftPaneItems = this._leftPaneItems || this._api.one('navigation').getList();

    return this._leftPaneItems;
};

InspirationService.prototype.findNavigationItemsByName = function (navItems, parentName, childName) {
    var navItem = _.find(navItems, { UrlPart: parentName });

    if (childName !== undefined && navItem && _.some(navItem.Items)) {
        navItem = _.find(navItem.Items, { UrlPart: childName });
    }

    return navItem;
};

InspirationService.prototype.getCardsByPageID = function (pageId) {
    return this._api.one('page', pageId).get();
};

InspirationService.prototype.getCardsForUrl = function (url) {
    return this._api.one('cards').get({ url: url });
};

InspirationService.prototype.getDiscoverPathForCard = function (cardId) {
    return this._api.one('cards', cardId).one('DiscoverPath').get();
};

InspirationService.prototype.setContentCardId = function (cardId) {
    var _this = this;

    // Disabled due to https://github.com/eslint/eslint/issues/5692
    // Please re-enable if the issue is fixed.
    /* eslint-disable prefer-const */
    var stateChangeErrorOff = void 0;
    this._removeDataSessionStorage('dynamicContentCardId'); // just in case


    var clickContentCardOff = this.$rootScope.$on('$stateChangeSuccess', function () {
        _this.ContentCardId = cardId;
        stateChangeErrorOff();
        clickContentCardOff();

        var navigateAwayOff = _this.$rootScope.$on('$stateChangeStart', function () {
            _this.ContentCardId = null;
            navigateAwayOff();
        });
    });

    stateChangeErrorOff = this.$rootScope.$on('$stateChangeError', function () {
        _this.ContentCardId = null;
        stateChangeErrorOff();
        clickContentCardOff();
    });
    /* eslint-enable prefer-const */
};

// Attributes that controls the center panel's behavior for SmallFormat when the item has no children items
InspirationService.prototype.setChildlessItem = function (childlessItem) {
    this._isChildLessItem = childlessItem;
};

InspirationService.prototype.isChildlessItem = function () {
    return this._isChildLessItem;
};

InspirationService.prototype.setDynamicContentCardIdSessionStorage = function (cardId) {
    this._setDataSessionStorage('dynamicContentCardId', cardId);
};

InspirationService.prototype._setNavigateAwayOff = function () {
    var _this2 = this;

    var navigateAwayOff = this.$rootScope.$on('$stateChangeSuccess', function () {
        _this2._removeDataSessionStorage('dynamicContentCardId');
        navigateAwayOff();
    });
};

InspirationService.prototype.getContentCardId = function () {
    this._setNavigateAwayOff();
    return this.ContentCardId ? this.ContentCardId : this._getDataSessionStorage('dynamicContentCardId');
};

// private session storage apis

/**
 * Create an item in DOM sessionStorage.
 * @param {String} name
 * @param {Object} data
 */
InspirationService.prototype._setDataSessionStorage = function (name, data) {
    this.localStorageWrapper.set(name, data);

    return data;
};

/**
 * Remove an item in DOM sessionStorage.
 * @param {String} name
 */
InspirationService.prototype._removeDataSessionStorage = function (name) {
    this.localStorageWrapper.remove(name);

    // allow chaining
    return this;
};

/**
 * Gets an item in DOM sessionStorage.
 * @param {String} name
 */
InspirationService.prototype._getDataSessionStorage = function (name) {
    return this.localStorageWrapper.get(name) || null;
};

module.exports = InspirationService;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find;

var InspirationNavigationController = function () {
    function InspirationNavigationController($state, analyticsService) {
        _classCallCheck(this, InspirationNavigationController);

        this.$state = $state;
        this.analyticsService = analyticsService;
    }

    _createClass(InspirationNavigationController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.$state.params && this.menuItems) {
                this.openLevel1 = this.$state.params.parent ? find(this.menuItems, { UrlPart: this.$state.params.parent }) : null;
                this.openLevel2 = this.$state.params.child && this.openLevel1 && this.openLevel1.Items ? find(this.openLevel1.Items, { UrlPart: this.$state.params.child }) : null;
            }
        }
    }, {
        key: 'isOpen',
        value: function isOpen(category) {
            var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            return level === 2 ? this.$state.includes('shop.inspiration.parent.child', { child: category.UrlPart }) : this.$state.includes('shop.inspiration.parent', { parent: category.UrlPart });
        }
    }, {
        key: 'toggleCategory',
        value: function toggleCategory(category, level) {
            if (level === 1) {
                this.openLevel1 = this.openLevel1 === category ? null : category;
                this.openLevel2 = null;
            } else {
                this.openLevel2 = this.openLevel2 === category ? null : category;
            }
        }
    }, {
        key: 'pushDataToAnalyticsService',
        value: function pushDataToAnalyticsService() {
            this.analyticsService.push({
                data: {
                    trackingType: 'link'
                },
                type: this.analyticsService.mapperTypes.customEvent.menuClick
            });
        }
    }]);

    return InspirationNavigationController;
}();

var inspirationNavigationComponentDefinition = {
    bindings: {
        menuItems: '<'
    },
    controller: ['$state', 'AnalyticsService', InspirationNavigationController],
    template: __webpack_require__(946).trim()
};

module.exports = {
    InspirationNavigationController: InspirationNavigationController,
    inspirationNavigationComponentDefinition: inspirationNavigationComponentDefinition
};

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navigation treeNavigation inspirationNavigation\" aria-label=\"Discover\">\r\n    <ul class=\"navigation-items\">\r\n        <li ng-repeat=\"item in ::$ctrl.menuItems\">\r\n            <a\r\n                id=\"{{ ::item.UrlPart }}\"\r\n                class=\"inspirationNavigation-link navigation-header inspirationNavigation-parent\"\r\n                ng-attr-controls=\"{{ item.Items.length > 0 ? item.UrlPart + '-children' : undefined }}\"\r\n                ng-class=\"{ 'is-open': $ctrl.isOpen(item, 1) && $ctrl.openLevel1.ID === item.ID, 'has-nochildren': !item.Items.length }\"\r\n                ng-click=\"$ctrl.toggleCategory(item, 1);$ctrl.pushDataToAnalyticsService()\"\r\n                ui-sref=\"shop.inspiration.parent({ parent: item.UrlPart })\"\r\n                ui-sref-active-eq=\"is-active\"\r\n                ui-sref-opts=\"{ inherit: false }\">\r\n\r\n                {{ ::item.Name }}&nbsp;\r\n                <span class=\"inspirationNavigation-iconRegion\" ng-if=\"item.Items.length > 0\">\r\n                    <i class=\"iconww-ArrowUp inspirationNavigation-collapseIcon\"></i>\r\n                    <i class=\"iconww-ArrowDown inspirationNavigation-expandIcon\"></i>\r\n                </span>\r\n            </a>\r\n\r\n            <ul\r\n                id=\"{{ ::item.UrlPart }}-children\"\r\n                class=\"navigation-items treeNavigation-children inspirationNavigation-children\"\r\n                aria-labelledby=\"{{ ::item.UrlPart }}\"\r\n                ng-show=\"$ctrl.openLevel1.ID === item.ID\">\r\n\r\n                <li ng-repeat=\"level2 in ::item.Items\">\r\n                    <a\r\n                        class=\"inspirationNavigation-link inspirationNavigation-child\"\r\n                        ng-attr-controls=\"{{ level2.Items.length > 0 ? level2.UrlPart + '-children' : undefined }}\"\r\n                        ng-class=\"{ 'is-open': $ctrl.isOpen(level2, 2) && $ctrl.openLevel2.ID === level2.ID, 'has-nochildren': !level2.Items.length }\"\r\n                        ng-click=\"$ctrl.toggleCategory(level2, 2);$ctrl.pushDataToAnalyticsService()\"\r\n                        ui-sref=\"shop.inspiration.parent.child({ parent: item.UrlPart, child: level2.UrlPart })\"\r\n                        ui-sref-active=\"is-active\"\r\n                        ui-sref-opts=\"{ inherit: false }\">\r\n\r\n                        {{ ::level2.Name }}&nbsp;\r\n                        <span class=\"inspirationNavigation-iconRegion\" ng-if=\"level2.Items.length > 0\">\r\n                            <i class=\"iconww-ArrowUp inspirationNavigation-collapseIcon\"></i>\r\n                            <i class=\"iconww-ArrowDown inspirationNavigation-expandIcon\"></i>\r\n                        </span>\r\n                    </a>\r\n\r\n                    <ul\r\n                        ng-if=\"level2.Items\"\r\n                        ng-show=\"$ctrl.openLevel2.ID === level2.ID\"\r\n                        id=\"{{ ::level2.UrlPart }}-children\"\r\n                        class=\"navigation-items inspirationNavigation-grandchildren\"\r\n                        aria-labelledby=\"{{ ::level2.UrlPart }}\">\r\n\r\n                        <li ng-repeat=\"level3 in ::level2.Items\">\r\n                            <a\r\n                                class=\"inspirationNavigation-link inspirationNavigation-grandchild\"\r\n                                ui-sref=\"shop.inspiration.parent.child.grandchild({\r\n                                    parent: item.UrlPart,\r\n                                    child: level2.UrlPart,\r\n                                    grandchild: level3.UrlPart })\"\r\n                                ui-sref-active=\"is-active\"\r\n                                ui-sref-opts=\"{ inherit: false }\">\r\n\r\n                                {{ ::level3.Name }}\r\n                            </a>\r\n                        </li>\r\n                    </ul>\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</nav>\r\n"

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InspirationTileController = function () {
    function InspirationTileController($state, breakpointsService, trolleyService) {
        _classCallCheck(this, InspirationTileController);

        this.$state = $state;
        this.trolleyService = trolleyService;
        this.breakpointsService = breakpointsService;
    }

    _createClass(InspirationTileController, [{
        key: '$onInit',
        value: function $onInit() {
            this.linkTarget = this.card.PromoOpenInNewTab ? '_blank' : undefined;
            this.linkHref = this.getLink();
        }
    }, {
        key: 'getLink',
        value: function getLink() {
            if (this.card.CardLinkTarget) {
                return this.card.CardLinkTarget;
            } else if (this.card.ProductGroupId) {
                return this.$state.href('shop.productgroup', { Id: this.card.ProductGroupId });
            } else if (this.card.Product) {
                return this.$state.href('shop.productdetails', { productId: this.card.Product.Stockcode, productName: this.card.Product.UrlFriendlyName, product: this.card.Product });
            } else if (this.card.RecipeId) {
                return this.$state.href('shop.recipedetail', { recipeId: this.card.RecipeId });
            }
            return this.$state.href('shop.inspirationcard', { id: this.card.ID, name: this.card.UrlPart });
        }
    }]);

    return InspirationTileController;
}();

var inspirationTileComponentDefinition = {
    bindings: {
        card: '<',
        onClick: '&?'
    },
    controller: ['$state', 'BreakpointsService', 'TrolleyService', InspirationTileController],
    template: __webpack_require__(948).trim()
};

module.exports = {
    InspirationTileController: InspirationTileController,
    inspirationTileComponentDefinition: inspirationTileComponentDefinition
};

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = "<div class=\"inspirationTile tile\"\r\n    ng-class=\"{'has-homepage-small-image' : $ctrl.card.HomepageSmallImagePath, 'inspirationTile--product': !!$ctrl.card.Product, 'is-inTrolley' : $ctrl.card.Product.IsInTrolley}\">\r\n    <h3 class=\"inspirationTile-header\">\r\n        <a class=\"inspirationTile-imageContainer\"\r\n            ng-href=\"{{ ::$ctrl.linkHref }}\"\r\n            ng-attr-target=\"{{ ::$ctrl.linkTarget }}\"\r\n            ng-click=\"$ctrl.onClick({ $event: $event })\">\r\n\r\n            <img class=\"inspirationTile-image\"\r\n                ng-src=\"{{ ($ctrl.card.HomepageSmallImagePath && $ctrl.breakpointsService.isInSmallFormat) ? $ctrl.card.HomepageSmallImagePath : $ctrl.card.LargeImagePath }}\"\r\n                alt=\"{{ ::($ctrl.card.ImageAltText || $ctrl.card.Name) }}\" />\r\n        </a>\r\n    </h3>\r\n\r\n    <div class=\"inspirationTile-information\">\r\n        <a class=\"heading4 inspirationTile-name\"\r\n            ng-class=\"{'has-description' : $ctrl.card.Description}\"\r\n            ng-href=\"{{ ::$ctrl.linkHref }}\"\r\n            ng-attr-target=\"{{ ::$ctrl.linkTarget }}\"\r\n            ng-click=\"$ctrl.onClick({ $event: $event })\">\r\n\r\n            {{ ::$ctrl.card.Name }}\r\n        </a>\r\n\r\n        <p class=\"inspirationTile-description\" ng-if=\"::$ctrl.card.Description\">\r\n            {{ ::$ctrl.card.Description }}\r\n        </p>\r\n\r\n        <a class=\"button inspirationTile-button\"\r\n            ng-if=\"::!$ctrl.card.Product\"\r\n            ng-href=\"{{ ::$ctrl.linkHref }}\"\r\n            ng-attr-target=\"{{ ::$ctrl.linkTarget }}\"\r\n            ng-click=\"$ctrl.onClick({ $event: $event })\">\r\n\r\n            {{ ::$ctrl.card.LinkText }}\r\n        </a>\r\n\r\n        <div class=\"inspirationTile-productControls\" ng-if=\"::$ctrl.card.Product\">\r\n            <wow-product-save-to-list\r\n                product=\"::$ctrl.card.Product\">\r\n            </wow-product-save-to-list>\r\n\r\n            <wow-cart-controls\r\n                shelf-product=\"::$ctrl.card.Product\"\r\n                trolley-product=\"$ctrl.trolleyService.trolleyProductsByStockcode[$ctrl.card.Product.Stockcode]\"\r\n                show-in-trolley-message=\"true\">\r\n            </wow-cart-controls>\r\n        </div>\r\n    </div>\r\n\r\n    <span class=\"sr-only\" ng-if=\"::$ctrl.card.PromoOpenInNewTab\">, opens in a new window</span>\r\n</div>\r\n"

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InspirationDetailTileController = function () {
    function InspirationDetailTileController($scope, $element, $state, moveFocus, inspirationService) {
        _classCallCheck(this, InspirationDetailTileController);

        this.$scope = $scope;
        this.$element = $element;
        this.$state = $state;
        this.moveFocus = moveFocus;
        this.inspirationService = inspirationService;
    }

    _createClass(InspirationDetailTileController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.$on('window:resize', function () {
                if (_this.isDetailExpanded()) {
                    _this.expand();
                }
            });

            this.$scope.$watch(function () {
                return _this.$state.params.cardId;
            }, function (cardId) {
                return _this.card.ID === cardId ? _this.expand() : _this.shrink();
            });
        }
    }, {
        key: 'openCardDetail',
        value: function openCardDetail() {
            this.$state.go('.', { cardId: this.card.ID, name: this.card.UrlPart });
        }
    }, {
        key: 'closeCardDetail',
        value: function closeCardDetail() {
            this.$state.go('.', { cardId: undefined, name: undefined });
        }
    }, {
        key: 'isDetailExpanded',
        value: function isDetailExpanded() {
            return this.card.ID === this.$state.params.cardId;
        }
    }, {
        key: 'shrink',
        value: function shrink() {
            this.$element.find('._inspirationDetailTile').css('margin-bottom', '');
        }
    }, {
        key: 'expand',
        value: function expand() {
            var $tile = this.$element.find('._inspirationDetailTile');
            var $detail = this.$element.find('._inspirationDetailTile-detail');

            $tile.css('margin-bottom', $detail.height() + 20);

            $detail.css('top', $tile.position().top + $tile.height());
        }
    }, {
        key: 'goToCard',
        value: function goToCard($event) {
            if (this.card.CardLinkTarget || this.card.ProductGroupId || this.card.Product || this.card.RecipeId) {
                this.inspirationService.setContentCardId(this.card.ID);
            } else if ($event.button === 0) {
                $event.preventDefault();
                this.openCardDetail();
                this.moveFocus('._inspirationDetailTile-detail');
            }
        }
    }]);

    return InspirationDetailTileController;
}();

InspirationDetailTileController.$inject = ['$scope', '$element', '$state', 'MoveFocus', 'InspirationService'];

var inspirationDetailTileComponentDefinition = {
    bindings: {
        card: '<'
    },
    controller: InspirationDetailTileController,
    template: __webpack_require__(950).trim()
};

module.exports = {
    InspirationDetailTileController: InspirationDetailTileController,
    inspirationDetailTileComponentDefinition: inspirationDetailTileComponentDefinition
};

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports = "<div class=\"inspirationDetailTile _inspirationDetailTile\">\r\n    <wow-inspiration-tile id=\"inspirationCard-{{ ::$ctrl.card.ID }}\" card=\"::$ctrl.card\" on-click=\"$ctrl.goToCard($event)\"></wow-inspiration-tile>\r\n\r\n    <div class=\"inspirationDetailTile-selectedPointer\" ng-show=\"$ctrl.isDetailExpanded()\"></div>\r\n</div>\r\n\r\n<div class=\"inspirationDetailTile-detail _inspirationDetailTile-detail\" tabindex=\"-1\" ng-if=\"$ctrl.isDetailExpanded()\">\r\n    <button ng-click=\"$ctrl.closeCardDetail()\" class=\"iconButton inspirationDetailTile-close\" oly-move-focus=\"inspirationCard-{{ ::$ctrl.card.ID }}\">\r\n        <i class=\"iconww-Cross\"></i><span class=\"sr-only\">Close details</span>\r\n    </button>\r\n\r\n    <!-- The ng-click on this element is a hack to support resizing when using expanding elements added via dynamic content (e.g. accordians written by the content team) -->\r\n    <wow-inspiration-detail card=\"::$ctrl.card\" onload=\"$ctrl.expand()\" oly-grab-focus=\"true\" tabindex=\"-1\" ng-click=\"$ctrl.expand()\"></wow-inspiration-detail>\r\n</div>\r\n"

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(32),
    createInspirationTiles = _require.createInspirationTiles,
    _require2 = __webpack_require__(19),
    mergeInspirationTiles = _require2.mergeInspirationTiles;

var InspirationDetailTileListController = function () {
    function InspirationDetailTileListController($location, $q, analyticsService, inspirationService) {
        _classCallCheck(this, InspirationDetailTileListController);

        this.$location = $location;
        this.$q = $q;
        this.analyticsService = analyticsService;
        this.inspirationService = inspirationService;
    }

    _createClass(InspirationDetailTileListController, [{
        key: 'createTiles',
        value: function createTiles(pageCards, urlCards) {
            return {
                items: mergeInspirationTiles(createInspirationTiles(pageCards, 'inspirationdetail'), urlCards, { type: 'inspirationdetail' })
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles() {
            var _this = this;

            return this.$q.all([this.inspirationService.getCardsByPageID(this.pageId), this.inspirationService.getCardsForUrl(this.$location.pathAndSearch())]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    pageCards = _ref2[0].InspirationCards,
                    urlCards = _ref2[1].Cards;

                _this.analyticsService.push({ type: _this.analyticsService.mapperTypes.content.general });
                return _this.createTiles(pageCards, urlCards);
            });
        }
    }]);

    return InspirationDetailTileListController;
}();

InspirationDetailTileListController.$inject = ['$location', '$q', 'AnalyticsService', 'InspirationService'];

var inspirationDetailTileListComponentDefinition = {
    bindings: {
        pageId: '<'
    },
    controller: InspirationDetailTileListController,
    template: '\n        <wow-tile-list\n            should-get-inspiration-cards="false"\n            get-tiles="$ctrl.getTiles()">\n        </wow-tile-list>\n    '
};

module.exports = {
    InspirationDetailTileListController: InspirationDetailTileListController,
    inspirationDetailTileListComponentDefinition: inspirationDetailTileListComponentDefinition
};

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InspirationDetailController = function () {
    function InspirationDetailController($scope, $element, $location, analytics) {
        _classCallCheck(this, InspirationDetailController);

        this.$scope = $scope;
        this.$element = $element;
        this.$location = $location;
        this.analytics = analytics;
    }

    _createClass(InspirationDetailController, [{
        key: '$onInit',
        value: function $onInit() {
            this.analytics.push({ data: { card: this.card, list: this.$location.path() }, type: this.analytics.mapperTypes.content.inspiration });

            this.scheduleKey = this.card.ID + '-card-schedule';
        }
    }, {
        key: '$postLink',
        value: function $postLink() {
            var _this = this;

            this.$element[0].addEventListener('load', function () {
                // Re-triggers load whenever new images finish downloading in order
                // to correctly resize.
                _this.$scope.$apply(function () {
                    return _this.onload();
                });
            }, true);
        }
    }]);

    return InspirationDetailController;
}();

InspirationDetailController.$inject = ['$scope', '$element', '$location', 'AnalyticsService'];

var inspirationDetailComponentDefinition = {
    bindings: {
        card: '<',
        onload: '&'
    },
    controller: InspirationDetailController,
    template: __webpack_require__(953).trim()
};

module.exports = {
    InspirationDetailController: InspirationDetailController,
    inspirationDetailComponentDefinition: inspirationDetailComponentDefinition
};

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports = "<div class=\"inspirationDetail text-left\">\r\n    <oly-dynamic-content\r\n        schedule-key=\"$ctrl.scheduleKey\"\r\n        onload=\"$ctrl.onload()\">\r\n    </oly-dynamic-content>\r\n</div>\r\n"

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);
var ngSanitize = __webpack_require__(24);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(4); // eslint-disable-line no-unused-vars

var olyCommonModule = __webpack_require__(3);
var wowCommonModule = __webpack_require__(5);

var _require = __webpack_require__(955),
    SearchService = _require.SearchService;

var _require2 = __webpack_require__(956),
    SearchPhraseActionService = _require2.SearchPhraseActionService;

var _require3 = __webpack_require__(957),
    searchMultisearchComponentDefinition = _require3.searchMultisearchComponentDefinition;

var _require4 = __webpack_require__(959),
    searchNavigationComponentDefinition = _require4.searchNavigationComponentDefinition;

var _require5 = __webpack_require__(961),
    searchNavigationLinkComponentDefinition = _require5.searchNavigationLinkComponentDefinition;

var _require6 = __webpack_require__(963),
    searchProductTileListComponentDefinition = _require6.searchProductTileListComponentDefinition;

var _require7 = __webpack_require__(964),
    searchRecipeTileListComponentDefinition = _require7.searchRecipeTileListComponentDefinition;

var _require8 = __webpack_require__(965),
    searchInspirationTileListComponentDefinition = _require8.searchInspirationTileListComponentDefinition;

var _require9 = __webpack_require__(966),
    searchTermTileListUpdaterComponentDefinition = _require9.searchTermTileListUpdaterComponentDefinition;

var _require10 = __webpack_require__(967),
    searchZeroResultComponentDefinition = _require10.searchZeroResultComponentDefinition;

var searchModuleName = 'wowApp.search';

angular.module(searchModuleName, [olyCommonModule, wowCommonModule, ngSanitize, uiRouter, 'restangular']).service('SearchService', SearchService).service('SearchPhraseActionService', SearchPhraseActionService).service('SearchMultisearchService', ['Restangular', 'BreakpointsService', '$stateParams', 'LocalStorageWrapper', __webpack_require__(969)]).component('wowMultisearch', searchMultisearchComponentDefinition).component('wowSearchNavigation', searchNavigationComponentDefinition).component('wowSearchNavigationLink', searchNavigationLinkComponentDefinition).component('wowSearchProductTileList', searchProductTileListComponentDefinition).component('wowSearchRecipeTileList', searchRecipeTileListComponentDefinition).component('wowSearchInspirationTileList', searchInspirationTileListComponentDefinition).component('wowSearchTermTileListUpdater', searchTermTileListUpdaterComponentDefinition).component('wowSearchZeroResults', searchZeroResultComponentDefinition).directive('wowSearchExternalResult', ['$sce', 'SettingsService', '$stateParams', 'SearchPhraseActionService', '$state', 'ShopperService', __webpack_require__(970)]);

module.exports = searchModuleName;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    chain = _require.chain,
    set = _require.set,
    filter = _require.filter;

var SearchService = function () {
    function SearchService($location, Restangular, categoriesService) {
        _classCallCheck(this, SearchService);

        this.$location = $location;
        this.api = Restangular.one('Search');
        this.categoriesService = categoriesService;

        this.categories = [];
        this.searchCounts = {};
        this.isHeaderSearch = false;
        this.isAutocompleteSearch = false;
    }

    _createClass(SearchService, [{
        key: 'determineStateToShow',
        value: function determineStateToShow(searchTerm, multisearchItems) {
            var params = { searchTerm: searchTerm, multisearchItems: multisearchItems };

            if (searchTerm.toLowerCase().indexOf('recipe') > -1) {
                if (this.searchCounts.RecipeCount > 0) {
                    return { name: 'shop.search.recipes', params: params };
                } else if (this.searchCounts.ProductCount > 0) {
                    return { name: 'shop.search.products', params: params };
                } else if (this.searchCounts.ArticleCount > 0) {
                    return { name: 'shop.search.articles', params: params };
                }

                return { name: 'shop.search.zero-result', params: params };
            }

            if (this.searchCounts.ProductCount > 0) {
                return { name: 'shop.search.products', params: params };
            } else if (this.searchCounts.RecipeCount > 0) {
                return { name: 'shop.search.recipes', params: params };
            } else if (this.searchCounts.ArticleCount > 0) {
                return { name: 'shop.search.articles', params: params };
            }

            return { name: 'shop.search.zero-result', params: params };
        }
    }, {
        key: 'getSearchSuggestion',
        value: function getSearchSuggestion(searchTerm) {
            return this.api.one('suggestion').get({
                Key: searchTerm
            });
        }
    }, {
        key: 'getSearchCounts',
        value: function getSearchCounts(searchTerm) {
            var _this = this;

            this.searchCounts = { loadingCount: true };

            return this.api.one('count').get({
                SearchTerm: searchTerm
            }).then(function (data) {
                _this.searchCounts = data.SearchCount;
            }).finally(function () {
                _this.searchCounts.loadingCount = false;
            });
        }
    }, {
        key: 'getCategoriesFromAggregation',
        value: function getCategoriesFromAggregation(aggregations) {
            var _this2 = this;

            if (!aggregations) return [];

            return chain(aggregations).find({ Name: 'Category' }).get('Results', []).map(function (r) {
                return set(_this2.categoriesService.getById(r.Term), 'ProductCount', r.Count);
            }).filter(function (r) {
                return r && r.NodeLevel === 1 && r.IsSpecial === false;
            }).value();
        }
    }, {
        key: 'doSearch',
        value: function doSearch(searchTerm, pageSize, pageNumber, sortType, isSpecial, filters) {
            var _this3 = this;

            return this.api.post('products', {
                SearchTerm: searchTerm,
                PageSize: pageSize,
                PageNumber: pageNumber,
                SortType: sortType,
                IsSpecial: isSpecial,
                Filters: filters ? filters.filters : [],
                Location: this.$location.url(),
                Passes: this.passes
            }).then(function (data) {
                _this3.categories = _this3.getCategoriesFromAggregation(data.Aggregations);
                _this3.passes = data.Passes;

                return {
                    items: data.Products,
                    totalRecordCount: data.SearchResultsCount || 0,
                    aggregations: filter(data.Aggregations, function (a) {
                        return a.ShowFilter;
                    }), // later we will need to accommodate multiple aggregations from this point on
                    hasTobaccoItems: data.HasTobaccoItems
                };
            });
        }
    }, {
        key: 'doSearchSpecials',
        value: function doSearchSpecials(searchTerm, pageSize, pageNumber, sortType, filters) {
            var _this4 = this;

            return this.api.post('specials', {
                SearchTerm: searchTerm,
                PageSize: pageSize,
                PageNumber: pageNumber,
                SortType: sortType,
                Filters: filters ? filters.filters : []
            }).then(function (data) {
                _this4.categories = _this4.getCategoriesFromAggregation(data.Aggregations);

                return {
                    items: data.Products,
                    totalRecordCount: data.SearchResultsCount || 0,
                    hasTobaccoItems: data.HasTobaccoItems
                };
            });
        }
    }, {
        key: 'doSearchRecipes',
        value: function doSearchRecipes(searchTerm, pageSize, pageNumber, sortType) {
            return this.api.one('recipes').get({
                SearchTerm: searchTerm,
                PageSize: pageSize,
                PageNumber: pageNumber,
                SortType: sortType
            }).then(function (data) {
                return {
                    items: data.Recipes,
                    totalRecordCount: data.SearchResultsCount || 0
                };
            });
        }
    }, {
        key: 'doSearchArticles',
        value: function doSearchArticles(searchTerm, pageSize, pageNumber) {
            return this.api.one('articles').get({
                SearchTerm: searchTerm,
                PageSize: pageSize,
                PageNumber: pageNumber
            }).then(function (data) {
                return {
                    items: data.Cards,
                    totalRecordCount: data.SearchResultsCount || 0
                };
            });
        }
    }]);

    return SearchService;
}();

SearchService.$inject = ['$location', 'Restangular', 'CategoriesService'];

module.exports = { SearchService: SearchService };

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    keyBy = _require.keyBy;

var SearchPhraseActionService = function () {
    function SearchPhraseActionService($state, $window, $timeout, $q, Restangular, moveFocus, bootstrap, settings, loginService, shopperService, searchMultisearchService, searchService, analyticsService) {
        _classCallCheck(this, SearchPhraseActionService);

        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$q = $q;
        this.api = Restangular.one('Search');
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.loginService = loginService;
        this.shopperService = shopperService;
        this.multisearchService = searchMultisearchService;
        this.searchService = searchService;
        this.analyticsService = analyticsService;

        this.action = {
            login: 'PromptLogin',
            navigate: 'GoToUrl'
        };

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.SearchPhraseActions)) {
            this.setSearchPhraseActions.call(this, bootstrap.getBootstrappedData(bootstrap.bootstrapped.SearchPhraseActions));
        }
    }

    _createClass(SearchPhraseActionService, [{
        key: 'setSearchPhraseActions',
        value: function setSearchPhraseActions(searchPhraseActions) {
            this.searchPhraseActions = keyBy(searchPhraseActions.SearchPhraseActions, function (searchPhraseAction) {
                return searchPhraseAction.Phrase.toLowerCase();
            });
        }
    }, {
        key: 'getSearchPhraseAction',
        value: function getSearchPhraseAction(searchTerm) {
            if (this.searchPhraseActions) {
                return this.$q.when(searchTerm.toLowerCase() in this.searchPhraseActions && this.searchPhraseActions[searchTerm.toLowerCase()]);
            }

            return this._api.one('SearchPhraseAction').get({
                SearchTerm: searchTerm
            });
        }
    }, {
        key: 'actionPromptsForLogin',
        value: function actionPromptsForLogin(searchPhraseAction) {
            return searchPhraseAction.Action === this.action.login && this.shopperService.IsGuest;
        }
    }, {
        key: 'performSearchPhraseAction',
        value: function performSearchPhraseAction(searchPhraseAction) {
            var _this = this;

            return this.$q(function (resolve, reject) {
                if (_this.actionPromptsForLogin(searchPhraseAction)) {
                    _this.moveFocus('#loginForm-Email');
                    return _this.loginService.promptForLogin(_this.loginService.LoginToContinueMessage).then(resolve);
                } else if (searchPhraseAction.Action === _this.action.navigate) {
                    _this.analyticsService.push({
                        data: {
                            type: 'external',
                            searchKeyword: searchPhraseAction.Phrase
                        },
                        type: _this.analyticsService.mapperTypes.search.result
                    });
                    // A timeout is imposed just in case of the page get redirected before the data can be pushed to analytics provider.
                    // Frontend setting externalRedirectionDelay is introduced, specifying the milliseconds taken to delay the redirection.
                    // Ideally the analytics push should return a promise and the redirection should take place in the callback.
                    _this.$timeout(function () {
                        if (searchPhraseAction.Target === 'Blank') {
                            _this.$state.go('shop.search.external-result', { searchTerm: searchPhraseAction.Phrase }, { inherit: false });
                            _this.$window.open(searchPhraseAction.URL, '_blank');
                        } else {
                            _this.$window.location.href = searchPhraseAction.URL;
                        }
                    }, _this.settings.search.externalRedirectionDelay);
                    return reject();
                }
                return resolve();
            });
        }
    }, {
        key: 'searchRequiresLogin',
        value: function searchRequiresLogin(searchPhrase) {
            var _this2 = this;

            return this.$q(function (resolve) {
                if (!searchPhrase || searchPhrase === '') {
                    resolve(false);
                }
                _this2.getSearchPhraseAction(searchPhrase).then(function (action) {
                    if (action) {
                        resolve(_this2.actionPromptsForLogin(action) && !_this2.multisearchService.isSearchMultisearch());
                    }
                    resolve(false);
                });
            });
        }
    }]);

    return SearchPhraseActionService;
}();

SearchPhraseActionService.$inject = ['$state', '$window', '$timeout', '$q', 'Restangular', 'MoveFocus', 'BootstrapService', 'Settings', 'LoginService', 'ShopperService', 'SearchMultisearchService', 'SearchService', 'AnalyticsService'];

module.exports = { SearchPhraseActionService: SearchPhraseActionService };

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var angular = __webpack_require__(1);

var _require = __webpack_require__(0),
    compact = _require.compact,
    each = _require.each,
    map = _require.map,
    replace = _require.replace,
    uniqBy = _require.uniqBy;

var key = { esc: 27 };
var newlineCharacter = '\n';

var SearchMultisearchController = function () {
    function SearchMultisearchController($state, $timeout, $window, moveFocus, settings, searchMultisearchService, searchService) {
        _classCallCheck(this, SearchMultisearchController);

        this.$state = $state;
        this.$timeout = $timeout;
        this.$window = $window;
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.searchMultisearchService = searchMultisearchService;
        this.searchService = searchService;
    }

    _createClass(SearchMultisearchController, [{
        key: '$onInit',
        value: function $onInit() {
            this.multisearchText = this.searchMultisearchService.getMultisearchItems().join(newlineCharacter);
            this.searchLimitErrorMessage = '';
            this.showSearchLimitError = false;
            this.searchLimitErrorMessage = this.settings.search.searchItemLimitReached;
            this.maximumItemsToSearch = this.settings.search.maximumItemsToSearch;
        }
    }, {
        key: 'getMultisearchList',
        value: function getMultisearchList() {
            // Split text by comma or new line character then remove duplicates, remove empty rows, trim
            return uniqBy(compact(map(this.multisearchText.trim().split(',').join(newlineCharacter).split(newlineCharacter), function (value) {
                return value.trim();
            })));
        }
    }, {
        key: 'toggleMultisearch',
        value: function toggleMultisearch() {
            var _this = this;

            if (this.isActive) {
                this.$timeout(function () {
                    _this.isActive = false;
                    _this.moveFocus('#headerSearch');
                });
            } else {
                this.$timeout(function () {
                    _this.isActive = true;
                    _this.moveFocus('#multisearch-textbox');
                });
            }
        }
    }, {
        key: 'onPaste',
        value: function onPaste($event) {
            var _this2 = this;

            $event.preventDefault();
            var clipboardData = this.$window.clipboardData ? this.$window.clipboardData.getData('Text') : $event.originalEvent.clipboardData.getData('text/plain');

            if (clipboardData === undefined || !clipboardData.trim()) {
                return;
            }

            clipboardData = clipboardData.trim();
            // Convert a comma seperated list to newline seperated list (must not be already newline seperated)
            // Regex will replace all commas and also trim (\s*)
            if (clipboardData.indexOf(newlineCharacter) === -1) {
                clipboardData = replace(clipboardData, /\s*,\s*/g, newlineCharacter);
            }

            // Find out where the cursor is
            var cursorStart = $event.currentTarget.selectionStart;
            var cursorEnd = $event.currentTarget.selectionEnd;
            // Insert and replace selection (if there is any)
            this.multisearchText = this.multisearchText.substr(0, cursorStart) + clipboardData + this.multisearchText.substr(cursorEnd);

            // Move the cursor to the end of the pasted string
            var targetCursorPosition = cursorStart + clipboardData.length;
            this.$timeout(function () {
                $event.currentTarget.setSelectionRange(targetCursorPosition, targetCursorPosition);
                _this2.updateScroll($event.currentTarget, targetCursorPosition);
            });
        }
    }, {
        key: 'updateScroll',
        value: function updateScroll(textareaElement, cursorPosition) {
            var lineHeight = 41; // Line height is from search-multisearch.component.less
            var lineNumberOfCursor = this.getNumberofItems(each(this.multisearchText.substring(0, cursorPosition).trim().split(newlineCharacter)));
            var bottomOfContent = lineHeight * lineNumberOfCursor;
            var topOfContent = bottomOfContent - lineHeight > 0 ? bottomOfContent - lineHeight : 0;

            if (bottomOfContent > textareaElement.scrollTop) {
                textareaElement.scrollTop = topOfContent;
            }
        }
    }, {
        key: 'onKeydown',
        value: function onKeydown($event) {
            switch ($event.keyCode) {
                // Escape
                case key.esc:
                    $event.stopPropagation();
                    $event.preventDefault();
                    this.toggleMultisearch();
                    break;
                // Others
                default:
                    break;
            }
        }
    }, {
        key: 'getNumberofItems',
        value: function getNumberofItems() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getMultisearchList();

            return items.length;
        }
    }, {
        key: 'isOverMaximumLimit',
        value: function isOverMaximumLimit() {
            var listLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getNumberofItems();

            return listLength > this.maximumItemsToSearch;
        }
    }, {
        key: 'executeMultisearch',
        value: function executeMultisearch() {
            var multisearchItems = this.getMultisearchList();

            if (this.isOverMaximumLimit(multisearchItems.length)) {
                return;
            }

            this.searchMultisearchService.updateMultisearchItems(multisearchItems);
            var firstItem = multisearchItems[0];
            if (!firstItem || firstItem.length < 1) {
                return;
            }

            this.searchService.isHeaderSearch = true;

            this.$state.go('shop.search', { searchTerm: firstItem, multisearchItems: multisearchItems.join(',') }, { inherit: false, reload: true });

            if (angular.isFunction(this.onMultisearch)) {
                this.onMultisearch();
            }
        }
    }]);

    return SearchMultisearchController;
}();

var searchMultisearchComponentDefinition = {
    bindings: {
        isActive: '=?',
        searchTerm: '=?',
        onMultisearch: '&?'
    },
    controller: ['$state', '$timeout', '$window', 'MoveFocus', 'Settings', 'SearchMultisearchService', 'SearchService', SearchMultisearchController],
    template: __webpack_require__(958).trim()
};

module.exports = {
    SearchMultisearchController: SearchMultisearchController,
    searchMultisearchComponentDefinition: searchMultisearchComponentDefinition
};

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = "<div class=\"searchMultisearch-wrapper\" ng-class=\"{'is-active': $ctrl.isActive}\" ng-switch=\"$ctrl.isActive\">\r\n    <div id=\"multisearchLinkContainer\" ng-switch-when=\"false\">\r\n        <button\r\n            class=\"searchMultisearch-activateButton\"\r\n            type=\"button\"\r\n            ng-click=\"$ctrl.toggleMultisearch()\">\r\n                <div class=\"searchMultisearch-activateButtonWrapper\">\r\n                    <i class=\"iconww-List searchMultisearch-activateButtonIcon\"></i>\r\n                    <span>Search for a list of items</span>\r\n                </div>\r\n        </button>\r\n    </div>\r\n\r\n    <div ng-switch-when=\"true\">\r\n        <h5 class=\"searchMultisearch-activeHeader\">\r\n          <i class=\"iconww-List searchMultisearch-activeHeaderIcon\"></i>\r\n          <span>Type or paste your list below</span>\r\n        </h5>\r\n\r\n        <div class=\"searchMultisearch-textboxWrapper\">\r\n            <label id=\"multisearch-srMessage\" for=\"multisearch-textbox\" class=\"sr-only\">\r\n                <span id=\"multisearchErrorMessage\" ng-if=\"$ctrl.isOverMaximumLimit()\">{{::$ctrl.searchLimitErrorMessage}} There are currently {{$ctrl.getNumberofItems()}} items.</span>\r\n                <span>Search with a list of items. Begin by typing an item and pressing the enter key to enter another item.</span>\r\n            </label>\r\n            <textarea\r\n              id=\"multisearch-textbox\"\r\n              name=\"multisearch\"\r\n              class=\"searchMultisearch-textbox\"\r\n              autocomplete=\"off\"\r\n              placeholder=\"e.g. milk &#x000A;bread &#x000A;cheese\"\r\n              ng-model=\"$ctrl.multisearchText\"\r\n              ng-paste=\"$ctrl.onPaste($event)\"\r\n              ng-keydown=\"$ctrl.onKeydown($event)\">\r\n            </textarea>\r\n        </div>\r\n        <div class=\"searchMultisearch-errorMessage\" ng-show=\"$ctrl.isOverMaximumLimit()\">{{::$ctrl.searchLimitErrorMessage}}</div>\r\n\r\n        <div class=\"searchMultisearch-actionsWrapper\">\r\n            <button\r\n                class=\"linkButton searchMultisearch-iconButton\"\r\n                type=\"button\"\r\n                ng-click=\"$ctrl.toggleMultisearch()\"><i class=\"searchMultisearch-cancelButton iconww-Cross\"></i>   Cancel</button>\r\n            <button\r\n                class=\"button button--primary searchMultisearch-searchButton\"\r\n                type=\"button\"\r\n                ng-click=\"$ctrl.executeMultisearch()\"\r\n                ng-disabled=\"$ctrl.isOverMaximumLimit()\">\r\n                    <div class=\"searchMultisearch-searchButtonWrapper\">\r\n                        <span class=\"searchMultisearch-searchButtonText\">Search</span>\r\n                        <i class=\"iconww-Search\"></i>\r\n                    </div>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    filter = _require.filter;

var SearchNavigationController = function () {
    function SearchNavigationController($scope, $state, breakpointsService, searchService, multisearchService) {
        _classCallCheck(this, SearchNavigationController);

        this.$scope = $scope;
        this.$state = $state;

        this.breakpointsService = breakpointsService;
        this.searchService = searchService;
        this.multisearchService = multisearchService;
    }

    _createClass(SearchNavigationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isCategoriesExpanded = this.filter ? !!find(this.filter.filters, function (f) {
                return f.Key === 'Category';
            }) : !this.breakpointsService.isInSmallFormat;
            this.isMultisearch = this.multisearchService.isSearchMultisearch();
            this.searchTerms = this.isMultisearch ? this.multisearchItems.split(',') : [this.searchTerm];
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.filter && !changes.filter.isFirstChange()) {
                // This is a hack to update active styles on navigation links.
                // Because search state has `reloadOnSearch: false` it does not trigger
                // $stateChangeSuccess event whenver the query params change. ui-sref-active
                // listens for $stateChangeSuccess in order to update itself. This means the
                // nav links do not get highlighted correctly without this.
                //
                // As long as no children of this scope depend on this event being real this
                // should be safe.
                this.$scope.$broadcast('$stateChangeSuccess');
            }
        }
    }, {
        key: 'categoryClick',
        value: function categoryClick(categoryId) {
            if (this.getMultisearchParam() === 'undefined') {
                this.$state.go('.', { searchTerm: this.searchTerm, filter: this.formFilters(categoryId) }, { inherit: false });
            } else {
                this.$state.go('.', { searchTerm: this.searchTerm, multisearchItems: this.getMultisearchParam(), filter: this.formFilters(categoryId) }, { inherit: false });
            }
        }
    }, {
        key: 'formFilters',
        value: function formFilters(categoryId) {
            var applied = this.filter ? { filters: filter(this.filter.filters, function (f) {
                    return f.Key !== 'Category';
                }) } : { filters: [] };

            applied.filters.push({ Key: 'Category', Items: [{ Term: categoryId }] });
            return applied;
        }
    }, {
        key: 'getMultisearchParam',
        value: function getMultisearchParam() {
            return this.multisearchItems ? '\'' + this.multisearchItems + '\'' : 'undefined';
        }
    }, {
        key: 'shouldShowCategories',
        value: function shouldShowCategories() {
            return (this.$state.includes('shop.search.products') || this.$state.includes('shop.search.specials')) && this.searchService.categories.length > 0;
        }
    }, {
        key: 'isActiveCategory',
        value: function isActiveCategory(category) {
            var categoryFilter = this.filter ? this.filter.filters.find(function (f) {
                return f.Key === 'Category';
            }) : {};

            return category.NodeId === (categoryFilter && categoryFilter.Items ? categoryFilter.Items[0].Term : null);
        }
    }, {
        key: 'toggleCategories',
        value: function toggleCategories() {
            this.isCategoriesExpanded = !this.isCategoriesExpanded;
        }
    }]);

    return SearchNavigationController;
}();

SearchNavigationController.$inject = ['$scope', '$state', 'BreakpointsService', 'SearchService', 'SearchMultisearchService'];

var searchNavigationComponentDefinition = {
    bindings: {
        searchTerm: '<',
        multisearchItems: '<',
        filter: '<',
        disableNavigationLinks: '<'
    },
    controller: SearchNavigationController,
    template: __webpack_require__(960).trim()
};

module.exports = {
    SearchNavigationController: SearchNavigationController,
    searchNavigationComponentDefinition: searchNavigationComponentDefinition
};

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navigation\" aria-labelledby=\"searchNavigation-title\">\r\n    <h2 id=\"searchNavigation-title\" class=\"sr-only\">Search results navigation</h2>\r\n\r\n    <ul class=\"navigation-items\">\r\n        <li ng-repeat=\"searchTerm in ::$ctrl.searchTerms track by searchTerm\">\r\n            <a\r\n                aria-controls=\"{{ ::searchTerm }}\"\r\n                aria-expanded=\"{{ ::(searchTerm === $ctrl.searchTerm) }}\"\r\n                ui-sref=\"shop.search({ searchTerm: '{{ ::searchTerm }}', multisearchItems: {{ ::$ctrl.getMultisearchParam() }}, filter: undefined })\"\r\n                ui-sref-opts=\"{ inherit: false, reload: true }\"\r\n                ng-class=\"::($ctrl.isMultisearch ? 'navigation-link' : 'navigation-header navigation-link is-inert')\">\r\n                <span>\r\n                    {{ ::(!$ctrl.isMultisearch ? 'Search: ' : '') + searchTerm }}\r\n                    <span ng-if=\"!$ctrl.searchService.searchCounts.loadingCount && $ctrl.searchTerm === searchTerm && $ctrl.isMultisearch\" class=\"multisearch-count\">({{ ::$ctrl.searchService.searchCounts.Total }})</span>\r\n                    <i ng-if=\"$ctrl.isMultisearch\" ng-class=\"::($ctrl.searchTerm === searchTerm ? 'iconww-ArrowUp' : 'iconww-ArrowDown')\"></i>\r\n                    <wow-loading-spinner class=\"searchCountSpinner\" ng-if=\"$ctrl.searchService.searchCounts.loadingCount && isActiveMultisearchItem(searchTerm)\"></wow-loading-spinner>\r\n                </span>\r\n            </a>\r\n\r\n            <ul id=\"{{ ::searchTerm }}\" class=\"navigation-items\" aria-label=\"{{ ::searchTerm }} results\" ng-if=\"::searchTerm === $ctrl.searchTerm\">\r\n                <li>\r\n                    <wow-search-navigation-link\r\n                        count=\"$ctrl.searchService.searchCounts.ProductCount\"\r\n                        is-disabled=\"::$ctrl.disableNavigationLinks\"\r\n                        sref=\"shop.search.products({ searchTerm: '{{ ::searchTerm }}', multisearchItems: {{ ::$ctrl.getMultisearchParam() }}, filter: undefined })\"\r\n                        link-text=\"All Products\">\r\n                    </wow-search-navigation-link>\r\n                </li>\r\n                <li>\r\n                    <wow-search-navigation-link\r\n                        count=\"$ctrl.searchService.searchCounts.SpecialProductCount\"\r\n                        is-disabled=\"::$ctrl.disableNavigationLinks\"\r\n                        sref=\"shop.search.specials({ searchTerm: '{{ ::searchTerm }}', multisearchItems: {{ ::$ctrl.getMultisearchParam() }}, filter: undefined })\"\r\n                        link-text=\"All Specials\"\r\n                        class-modifier=\"is-special\">\r\n                    </wow-search-navigation-link>\r\n                </li>\r\n                <li>\r\n                    <wow-search-navigation-link\r\n                        count=\"$ctrl.searchService.searchCounts.RecipeCount\"\r\n                        is-disabled=\"::$ctrl.disableNavigationLinks\"\r\n                        sref=\"shop.search.recipes({ searchTerm: '{{ ::searchTerm }}', multisearchItems: {{ ::$ctrl.getMultisearchParam() }} })\"\r\n                        link-text=\"All Recipes\">\r\n                    </wow-search-navigation-link>\r\n                </li>\r\n                <li>\r\n                    <wow-search-navigation-link\r\n                        count=\"$ctrl.searchService.searchCounts.ArticleCount\"\r\n                        is-disabled=\"::$ctrl.disableNavigationLinks\"\r\n                        sref=\"shop.search.articles({ searchTerm: '{{ ::searchTerm }}', multisearchItems: {{ ::$ctrl.getMultisearchParam() }} })\"\r\n                        link-text=\"Articles\">\r\n                    </wow-search-navigation-link>\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n\r\n    <div ng-if=\"$ctrl.shouldShowCategories()\">\r\n        <button class=\"linkButton navigation-header navigation-link treeNavigation-parent\"\r\n            ng-class=\"{ 'is-open': $ctrl.isCategoriesExpanded }\"\r\n            ng-click=\"$ctrl.toggleCategories()\"\r\n            aria-controls=\"_searchResultCategories\"\r\n            aria-expanded=\"{{ $ctrl.isCategoriesExpanded }}\">\r\n            <span>\r\n                Results by Aisle&nbsp;<i class=\"iconww-ArrowDown treeNavigation-expandIcon\"></i><i class=\"iconww-ArrowUp treeNavigation-collapseIcon\"></i>\r\n            </span>\r\n        </button>\r\n\r\n        <ul id=\"_searchResultCategories\" aria-label=\"Search result categories\" class=\"treeNavigation-children\">\r\n            <li ng-repeat=\"category in $ctrl.searchService.categories | orderBy:'-ProductCount' track by (category.NodeId + $ctrl.isSpecial)\">\r\n                <a class=\"navigation-link\"\r\n                    href=\"javascript:;\"\r\n                    ng-click=\"$ctrl.categoryClick(category.NodeId)\"\r\n                    ng-class=\"{ 'is-active': $ctrl.isActiveCategory(category) }\">\r\n\r\n                    <span class=\"navigation-linkText\">\r\n                        {{ ::category.Description }}&nbsp;{{ (!$ctrl.searchService.searchCounts.loadingCount && category.ProductCount) ? '(' + category.ProductCount + ')' : '' }}&nbsp;<i class=\"iconww-ArrowRight\"></i>\r\n                    </span>\r\n                </a>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</nav>\r\n"

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchNavigationLinkController = function SearchNavigationLinkController(searchService) {
    _classCallCheck(this, SearchNavigationLinkController);

    this.searchService = searchService;
};

SearchNavigationLinkController.$inject = ['SearchService'];

var searchNavigationLinkComponentDefinition = {
    bindings: {
        count: '<',
        isDisabled: '<',
        sref: '@',
        linkText: '@',
        classModifier: '@?'
    },
    controller: SearchNavigationLinkController,
    template: __webpack_require__(962).trim()
};

module.exports = {
    SearchNavigationLinkController: SearchNavigationLinkController,
    searchNavigationLinkComponentDefinition: searchNavigationLinkComponentDefinition
};

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = "<a\r\n    class=\"navigation-link\"\r\n    ng-class=\"[$ctrl.classModifier, { 'is-disabled': ($ctrl.count <= 0 || $ctrl.isDisabled) }]\"\r\n    ui-sref=\"{{ $ctrl.sref }}\"\r\n    ui-sref-opts=\"{ inherit: false }\"\r\n    ui-sref-active-eq=\"is-active\">\r\n\r\n    <span>\r\n        {{ ::$ctrl.linkText }}\r\n        <span ng-show=\"!$ctrl.searchService.searchCounts.loadingCount && $ctrl.count != null\">({{ $ctrl.count }})&nbsp;<i class=\"iconww-ArrowRight\"></i></span>\r\n        <wow-loading-spinner class=\"searchCountSpinner\" ng-if=\"$ctrl.searchService.searchCounts.loadingCount\"></wow-loading-spinner>\r\n    </span>\r\n</a>\r\n"

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    filter = _require.filter,
    some = _require.some,
    _require2 = __webpack_require__(10),
    createProductTiles = _require2.createProductTiles,
    createBundleTiles = _require2.createBundleTiles;

var SearchProductTileListController = function () {
    function SearchProductTileListController(settings, analyticsService, searchService, sortByKeys, pageBannerStateService) {
        _classCallCheck(this, SearchProductTileListController);

        this.settings = settings;
        this.analyticsService = analyticsService;
        this.searchService = searchService;
        this.sortByKeys = sortByKeys;
        this.pageBannerStateService = pageBannerStateService;
    }

    _createClass(SearchProductTileListController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.filter) {
                this.sortOptions = {
                    sortContext: this.sortByKeys.SEARCH_RESULTS_KEY,
                    sortTypes: this.getSortTypes(this.settings.search.sortOptions)
                };
            }
        }
    }, {
        key: 'getSortTypes',
        value: function getSortTypes(sortTypes) {
            if (this.isSpecial) {
                sortTypes = filter(sortTypes, function (item) {
                    return item.Value !== 'Special';
                });
            }

            if (this.isList || this.isFilteredByCategory()) {
                sortTypes = filter(sortTypes, function (item) {
                    return item.Value !== 'Aisle';
                });
            }

            return sortTypes;
        }
    }, {
        key: 'isFilteredByCategory',
        value: function isFilteredByCategory() {
            return this.filter && some(this.filter.filters, { Key: 'Category' });
        }
    }, {
        key: 'createTiles',
        value: function createTiles(result) {
            return {
                items: this.isSpecial ? createProductTiles(result.items) : createBundleTiles(result.items),
                totalRecordCount: result.totalRecordCount,
                aggregations: result.aggregations
            };
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber) {
            var _this = this;

            var sortType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Name';
            var searchFilter = arguments[3];

            var cardsPromise = this.isSpecial ? this.searchService.doSearchSpecials(this.searchTerm, pageSize, pageNumber, sortType, searchFilter) : this.searchService.doSearch(this.searchTerm, pageSize, pageNumber, sortType, !!this.isSpecial, searchFilter);

            return cardsPromise.then(function (result) {
                return _this.tobaccoCheck(result);
            }).then(function (result) {
                return _this.createTiles(result);
            }).then(function (result) {
                return _this.pushAnalytics(result);
            });
        }
    }, {
        key: 'pushAnalytics',
        value: function pushAnalytics(result) {
            if (this.searchService.isHeaderSearch) {
                this.searchService.isHeaderSearch = false;
                var searchKeywordType = this.settings.search.suggestionType === 'completion' ? 'SuggestedV3' : 'Suggested';
                this.analyticsService.push({
                    data: {
                        trackingType: 'link',
                        searchKeyword: this.searchTerm,
                        listKeywords: this.multisearchItems,
                        searchResult: result,
                        refinementsUsed: 'All Products',
                        searchKeywordType: this.searchService.isAutocompleteSearch ? searchKeywordType : 'Self-typed'
                    },
                    type: this.analyticsService.mapperTypes.customEvent.search.success
                });

                this.searchService.isAutocompleteSearch = false;
            }

            return result;
        }
    }, {
        key: 'tobaccoCheck',
        value: function tobaccoCheck(result) {
            this.pageBannerStateService.setTobaccoBanner(result.hasTobaccoItems);

            return result;
        }
    }, {
        key: 'createAnalyticsData',
        value: function createAnalyticsData(contentData) {
            return {
                type: this.isSpecial ? 'specials' : 'products',
                categories: this.searchService.categories || '',
                sortOptions: this.sortOptions,
                sortBy: contentData.sortType ? contentData.sortType.Value : '',
                searchKeyword: this.searchTerm,
                listKeywords: this.multisearchItems,
                refinementsUsed: this.filter ? this.filter.filters : '',
                searchResult: contentData,
                pageNumber: this.pageNumber
            };
        }
    }, {
        key: 'pushContentDataToAnalytics',
        value: function pushContentDataToAnalytics(contentData) {
            this.analyticsService.push({
                data: this.createAnalyticsData(contentData),
                type: this.analyticsService.mapperTypes.search.result
            });
        }
    }]);

    return SearchProductTileListController;
}();

SearchProductTileListController.$inject = ['Settings', 'AnalyticsService', 'SearchService', 'SortByKeys', 'PageBannerStateService'];

var searchProductTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        multisearchItems: '<',
        isSpecial: '<',
        isList: '<',
        pageNumber: '<',
        sortBy: '<',
        filter: '<'
    },
    controller: SearchProductTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.settings.search.searchHeadingText + \' \u201C\' + $ctrl.searchTerm + \'\u201D\'"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            filter="$ctrl.filter"\n            sort-options="$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType, filter)"\n            should-remember-sort="::$ctrl.settings.search.shouldRememberSort"\n            push-content-to-analytics="$ctrl.pushContentDataToAnalytics(contentData)"\n            no-results-term="$ctrl.searchTerm">\n\n            <zero-result>\n                <wow-search-zero-results></wow-search-zero-results>\n            </zero-result>\n\n            <control>\n                <wow-search-term-tile-list-updater\n                    search-term="$ctrl.searchTerm">\n                </wow-search-term-tile-list-updater>\n            </control>\n        </wow-tile-list>\n    '
};

module.exports = {
    SearchProductTileListController: SearchProductTileListController,
    searchProductTileListComponentDefinition: searchProductTileListComponentDefinition
};

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(26),
    createRecipeTiles = _require.createRecipeTiles;

var SearchRecipeTileListController = function () {
    function SearchRecipeTileListController(settings, analyticsService, searchService, sortByKeys) {
        _classCallCheck(this, SearchRecipeTileListController);

        this.settings = settings;
        this.analyticsService = analyticsService;
        this.searchService = searchService;
        this.sortByKeys = sortByKeys;
    }

    _createClass(SearchRecipeTileListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
        }
    }, {
        key: 'createTiles',
        value: function createTiles(tiles) {
            return {
                items: createRecipeTiles(tiles.items),
                totalRecordCount: tiles.totalRecordCount
            };
        }
    }, {
        key: 'pushToAnalytics',
        value: function pushToAnalytics(tiles) {
            if (this.searchService.isHeaderSearch) {
                this.searchService.isHeaderSearch = false;
                var searchKeywordType = this.settings.search.suggestionType === 'completion' ? 'SuggestedV3' : 'Suggested';
                this.analyticsService.push({
                    data: {
                        trackingType: 'link',
                        searchKeyword: this.searchTerm,
                        listKeywords: this.multisearchItems,
                        searchResult: tiles,
                        refinementsUsed: 'All Recipes',
                        searchKeywordType: this.searchService.isAutocompleteSearch ? searchKeywordType : 'Self-typed'
                    },
                    type: this.analyticsService.mapperTypes.customEvent.search.success
                });

                this.searchService.isAutocompleteSearch = false;
            }

            return tiles;
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber, sortType) {
            var _this = this;

            return this.searchService.doSearchRecipes(this.searchTerm, pageSize, pageNumber, sortType).then(function (tiles) {
                return _this.createTiles(tiles);
            }).then(function (tiles) {
                return _this.pushToAnalytics(tiles);
            });
        }
    }, {
        key: 'createAnalyticsData',
        value: function createAnalyticsData(contentData) {
            return {
                type: 'recipes',
                sortOptions: this.sortOptions,
                sortBy: contentData.sortType ? contentData.sortType.Value : '',
                searchKeyword: this.searchTerm,
                listKeywords: this.multisearchItems,
                searchResult: contentData,
                pageNumber: this.pageNumber
            };
        }
    }, {
        key: 'pushContentDataToAnalytics',
        value: function pushContentDataToAnalytics(contentData) {
            this.analyticsService.push({
                data: this.createAnalyticsData(contentData),
                type: this.analyticsService.mapperTypes.search.result
            });
        }
    }]);

    return SearchRecipeTileListController;
}();

SearchRecipeTileListController.$inject = ['Settings', 'AnalyticsService', 'SearchService', 'SortByKeys'];

var searchRecipeTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        pageNumber: '<',
        sortBy: '<'
    },
    controller: SearchRecipeTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.settings.search.searchHeadingText + \' \u201C\' + $ctrl.searchTerm + \'\u201D\'"\n            page-number="$ctrl.pageNumber"\n            sort-by="$ctrl.sortBy"\n            sort-options="::$ctrl.sortOptions"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)"\n            should-remember-sort="::$ctrl.settings.search.shouldRememberSort"\n            push-content-to-analytics="$ctrl.pushContentDataToAnalytics(contentData)">\n\n            <zero-result>\n                <wow-search-zero-results></wow-search-zero-results>\n            </zero-result>\n        </wow-tile-list>\n    '
};

module.exports = {
    SearchRecipeTileListController: SearchRecipeTileListController,
    searchRecipeTileListComponentDefinition: searchRecipeTileListComponentDefinition
};

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(32),
    createInspirationTiles = _require.createInspirationTiles;

var SearchInspirationTileListController = function () {
    function SearchInspirationTileListController(settings, analyticsService, searchService) {
        _classCallCheck(this, SearchInspirationTileListController);

        this.settings = settings;
        this.analyticsService = analyticsService;
        this.searchService = searchService;
    }

    _createClass(SearchInspirationTileListController, [{
        key: 'createTiles',
        value: function createTiles(result) {
            return {
                items: createInspirationTiles(result.items),
                totalRecordCount: result.totalRecordCount
            };
        }
    }, {
        key: 'pushToAnalytics',
        value: function pushToAnalytics(result) {
            if (this.searchService.isHeaderSearch) {
                this.searchService.isHeaderSearch = false;
                var searchKeywordType = this.settings.search.suggestionType === 'completion' ? 'SuggestedV3' : 'Suggested';
                this.analyticsService.push({
                    data: {
                        trackingType: 'link',
                        searchKeyword: this.searchTerm,
                        listKeywords: this.multisearchItems,
                        searchResult: result,
                        refinementsUsed: 'Articles',
                        searchKeywordType: this.searchService.isAutocompleteSearch ? searchKeywordType : 'Self-typed'
                    },
                    type: this.analyticsService.mapperTypes.customEvent.search.success
                });

                this.searchService.isAutocompleteSearch = false;
            }

            this.analyticsService.push({
                data: {
                    type: 'articles',
                    searchKeyword: this.searchTerm,
                    listKeywords: this.multisearchItems,
                    pageNumber: this.pageNumber,
                    searchResult: result
                },
                type: this.analyticsService.mapperTypes.search.result
            });

            return result;
        }
    }, {
        key: 'getTiles',
        value: function getTiles(pageSize, pageNumber) {
            var _this = this;

            return this.searchService.doSearchArticles(this.searchTerm, pageSize, pageNumber).then(function (result) {
                return _this.createTiles(result);
            }).then(function (result) {
                return _this.pushToAnalytics(result);
            });
        }
    }]);

    return SearchInspirationTileListController;
}();

SearchInspirationTileListController.$inject = ['Settings', 'AnalyticsService', 'SearchService'];

var searchInspirationTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        pageNumber: '<'
    },
    controller: SearchInspirationTileListController,
    template: '\n        <wow-tile-list\n            list-title="$ctrl.settings.search.searchHeadingText + \' \u201C\' + $ctrl.searchTerm + \'\u201D\'"\n            page-number="$ctrl.pageNumber"\n            get-tiles="$ctrl.getTiles(pageSize, pageNumber)"\n            should-remember-sort="::$ctrl.settings.search.shouldRememberSort">\n\n            <zero-result>\n                <wow-search-zero-results></wow-search-zero-results>\n            </zero-result>\n        </wow-tile-list>\n    '
};

module.exports = {
    SearchInspirationTileListController: SearchInspirationTileListController,
    searchInspirationTileListComponentDefinition: searchInspirationTileListComponentDefinition
};

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchTermTileListUpdaterController = function () {
    function SearchTermTileListUpdaterController() {
        _classCallCheck(this, SearchTermTileListUpdaterController);
    }

    _createClass(SearchTermTileListUpdaterController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.searchTerm && !changes.searchTerm.isFirstChange()) {
                this.tileList.update();
            }
        }
    }]);

    return SearchTermTileListUpdaterController;
}();

/**
 * @ngdoc component
 * @name wowSearchTermTileListUpdater
 *
 * This component is transcluded into tile list for the purpose of updating
 * the products whenever the search term is changed.
 *
 * This is not useful for the search page itself since changing the search
 * term causes a reload there - this is intended for use in lists when doing
 * free text tags search. Therefore this component is not needed for recipe
 * or inspiration search since those searches are not performed outside of search.
 */


var searchTermTileListUpdaterComponentDefinition = {
    bindings: {
        searchTerm: '<'
    },
    require: {
        tileList: '^wowTileList'
    },
    controller: SearchTermTileListUpdaterController
};

module.exports = {
    SearchTermTileListUpdaterController: SearchTermTileListUpdaterController,
    searchTermTileListUpdaterComponentDefinition: searchTermTileListUpdaterComponentDefinition
};

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchZeroResultComponentController = function () {
    function SearchZeroResultComponentController($sce, $state, $sanitize, settings, analyticsService, searchService) {
        _classCallCheck(this, SearchZeroResultComponentController);

        this.$sce = $sce;
        this.$state = $state;
        this.$sanitize = $sanitize;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.searchService = searchService;
    }

    _createClass(SearchZeroResultComponentController, [{
        key: '$onInit',
        value: function $onInit() {
            this.searchTerm = '';
            this.originalSearchTerm = this.$sanitize(this.$state.params.searchTerm);

            this.pageName = 'results';
            if (this.$state.current.name === 'shop.search.products') {
                this.pageName = 'products';
            } else if (this.$state.current.name === 'shop.search.specials') {
                this.pageName = 'specials';
            } else if (this.$state.current.name === 'shop.search.recipes') {
                this.pageName = 'recipes';
            } else if (this.$state.current.name === 'shop.search.articles') {
                this.pageName = 'articles';
            }

            this.analyticsService.push({
                data: {
                    type: this.pageName,
                    categories: this.searchService.categories || '',
                    searchKeyword: this.originalSearchTerm,
                    listKeywords: this.$state.params.multisearchItems,
                    searchResult: []
                },
                type: this.analyticsService.mapperTypes.search.result
            });

            var emptyProductSearchMessageBeforeAfter = this.settings.search.zeroSearchResultsMessage.split('{search}');
            this.searchTerm = this.$state.params.searchTerm;
            this.emptyProductSearchMessageBefore = this.$sce.trustAsHtml(emptyProductSearchMessageBeforeAfter[0]);
            this.emptyProductSearchMessageAfter = this.$sce.trustAsHtml(emptyProductSearchMessageBeforeAfter[1]);
        }
    }]);

    return SearchZeroResultComponentController;
}();

SearchZeroResultComponentController.$inject = ['$sce', '$state', '$sanitize', 'Settings', 'AnalyticsService', 'SearchService'];

var searchZeroResultComponentDefinition = {
    controller: SearchZeroResultComponentController,
    template: __webpack_require__(968).trim()
};

module.exports = {
    SearchZeroResultComponentController: SearchZeroResultComponentController,
    searchZeroResultComponentDefinition: searchZeroResultComponentDefinition
};

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports = "<div class=\"search-zero-results-wrapper\">\r\n    <h1 class=\"search-zero-results-wrapper-header\">No {{ $ctrl.pageName}} found</h1>\r\n    <div class=\"search-zero-results-wrapper-blurb\">\r\n        <span ng-bind-html=\"$ctrl.emptyProductSearchMessageBefore\"></span>\r\n        {{ $ctrl.searchTerm }}\r\n        <span ng-bind-html=\"$ctrl.emptyProductSearchMessageAfter\"></span>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var multisearchKey = 'multisearchKey';

var SearchMultisearchService = function SearchMultisearchService(Restangular, breakpointsService, $stateParams, LocalStorageWrapper) {
    this._api = Restangular.one('Search');
    this.breakpoints = breakpointsService;
    this._stateParams = $stateParams;
    this.localStorage = LocalStorageWrapper;
};

SearchMultisearchService.prototype.getMultisearchItems = function () {
    var items = this.localStorage.get(multisearchKey) || '';
    return items.split(',');
};

SearchMultisearchService.prototype.updateMultisearchItems = function (multisearchItems) {
    if (multisearchItems) {
        this.localStorage.set(multisearchKey, multisearchItems.join(','));
    }
};

SearchMultisearchService.prototype.isSearchTermPartOfMultisearchList = function (searchTerm, multisearchItems) {
    if (!this._stateParams.multisearchItems && !multisearchItems) {
        return false;
    }
    if (!this._stateParams.searchTerm && !searchTerm) {
        return false;
    }

    var searchPhrase = searchTerm || this._stateParams.searchTerm;
    var items = multisearchItems ? multisearchItems.split(',') : this._stateParams.multisearchItems.split(',');
    var listIndex = items.indexOf(searchPhrase);
    if (listIndex < 0) {
        return false;
    }

    return true;
};

SearchMultisearchService.prototype.isSearchMultisearch = function () {
    return this._stateParams.multisearchItems && this.isSearchTermPartOfMultisearchList();
};

module.exports = SearchMultisearchService;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($sce, settingsService, $stateParams, searchPhraseActionService, $state, shopperService) {
    function SearchExternalResultsController() {
        var _this = this;

        // If the search phrase isn't associated with an action
        // Or if the action was to prompt for login and user is not a guest, do normal search
        searchPhraseActionService.getSearchPhraseAction($stateParams.searchTerm).then(function (action) {
            if (!action || action.Action === searchPhraseActionService.action.login && !shopperService.IsGuest) {
                $state.go('shop.search', { searchTerm: $stateParams.searchTerm, multisearchItems: $stateParams.multisearchItems }, { inherit: false, reload: true, location: 'replace' });
            }
        });

        settingsService.getSettingValue('Search', 'SearchResultInNewTab').then(function (setting) {
            var externalResultMessageBeforeAfter = setting.split('{searchTerm}');
            _this.SearchTerm = $stateParams.searchTerm;
            _this.ExternalResultMessageBefore = $sce.trustAsHtml(externalResultMessageBeforeAfter[0]);
            _this.ExternalResultMessageAfter = $sce.trustAsHtml(externalResultMessageBeforeAfter[1]);
        });
    }

    return {
        restrict: 'E',
        scope: {},
        bindToController: true,
        controllerAs: 'ctrl',
        controller: [SearchExternalResultsController],
        template: '<div class="search-zero-results-wrapper"><div class="search-zero-results-wrapper-blurb"><span ng-bind-html="ctrl.ExternalResultMessageBefore"></span>{{ctrl.SearchTerm}}<span ng-bind-html="ctrl.ExternalResultMessageAfter"></span></div></div>'
    };
};

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(4); // eslint-disable-line no-unused-vars
__webpack_require__(21);
var olyDialog = __webpack_require__(22);

var wowCommonModule = __webpack_require__(5);
var olyCommonModule = __webpack_require__(3);
var analyticsModule = __webpack_require__(8);

var orderModuleName = 'wowApp.order';

angular.module(orderModuleName, [analyticsModule, olyCommonModule, wowCommonModule, uiRouter, 'restangular', olyDialog]);

// ------------------------------------------
// Components
// ------------------------------------------
__webpack_require__(972);
__webpack_require__(991);
__webpack_require__(993);
__webpack_require__(995);

module.exports = orderModuleName;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp.shop');

var _require = __webpack_require__(973),
    checkoutConfirmationControllerComponentDefinition = _require.checkoutConfirmationControllerComponentDefinition;

var _require2 = __webpack_require__(975),
    checkoutConfirmationOrderDetailsControllerComponentDefinition = _require2.checkoutConfirmationOrderDetailsControllerComponentDefinition;

var _require3 = __webpack_require__(977),
    checkoutConfirmationOrderEmailControllerComponentDefinition = _require3.checkoutConfirmationOrderEmailControllerComponentDefinition;

var _require4 = __webpack_require__(979),
    checkoutConfirmationOrderPaymentBreakdownControllerComponentDefinition = _require4.checkoutConfirmationOrderPaymentBreakdownControllerComponentDefinition;

var _require5 = __webpack_require__(981),
    checkoutConfirmationOrderSaveToListControllerComponentDefinition = _require5.checkoutConfirmationOrderSaveToListControllerComponentDefinition;

var _require6 = __webpack_require__(983),
    orderConfirmationOrderInformaionComponentDefinition = _require6.orderConfirmationOrderInformaionComponentDefinition;

var _require7 = __webpack_require__(984),
    orderConfirmationExportOptionsControllerComponentDefinition = _require7.orderConfirmationExportOptionsControllerComponentDefinition;

var _require8 = __webpack_require__(986),
    orderConfirmationPanelControllerComponentDefinition = _require8.orderConfirmationPanelControllerComponentDefinition;

var _require9 = __webpack_require__(988),
    orderConfirmationPrintControllerComponentDefinition = _require9.orderConfirmationPrintControllerComponentDefinition;

var OrderConfirmationEmailService = __webpack_require__(990);

wowApp.component('wowCheckoutConfirmation', checkoutConfirmationControllerComponentDefinition);
wowApp.component('wowCheckoutConfirmationOrderDetails', checkoutConfirmationOrderDetailsControllerComponentDefinition);
wowApp.component('wowCheckoutConfirmationOrderEmail', checkoutConfirmationOrderEmailControllerComponentDefinition);
wowApp.component('wowCheckoutConfirmationOrderPaymentBreakdown', checkoutConfirmationOrderPaymentBreakdownControllerComponentDefinition);
wowApp.component('wowCheckoutConfirmationOrderSaveToList', checkoutConfirmationOrderSaveToListControllerComponentDefinition);
wowApp.component('wowOrderConfirmationOrderInformation', orderConfirmationOrderInformaionComponentDefinition);
wowApp.component('wowOrderConfirmationExportOptions', orderConfirmationExportOptionsControllerComponentDefinition);
wowApp.component('wowOrderConfirmationPanel', orderConfirmationPanelControllerComponentDefinition);
wowApp.component('wowOrderConfirmationPrint', orderConfirmationPrintControllerComponentDefinition);
wowApp.service('OrderConfirmationEmailService', ['Restangular', OrderConfirmationEmailService]);

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    cloneDeep = _require.cloneDeep,
    forEach = _require.forEach,
    reduce = _require.reduce;

var $ = __webpack_require__(2);

var CheckoutConfirmationController = function () {
    function CheckoutConfirmationController(settings, analyticsService, shopperService, orderInformationService) {
        _classCallCheck(this, CheckoutConfirmationController);

        this.settings = settings;
        this.analyticsService = analyticsService;
        this.shopperService = shopperService;
        this.orderInformationService = orderInformationService;
    }

    _createClass(CheckoutConfirmationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.placedOrder = this.confirmation.Order;
            this.orderId = this.placedOrder.OrderId;
            this.orderStatus = this.placedOrder.OrderStatus;
            this.orderCancelled = this.orderStatus === 'Cancelled';
            this.RewardsCardName = this.settings.everydayRewards.cardName;
            this.EVoucherDisplayName = this.settings.checkout.eVoucherDisplayName;

            if (this.placedOrder) {
                if (!this.confirmation.IsPushedToDtm || !this.confirmation.IsPushedToGtm) {
                    var orderWithoutDetail = cloneDeep(this.placedOrder);
                    delete orderWithoutDetail.PaymentBreakdown;
                    var analyticsObj = {
                        data: {
                            order: orderWithoutDetail,
                            orderDetails: this.placedOrder,
                            shopper: this.shopperService.shopper,
                            shopperDetails: undefined,
                            rewardsPointsConversionBase: this.settings.loyalty.rewardsConversionBase
                        }
                    };
                    analyticsObj.type = 'orderAnalytics';
                    this.analyticsService.push(analyticsObj);
                }

                if (this.confirmation.Order.IsRewardsSubscriptionPurchased) {
                    this.rewardsPlus = {
                        isRewardsSubscriptionPurchased: true,
                        edrCardNumber: this.confirmation.Order.RewardsCardNumber
                    };

                    this.shopperService.assignRewardsPlusPurchaseInfo(this.rewardsPlus);
                }
            }

            if (this.settings.siteCensus.responsysTrackingPixel) {
                this.addResponsysTrackingPixelToBody(this.createSourceString(this.settings.siteCensus.responsysTrackingPixel));
            }

            this.isDelivery = this.isDelivery(this.placedOrder.DeliveryMethod);
            this.deliveryTypeHeader = this.getDeliveryTypeHeader(this.placedOrder.DeliveryMethod);

            this.warningMessage = this.orderInformationService.getWarningMessage({
                order: this.confirmation,
                deliveryMethod: this.confirmation.Order.DeliveryMethod
            });
        }
    }, {
        key: 'stringFormat',
        value: function stringFormat(string, args) {
            forEach(args, function (value, key) {
                string = string.replace('{' + key + '}', value);
            });
            return string;
        }
    }, {
        key: 'calculateQuantity',
        value: function calculateQuantity(products) {
            return reduce(products, function (sum, product) {
                return sum + product.Quantity;
            }, 0);
        }
    }, {
        key: 'createSourceString',
        value: function createSourceString(urlSetting) {
            return this.stringFormat(urlSetting, {
                OrderID: this.placedOrder.OrderId,
                OrderTotal: this.placedOrder.TotalIncludingGst,
                OrderQty: this.calculateQuantity(this.placedOrder.Products),
                ShopperID: this.shopperService.shopper.Id
            });
        }
    }, {
        key: 'addResponsysTrackingPixelToBody',
        value: function addResponsysTrackingPixelToBody(sourceString) {
            $('<img id="responsysTrackingPixel" src="' + sourceString + '">').appendTo('body');
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            var element = $('#responsysTrackingPixel');
            if (element) {
                $('#responsysTrackingPixel').remove();
            }
        }
    }, {
        key: 'isDelivery',
        value: function isDelivery(deliveryMethod) {
            return deliveryMethod === this.settings.orderConfirmation.courierDeliveryMethod || deliveryMethod === this.settings.orderConfirmation.expressDeliveryMethod;
        }
    }, {
        key: 'getDeliveryTypeHeader',
        value: function getDeliveryTypeHeader(deliveryMethod) {
            switch (deliveryMethod) {
                case this.settings.orderConfirmation.courierDeliveryMethod:
                    return this.settings.orderConfirmation.courierOrderConfirmationHeader;
                case this.settings.orderConfirmation.expressDeliveryMethod:
                    return this.settings.orderConfirmation.expressDeliveryOrderConfirmationHeader;
                case this.settings.orderConfirmation.pickupDeliveryMethod:
                case this.settings.orderConfirmation.hubspokDeliveryMethod:
                    return this.settings.orderConfirmation.pickupDeliveryOrderConfirmationHeader;
                default:
                    return '';
            }
        }
    }]);

    return CheckoutConfirmationController;
}();

CheckoutConfirmationController.$inject = ['Settings', 'AnalyticsService', 'ShopperService', 'OrderInformationService'];

var checkoutConfirmationControllerComponentDefinition = {
    bindings: {
        confirmation: '<',
        showSaveCard: '<saveCard'
    },
    controller: CheckoutConfirmationController,
    template: __webpack_require__(974).trim()
};

module.exports = {
    CheckoutConfirmationController: CheckoutConfirmationController,
    checkoutConfirmationControllerComponentDefinition: checkoutConfirmationControllerComponentDefinition
};

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkoutConfirmation\" ng-if=\"$ctrl.orderId\">\r\n    <div class=\"checkoutConfirmation-message\" ng-switch=\"$ctrl.orderStatus\">\r\n        <i class=\"checkoutConfirmation-successIcon iconww-Tick\" />\r\n        <h2 class=\"checkoutConfirmation-header\">\r\n            {{$ctrl.deliveryTypeHeader}}\r\n            <wow-setting ng-switch-when=\"Placed\" setting-group=\"OrderConfirmation\" setting-name=\"OrderConfirmedMessage\"></wow-setting>\r\n            <wow-setting ng-switch-when=\"Cancelled\" setting-group=\"OrderConfirmation\" setting-name=\"OrderCancelledMessage\"></wow-setting>\r\n        </h2>\r\n        <span>\r\n            <wow-setting ng-switch-when=\"Placed\" setting-group=\"OrderConfirmation\" setting-name=\"OrderConfirmedAdditionalMessage\"></wow-setting>\r\n            <div ng-if=\"$ctrl.orderCancelled && !$ctrl.placedOrder.IsPostPickPayOrder\">\r\n                <wow-setting setting-group=\"OrderConfirmation\" setting-name=\"OrderCancelledAdditionalMessage\"></wow-setting>\r\n            </div>\r\n            <div ng-if=\"$ctrl.orderCancelled && $ctrl.placedOrder.IsPostPickPayOrder\">\r\n                <wow-setting setting-group=\"Payments\" setting-name=\"CancelPostPickPayOrderCancelConfirmationAdditionalMessage\"></wow-setting>\r\n                <div class=\"checkoutConfirmation-information\">\r\n                            <wow-setting class=\"checkoutConfirmation-warning\" setting-group=\"Payments\" setting-name=\"CancelPostPickPayOrderCancelConfirmationBodyMessage\"></wow-setting>\r\n                </div>\r\n            </div>\r\n        </span>\r\n    </div>\r\n    <!-- Order email details -->\r\n    <wow-checkout-confirmation-order-email order=\"$ctrl.placedOrder\"></wow-checkout-confirmation-order-email>\r\n\r\n    <!-- Main Order details -->\r\n    <wow-checkout-confirmation-order-details\r\n        order=\"$ctrl.placedOrder\"\r\n        order-cancelled=\"$ctrl.orderCancelled\"\r\n        show-save-card=\"$ctrl.showSaveCard\">\r\n    </wow-checkout-confirmation-order-details>\r\n\r\n    <!-- Save order as list -->\r\n    <wow-checkout-confirmation-order-save-to-list\r\n    ng-if=\"$ctrl.settings.content.enableSaveOrderToList\"\r\n    order-id=\"$ctrl.confirmation.Order.OrderId\">\r\n    </wow-checkout-confirmation-order-save-to-list>\r\n\r\n    <!-- Order warning details -->\r\n    <div\r\n        class=\"alert alert--info checkoutConfirmation-warning\"\r\n        ng-if=\"$ctrl.warningMessage\"\r\n        tabindex=\"-1\"\r\n        role=\"alert\">\r\n        <span class=\"checkoutConfirmation-warningIconContainer\">\r\n            <img ng-src=\"/images/order/iconww-message-alert.svg\" alt=\"Alert\"/>\r\n        </span>\r\n        <p class=\"checkoutConfirmation-warningTextContainer\" ng-bind-html=\"$ctrl.warningMessage | sanitize\"></p>\r\n    </div>\r\n\r\n    <wow-order-confirmation-order-information\r\n        order=\"$ctrl.confirmation\">\r\n    </wow-order-confirmation-order-information>\r\n</div>\r\n"

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    findKey = _require.findKey,
    isEmpty = _require.isEmpty;

var CheckoutConfirmationOrderDetailsController = function () {
    function CheckoutConfirmationOrderDetailsController(settings, shopperService) {
        _classCallCheck(this, CheckoutConfirmationOrderDetailsController);

        this.settings = settings;
        this.shopperService = shopperService;
    }

    _createClass(CheckoutConfirmationOrderDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.digitalPayFallbackEnabled = this.settings.digitalPay.digitalPayFallback;
            this.shopperService.getDeliveryPassesSummary().then(function (response) {
                _this.hasDeliveryPasses = response.ActiveDeliveryPassSummary || !isEmpty(response.UnusedDeliveryPassesSummary);
            });

            this.paymentType = this.getPaymentType();
            this.packagingFeeEnabled = this.settings.checkout.enablePackagingPreference && !!this.order.PackagingFeeLabel;
        }
    }, {
        key: 'getPaymentType',
        value: function getPaymentType() {
            var paidByKey = findKey(this.order.PaymentBreakdown, function (payment) {
                return payment > 0;
            });

            // Only support credit card, gift card and paypal for now
            switch (paidByKey) {
                case this.settings.orderConfirmation.creditCardKey:
                    return 'Credit card';
                case this.settings.orderConfirmation.paypalKey:
                    return 'PayPal';
                case this.settings.orderConfirmation.giftCardKey:
                    return 'Gift card';
                default:
                    return '';
            }
        }
    }]);

    return CheckoutConfirmationOrderDetailsController;
}();

CheckoutConfirmationOrderDetailsController.$inject = ['Settings', 'ShopperService'];

var checkoutConfirmationOrderDetailsControllerComponentDefinition = {
    bindings: {
        order: '<',
        orderCancelled: '<',
        showSaveCard: '<'
    },
    controller: CheckoutConfirmationOrderDetailsController,
    template: __webpack_require__(976).trim()
};

module.exports = {
    CheckoutConfirmationOrderDetailsController: CheckoutConfirmationOrderDetailsController,
    checkoutConfirmationOrderDetailsControllerComponentDefinition: checkoutConfirmationOrderDetailsControllerComponentDefinition
};

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkoutConfirmationOrderDetails\">\r\n    <div class=\"checkoutConfirmationOrderDetails-orderDetailsRow\">\r\n        <span>Order Number</span>\r\n        <span class=\"checkoutConfirmationOrderDetails-orderDetailsText\">{{$ctrl.order.OrderId}}</span>\r\n    </div>\r\n    <div class=\"checkoutConfirmationOrderDetails-orderDetailsRow\">\r\n        <span>Order Created</span>\r\n        <span class=\"checkoutConfirmationOrderDetails-orderDetailsText\">{{$ctrl.order.CreatedDate | date: 'dd MMM yyyy'}}</span>\r\n    </div>\r\n\r\n    <div ng-if=\"!$ctrl.orderCancelled && $ctrl.order.IsPostPickPayOrder\" class=\"orderInformation\">\r\n        <div class=\"orderInformation-container\">\r\n            <h2 class=\"heading4 orderInformation-heading\">\r\n                YOUR PAYMENT:\r\n            </h2>\r\n\r\n            <div>\r\n                <p class=\"orderInformation-text\">\r\n                    <div wow-html-setting setting-group=\"Payments\" setting-name=\"OrderConfirmedPostPickPaymentMessage\"></div>\r\n                </p>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <!-- Order details which are not shown for cancelled orders -->\r\n    <div ng-if=\"!$ctrl.orderCancelled\">\r\n        <div class=\"checkoutConfirmationOrderDetails-orderDetailsRow\">\r\n            <span>Subtotal</span>\r\n            <span class=\"checkoutConfirmationOrderDetails-orderDetailsAmount\">{{$ctrl.order.Subtotal | currency}}</span>\r\n        </div>\r\n        <div class=\"checkoutConfirmationOrderDetails-orderDetailsRow\" ng-if=\"$ctrl.order.OrderDiscountWithoutTeamDiscount > 0\">\r\n            <span>Order discount</span>\r\n            <span class=\"checkoutConfirmationOrderDetails-orderDetailsDeduction\">-{{$ctrl.order.OrderDiscountWithoutTeamDiscount | currency}}</span>\r\n        </div>\r\n        <div class=\"checkoutConfirmationOrderDetails-orderDetailsRow\" ng-if=\"$ctrl.order.TeamDiscount > 0\">\r\n            <span>Staff discount</span>\r\n            <span class=\"checkoutConfirmationOrderDetails-orderDetailsDeduction\">-{{$ctrl.order.TeamDiscount | currency}}</span>\r\n        </div>\r\n        <div class=\"checkoutConfirmationOrderDetails-orderDetailsRow\" ng-if=\"$ctrl.packagingFeeEnabled\">\r\n            <div>\r\n                <span>{{$ctrl.order.PackagingFeeLabel}}</span>\r\n                <span ng-if=\"!!$ctrl.order.PackagingUnitPrice\" class=\"text-nowrap\"\r\n                    ng-bind-html=\"{EstimatedCount:$ctrl.order.PackagingCount, UnitCost:$ctrl.order.PackagingUnitPrice} | wowPackagingPriceLabel : true\">\r\n                </span>\r\n            </div>\r\n            <span class=\"checkoutConfirmationOrderDetails-orderDetailsAmount\">{{$ctrl.order.PackagingFee | currency}}</span>\r\n        </div>\r\n        <div class=\"checkoutConfirmationOrderDetails-orderDetailsRow deliveryFee\">\r\n            <div class=\"deliveryFee-container\">\r\n                <span>{{ $ctrl.order.DeliveryMethod === 'Pickup' ? 'Service' : 'Delivery' }} fee</span>\r\n                <span class=\"checkoutConfirmationOrderDetails-orderDetailsAmount\">\r\n                    {{  $ctrl.order.DeliveryMethod === 'Pickup' ? 0 : $ctrl.order.DeliveryFee | currency }}\r\n                </span>\r\n            </div>\r\n        </div>\r\n        <div class=\"checkoutConfirmationOrderDetails-orderDetailsTotal\">\r\n            <span class=\"checkoutConfirmationOrderDetails-orderDetailsTotalLabel\">Total <span class=\"checkoutConfirmationOrderDetails-orderDetailsTotalSideNote\">(incl GST)</span></span>\r\n            <span class=\"checkoutConfirmationOrderDetails-orderDetailsTotalAmount\">{{$ctrl.order.TotalIncludingGst | currency}}</span>\r\n        </div>\r\n\r\n        <!-- Order payment breakdown -->\r\n        <wow-checkout-confirmation-order-payment-breakdown order=\"$ctrl.order\"></wow-checkout-confirmation-order-payment-breakdown>\r\n\r\n        <div ng-if=\"$ctrl.showSaveCard && !$ctrl.digitalPayFallbackEnabled && $ctrl.paymentType\" class=\"checkoutConfirmationOrderDetails-saveCardContainer\">\r\n            <wow-save-card order-id=\"$ctrl.order.OrderId\" payment-type=\"$ctrl.paymentType\"></wow-save-card>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckoutConfirmationOrderEmailController = function () {
    function CheckoutConfirmationOrderEmailController(shopperService, settings) {
        _classCallCheck(this, CheckoutConfirmationOrderEmailController);

        this.shopperService = shopperService;
        this.settings = settings;
    }

    _createClass(CheckoutConfirmationOrderEmailController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.shouldHideTrackMyOrderLink = this.order.DeliveryMethod === this.settings.orderConfirmation.expressDeliveryMethod;
            this.shopperService.getCurrentShopper().then(function (shopper) {
                _this.currentShopperEmail = shopper.Email;
            });
        }
    }]);

    return CheckoutConfirmationOrderEmailController;
}();

CheckoutConfirmationOrderEmailController.$inject = ['ShopperService', 'Settings'];

var checkoutConfirmationOrderEmailControllerComponentDefinition = {
    bindings: {
        order: '<'
    },
    controller: CheckoutConfirmationOrderEmailController,
    template: __webpack_require__(978).trim()
};

module.exports = {
    CheckoutConfirmationOrderEmailController: CheckoutConfirmationOrderEmailController,
    checkoutConfirmationOrderEmailControllerComponentDefinition: checkoutConfirmationOrderEmailControllerComponentDefinition
};

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkoutConfirmationOrderEmail\">\r\n    <p>\r\n        An email is on its way to <span class=\"checkoutConfirmationOrderEmail-emailLink\">{{$ctrl.currentShopperEmail}}</span> with all your details including a summary of items ordered.\r\n    </p>\r\n    <p class=\"checkoutConfirmationOrderEmail-trackMyOrder\" ng-if=\"::!$ctrl.shouldHideTrackMyOrderLink\">\r\n        You can <a href=\"javascript:;\" ui-sref=\"shop.myaccount.trackmyorder.orderId({orderId: $ctrl.order.OrderId })\">track your order</a> to see its progress at any time.\r\n    </p>\r\n</div>\r\n"

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    toArray = _require.toArray,
    compact = _require.compact;

var CheckoutConfirmationOrderPaymentBreakdownController = function () {
    function CheckoutConfirmationOrderPaymentBreakdownController() {
        _classCallCheck(this, CheckoutConfirmationOrderPaymentBreakdownController);
    }

    _createClass(CheckoutConfirmationOrderPaymentBreakdownController, [{
        key: '$onInit',
        value: function $onInit() {
            this.shouldShowBreakdownAmount = compact(toArray(this.order.PaymentBreakdown)).length > 1;
        }
    }]);

    return CheckoutConfirmationOrderPaymentBreakdownController;
}();

var checkoutConfirmationOrderPaymentBreakdownControllerComponentDefinition = {
    bindings: {
        order: '<'
    },
    controller: [CheckoutConfirmationOrderPaymentBreakdownController],
    template: __webpack_require__(980).trim()
};

module.exports = {
    CheckoutConfirmationOrderPaymentBreakdownController: CheckoutConfirmationOrderPaymentBreakdownController,
    checkoutConfirmationOrderPaymentBreakdownControllerComponentDefinition: checkoutConfirmationOrderPaymentBreakdownControllerComponentDefinition
};

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkoutConfirmationOrderPaymentBreakdown\" ng-if=\"$ctrl.order.PaymentBreakdown\">\r\n    <div class=\"checkoutConfirmationOrderPaymentBreakdown-summaryRow\" ng-if=\"$ctrl.order.PaymentBreakdown.Coupon\">\r\n        <span class=\"checkoutConfirmationOrderPaymentBreakdown-summaryLabel\">Paid with Coupon</span>\r\n        <span\r\n            class=\"checkoutConfirmationOrderPaymentBreakdown-summaryPaymentAmount\"\r\n            ng-if=\"::$ctrl.shouldShowBreakdownAmount\">\r\n            {{$ctrl.order.PaymentBreakdown.Coupon | currency}}\r\n        </span>\r\n    </div>\r\n    <div class=\"checkoutConfirmationOrderPaymentBreakdown-summaryRow\" ng-if=\"$ctrl.order.PaymentBreakdown.eVoucher\">\r\n        <span class=\"checkoutConfirmationOrderPaymentBreakdown-summaryLabel\">\r\n            Paid with <wow-setting setting-group==\"Checkout\" setting-name=\"EVoucherDisplayName\"></wow-setting>\r\n        </span>\r\n        <span\r\n            class=\"checkoutConfirmationOrderPaymentBreakdown-summaryPaymentAmount\"\r\n            ng-if=\"::$ctrl.shouldShowBreakdownAmount\">\r\n            {{$ctrl.order.PaymentBreakdown.eVoucher | currency}}\r\n        </span>\r\n    </div>\r\n    <div class=\"checkoutConfirmationOrderPaymentBreakdown-summaryRow\" ng-if=\"$ctrl.order.PaymentBreakdown.WowRewards\">\r\n        <span class=\"checkoutConfirmationOrderPaymentBreakdown-summaryLabel\">\r\n            Paid with <wow-setting setting-group==\"EverydayRewards\" setting-name=\"CardName\"></wow-setting>\r\n        </span>\r\n        <span\r\n            class=\"checkoutConfirmationOrderPaymentBreakdown-summaryPaymentAmount\"\r\n            ng-if=\"::$ctrl.shouldShowBreakdownAmount\">\r\n            {{$ctrl.order.PaymentBreakdown.WowRewards | currency}}\r\n        </span>\r\n    </div>\r\n    <div class=\"checkoutConfirmationOrderPaymentBreakdown-summaryRow\" ng-if=\"$ctrl.order.PaymentBreakdown.GiftCard\">\r\n        <span class=\"checkoutConfirmationOrderPaymentBreakdown-summaryLabel\">Paid with Gift Card</span>\r\n        <span\r\n            class=\"checkoutConfirmationOrderPaymentBreakdown-summaryPaymentAmount\"\r\n            ng-if=\"::$ctrl.shouldShowBreakdownAmount\">\r\n            {{$ctrl.order.PaymentBreakdown.GiftCard | currency}}\r\n        </span>\r\n    </div>\r\n    <div class=\"checkoutConfirmationOrderPaymentBreakdown-summaryRow\" ng-if=\"$ctrl.order.PaymentBreakdown.CreditCard\">\r\n        <span class=\"checkoutConfirmationOrderPaymentBreakdown-summaryLabel\">Paid with Credit Card</span>\r\n        <span\r\n            class=\"checkoutConfirmationOrderPaymentBreakdown-summaryPaymentAmount\"\r\n            ng-if=\"::$ctrl.shouldShowBreakdownAmount\">\r\n            {{$ctrl.order.PaymentBreakdown.CreditCard | currency}}\r\n        </span>\r\n    </div>\r\n    <div class=\"checkoutConfirmationOrderPaymentBreakdown-summaryRow\" ng-if=\"$ctrl.order.PaymentBreakdown.Account\">\r\n        <span class=\"checkoutConfirmationOrderPaymentBreakdown-summaryLabel\">Charged to Account</span>\r\n        <span\r\n            class=\"checkoutConfirmationOrderPaymentBreakdown-summaryPaymentAmount\"\r\n            ng-if=\"::$ctrl.shouldShowBreakdownAmount\">\r\n            {{$ctrl.order.PaymentBreakdown.Account | currency}}\r\n        </span>\r\n    </div>\r\n    <div class=\"checkoutConfirmationOrderPaymentBreakdown-summaryRow\" ng-if=\"$ctrl.order.PaymentBreakdown.PayPal\">\r\n        <span class=\"checkoutConfirmationOrderPaymentBreakdown-summaryLabel\">Paid with PayPal</span>\r\n        <span\r\n            class=\"checkoutConfirmationOrderPaymentBreakdown-summaryPaymentAmount\"\r\n            ng-if=\"::$ctrl.shouldShowBreakdownAmount\">\r\n            {{$ctrl.order.PaymentBreakdown.PayPal | currency}}\r\n        </span>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckoutConfirmationOrderSaveToListController = function () {
    function CheckoutConfirmationOrderSaveToListController($sce, settings, orderManagementService, analyticsService, savedListsService) {
        _classCallCheck(this, CheckoutConfirmationOrderSaveToListController);

        this.$sce = $sce;
        this.settings = settings;
        this.orderManagementService = orderManagementService;
        this.analyticsService = analyticsService;
        this.savedListsService = savedListsService;
    }

    _createClass(CheckoutConfirmationOrderSaveToListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.showListLink = false;
            this.showErrorMessage = false;
            this.listId = '';
            this.responseMessage = '';
            this.loading = false;
        }
    }, {
        key: 'saveAsListClick',
        value: function saveAsListClick() {
            var _this = this;

            this.loading = true;
            return this.orderManagementService.saveOrderToList(this.orderId).then(function (response) {
                if (response.Success) {
                    _this.listId = response.ListId;
                    _this.showListLink = true;
                    _this.responseMessage = 'Saved to Lists as \'' + response.ListName + '\' ';
                    _this.savedListsService.invalidateCache();

                    _this.savedListsService.getProductsForSelectedList(_this.listId).then(function (list) {
                        list.ListId = _this.listId;
                        list.Name = response.ListName;
                        list.ProductsCount = list.TotalRecordCount;
                        list.Timestamp = Date.now();
                        _this.analyticsService.push({
                            data: {
                                trackingType: 'link',
                                list: list,
                                product: list.Items
                            },
                            type: _this.analyticsService.mapperTypes.customEvent.list.AddOrder
                        });

                        _this.loading = false;
                    });
                } else {
                    _this.showErrorMessage = true;
                    console.warn('Save order to list error: ' + response.Message);
                }
            });
        }
    }]);

    return CheckoutConfirmationOrderSaveToListController;
}();

CheckoutConfirmationOrderSaveToListController.$inject = ['$sce', 'Settings', 'OrderManagementService', 'AnalyticsService', 'SavedListsService'];

var checkoutConfirmationOrderSaveToListControllerComponentDefinition = {
    bindings: {
        orderId: '<'
    },
    controller: CheckoutConfirmationOrderSaveToListController,
    template: __webpack_require__(982).trim()
};

module.exports = {
    CheckoutConfirmationOrderSaveToListController: CheckoutConfirmationOrderSaveToListController,
    checkoutConfirmationOrderSaveToListControllerComponentDefinition: checkoutConfirmationOrderSaveToListControllerComponentDefinition
};

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports = "\r\n    <div class=\"checkoutConfirmationOrderSaveToList\">\r\n        <p class=\"checkoutConfirmationOrderSaveToList-heading\" ng-bind-html=\"$ctrl.settings.orderConfirmation.SaveToListHeading\"></p>\r\n        <p class=\"checkoutConfirmationOrderSaveToList-content\" ng-bind-html=\"$ctrl.$sce.trustAsHtml($ctrl.settings.orderConfirmation.SaveToListContent)\"> </p>\r\n        <button id=\"saveOrderToList\" ng-if=\"!$ctrl.showListLink\" ng-click=\"$ctrl.saveAsListClick()\" class=\"button button--primary\" ng-disabled=\"$ctrl.loading\" >\r\n            Save as list\r\n        </button>\r\n        <p class=\"checkoutConfirmationOrderSaveToList-response\" ng-if=\"$ctrl.showListLink\">\r\n                <i class=\"checkoutConfirmationOrderSaveToList-successIcon iconww-Tick\"></i>\r\n            <span ng-bind-html=\"$ctrl.responseMessage\"></span>\r\n        </p>\r\n        <a\r\n        id=\"orderToListLink\"\r\n        ng-if=\"$ctrl.showListLink\"\r\n        class=\"button\"\r\n        ui-sref=\"shop.list.edit({listId: $ctrl.listId})\"\r\n        ui-sref-opts=\"{ inherit: false }\">\r\n            View now\r\n            <i class=\"checkoutConfirmationOrderSaveToList-viewNowIcon iconww-ArrowRight\"></i>\r\n        </a>\r\n    </div>\r\n\r\n    <div\r\n        class=\"alert alert--error checkoutConfirmation-warning\"\r\n        ng-if=\"$ctrl.showErrorMessage\"\r\n        tabindex=\"-1\"\r\n        role=\"alert\">\r\n        <div class=\"checkoutConfirmationOrderSaveToList-errorIconContainer\" alt=\"error icon\">\r\n        </div>\r\n        <p class=\"checkoutConfirmation-warningTextContainer\" ng-bind-html=\"$ctrl.settings.orderConfirmation.SaveToListError | sanitize\"></p>\r\n    </div>\r\n"

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderConfirmationOrderInformationComponentController = function () {
    function OrderConfirmationOrderInformationComponentController(settings) {
        _classCallCheck(this, OrderConfirmationOrderInformationComponentController);

        this.settings = settings;
    }

    _createClass(OrderConfirmationOrderInformationComponentController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.order || !this.order.Order) return;

            this.orderInfo = this.getOrderInfo();
            this.dateInfo = this.getDateInfo();
            this.addressInfo = this.getAddressInfo();
            this.storeInfo = this.getStoreInfo();
        }
    }, {
        key: 'getOrderInfo',
        value: function getOrderInfo() {
            return {
                method: this.order.Order.DeliveryMethod,
                headerTexts: this.getHeaderTexts(),
                canLeaveUnattended: this.order.CanLeaveOrderUnattended,
                instructions: this.order.Order.DeliveryInstructions
            };
        }
    }, {
        key: 'getHeaderTexts',
        value: function getHeaderTexts() {
            return {
                delivery: this.settings.orderConfirmation.courierDeliveryDetailsHeader,
                express: this.settings.orderConfirmation.expressDeliveryDetailsHeader,
                pickup: this.settings.orderConfirmation.pickupDeliveryDetailsHeader
            };
        }
    }, {
        key: 'getDateInfo',
        value: function getDateInfo() {
            return {
                date: this.order.Order.DeliveryDate,
                startTime: this.order.Order.DeliveryStartTime,
                endTime: this.order.Order.DeliveryEndTime,
                minutesRemainingUntilExpressDelivery: this.order.Order.MinutesRemainingUntilExpressDelivery
            };
        }
    }, {
        key: 'getAddressInfo',
        value: function getAddressInfo() {
            return {
                street1: this.order.Order.DeliveryStreet1,
                street2: this.order.Order.DeliveryStreet2,
                suburb: this.order.Order.DeliverySuburb,
                postcode: this.order.Order.DeliveryPostalCode
            };
        }
    }, {
        key: 'getStoreInfo',
        value: function getStoreInfo() {
            if (this.order.Order.DeliveryMethod !== 'Pickup') return null;

            return {
                name: this.order.Order.PickUpStoreName,
                tradingHours: this.order.TradingHours,
                details: this.order.Store
            };
        }
    }]);

    return OrderConfirmationOrderInformationComponentController;
}();

OrderConfirmationOrderInformationComponentController.$inject = ['Settings'];

var orderConfirmationOrderInformaionComponentDefinition = {
    bindings: {
        order: '<'
    },
    controller: OrderConfirmationOrderInformationComponentController,
    template: '\n        <wow-order-information\n            order-info="::$ctrl.orderInfo"\n            date-info="::$ctrl.dateInfo"\n            address-info="::$ctrl.addressInfo"\n            store-info="::$ctrl.storeInfo"\n            is-guest="false">\n        </wow-order-information>\n        <wow-order-information-tips\n            order-method="::$ctrl.orderInfo.method">\n        </wow-order-information-tips>\n    '
};

module.exports = {
    OrderConfirmationOrderInformationComponentController: OrderConfirmationOrderInformationComponentController,
    orderConfirmationOrderInformaionComponentDefinition: orderConfirmationOrderInformaionComponentDefinition
};

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderConfirmationExportOptionsController = function () {
    function OrderConfirmationExportOptionsController(settingsService, $state, $element, orderConfirmationEmailService, moveFocus, $q, $timeout, breakpointsService, analyticsService) {
        _classCallCheck(this, OrderConfirmationExportOptionsController);

        this.showPrintOption = false;
        this.showEmailOption = false;
        this.showDownloadOption = false;
        this.isEmailFormVisible = false;
        this.settingsService = settingsService;
        this.$state = $state;
        this.$element = $element;
        this.orderConfirmationEmailService = orderConfirmationEmailService;
        this.moveFocus = moveFocus;
        this.$q = $q;
        this.$timeout = $timeout;
        this.breakpointsService = breakpointsService;
        this.analyticsService = analyticsService;
    }

    _createClass(OrderConfirmationExportOptionsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.formSendOrderConfirmation = {};
            if (this.$state.params.orderId) {
                this.orderId = this.$state.params.orderId;
            }

            this.settingsService.getSettingValue('OneSite', 'EnableOrderConfirmationExportOptions').then(function (exportOptions) {
                if (exportOptions.length > 0) {
                    exportOptions.forEach(function (option) {
                        var cleanedOption = option.trim().toLowerCase();
                        switch (cleanedOption) {
                            case 'print':
                                _this.showPrintOption = true;
                                break;
                            case 'email':
                                _this.showEmailOption = true;
                                break;
                            case 'download':
                                _this.showDownloadOption = true;
                                break;
                            default:
                        }
                    });
                }
            });
        }
    }, {
        key: 'showExportOptions',
        value: function showExportOptions() {
            return (this.showPrintOption || this.showEmailOption || this.showDownloadOption) && this.$state.includes('shop.confirmation');
        }
    }, {
        key: 'toggleEmailSection',
        value: function toggleEmailSection() {
            this.isEmailFormVisible = !this.isEmailFormVisible;
            if (this.isEmailFormVisible) {
                this.resetOrderConfirmFormEmail();
            }
            this.errorMessage = undefined;
        }
    }, {
        key: 'resetOrderConfirmFormEmail',
        value: function resetOrderConfirmFormEmail() {
            if (this.sendOrderConfirmationForm) {
                this.sendOrderConfirmationForm.$setPristine();
                this.sendOrderConfirmationForm.$setUntouched();
                this.confirm = {};
            }
            this.emailSentMessage = null;
            this.errorMessage = null;
        }
    }, {
        key: 'emailSentSuccessfull',
        value: function emailSentSuccessfull() {
            var _this2 = this;

            this.errorMessage = null;
            this.emailSentMessage = 'Order confirmation email has been sent successfully';
            this.moveFocus('.orderConfirmationExportOptions-sendEmail');
            this.$timeout(function () {
                _this2.resetOrderConfirmFormEmail();
            }, 5000);
        }
    }, {
        key: 'showEmailErrorMessage',
        value: function showEmailErrorMessage(message) {
            this.emailSentMessage = null;
            this.errorMessage = message;
            this.analyticsService.pushError(message);
        }
    }, {
        key: 'sendOrderConfirmation',
        value: function sendOrderConfirmation() {
            var _this3 = this;

            if (this.$element != null && this.$element.find('#sendOrderConfirmationForm-Email').val().length === 0) {
                // It is a hack as ng-model (scope.confirm.email) is not updated until email is entered in right format
                this.showEmailErrorMessage('Email address is required.');
            } else if (!this.sendOrderConfirmationForm.$valid) {
                // don't submit to server if client side is not valid
                this.showEmailErrorMessage('Email address is required to be in the format of example@example.com.');
            } else if (this.emailSentMessage) {
                this.resetOrderConfirmFormEmail();
            } else {
                this.sendingEmail = true;
                this.orderConfirmationEmailService.sendOrderConfirmationEmail(this.orderId, this.confirm.email).then(function (isEmailSend) {
                    if (isEmailSend) {
                        _this3.emailSentSuccessfull();
                    } else {
                        _this3.showEmailErrorMessage('There is an error sending the email.');
                    }
                    _this3.sendingEmail = false;
                });
            }
        }
    }]);

    return OrderConfirmationExportOptionsController;
}();

var orderConfirmationExportOptionsControllerComponentDefinition = {
    bindings: {
        emailFormVisibility: '='
    },
    controller: ['SettingsService', '$state', '$element', 'OrderConfirmationEmailService', 'MoveFocus', '$q', '$timeout', 'BreakpointsService', 'AnalyticsService', OrderConfirmationExportOptionsController],
    template: __webpack_require__(985).trim()
};

module.exports = {
    OrderConfirmationExportOptionsController: OrderConfirmationExportOptionsController,
    orderConfirmationExportOptionsControllerComponentDefinition: orderConfirmationExportOptionsControllerComponentDefinition
};

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports = "<div class=\"orderConfirmationExportOptions\">\r\n    <span aria-live=\"polite\" class=\"sr-only\" aria-atomic=\"true\" ng-bind=\"$ctrl.emailSentMessage\"></span>\r\n    <div class=\"orderConfirmationExportOptions-exportOptions\" ng-show=\"$ctrl.showExportOptions()\">\r\n        <a class=\"orderConfirmationExportOptions-exportOptionLink\" ng-href=\"/Checkout/PrintConfirmation?OrderID={{$ctrl.orderId}}\" target=\"_blank\">\r\n            <span class=\"sr-only\">Print order confirmation</span>\r\n            <img ng-show=\"$ctrl.showPrintOption\" src=\"/images/checkout/confirmation/icon-print.svg\" class=\"orderConfirmationExportOptions-exportOptionIcon\" />\r\n            <span>Print order summary</span>\r\n        </a>\r\n        <a class=\"orderConfirmationExportOptions-exportOptionLink _orderConfirmationExportOptions-sendEmailIcon\" href=\"javascript://\" ng-click=\"$ctrl.toggleEmailSection()\" oly-move-focus=\"sendOrderConfirmationForm-Email\">\r\n            <span class=\"sr-only\">Send order confirmation email</span>\r\n            <img ng-show=\"$ctrl.showEmailOption\" src=\"/images/checkout/confirmation/icon-email.svg\" class=\"orderConfirmationExportOptions-exportOptionIcon\" />\r\n            <span>E-mail order summary</span>\r\n        </a>\r\n    </div>\r\n    <div class=\"orderConfirmationExportOptions-sendEmailContainer\" ng-show=\"$ctrl.isEmailFormVisible\">\r\n        <form name=\"$ctrl.sendOrderConfirmationForm\" ng-submit=\"$ctrl.sendOrderConfirmation()\" role=\"form\" novalidate>\r\n            <oly-form-validation-summary user-message=\"{{$ctrl.errorMessage}}\"></oly-form-validation-summary>\r\n            <fieldset>\r\n                <legend class=\"sr-only\">Send order confirmation</legend>\r\n                <div class=\"emailInputContainer\">\r\n                    <wow-input-container class=\"sendOrderConfirmationForm-input\">\r\n                        <label for=\"sendOrderConfirmationForm-Email\" class=\"inputLabel\">\r\n                            Please enter a email address\r\n                        </label>\r\n                        <input id=\"sendOrderConfirmationForm-Email\" type=\"email\" name=\"Email\" class=\"addNew\" ng-model=\"$ctrl.confirm.email\" required aria-required=\"true\" autocomplete=\"off\" wow-email-validator />\r\n                    </wow-input-container>\r\n                    <div class=\"orderConfirmationExportOptions-sendContainer\">\r\n                        <oly-button class=\"orderConfirmationExportOptions-sendEmailButton\" loading=\"{state: sendingEmail, message: 'Please wait, sending email'}\">\r\n                            <button type=\"submit\" ng-model=\"button\" class=\"button button--primary orderConfirmationExportOptions-sendEmail\">\r\n                                <span ng-hide=\"$ctrl.emailSentMessage\">\r\n                                    Send\r\n                                    <span ng-if=\"$ctrl.sendingEmail\" class=\"sr-only\">order confirmation email for order id {{$ctrl.orderId}}</span>\r\n                                </span>\r\n                                <i class=\"orderConfirmationExportOptions-tickMark iconww-Tick\" id=\"successful-tick\" ng-show=\"$ctrl.emailSentMessage\"></i>\r\n                            </button>\r\n                        </oly-button>\r\n                    </div>\r\n                </div>\r\n            </fieldset>\r\n        </form>\r\n         <button type=\"button\" class=\"linkButton orderConfirmationExportOptions-cancelButton\" ng-click=\"$ctrl.toggleEmailSection()\">Cancel</button>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderConfirmationPanelController = function () {
    function OrderConfirmationPanelController(shopperService, analyticsService) {
        _classCallCheck(this, OrderConfirmationPanelController);

        this.analyticsService = analyticsService;
        this.shopperService = shopperService;
    }

    _createClass(OrderConfirmationPanelController, [{
        key: '$onInit',
        value: function $onInit() {
            this.status = 'loading';
            var order = this.order ? this.order.Order : {};
            // Todo: unwrap confirmation so that we're just dealing with the order :/
            this.orderCancelled = order.OrderStatus === 'Cancelled';
            if (this.order) {
                this.status = 'orderconfirmation';
            }
            this.analyticsService.push({
                data: {
                    order: order,
                    shopper: this.shopperService.shopper
                },
                type: this.analyticsService.mapperTypes.shop.orderConfirmation
            });
        }
    }]);

    return OrderConfirmationPanelController;
}();

OrderConfirmationPanelController.$inject = ['ShopperService', 'AnalyticsService'];

var orderConfirmationPanelControllerComponentDefinition = {
    bindings: {
        order: '<',
        saveCard: '<'
    },
    controller: OrderConfirmationPanelController,
    template: __webpack_require__(987).trim()
};

module.exports = {
    OrderConfirmationPanelController: OrderConfirmationPanelController,
    orderConfirmationPanelControllerComponentDefinition: orderConfirmationPanelControllerComponentDefinition
};

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports = "<div class=\"orderConfirmationPanel orderConfirmationPanel-scrollingContent\" ng-switch=\"$ctrl.status\">\r\n    <div class=\"orderConfirmationPanel-topBar\">\r\n        <a class=\"orderConfirmationPanel-topBarLink\" href=\"/\">< Back to home</a>\r\n    </div>\r\n    <wow-checkout-confirmation ng-switch-when=\"orderconfirmation\" confirmation=\"::$ctrl.order\" save-card=\"::$ctrl.saveCard\"></wow-checkout-confirmation>\r\n    <wow-order-confirmation-export-options ng-switch-when=\"orderconfirmation\" ng-if=\"!$ctrl.orderCancelled\"></wow-order-confirmation-export-options>\r\n    <wow-loading-spinner ng-switch-when=\"loading\"></wow-loading-spinner>\r\n</div>\r\n"

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderConfirmationPrintController = function () {
    function OrderConfirmationPrintController($timeout, settings) {
        _classCallCheck(this, OrderConfirmationPrintController);

        this.settings = settings;
        this.recipientHeader = this.isDelivery() ? settings.orderConfirmation.deliveryMessage : settings.orderConfirmation.pickupMessage;
        this.packagingFeeEnabled = this.settings.checkout.enablePackagingPreference && !!this.order.PackagingFeeLabel;
        $timeout(function () {
            return window.print();
        }, 0);
    }

    _createClass(OrderConfirmationPrintController, [{
        key: 'isDelivery',
        value: function isDelivery() {
            return this.order.DeliveryMethod === 'Courier' || this.order.DeliveryMethod === 'TPCour' || this.order.DeliveryMethod === 'XpressD';
        }
    }]);

    return OrderConfirmationPrintController;
}();

var orderConfirmationPrintControllerComponentDefinition = {
    bindings: {
        order: '<'
    },
    controller: ['$timeout', 'Settings', OrderConfirmationPrintController],
    template: __webpack_require__(989).trim()
};

module.exports = {
    OrderConfirmationPrintController: OrderConfirmationPrintController,
    orderConfirmationPrintControllerComponentDefinition: orderConfirmationPrintControllerComponentDefinition
};

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirmationprint\">\r\n\t<h1 class=\"confirmationprint-heading\">Confirmation - Thank you for shopping with Woolworths</h1>\r\n\t<div class=\"confirmationprint-wrapper\">\r\n\t\t<div class=\"confirmationprint-header\">\r\n\t\t\t<div class=\"confirmationprint-icon\">\r\n\t\t\t\t<img src=\"/images/trolley/bg-trolley-cart.png\">\r\n\t\t\t</div>\r\n\t\t\t<div class=\"confirmationprint-headerContent\">\r\n\t\t\t\t<h2 class=\"confirmationprint-headerTitle\">Grocery Items</h2>\r\n\r\n\t\t\t\t<div class=\"confirmationprint-headerTop\">\r\n\t\t\t\t\t<label class=\"confirmationprint-headerLabel\">Order Number</label> #{{ ::$ctrl.order.OrderId}}\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"confirmationprint-headerTop\">\r\n\t\t\t\t\t<label class=\"confirmationprint-headerLabel\">Order created</label> {{ ::$ctrl.order.CreatedDate | date: 'dd MMM yyyy'}}\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"confirmationprint-line\"></div>\r\n\t\t<div class=\"confirmationprint-header\">\r\n\t\t\t<div class=\"confirmationprint-headerBottom\">\r\n\t\t\t\t<div class=\"confirmationprint-headerLabel\">{{ ::$ctrl.recipientHeader}}</div>\r\n\t\t\t\t<div class=\"\">\r\n\t\t\t\t\t<span ng-if=\"$ctrl.isDelivery()\">{{ ::$ctrl.order.FirstName}} {{ ::$ctrl.order.LastName}}<br/></span> {{ ::$ctrl.order.DeliveryStreet1}}\r\n\t\t\t\t\t<br/>\r\n\t\t\t\t\t<span ng-show=\"$ctrl.order.DeliveryStreet2\">{{ ::$ctrl.order.DeliveryStreet2}}<br /></span> {{ ::$ctrl.order.DeliverySuburb}},\r\n\t\t\t\t\t{{ $ctrl.order.DeliveryPostalCode}}\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"confirmationprint-headerBottom\">\r\n\t\t\t\t<div class=\"confirmationprint-headerLabel\" ng-if=\"::$ctrl.isDelivery()\">Delivery date</div>\r\n\t\t\t\t<div class=\"confirmationprint-headerLabel\" ng-if=\"::!$ctrl.isDelivery()\">\r\n\t\t\t\t\t<wow-setting setting-group=\"DeliveryInfo\" setting-name=\"PickupDisplayText\"></wow-setting> date\r\n\t\t\t\t</div>\r\n\t\t\t\t<div>{{ ::$ctrl.order.DeliveryDate | date: 'dd MMM'}} between {{ ::$ctrl.order.DeliveryStartTime}} and {{ ::$ctrl.order.DeliveryEndTime}}</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<table class=\"confirmationprint-items\">\r\n\t\t\t<thead class=\"confirmationprint-itemsTitle\">\r\n\t\t\t\t<tr>\r\n\t\t\t\t\t<th class=\"confirmationprint-itemsHeader confirmationprint-itemQty\">Qty\r\n\t\t\t\t\t</th>\r\n\t\t\t\t\t<th class=\"confirmationprint-itemsHeader\">Item\r\n\t\t\t\t\t</th>\r\n\t\t\t\t\t<th class=\"confirmationprint-itemsHeader\">$/Unit\r\n\t\t\t\t\t</th>\r\n\t\t\t\t\t<th class=\"confirmationprint-itemsHeader\">Promo Disc\r\n\t\t\t\t\t</th>\r\n\t\t\t\t\t<th class=\"confirmationprint-itemsHeader confirmationprint-itemsTotal\">Total\r\n\t\t\t\t\t</th>\r\n\t\t\t\t</tr>\r\n\t\t\t</thead>\r\n\t\t\t<tbody>\r\n\t\t\t\t<tr class=\"confirmationprint-itemRow\" ng-repeat=\"product in  $ctrl.order.Products\">\r\n\t\t\t\t\t<td class=\"confirmationprint-itemQty confirmationprint-itemCol\">\r\n\t\t\t\t\t\t{{product.Quantity}}\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t<td class=\"confirmationprint-itemName confirmationprint-itemCol\">\r\n\t\t\t\t\t\t{{product.Name}} {{product.VolumeSize}}\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t<td class=\"unit confirmationprint-itemCol\">\r\n\t\t\t\t\t\t{{product.SalePrice | currency}}\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t<td class=\"promo confirmationprint-itemCol\">\r\n\t\t\t\t\t\t<span ng-if=\"product.Discount > 0\">{{ product.Discount | currency}}</span>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t<td class=\"total confirmationprint-itemCol confirmationprint-itemsTotal\">\r\n\t\t\t\t\t\t{{product.Subtotal | currency}}\r\n\t\t\t\t\t</td>\r\n\t\t\t\t</tr>\r\n\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t<div class=\"confirmationprint-break\"></div>\r\n\t\t<div class=\"confirmationprint-summary\" layout=\"row\" layout-align=\"end center\">\r\n\t\t\t<table class=\"confirmationprint-summaryTable\">\r\n\t\t\t\t<tbody>\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Sub Total\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\" id=\"order-subtotals\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.Subtotal | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.DiscountableSubtotal !==  $ctrl.order.Subtotal\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">\r\n\t\t\t\t\t\t\t<wow-html-setting setting-group=\"Checkout\" setting-name=\"DiscountableSubtotalFieldLabel\"></wow-html-setting>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.DiscountableSubtotal | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.OrderDiscountWithoutTeamDiscount > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Less Order Discount\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">- {{ ::$ctrl.order.OrderDiscountWithoutTeamDiscount | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.TeamDiscount > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Less Team Discount\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">- {{ ::$ctrl.order.TeamDiscount | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.packagingFeeEnabled\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PackagingFeeLabel}}\r\n\t\t\t\t\t\t\t<span ng-if=\"!!$ctrl.order.PackagingUnitPrice\" class=\"text-nowrap confirmationprint-summaryGst\"\r\n\t\t\t\t\t\t\t    ng-bind-html=\"{EstimatedCount:$ctrl.order.PackagingCount, UnitCost:$ctrl.order.PackagingUnitPrice} | wowPackagingPriceLabel : true\">\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\"> {{ ::$ctrl.order.PackagingFee | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">\r\n\t\t\t\t\t\t\tDelivery Fee\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.DeliveryFeeBeforeDiscount | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.DeliveryFeeDiscount\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Less Delivery Fee Discount\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">- {{ ::$ctrl.order.DeliveryFeeDiscount | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.AdditionalDeductions > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Less Promotion Discount\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">- {{ ::$ctrl.order.AdditionalDeductions | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr class=\"confirmationprint-summaryTotal\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">\r\n\t\t\t\t\t\t\t<strong>Total</strong> <span class=\"confirmationprint-summaryGst\">(including GST)</span>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t<strong>{{ ::$ctrl.order.TotalIncludingGst | currency}}</strong>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.Coupon > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid with Coupon</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.Coupon | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.eVoucher > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid with\r\n\t\t\t\t\t\t\t<wow-setting setting-group=\"Checkout\" setting-name=\"EVoucherDisplayName\"></wow-setting>\r\n\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.eVoucher | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.WowRewards > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid with\r\n\t\t\t\t\t\t\t<wow-setting setting-group=\"EverydayRewards\" setting-name=\"CardName\"></wow-setting>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.WowRewards | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.GiftCard > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid with Gift Card</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.GiftCard | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.CreditCard > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid with Credit Card</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.CreditCard | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.PayPal > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Paid with PayPal</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.PayPal | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\r\n\t\t\t\t\t<tr ng-if=\"$ctrl.order.PaymentBreakdown.Account > 0\">\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryLabel\">Charged to Account</td>\r\n\t\t\t\t\t\t<td class=\"confirmationprint-summaryAmount\">\r\n\t\t\t\t\t\t\t{{ ::$ctrl.order.PaymentBreakdown.Account | currency}}\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</tbody>\r\n\t\t\t</table>\r\n\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n"

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OrderConfirmationEmailService = function OrderConfirmationEmailService(restangular) {
    this._api = restangular.one('Checkout');
};

OrderConfirmationEmailService.prototype.sendOrderConfirmationEmail = function (orderId, toAddress) {
    return this._api.post('ConfirmOrderEmail', { OrderId: orderId, ToAddress: toAddress });
};

module.exports = OrderConfirmationEmailService;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var DeliveryOptionsService = __webpack_require__(992);

angular.module('wowApp.shop').service('DeliveryOptionsService', DeliveryOptionsService);

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeliveryOptionsService = function () {
    function DeliveryOptionsService(restangular, bootstrap, shopperService) {
        _classCallCheck(this, DeliveryOptionsService);

        this.shopperService = shopperService;

        this.api = restangular.one('Delivery');
        this.options = {};
        this.hasPhoneReVerified = false;
        this.hasPhoneSubmittedForVerification = false;

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.DeliveryInfo)) {
            this.options.DeliveryInstructions = bootstrap.getBootstrappedData(bootstrap.bootstrapped.DeliveryInfo).DeliveryInstructions;
            this.options.PickupInstructions = bootstrap.getBootstrappedData(bootstrap.bootstrapped.DeliveryInfo).PickupInstructions;
            this.options.CanLeaveUnattended = bootstrap.getBootstrappedData(bootstrap.bootstrapped.DeliveryInfo).CanLeaveUnattended;
        }
    }

    _createClass(DeliveryOptionsService, [{
        key: 'getSavedMessage',
        value: function getSavedMessage() {
            return this.fulfilmentService.isDelivery() ? this.options.deliveryMessage : this.options.pickupMessage;
        }
    }, {
        key: 'getOptions',
        value: function getOptions() {
            var _this = this;

            return this.api.one('Options').doGET().then(function (response) {
                _this.options = response;
                return _this.options;
            });
        }
    }, {
        key: 'setOptions',
        value: function setOptions(options) {
            var _this2 = this;

            if (!options) {
                return this.getOptions();
            }

            return this.api.one('Options').doPOST(options).then(function (response) {
                _this2.options = response;

                // Update the mobile phone in the Shopper Service
                if (_this2.options.MobilePhone) {
                    _this2.shopperService.setMobilePhone(_this2.options.MobilePhone, false);
                }

                return _this2.options;
            });
        }
    }]);

    return DeliveryOptionsService;
}();

DeliveryOptionsService.$inject = ['Restangular', 'BootstrapService', 'ShopperService'];

module.exports = DeliveryOptionsService;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var OrderManagementService = __webpack_require__(994);

angular.module('wowApp.shop').service('OrderManagementService', ['$rootScope', 'Restangular', 'RestangularV3', 'BreakpointsService', OrderManagementService]);

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function OrderManagementService($rootScope, Restangular, RestangularV3, _breakpointsService) {
    this.$rootScope = $rootScope;
    this._api = Restangular.one('order');
    this._apiv3 = RestangularV3.one('order');
    this._deliveryWindowApi = Restangular.one('DeliveryWindows');
    this.breakpointsService = _breakpointsService;
    this.loadingOrders = null;
    this.loadedOpenOrderCountResponse = null;

    this.timeTable = [];

    this.switchAction = { id: 0, action: '' };
}

OrderManagementService.prototype.invalidate = function () {
    // Call this function before getOrders in order to freshly load
    // orders
    // invalidate loadedOpenOrderCountResponse when orders get invalidated
    this.loadingOrders = null;
    this.orders = null;
    this.loadedOpenOrderCountResponse = null;
};

OrderManagementService.prototype.setOrders = function (orders) {
    this.orders = orders;
    return orders;
};

OrderManagementService.prototype.getOrders = function () {
    if (this.loadingOrders) {
        // if we have already loaded orders, return the resolved promise.
        return this.loadingOrders;
    }

    this.loadingOrders = this._api.get().then(this.setOrders.bind(this));

    return this.loadingOrders;
};

OrderManagementService.prototype.updateSelectedAction = function (orderId, action) {
    // This function gets updated whenever an option is selected from
    // an order-status-card
    this.switchAction.id = orderId;
    this.switchAction.action = action;
};

OrderManagementService.prototype.updateSelectedPendingOrder = function (orderId) {
    // This function gets updated whenever the dropdown option is clicked on
    // an order-status-card
    this.selectedPendingOrderId = orderId;
};

OrderManagementService.prototype.getPastOrderDeliveryWindow = function (orderId, isDelivery) {
    var _this = this;

    return this._deliveryWindowApi.one('PastOrder').get({ OrderId: orderId, isDelivery: isDelivery }).then(function (response) {
        _this.timeTable = response;
    });
};

OrderManagementService.prototype.savePastOrderDeliveryWindow = function (orderId, deliveryWindowId, windowDate) {
    var _this2 = this;

    return this._deliveryWindowApi.post('ReservePastOrderWindow', { OrderId: orderId, DeliveryWindowId: deliveryWindowId, WindowDate: windowDate }).then(function (response) {
        if (response.IsSuccessful) {
            _this2.updateSelectedAction(0, '');
            return response;
        }
        return response;
    });
};

OrderManagementService.prototype.cancelOrder = function (orderId) {
    var _this3 = this;

    return this._api.post('cancel', { OrderId: orderId }).then(function () {
        _this3.updateSelectedAction(0, '');
    });
};

OrderManagementService.prototype.changeOrder = function (orderId) {
    var _this4 = this;

    return this._api.post('amend', { OrderId: orderId, OrderDeviceFormat: this.breakpointsService.getDeviceDisplayFormatString() }).then(function () {
        _this4.updateSelectedAction(0, '');
    });
};

OrderManagementService.prototype.getTotalOrderCount = function () {
    if (this.loadedOpenOrderCountResponse) {
        // if we have already loaded open orders count, return the resolved promise.
        return this.loadedOpenOrderCountResponse;
    }
    this.loadedOpenOrderCountResponse = this._apiv3.one('openordercount').get();
    return this.loadedOpenOrderCountResponse;
};

OrderManagementService.prototype.saveOrderToList = function (orderId) {
    var _this5 = this;

    return this._apiv3.one(orderId + '/save').post().then(function (response) {
        // We need to broadcast when this happens so the product save to list component updates the list
        _this5.$rootScope.$broadcast('savedLists:AddNewList');

        return response;
    });
};

module.exports = OrderManagementService;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(996),
    SavedCardService = _require.SavedCardService;

var _require2 = __webpack_require__(997),
    saveCardComponentDefinition = _require2.saveCardComponentDefinition;

angular.module('wowApp.shop').service('SavedCardService', ['Restangular', SavedCardService]).component('wowSaveCard', saveCardComponentDefinition);

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SavedCardService = function () {
    function SavedCardService(Restangular) {
        _classCallCheck(this, SavedCardService);

        this._api = Restangular.all('SavedCards');
        this._deleteCardApi = Restangular.all('/SavedCards/DeleteSavedCards');
    }

    _createClass(SavedCardService, [{
        key: 'getSavedCard',
        value: function getSavedCard(panNumber) {
            return this._api.get(panNumber);
        }
    }, {
        key: 'getSavedCards',
        value: function getSavedCards() {
            return this._api.getList();
        }
    }, {
        key: 'deleteSavedCard',
        value: function deleteSavedCard(pan) {
            return this._deleteCardApi.post({ Pan: pan });
        }
    }, {
        key: 'saveCardForOrder',
        value: function saveCardForOrder(orderId) {
            return this._api.post({ OrderId: orderId });
        }
    }]);

    return SavedCardService;
}();

module.exports = { SavedCardService: SavedCardService };

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SaveCardController = function () {
    function SaveCardController(savedCardService) {
        _classCallCheck(this, SaveCardController);

        this.savedCardService = savedCardService;
    }

    _createClass(SaveCardController, [{
        key: '$onInit',
        value: function $onInit() {
            this.cardSaved = false;
        }
    }, {
        key: 'saveCard',
        value: function saveCard() {
            var _this = this;

            this.cardSaved = true;

            this.savedCardService.saveCardForOrder(this.orderId).then(function () {
                delete _this.error;
            }).catch(function () {
                _this.cardSaved = false;
                _this.error = 'There was an error saving your card.';
            });
        }
    }]);

    return SaveCardController;
}();

SaveCardController.$inject = ['SavedCardService'];

var saveCardComponentDefinition = {
    bindings: {
        orderId: '<',
        paymentType: '<'
    },
    controller: SaveCardController,
    template: __webpack_require__(998).trim()
};

module.exports = {
    SaveCardController: SaveCardController,
    saveCardComponentDefinition: saveCardComponentDefinition
};

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = "<div class=\"saveCard\">\r\n    <div ng-if=\"$ctrl.error\" class=\"u-error\">{{ $ctrl.error }}</div>\r\n    <div>\r\n        Save {{$ctrl.paymentType}} for future purchases\r\n        <button class=\"button button--primary\" ng-click=\"$ctrl.saveCard()\" ng-if=\"!$ctrl.cardSaved\">\r\n            Save\r\n        </button>\r\n        <button class=\"button button--primary\" ng-if=\"$ctrl.cardSaved\" disabled>\r\n            Saved <i class=\"iconww-Tick\"></i>\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);
var ngMessages = __webpack_require__(14);
var uiRouter = __webpack_require__(6);
var restangular = __webpack_require__(4); // eslint-disable-line no-unused-vars

var wowCommonModule = __webpack_require__(5);
var olyCommonModule = __webpack_require__(3);
var analyticsModule = __webpack_require__(8);

var addressModuleName = 'wowApp.fulfilment';

var fulfilmentService = __webpack_require__(1000);
var deliveryFeeService = __webpack_require__(1001);

angular.module(addressModuleName, [analyticsModule, olyCommonModule, wowCommonModule, ngMessages, uiRouter, 'restangular']).service('FulfilmentService', fulfilmentService).service('DeliveryFeeService', deliveryFeeService);

// ------------------------------------------
// Components
// ------------------------------------------
__webpack_require__(1002);
__webpack_require__(1018);
__webpack_require__(1023);
__webpack_require__(1028);
__webpack_require__(1033);
__webpack_require__(1049);

module.exports = addressModuleName;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isEmpty = _require.isEmpty,
    trim = _require.trim;

var FulfilmentService = function () {
    function FulfilmentService($rootScope, restangular, bootstrap, analytics, addressService, settings) {
        _classCallCheck(this, FulfilmentService);

        this.$rootScope = $rootScope;
        this.bootstrap = bootstrap;
        this.api = restangular.one('Fulfilment');
        this.storeCodeApi = restangular.one('Storecode');
        this.analytics = analytics;
        this.addressService = addressService;
        this.bootstrap = bootstrap;
        this.settings = settings;

        this.fulfilmentOptions = {
            pickup: {
                name: settings.fulfilmentMethod.pickupOptionName,
                text: settings.fulfilmentMethod.pickupOptionMessage,
                value: settings.fulfilmentMethod.pickupOptionMessage,
                subheading: settings.fulfilmentMethod.pickupOptionSubheading,
                isVariableSubheading: false,
                icon: 'iconww-Cart',
                addressText: 'select supermarket',
                type: 'pickup'
            },
            delivery: {
                name: settings.fulfilmentMethod.deliveryOptionName,
                text: settings.fulfilmentMethod.deliveryOptionMessage,
                value: settings.fulfilmentMethod.deliveryOptionMessage,
                subheading: settings.fulfilmentMethod.deliveryOptionSubheading,
                isVariableSubheading: true,
                icon: 'iconww-Cart',
                addressText: 'select address',
                type: 'delivery'
            },
            none: {
                name: settings.fulfilmentMethod.noneOptionName,
                text: settings.fulfilmentMethod.noneOptionMessage,
                value: settings.fulfilmentMethod.noneOptionMessage,
                subheading: settings.fulfilmentMethod.noneOptionSubheading,
                isVariableSubheading: false,
                selected: true,
                icon: 'iconww-Cart',
                type: 'none'
            }
        };

        this.fulfilmentSteps = {
            fulfilmentMethod: 'FULFILMENT_METHOD',
            address: 'ADDRESS',
            timeslot: 'TIMESLOT',
            billing: 'BILLING'
        };

        this.checkoutFulfilmentOptions = {
            pickup: this.fulfilmentOptions.pickup,
            delivery: this.fulfilmentOptions.delivery
        };

        this.selectedFulfilmentMethod = this.fulfilmentOptions.none;

        this.setFulfilmentFromBootstrap();
    }

    _createClass(FulfilmentService, [{
        key: 'setFulfilmentFromBootstrap',
        value: function setFulfilmentFromBootstrap() {
            this.setDeliveryInfo(this.bootstrap.getBootstrappedDataIfPresent(this.bootstrap.bootstrapped.DeliveryInfo));

            // Update the fulfilment subheading - if it's express delivery
            if (this.selectedFulfilmentMethod === this.fulfilmentOptions.delivery && this.isExpress) {
                this.fulfilmentOptions.delivery.subheading = this.settings.fulfilmentMethod.expressDeliveryOptionSubheading;
            }
        }
    }, {
        key: 'setDeliveryInfo',
        value: function setDeliveryInfo(deliveryInfo) {
            if (deliveryInfo == null) return;

            this.selectedFulfilmentMethod = deliveryInfo.DeliveryMethod === 'Courier' ? this.fulfilmentOptions.delivery : this.fulfilmentOptions.pickup;
            this.reservedDate = deliveryInfo.ReservedDate && deliveryInfo.ReservedDate.AbsoluteDateText ? deliveryInfo.ReservedDate : null;
            this.reservedTime = deliveryInfo.ReservedTime && deliveryInfo.ReservedTime.Id > 0 ? deliveryInfo.ReservedTime : null;
            this.isExpress = deliveryInfo.IsExpress;
            this.savedAddress = deliveryInfo.Address && deliveryInfo.Address.AddressId > 0 ? deliveryInfo.Address : null;
        }
    }, {
        key: 'getFullDeliveryAddress',
        value: function getFullDeliveryAddress(address) {
            if (isEmpty(address)) return '';

            var street1 = address.Street1 ? trim(address.Street1) + ', ' : '';
            var suburb = address.SuburbName ? trim(address.SuburbName) : '';
            var state = address.State ? trim(address.State) : '';
            var postCode = address.PostalCode ? trim(address.PostalCode) : '';
            var suburbStatePostcodeText = suburb + ' ' + state + ' ' + postCode;

            return '' + street1 + suburbStatePostcodeText;
        }
    }, {
        key: 'changeFulfilmentTimeslot',
        value: function changeFulfilmentTimeslot() {
            if (!this.savedAddress || this.isNotSet()) {
                this.setFulfilmentFromBootstrap();
            }

            this.$rootScope.$broadcast('fulfilment:changeTimeslot');
        }
    }, {
        key: 'changeFulfilmentMethod',
        value: function changeFulfilmentMethod() {
            this.selectedFulfilmentMethod = this.fulfilmentOptions.none;
            this.$rootScope.$broadcast('fulfilment:changeMethod');
        }
    }, {
        key: 'clearFulfilmentInfo',
        value: function clearFulfilmentInfo() {
            this.selectedFulfilmentMethod = this.fulfilmentOptions.none;
            this.clearAddressAndTime();
        }
    }, {
        key: 'clearAddressAndTime',
        value: function clearAddressAndTime() {
            this.savedAddress = null;
            this.clearTime();
        }
    }, {
        key: 'clearTime',
        value: function clearTime() {
            this.reservedDate = null;
            this.reservedTime = null;
        }
    }, {
        key: 'canOrderBeFulfilled',
        value: function canOrderBeFulfilled() {
            return this.selectedFulfilmentMethod !== this.fulfilmentOptions.none && !!this.savedAddress && !!this.reservedDate && !!this.reservedTime && !!this.addressService.getPrimaryAddress();
        }
    }, {
        key: 'isDelivery',
        value: function isDelivery() {
            return this.selectedFulfilmentMethod.name === this.fulfilmentOptions.delivery.name;
        }
    }, {
        key: 'isPickup',
        value: function isPickup() {
            return this.selectedFulfilmentMethod.name === this.fulfilmentOptions.pickup.name;
        }
    }, {
        key: 'isNotSet',
        value: function isNotSet() {
            return this.selectedFulfilmentMethod.name === this.fulfilmentOptions.none.name;
        }
    }, {
        key: 'setStore',
        value: function setStore(storeCode) {
            return this.storeCodeApi.doPOST({ storeCode: storeCode });
        }
    }, {
        key: 'saveFulfilment',
        value: function saveFulfilment(fulfilmentInfo) {
            var _this = this;

            return this.api.doPOST({
                fulfilmentMethod: fulfilmentInfo.fulfilmentMethod,
                addressId: fulfilmentInfo.address.AddressId,
                timeslotId: fulfilmentInfo.fulfilmentWindow.time ? fulfilmentInfo.fulfilmentWindow.time.Id : undefined,
                windowDate: fulfilmentInfo.fulfilmentWindow.date ? fulfilmentInfo.fulfilmentWindow.date.Date : undefined,
                billingAddressId: fulfilmentInfo.billingAddressId
            }).then(function (response) {
                if (fulfilmentInfo.fulfilmentMethod && fulfilmentInfo.address && fulfilmentInfo.fulfilmentWindow.date && fulfilmentInfo.fulfilmentWindow.time) {
                    _this.analytics.push({
                        data: fulfilmentInfo,
                        type: _this.analytics.mapperTypes.shop.fulfilment
                    });
                }
                return response;
            });
        }
    }]);

    return FulfilmentService;
}();

FulfilmentService.$inject = ['$rootScope', 'Restangular', 'BootstrapService', 'AnalyticsService', 'AddressService', 'Settings'];

module.exports = FulfilmentService;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeliveryFeeService = function () {
    function DeliveryFeeService(restangular) {
        _classCallCheck(this, DeliveryFeeService);

        this.api = restangular.one('Delivery');
    }

    _createClass(DeliveryFeeService, [{
        key: 'getDeliveryFeeStructure',
        value: function getDeliveryFeeStructure() {
            return this.api.one('DeliveryFeeStructure').get();
        }
    }]);

    return DeliveryFeeService;
}();

DeliveryFeeService.$inject = ['Restangular'];

module.exports = DeliveryFeeService;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(1003),
    pickupAddressSearchComponentDefinition = _require.pickupAddressSearchComponentDefinition;

var _require2 = __webpack_require__(1005),
    pickupAddressListComponentDefinition = _require2.pickupAddressListComponentDefinition;

var _require3 = __webpack_require__(1007),
    pickupAddressComponentDefinition = _require3.pickupAddressComponentDefinition;

var _require4 = __webpack_require__(1009),
    savedAddressesComponentDefinition = _require4.savedAddressesComponentDefinition;

var _require5 = __webpack_require__(1011),
    manualAddressComponentDefinition = _require5.manualAddressComponentDefinition;

var _require6 = __webpack_require__(1013),
    addressEntryFormComponentDefinition = _require6.addressEntryFormComponentDefinition;

var AddressServiceDefinition = __webpack_require__(1015);

angular.module('wowApp.fulfilment').constant('AddressEntryModes', {
    manual: 'MANUAL',
    search: 'SEARCH'
}).service('AddressService', AddressServiceDefinition).service('PickupAddressSearchService', ['Restangular', 'StoreService', __webpack_require__(1016)]).factory('StateService', ['$rootScope', 'Restangular', __webpack_require__(1017)]).component('wowPickupAddressSearch', pickupAddressSearchComponentDefinition).component('wowPickupAddressList', pickupAddressListComponentDefinition).component('wowPickupAddress', pickupAddressComponentDefinition).component('wowSavedAddresses', savedAddressesComponentDefinition).component('wowManualAddress', manualAddressComponentDefinition).component('wowAddressEntryForm', addressEntryFormComponentDefinition);

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LatLng = __webpack_require__(15);

var LOCATION_SEARCH_TEXT = 'Using your location';

var PickupAddressSearchController = function () {
    function PickupAddressSearchController($element, settings, locationService, pickupAddressSearchService, moveFocus) {
        _classCallCheck(this, PickupAddressSearchController);

        this.$element = $element;
        this.settings = settings;
        this.locationService = locationService;
        this.pickupAddressSearchService = pickupAddressSearchService;
        this.moveFocus = moveFocus;
    }

    _createClass(PickupAddressSearchController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.searchPending = false;

            this.clearSearch();

            this.currentLocation = null;
            this.getLocation().then(function (location) {
                _this.currentLocation = location;
                _this.isGeolocationEnabled = _this.isFulfilmentSelector && !!location;
                if (!_this.isFulfilmentSelector) {
                    _this.search(location);
                }
            });
        }
    }, {
        key: 'onKeyPress',
        value: function onKeyPress($event) {
            this.searchPending = true;
            if ($event && $event.keyCode === 13) {
                $event.preventDefault();
                this.searchPending = false;
                if (!this.searchString) {
                    return;
                }
                this.search(this.searchString);
            }
        }
    }, {
        key: 'onClickSearchInput',
        value: function onClickSearchInput() {
            if (this.searchString === LOCATION_SEARCH_TEXT) {
                this.searchString = '';
            }
        }
    }, {
        key: 'onClickSearch',
        value: function onClickSearch($event) {
            $event.preventDefault();
            if (!this.searchString && !this.isFulfilmentSelector) {
                return;
            }
            this.searchPending = false;
            var searchString = this.isGeolocationEnabled ? this.currentLocation : this.searchString;
            this.search(searchString);
        }
    }, {
        key: 'search',
        value: function search(searchTerm) {
            var _this2 = this;

            if (this.searchPending) {
                this.searchPending = false;
                return;
            }
            var locationSearchText = this.isFulfilmentSelector ? this.settings.fulfilmentSelector.searchByCurrentLocationLabel : LOCATION_SEARCH_TEXT;

            this.searchString = searchTerm instanceof LatLng ? locationSearchText : searchTerm;
            this.isSearching = true;
            this.hasSearched = true;

            this.performSearch(searchTerm).finally(function () {
                _this2.isSearching = false;
                _this2.moveFocus('._pickupAddressSearch-searchResult:first');
            });
        }
    }, {
        key: 'performSearch',
        value: function performSearch(searchTerm) {
            if (searchTerm instanceof LatLng) {
                return this.searchStoresByGeolocation(searchTerm);
            }

            if (isNaN(searchTerm)) {
                return this.searchSuburbs(searchTerm);
            }

            return this.searchStoresByPostcode(searchTerm);
        }
    }, {
        key: 'searchSuburbs',
        value: function searchSuburbs(searchTerm) {
            var _this3 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.suburbs;
            return this.pickupAddressSearchService.searchSuburbs(searchTerm).then(function (suburbs) {
                _this3.suburbs = suburbs;
            });
        }
    }, {
        key: 'searchStoresByPostcode',
        value: function searchStoresByPostcode(postcode) {
            var _this4 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.stores;
            return this.pickupAddressSearchService.searchByPostcode({ postcode: postcode }).then(function (pickupStores) {
                return _this4.setStores({ stores: pickupStores });
            });
        }
    }, {
        key: 'searchStoresByGeolocation',
        value: function searchStoresByGeolocation(position) {
            var _this5 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.stores;
            return this.pickupAddressSearchService.searchByGeolocation(position).then(function (pickupStores) {
                return _this5.setStores({ stores: pickupStores });
            });
        }
    }, {
        key: 'getLocation',
        value: function getLocation() {
            return this.locationService.getCurrentLocation();
        }
    }, {
        key: 'clearSearch',
        value: function clearSearch() {
            this.searchPending = false;
            this.hasSearched = false;
            this.isSearching = false;
            this.searchString = '';
            this.setStores({ stores: [] });
        }
    }, {
        key: 'resetSearch',
        value: function resetSearch() {
            this.clearSearch();
            this.moveFocus('._pickupAddressSearch-input');
        }
    }, {
        key: 'onTextInputChange',
        value: function onTextInputChange() {
            this.hasSearched = true;
        }
    }]);

    return PickupAddressSearchController;
}();

var pickupAddressSearchComponentDefinition = {
    bindings: {
        suburbs: '=',
        searchMode: '=',
        isSearching: '=',
        hasSearched: '=',
        searchString: '=',
        setStores: '&',
        isFulfilmentSelector: '='
    },
    controller: ['$element', 'Settings', 'LocationService', 'PickupAddressSearchService', 'MoveFocus', PickupAddressSearchController],
    template: __webpack_require__(1004).trim()
};

module.exports = {
    PickupAddressSearchController: PickupAddressSearchController,
    pickupAddressSearchComponentDefinition: pickupAddressSearchComponentDefinition
};

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports = "<fieldset class=\"pickupAddressSearch-search\">\r\n    <legend class=\"sr-only\">Pickup store search</legend>\r\n\r\n    <wow-input-container class=\"pickupAddressSearch-inputContainer\">\r\n        <label for=\"pickupAddressSearch-storeSearch\">\r\n            <wow-setting setting-group=\"ClickAndCollect\" setting-name=\"ClickAndCollectStoreSearchLabel\" ng-if=\"!$ctrl.isFulfilmentSelector\"></wow-setting>\r\n            <span ng-if=\"$ctrl.isFulfilmentSelector\">Search for Pick up location *</span>\r\n        </label>\r\n\r\n        <input\r\n            id=\"pickupAddressSearch-storeSearch\"\r\n            type=\"search\"\r\n            class=\"pickupAddressSearch-input _pickupAddressSearch-input\"\r\n            ng-class=\"{'is-fulfilmentSelector':$ctrl.isFulfilmentSelector, 'focused':$ctrl.hasSearched}\"\r\n            ng-model=\"$ctrl.searchString\"\r\n            autocomplete=\"off\"\r\n            ng-change=\"$ctrl.onTextInputChange()\"\r\n            ng-keypress=\"$ctrl.onKeyPress($event)\"\r\n            ng-click=\"$ctrl.onClickSearchInput()\"\r\n            oly-grab-focus=\"!$ctrl.isFulfilmentSelector\"\r\n            wow-event-recorder=\"keydown\"\r\n            data-er-category=\"Delivery Window\"\r\n            data-er-label=\"Local Supermarket Search\"\r\n            data-er-value=\"{{$ctrl.searchString}}\"\r\n            data-er-trigger-key-code=\"13\" />\r\n\r\n        <button\r\n            type=\"button\"\r\n            class=\"pickupAddressSearch-inputButton\"\r\n            ng-class=\"{'is-fulfilmentSelector-cross':$ctrl.isFulfilmentSelector}\"\r\n            ng-show=\"$ctrl.hasSearched\"\r\n            ng-click=\"$ctrl.resetSearch()\">\r\n            <span class=\"sr-only\">Reset pickup store search</span>\r\n            <i class=\"icon-close_x\"></i>\r\n        </button>\r\n\r\n        <button\r\n            type=\"submit\"\r\n            class=\"pickupAddressSearch-inputButton\"\r\n            ng-if=\"!$ctrl.isFulfilmentSelector\"\r\n            ng-show=\"!$ctrl.hasSearched\"\r\n            ng-click=\"$ctrl.onClickSearch($event)\"\r\n            wow-event-recorder=\"click\"\r\n            data-er-category=\"Delivery Window\"\r\n            data-er-label=\"Local Supermarket Search\"\r\n            data-er-value=\"{{$ctrl.searchString}}\">\r\n            <span class=\"sr-only\">Search for pickup stores</span>\r\n            <i class=\"icon-search\"></i>\r\n        </button>\r\n\r\n        <button\r\n            class=\"pickupAddressSearch-geoLocationButton\"\r\n            ng-if=\"$ctrl.isFulfilmentSelector\"\r\n            ng-show=\"!$ctrl.hasSearched\"\r\n            ng-disabled=\"!$ctrl.isGeolocationEnabled\"\r\n            ng-click=\"$ctrl.onClickSearch($event)\" aria-role=\"button\" >\r\n            <span class=\"sr-only\">Find pick up addresses near me</span>\r\n            <i ng-if=\"!$ctrl.isGeolocationEnabled\" class=\"iconww-unavailable pickupAddressSearch-geoLocationButton--disabled\" style=\"cursor: default;\"></i>\r\n            <i ng-if=\"$ctrl.isGeolocationEnabled\" class=\"iconww-selected pickupAddressSearch-geoLocationButton--enabled\"></i>\r\n        </button>\r\n    </wow-input-container>\r\n</fieldset>\r\n\r\n<fieldset\r\n    class=\"pickupAddress-resultsContainer\"\r\n    ng-class=\"{'pickupAddress-resultsContainer--fulfilmentSelector': $ctrl.isFulfilmentSelector}\"\r\n    ng-if=\"$ctrl.hasSearched && $ctrl.searchMode === $ctrl.pickupAddressSearchService.searchModes.suburbs\">\r\n    <ul class=\"pickupAddress-results\"\r\n        ng-class=\"{'pickupAddress-results--fulfilmentSelector': $ctrl.isFulfilmentSelector}\"\r\n        role=\"listbox\"\r\n        aria-label=\"Pickup {{$ctrl.searchMode}} search results for {{$ctrl.searchString}}\"\r\n        ng-switch=\"$ctrl.isFulfilmentSelector\">\r\n\r\n        <li ng-if=\"$ctrl.isSearching\">\r\n            <wow-loading-spinner message=\"Searching for suburbs, please wait...\"></wow-loading-spinner>\r\n        </li>\r\n\r\n        <li\r\n            role=\"option\"\r\n            class=\"pickupAddress-searchResult _pickupAddressSearch-searchResult\"\r\n            ng-if=\"!$ctrl.isSearching && $ctrl.suburbs.length > 0\"\r\n            ng-repeat=\"suburb in $ctrl.suburbs\"\r\n            ng-switch-when=\"false\">\r\n\r\n            <input\r\n                type=\"radio\"\r\n                name=\"suburb\"\r\n                id=\"{{ ::suburb.PostCode }}\"\r\n                class=\"wowRadio\"\r\n                ng-value=\"::suburb.PostCode\"\r\n                ng-keydown=\"::($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.search(suburb.PostCode)\">\r\n\r\n            <label for=\"{{ ::suburb.PostCode }}\" ng-click=\"::$ctrl.search(suburb.PostCode)\">\r\n                <span class=\"sr-only\">Search for stores from</span>\r\n                <p class=\"pickupAddress-storeDescription\">{{::suburb.SuburbStateString}}</p>\r\n            </label>\r\n        </li>\r\n\r\n        <li\r\n            role=\"option\"\r\n            class=\"pickupAddress-result--fulfilmentSelector _pickupAddressSearch-searchResult\"\r\n            ng-if=\"!$ctrl.isSearching && $ctrl.suburbs.length > 0\"\r\n            ng-repeat=\"suburb in $ctrl.suburbs\"\r\n            ng-value=\"::suburb.PostCode\"\r\n            ng-click=\"::$ctrl.search(suburb.PostCode)\"\r\n            ng-switch-when=\"true\">\r\n\r\n            <p class=\"pickupAddress-storeDescription\">{{::suburb.SuburbStateString}}</p>\r\n        </li>\r\n\r\n        <li role=\"option\" ng-if=\"!$ctrl.searching &&  $ctrl.suburbs.length === 0\">\r\n            <button\r\n                type=\"button\"\r\n                class=\"pickupAddress-button linkButton _pickupAddressSearch-searchResult\"\r\n                ng-class=\"{'pickupAddressSearch-button--fulfilmentSelector pickupAddress-button--fulfilmentSelector': $ctrl.isFulfilmentSelector}\"\r\n                ng-click=\"$ctrl.resetSearch()\">No results found.<span class=\"sr-only\">Select to search again.</span></button>\r\n        </li>\r\n    </ul>\r\n</fieldset>\r\n"

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(0);

var PickupAddressListController = function () {
    function PickupAddressListController($scope, $element, addressService, stateService, moveFocus) {
        var _this = this;

        _classCallCheck(this, PickupAddressListController);

        this.$scope = $scope;
        this.$element = $element;
        this.stateService = stateService;
        this.moveFocus = moveFocus;

        this.updatePickupStores = _.debounce(function (selectedState) {
            _this.isSearching = true;
            _this.hasSearched = true;
            var args = selectedState && selectedState.Code ? { state: selectedState.Code } : undefined;
            addressService.getPickupAddresses(args).then(function (pickupStores) {
                _this.isSearching = false;
                _this.setStores({ stores: pickupStores });
            });
        }, 500);

        $scope.$watch(function () {
            return _this.states.selectedState;
        }, function () {
            return _this.updatePickupStores(_this.states.selectedState);
        });
    }

    _createClass(PickupAddressListController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.states = {
                states: [],
                selectedState: null
            };

            this.moveFocus(this.$element.find('._pickupAddressList-stateSelect'));

            this.stateService.getStates().then(function (states) {
                var selectedState = _.find(states, 'IsStateForDeliveryAddress');

                if (!selectedState) {
                    selectedState = _.first(states);
                }

                _this2.states = {
                    states: states,
                    selectedState: selectedState
                };
            });
        }
    }]);

    return PickupAddressListController;
}();

var pickupAddressListComponentDefinition = {
    bindings: {
        hasSearched: '=',
        isSearching: '=',
        pickupStores: '=',
        setStores: '&'
    },
    controller: ['$scope', '$element', 'AddressService', 'StateService', 'MoveFocus', PickupAddressListController],
    template: __webpack_require__(1006).trim()
};

module.exports = {
    PickupAddressListController: PickupAddressListController,
    pickupAddressListComponentDefinition: pickupAddressListComponentDefinition
};

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pickupAddressList\" ng-if=\"$ctrl.states.selectedState\">\r\n    <fieldset class=\"pickupAddressSearch-search\">\r\n        <wow-select-container class=\"pickupaddresslist-stateselect\">\r\n            <label for=\"pickupAddressList-states\">Filter by state</label>\r\n            <select id=\"pickupAddressList-states\"\r\n                    class=\"_pickupAddressList-stateSelect\"\r\n                    ng-model=\"$ctrl.states.selectedState\"\r\n                    ng-options=\"state.Label for state in $ctrl.states.states\"\r\n                    oly-grab-focus=\"true\">\r\n            </select>\r\n        </wow-select-container>\r\n    </fieldset>\r\n</div>\r\n"

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PickupAddressController = function () {
    function PickupAddressController($element, settings, pickupAddressSearchService, featureService, moveFocus) {
        _classCallCheck(this, PickupAddressController);

        this.$element = $element;
        this.pickupAddressSearch = pickupAddressSearchService;
        this.settings = settings;
        this.moveFocus = moveFocus;

        this.isStoreSearchEnabled = featureService.isEnabled(featureService.features.clickAndCollectStoreSearch);
        this.id = $element.attr('id') || '';
    }

    _createClass(PickupAddressController, [{
        key: '$onInit',
        value: function $onInit() {
            this.pickupStores = [];

            this.storesPerPage = this.settings.clickAndCollect.clickAndCollectStoresPerPage;
            this.numberOfStoresToShow = this.storesPerPage;
        }
    }, {
        key: 'setStores',
        value: function setStores(stores) {
            this.pickupStores = stores;
            this.selectedStore = null;
        }
    }, {
        key: 'hasStores',
        value: function hasStores() {
            return !!this.pickupStores && this.pickupStores.length > 0;
        }
    }, {
        key: 'hasMoreStores',
        value: function hasMoreStores() {
            return this.hasStores() && this.numberOfStoresToShow < this.pickupStores.length;
        }
    }, {
        key: 'viewMoreStores',
        value: function viewMoreStores() {
            var _this = this;

            var numberPreviouslyShowing = this.numberOfStoresToShow;

            if (this.hasMoreStores()) {
                this.numberOfStoresToShow += this.storesPerPage;
            }

            this.moveFocus(function () {
                return _this.$element.find('._pickupAddressSearch-searchResult').eq(numberPreviouslyShowing);
            });
        }
    }, {
        key: 'onSelectStore',
        value: function onSelectStore(store) {
            this.selectedStore = store.AddressId;
            this.setPickupAddress({ addr: store });
        }
    }]);

    return PickupAddressController;
}();

var pickupAddressComponentDefinition = {
    bindings: {
        setPickupAddress: '&',
        classModifier: '@?',
        isRequired: '<?'
    },
    controller: ['$element', 'Settings', 'PickupAddressSearchService', 'FeatureService', 'MoveFocus', PickupAddressController],
    template: __webpack_require__(1008).trim()
};

module.exports = {
    PickupAddressController: PickupAddressController,
    pickupAddressComponentDefinition: pickupAddressComponentDefinition
};

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pickupAddress\" ng-switch=\"$ctrl.isStoreSearchEnabled\" ng-class=\"::'pickupAddress--' + $ctrl.classModifier\" ng-init=\"$ctrl.viewMoreCounter=0\">\r\n    <ng-form name=\"$ctrl.pickupAddress\">\r\n        <div class=\"pickupAddress-filter\">\r\n            <wow-pickup-address-search\r\n                search-string=\"$ctrl.searchString\"\r\n                search-mode=\"$ctrl.searchMode\"\r\n                is-searching=\"$ctrl.isSearching\"\r\n                has-searched=\"$ctrl.hasSearched\"\r\n                suburbs=\"$ctrl.suburbs\"\r\n                set-stores=\"$ctrl.setStores(stores)\"\r\n                is-fulfilment-selector=\"false\"\r\n                ng-switch-when=\"true\">\r\n            </wow-pickup-address-search>\r\n\r\n            <wow-pickup-address-list\r\n                set-stores=\"$ctrl.setStores(stores)\"\r\n                is-searching=\"$ctrl.isSearching\"\r\n                has-searched=\"$ctrl.hasSearched\"\r\n                ng-switch-when=\"false\">\r\n            </wow-pickup-address-list>\r\n        </div>\r\n\r\n        <fieldset class=\"pickupAddress-resultsContainer\" ng-if=\"$ctrl.hasSearched\">\r\n            <ul class=\"pickupAddress-results\"\r\n                role=\"listbox\"\r\n                aria-label=\"Pickup {{$ctrl.searchMode}} search results for {{$ctrl.searchString}}\"\r\n                ng-if=\"$ctrl.searchMode !== $ctrl.pickupAddressSearch.searchModes.suburbs\">\r\n\r\n                <li ng-if=\"$ctrl.isSearching\">\r\n                    <wow-loading-spinner message=\"Searching for stores, please wait...\"></wow-loading-spinner>\r\n                </li>\r\n\r\n                <li role=\"option\" ng-if=\"!$ctrl.isSearching\" class=\"pickupAddress-searchResult _pickupAddressSearch-searchResult\"\r\n                    ng-repeat=\"store in $ctrl.pickupStores | limitTo: $ctrl.numberOfStoresToShow track by store.AddressId\">\r\n\r\n                    <input\r\n                        type=\"radio\"\r\n                        name=\"pickupStore\"\r\n                        id=\"{{ ::$ctrl.id + store.AddressId }}\"\r\n                        class=\"wowRadio\"\r\n                        ng-model=\"$ctrl.selectedStore\"\r\n                        ng-value=\"::store.AddressId\"\r\n                        ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.onSelectStore(store)\">\r\n\r\n                    <label for=\"{{ ::$ctrl.id + store.AddressId }}\"\r\n                            class=\"pickupAddress-storeDetails\"\r\n                            ng-click=\"$ctrl.onSelectStore(store)\"\r\n                            wow-event-recorder=\"click\"\r\n                            data-er-category=\"Delivery Window\"\r\n                            data-er-label=\"Super market selected\"\r\n                            data-er-value=\"No. of times View more clicked before picking the supermarket {{$ctrl.viewMoreCounter}}\">\r\n                        <span class=\"sr-only\">Select </span>\r\n                        <span class=\"pickupAddress-store\">\r\n                            <p class=\"pickupAddress-storeDescription\">{{::store.Description}}</p>\r\n                            <address class=\"pickupAddress-storeAddress\">{{::store.Street1}}</address>\r\n                        </span>\r\n\r\n                        <span class=\"pickupAddress-storeDistance\" ng-show=\"::store.Distance\">{{::store.Distance}}km <span class=\"sr-only\">away</span></span>\r\n\r\n                        <span class=\"sr-only\"> as pickup store.</span>\r\n                    </label>\r\n                </li>\r\n            </ul>\r\n        </fieldset>\r\n\r\n        <div class=\"pickupAddress-more\" ng-if=\"$ctrl.hasSearched && $ctrl.hasStores() && $ctrl.searchMode !== $ctrl.pickupAddressSearch.searchModes.suburbs\" ng-switch=\"$ctrl.hasMoreStores()\">\r\n            <button\r\n                type=\"button\"\r\n                class=\"pickupAddress-button linkButton\"\r\n                ng-switch-when=\"true\"\r\n                ng-click=\"$ctrl.viewMoreStores();$ctrl.viewMoreCounter = $ctrl.viewMoreCounter + 1\"\r\n                wow-event-recorder=\"click\"\r\n                data-er-category=\"Delivery Window\"\r\n                data-er-label=\"View More to find Local Supermarket\">View more <i class=\"iconww-Plus pickupAddress-buttonIcon\"></i></button>\r\n            <button type=\"button\" class=\"pickupAddress-button linkButton\" ng-switch-when=\"false\" disabled>No more results to view</button>\r\n        </div>\r\n\r\n        <wow-input-container class=\"pickupAddress-validationMessages\" ng-show=\"$ctrl.pickupAddress.$invalid && $ctrl.pickupAddress.$submitted\">\r\n            <!-- hidden input field for form validation -->\r\n            <input type=\"hidden\" class=\"hidden\" name=\"pickupAddressList\" ng-model=\"$ctrl.selectedStore\" ng-required=\"$ctrl.isRequired\" />\r\n            <span ng-messages=\"$ctrl.pickupAddress.$error\" class=\"wowInput-errors\" id=\"pickupAddressErrors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">A store has not been selected.</span>\r\n            </span>\r\n        </wow-input-container>\r\n    </ng-form>\r\n</div>\r\n"

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SavedAddressesController = function () {
    function SavedAddressesController(moveFocus, addressService) {
        _classCallCheck(this, SavedAddressesController);

        this.moveFocus = moveFocus;
        this.addressService = addressService;
    }

    _createClass(SavedAddressesController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.addressService.getSavedAddresses().then(function () {
                _this.savedAddresses = _this.addressService.savedAddresses;
                if (_this.savedAddresses && _this.savedAddresses.length > 0) {
                    _this.moveFocus('#savedAddresses-results');
                }
            });
        }
    }, {
        key: 'setEntryMode',
        value: function setEntryMode(mode) {
            if (this.isNewFulfilmentMethodSelector) {
                this.heading = mode === 'MANUAL' ? 'Enter a new delivery address' : 'Choose a location';
            }
        }
    }]);

    return SavedAddressesController;
}();

var savedAddressesComponentDefinition = {
    bindings: {
        heading: '@',
        isGuest: '<',
        onSavedAddressSelected: '&?',
        onSaveNewManualAddress: '&',
        onSaveNewAutoAddress: '&',
        saveAddressError: '<?',
        saveAddressErrorTitle: '@?',
        isNewFulfilmentMethodSelector: '<?',
        selectedAddress: '=?'
    },
    controller: ['MoveFocus', 'AddressService', SavedAddressesController],
    template: __webpack_require__(1010).trim()
};

module.exports = {
    SavedAddressesController: SavedAddressesController,
    savedAddressesComponentDefinition: savedAddressesComponentDefinition
};

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = "<div class=\"savedAddresses\" ng-class=\"{'savedAddresses-v2' : $ctrl.isNewFulfilmentMethodSelector}\">\r\n    <fieldset class=\"savedAddresses-choices\" id=\"savedAddresses-results\" ng-if=\"::!$ctrl.isGuest && !$ctrl.isNewFulfilmentMethodSelector\">\r\n        <legend class=\"savedAddresses-legend\">\r\n            Previously used addresses\r\n        </legend>\r\n\r\n        <wow-loading-spinner ng-if=\"!$ctrl.savedAddresses\" message=\"Loading your saved addresses.\"></wow-loading-spinner>\r\n\r\n        <p ng-if=\"$ctrl.savedAddresses && $ctrl.savedAddresses.length === 0\">\r\n            (0) Saved addresses found\r\n        </p>\r\n\r\n        <div class=\"savedAddresses-savedAddress\"\r\n            ng-if=\"$ctrl.savedAddresses && $ctrl.savedAddresses.length > 0\"\r\n            ng-repeat=\"address in $ctrl.savedAddresses track by address.AddressId\">\r\n            <input\r\n                type=\"radio\"\r\n                name=\"savedAddress\"\r\n                id=\"address-{{ ::address.AddressId }}\"\r\n                class=\"wowRadio\"\r\n                ng-value=\"address.AddressId\"\r\n                ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.onSavedAddressSelected({ address: address })\"\r\n                ng-checked=\"$first\">\r\n            <label\r\n                for=\"address-{{ ::address.AddressId }}\"\r\n                ng-click=\"$ctrl.onSavedAddressSelected({ address: address })\"\r\n                wow-event-recorder=\"click\"\r\n                data-er-category=\"Delivery Window\"\r\n                data-er-label=\"Previously used address selection\">\r\n                {{ ::address.AddressText }}\r\n            </label>\r\n        </div>\r\n    </fieldset>\r\n\r\n\r\n\r\n    <hr class=\"savedAddresses-separator\" ng-if=\"::!$ctrl.isGuest && !$ctrl.isNewFulfilmentMethodSelector\">\r\n\r\n    <ng-form name=\"$ctrl.savedAddressForm\">\r\n        <wow-notification-message\r\n            ng-if=\"$ctrl.saveAddressError\"\r\n            is-dismissible=\"false\"\r\n            type=\"error\"\r\n            title=\"{{ $ctrl.saveAddressErrorTitle }}\"\r\n            message=\"{{ $ctrl.saveAddressError }}\"\r\n            class=\"savedAddresses-notification\"\r\n            container-classes=\"notificationMessage-container--small\"\r\n        />\r\n        <fieldset class=\"savedAddresses-addresses\" ng-class=\"{'savedAddresses-v2-addresses' : $ctrl.isNewFulfilmentMethodSelector}\">\r\n            <legend class=\"savedAddresses-legend savedAddresses-search\" ng-class=\"{'savedAddresses-v2-legend' : $ctrl.isNewFulfilmentMethodSelector}\">\r\n                {{$ctrl.heading}}\r\n            </legend>\r\n            <wow-address-entry-form\r\n                input-id=\"savedAddress\"\r\n                message-on-error=\"Unable to set address.\"\r\n                on-save-auto-address=\"$ctrl.onSaveNewAutoAddress({ address: address })\"\r\n                on-saved-address-selected=\"$ctrl.onSavedAddressSelected({ address: address })\"\r\n                on-save-manual-address=\"$ctrl.onSaveNewManualAddress({ address: address })\"\r\n                should-focus-initially=\"$ctrl.savedAddresses && $ctrl.savedAddresses.length === 0\"\r\n                should-reset-mode=\"false\"\r\n                show-submit=\"true\"\r\n                saved-addresses=\"$ctrl.savedAddresses\"\r\n                is-new-fulfilment-method-selector=\"$ctrl.isNewFulfilmentMethodSelector\"\r\n                selected-address=\"$ctrl.selectedAddress\"\r\n                on-set-entry-mode=\"$ctrl.setEntryMode(mode)\">\r\n            </wow-address-entry-form>\r\n        </fieldset>\r\n    </ng-form>\r\n</div>\r\n"

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find;

var ManualAddressController = function () {
    function ManualAddressController($q, moveFocus, settings, addressService, deliveryFormControlState) {
        _classCallCheck(this, ManualAddressController);

        this.$q = $q;
        this.moveFocus = moveFocus;
        this.addressService = addressService;
        this.deliveryFormControlState = deliveryFormControlState;
        this.maxCharactersManualAddress1 = settings.oneSite.maxCharactersManualAddress1;
        this.maxCharactersManualAddress2 = settings.oneSite.maxCharactersManualAddress2;
    }

    _createClass(ManualAddressController, [{
        key: 'addressChange',
        value: function addressChange() {
            if (this.onAddressChange) {
                this.onAddressChange({ address: this.address });
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.moveFocus('#manualAddress');
            if (!this.initialAddress) {
                this.clearInput();
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.initialAddress && this.initialAddress) {
                this.clearInput();
                this.useInitialAddress(this.initialAddress);
            }
        }
    }, {
        key: 'clearInput',
        value: function clearInput() {
            this.address = {
                postcode: '', street1: '', street2: '', suburbId: null, suburb: ''
            };
            this.suburbs = [];
        }
    }, {
        key: 'useInitialAddress',
        value: function useInitialAddress(address) {
            var _this = this;

            this.address.postcode = address.postcode;
            this.loadSuburbs().then(function () {
                var initialSuburb = _this.getInitialSuburb(address);
                _this.address = {
                    postcode: address.postcode,
                    street1: address.street1,
                    street2: address.street2,
                    suburbId: initialSuburb.Id,
                    suburb: initialSuburb.Text
                };
                _this.setSuburb({
                    Id: initialSuburb.Id,
                    Text: initialSuburb.Text
                });
            });
        }
    }, {
        key: 'getInitialSuburb',
        value: function getInitialSuburb(address) {
            return address.suburbId ? {
                Id: address.suburbId,
                Text: address.suburbName
            } : this.getSuburbByName(address.suburbName);
        }
    }, {
        key: 'getSuburbByName',
        value: function getSuburbByName(suburbName) {
            return suburbName && this.suburbs && this.suburbs.length ? find(this.suburbs, function (item) {
                return item.Text.toLowerCase() === suburbName.toLowerCase();
            }) : { Id: '', Text: '' };
        }
    }, {
        key: 'setSuburb',
        value: function setSuburb(suburb) {
            if (suburb) {
                this.address.suburbId = !suburb.Id || suburb.Id === 'n/a' ? 0 : suburb.Id;
                this.address.suburb = suburb.Text;
                this.selectedSuburb = suburb;
                this.addressChange();
            }
            return this.selectedSuburb;
        }
    }, {
        key: 'loadSuburbs',
        value: function loadSuburbs() {
            var _this2 = this;

            if (this.address.postcode && this.address.postcode.length === 4) {
                return this.addressService.getSuburbs(this.address.postcode).then(function (suburbs) {
                    _this2.suburbs = suburbs;
                    if (_this2.suburbs && _this2.suburbs.length) {
                        _this2.setSuburb(_this2.suburbs[0]);
                    }

                    _this2.addressChange();
                });
            } else if (this.address.postcode && this.address.postcode.length !== 4) {
                this.suburbs = null;
                this.address.suburb = null;
                this.addressChange();
            }
            return this.$q.reject();
        }
    }, {
        key: 'onClickManualAddressForExpress',
        value: function onClickManualAddressForExpress() {
            if (this.isForExpress && this.manualAddressMode === 'SEARCH') {
                this.onValidateManualAddressForExpress();
            } else if (this.isForExpress && this.manualAddressMode === 'SHOP') {
                this.onShopManualAddressForExpress();
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            this.deliveryFormControlState.setChildFormSubmitting();
            this.onAddressSaved({ address: this.address });
        }
    }, {
        key: 'manualSearchButtonCaption',
        get: function get() {
            return this.isForExpress && this.manualAddressMode === 'SEARCH' && !this.isExpressUnavailable ? 'Search now' : 'Shop now';
        }
    }, {
        key: 'shouldDisableShopButton',
        get: function get() {
            return !this.manualAddressForm.$valid && this.manualAddressMode === 'SEARCH' || this.isExpressUnavailable;
        }
    }]);

    return ManualAddressController;
}();

ManualAddressController.$inject = ['$q', 'MoveFocus', 'Settings', 'AddressService', 'DeliveryFormControlState'];

var manualAddressComponentDefinition = {
    transclude: {
        switchToSearch: '?switchToSearch'
    },
    bindings: {
        initialAddress: '<?',
        messageOnError: '@?',
        onAddressSaved: '&',
        onAddressChange: '&?',
        showSubmit: '<',
        manualAddressForm: '=?',
        isNewFulfilmentMethodSelector: '<?',

        // Express Delivery specific bindings.
        isForExpress: '<?',
        isExpressUnavailable: '<?',
        manualAddressMode: '@?',
        onValidateManualAddressForExpress: '&?',
        onShopManualAddressForExpress: '&?',
        isGrid: '<?'
    },
    controller: ManualAddressController,
    template: __webpack_require__(1012).trim()
};

module.exports = {
    ManualAddressController: ManualAddressController,
    manualAddressComponentDefinition: manualAddressComponentDefinition
};

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports = "<ng-form name=\"$ctrl.manualAddressForm\" id=\"manualAddress\" class=\"manualAddress\" ng-class=\"{'manualAddress--grid' : $ctrl.isGrid}\">\r\n    <oly-form-validation-summary user-message=\"{{ ::$ctrl.messageOnError }}\" ng-if=\"$ctrl.messageOnError\"></oly-form-validation-summary>\r\n    <div class=\"manualAddress-inputContainer\">\r\n        <wow-input-container class=\"manualAddress-input\">\r\n            <label for=\"_manualAddressFormStreet1\">\r\n                Street Address 1 *\r\n            </label>\r\n            <input\r\n                type=\"text\"\r\n                id=\"_manualAddressFormStreet1\"\r\n                name=\"street1\"\r\n                ng-model=\"$ctrl.address.street1\"\r\n                ng-change=\"$ctrl.addressChange()\"\r\n                required\r\n                autocomplete=\"off\"\r\n                ng-model-options=\"{ updateOn: 'blur' }\"\r\n                ng-maxlength=\"{{ $ctrl.maxCharactersManualAddress1 }}\"\r\n                ng-pattern=\"/^[^&lt;&gt;]*$/\"\r\n                oly-grab-focus=\"true\"/>\r\n            <span ng-messages=\"$ctrl.manualAddressForm.street1.$error\" class=\"wowInput-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">Street address is required</span>\r\n                <span ng-message=\"maxlength\" class=\"wowInput-error\">{{$ctrl.maxCharactersManualAddress1}} character limit is exceeded</span>\r\n                <span ng-message=\"pattern\" class=\"wowInput-error\">Street address contains invalid characters</span>\r\n            </span>\r\n        </wow-input-container>\r\n        <wow-input-container class=\"manualAddress-input\">\r\n            <label for=\"_manualAddressFormStreet2\">\r\n                Street Address 2<span class=\"sr-only\"> optional</span>\r\n            </label>\r\n            <input\r\n                type=\"text\"\r\n                id=\"_manualAddressFormStreet2\"\r\n                name=\"street2\"\r\n                ng-model=\"$ctrl.address.street2\"\r\n                ng-change=\"$ctrl.addressChange()\"\r\n                ng-model-options=\"{ updateOn: 'blur' }\"\r\n                ng-maxlength=\"{{ $ctrl.maxCharactersManualAddress2 }}\"\r\n                ng-pattern=\"/^[^&lt;&gt;]*$/\"/>\r\n            <span ng-messages=\"$ctrl.manualAddressForm.street2.$error\" class=\"wowInput-errors\">\r\n                <span ng-message=\"maxlength\" class=\"wowInput-error\">{{$ctrl.maxCharactersManualAddress2}} character limit is exceeded</span>\r\n                <span ng-message=\"pattern\" class=\"wowInput-error\">Street address contains invalid characters</span>\r\n            </span>\r\n        </wow-input-container>\r\n        <wow-input-container class=\"manualAddress-input\">\r\n            <label for=\"_manualAddressFormPostCode\">\r\n                Postcode *\r\n            </label>\r\n\r\n\r\n            <input\r\n                type=\"tel\"\r\n                id=\"_manualAddressFormPostCode\"\r\n                name=\"postCode\"\r\n                ng-model=\"$ctrl.address.postcode\"\r\n                ng-class=\"$ctrl.isGrid || $ctrl.isNewFulfilmentMethodSelector ? 'wowInput' : 'wowInput--small'\"\r\n                wow-post-code\r\n                ng-change=\"$ctrl.loadSuburbs()\"\r\n                required\r\n                autocomplete=\"off\"\r\n                ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 200, blur: 0 } }\"/>\r\n            <span ng-messages=\"$ctrl.manualAddressForm.postCode.$error\" class=\"wowInput-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">Postcode is required</span>\r\n                <span ng-message=\"invalid\" class=\"wowInput-error\">Postcode is invalid</span>\r\n            </span>\r\n        </wow-input-container>\r\n\r\n        <div class=\"wowInputContainer manualAddress-input\">\r\n            <wow-select-container>\r\n                <label for=\"_manualAddressFormSuburb\">Suburb *</label>\r\n                <select name=\"suburb\"\r\n                    id=\"_manualAddressFormSuburb\"\r\n                    ng-model=\"$ctrl.setSuburb\"\r\n                    ng-model-options=\"{ updateOn: 'default', getterSetter: true }\"\r\n                    ng-options=\"s as s.Text for s in $ctrl.suburbs track by s.Id\"\r\n                    ng-class=\"{'is-disabled': !$ctrl.suburbs.length}\"\r\n                    ng-required=\"$ctrl.suburbs.length\">\r\n                    <option value=\"\" ng-if=\"!$ctrl.suburbs.length\">\r\n                        Please enter a postcode\r\n                    </option>\r\n                </select>\r\n            </wow-select-container>\r\n\r\n            <span ng-messages=\"$ctrl.manualAddressForm.suburb.$error\" class=\"wowInput-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error\">Suburb is required</span>\r\n            </span>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <button type=\"submit\"\r\n            ng-class=\"!$ctrl.isNewFulfilmentMethodSelector ? 'manualAddress-button linkButton' : 'button button--primary manualAddressV2-saveButton'\"\r\n            ng-click=\"$ctrl.manualAddressForm.$valid && $ctrl.onSubmit()\"\r\n            ng-if=\"$ctrl.showSubmit\"\r\n            wow-event-recorder=\"click\"\r\n            data-er-category=\"Delivery Address\"\r\n            data-er-label=\"Save manually entered address\">\r\n        {{ !$ctrl.isNewFulfilmentMethodSelector ? 'Save' : 'Save address'}}\r\n    </button>\r\n    <div class=\"manualAddress-expressButtonContainer\">\r\n        <div class=\"manualAddress-switchToSearch\" ng-transclude=\"switchToSearch\"></div>\r\n        <button\r\n            type=\"button\"\r\n            ng-if=\"$ctrl.isForExpress\"\r\n            class=\"manualAddress-expressButton manualAddress-textUppercase button button--primary\"\r\n            ng-disabled=\"$ctrl.shouldDisableShopButton\"\r\n            ng-click=\"$ctrl.onClickManualAddressForExpress()\">\r\n            {{$ctrl.manualSearchButtonCaption}}\r\n            <i class=\"iconww-ArrowRight\"></i>\r\n        </button>\r\n    </div>\r\n</ng-form>\r\n"

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isEmpty = _require.isEmpty;

var AddressEntryFormController = function () {
    function AddressEntryFormController($q, moveFocus, addressService, fulfilmentService, addressEntryModes) {
        _classCallCheck(this, AddressEntryFormController);

        this.$q = $q;
        this.moveFocus = moveFocus;
        this.addressService = addressService;
        this.fulfilmentService = fulfilmentService;
        this.addressEntryModes = addressEntryModes;
    }

    _createClass(AddressEntryFormController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.isNewFulfilmentMethodSelector) {
                this.autocompleteText = this.fulfilmentService.getFullDeliveryAddress(this.selectedAddress);
            }
            this.shouldResetMode = this.shouldResetMode !== undefined ? this.shouldResetMode : true;
            this.shouldFocusInitially = this.shouldFocusInitially !== undefined ? this.shouldFocusInitially : true;
            if (!this.isNewFulfilmentMethodSelector) {
                this.clearInput();
            }
            if (!this.initialAddress) {
                this.addressEntryMode = this.addressEntryModes.search;
            }
            this.address = null;
            if (this.shouldFocusInitially && !this.isNewFulfilmentMethodSelector) {
                this.moveFocus('#address-' + this.inputId);
            }
        }
    }, {
        key: 'getItemText',
        value: function getItemText(item) {
            return item.Text ? item.Text : item.AddressText;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.initialAddress && this.initialAddress) {
                this.setEntryMode(this.addressEntryModes.manual);
            }
        }
    }, {
        key: 'addressOnType',
        value: function addressOnType() {
            if (this.isNewFulfilmentMethodSelector) {
                this.selectedAddress = null;
                if (!!this.autocompleteText && this.autocompleteText.length >= 3) {
                    this.addressService._clearAutoAddresses();
                    return this.addressService.addressOnType(this.autocompleteText);
                }
                var deferred = this.$q.defer();
                deferred.resolve(this.savedAddresses);
                return deferred.promise;
            }

            return this.addressService.addressOnType(this.autocompleteText);
        }
    }, {
        key: 'clearInput',
        value: function clearInput() {
            this.autocompleteText = this.addressQuery ? this.addressQuery.AddressText : '';
        }
    }, {
        key: 'saveSearchedAddress',
        value: function saveSearchedAddress(address) {
            if (this.isNewFulfilmentMethodSelector) {
                if (!isEmpty(address)) {
                    if (typeof address.Id !== 'undefined') {
                        this.onSaveAutoAddress({ address: address });
                    } else {
                        this.onSavedAddressSelected({ address: address });
                    }
                    return;
                }
            }

            if (this.onSaveAutoAddress) {
                this.onSaveAutoAddress({ address: address });
            }
            if (!this.shouldRetainInput) {
                this.clearInput();
            } else {
                this.autocompleteText = address.Text;
            }
        }
    }, {
        key: 'saveManualAddress',
        value: function saveManualAddress(address) {
            var _this = this;

            if (address.suburbId && address.suburbId > 0) {
                if (this.onSaveManualAddress) {
                    this.$q.when(this.onSaveManualAddress({ address: address })).then(function () {
                        if (_this.shouldResetMode) {
                            _this.setEntryMode(_this.addressEntryModes.search);
                        }
                    });
                }
                if (!this.shouldRetainInput) {
                    this.clearInput();
                }
            }
        }
    }, {
        key: 'setEntryMode',
        value: function setEntryMode(mode) {
            this.addressEntryMode = mode;
            if (mode === this.addressEntryModes.search) {
                this.moveFocus('#address-' + this.inputId);
            }
            this.address = null;
        }
    }, {
        key: 'addressEntryMode',
        set: function set(mode) {
            this.entryMode = mode;
            if (this.onSetEntryMode) {
                this.onSetEntryMode({ mode: mode });
            }
        },
        get: function get() {
            return this.entryMode;
        }
    }]);

    return AddressEntryFormController;
}();

AddressEntryFormController.$inject = ['$q', 'MoveFocus', 'AddressService', 'FulfilmentService', 'AddressEntryModes'];

var addressEntryFormComponentDefinition = {
    bindings: {
        inputId: '@',
        addressQuery: '<?',
        showSubmit: '=?',
        messageOnError: '@?',
        shouldFocusInitially: '<?',
        shouldResetMode: '<?',
        shouldRetainInput: '<?',
        onSaveAutoAddress: '&?',
        onSavedAddressSelected: '&?',
        onSaveManualAddress: '&?',
        onManualAddressChange: '&?',
        onSetEntryMode: '&?',
        initialAddress: '<?',
        savedAddresses: '=?',
        isNewFulfilmentMethodSelector: '<?',
        selectedAddress: '=?',

        // Express Delivery specific bindings.
        isForExpress: '<?',
        isExpressUnavailable: '<?',
        manualAddressMode: '@?',
        onValidateManualAddressForExpress: '&?',
        onShopManualAddressForExpress: '&?'
    },
    controller: AddressEntryFormController,
    template: __webpack_require__(1014).trim()
};

module.exports = {
    AddressEntryFormController: AddressEntryFormController,
    addressEntryFormComponentDefinition: addressEntryFormComponentDefinition
};

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports = "<div class=\"addressEntryForm\" ng-class=\"$ctrl.isNewFulfilmentMethodSelector ? 'addressEntryFormV2' : ''\" ng-switch=\"$ctrl.addressEntryMode\">\r\n    <fieldset ng-switch-when=\"SEARCH\">\r\n        <ng-form name=\"$ctrl.autoAddressForm\" novalidate>\r\n            <oly-form-validation-summary user-message=\"{{ ::$ctrl.messageOnError }}\" ng-if=\"$ctrl.messageOnError\"></oly-form-validation-summary>\r\n            <wow-input-container>\r\n                <label for=\"address-{{$ctrl.inputId}}\" ng-if=\"::!$ctrl.isNewFulfilmentMethodSelector\">\r\n                    Search for a new address *\r\n                </label>\r\n                <label for=\"address-{{$ctrl.inputId}}\" ng-if=\"::$ctrl.isNewFulfilmentMethodSelector\">\r\n                    {{$ctrl.selectedAddress ? 'Deliver to' : 'Search for a new address'}}\r\n                </label>\r\n                <oly-autocomplete\r\n                    input-id=\"address-{{$ctrl.inputId}}\"\r\n                    input-name=\"address\"\r\n                    class=\"addressEntryForm-searchAutocompleteWrapper\"\r\n                    text=\"$ctrl.autocompleteText\"\r\n                    items=\"$ctrl.addressOnType()\"\r\n                    item-text=\"$ctrl.getItemText\"\r\n                    selected-item=\"$ctrl.address\"\r\n                    run-on-select=\"$ctrl.saveSearchedAddress($ctrl.address)\"\r\n                    is-required=\"true\"\r\n                    search-box-class=\"addressEntryForm-searchAutocompleteTextField\"\r\n                    dropdown-class=\"addressEntryForm-searchAutocompleteDropdown\"\r\n                    show-clear-button=\"true\"\r\n                    show-prefix=\"$ctrl.isNewFulfilmentMethodSelector && $ctrl.savedAddresses.length && (!$ctrl.autocompleteText || ($ctrl.autocompleteText.length < 3))\"\r\n                    action-button-wrapper-class=\"addressEntryForm-searchAutocompleteActionsWrapper\"\r\n                    action-button-class=\"addressEntryForm-searchAutocompleteClearButton\"\r\n                    min-length=\"0\">\r\n                    <autocomplete-prefix class=\"addressEntryFormV2-searchAutocompletePrefixItem\">\r\n                        Previously used addresses\r\n                    </autocomplete-prefix>\r\n                    <autocomplete-item\r\n                        ng-class=\"!$ctrl.isNewFulfilmentMethodSelector ? 'addressEntryForm-searchAutocompleteItem' : 'addressEntryFormV2-searchAutocompleteItem'\"\r\n                        wow-event-recorder=\"click\"\r\n                        data-er-category=\"Delivery Address\"\r\n                        data-er-label=\"AMAS address selection (New)\">\r\n                        {{ ::item.Text ? item.Text : item.AddressText }}\r\n                    </autocomplete-item>\r\n                    <autocomplete-not-found ng-if=\"!$ctrl.isNewFulfilmentMethodSelector\">\r\n                        No addresses found for “{{$ctrl.autocompleteText}}”\r\n                    </autocomplete-not-found>\r\n                    <autocomplete-not-found ng-if=\"$ctrl.isNewFulfilmentMethodSelector\">\r\n                        Addresses not found.\r\n                        <button\r\n                            type=\"button\"\r\n                            class=\"linkButton\"\r\n                            ng-click=\"::$ctrl.setEntryMode($ctrl.addressEntryModes.manual)\">\r\n                            Enter manually <i class=\"iconww-ArrowRight fulfilmentSelectorDeliveryAddress-buttonIcon\"></i>\r\n                        </button>\r\n                    </autocomplete-not-found>\r\n                </oly-autocomplete>\r\n                <span ng-messages=\"$ctrl.autoAddressForm.address.$error\" class=\"wowInput-errors\">\r\n                    <span ng-message=\"required\" class=\"wowInput-error\">Address is required.</span>\r\n                </span>\r\n                <p class=\"addressEntryForm-tip\">Enter street number followed by street name</p>\r\n            </wow-input-container>\r\n\r\n            <button\r\n                type=\"button\"\r\n                class=\"addressEntryForm-button linkButton\"\r\n                ng-click=\"::$ctrl.setEntryMode($ctrl.addressEntryModes.manual)\"\r\n                wow-event-recorder=\"click\"\r\n                data-er-category=\"Delivery Address\"\r\n                data-er-label=\"Enter my address manually\"\r\n                ng-if=\"!$ctrl.isNewFulfilmentMethodSelector\">\r\n                Enter my address manually\r\n            </button>\r\n        </ng-form>\r\n    </fieldset>\r\n\r\n    <fieldset ng-switch-when=\"MANUAL\">\r\n        <wow-manual-address\r\n            initial-address=\"$ctrl.initialAddress\"\r\n            message-on-error=\"{{ ::$ctrl.messageOnError }}\"\r\n            on-address-change=\"$ctrl.onManualAddressChange({address: address})\"\r\n            on-address-saved=\"$ctrl.saveManualAddress(address)\"\r\n            show-submit=\"$ctrl.showSubmit\"\r\n            is-grid=\"$ctrl.isForExpress\"\r\n            is-for-express=\"$ctrl.isForExpress\"\r\n            is-express-unavailable=\"$ctrl.isExpressUnavailable\"\r\n            manual-address-mode=\"{{$ctrl.manualAddressMode}}\"\r\n            on-validate-manual-address-for-express=\"$ctrl.onValidateManualAddressForExpress()\"\r\n            on-shop-manual-address-for-express=\"$ctrl.onShopManualAddressForExpress()\"\r\n            is-new-fulfilment-method-selector=\"$ctrl.isNewFulfilmentMethodSelector\">\r\n                <switch-to-search>\r\n                    <button\r\n                        type=\"button\"\r\n                        class=\"linkButton\"\r\n                        ng-class=\"{'addressEntryForm-button': !$ctrl.isForExpress, 'addressEntryForm-expressButton': $ctrl.isForExpress}\"\r\n                        ng-click=\"::$ctrl.setEntryMode($ctrl.addressEntryModes.search)\"\r\n                        wow-event-recorder=\"click\"\r\n                        data-er-category=\"Delivery Address\"\r\n                        data-er-label=\"Search for an address (Manullay entered)\">\r\n                        {{$ctrl.isForExpress || $ctrl.isNewFulfilmentMethodSelector ? '<' : ''}} Search for an address\r\n                    </button>\r\n                </switch-to-search>\r\n        </wow-manual-address>\r\n    </fieldset>\r\n</div>\r\n"

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    remove = _require.remove;

var AddressService = function () {
    function AddressService($timeout, $q, restangular, trolleyService) {
        _classCallCheck(this, AddressService);

        this._addressRoute = restangular.one('address');
        this.$timeout = $timeout;
        this.$q = $q;
        this.trolleyService = trolleyService;

        this.initialize();
    }

    _createClass(AddressService, [{
        key: 'initialize',
        value: function initialize() {
            this.suburbs = [];
            this.autoAddresses = [];
            this.savedAddress = {};
            this.searchError = {
                Id: '',
                Text: ''
            };

            this._clearSavedError();

            this.isNonServiced = false;
            this.autoAddressSearchTerm = '';
            this.autoAddressSource = ''; // Keep tracking of current template.
            this.nonServicedAddressResult = false;
            this.decideLater = {
                collect: { Description: 'a store which I\'ll set later' },
                delivery: { Description: 'an address which I\'ll set later' }
            };
        }

        // Internal functions

    }, {
        key: '_onSaveSuccess',
        value: function _onSaveSuccess(response) {
            this._clearSavedError();
            this.isNonServiced = response.IsNonServiced;

            if (response.Address && response.Address.AddressText.length > 0) {
                this.savedAddress = response.Address;
                this.trolleyService.getTrolley();
                this.savedAddressesPromise = null;
                return response;
            }

            if (response.Address && response.Address.AddressId === 0) {
                this.savedError.ErrorType = 'Authentication Error';
                this.savedError.ErrorCode = 'Shopper is guest';
                this.savedError.ErrorMessage = 'Addresses cannot be saved for guest users.';
                return false;
            }

            this.savedError.ErrorType = 'Service Stack Error';
            this.savedError.ErrorCode = 'Invalid response';
            this.savedError.ErrorMessage = 'The address has failed to save.';
            return false;
        }
    }, {
        key: '_onSaveFailure',
        value: function _onSaveFailure(response) {
            this.savedError = response;
            if (response.data.ResponseStatus) {
                this.savedError.ErrorCode = response.data.ResponseStatus.ErrorCode;
                this.savedError.ErrorMessage = response.data.ResponseStatus.Message;
                this.savedError.ErrorResponse = response.data.ResponseStatus.Errors;
            } else {
                this.savedError.ErrorMessage = 'The address has failed to save.';
            }

            return false;
        }
    }, {
        key: '_clearAutoAddresses',
        value: function _clearAutoAddresses() {
            this.searchError = {
                Id: '',
                Text: ''
            };
            this.autoAddresses = [];
        }
    }, {
        key: '_clearSavedError',
        value: function _clearSavedError() {
            this.savedError = {
                ErrorType: '',
                ErrorCode: '',
                ErrorMessage: '',
                ErrorResponse: []
            };
        }

        // global functions.

    }, {
        key: 'search',
        value: function search(query) {
            var _this = this;

            return this._addressRoute.one('search').doPOST({
                Search: query
            }).then(function (response) {
                if (response.Response && response.Response.length > 0 && response.Response[0].Id !== '') {
                    _this.autoAddresses = response.Response;
                } else {
                    _this.searchError = { Id: 'n/a', Text: '(0) Addresses found for ' + query };
                }
                return true;
            }, function () {
                _this.searchError = { Id: 'n/a', Text: 'An error has occured searching for ' + query };
                return false;
            });
        }
    }, {
        key: 'setAddress',
        value: function setAddress(address) {
            this.savedAddress = address;
        }
    }, {
        key: 'delete',
        value: function _delete(address) {
            var _this2 = this;

            remove(this.savedAddresses, function (a) {
                return a === address;
            });
            return this._addressRoute.one('delete').doPOST({ AddressId: address.AddressId }).finally(function () {
                _this2.savedAddressesPromise = null;
            });
        }
    }, {
        key: 'saveAddress',
        value: function saveAddress(address) {
            var _this3 = this;

            return this._addressRoute.one('auto').doPOST({
                AddressId: address.Id
            }).then(function (response) {
                return _this3._onSaveSuccess(response);
            }, function (response) {
                return _this3._onSaveFailure(response);
            });
        }
    }, {
        key: 'updateAddress',
        value: function updateAddress(savedAddressId, selectedAddress) {
            var _this4 = this;

            return this._addressRoute.one('updateAuto').doPOST({
                SavedAddressId: savedAddressId,
                SelectedAddressId: selectedAddress.Id
            }).then(function (response) {
                return _this4._onSaveSuccess(response);
            }, function (response) {
                return _this4._onSaveFailure(response);
            });
        }
    }, {
        key: 'saveAutoAddress',
        value: function saveAutoAddress(addr) {
            var _this5 = this;

            if (addr && addr.Id !== 'n/a') {
                this._clearAutoAddresses();
                this.autoAddressSearchTerm = '';
                this.autoAddressSource = addr.source;
                return this.saveAddress(addr).then(function (address) {
                    if (address) {
                        _this5.autoAddressSearchTerm = '';
                    }
                    return address;
                });
            }
            return this.$q.when(null);
        }
    }, {
        key: 'saveManualAddress',
        value: function saveManualAddress(address) {
            var _this6 = this;

            return this._addressRoute.one('manual').doPOST({
                Street1: address.street1,
                Street2: address.street2,
                SuburbId: address.suburbId,
                Postcode: address.postcode
            }).then(function (response) {
                return _this6._onSaveSuccess(response);
            }, function (response) {
                return _this6._onSaveFailure(response);
            });
        }
    }, {
        key: 'saveNewManualAddressForBilling',
        value: function saveNewManualAddressForBilling(address) {
            return this._addressRoute.one('manualBilling').doPOST({
                Street1: address.street1,
                Street2: address.street2,
                SuburbId: address.suburbId,
                Postcode: address.postcode
            });
        }
    }, {
        key: 'saveNewAutoAddressForBilling',
        value: function saveNewAutoAddressForBilling(address) {
            this._clearAutoAddresses();
            this.autoAddressSearchTerm = '';
            this.autoAddressSource = address.source;
            return this._addressRoute.one('autoBilling').doPOST({
                AddressId: address.Id
            });
        }
    }, {
        key: 'setSavedAddressAsBilling',
        value: function setSavedAddressAsBilling(addressId) {
            return this._addressRoute.one('billing').doPOST({ addressId: addressId });
        }
    }, {
        key: 'updateManualAddress',
        value: function updateManualAddress(savedAddressId, newAddress) {
            var _this7 = this;

            return this._addressRoute.one('updateManual').doPOST({
                SavedAddressId: savedAddressId,
                Street1: newAddress.street1,
                Street2: newAddress.street2,
                SuburbId: newAddress.suburbId,
                Postcode: newAddress.postcode
            }).then(function (response) {
                return _this7._onSaveSuccess(response);
            }, function (response) {
                return _this7._onSaveFailure(response);
            });
        }
    }, {
        key: 'getSuburbs',
        value: function getSuburbs(query) {
            var _this8 = this;

            return this._addressRoute.one('suburb', query).get().then(function (response) {
                _this8.suburbs = response.Response && response.Response.length > 0 ? response.Response : [{ Id: 'n/a', Text: '(0) Suburbs found for ' + query }];
                return _this8.suburbs;
            }, function () {
                return [{ Id: 'n/a', Text: 'An error has occured searching for ' + query }];
            });
        }
    }, {
        key: 'getPrimaryAddress',
        value: function getPrimaryAddress() {
            return find(this.savedAddresses, { IsPrimary: true });
        }
    }, {
        key: 'setPickupAddress',
        value: function setPickupAddress() {
            var _this9 = this;

            var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (address) {
                return this._addressRoute.one('SetPickup').doPOST({ AddressId: address.AddressId }).then(function () {
                    _this9.savedAddress.AddressId = address.AddressId;
                    _this9.savedAddress.AddressText = address.Description;
                });
            }
            this.savedAddress.AddressId = 0;
            this.savedAddress.AddressText = this.decideLater.collect.Description;
            return this.$q.when(this.savedAddress);
        }
    }, {
        key: 'setDeliveryAddress',
        value: function setDeliveryAddress() {
            var _this10 = this;

            var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (address) {
                return this._addressRoute.one('SetDelivery').doPOST({ AddressId: address.AddressId }).then(function (data) {
                    _this10.savedAddress.AddressId = address.AddressId;
                    _this10.savedAddress.AddressText = address.AddressText;
                    _this10.isNonServiced = data.IsServiceNotAvailable;
                });
            }
            this.savedAddress.AddressId = 0;
            this.savedAddress.AddressText = this.decideLater.delivery.Description;
            return this.$q.when(this.savedAddress);
        }
    }, {
        key: 'getPickupAddresses',
        value: function getPickupAddresses(args) {
            return this._addressRoute.one('pickupaddresses').get(args).then(function (data) {
                return data.Response;
            });
        }
    }, {
        key: 'getSavedAddresses',
        value: function getSavedAddresses() {
            var _this11 = this;

            if (!this.savedAddressesPromise) {
                this.savedAddressesPromise = this._addressRoute.get().then(function (response) {
                    _this11.savedAddresses = response.Address;
                    return true;
                }, function () {
                    _this11.savedAddresses = [];
                    return false;
                });
            }
            return this.savedAddressesPromise;
        }
    }, {
        key: 'saveSelectedSavedAddress',
        value: function saveSelectedSavedAddress(address) {
            this.savedAddress.AddressId = address.AddressId;
            this.savedAddress.AddressText = address.AddressText;
            this.savedAddress.IsPrimary = address.IsPrimary;
            return this.setDeliveryAddress(address);
        }
    }, {
        key: 'isNonServicedAddress',
        value: function isNonServicedAddress(postcode, amasAddressId) {
            return this._addressRoute.one('IsNonService').get({
                Postcode: postcode,
                AmasAddressId: amasAddressId
            });
        }
    }, {
        key: 'setPartnerDeliveryAddress',
        value: function setPartnerDeliveryAddress(address) {
            var _this12 = this;

            return this._addressRoute.one('SetDelivery').one('PartnerBranch', address.PartnerBranchId).post().then(function () {
                _this12.savedAddress = address;
                _this12.trolleyService.getTrolley();
            });
        }
    }, {
        key: 'removePartnerAddressAssociation',
        value: function removePartnerAddressAssociation(branchId, addressId) {
            return this._addressRoute.post('DeletePartnerBranchAssociation', {
                PartnerBranchId: branchId,
                PartnerBranchAddressId: addressId
            });
        }
    }, {
        key: 'addressOnType',
        value: function addressOnType() {
            var _this13 = this;

            var searchTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.autoAddressSearchTerm;

            this._clearAutoAddresses();
            return this.search(searchTerm).then(function (response) {
                return response ? _this13.autoAddresses : [];
            });
        }
    }, {
        key: 'addressOnSelectNonService',
        value: function addressOnSelectNonService(addr) {
            var _this14 = this;

            this.nonServicedAddressResult = false;
            this.autoAddressSource = addr.source;
            this.isNonServicedAddress(addr.Postcode, addr.Id).then(function (data) {
                if (data.IsNonServiced) {
                    _this14.nonServicedAddressResult = true;
                }
                if (addr && addr.Id !== 'n/a') {
                    _this14._clearAutoAddresses();
                    _this14.autoAddressSearchTerm = addr.Text;
                }
            });
        }
    }]);

    return AddressService;
}();

AddressService.$inject = ['$timeout', '$q', 'Restangular', 'TrolleyService'];

module.exports = AddressService;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function PickupAddressSearchService(Restangular, storeService) {
    this.storeService = storeService;

    this._storeRoute = Restangular.one('PickupStores');

    this._cache = {};

    this.searchModes = {
        suburbs: 'suburbs',
        stores: 'stores',
        states: 'states'
    };
}

PickupAddressSearchService.prototype.searchByPostcode = function (args) {
    if (!(args.postcode in this._cache)) {
        this._cache[args.postcode] = this._storeRoute.one('Search').get(args);
    }

    return this._cache[args.postcode];
};

PickupAddressSearchService.prototype.searchByGeolocation = function (position) {
    return this._storeRoute.one('Search').get(position);
};

PickupAddressSearchService.prototype.searchSuburbs = _.memoize(function (searchTerm) {
    return this.storeService.searchSuburbs(searchTerm);
});

PickupAddressSearchService.prototype.invalidate = function () {
    this._cache = {};
};

module.exports = PickupAddressSearchService;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($rootScope, Restangular) {
    function StateService() {
        this._api = Restangular.one('states');
    }

    var statesPromise = void 0;
    StateService.prototype.getStates = function () {
        if (statesPromise) {
            return statesPromise;
        }

        statesPromise = this._api.get().then(function (states) {
            return states.plain();
        });

        return statesPromise;
    };

    StateService.prototype.invalidate = function () {
        statesPromise = null;
    };

    return new StateService();
};

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(1019),
    deliveryWizardComponentDefinition = _require.deliveryWizardComponentDefinition;

var _require2 = __webpack_require__(1021),
    expressDeliveryAlertControllerDefinition = _require2.expressDeliveryAlertControllerDefinition;

angular.module('wowApp.fulfilment').component('wowDeliveryWizard', deliveryWizardComponentDefinition).component('wowExpressDeliveryAlert', expressDeliveryAlertControllerDefinition);

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeliveryWizardController = function () {
    function DeliveryWizardController($q, addressService, timeslotService, shopperService, loginService, fulfilmentSteps, sessionStorage, settings) {
        _classCallCheck(this, DeliveryWizardController);

        this.$q = $q;
        this.addressService = addressService;
        this.timeslotService = timeslotService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.fulfilmentSteps = fulfilmentSteps;
        this.sessionStorage = sessionStorage;
        this.settings = settings;

        this.timeTable = undefined;
        this.sessionStorageKey = 'login:trigger';
        this.saveAddressError = null;
    }

    _createClass(DeliveryWizardController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.currentAddress) {
                this.fetchTimeslots(this.currentAddress);
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.isActive && changes.isActive.currentValue === false) {
                if (this.currentStep === this.fulfilmentSteps.address) {
                    this.decideAddressLater();
                } else if (this.currentStep === this.fulfilmentSteps.timeslot) {
                    this.decideTimeLater();
                }
            }
        }
    }, {
        key: 'fetchTimeslots',
        value: function fetchTimeslots(address) {
            var _this = this;

            this.timeTable = [];
            this.timeslotService.listTimeslots(address.AreaId, 'Courier', address.SuburbId, address.AddressId, this.shouldGetDynamicTimetable).then(function (dates) {
                _this.reservedWindow = _this.timeslotService.findReservedWindow(dates);
                _this.timeTable = dates.length === 0 ? null : dates;
                return dates;
            });
        }
    }, {
        key: 'loginToSaveAddress',
        value: function loginToSaveAddress(loginCallback) {
            var _this2 = this;

            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToSetDeliveryOrPickupAddressMessage, undefined, undefined, undefined, function () {
                    if (_this2.allowDecideLater) {
                        _this2.sessionStorage.set(_this2.sessionStorageKey, 'GuestLoginToSaveAddress');
                    }
                    return loginCallback();
                });
            }
            return loginCallback();
        }
    }, {
        key: 'saveNewManualAddressForDelivery',
        value: function saveNewManualAddressForDelivery(address) {
            var _this3 = this;

            return this.loginToSaveAddress(function () {
                return _this3.addressService.saveManualAddress(address).then(function (addressResponse) {
                    return _this3.saveAddressForDeliveryCallback(addressResponse);
                });
            });
        }
    }, {
        key: 'saveNewAutoAddressForDelivery',
        value: function saveNewAutoAddressForDelivery(address) {
            var _this4 = this;

            return this.loginToSaveAddress(function () {
                return _this4.addressService.saveAutoAddress(address).then(function (addressResponse) {
                    return _this4.saveAddressForDeliveryCallback(addressResponse);
                });
            });
        }
    }, {
        key: 'saveAddressForDeliveryCallback',
        value: function saveAddressForDeliveryCallback(addressResponse) {
            this.saveAddressError = null;
            if (addressResponse && addressResponse.Address) {
                return this.addressSelected(addressResponse.Address);
            } else if (this.addressService.savedError && this.addressService.savedError.ErrorMessage) {
                this.saveAddressError = this.addressService.savedError.ErrorMessage + ' Alternatively you could choose pick up.';
            }
            return this.$q.reject(this.addressService.savedError);
        }
    }, {
        key: 'setDeliveryAddress',
        value: function setDeliveryAddress(address) {
            this.addressSelected(address);
        }
    }, {
        key: 'addressSelected',
        value: function addressSelected(address) {
            this.saveAddressError = null;
            this.currentAddress = address;
            this.changes();

            if (this.allowDecideLater && !this.settings.fulfilmentTimetable.showTimesWhenAllowDecideLater) {
                this.decideTimeLater();
            } else {
                this.fetchTimeslots(this.currentAddress);
                this.currentStep = this.fulfilmentSteps.timeslot;
            }
        }
    }, {
        key: 'decideAddressLater',
        value: function decideAddressLater() {
            this.currentAddress = null;
            this.selectedDate = null;
            this.selectedTime = null;
            this.finish();
        }
    }, {
        key: 'setDate',
        value: function setDate(date) {
            this.selectedDate = date;
        }
    }, {
        key: 'setTime',
        value: function setTime(time) {
            this.selectedTime = time;
            this.finish();
        }
    }, {
        key: 'decideTimeLater',
        value: function decideTimeLater() {
            this.selectedDate = null;
            this.selectedTime = null;
            this.finish();
        }
    }, {
        key: 'changes',
        value: function changes() {
            this.onFulfilmentChange(this.getCurrentFulfilmentInfo());
        }
    }, {
        key: 'finish',
        value: function finish() {
            this.onFulfilmentSelected(this.getCurrentFulfilmentInfo());
        }
    }, {
        key: 'getCurrentFulfilmentInfo',
        value: function getCurrentFulfilmentInfo() {
            return {
                fulfilmentInfo: {
                    address: this.currentAddress,
                    fulfilmentMethod: 'Courier', // matches the enum in the api
                    fulfilmentWindow: {
                        date: this.selectedDate,
                        time: this.selectedTime
                    }
                }
            };
        }
    }]);

    return DeliveryWizardController;
}();

DeliveryWizardController.$inject = ['$q', 'AddressService', 'FulfilmentTimeslotService', 'ShopperService', 'LoginService', 'FulfilmentSteps', 'SessionStorageWrapper', 'Settings'];

var deliveryWizardComponentDefinition = {
    controller: DeliveryWizardController,
    bindings: {
        onFulfilmentSelected: '&',
        onFulfilmentChange: '&',
        currentAddress: '<?',
        currentTimeslot: '<?',
        allowDecideLater: '<?',
        currentStep: '=',
        isActive: '<',
        shouldGetDynamicTimetable: '<?',
        isNewFulfilmentMethodSelector: '<?'
    },
    template: __webpack_require__(1020).trim()
};

module.exports = {
    DeliveryWizardController: DeliveryWizardController,
    deliveryWizardComponentDefinition: deliveryWizardComponentDefinition
};

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports = "<fieldset ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.address\" id=\"fulfilmentAddress\" class=\"deliveryWizard\">\r\n    <wow-saved-addresses\r\n        heading=\"{{!$ctrl.isNewFulfilmentMethodSelector ? 'Enter a new delivery address' : 'Choose a location'}}\"\r\n        is-guest=\"$ctrl.shopperService.IsGuest\"\r\n        on-saved-address-selected=\"$ctrl.setDeliveryAddress(address)\"\r\n        on-save-new-manual-address=\"$ctrl.saveNewManualAddressForDelivery(address)\"\r\n        on-save-new-auto-address=\"$ctrl.saveNewAutoAddressForDelivery(address)\"\r\n        save-address-error=\"$ctrl.saveAddressError\"\r\n        save-address-error-title=\"Unable to deliver\"\r\n        is-new-fulfilment-method-selector=\"$ctrl.isNewFulfilmentMethodSelector\"\r\n        selected-address=\"$ctrl.currentAddress\">\r\n    </wow-saved-addresses>\r\n\r\n    <hr class=\"fulfilmentMethodWizard-separator\" ng-if=\"::$ctrl.allowDecideLater && !$ctrl.isNewFulfilmentMethodSelector\">\r\n\r\n    <button type=\"button\" ng-if=\"::$ctrl.allowDecideLater && !$ctrl.isNewFulfilmentMethodSelector\"\r\n        class=\"fulfilmentMethodWizard-button linkButton\"\r\n        ng-click=\"$ctrl.decideAddressLater()\">\r\n            I'll choose an address later\r\n    </button>\r\n</fieldset>\r\n\r\n<!-- <fieldset ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.address && $ctrl.isNewFulfilmentMethodSelector\" id=\"fulfilmentAddress\" class=\"deliveryWizard\">\r\n\r\n    <wow-delivery-address-selector-v2\r\n        id=\"fulfilmentSelector-saved-address\"\r\n        input-id=\"fulfilmentSelector-delivery\"\r\n        saved-addresses=\"$ctrl.savedAddresses\"\r\n        on-save-auto-address=\"$ctrl.saveNewAutoAddressForDelivery(address)\"\r\n        on-saved-address-selected=\"$ctrl.setDeliveryAddress(address)\"\r\n        on-save-new-manual-address=\"$ctrl.saveNewManualAddressForDelivery(address)\"\r\n        selected-address=\"$ctrl.currentAddress\"\r\n        mandatory-error=\"$ctrl.addressEmptyError\">\r\n    </wow-delivery-address-selector-v2> -->\r\n\r\n    <!-- <wow-saved-addresses\r\n        heading=\"Enter a new delivery address\"\r\n        is-guest=\"$ctrl.shopperService.IsGuest\"\r\n        on-saved-address-selected=\"$ctrl.setDeliveryAddress(address)\"\r\n        on-save-new-manual-address=\"$ctrl.saveNewManualAddressForDelivery(address)\"\r\n        on-save-new-auto-address=\"$ctrl.saveNewAutoAddressForDelivery(address)\"\r\n        save-address-error=\"$ctrl.saveAddressError\"\r\n        save-address-error-title=\"Unable to deliver\">\r\n    </wow-saved-addresses> -->\r\n\r\n    <!-- <hr class=\"fulfilmentMethodWizard-separator\" ng-if=\"::$ctrl.allowDecideLater\">\r\n\r\n    <button type=\"button\" ng-if=\"::$ctrl.allowDecideLater\"\r\n        class=\"fulfilmentMethodWizard-button linkButton\"\r\n        ng-click=\"$ctrl.decideAddressLater()\">\r\n            I'll choose an address later\r\n    </button> -->\r\n<!-- </fieldset> -->\r\n\r\n<fieldset class=\"fulfilmentMethodWizard-timetable\" id=\"fulfilmentTimetable\" ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.timeslot\">\r\n    <wow-fulfilment-timetable\r\n        time-table=\"$ctrl.timeTable\"\r\n        reserved-date=\"$ctrl.reservedWindow.date\"\r\n        reserved-time=\"$ctrl.reservedWindow.time\"\r\n        on-set-fulfilment-date=\"$ctrl.setDate(selectedDate)\"\r\n        on-set-fulfilment-time=\"$ctrl.setTime(fulfilmentTime)\"\r\n        is-delivery=\"true\">\r\n    </wow-fulfilment-timetable>\r\n\r\n    <button type=\"button\" ng-if=\"::$ctrl.allowDecideLater\"\r\n        class=\"fulfilmentMethodWizard-button linkButton\"\r\n        ng-click=\"$ctrl.decideTimeLater()\">\r\n            I'll choose a time later\r\n    </button>\r\n</fieldset>\r\n"

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpressDeliveryAlertController = function () {
    function ExpressDeliveryAlertController(settings) {
        _classCallCheck(this, ExpressDeliveryAlertController);

        this.settings = settings;
    }

    _createClass(ExpressDeliveryAlertController, [{
        key: 'closeAlert',
        value: function closeAlert() {
            this.closed = true;
        }
    }]);

    return ExpressDeliveryAlertController;
}();

ExpressDeliveryAlertController.$inject = ['Settings'];

var expressDeliveryAlertControllerDefinition = {
    controller: ExpressDeliveryAlertController,
    template: __webpack_require__(1022).trim()
};

module.exports = {
    ExpressDeliveryAlertController: ExpressDeliveryAlertController,
    expressDeliveryAlertControllerDefinition: expressDeliveryAlertControllerDefinition
};

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"!$ctrl.closed\" class=\"expressDeliveryAlert\">\r\n    <a ng-click=\"$ctrl.closeAlert()\" href=\"javascript:\">\r\n        <i class=\"iconww-Cross expressDeliveryAlert-close-button\"></i>\r\n    </a>\r\n    <i class=\"icon-alert_exclamation expressDeliveryAlert-icon\"></i>\r\n    <div class=\"expressDeliveryAlert-content\">\r\n        <div class=\"expressDeliveryAlert-content-title\">Delivery Now</div>\r\n        <p class=\"expressDeliveryAlert-content-text\">{{ $ctrl.settings.deliveryWindowAlerts.expressDeliveryUnavailableMessage }}</p>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(1024),
    pickupWizardComponentDefinition = _require.pickupWizardComponentDefinition;

var _require2 = __webpack_require__(1026),
    pickUpAddressSelectorComponentDefinition = _require2.pickUpAddressSelectorComponentDefinition;

angular.module('wowApp.fulfilment').component('wowPickupWizard', pickupWizardComponentDefinition).component('wowPickupAddressSelectorV2', pickUpAddressSelectorComponentDefinition);

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PickupWizardController = function () {
    function PickupWizardController(addressService, timeslotService, fulfilmentSteps, loginService, shopperService, sessionStorage, settings) {
        _classCallCheck(this, PickupWizardController);

        this.addressService = addressService;
        this.timeslotService = timeslotService;
        this.fulfilmentSteps = fulfilmentSteps;
        this.loginService = loginService;
        this.shopperService = shopperService;
        this.sessionStorage = sessionStorage;
        this.settings = settings;

        this.timeTable = [];
        this.hasFinished = false;
        this.sessionStorageKey = 'login:trigger';
    }

    _createClass(PickupWizardController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.currentAddress) {
                this.fetchTimeslots(this.currentAddress.AreaId);
            }

            if (this.currentTimeslot) {
                this.selectedDate = this.currentTimeslot.Date;
                this.selectedTime = this.currentTimeslot.Time;
            }

            var primaryAddress = this.addressService.getPrimaryAddress();

            this.selectedBillingAddressId = primaryAddress ? primaryAddress.AddressId : null;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.isActive) {
                if (changes.isActive.currentValue) {
                    this.hasFinished = false;
                } else if (!this.hasFinished) {
                    if (this.currentStep === this.fulfilmentSteps.address) {
                        this.decideAddressLater();
                    } else if (this.currentStep === this.fulfilmentSteps.timeslot) {
                        this.decideTimeLater();
                    }
                }
            }
        }
    }, {
        key: 'ensureLoggedIn',
        value: function ensureLoggedIn(callback) {
            var _this = this;

            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToSetDeliveryOrPickupAddressMessage, undefined, undefined, undefined, function () {
                    if (_this.allowDecideLater) {
                        _this.sessionStorage.set(_this.sessionStorageKey, 'GuestLoginToSaveAddress');
                    }
                    callback();
                });
            } else {
                callback();
            }
        }
    }, {
        key: 'setCollectionAddress',
        value: function setCollectionAddress(address) {
            var _this2 = this;

            this.ensureLoggedIn(function () {
                _this2.currentAddress = address;
                _this2.change();

                if (_this2.allowDecideLater && !_this2.settings.fulfilmentTimetable.showTimesWhenAllowDecideLater) {
                    _this2.decideTimeLater();
                } else {
                    _this2.fetchTimeslots(address.AreaId);
                    _this2.currentStep = _this2.fulfilmentSteps.timeslot;
                }
            });
        }
    }, {
        key: 'fetchTimeslots',
        value: function fetchTimeslots(areaId) {
            var _this3 = this;

            this.timeslotService.listTimeslots(areaId, 'Pickup').then(function (dates) {
                _this3.reservedWindow = _this3.timeslotService.findReservedWindow(dates);
                _this3.timeTable = dates;
                return dates;
            });
        }
    }, {
        key: 'decideAddressLater',
        value: function decideAddressLater() {
            this.currentAddress = null;
            this.selectedTime = null;
            this.selectedDate = null;
            this.finish();
        }
    }, {
        key: 'setDate',
        value: function setDate(date) {
            this.selectedDate = date;
        }
    }, {
        key: 'setTime',
        value: function setTime(time) {
            this.selectedTime = time;
            if (this.shouldShowBilling && !this.addressService.getPrimaryAddress()) {
                this.change();
                this.currentStep = this.fulfilmentSteps.billing;
            } else {
                this.finish();
            }
        }
    }, {
        key: 'decideTimeLater',
        value: function decideTimeLater() {
            this.selectedTime = null;
            this.selectedDate = null;
            this.finish();
        }
    }, {
        key: 'saveNewManualAddressForBilling',
        value: function saveNewManualAddressForBilling(address) {
            var _this4 = this;

            this.addressService.saveNewManualAddressForBilling(address).then(function (addressResponse) {
                _this4.selectedBillingAddressId = addressResponse.Address.AddressId;
                _this4.finish();
            });
        }
    }, {
        key: 'saveNewAutoAddressForBilling',
        value: function saveNewAutoAddressForBilling(address) {
            var _this5 = this;

            this.addressService.saveNewAutoAddressForBilling(address).then(function (addressResponse) {
                _this5.selectedBillingAddressId = addressResponse.Address.AddressId;
                _this5.finish();
            });
        }
    }, {
        key: 'setSavedAddressAsBilling',
        value: function setSavedAddressAsBilling(address) {
            this.selectedBillingAddressId = address.AddressId;
            this.finish();
        }
    }, {
        key: 'change',
        value: function change() {
            this.onFulfilmentChange(this.getFulfilmentInfo());
        }
    }, {
        key: 'finish',
        value: function finish() {
            this.hasFinished = true;
            this.onFulfilmentSelected(this.getFulfilmentInfo());
        }
    }, {
        key: 'getFulfilmentInfo',
        value: function getFulfilmentInfo() {
            return {
                fulfilmentInfo: {
                    address: this.currentAddress,
                    fulfilmentMethod: 'Pickup',
                    fulfilmentWindow: {
                        date: this.selectedDate,
                        time: this.selectedTime
                    },
                    billingAddressId: this.selectedBillingAddressId
                }
            };
        }
    }]);

    return PickupWizardController;
}();

PickupWizardController.$inject = ['AddressService', 'FulfilmentTimeslotService', 'FulfilmentSteps', 'LoginService', 'ShopperService', 'SessionStorageWrapper', 'Settings'];

var pickupWizardComponentDefinition = {
    controller: PickupWizardController,
    bindings: {
        shouldShowBilling: '<?',
        onFulfilmentSelected: '&',
        onFulfilmentChange: '&',
        allowDecideLater: '<?',
        currentAddress: '<?',
        currentTimeslot: '<?',
        currentStep: '=',
        isActive: '<',
        isNewFulfilmentMethodSelector: '<?'
    },
    template: __webpack_require__(1025).trim()
};

module.exports = {
    PickupWizardController: PickupWizardController,
    pickupWizardComponentDefinition: pickupWizardComponentDefinition
};

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports = "<fieldset ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.address && !$ctrl.isNewFulfilmentMethodSelector\" id=\"fulfilmentAddress\">\r\n    <legend class=\"pickupWizard-legend pickupWizard-search\">\r\n        Find your local supermarket\r\n    </legend>\r\n\r\n    <wow-pickup-address\r\n        class=\"pickupWizard-storeSelector\"\r\n        id=\"fulfilment-pickup-address\"\r\n        set-pickup-address=\"$ctrl.setCollectionAddress(addr)\">\r\n    </wow-pickup-address>\r\n\r\n    <hr class=\"pickupWizard-separator\" ng-if=\"::$ctrl.allowDecideLater\">\r\n\r\n    <button type=\"button\" ng-if=\"::$ctrl.allowDecideLater\"\r\n            class=\"pickupWizard-button linkButton\"\r\n            ng-click=\"$ctrl.decideAddressLater()\">\r\n        I'll choose a store later\r\n    </button>\r\n</fieldset>\r\n\r\n<fieldset class=\"pickupWizardV2\" ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.address && $ctrl.isNewFulfilmentMethodSelector\" id=\"fulfilmentAddress\">\r\n    <legend class=\"pickupWizardV2-legend\">\r\n        Choose a store\r\n    </legend>\r\n\r\n\r\n\r\n    <!-- pick up stores search section -->\r\n    <wow-pickup-address-selector-v2\r\n        id=\"fulfilmentSelector-pickup-address\"\r\n        input-id=\"fulfilmentSelector-pickup\"\r\n        set-pickup-address=\"$ctrl.setCollectionAddress(addr)\"\r\n        selected-address=\"$ctrl.currentAddress\">\r\n    </wow-pickup-address-selector-v2>\r\n\r\n</fieldset>\r\n\r\n<fieldset ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.timeslot\">\r\n    <wow-fulfilment-timetable\r\n        time-table=\"$ctrl.timeTable\"\r\n        reserved-date=\"$ctrl.reservedWindow.date\"\r\n        reserved-time=\"$ctrl.reservedWindow.time\"\r\n        on-set-fulfilment-date=\"$ctrl.setDate(selectedDate)\"\r\n        on-set-fulfilment-time=\"$ctrl.setTime(fulfilmentTime)\"\r\n        is-delivery=\"false\">\r\n    </wow-fulfilment-timetable>\r\n\r\n    <button type=\"button\" ng-if=\"::$ctrl.allowDecideLater\"\r\n        class=\"pickupWizard-button linkButton\"\r\n        ng-click=\"$ctrl.decideTimeLater()\">\r\n            I'll choose a time later\r\n    </button>\r\n</fieldset>\r\n\r\n<div ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.billing\" id=\"fulfilmentBillingAddress\">\r\n    <wow-saved-addresses\r\n        heading=\"Enter your billing address\"\r\n        is-guest=\"$ctrl.shopperService.IsGuest\"\r\n        on-saved-address-selected=\"$ctrl.setSavedAddressAsBilling(address)\"\r\n        on-save-new-manual-address=\"$ctrl.saveNewManualAddressForBilling(address)\"\r\n        on-save-new-auto-address=\"$ctrl.saveNewAutoAddressForBilling(address)\">\r\n    </wow-saved-addresses>\r\n\r\n    <hr class=\"pickupWizard-separator\" ng-if=\"::$ctrl.allowDecideLater\">\r\n\r\n    <button type=\"button\" ng-if=\"::$ctrl.allowDecideLater\"\r\n        class=\"pickupWizard-button linkButton\"\r\n        ng-click=\"$ctrl.decideBillingAddressLater()\">\r\n            I'll choose a billing address later\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isEmpty = _require.isEmpty;

var LatLng = __webpack_require__(15);
var TealiumEventBuilder = __webpack_require__(9);

var PickUpAddressSelectorController = function () {
    function PickUpAddressSelectorController($q, $timeout, settings, analyticsService, locationService, pickupAddressSearchService, moveFocus, fulfilmentService) {
        _classCallCheck(this, PickUpAddressSelectorController);

        this.$q = $q;
        this.$timeout = $timeout;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.locationService = locationService;
        this.pickupAddressSearchService = pickupAddressSearchService;
        this.moveFocus = moveFocus;
        this.fulfillmentService = fulfilmentService;
    }

    _createClass(PickUpAddressSelectorController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.pickupStores = [];
            this.locationSearchText = this.settings.fulfilmentSelector.searchByCurrentLocationLabel;

            this.currentLocation = this.locationService.latlng;
            this.isGeolocationEnabled = !isEmpty(this.locationService.latlng);

            this.locationService.getCurrentLocation().then(function (location) {
                _this.currentLocation = location;
                _this.isGeolocationEnabled = !!location;
            }, function () {
                _this.currentLocation = null;
                _this.isGeolocationEnabled = false;
            });

            this.storesPerPage = this.settings.fulfilmentSelector.pickupStoresPerPage;
            this.numberOfStoresToShow = this.storesPerPage;

            this.selectedStoreText = this.selectedAddress ? this.selectedAddress.AddressText : '';
            // this.screenName = 'FulfilmentSelection';
            // const event = new TealiumEventBuilder()
            //     .withScreenName(this.screenName)
            //     .withLabel('Fulfilment type toggle')
            //     .withValue('Pickup')
            //     .withEventName('modal_view')
            //     .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            //     .withTrackingType('link')
            //     .build();

            // this.analyticsService.push(event);

            // this.fulfilmentSelectorService.subscribeEscPushAnalytics(this.analyticsService, this.screenName);
        }
    }, {
        key: 'onSuburbSelected',
        value: function onSuburbSelected(suburb) {
            if (!isEmpty(suburb)) {
                if (!suburb.AddressText) {
                    this.suburbs = [];
                    var element = document.getElementById('suburb-' + this.inputId);
                    element.value = suburb.PostCode;
                    this.$timeout(function () {
                        if (typeof Event === 'function') {
                            element.dispatchEvent(new Event('change'));
                        } else {
                            var event = document.createEvent('Event');
                            event.initEvent('change', false, true);
                            element.dispatchEvent(event);
                        }
                    }, 50);
                } else {
                    this.onSelectStore(suburb);
                }
            }
        }
    }, {
        key: 'onClickGeo',
        value: function onClickGeo($event) {
            $event.preventDefault();
            this.moveFocus('#suburb-' + this.inputId);
            if (this.suburbText) {
                return;
            }
            if (this.isGeolocationEnabled) {
                var element = document.getElementById('suburb-' + this.inputId);
                element.value = this.locationSearchText;
                this.$timeout(function () {
                    element.dispatchEvent(new Event('change'));
                }, 50);
            }
        }
    }, {
        key: 'suburbOnType',
        value: function suburbOnType() {
            var _this2 = this;

            if (!!this.suburbText && this.suburbText.length >= this.settings.fulfilmentSelector.numberOfKeystrokesToTriggerSearch) {
                return this.performSearch(this.suburbText).then(function (response) {
                    return response ? _this2.suburbs : _this2.pickupStores;
                });
            }

            this.selectedAddress = null;

            return this.$q.defer().promise;
        }
    }, {
        key: 'performSearch',
        value: function performSearch(searchTerm) {
            if (searchTerm === this.locationSearchText && this.isGeolocationEnabled) {
                searchTerm = this.currentLocation;
            }

            if (searchTerm instanceof LatLng) {
                return this.searchStoresByGeolocation(searchTerm);
            }

            if (isNaN(searchTerm)) {
                return this.searchSuburbs(searchTerm);
            }

            return this.searchStoresByPostcode(searchTerm);
        }
    }, {
        key: 'searchSuburbs',
        value: function searchSuburbs(searchTerm) {
            var _this3 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.suburbs;
            return this.pickupAddressSearchService.searchSuburbs(searchTerm).then(function (suburbs) {
                _this3.suburbs = suburbs;
                return true;
            });
        }
    }, {
        key: 'searchStoresByPostcode',
        value: function searchStoresByPostcode(postcode) {
            var _this4 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.stores;
            return this.pickupAddressSearchService.searchByPostcode({ postcode: postcode }).then(function (pickupStores) {
                _this4.setStores(pickupStores);
                _this4.suburbs = [];
                return false;
            });
        }
    }, {
        key: 'searchStoresByGeolocation',
        value: function searchStoresByGeolocation(position) {
            var _this5 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.stores;
            return this.pickupAddressSearchService.searchByGeolocation(position).then(function (pickupStores) {
                _this5.setStores(pickupStores);
                _this5.suburbs = [];
                return false;
            });
        }
    }, {
        key: 'setStores',
        value: function setStores(stores) {
            this.pickupStores = stores;
            this.selectedStore = null;
            this.selectedStoreText = null;
        }
    }, {
        key: 'getSuburbText',
        value: function getSuburbText(item) {
            return item.SuburbStateString ? item.SuburbStateString : item.AddressText;
        }
    }, {
        key: 'clearSearch',
        value: function clearSearch(input) {
            if (input) {
                this.suburbText = null;
                this.selectedSuburb = null;
            }
            if (!input) {
                this.selectedStoreText = null;
                this.selectedStore = null;
                this.selectedAddress = null;
            }
            this.moveFocus('#suburb-' + this.inputId);
        }
    }, {
        key: 'onSelectStore',
        value: function onSelectStore(store) {
            if (this.selectedAddress && this.selectedAddress.AddressId !== store.AddressId) {
                var event = new TealiumEventBuilder().withScreenName(this.screenName).withLabel('Pickup store change').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withEventName('modal_interaction').withTrackingType('link').build();

                this.analyticsService.push(event);
            }
            this.selectedStore = store.AddressId;
            this.selectedStoreText = store.AddressText;
            this.suburbText = null;
            this.selectedSuburb = null;
            this.pickupStores = [];
            this.setPickupAddress({ addr: store });
            this.moveFocus('.fulfilmentSelectorDialog-button');
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            // this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
        }
    }, {
        key: 'onSelectedFocus',
        value: function onSelectedFocus($event) {
            var element = $event.currentTarget;
            if (element.selectionStart === 0 && element.selectionEnd === element.value.length) {
                this.$timeout(function () {
                    element.setSelectionRange(0, element.value.length);
                }, 1);
            } else {
                element.setSelectionRange(0, element.value.length);
            }
        }
    }, {
        key: 'onSelectedKeypress',
        value: function onSelectedKeypress($event) {
            var _this6 = this;

            var inp = String.fromCharCode($event.keyCode);
            if ($event.keyCode === 37 || $event.keyCode === 38 || $event.keyCode === 39 || $event.keyCode === 40 || $event.keyCode === 36 || $event.keyCode === 35) {
                // Arrow keys + page up/down
                this.onSelectedFocus($event);
            } else if ($event.keyCode === 27 || $event.keyCode === 8 || $event.keyCode === 46 || $event.keyCode === 9) {
                // Allow esc/bck/del/Tab keys
            } else if ($event.keyCode === 32) {
                // space
                $event.stopPropagation();
                this.moveFocus('#suburb-' + this.inputId);
            } else if (/[a-zA-Z0-9-_ ]/.test(inp)) {
                // All other keys should do nothing
                var element = $event.currentTarget;
                element.value = '';
                this.suburbText = String.fromCharCode($event.keyCode);
                this.$timeout(function () {
                    element.dispatchEvent(new Event('change'));
                    _this6.moveFocus('#suburb-' + _this6.inputId);
                }, 50);
                $event.stopPropagation();
                $event.preventDefault();
            } else {
                // All other keys should do nothing
                $event.preventDefault();
            }
        }
    }]);

    return PickUpAddressSelectorController;
}();

PickUpAddressSelectorController.$inject = ['$q', '$timeout', 'Settings', 'AnalyticsService', 'LocationService', 'PickupAddressSearchService', 'MoveFocus', 'FulfilmentService'];

var pickUpAddressSelectorComponentDefinition = {
    bindings: {
        inputId: '@',
        classModifier: '@?',
        setPickupAddress: '&',
        selectedAddress: '=?',
        mandatoryError: '<?'
    },
    controller: PickUpAddressSelectorController,
    template: __webpack_require__(1027).trim()
};

module.exports = {
    PickUpAddressSelectorController: PickUpAddressSelectorController,
    pickUpAddressSelectorComponentDefinition: pickUpAddressSelectorComponentDefinition
};

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pickupSelectorV2\">\r\n    <ng-form ng-switch=\"!!$ctrl.selectedStore\">\r\n        <div ng-switch=\"!!$ctrl.selectedStoreText\" class=\"pickupSelectorV2-inputContainer\">\r\n            <wow-input-container ng-switch-when=\"true\">\r\n                <label for=\"pickupSelectorAddress-selectedStore\">\r\n                    {{ ::$ctrl.settings.fulfilmentSelector.pickupStoreInputLabel }}\r\n                </label>\r\n                <input\r\n                    id=\"pickupSelectorAddress-selectedStore\"\r\n                    class=\"pickupSelectorV2-input adjustment\"\r\n                    type=\"text\"\r\n                    dropdown-class=\"pickupSelectorV2-searchAutocompleteDropdown\"\r\n                    ng-focus=\"$ctrl.onSelectedFocus($event)\"\r\n                    ng-click=\"$ctrl.onSelectedFocus($event)\"\r\n                    ng-keypress=\"$ctrl.onSelectedKeypress($event)\"\r\n                    ng-model=\"$ctrl.selectedStoreText\"\r\n                    autocomplete=\"off\"/>\r\n                <button\r\n                    type=\"button\"\r\n                    class=\"pickupSelectorV2-inputButton\"\r\n                    ng-click=\"$ctrl.clearSearch()\">\r\n                    <span class=\"sr-only\">Reset search</span>\r\n                    <i class=\"icon-close_x\"></i>\r\n                </button>\r\n            </wow-input-container>\r\n            <wow-input-container ng-switch-when=\"false\" ng-class=\"{'error': $ctrl.mandatoryError}\">\r\n                <label for=\"pickupSelectorAddress-storeSearch\">\r\n                    <span>Search for Pick up location *</span>\r\n                </label>\r\n                <oly-autocomplete\r\n                    input-id=\"suburb-{{$ctrl.inputId}}\"\r\n                    input-name=\"suburb\"\r\n                    text=\"$ctrl.suburbText\"\r\n                    items=\"$ctrl.suburbOnType()\"\r\n                    item-text=\"$ctrl.getSuburbText\"\r\n                    selected-item=\"$ctrl.selectedSuburb\"\r\n                    run-on-select=\"$ctrl.onSuburbSelected($ctrl.selectedSuburb)\"\r\n                    is-required=\"true\"\r\n                    search-box-class=\"pickupSelectorV2-searchAutocompleteTextField suburb\"\r\n                    dropdown-class=\"pickupSelectorV2-searchAutocompleteDropdown suburb\"\r\n                    show-clear-button=\"true\"\r\n                    action-button-wrapper-class=\"pickupSelectorV2-searchAutocompleteActionsWrapper suburb\"\r\n                    action-button-class=\"pickupSelectorV2-searchAutocompleteClearButton suburb\"\r\n                    item-class=\"{{$ctrl.searchMode}}\"\r\n                    min-length=\"4\">\r\n                    <autocomplete-item>\r\n                            <div  ng-show=\"item.AddressText && item.Street1\" class=\"pickupSelectorV2-store\">\r\n                                    <p class=\"pickupSelectorV2-storeDescription\">{{ ::item.AddressText }}</p>\r\n                                    <address class=\"pickupSelectorV2-storeAddress\">{{ ::item.Street1 }}</address>\r\n                            </div>\r\n                            <span class=\"pickupSelectorV2-storeDistance\" ng-show=\"item.Distance\">{{ ::item.Distance + 'km' }}</span>\r\n                            {{ ::item.SuburbStateString }}\r\n                    </autocomplete-item>\r\n                    <autocomplete-not-found class=\"pickupSelectorV2-NotFound suburb\">\r\n                        {{ $ctrl.searchMode == $ctrl.pickupAddressSearchService.searchModes.suburbs ?  'No suburb found.' : 'No stores found.' }}\r\n                        <button\r\n                            type=\"button\"\r\n                            class=\"pickupSelectorV2-button linkButton suburb\"\r\n                            ng-click=\"$ctrl.clearSearch($ctrl.suburbText)\" oly-move-focus=\"fulfilmentSelectorManualAddress-street1 suburb\">\r\n                            Reset Search\r\n                        </button>\r\n                    </autocomplete-not-found>\r\n                </oly-autocomplete>\r\n\r\n                <button\r\n                    id=\"pickupSelectorV2-geoLocationButton\"\r\n                    class=\"pickupSelectorV2Search-geoLocationButton\"\r\n                    ng-show=\"!$ctrl.suburbText\"\r\n                    ng-disabled=\"!$ctrl.isGeolocationEnabled\"\r\n                    ng-click=\"$ctrl.onClickGeo($event)\" aria-role=\"button\" >\r\n                    <span class=\"sr-only\">Find pick up addresses near me</span>\r\n                    <i ng-if=\"!$ctrl.isGeolocationEnabled\" class=\"iconww-unavailable pickupSelectorV2-geoLocationButton--disabled\" style=\"cursor: default;\"></i>\r\n                    <i ng-if=\"$ctrl.isGeolocationEnabled\" class=\"iconww-selected pickupSelectorV2-geoLocationButton--enabled\"></i>\r\n                </button>\r\n\r\n                <div role=\"alert\" class=\"pickupSelectorV2-addressEmpty\">\r\n                    <span ng-if=\"$ctrl.mandatoryError\"><span class=\"sr-only\">A Pickup </span>{{ ::$ctrl.settings.fulfilmentSelector.locationRequiredError }}</span>\r\n                </div>\r\n            </wow-input-container>\r\n        </div>\r\n    </ng-form>\r\n</div>\r\n"

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(1029),
    fulfilmentMethodWizardComponentDefinition = _require.fulfilmentMethodWizardComponentDefinition;

var _require2 = __webpack_require__(1031),
    fulfilmentMethodWizardComponentDefinitionV2 = _require2.fulfilmentMethodWizardComponentDefinitionV2;

angular.module('wowApp.fulfilment').component('wowFulfilmentMethodWizard', fulfilmentMethodWizardComponentDefinition).component('wowFulfilmentMethodWizardV2', fulfilmentMethodWizardComponentDefinitionV2).constant('FulfilmentSteps', Object.freeze({
    fulfilmentMethod: 'FULFILMENT_METHOD',
    address: 'ADDRESS',
    timeslot: 'TIMESLOT',
    billing: 'BILLING'
}));

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RESERVATION_MESSAGE_KEY = 'windowReservationMessage';

var FulfilmentMethodWizardController = function () {
    function FulfilmentMethodWizardController($scope, $window, $timeout, settings, moveFocus, sessionStorage, loadingIndicatorService, shopperService, fulfilmentService, addressService, loginService, shopPageStateService) {
        _classCallCheck(this, FulfilmentMethodWizardController);

        this.$scope = $scope;
        this.$window = $window;
        this.$timeout = $timeout;
        this.settings = settings;
        this.sessionStorage = sessionStorage;
        this.loadingIndicatorService = loadingIndicatorService;
        this.shopperService = shopperService;
        this.fulfilmentService = fulfilmentService;
        this.addressService = addressService;
        this.loginService = loginService;
        this.moveFocus = moveFocus;
        this.shopPageStateService = shopPageStateService;
    }

    _createClass(FulfilmentMethodWizardController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // The watchers below open method selection panel or fulfilment timetable when a certain event is fired.
            //
            // This is needed for the cart component and the checkout component to trigger the fulfilment method wizard to change the state when
            // errors, such as delivery window/method restricted products cannot be delivered, occurs in the process. The problem is that the
            // components responsible for the trigger is not a direct parent/child of the wizard, which make it difficult to manage the dataflow.
            //
            // All events listed should be fired from the fulfilment service only. Please refer to fulfilment.service.js for its usage.
            //
            // Of course, if possible please kindly avoid using events.
            this.changeMethodWatcher = this.$scope.$on('fulfilment:changeMethod', function () {
                return _this.openFulfilmentMethodSelection();
            });
            this.changeTimeslotWatcher = this.$scope.$on('fulfilment:changeTimeslot', function () {
                return _this.openTimeslots();
            });

            this.fulfilmentSteps = this.fulfilmentService.fulfilmentSteps;
            this.modalMessage = this.sessionStorage.getAndRemove(RESERVATION_MESSAGE_KEY);

            this.deliveryMethodMessage = this.settings.trolley.deliveryMethodMessage.replace(' {Firstname}', this.shopperService.IsGuest ? '' : ' ' + this.shopperService.shopper.FirstName);

            this.fulfilmentOptions = this.allowDecideLater ? this.fulfilmentService.fulfilmentOptions : this.fulfilmentService.checkoutFulfilmentOptions;

            // Make sure the wizard will go to the correct step when on checkout (allow decide later === false)
            if (!this.allowDecideLater) {
                this.$timeout(function () {
                    return _this.initializeFulfilmentStep();
                });
            }

            this.shouldShowDeliveryWindowErrorModal = this.shouldShowDeliveryWindowErrorModal !== undefined ? this.shouldShowDeliveryWindowErrorModal : true;
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            // Deregister watchers
            this.changeMethodWatcher();
            this.changeTimeslotWatcher();
        }
    }, {
        key: 'initializeFulfilmentStep',
        value: function initializeFulfilmentStep() {
            if (this.fulfilmentService.isNotSet()) {
                this.openFulfilmentMethodSelection();
            } else if (!this.fulfilmentService.savedAddress) {
                this.openAddressesSelection();
            } else if (!this.hasSelectedTimeslot()) {
                this.openTimeslots();
            }
        }
    }, {
        key: 'setFulfilmentMethod',
        value: function setFulfilmentMethod(fulfilmentMethod) {
            var _this2 = this;

            this.fulfilmentService.selectedFulfilmentMethod = fulfilmentMethod;

            this.changeAnswer(this.fulfilmentSteps.fulfilmentMethod);
            this.currentStep = this.fulfilmentSteps.fulfilmentMethod;
            this.fulfilmentService.savedAddress = null;

            this.$timeout(function () {
                _this2.currentStep = fulfilmentMethod === _this2.fulfilmentService.fulfilmentOptions.none ? null : _this2.fulfilmentSteps.address;

                if (fulfilmentMethod === _this2.fulfilmentService.fulfilmentOptions.none) {
                    _this2.fulfilmentService.clearFulfilmentInfo();
                }
            });
        }
    }, {
        key: 'ensureLoggedIn',
        value: function ensureLoggedIn(callback) {
            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToSetDeliveryOrPickupAddressMessage, undefined, undefined, undefined, callback);
            } else {
                callback();
            }
        }
    }, {
        key: 'saveFulfilment',
        value: function saveFulfilment(fulfilmentInfo) {
            var _this3 = this;

            var wasGuest = this.shopperService.IsGuest;

            if (fulfilmentInfo.address) {
                this.ensureLoggedIn(function () {
                    _this3.loadingIndicatorService.startLoading(true, _this3.settings.delivery.deliveryWindowReloadingMessage);
                    _this3.fulfilmentService.saveFulfilment(fulfilmentInfo).then(function (response) {
                        return _this3.onSaveFulfilment(response, wasGuest);
                    }).catch(function () {
                        return _this3.loadingIndicatorService.finishLoading();
                    });
                });
            } else {
                this.currentStep = null;
                this.fulfilmentService.clearAddressAndTime();
                this.shopPageStateService.isCartOpen = false;
            }
        }
    }, {
        key: 'onSaveFulfilment',
        value: function onSaveFulfilment(response, wasGuest) {
            if (wasGuest) return;

            if (response && response.Message) {
                this.sessionStorage.set(RESERVATION_MESSAGE_KEY, response.Message);
            }

            this.$window.location.reload();
        }
    }, {
        key: 'deliveryChange',
        value: function deliveryChange(fulfilmentInfo) {
            this.fulfilmentService.savedAddress = fulfilmentInfo.address;

            if (fulfilmentInfo.fulfilmentWindow) {
                this.fulfilmentService.reservedDate = fulfilmentInfo.fulfilmentWindow.date;
                this.fulfilmentService.reservedTime = fulfilmentInfo.fulfilmentWindow.time;
            }
        }
    }, {
        key: 'hasSelectedTimeslot',
        value: function hasSelectedTimeslot() {
            return !!(this.fulfilmentService.reservedDate && this.fulfilmentService.reservedTime && this.fulfilmentService.reservedDate.DateText && this.fulfilmentService.reservedTime.TimeWindow);
        }
    }, {
        key: 'selectedAddressText',
        value: function selectedAddressText() {
            return this.fulfilmentService.savedAddress ? this.fulfilmentService.savedAddress.AddressText : this.fulfilmentService.selectedFulfilmentMethod.addressText;
        }
    }, {
        key: 'billingAddressText',
        value: function billingAddressText() {
            var primaryAddress = this.addressService.getPrimaryAddress();

            return primaryAddress ? primaryAddress.AddressText : 'select billing address';
        }
    }, {
        key: 'openFulfilmentMethodSelection',
        value: function openFulfilmentMethodSelection() {
            this.changeAnswer(this.fulfilmentSteps.fulfilmentMethod);
            this.currentStep = this.fulfilmentSteps.fulfilmentMethod;
            this.fulfilmentService.savedAddress = null;
            this.moveFocus('#fulfilmentMethod');
        }
    }, {
        key: 'openAddressesSelection',
        value: function openAddressesSelection() {
            this.changeAnswer(this.fulfilmentSteps.address);
            this.currentStep = this.fulfilmentSteps.address;
            this.moveFocus('#fulfilmentAddress');
        }
    }, {
        key: 'openTimeslots',
        value: function openTimeslots() {
            this.changeAnswer(this.fulfilmentSteps.timeslot);
            this.currentStep = this.fulfilmentSteps.timeslot;
            this.moveFocus('#fulfilmentTimetable');
        }
    }, {
        key: 'openBilling',
        value: function openBilling() {
            this.changeAnswer(this.fulfilmentSteps.billing);
            this.currentStep = this.fulfilmentSteps.billing;
            this.moveFocus('#fulfilmentBillingAddress');
        }
    }, {
        key: 'changeAnswer',
        value: function changeAnswer(fulfilmentStep) {
            if (this.onChangeAnswer) {
                this.onChangeAnswer({ stepChanged: fulfilmentStep });
            }
        }
    }, {
        key: 'shouldShowBillingQuestionaire',
        value: function shouldShowBillingQuestionaire() {
            return this.shouldShowBilling && this.fulfilmentService.selectedFulfilmentMethod === this.fulfilmentService.fulfilmentOptions.pickup && this.fulfilmentService.reservedTime && this.currentStep !== this.fulfilmentSteps.address && this.currentStep !== this.fulfilmentSteps.timeslot;
        }
    }]);

    return FulfilmentMethodWizardController;
}();

FulfilmentMethodWizardController.$inject = ['$scope', '$window', '$timeout', 'Settings', 'MoveFocus', 'SessionStorageWrapper', 'LoadingIndicatorService', 'ShopperService', 'FulfilmentService', 'AddressService', 'LoginService', 'ShopPageStateService'];

var fulfilmentMethodWizardComponentDefinition = {
    bindings: {
        shouldShowBilling: '<?',
        allowDecideLater: '<',
        isActive: '<',
        onChangeAnswer: '&?',
        shouldGetDynamicTimetable: '<?',
        shouldShowDeliveryWindowErrorModal: '<?'
    },
    controller: FulfilmentMethodWizardController,
    template: __webpack_require__(1030).trim()
};

module.exports = {
    FulfilmentMethodWizardController: FulfilmentMethodWizardController,
    fulfilmentMethodWizardComponentDefinition: fulfilmentMethodWizardComponentDefinition
};

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports = "<ng-form name=\"$ctrl.fulfilmentWizard\" novalidate>\r\n    <div class=\"fulfilmentMethodWizard\" ng-class=\"{'is-editing': $ctrl.currentStep != null}\">\r\n        <div class=\"fulfilmentMethodWizard-questionnaire\">\r\n            <i class=\"fulfilmentMethodWizard-questionnaireIcon\" ng-class=\"[$ctrl.fulfilmentService.selectedFulfilmentMethod.icon, { 'is-active': !$ctrl.fulfilmentService.isDecideLater() }]\"></i>\r\n\r\n            <div>\r\n                <h4 class=\"fulfilmentMethodWizard-questionnaireHeading\">\r\n                    {{ $ctrl.fulfilmentService.canOrderBeFulfilled()\r\n                            ? $ctrl.fulfilmentService.selectedFulfilmentMethod.name + ' Confirmed'\r\n                            : $ctrl.settings.fulfilmentMethod.questionnaireHeading }}\r\n                </h4>\r\n\r\n                <p>{{ ::$ctrl.deliveryMethodMessage }}</p>\r\n\r\n                <div class=\"fulfilmentMethodWizard-questions\">\r\n\r\n                    <fieldset class=\"fulfilmentMethodWizard-choices\" id=\"fulfilmentMethod\">\r\n                        <legend class=\"fulfilmentMethodWizard-legend\">\r\n                            <span class=\"sr-only\">Select how you would like to receive your groceries.</span>\r\n                        </legend>\r\n\r\n                        <div class=\"fulfilmentMethodWizard-fulfilmentMethod\" ng-repeat=\"fulfilmentMethod in ::$ctrl.fulfilmentOptions track by fulfilmentMethod.name\">\r\n                            <div class=\"u-flex\">\r\n                                <input\r\n                                    type=\"radio\"\r\n                                    name=\"fulfilmentMethod\"\r\n                                    id=\"{{ ::fulfilmentMethod.name }}\"\r\n                                    class=\"wowRadio\"\r\n                                    ng-model=\"$ctrl.fulfilmentService.selectedFulfilmentMethod\"\r\n                                    ng-value=\"fulfilmentMethod\"\r\n                                    ng-click=\"$ctrl.fulfilmentService.clearAddressAndTime() && $ctrl.setFulfilmentMethod(fulfilmentMethod)\"\r\n                                    ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.fulfilmentService.clearAddressAndTime() && $ctrl.setFulfilmentMethod(fulfilmentMethod);\">\r\n                                <label class=\"fulfilmentMethodWizard-fulfilmentMethod-label\"\r\n                                        for=\"{{ ::fulfilmentMethod.name }}\"\r\n                                        ng-click=\"$ctrl.setFulfilmentMethod(fulfilmentMethod);\"\r\n                                        wow-event-recorder=\"click\"\r\n                                        data-er-category=\"Delivery Window\"\r\n                                        data-er-label=\"{{ ::fulfilmentMethod.name }} selected\">\r\n                                    {{ ::fulfilmentMethod.name }}\r\n                                    <div class=\"sr-only\" ng-if=\"$ctrl.settings.fulfilmentMethod.showDeliveryHint && fulfilmentMethod.isVariableSubheading\">{{ ::$ctrl.settings.fulfilmentMethod.deliveryHintText }}</div>\r\n                                </label>\r\n                                <div wow-event-recorder=\"mouseover\"\r\n                                    data-er-category=\"Delivery Window\"\r\n                                    data-er-label=\"Delivery help tip view\">\r\n                                        <oly-questionmark-tooltip\r\n                                            ng-if=\"$ctrl.settings.fulfilmentMethod.showDeliveryHint && fulfilmentMethod.isVariableSubheading\"\r\n                                            message=\"{{$ctrl.settings.fulfilmentMethod.deliveryHintText}}\"\r\n                                            custom-tooltip-class=\"'fulfilmentMethodWizard-deliveryTooltip'\">\r\n                                        </oly-questionmark-tooltip>\r\n                                </div>\r\n                            </div>\r\n                            <span\r\n                                ng-if=\"!fulfilmentMethod.isVariableSubheading || ($ctrl.fulfilmentService.selectedFulfilmentMethod === fulfilmentMethod && $ctrl.hasSelectedTimeslot())\"\r\n                                class=\"fulfilmentMethodWizard-fulfilmentMethod-subLabel\"\r\n                                role=\"status\"\r\n                                aria-live=\"polite\"\r\n                                aria-atomic=\"true\">\r\n                                {{ ::fulfilmentMethod.subheading }}\r\n                            </span>\r\n                        </div>\r\n                    </fieldset>\r\n\r\n                    <span ng-if=\"$ctrl.fulfilmentService.selectedFulfilmentMethod !== $ctrl.fulfilmentService.fulfilmentOptions.none && $ctrl.currentStep !== $ctrl.fulfilmentSteps.fulfilmentMethod\">\r\n                        {{ $ctrl.fulfilmentService.selectedFulfilmentMethod === $ctrl.fulfilmentService.fulfilmentOptions.pickup ? 'from' :'to' }}\r\n                        <a href=\"javascript://\"\r\n                            ng-click=\"$ctrl.openAddressesSelection()\"\r\n                            wow-event-recorder=\"click\"\r\n                            data-er-category=\"Delivery Window\"\r\n                            data-er-label=\"{{$ctrl.selectedAddressText().toLowerCase().indexOf('address') >= 0 ? 'Select Address' : 'Select Supermarket'}}\">\r\n                            {{ $ctrl.selectedAddressText() }}\r\n                            <i ng-class=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.address ? 'iconww-ArrowUp' : 'iconww-ArrowDown'\"></i>\r\n                        </a>\r\n                    </span>\r\n\r\n                    <span ng-if=\"$ctrl.fulfilmentService.savedAddress && $ctrl.currentStep !== $ctrl.fulfilmentSteps.address\">\r\n                        <span ng-if=\"!$ctrl.hasSelectedTimeslot() || $ctrl.currentStep === $ctrl.fulfilmentSteps.timeslot\">on</span>\r\n                        <a ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.timeslot\" href=\"javascript://\">\r\n                            select day and time\r\n                            <i class=\"iconww-ArrowUp\"></i>\r\n                        </a>\r\n                        <a ng-if=\"$ctrl.currentStep !== $ctrl.fulfilmentSteps.timeslot\"\r\n                            href=\"javascript://\"\r\n                            ng-click=\"$ctrl.openTimeslots()\"\r\n                            wow-event-recorder=\"click\"\r\n                            data-er-category=\"Delivery Window\"\r\n                            data-er-label=\"select timeslot\"\r\n                            ng-switch=\"$ctrl.hasSelectedTimeslot()\">\r\n                            <span ng-switch-when=\"true\">\r\n                                <span ng-if=\"!$ctrl.fulfilmentService.isExpress\">\r\n                                    <span ng-bind-html=\"$ctrl.fulfilmentService.reservedDate.DateText\"></span>\r\n                                    between\r\n                                </span>\r\n                                {{ $ctrl.fulfilmentService.reservedTime.TimeWindow }}\r\n                            </span>\r\n                            <span ng-switch-when=\"false\">select day and time</span>\r\n                            <i class=\"iconww-ArrowDown\"></i>\r\n                        </a>\r\n                    </span>\r\n\r\n                    <span ng-if=\"$ctrl.shouldShowBillingQuestionaire()\">\r\n                        My billing address is\r\n                        <span ng-if=\"$ctrl.currentStep === $ctrl.fulfilmentSteps.billing\"><a href=\"javascript://\"\r\n                                wow-event-recorder=\"click\"\r\n                                data-er-category=\"Delivery Window\"\r\n                                data-er-label=\"select billing address\">select billing address <i class=\"iconww-ArrowUp\"></i></a></span>\r\n                        <a href=\"javascript://\" ng-click=\"$ctrl.openBilling()\"\r\n                            ng-if=\"$ctrl.currentStep !== $ctrl.fulfilmentSteps.billing\"\r\n                            wow-event-recorder=\"click\"\r\n                            data-er-category=\"Delivery Window\"\r\n                            data-er-label=\"select billing address\">\r\n                            {{ $ctrl.billingAddressText() }}\r\n                            <i class=\"iconww-ArrowDown\"></i>\r\n                        </a>\r\n                    </span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div ng-if=\"$ctrl.currentStep && $ctrl.currentStep !== $ctrl.fulfilmentSteps.fulfilment\">\r\n            <wow-pickup-wizard\r\n                ng-if=\"$ctrl.fulfilmentService.selectedFulfilmentMethod === $ctrl.fulfilmentService.fulfilmentOptions.pickup\"\r\n                allow-decide-later=\"$ctrl.allowDecideLater\"\r\n                should-show-billing=\"$ctrl.shouldShowBilling\"\r\n                on-fulfilment-selected=\"$ctrl.saveFulfilment(fulfilmentInfo)\"\r\n                on-fulfilment-change=\"$ctrl.deliveryChange(fulfilmentInfo)\"\r\n                current-timeslot=\"{ Date: $ctrl.fulfilmentService.reservedDate, Time: $ctrl.fulfilmentService.reservedTime }\"\r\n                current-address=\"$ctrl.fulfilmentService.savedAddress\"\r\n                current-step=\"$ctrl.currentStep\"\r\n                is-active=\"$ctrl.isActive\">\r\n            </wow-pickup-wizard>\r\n\r\n            <wow-delivery-wizard\r\n                ng-if=\"$ctrl.fulfilmentService.selectedFulfilmentMethod === $ctrl.fulfilmentService.fulfilmentOptions.delivery\"\r\n                allow-decide-later=\"$ctrl.allowDecideLater\"\r\n                on-fulfilment-selected=\"$ctrl.saveFulfilment(fulfilmentInfo)\"\r\n                on-fulfilment-change=\"$ctrl.deliveryChange(fulfilmentInfo)\"\r\n                current-step=\"$ctrl.currentStep\"\r\n                current-timeslot=\"{ Date: $ctrl.fulfilmentService.reservedDate, Time: $ctrl.fulfilmentService.reservedTime }\"\r\n                current-address=\"$ctrl.fulfilmentService.savedAddress\"\r\n                is-active=\"$ctrl.isActive\"\r\n                should-get-dynamic-timetable=\"$ctrl.shouldGetDynamicTimetable\">\r\n            </wow-delivery-wizard>\r\n        </div>\r\n\r\n        <wow-timeslot-alert\r\n            reserved-timeslot=\"$ctrl.fulfilmentService.reservedTime\"\r\n            is-express=\"$ctrl.fulfilmentService.isExpress\">\r\n        </wow-timeslot-alert>\r\n\r\n        <wow-dialog\r\n            ng-if=\"$ctrl.modalMessage && $ctrl.shouldShowDeliveryWindowErrorModal\"\r\n            dialog-name=\"saved delivery window\"\r\n            message=\"{{ $ctrl.modalMessage }}\"\r\n            on-dismiss=\"::$ctrl.modalMessage = null\">\r\n        </wow-dialog>\r\n    </div>\r\n</ng-form>\r\n"

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RESERVATION_MESSAGE_KEY = 'windowReservationMessage';

var FulfilmentMethodWizardController = function () {
    function FulfilmentMethodWizardController($scope, $window, $timeout, settings, moveFocus, sessionStorage, loadingIndicatorService, shopperService, fulfilmentService, addressService, loginService, shopPageStateService) {
        _classCallCheck(this, FulfilmentMethodWizardController);

        this.$scope = $scope;
        this.$window = $window;
        this.$timeout = $timeout;
        this.settings = settings;
        this.sessionStorage = sessionStorage;
        this.loadingIndicatorService = loadingIndicatorService;
        this.shopperService = shopperService;
        this.fulfilmentService = fulfilmentService;
        this.addressService = addressService;
        this.loginService = loginService;
        this.moveFocus = moveFocus;
        this.shopPageStateService = shopPageStateService;
        this.fulfilmentMethodEditMode = true;
    }

    _createClass(FulfilmentMethodWizardController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // The watchers below open method selection panel or fulfilment timetable when a certain event is fired.
            //
            // This is needed for the cart component and the checkout component to trigger the fulfilment method wizard to change the state when
            // errors, such as delivery window/method restricted products cannot be delivered, occurs in the process. The problem is that the
            // components responsible for the trigger is not a direct parent/child of the wizard, which make it difficult to manage the dataflow.
            //
            // All events listed should be fired from the fulfilment service only. Please refer to fulfilment.service.js for its usage.
            //
            // Of course, if possible please kindly avoid using events.
            this.changeMethodWatcher = this.$scope.$on('fulfilment:changeMethod', function () {
                return _this.openFulfilmentMethodSelection();
            });
            this.changeTimeslotWatcher = this.$scope.$on('fulfilment:changeTimeslot', function () {
                return _this.openTimeslots();
            });

            this.fulfilmentSteps = this.fulfilmentService.fulfilmentSteps;
            this.modalMessage = this.sessionStorage.getAndRemove(RESERVATION_MESSAGE_KEY);

            this.deliveryMethodMessage = this.settings.trolley.deliveryMethodMessage.replace(' {Firstname}', this.shopperService.IsGuest ? '' : ' ' + this.shopperService.shopper.FirstName);

            this.fulfilmentOptions = this.allowDecideLater ? this.fulfilmentService.fulfilmentOptions : this.fulfilmentService.checkoutFulfilmentOptions;
            this.fulfilmentOptions.pickup.icon = 'iconww-Pickup';
            this.fulfilmentOptions.delivery.icon = 'iconww-Delivery';
            // Make sure the wizard will go to the correct step when on checkout (allow decide later === false)
            if (!this.allowDecideLater) {
                this.$timeout(function () {
                    return _this.initializeFulfilmentStep();
                });
            }

            this.shouldShowDeliveryWindowErrorModal = this.shouldShowDeliveryWindowErrorModal !== undefined ? this.shouldShowDeliveryWindowErrorModal : true;

            if (this.fulfilmentService.selectedFulfilmentMethod === this.fulfilmentService.fulfilmentOptions.pickup) {
                this.pickupAddressState = this.fulfilmentService.savedAddress;
            } else {
                this.deliveryAddressState = this.fulfilmentService.savedAddress;
            }
            this.lastSelectedFulfilmentMethod = this.fulfilmentService.selectedFulfilmentMethod;

            this.setReadOnlyState();
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            // Deregister watchers
            this.changeMethodWatcher();
            this.changeTimeslotWatcher();
        }
    }, {
        key: 'initializeFulfilmentStep',
        value: function initializeFulfilmentStep() {
            if (this.fulfilmentService.isNotSet()) {
                this.openFulfilmentMethodSelection();
            } else if (!this.fulfilmentService.savedAddress) {
                this.openAddressesSelection();
            } else if (!this.hasSelectedTimeslot()) {
                this.openTimeslots();
            }
        }
    }, {
        key: 'editFulfilmentMethod',
        value: function editFulfilmentMethod() {
            var _this2 = this;

            this.fulfilmentMethodEditMode = true;
            this.showBackToReadOnly = true;
            this.$timeout(function () {
                _this2.setFulfilmentMethod(_this2.lastSelectedFulfilmentMethod);
            });
        }
    }, {
        key: 'setReadOnlyState',
        value: function setReadOnlyState() {
            if ((this.pickupAddressState || this.deliveryAddressState) && !this.shopperService.IsGuest) {
                this.fulfilmentMethodEditMode = false;
            }
            this.showBackToReadOnly = false;
            this.currentStep = null;
        }
    }, {
        key: 'setFulfilmentMethod',
        value: function setFulfilmentMethod(fulfilmentMethod) {
            var _this3 = this;

            this.fulfilmentService.selectedFulfilmentMethod = fulfilmentMethod;

            this.changeAnswer(this.fulfilmentSteps.fulfilmentMethod);
            this.currentStep = this.fulfilmentSteps.fulfilmentMethod;
            this.fulfilmentService.savedAddress = null;

            this.$timeout(function () {
                _this3.currentStep = fulfilmentMethod === _this3.fulfilmentService.fulfilmentOptions.none ? null : _this3.fulfilmentSteps.address;

                if (fulfilmentMethod === _this3.fulfilmentService.fulfilmentOptions.none) {
                    _this3.fulfilmentService.clearFulfilmentInfo();
                }
            });
        }
    }, {
        key: 'ensureLoggedIn',
        value: function ensureLoggedIn(callback) {
            if (this.shopperService.IsGuest) {
                this.loginService.promptForLogin(this.loginService.LoginToSetDeliveryOrPickupAddressMessage, undefined, undefined, undefined, callback);
            } else {
                callback();
            }
        }
    }, {
        key: 'saveFulfilment',
        value: function saveFulfilment(fulfilmentInfo) {
            var _this4 = this;

            var wasGuest = this.shopperService.IsGuest;

            if (fulfilmentInfo.address) {
                this.ensureLoggedIn(function () {
                    _this4.loadingIndicatorService.startLoading(true, _this4.settings.delivery.deliveryWindowReloadingMessage);
                    _this4.fulfilmentService.saveFulfilment(fulfilmentInfo).then(function (response) {
                        return _this4.onSaveFulfilment(response, wasGuest);
                    }).catch(function () {
                        return _this4.loadingIndicatorService.finishLoading();
                    });
                });
            } else {
                this.currentStep = null;
                this.fulfilmentService.clearAddressAndTime();
                this.shopPageStateService.isCartOpen = false;
            }
        }
    }, {
        key: 'onSaveFulfilment',
        value: function onSaveFulfilment(response, wasGuest) {
            if (wasGuest) return;

            if (response && response.Message) {
                this.sessionStorage.set(RESERVATION_MESSAGE_KEY, response.Message);
            }

            this.$window.location.reload();
        }
    }, {
        key: 'deliveryChange',
        value: function deliveryChange(fulfilmentInfo) {
            this.fulfilmentService.savedAddress = fulfilmentInfo.address;

            if (fulfilmentInfo.fulfilmentWindow) {
                this.fulfilmentService.reservedDate = fulfilmentInfo.fulfilmentWindow.date;
                this.fulfilmentService.reservedTime = fulfilmentInfo.fulfilmentWindow.time;
            }
        }
    }, {
        key: 'hasSelectedTimeslot',
        value: function hasSelectedTimeslot() {
            return !!(this.fulfilmentService.reservedDate && this.fulfilmentService.reservedTime && this.fulfilmentService.reservedDate.DateText && this.fulfilmentService.reservedTime.TimeWindow);
        }
    }, {
        key: 'selectedAddressText',
        value: function selectedAddressText() {
            return this.fulfilmentService.savedAddress ? this.fulfilmentService.savedAddress.AddressText : this.fulfilmentService.selectedFulfilmentMethod.addressText;
        }
    }, {
        key: 'billingAddressText',
        value: function billingAddressText() {
            var primaryAddress = this.addressService.getPrimaryAddress();

            return primaryAddress ? primaryAddress.AddressText : 'select billing address';
        }
    }, {
        key: 'openFulfilmentMethodSelection',
        value: function openFulfilmentMethodSelection() {
            this.changeAnswer(this.fulfilmentSteps.fulfilmentMethod);
            this.currentStep = this.fulfilmentSteps.fulfilmentMethod;
            this.fulfilmentService.savedAddress = null;
            this.moveFocus('#fulfilmentMethod');
        }
    }, {
        key: 'openAddressesSelection',
        value: function openAddressesSelection() {
            this.changeAnswer(this.fulfilmentSteps.address);
            this.currentStep = this.fulfilmentSteps.address;
            this.moveFocus('#fulfilmentAddress');
        }
    }, {
        key: 'openTimeslots',
        value: function openTimeslots() {
            this.changeAnswer(this.fulfilmentSteps.timeslot);
            this.currentStep = this.fulfilmentSteps.timeslot;
            this.moveFocus('#fulfilmentTimetable');
        }
    }, {
        key: 'openBilling',
        value: function openBilling() {
            this.changeAnswer(this.fulfilmentSteps.billing);
            this.currentStep = this.fulfilmentSteps.billing;
            this.moveFocus('#fulfilmentBillingAddress');
        }
    }, {
        key: 'changeAnswer',
        value: function changeAnswer(fulfilmentStep) {
            if (this.onChangeAnswer) {
                this.onChangeAnswer({ stepChanged: fulfilmentStep });
            }
        }
    }, {
        key: 'shouldShowBillingQuestionaire',
        value: function shouldShowBillingQuestionaire() {
            return this.shouldShowBilling && this.fulfilmentService.selectedFulfilmentMethod === this.fulfilmentService.fulfilmentOptions.pickup && this.fulfilmentService.reservedTime && this.currentStep !== this.fulfilmentSteps.address && this.currentStep !== this.fulfilmentSteps.timeslot;
        }
    }]);

    return FulfilmentMethodWizardController;
}();

FulfilmentMethodWizardController.$inject = ['$scope', '$window', '$timeout', 'Settings', 'MoveFocus', 'SessionStorageWrapper', 'LoadingIndicatorService', 'ShopperService', 'FulfilmentService', 'AddressService', 'LoginService', 'ShopPageStateService'];

var fulfilmentMethodWizardComponentDefinitionV2 = {
    bindings: {
        shouldShowBilling: '<?',
        allowDecideLater: '<',
        isActive: '<',
        onChangeAnswer: '&?',
        shouldGetDynamicTimetable: '<?',
        shouldShowDeliveryWindowErrorModal: '<?'
    },
    controller: FulfilmentMethodWizardController,
    template: __webpack_require__(1032).trim()
};

module.exports = {
    FulfilmentMethodWizardController: FulfilmentMethodWizardController,
    fulfilmentMethodWizardComponentDefinitionV2: fulfilmentMethodWizardComponentDefinitionV2
};

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports = "<ng-form name=\"$ctrl.fulfilmentWizard\" novalidate>\r\n    <div class=\"fulfilmentMethodWizardV2\" ng-class=\"{'is-editing': $ctrl.currentStep != null}\">\r\n\r\n        <div class=\"fulfilmentMethodWizardV2-selectedState\" ng-if=\"!$ctrl.fulfilmentMethodEditMode\">\r\n            <i class=\"fulfilmentMethodWizardV2-selectedStateIcon\"\r\n                ng-class=\"[$ctrl.fulfilmentService.selectedFulfilmentMethod.icon, { 'is-active': !$ctrl.fulfilmentService.isDecideLater() }]\">\r\n            </i>\r\n\r\n            <div class=\"fulfilmentMethodWizardV2-wrapper\">\r\n                    <h4 class=\"fulfilmentMethodWizardV2-questionnaireHeading\">\r\n                        {{ $ctrl.lastSelectedFulfilmentMethod === $ctrl.fulfilmentService.fulfilmentOptions.pickup ? 'Pick up from' : 'Delivery to' }}:\r\n                    </h4>\r\n                    <p class=\"fulfilmentMethodWizardV2-selectedStateAddress\">{{$ctrl.deliveryAddressState ? $ctrl.deliveryAddressState.AddressText : $ctrl.pickupAddressState.AddressText}}</p>\r\n                    <a class=\"fulfilmentMethodWizardV2-selectedStateEdit\" href=\"javascript://\" ng-click=\"$ctrl.editFulfilmentMethod()\">\r\n                        Change\r\n                    </a>\r\n            </div>\r\n        </div>\r\n\r\n\r\n\r\n        <div class=\"fulfilmentMethodWizardV2-dayTime\" ng-class=\"{'fulfilmentMethodWizardV2-dayTimeIconPadding' : $ctrl.hasSelectedTimeslot()}\" ng-if=\"!$ctrl.fulfilmentMethodEditMode\">\r\n            <i class=\"fulfilmentMethodWizardV2-dayTimeIcon iconww-Clock\" ng-if=\"$ctrl.hasSelectedTimeslot()\">\r\n            </i>\r\n            <a class=\"fulfilmentMethodWizardV2-dayTimeLink\"\r\n                ng-class=\"{'fulfilmentMethodWizardV2-dayTimeLinkLeft' : $ctrl.hasSelectedTimeslot()}\"\r\n                href=\"javascript://\"\r\n                ng-click=\"$ctrl.openTimeslots()\"\r\n                ng-switch=\"$ctrl.hasSelectedTimeslot()\">\r\n                <span ng-switch-when=\"true\">\r\n                    <span ng-if=\"!$ctrl.fulfilmentService.isExpress\">\r\n                        <span ng-bind-html=\"$ctrl.fulfilmentService.reservedDate.DateText\"></span>\r\n                        between\r\n                    </span>\r\n                    {{ $ctrl.fulfilmentService.reservedTime.TimeWindow }}\r\n                </span>\r\n                <span ng-switch-when=\"false\">Select day and time</span>\r\n                <i class=\"iconww-ArrowDown\"></i>\r\n            </a>\r\n        </div>\r\n\r\n\r\n        <div class=\"fulfilmentMethodWizardV2-questionnaire\" ng-if=\"$ctrl.fulfilmentMethodEditMode\">\r\n            <div class=\"fulfilmentMethodWizardV2-wrapper\">\r\n                <h4 class=\"fulfilmentMethodWizardV2-questionnaireHeading\">\r\n                    {{ $ctrl.settings.fulfilmentSelector.fulfilmentMethodSelectorTitle }}\r\n                </h4>\r\n\r\n                <div class=\"fulfilmentMethodWizardV2-questions\">\r\n\r\n                    <fieldset class=\"fulfilmentMethodWizardV2-choices\" id=\"fulfilmentMethod\">\r\n                        <legend class=\"fulfilmentMethodWizardV2-legend\">\r\n                            <span class=\"sr-only\">Select how you would like to receive your groceries.</span>\r\n                        </legend>\r\n\r\n                        <div class=\"fulfilmentMethodWizardV2-fulfilmentMethod\" ng-repeat=\"fulfilmentMethod in ::$ctrl.fulfilmentOptions track by fulfilmentMethod.name\" ng-if=\"fulfilmentMethod.type !== 'none'\">\r\n                            <div class=\"u-flex\">\r\n                                <input\r\n                                    type=\"radio\"\r\n                                    name=\"fulfilmentMethod\"\r\n                                    id=\"{{ ::fulfilmentMethod.name }}\"\r\n                                    class=\"fulfilmentMethodWizardV2-radio\"\r\n                                    ng-model=\"$ctrl.fulfilmentService.selectedFulfilmentMethod\"\r\n                                    ng-value=\"fulfilmentMethod\"\r\n                                    ng-click=\"$ctrl.fulfilmentService.clearAddressAndTime() && $ctrl.setFulfilmentMethod(fulfilmentMethod)\"\r\n                                    ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.fulfilmentService.clearAddressAndTime() && $ctrl.setFulfilmentMethod(fulfilmentMethod);\">\r\n                                <label class=\"fulfilmentMethodWizardV2-fulfilmentMethod-label\"\r\n                                        for=\"{{ ::fulfilmentMethod.name }}\"\r\n                                        ng-click=\"$ctrl.setFulfilmentMethod(fulfilmentMethod);\"\r\n                                        wow-event-recorder=\"click\"\r\n                                        data-er-category=\"Delivery Window\"\r\n                                        data-er-label=\"{{ ::fulfilmentMethod.name }} selected\">\r\n                                    <span class=\"fulfilmentMethodWizardV2-fulfilmentMethod-icon icon\">\r\n                                        <i class=\"{{ ::fulfilmentMethod.icon }}\"></i>\r\n                                    </span>\r\n                                    <span class=\"fulfilmentMethodWizardV2-fulfilmentMethod-label-messages\">\r\n                                        <span class=\"fulfilmentMethodWizardV2-fulfilmentMethod-headLabel heading\">{{ ::fulfilmentMethod.name }}</span>\r\n                                        <span\r\n                                            ng-if=\"!fulfilmentMethod.isVariableSubheading || ($ctrl.fulfilmentService.selectedFulfilmentMethod === fulfilmentMethod && $ctrl.hasSelectedTimeslot())\"\r\n                                            class=\"fulfilmentMethodWizardV2-fulfilmentMethod-subLabel subheading\"\r\n                                            role=\"status\"\r\n                                            aria-live=\"polite\"\r\n                                            aria-atomic=\"true\">\r\n                                            {{ ::fulfilmentMethod.subheading }}\r\n                                        </span>\r\n                                    </span>\r\n                                    <div class=\"sr-only\" ng-if=\"$ctrl.settings.fulfilmentMethod.showDeliveryHint && fulfilmentMethod.isVariableSubheading\">{{ ::$ctrl.settings.fulfilmentMethod.deliveryHintText }}</div>\r\n                                </label>\r\n\r\n                            </div>\r\n\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"fulfilmentMethodWizardV2-pickupDeliveryWizard\" ng-if=\"$ctrl.currentStep && $ctrl.currentStep !== $ctrl.fulfilmentSteps.fulfilment\">\r\n            <wow-pickup-wizard\r\n                ng-if=\"$ctrl.fulfilmentService.selectedFulfilmentMethod === $ctrl.fulfilmentService.fulfilmentOptions.pickup\"\r\n                allow-decide-later=\"$ctrl.allowDecideLater\"\r\n                should-show-billing=\"$ctrl.shouldShowBilling\"\r\n                on-fulfilment-selected=\"$ctrl.saveFulfilment(fulfilmentInfo)\"\r\n                on-fulfilment-change=\"$ctrl.deliveryChange(fulfilmentInfo)\"\r\n                current-timeslot=\"{ Date: $ctrl.fulfilmentService.reservedDate, Time: $ctrl.fulfilmentService.reservedTime }\"\r\n                current-address=\"$ctrl.pickupAddressState\"\r\n                current-step=\"$ctrl.currentStep\"\r\n                is-active=\"$ctrl.isActive\"\r\n                is-new-fulfilment-method-selector=\"$ctrl.settings.frontendManagement.newFulfilmentMethodSelector\">\r\n            </wow-pickup-wizard>\r\n\r\n\r\n\r\n            <wow-delivery-wizard\r\n                ng-if=\"$ctrl.fulfilmentService.selectedFulfilmentMethod === $ctrl.fulfilmentService.fulfilmentOptions.delivery\"\r\n                allow-decide-later=\"$ctrl.allowDecideLater\"\r\n                on-fulfilment-selected=\"$ctrl.saveFulfilment(fulfilmentInfo)\"\r\n                on-fulfilment-change=\"$ctrl.deliveryChange(fulfilmentInfo)\"\r\n                current-step=\"$ctrl.currentStep\"\r\n                current-timeslot=\"{ Date: $ctrl.fulfilmentService.reservedDate, Time: $ctrl.fulfilmentService.reservedTime }\"\r\n                current-address=\"$ctrl.deliveryAddressState\"\r\n                is-active=\"$ctrl.isActive\"\r\n                should-get-dynamic-timetable=\"$ctrl.shouldGetDynamicTimetable\"\r\n                is-new-fulfilment-method-selector=\"$ctrl.settings.frontendManagement.newFulfilmentMethodSelector\">\r\n            </wow-delivery-wizard>\r\n        </div>\r\n\r\n        <div class=\"fulfilmentMethodWizardV2-cancel\" ng-if=\"$ctrl.showBackToReadOnly\">\r\n            <a class=\"fulfilmentMethodWizardV2-cancelLink\"\r\n                href=\"javascript://\"\r\n                ng-click=\"$ctrl.setReadOnlyState()\">\r\n                Cancel\r\n                <i class=\"fulfilmentMethodWizardV2-cancelIcon iconww-Cross\"></i>\r\n            </a>\r\n        </div>\r\n\r\n        <wow-timeslot-alert\r\n            reserved-timeslot=\"$ctrl.fulfilmentService.reservedTime\"\r\n            is-express=\"$ctrl.fulfilmentService.isExpress\">\r\n        </wow-timeslot-alert>\r\n\r\n        <wow-dialog\r\n            ng-if=\"$ctrl.modalMessage && $ctrl.shouldShowDeliveryWindowErrorModal\"\r\n            dialog-name=\"saved delivery window\"\r\n            message=\"{{ $ctrl.modalMessage }}\"\r\n            on-dismiss=\"::$ctrl.modalMessage = null\">\r\n        </wow-dialog>\r\n    </div>\r\n</ng-form>\r\n"

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(1034),
    fulfilmentSelectorDialogComponentDefinition = _require.fulfilmentSelectorDialogComponentDefinition;

var _require2 = __webpack_require__(1036),
    fulfilmentSelectorDialogContentComponentDefinition = _require2.fulfilmentSelectorDialogContentComponentDefinition;

var _require3 = __webpack_require__(1038),
    fulfilmentSelectorDeliveryPickupComponentDefinition = _require3.fulfilmentSelectorDeliveryPickupComponentDefinition;

var _require4 = __webpack_require__(1040),
    fulfilmentSelectorPickupAddressComponentDefinition = _require4.fulfilmentSelectorPickupAddressComponentDefinition;

var _require5 = __webpack_require__(1042),
    fulfilmentSelectorDeliveryAddressComponentDefinition = _require5.fulfilmentSelectorDeliveryAddressComponentDefinition;

var _require6 = __webpack_require__(1044),
    fulfilmentSelectorSelectedAddressComponentDefinition = _require6.fulfilmentSelectorSelectedAddressComponentDefinition;

var _require7 = __webpack_require__(1046),
    fulfilmentSelectorManualAddressComponentDefinition = _require7.fulfilmentSelectorManualAddressComponentDefinition;

var fulfilmentSelectorService = __webpack_require__(1048);

angular.module('wowApp.fulfilment').service('FulfilmentSelectorService', fulfilmentSelectorService).component('wowFulfilmentSelectorDialog', fulfilmentSelectorDialogComponentDefinition).component('wowFulfilmentSelectorDialogContent', fulfilmentSelectorDialogContentComponentDefinition).component('wowFulfilmentSelectorDeliveryPickup', fulfilmentSelectorDeliveryPickupComponentDefinition).component('wowFulfilmentSelectorPickupAddress', fulfilmentSelectorPickupAddressComponentDefinition).component('wowFulfilmentSelectorDeliveryAddress', fulfilmentSelectorDeliveryAddressComponentDefinition).component('wowFulfilmentSelectorSelectedAddress', fulfilmentSelectorSelectedAddressComponentDefinition).component('wowFulfilmentSelectorManualAddress', fulfilmentSelectorManualAddressComponentDefinition);

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tealiumEventBuilder = __webpack_require__(9);

var _tealiumEventBuilder2 = _interopRequireDefault(_tealiumEventBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FulfilmentSelectorDialogController = function () {
    function FulfilmentSelectorDialogController($scope, $state, settings, fulfilmentSelectorService, analyticsService, heartbeatService, $timeout, dialogRegistry) {
        _classCallCheck(this, FulfilmentSelectorDialogController);

        this.$scope = $scope;
        this.$state = $state;
        this.settings = settings;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.analyticsService = analyticsService;
        this.heartbeatService = heartbeatService;
        this.$timeout = $timeout;
        this.dialogRegistry = dialogRegistry;

        this.onInit();
    }

    _createClass(FulfilmentSelectorDialogController, [{
        key: 'onInit',
        value: function onInit() {
            var _this = this;

            this.isError = false;
            this.$scope.$on('error', function () {
                _this.isError = true;
            });
            this.$scope.$on('offline', function () {
                _this.isError = true;
            });

            // Check server session every 30 seconds.
            this.heartbeatService.startWaitingForContextExpiry(30000);
        }
    }, {
        key: 'goToConfirmStep',
        value: function goToConfirmStep() {
            var event = new _tealiumEventBuilder2.default().withScreenName('Manual Address entry').withLabel('Button/link click').withValue('Back').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withEventName('modal_interaction').withTrackingType('link').build();

            this.analyticsService.push(event);
            this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.confirm;
        }
    }, {
        key: 'onRedirectClick',
        value: function onRedirectClick() {
            var _this2 = this;

            var dialog = this.dialogRegistry.getDialog('fulfilment-selector-dialog');
            var event = new _tealiumEventBuilder2.default().withScreenName('FulfilmentSelection').withLabel('Button/link click').withValue('Close').withEventName('modal_interaction').withTrackingType('link').build();
            this.analyticsService.push(event);

            if (dialog) {
                dialog.close();
            }
            this.$timeout(function () {
                _this2.$state.go('root');
            }, 500);
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            // Reset to regular check time.
            this.heartbeatService.startContextHeartbeat();
            this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
        }
    }]);

    return FulfilmentSelectorDialogController;
}();

FulfilmentSelectorDialogController.$inject = ['$scope', '$state', 'Settings', 'FulfilmentSelectorService', 'AnalyticsService', 'HeartbeatService', '$timeout', 'DialogRegistry'];

var fulfilmentSelectorDialogComponentDefinition = {
    controller: FulfilmentSelectorDialogController,
    template: __webpack_require__(1035).trim()
};

module.exports = {
    FulfilmentSelectorDialogController: FulfilmentSelectorDialogController,
    fulfilmentSelectorDialogComponentDefinition: fulfilmentSelectorDialogComponentDefinition
};

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports = "<dialog name=\"fulfilment-selector-dialog\" id=\"_fulfilmentSelectorDialog\" class=\"olyDialog fulfilmentSelectorDialog\" aria-modal=\"true\">\r\n    <!-- title container -->\r\n    <div  ng-if=\"!$ctrl.isError\" class=\"fulfilmentSelectorDialog-title\" ng-class=\"{'fulfilmentSelectorDialog-titleCentered': $ctrl.fulfilmentSelectorService.currentStep === $ctrl.fulfilmentSelectorService.fulfilmentSelectorStepConfirm}\" aria-label=\"{{$ctrl.fulfilmentSelectorService.welcomeMessage}} {{::$ctrl.fulfilmentSelectorService.shopperName}}!\">\r\n        <!-- inner container -->\r\n        <div class=\"fulfilmentSelectorDialog-titleInner\">\r\n\r\n            <!-- back button -->\r\n            <div tabindex=\"0\" class=\"fulfilmentSelectorDialog-backButtonContainer\"\r\n                ng-if=\"$ctrl.fulfilmentSelectorService.currentStep === $ctrl.fulfilmentSelectorService.fulfilmentSelectorStepManualAddress\"\r\n                ng-click=\"$ctrl.goToConfirmStep()\">\r\n                <i class=\"iconww-ArrowLeft fulfilmentSelectorDialog-iconBack\"></i>\r\n                <span class=\"fulfilmentSelectorDialog-linkBack\">Back</span>\r\n            </div>\r\n\r\n            <!-- welcome message and shopper name -->\r\n            <div class=\"fulfilmentSelectorDialog-shopperMessage\"\r\n                ng-if=\"$ctrl.fulfilmentSelectorService.currentStep === $ctrl.fulfilmentSelectorService.fulfilmentSelectorStepStartShopping\r\n                    && $ctrl.fulfilmentSelectorService.shopperName\">\r\n                <span class=\"fulfilmentSelectorDialog-shopperMessageWelcome\">{{$ctrl.fulfilmentSelectorService.welcomeMessage}}</span>\r\n                <span class=\"fulfilmentSelectorDialog-shopperMessageName\">{{::$ctrl.fulfilmentSelectorService.shopperName}}!</span>\r\n            </div>\r\n\r\n            <!-- title message -->\r\n            <span class=\"fulfilmentSelectorDialog-titleMessage\">{{$ctrl.fulfilmentSelectorService.modalTitleMessage}}</span>\r\n        </div>\r\n    </div>\r\n\r\n    <wow-fulfilment-selector-dialog-content ng-if=\"!$ctrl.isError\" />\r\n\r\n    <div class=\"fulfilmentSelectorDialog-error\" ng-if=\"$ctrl.isError\" >\r\n        <img ng-src=\"{{$ctrl.settings.fulfilmentSelector.errorImageURL}}\" class=\"fulfilmentSelectorDialog-errorImage\" alt=\"Error image\" title=\"This image is artwork to imply an error has occurred.\" />\r\n        <div class=\"fulfilmentSelectorDialog-errorTitle\">{{ $ctrl.settings.fulfilmentSelector.errorTitle }}</div>\r\n        <div class=\"fulfilmentSelectorDialog-errorMessage\">{{ $ctrl.settings.fulfilmentSelector.errorMessage }}</div>\r\n        <div class=\"olyDialog-buttons fulfilmentSelectorDialog-buttonContainer\">\r\n            <button\r\n                aria-label=\"Close this window and return to the homepage.\"\r\n                oly-dialog-close\r\n                class=\"button button--primary olyDialog-buttonsConfirm fulfilmentSelectorDialog-button\"\r\n                ng-click=\"$ctrl.onRedirectClick()\">\r\n                CLOSE<span class=\"sr-only\"> WINDOW</span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</dialog>\r\n"

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FulfilmentSelectorDialogContentController = function () {
    function FulfilmentSelectorDialogContentController(fulfilmentSelectorService) {
        _classCallCheck(this, FulfilmentSelectorDialogContentController);

        this.fulfilmentSelectorService = fulfilmentSelectorService;
    }

    _createClass(FulfilmentSelectorDialogContentController, [{
        key: '$onInit',
        value: function $onInit() {
            this.dialogCtrl.show();
        }
    }]);

    return FulfilmentSelectorDialogContentController;
}();

FulfilmentSelectorDialogContentController.$inject = ['FulfilmentSelectorService'];

var fulfilmentSelectorDialogContentComponentDefinition = {
    require: { dialogCtrl: '^dialog' },
    controller: FulfilmentSelectorDialogContentController,
    template: __webpack_require__(1037).trim()
};

module.exports = {
    FulfilmentSelectorDialogContentController: FulfilmentSelectorDialogContentController,
    fulfilmentSelectorDialogContentComponentDefinition: fulfilmentSelectorDialogContentComponentDefinition
};

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fulfilmentSelectorDialog-content\">\r\n    <wow-fulfilment-selector-selected-address\r\n        ng-if=\"$ctrl.fulfilmentSelectorService.currentStep === $ctrl.fulfilmentSelectorService.fulfilmentSelectorStepStartShopping\" />\r\n    <wow-fulfilment-selector-manual-address\r\n        ng-if=\"$ctrl.fulfilmentSelectorService.currentStep === $ctrl.fulfilmentSelectorService.fulfilmentSelectorStepManualAddress\" />\r\n    <wow-fulfilment-selector-delivery-pickup\r\n        ng-if=\"$ctrl.fulfilmentSelectorService.currentStep === $ctrl.fulfilmentSelectorService.fulfilmentSelectorStepConfirm\" />\r\n</div>\r\n"

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tealiumEventBuilder = __webpack_require__(9);

var _tealiumEventBuilder2 = _interopRequireDefault(_tealiumEventBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    clone = _require.clone,
    isEmpty = _require.isEmpty;

var merchantHostedStorageKey = 'pendingMerchantHostedLogic';

var FulfilmentSelectorDeliveryPickupController = function () {
    function FulfilmentSelectorDeliveryPickupController($rootScope, dialogRegistry, settings, addressService, fulfilmentService, fulfilmentSelectorService, analyticsService, sessionStorage) {
        _classCallCheck(this, FulfilmentSelectorDeliveryPickupController);

        this.$rootScope = $rootScope;
        this.dialogRegistry = dialogRegistry;
        this.settings = settings;
        this.addressService = addressService;
        this.fulfilmentService = fulfilmentService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.analyticsService = analyticsService;
        this.sessionStorage = sessionStorage;
    }

    _createClass(FulfilmentSelectorDeliveryPickupController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.fulfilmentSelectorService.setModalTitleMessage(this.settings.fulfilmentSelector.fulfilmentMethodSelectorTitle);

            var existingfulfilmentMethodType = this.fulfilmentService.selectedFulfilmentMethod.type;

            // get the selectorFulfilmentOptions object based on existing method
            this.selectedFulfilmentMethod = this.fulfilmentSelectorService.getSelectorFulfilmentOption(existingfulfilmentMethodType);

            // update selectorFulfilmentOptions in service
            this.fulfilmentSelectorService.updateSelectorFulfilmentOptions(existingfulfilmentMethodType);

            if (this.fulfilmentSelectorService.isNotServiced) {
                if (!isEmpty(this.fulfilmentService.manualAddress)) {
                    this.selectedDeliveryAddress = this.fulfilmentService.manualAddress;
                }
            } else if (!isEmpty(this.selectedFulfilmentMethod)) {
                if (this.isPickup()) {
                    this.fulfilmentSelectorService.selectedPickupAddress = this.fulfilmentService.savedAddress;
                } else {
                    this.fulfilmentSelectorService.selectedDeliveryAddress = this.fulfilmentService.savedAddress;
                }
            }

            this.addressService.getSavedAddresses().then(function () {
                _this.savedAddresses = _this.addressService.savedAddresses;
            });

            // keep previous values of address and fufilment method in case user submits empty address
            this.previouslySelectedAddress = clone(this.fulfilmentService.savedAddress);
            this.previouslySelectedFulfilmentMethod = clone(this.selectedFulfilmentMethod);
            this.addressEmptyError = false;
        }
    }, {
        key: 'isPickup',
        value: function isPickup() {
            return !isEmpty(this.selectedFulfilmentMethod) ? this.selectedFulfilmentMethod.type === this.fulfilmentSelectorService.fulfilmentMethodPickupType : this.previouslySelectedFulfilmentMethod.type === this.fulfilmentSelectorService.fulfilmentMethodPickupType;
        }
    }, {
        key: 'pickupAddressSelected',
        value: function pickupAddressSelected(address) {
            this.fulfilmentSelectorService.selectedPickupAddress = address;
            this.updateAddressEmptyError();
        }
    }, {
        key: 'deliveryAddressSelected',
        value: function deliveryAddressSelected(address) {
            this.fulfilmentSelectorService.selectedDeliveryAddress = address;
            this.updateAddressEmptyError();
            if (!address || !address.AreaId) {
                this.fulfilmentSelectorService.isNotServiced = true;
                var _event = new _tealiumEventBuilder2.default().withScreenName('FulfilmentSelection').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withAction('click').withLabel('Non serviced address').withEventName('error').withValue('' + this.tempAddress.Text).withTrackingType('link').build();
                this.analyticsService.push(_event);
            } else {
                this.fulfilmentSelectorService.isNotServiced = false;
            }
        }
    }, {
        key: 'onSaveAutoAddress',
        value: function onSaveAutoAddress(address) {
            var _this2 = this;

            this.tempAddress = address;
            return this.addressService.saveAutoAddress(address).then(function (response) {
                return _this2.deliveryAddressSelected(response.Address);
            });
        }
    }, {
        key: 'setFulfilmentMethod',
        value: function setFulfilmentMethod(fulfilmentMethod) {
            var event = new _tealiumEventBuilder2.default().withScreenName('FulfilmentSelection').withLabel('Fulfilment type toggle').withValue(fulfilmentMethod.name === 'Delivery' ? 'Delivery' : 'Pickup').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withEventName('modal_interaction').withTrackingType('link').build();

            this.analyticsService.push(event);
            this.selectedFulfilmentMethod = fulfilmentMethod;
            this.fulfilmentSelectorService.updateSelectorFulfilmentOptions(fulfilmentMethod.type);

            if (this.addressEmptyError) {
                this.updateAddressEmptyError();
            }
            if (this.fulfilmentSelectorService.isNotServiced && isEmpty(this.fulfilmentSelectorService.selectedDeliveryAddress)) {
                this.fulfilmentSelectorService.isNotServiced = false;
            }
        }
    }, {
        key: 'updateAddressEmptyError',
        value: function updateAddressEmptyError() {
            var address = this.isPickup() ? this.fulfilmentSelectorService.selectedPickupAddress : this.fulfilmentSelectorService.selectedDeliveryAddress;

            if (isEmpty(address)) {
                this.addressEmptyError = true;
            } else {
                this.addressEmptyError = false;
            }
        }
    }, {
        key: 'saveFulfilment',
        value: function saveFulfilment() {
            var event = new _tealiumEventBuilder2.default().withScreenName('FulfilmentSelection').withLabel('Button/link click').withValue('Next').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withEventName('modal_interaction').withTrackingType('link').build();

            this.analyticsService.push(event);

            var address = this.isPickup() ? this.fulfilmentSelectorService.selectedPickupAddress : this.fulfilmentSelectorService.selectedDeliveryAddress;

            if (isEmpty(address)) {
                this.addressEmptyError = true;
                return;
            }

            this.addressEmptyError = false;

            if (!this.isPickup() && this.fulfilmentSelectorService.isNotServiced) {
                return;
            }

            if (address.AddressId !== this.previouslySelectedAddress.AddressId) {
                // save address for future use
                this.fulfilmentService.saveFulfilment({
                    fulfilmentMethod: this.isPickup() ? 'Pickup' : 'Courier',
                    address: address,
                    fulfilmentWindow: { time: null },
                    billingAddressId: null
                });

                // set up fulfilment method and address for right hand panel
                this.fulfilmentService.selectedFulfilmentMethod = this.isPickup() ? this.fulfilmentService.fulfilmentOptions.pickup : this.fulfilmentService.fulfilmentOptions.delivery;

                this.fulfilmentService.savedAddress = address != null ? address : this.previouslySelectedAddress;

                // Reset the time/date since they have confirmed a new selection.
                this.fulfilmentService.reservedDate = null;
                this.fulfilmentService.reservedTime = null;
            }

            // switch to start shopping screen
            this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.startShopping;

            if (this.fulfilmentSelectorService.shouldEnableFulfilmentSelectorStartShopping) {
                this.fulfilmentSelectorService.setUserPreferenceFulfilmentSelectorStepStartShopping(true);
            }

            this.sessionStorage.set(merchantHostedStorageKey, true);
        }
    }, {
        key: 'confirmLater',
        value: function confirmLater() {
            var dialog = this.dialogRegistry.getDialog('fulfilment-selector-dialog');
            var event = new _tealiumEventBuilder2.default().withScreenName('FulfilmentSelection').withLabel('Button/link click').withValue('Confirm later').withEventName('modal_interaction').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withAction('click').withTrackingType('link').build();
            this.analyticsService.push(event);

            if (dialog) {
                this.$rootScope.$broadcast('FMS:close');
                dialog.close();
            }
        }
    }, {
        key: 'onKeyPress',
        value: function onKeyPress($event, option) {
            if ($event && $event.keyCode === 13) {
                this.setFulfilmentMethod(option);

                event.preventDefault();
            }
        }
    }]);

    return FulfilmentSelectorDeliveryPickupController;
}();

FulfilmentSelectorDeliveryPickupController.$inject = ['$rootScope', 'DialogRegistry', 'Settings', 'AddressService', 'FulfilmentService', 'FulfilmentSelectorService', 'AnalyticsService', 'SessionStorageWrapper'];

var fulfilmentSelectorDeliveryPickupComponentDefinition = {
    controller: FulfilmentSelectorDeliveryPickupController,
    template: __webpack_require__(1039).trim()
};

module.exports = {
    FulfilmentSelectorDeliveryPickupController: FulfilmentSelectorDeliveryPickupController,
    fulfilmentSelectorDeliveryPickupComponentDefinition: fulfilmentSelectorDeliveryPickupComponentDefinition
};

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports = "<form name=\"$ctrl.fulfilmentSelectorDeliveryPickupForm\" id=\"fulfilmentSelectorDeliveryPickupForm\" class=\"fulfilmentSelectorDeliveryPickupForm\">\r\n    <div class=\"fulfilmentSelectorDialog-sectionWrapper\">\r\n        <wow-notification-message container-classes=\"fulfilmentSelectorDeliveryPickupForm-notification notificationMessage-container--small\" title=\"{{ $ctrl.settings.fulfilmentSelector.notServicedNotificationTitle }}\" message=\"{{ $ctrl.settings.fulfilmentSelector.notServicedNotificationMessage }}\" is-visible=\"$ctrl.fulfilmentSelectorService.isNotServiced && $ctrl.selectedFulfilmentMethod.type !== $ctrl.fulfilmentSelectorService.fulfilmentMethodPickupType\" is-dismissible=\"false\" type=\"error\"></wow-notification-message>\r\n        <ul class=\"fulfilmentSelectorDeliveryPickupForm-options\" aria-label=\"Please select your fulfilment method\">\r\n            <li tabindex=\"0\" id=\"fulfilmentSelectorDeliveryPickupForm-option\" class=\"fulfilmentSelectorDeliveryPickupForm-option\"\r\n                ng-repeat=\"option in ::$ctrl.fulfilmentSelectorService.selectorFulfilmentOptions track by option.type\"\r\n                ng-class=\"{ 'is-selected': option.isSelected }\"\r\n                ng-click=\"$ctrl.setFulfilmentMethod(option)\"\r\n                ng-keypress=\"$ctrl.onKeyPress($event, option)\">\r\n                <input\r\n                    class=\"fulfilmentSelectorDeliveryPickupForm-radio\"\r\n                    type=\"radio\"\r\n                    name=\"fulfilmentOption\"\r\n                    id=\"{{ ::option.type }}\"\r\n                    ng-value=\"option\"\r\n                    ng-model=\"ctrl.fulfilmentService.selectedFulfilmentMethod\"\r\n                    required />\r\n\r\n                <!-- radio-button-like icon -->\r\n                <div class=\"fulfilmentSelectorDialog-radioLikeIcon\" ng-if=\"option.isSelected\"></div>\r\n\r\n                <!-- method icon -->\r\n                <i class=\"{{ ::option.icon }} fulfilmentSelectorDeliveryPickupForm-icon\"></i>\r\n\r\n                <!-- method name -->\r\n                <label for=\"{{ ::option.type }}\" class=\"fulfilmentSelectorDeliveryPickupForm-label\">{{:: option.name }}</label>\r\n\r\n                <!-- minimum spending displaying text -->\r\n                <span class=\"fulfilmentSelectorDeliveryPickupForm-subheading\">{{:: option.subheading }}</span>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n    <!-- pick up stores search section -->\r\n    <wow-fulfilment-selector-pickup-address\r\n        ng-if=\"$ctrl.selectedFulfilmentMethod.type === $ctrl.fulfilmentSelectorService.fulfilmentMethodPickupType\"\r\n        id=\"fulfilmentSelector-pickup-address\"\r\n        input-id=\"fulfilmentSelector-pickup\"\r\n        set-pickup-address=\"$ctrl.pickupAddressSelected(addr)\"\r\n        selected-address=\"$ctrl.fulfilmentSelectorService.selectedPickupAddress\"\r\n        mandatory-error=\"$ctrl.addressEmptyError\">\r\n    </wow-fulfilment-selector-pickup-address>\r\n\r\n    <!-- delivery addresses search section -->\r\n    <wow-fulfilment-selector-delivery-address\r\n        ng-if=\"$ctrl.selectedFulfilmentMethod.type === $ctrl.fulfilmentSelectorService.fulfilmentMethodDeliveryType\"\r\n        id=\"fulfilmentSelector-saved-address\"\r\n        input-id=\"fulfilmentSelector-delivery\"\r\n        saved-addresses=\"$ctrl.savedAddresses\"\r\n        on-save-auto-address=\"$ctrl.onSaveAutoAddress(address)\"\r\n        on-saved-address-selected=\"$ctrl.deliveryAddressSelected(addr)\"\r\n        selected-address=\"$ctrl.fulfilmentSelectorService.selectedDeliveryAddress\"\r\n        mandatory-error=\"$ctrl.addressEmptyError\">\r\n\r\n    </wow-fulfilment-selector-delivery-address>\r\n</form>\r\n<div class=\"fulfilmentSelectorDialog-sectionWrapper\">\r\n    <!-- submit button -->\r\n    <div class=\"fulfilmentSelectorDialog-buttonContainer\">\r\n        <button ng-click=\"$ctrl.saveFulfilment()\" oly-move-focus=\".fulfilmentSelectorDialog-title\" class=\"button button--primary fulfilmentSelectorDialog-button\">\r\n            NEXT<span class=\"sr-only\">, save address</span><i class=\"iconww-ArrowRight fulfilmentSelectorDialog-arrow\"></i>\r\n        </button>\r\n    </div>\r\n    <div tabindex=\"0\" ng-click=\"$ctrl.confirmLater()\" oly-move-focus=\"center-panel\" class=\"fulfilmentSelectorDeliveryPickupForm-confirmLater\">\r\n        {{$ctrl.settings.fulfilmentSelector.confirmLaterLabel}}<span class=\"sr-only\">, click here to confirm later</span><i class=\"iconww-ArrowRight fulfilmentSelectorDeliveryPickupForm-arrow\"></i>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isEmpty = _require.isEmpty;

var LatLng = __webpack_require__(15);
var TealiumEventBuilder = __webpack_require__(9);

var FulfilmentSelectorPickupAddressController = function () {
    function FulfilmentSelectorPickupAddressController($q, $timeout, settings, analyticsService, locationService, pickupAddressSearchService, fulfilmentSelectorService, moveFocus) {
        _classCallCheck(this, FulfilmentSelectorPickupAddressController);

        this.$q = $q;
        this.$timeout = $timeout;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.locationService = locationService;
        this.pickupAddressSearchService = pickupAddressSearchService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.moveFocus = moveFocus;
    }

    _createClass(FulfilmentSelectorPickupAddressController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.pickupStores = [];
            this.locationSearchText = this.settings.fulfilmentSelector.searchByCurrentLocationLabel;

            this.currentLocation = this.locationService.latlng;
            this.isGeolocationEnabled = !isEmpty(this.locationService.latlng);

            this.locationService.getCurrentLocation().then(function (location) {
                _this.currentLocation = location;
                _this.isGeolocationEnabled = !!location;
            }, function () {
                _this.currentLocation = null;
                _this.isGeolocationEnabled = false;
            });

            this.storesPerPage = this.settings.fulfilmentSelector.pickupStoresPerPage;
            this.numberOfStoresToShow = this.storesPerPage;

            this.selectedStoreText = this.selectedAddress ? this.selectedAddress.AddressText : '';
            this.screenName = 'FulfilmentSelection';
            var event = new TealiumEventBuilder().withScreenName(this.screenName).withLabel('Fulfilment type toggle').withValue('Pickup').withEventName('modal_view').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withTrackingType('link').build();

            this.analyticsService.push(event);

            this.fulfilmentSelectorService.subscribeEscPushAnalytics(this.analyticsService, this.screenName);
        }
    }, {
        key: 'onSuburbSelected',
        value: function onSuburbSelected(suburb) {
            if (!isEmpty(suburb)) {
                if (!suburb.AddressText) {
                    this.suburbs = [];
                    var element = document.getElementById('suburb-' + this.inputId);
                    element.value = suburb.PostCode;
                    this.$timeout(function () {
                        if (typeof Event === 'function') {
                            element.dispatchEvent(new Event('change'));
                        } else {
                            var event = document.createEvent('Event');
                            event.initEvent('change', false, true);
                            element.dispatchEvent(event);
                        }
                    }, 50);
                } else {
                    this.onSelectStore(suburb);
                }
            }
        }
    }, {
        key: 'onClickGeo',
        value: function onClickGeo($event) {
            $event.preventDefault();
            this.moveFocus('#suburb-' + this.inputId);
            if (this.suburbText) {
                return;
            }
            if (this.isGeolocationEnabled) {
                var element = document.getElementById('suburb-' + this.inputId);
                element.value = this.locationSearchText;
                this.$timeout(function () {
                    element.dispatchEvent(new Event('change'));
                }, 50);
            }
        }
    }, {
        key: 'suburbOnType',
        value: function suburbOnType() {
            var _this2 = this;

            if (!!this.suburbText && this.suburbText.length >= this.settings.fulfilmentSelector.numberOfKeystrokesToTriggerSearch) {
                return this.performSearch(this.suburbText).then(function (response) {
                    return response ? _this2.suburbs : _this2.pickupStores;
                });
            }

            this.selectedAddress = null;

            return this.$q.defer().promise;
        }
    }, {
        key: 'performSearch',
        value: function performSearch(searchTerm) {
            if (searchTerm === this.locationSearchText && this.isGeolocationEnabled) {
                searchTerm = this.currentLocation;
            }

            if (searchTerm instanceof LatLng) {
                return this.searchStoresByGeolocation(searchTerm);
            }

            if (isNaN(searchTerm)) {
                return this.searchSuburbs(searchTerm);
            }

            return this.searchStoresByPostcode(searchTerm);
        }
    }, {
        key: 'searchSuburbs',
        value: function searchSuburbs(searchTerm) {
            var _this3 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.suburbs;
            return this.pickupAddressSearchService.searchSuburbs(searchTerm).then(function (suburbs) {
                _this3.suburbs = suburbs;
                return true;
            });
        }
    }, {
        key: 'searchStoresByPostcode',
        value: function searchStoresByPostcode(postcode) {
            var _this4 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.stores;
            return this.pickupAddressSearchService.searchByPostcode({ postcode: postcode }).then(function (pickupStores) {
                _this4.setStores(pickupStores);
                _this4.suburbs = [];
                return false;
            });
        }
    }, {
        key: 'searchStoresByGeolocation',
        value: function searchStoresByGeolocation(position) {
            var _this5 = this;

            this.searchMode = this.pickupAddressSearchService.searchModes.stores;
            return this.pickupAddressSearchService.searchByGeolocation(position).then(function (pickupStores) {
                _this5.setStores(pickupStores);
                _this5.suburbs = [];
                return false;
            });
        }
    }, {
        key: 'setStores',
        value: function setStores(stores) {
            this.pickupStores = stores;
            this.selectedStore = null;
            this.selectedStoreText = null;
        }
    }, {
        key: 'getSuburbText',
        value: function getSuburbText(item) {
            return item.SuburbStateString ? item.SuburbStateString : item.AddressText;
        }
    }, {
        key: 'clearSearch',
        value: function clearSearch(input) {
            if (input) {
                this.suburbText = null;
                this.selectedSuburb = null;
            }
            if (!input) {
                this.selectedStoreText = null;
                this.selectedStore = null;
                this.selectedAddress = null;
            }
            this.moveFocus('#suburb-' + this.inputId);
        }
    }, {
        key: 'onSelectStore',
        value: function onSelectStore(store) {
            if (this.selectedAddress && this.selectedAddress.AddressId !== store.AddressId) {
                var event = new TealiumEventBuilder().withScreenName(this.screenName).withLabel('Pickup store change').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withEventName('modal_interaction').withTrackingType('link').build();

                this.analyticsService.push(event);
            }
            this.selectedStore = store.AddressId;
            this.selectedStoreText = store.AddressText;
            this.suburbText = null;
            this.selectedSuburb = null;
            this.pickupStores = [];
            this.setPickupAddress({ addr: store });
            this.moveFocus('.fulfilmentSelectorDialog-button');
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
        }
    }, {
        key: 'onSelectedFocus',
        value: function onSelectedFocus($event) {
            var element = $event.currentTarget;
            if (element.selectionStart === 0 && element.selectionEnd === element.value.length) {
                this.$timeout(function () {
                    element.setSelectionRange(0, element.value.length);
                }, 1);
            } else {
                element.setSelectionRange(0, element.value.length);
            }
        }
    }, {
        key: 'onSelectedKeypress',
        value: function onSelectedKeypress($event) {
            var _this6 = this;

            var inp = String.fromCharCode($event.keyCode);
            if ($event.keyCode === 37 || $event.keyCode === 38 || $event.keyCode === 39 || $event.keyCode === 40 || $event.keyCode === 36 || $event.keyCode === 35) {
                // Arrow keys + page up/down
                this.onSelectedFocus($event);
            } else if ($event.keyCode === 27 || $event.keyCode === 8 || $event.keyCode === 46 || $event.keyCode === 9) {
                // Allow esc/bck/del/Tab keys
            } else if ($event.keyCode === 32) {
                // space
                $event.stopPropagation();
                this.moveFocus('#suburb-' + this.inputId);
            } else if (/[a-zA-Z0-9-_ ]/.test(inp)) {
                // All other keys should do nothing
                var element = $event.currentTarget;
                element.value = '';
                this.suburbText = String.fromCharCode($event.keyCode);
                this.$timeout(function () {
                    element.dispatchEvent(new Event('change'));
                    _this6.moveFocus('#suburb-' + _this6.inputId);
                }, 50);
                $event.stopPropagation();
                $event.preventDefault();
            } else {
                // All other keys should do nothing
                $event.preventDefault();
            }
        }
    }]);

    return FulfilmentSelectorPickupAddressController;
}();

FulfilmentSelectorPickupAddressController.$inject = ['$q', '$timeout', 'Settings', 'AnalyticsService', 'LocationService', 'PickupAddressSearchService', 'FulfilmentSelectorService', 'MoveFocus'];

var fulfilmentSelectorPickupAddressComponentDefinition = {
    bindings: {
        inputId: '@',
        classModifier: '@?',
        setPickupAddress: '&',
        selectedAddress: '=?',
        mandatoryError: '<?'
    },
    controller: FulfilmentSelectorPickupAddressController,
    template: __webpack_require__(1041).trim()
};

module.exports = {
    FulfilmentSelectorPickupAddressController: FulfilmentSelectorPickupAddressController,
    fulfilmentSelectorPickupAddressComponentDefinition: fulfilmentSelectorPickupAddressComponentDefinition
};

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fulfilmentSelectorPickupAddress\" ng-class=\"::'fulfilmentSelectorPickupAddress--' + $ctrl.classModifier\">\r\n    <ng-form name=\"$ctrl.fulfilmentSelectorPickupAddressForm\" ng-switch=\"!!$ctrl.selectedStore\">\r\n        <div ng-switch=\"!!$ctrl.selectedStoreText\" class=\"fulfilmentSelectorPickupAddress-inputContainer\">\r\n            <wow-input-container ng-switch-when=\"true\">\r\n                <label for=\"fulfilmentSelectorPickupAddress-selectedStore\">\r\n                    {{ ::$ctrl.settings.fulfilmentSelector.pickupStoreInputLabel }}\r\n                </label>\r\n                <input\r\n                    id=\"fulfilmentSelectorPickupAddress-selectedStore\"\r\n                    class=\"fulfilmentSelectorPickupAddress-input adjustment\"\r\n                    type=\"text\"\r\n                    dropdown-class=\"fulfilmentSelectorPickupAddress-searchAutocompleteDropdown\"\r\n                    ng-focus=\"$ctrl.onSelectedFocus($event)\"\r\n                    ng-click=\"$ctrl.onSelectedFocus($event)\"\r\n                    ng-keypress=\"$ctrl.onSelectedKeypress($event)\"\r\n                    ng-model=\"$ctrl.selectedStoreText\"\r\n                    autocomplete=\"off\"/>\r\n                <button\r\n                    type=\"button\"\r\n                    class=\"fulfilmentSelectorPickupAddress-inputButton\"\r\n                    ng-click=\"$ctrl.clearSearch()\">\r\n                    <span class=\"sr-only\">Reset search</span>\r\n                    <i class=\"icon-close_x\"></i>\r\n                </button>\r\n            </wow-input-container>\r\n            <wow-input-container ng-switch-when=\"false\" ng-class=\"{'error': $ctrl.mandatoryError}\">\r\n                <label for=\"fulfilmentSelectorPickupAddressSearch-storeSearch\">\r\n                    <span>Search for Pick up location *</span>\r\n                </label>\r\n                <oly-autocomplete\r\n                    input-id=\"suburb-{{$ctrl.inputId}}\"\r\n                    input-name=\"suburb\"\r\n                    text=\"$ctrl.suburbText\"\r\n                    items=\"$ctrl.suburbOnType()\"\r\n                    item-text=\"$ctrl.getSuburbText\"\r\n                    selected-item=\"$ctrl.selectedSuburb\"\r\n                    run-on-select=\"$ctrl.onSuburbSelected($ctrl.selectedSuburb)\"\r\n                    is-required=\"true\"\r\n                    search-box-class=\"fulfilmentSelectorPickupAddress-searchAutocompleteTextField suburb\"\r\n                    dropdown-class=\"fulfilmentSelectorPickupAddress-searchAutocompleteDropdown suburb\"\r\n                    show-clear-button=\"true\"\r\n                    action-button-wrapper-class=\"fulfilmentSelectorPickupAddress-searchAutocompleteActionsWrapper suburb\"\r\n                    action-button-class=\"fulfilmentSelectorPickupAddress-searchAutocompleteClearButton suburb\"\r\n                    item-class=\"{{$ctrl.searchMode}}\"\r\n                    min-length=\"4\">\r\n                    <autocomplete-item>\r\n                            <div  ng-show=\"item.AddressText && item.Street1\" class=\"fulfilmentSelectorPickupAddress-store\">\r\n                                    <p class=\"fulfilmentSelectorPickupAddress-storeDescription\">{{ ::item.AddressText }}</p>\r\n                                    <address class=\"fulfilmentSelectorPickupAddress-storeAddress\">{{ ::item.Street1 }}</address>\r\n                            </div>\r\n                            <span class=\"fulfilmentSelectorPickupAddress-storeDistance\" ng-show=\"item.Distance\">{{ ::item.Distance + 'km' }}</span>\r\n                            {{ ::item.SuburbStateString }}\r\n                    </autocomplete-item>\r\n                    <autocomplete-not-found class=\"fulfilmentSelectorPickupAddress-NotFound suburb\">\r\n                        {{ $ctrl.searchMode == $ctrl.pickupAddressSearchService.searchModes.suburbs ?  'No suburb found.' : 'No stores found.' }}\r\n                        <button\r\n                            type=\"button\"\r\n                            class=\"fulfilmentSelectorPickupAddress-button linkButton suburb\"\r\n                            ng-click=\"$ctrl.clearSearch($ctrl.suburbText)\" oly-move-focus=\"fulfilmentSelectorManualAddress-street1 suburb\">\r\n                            Reset Search\r\n                        </button>\r\n                    </autocomplete-not-found>\r\n                </oly-autocomplete>\r\n\r\n                <button\r\n                    id=\"fulfilmentSelectorPickupAddressSearch-geoLocationButton\"\r\n                    class=\"fulfilmentSelectorPickupAddressSearch-geoLocationButton\"\r\n                    ng-show=\"!$ctrl.suburbText\"\r\n                    ng-disabled=\"!$ctrl.isGeolocationEnabled\"\r\n                    ng-click=\"$ctrl.onClickGeo($event)\" aria-role=\"button\" >\r\n                    <span class=\"sr-only\">Find pick up addresses near me</span>\r\n                    <i ng-if=\"!$ctrl.isGeolocationEnabled\" class=\"iconww-unavailable pickupAddressSearch-geoLocationButton--disabled\" style=\"cursor: default;\"></i>\r\n                    <i ng-if=\"$ctrl.isGeolocationEnabled\" class=\"iconww-selected pickupAddressSearch-geoLocationButton--enabled\"></i>\r\n                </button>\r\n\r\n                <div role=\"alert\" class=\"fulfilmentSelectorPickupAddress-addressEmpty\">\r\n                    <span ng-if=\"$ctrl.mandatoryError\"><span class=\"sr-only\">A Pickup </span>{{ ::$ctrl.settings.fulfilmentSelector.locationRequiredError }}</span>\r\n                </div>\r\n            </wow-input-container>\r\n        </div>\r\n    </ng-form>\r\n</div>\r\n"

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    isEmpty = _require.isEmpty;

var TealiumEventBuilder = __webpack_require__(9);

var FulfilmentSelectorDeliveryAddressController = function () {
    function FulfilmentSelectorDeliveryAddressController($q, settings, addressService, analyticsService, fulfilmentSelectorService) {
        _classCallCheck(this, FulfilmentSelectorDeliveryAddressController);

        this.$q = $q;
        this.settings = settings;
        this.addressService = addressService;
        this.analyticsService = analyticsService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.isEmpty = isEmpty;
    }

    _createClass(FulfilmentSelectorDeliveryAddressController, [{
        key: '$onInit',
        value: function $onInit() {
            this.autocompleteText = this.fulfilmentSelectorService.getFullDeliveryAddress(this.selectedAddress);
            this.hasSearched = !!this.autocompleteText && this.autocompleteText.length >= this.settings.fulfilmentSelector.numberOfKeystrokesToTriggerSearch;
            this.activeSearchMode = 'AMAS_ADDRESSES';

            this.screenName = 'FulfilmentSelection';
            var event = new TealiumEventBuilder().withScreenName(this.screenName).withLabel('Fulfilment type toggle').withValue('Delivery').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withEventName('modal_view').withTrackingType('link').build();

            this.analyticsService.push(event);

            this.fulfilmentSelectorService.subscribeEscPushAnalytics(this.analyticsService, this.screenName);
        }
    }, {
        key: 'onAddressSelected',
        value: function onAddressSelected(address) {
            if (!this.selectedAddress || typeof this.selectedAddress.AddressId !== 'undefined' && this.selectedAddress.AddressId !== address.AddressId || typeof this.selectedAddress.Id !== 'undefined' && this.selectedAddress.Id !== address.Id) {
                var event = new TealiumEventBuilder().withScreenName(this.screenName).withLabel('AddressChange').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withEventName('modal_interaction').withTrackingType('link').build();
                this.analyticsService.push(event);
            }
            if (!isEmpty(address)) {
                this.autocompleteText = address.Text ? address.Text : this.fulfilmentSelectorService.getFullDeliveryAddress(address);
                this.hasSearched = !!this.autocompleteText;
                if (typeof address.Id !== 'undefined') {
                    this.onSaveAutoAddress({ address: address });
                } else {
                    this.onSavedAddressSelected({ addr: address });
                }
            }
        }
    }, {
        key: 'getItemText',
        value: function getItemText(item) {
            return item.Text ? item.Text : item.AddressText;
        }
    }, {
        key: 'openManualAddressForm',
        value: function openManualAddressForm() {
            var event = new TealiumEventBuilder().withScreenName(this.screenName).withLabel('Button/link click').withValue('Add manually').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withEventName('modal_interaction').withTrackingType('link').build();
            this.analyticsService.push(event);

            this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.manualAddress;
        }
    }, {
        key: 'addressOnType',
        value: function addressOnType() {
            var _this = this;

            if (!!this.autocompleteText && this.autocompleteText.length >= this.settings.fulfilmentSelector.numberOfKeystrokesToTriggerSearch) {
                this.addressService._clearAutoAddresses();
                return this.addressService.search(this.autocompleteText).then(function (response) {
                    return response ? _this.addressService.autoAddresses : [];
                });
            }

            this.selectedAddress = null;

            var deferred = this.$q.defer();
            deferred.resolve(this.savedAddresses);
            return deferred.promise;
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
        }
    }]);

    return FulfilmentSelectorDeliveryAddressController;
}();

FulfilmentSelectorDeliveryAddressController.$inject = ['$q', 'Settings', 'AddressService', 'AnalyticsService', 'FulfilmentSelectorService'];

var fulfilmentSelectorDeliveryAddressComponentDefinition = {
    bindings: {
        inputId: '@',
        savedAddresses: '<?',
        onSaveAutoAddress: '&?',
        onSavedAddressSelected: '&?',
        selectedAddress: '=?',
        mandatoryError: '<?'
    },
    controller: FulfilmentSelectorDeliveryAddressController,
    template: __webpack_require__(1043).trim()
};

module.exports = {
    FulfilmentSelectorDeliveryAddressController: FulfilmentSelectorDeliveryAddressController,
    fulfilmentSelectorDeliveryAddressComponentDefinition: fulfilmentSelectorDeliveryAddressComponentDefinition
};

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fulfilmentSelectorDeliveryAddress\">\r\n    <wow-input-container ng-class=\"{'error': $ctrl.mandatoryError}\">\r\n        <label for=\"address-{{$ctrl.inputId}}\">\r\n            <span ng-if=\"$ctrl.isEmpty($ctrl.selectedAddress)\">Search for a new address *</span>\r\n            <span ng-if=\"!$ctrl.isEmpty($ctrl.selectedAddress)\">{{ ::$ctrl.settings.fulfilmentSelector.deliveryAddressInputLabel }}</span>\r\n        </label>\r\n\r\n        <oly-autocomplete\r\n            input-id=\"address-{{$ctrl.inputId}}\"\r\n            input-name=\"address\"\r\n            text=\"$ctrl.autocompleteText\"\r\n            items=\"$ctrl.addressOnType()\"\r\n            item-text=\"$ctrl.getItemText\"\r\n            selected-item=\"$ctrl.address\"\r\n            run-on-select=\"$ctrl.onAddressSelected($ctrl.address)\"\r\n            is-required=\"true\"\r\n            search-box-class=\"fulfilmentSelectorDeliveryAddress-searchAutocompleteTextField\"\r\n            dropdown-class=\"fulfilmentSelectorDeliveryAddress-searchAutocompleteDropdown\"\r\n            show-clear-button=\"true\"\r\n            show-prefix=\"!$ctrl.autocompleteText || ($ctrl.autocompleteText.length < $ctrl.settings.fulfilmentSelector.numberOfKeystrokesToTriggerSearch)\"\r\n            action-button-wrapper-class=\"fulfilmentSelectorDeliveryAddress-searchAutocompleteActionsWrapper\"\r\n            action-button-class=\"fulfilmentSelectorDeliveryAddress-searchAutocompleteClearButton\"\r\n            min-length=\"0\">\r\n            <autocomplete-prefix class=\"fulfilmentSelectorDeliveryAddress-searchAutocompletePrefix\">\r\n                    Previously used addresses\r\n            </autocomplete-prefix>\r\n            <autocomplete-item>{{ ::item.Text ? item.Text : item.AddressText }}</autocomplete-item>\r\n            <autocomplete-not-found class=\"fulfilmentSelectorDeliveryAddress-SearchAutoCompleteNotFound\">\r\n                Addresses not found.\r\n                <button\r\n                    type=\"button\"\r\n                    class=\"fulfilmentSelectorDeliveryAddress-button linkButton\"\r\n                    ng-click=\"$ctrl.openManualAddressForm()\" oly-move-focus=\"fulfilmentSelectorManualAddress-street1\">\r\n                    Enter manually <i class=\"iconww-ArrowRight fulfilmentSelectorDeliveryAddress-buttonIcon\"></i>\r\n                </button>\r\n            </autocomplete-not-found>\r\n        </oly-autocomplete>\r\n\r\n        <div role=\"alert\" class=\"fulfilmentSelectorDeliveryAddress-addressEmpty\">\r\n            <span ng-if=\"$ctrl.mandatoryError\"><span class=\"sr-only\">A Delivery </span>{{ ::$ctrl.settings.fulfilmentSelector.addressRequiredError }}</span>\r\n        </div>\r\n    </wow-input-container>\r\n\r\n</div>\r\n"

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TealiumEventBuilder = __webpack_require__(9);

var FulfilmentSelectorSelectedAddressController = function () {
    function FulfilmentSelectorSelectedAddressController($rootScope, settings, addressService, analyticsService, fulfilmentSelectorService, fulfilmentService) {
        _classCallCheck(this, FulfilmentSelectorSelectedAddressController);

        this.$rootScope = $rootScope;
        this.settings = settings;
        this.addressService = addressService;
        this.analyticsService = analyticsService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.fulfilmentService = fulfilmentService;
    }

    _createClass(FulfilmentSelectorSelectedAddressController, [{
        key: '$onInit',
        value: function $onInit() {
            this.fulfilmentSelectorService.setModalTitleMessage('');
            var existingfulfilmentMethodType = this.fulfilmentService.selectedFulfilmentMethod.type;
            this.selectedFulfilmentMethod = this.fulfilmentSelectorService.getSelectorFulfilmentOption(existingfulfilmentMethodType);
            this.addressToDisplay = this.fulfilmentSelectorService.getAddressToDisplay(existingfulfilmentMethodType, this.fulfilmentService.savedAddress);

            this.screenName = 'Confirmation';
            var event = new TealiumEventBuilder().withScreenName(this.screenName).withEventName('modal_view').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withTrackingType('link').build();

            this.analyticsService.push(event);

            this.fulfilmentSelectorService.subscribeEscPushAnalytics(this.analyticsService, this.screenName);
        }
    }, {
        key: 'onChangeAddress',
        value: function onChangeAddress() {
            var event = new TealiumEventBuilder().withScreenName(this.screenName).withLabel('Button/link click').withValue('Change').withEventName('modal_interaction').withEventType('fulfilmentSelectorDialog').withTrackingType('link').build();
            this.analyticsService.push(event);

            this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.confirm;
        }
    }, {
        key: 'onStartShopping',
        value: function onStartShopping() {
            var event = new TealiumEventBuilder().withScreenName(this.screenName).withLabel('Button/link click').withValue('Confirm').withEventName('modal_interaction').withEventType('fulfilmentSelectorDialog').withTrackingType('link').build();
            this.analyticsService.push(event);

            this.$rootScope.$broadcast('FMS:close');
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
        }
    }]);

    return FulfilmentSelectorSelectedAddressController;
}();

FulfilmentSelectorSelectedAddressController.$inject = ['$rootScope', 'Settings', 'AddressService', 'AnalyticsService', 'FulfilmentSelectorService', 'FulfilmentService'];

var fulfilmentSelectorSelectedAddressComponentDefinition = {
    controller: FulfilmentSelectorSelectedAddressController,
    template: __webpack_require__(1045).trim()
};

module.exports = {
    FulfilmentSelectorSelectedAddressController: FulfilmentSelectorSelectedAddressController,
    fulfilmentSelectorSelectedAddressComponentDefinition: fulfilmentSelectorSelectedAddressComponentDefinition
};

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fulfilmentSelectorSelectedAddress\">\r\n    <div class=\"fulfilmentSelectorSelectedAddress-info\">\r\n        <span class=\"fulfilmentSelectorSelectedAddress-title\">{{ $ctrl.settings.fulfilmentSelector.selectedAddressTitle }}</span>\r\n        <div class=\"fulfilmentSelectorSelectedAddress-infoContainer\">\r\n            <div class=\"fulfilmentSelectorSelectedAddress-card\">\r\n                <div class=\"fulfilmentSelectorSelectedAddress-cardTop\">\r\n                    <!-- fulfilment method name and icon -->\r\n                    <div class=\"fulfilmentSelectorSelectedAddress-cardTopLeft\">\r\n                        <i class=\"{{ $ctrl.selectedFulfilmentMethod.icon }} fulfilmentSelectorSelectedAddress-icon\" />\r\n                        <span class=\"fulfilmentSelectorSelectedAddress-methodTitle\">\r\n                            {{ $ctrl.selectedFulfilmentMethod.name }}\r\n                        </span>\r\n                    </div>\r\n\r\n                    <!-- change link click -->\r\n                    <button\r\n                        class=\"fulfilmentSelectorSelectedAddress-change\"\r\n                        ng-click=\"$ctrl.onChangeAddress()\" aria-label=\"Change your fulfilment preference\">\r\n                        Change\r\n                    </button>\r\n                </div>\r\n\r\n                <!-- address information -->\r\n                <span class=\"fulfilmentSelectorSelectedAddress-address\">{{ ::$ctrl.addressToDisplay.line1 }}</span>\r\n                <span class=\"fulfilmentSelectorSelectedAddress-address\">{{ ::$ctrl.addressToDisplay.line2 }}</span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"fulfilmentSelectorDialog-sectionWrapper-noBorder\">\r\n    <!-- submit button -->\r\n    <div class=\"fulfilmentSelectorDialog-buttonContainer\">\r\n        <button\r\n            aria-label=\"Confirm your fulfilment preference\"\r\n            oly-dialog-close\r\n            oly-move-focus=\"center-panel\"\r\n            class=\"button button--primary fulfilmentSelectorDialog-button\"\r\n            ng-click=\"$ctrl.onStartShopping()\">\r\n            CONFIRM<i class=\"iconww-ArrowRight fulfilmentSelectorSelectedAddress-continueArrow\"></i>\r\n        </button>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TealiumEventBuilder = __webpack_require__(9);

var FulfilmentSelectorManualAddressController = function () {
    function FulfilmentSelectorManualAddressController($q, settings, addressService, analyticsService, fulfilmentService, fulfilmentSelectorService) {
        _classCallCheck(this, FulfilmentSelectorManualAddressController);

        this.$q = $q;
        this.settings = settings;
        this.addressService = addressService;
        this.analyticsService = analyticsService;
        this.fulfilmentService = fulfilmentService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
    }

    _createClass(FulfilmentSelectorManualAddressController, [{
        key: '$onInit',
        value: function $onInit() {
            this.fulfilmentSelectorService.setModalTitleMessage(this.settings.fulfilmentSelector.manualAddressTitle);

            this.address = {
                postcode: null, street1: null, street2: null, suburbId: null, suburb: null
            };

            this.showRegionalNotification = !this.fulfilmentSelectorService.hasDismissedRegionalNotification;

            this.screenName = 'Manual address entry';
            var event = new TealiumEventBuilder().withScreenName(this.screenName).withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withTrackingType('link').withEventName('modal_view').build();

            this.analyticsService.push(event);

            this.fulfilmentSelectorService.subscribeEscPushAnalytics(this.analyticsService, this.screenName);
        }
    }, {
        key: 'onDismissRegionalNotification',
        value: function onDismissRegionalNotification() {
            this.fulfilmentSelectorService.setDismissedRegionalNotificationPreference(true);

            var event = new TealiumEventBuilder().withScreenName(this.screenName).withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withTrackingType('link').withAction('click').withLabel('Remote Order Info').withEventName('Link_click').withValue('close').build();

            this.analyticsService.push(event);
        }
    }, {
        key: 'setSuburb',
        value: function setSuburb(suburb) {
            if (!suburb) return null;

            if (suburb.Id && suburb.Text && suburb.Id !== 'n/a') {
                this.address.suburbId = suburb.Id;
                this.address.suburb = suburb.Text;
            }
            return suburb;
        }
    }, {
        key: 'loadSuburbs',
        value: function loadSuburbs() {
            var _this = this;

            if (this.address.postcode && this.address.postcode.length === 4) {
                return this.addressService.getSuburbs(this.address.postcode).then(function (suburbs) {
                    _this.suburbs = suburbs;
                    if (_this.suburbs && _this.suburbs.length) {
                        _this.setSuburb(_this.suburbs[0]);
                    }
                });
            } else if (this.address.postcode && this.address.postcode.length !== 4) {
                this.suburbs = null;
                this.address.suburb = null;
            }
            return this.$q.reject();
        }
    }, {
        key: 'validateInput',
        value: function validateInput(address) {
            if (!address.street1 || address.street1.length > this.settings.oneSite.maxCharactersManualAddress1) return false;
            if (!address.postcode) return false;
            if (!address.suburbId) return false;
            return true;
        }
    }, {
        key: 'saveManualAddress',
        value: function saveManualAddress() {
            var _this2 = this;

            var event = new TealiumEventBuilder().withScreenName(this.screenName).withLabel('Button/link click').withValue('Save').withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withEventName('modal_interaction').withTrackingType('link').build();

            this.analyticsService.push(event);

            if (this.validateInput(this.address)) {
                this.addressService.saveManualAddress(this.address).then(function (addressResponse) {
                    var address = addressResponse.Address;
                    if (!address || !address.AreaId) {
                        _this2.fulfilmentSelectorService.isNotServiced = true;
                        var notServicedEvent = new TealiumEventBuilder().withScreenName('FulfilmentSelection').withEventType(_this2.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog).withAction('click').withLabel('Non serviced address').withEventName('error').withValue(_this2.address.suburb + ' ' + _this2.address.postcode).withTrackingType('link').build();
                        _this2.analyticsService.push(notServicedEvent);
                        // return to previous screen.
                        _this2.fulfilmentService.manualAddress = address;
                        _this2.fulfilmentService.selectedFulfilmentMethod = _this2.fulfilmentService.fulfilmentOptions.delivery;
                        _this2.fulfilmentSelectorService.currentStep = _this2.fulfilmentSelectorService.fulfilmentSelectorStepConfirm;
                    } else {
                        _this2.fulfilmentSelectorService.isNotServiced = false;
                        // save and continue.
                        _this2.saveFulfilment(address);
                    }
                });
            }
        }
    }, {
        key: 'saveFulfilment',
        value: function saveFulfilment(address) {
            this.fulfilmentService.saveFulfilment({
                fulfilmentMethod: 'Courier',
                address: address,
                fulfilmentWindow: { time: null },
                billingAddressId: null
            });

            this.fulfilmentService.savedAddress = address;
            this.fulfilmentService.selectedFulfilmentMethod = this.fulfilmentService.fulfilmentOptions.delivery;

            this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.startShopping;
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
        }
    }]);

    return FulfilmentSelectorManualAddressController;
}();

FulfilmentSelectorManualAddressController.$inject = ['$q', 'Settings', 'AddressService', 'AnalyticsService', 'FulfilmentService', 'FulfilmentSelectorService'];

var fulfilmentSelectorManualAddressComponentDefinition = {
    controller: FulfilmentSelectorManualAddressController,
    template: __webpack_require__(1047).trim()
};

module.exports = {
    FulfilmentSelectorManualAddressController: FulfilmentSelectorManualAddressController,
    fulfilmentSelectorManualAddressComponentDefinition: fulfilmentSelectorManualAddressComponentDefinition
};

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports = "<form name=\"$ctrl.fulfilmentSelectorManualAddressForm\" class=\"fulfilmentSelectorManualAddress\" novalidate>\r\n    <div class=\"fulfilmentSelectorManualAddress-inputContainer\">\r\n        <wow-notification-message class=\"fulfilmentSelectorManualAddress-notification\" title=\"{{ $ctrl.settings.fulfilmentSelector.remoteOrderNotificationTitle }}\" message=\"{{ $ctrl.settings.fulfilmentSelector.remoteOrderNotificationMessage }}\" container-classes=\"fulfilmentSelectorManualAddress-notificationContainer notificationMessage-container--small\" is-dismissible=\"true\" on-Dismiss=\"$ctrl.onDismissRegionalNotification()\" is-visible=\"$ctrl.showRegionalNotification\" type=\"info\"></wow-notification-message>\r\n        <!-- street address 1 input -->\r\n        <wow-input-container class=\"fulfilmentSelectorManualAddress-input\">\r\n            <label for=\"fulfilmentSelectorManualAddress-street1\">\r\n                {{::$ctrl.settings.fulfilmentSelector.manualAddressStreet1InputLabel}} *\r\n            </label>\r\n            <input\r\n                type=\"text\"\r\n                id=\"fulfilmentSelectorManualAddress-street1\"\r\n                name=\"street1\"\r\n                ng-model=\"$ctrl.address.street1\"\r\n                ng-maxlength=\"{{::$ctrl.settings.oneSite.maxCharactersManualAddress1}}\"\r\n                autocomplete=\"off\"\r\n                ng-model-options=\"{ updateOn: 'blur' }\"\r\n                required/>\r\n            <span ng-messages=\"$ctrl.fulfilmentSelectorManualAddressForm.street1.$error\" class=\"wowInput-errors fulfilmentSelectorManualAddress-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error fulfilmentSelectorManualAddress-errors size\">\r\n                    Street address is required.\r\n                </span>\r\n                <span ng-message=\"maxlength\" class=\"wowInput-error fulfilmentSelectorManualAddress-errors size\">\r\n                    {{$ctrl.settings.oneSite.maxCharactersManualAddress1}} characters limit is exceeded.\r\n                </span>\r\n            </span>\r\n        </wow-input-container>\r\n\r\n        <!-- street address 2 input -->\r\n        <wow-input-container class=\"fulfilmentSelectorManualAddress-input\">\r\n            <label for=\"fulfilmentSelectorManualAddress-street2\">\r\n                {{::$ctrl.settings.fulfilmentSelector.manualAddressStreet2InputLabel}}\r\n            </label>\r\n            <input\r\n                type=\"text\"\r\n                id=\"fulfilmentSelectorManualAddress-street2\"\r\n                name=\"street2\"\r\n                ng-model=\"$ctrl.address.street2\"\r\n                ng-maxlength=\"{{::$ctrl.settings.oneSite.maxCharactersManualAddress2}}\"\r\n                ng-model-options=\"{ updateOn: 'blur' }\"/>\r\n            <span ng-messages=\"$ctrl.fulfilmentSelectorManualAddressForm.street2.$error\" class=\"wowInput-errors fulfilmentSelectorManualAddress-errors\">\r\n                <span ng-message=\"maxlength\" class=\"wowInput-error fulfilmentSelectorManualAddress-errors size\">\r\n                    {{::$ctrl.settings.oneSite.maxCharactersManualAddress2}} characters limit is exceeded.\r\n                </span>\r\n            </span>\r\n        </wow-input-container>\r\n\r\n        <!-- postcode input -->\r\n        <wow-input-container class=\"fulfilmentSelectorManualAddress-input\">\r\n            <label for=\"fulfilmentSelectorManualAddress-postCode\">\r\n                {{::$ctrl.settings.fulfilmentSelector.manualAddressPostcodeInputLabel}} *\r\n            </label>\r\n            <input\r\n                type=\"tel\"\r\n                id=\"fulfilmentSelectorManualAddress-postCode\"\r\n                name=\"postCode\"\r\n                ng-model=\"$ctrl.address.postcode\"\r\n                ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 200, blur: 0 } }\"\r\n                ng-change=\"$ctrl.loadSuburbs()\"\r\n                autocomplete=\"off\"\r\n                wow-post-code\r\n                required/>\r\n            <span ng-messages=\"$ctrl.fulfilmentSelectorManualAddressForm.postCode.$error\" class=\"wowInput-errors fulfilmentSelectorManualAddress-errors\">\r\n                <span ng-message=\"required\" class=\"wowInput-error fulfilmentSelectorManualAddress-errors size\">\r\n                    {{::$ctrl.settings.fulfilmentSelector.manualAddressPostcodeInputLabel}} is required.\r\n                </span>\r\n                <span ng-message=\"invalid\" class=\"wowInput-error fulfilmentSelectorManualAddress-errors size\">\r\n                    {{::$ctrl.settings.fulfilmentSelector.manualAddressPostcodeInputLabel}} entered is invalid.\r\n                </span>\r\n            </span>\r\n        </wow-input-container>\r\n\r\n        <!-- suburb input -->\r\n        <wow-select-container class=\"wowInputContainer fulfilmentSelectorManualAddress-input\">\r\n            <label for=\"fulfilmentSelectorManualAddress-suburb\">\r\n                {{::$ctrl.settings.fulfilmentSelector.manualAddressSuburbInputLabel}} *\r\n            </label>\r\n            <select\r\n                name=\"suburb\"\r\n                id=\"fulfilmentSelectorManualAddress-suburb\"\r\n                ng-model=\"$ctrl.selectedSuburb\"\r\n                ng-change=\"$ctrl.setSuburb($ctrl.selectedSuburb)\"\r\n                ng-model-options=\"{ updateOn: 'default', getterSetter: true }\"\r\n                ng-options=\"s as s.Text for s in $ctrl.suburbs track by s.Id\"\r\n                ng-class=\"{'is-disabled': !$ctrl.suburbs.length}\">\r\n                <option value=\"\" ng-if=\"!$ctrl.suburbs.length\">\r\n                    Please enter a {{::$ctrl.settings.fulfilmentSelector.manualAddressPostcodeInputLabel}}\r\n                </option>\r\n            </select>\r\n        </wow-select-container>\r\n    </div>\r\n\r\n    <!-- submit button -->\r\n    <div class=\"fulfilmentSelectorManualAddress-buttonContainer\">\r\n        <button ng-click=\"$ctrl.saveManualAddress()\" class=\"button button--primary fulfilmentSelectorManualAddress-button\">\r\n            SAVE <i class=\"iconww-ArrowRight fulfilmentSelectorDialog-arrow\" />\r\n        </button>\r\n    </div>\r\n</form>\r\n"

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    find = _require.find,
    forEach = _require.forEach,
    trim = _require.trim,
    isEmpty = _require.isEmpty;

var TealiumEventBuilder = __webpack_require__(9);
var $ = __webpack_require__(2);

var FulfilmentSelectorService = function () {
    function FulfilmentSelectorService(settings, bootstrap, userPreferenceService) {
        _classCallCheck(this, FulfilmentSelectorService);

        this.settings = settings;
        this.bootstrap = bootstrap;
        this.userPreferenceService = userPreferenceService;

        this.init();
    }

    _createClass(FulfilmentSelectorService, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.isNotServiced = false;
            this.selectedPickupAddress = null;
            this.selectedDeliveryAddress = null;
            this.fulfilmentMethodPickupType = 'pickup';
            this.fulfilmentMethodDeliveryType = 'delivery';

            this.fulfilmentSelectorStepConfirm = 'CONFIRM';
            this.fulfilmentSelectorStepStartShopping = 'START_SHOPPING';
            this.fulfilmentSelectorStepManualAddress = 'MANUAL_ADDRESS';

            this.selectorFulfilmentOptions = [{
                name: 'Pick up',
                subheading: this.settings.fulfilmentSelector.pickupOptionSubheading,
                icon: 'iconww-Pickup',
                type: this.fulfilmentMethodPickupType,
                isSelected: false
            }, {
                name: 'Delivery',
                subheading: this.settings.fulfilmentSelector.deliveryOptionSubheading,
                icon: 'iconww-Delivery',
                type: this.fulfilmentMethodDeliveryType,
                isSelected: false
            }];

            this.fulfilmentSelectorSteps = {
                confirm: this.fulfilmentSelectorStepConfirm,
                startShopping: this.fulfilmentSelectorStepStartShopping,
                manualAddress: this.fulfilmentSelectorStepManualAddress
            };

            this.userPreferenceService.getUserPreference().then(function (userPreferences) {
                _this.currentStep = _this.isStepStartShoppingEnabled(userPreferences) ? _this.fulfilmentSelectorSteps.startShopping : _this.fulfilmentSelectorSteps.confirm;

                _this.shouldEnableFulfilmentSelectorStartShopping = !_this.isStepStartShoppingEnabled(userPreferences);
                _this.hasDismissedRegionalNotification = _this.isRegionalNotificationDismissed(userPreferences);
            });

            this.welcomeMessage = this.settings.fulfilmentSelector.welcomeMessage;

            var shopperInfo = this.bootstrap.getBootstrappedDataIfPresent(this.bootstrap.bootstrapped.Shopper);
            this.shopperName = shopperInfo && shopperInfo.FirstName ? shopperInfo.FirstName : '';

            this.currentlySubscribedToEsc = null;
        }
    }, {
        key: 'isStepStartShoppingEnabled',
        value: function isStepStartShoppingEnabled(userPref) {
            return !!userPref && !isEmpty(userPref) && userPref.FulfilmentSelectorStepStartShoppingEnabled;
        }
    }, {
        key: 'isRegionalNotificationDismissed',
        value: function isRegionalNotificationDismissed(userPref) {
            return !!userPref && !isEmpty(userPref) && userPref.HasDismissedRegionalNotification;
        }
    }, {
        key: 'setModalTitleMessage',
        value: function setModalTitleMessage(message) {
            this.modalTitleMessage = message;
        }
    }, {
        key: 'getSelectorFulfilmentOption',
        value: function getSelectorFulfilmentOption(fulfilmentOptionType) {
            return find(this.selectorFulfilmentOptions, function (o) {
                return o.type === fulfilmentOptionType;
            });
        }
    }, {
        key: 'updateSelectorFulfilmentOptions',
        value: function updateSelectorFulfilmentOptions(optionType) {
            forEach(this.selectorFulfilmentOptions, function (o) {
                o.isSelected = o.type === optionType;
            });
        }
    }, {
        key: 'getFullDeliveryAddress',
        value: function getFullDeliveryAddress(address) {
            if (isEmpty(address)) return '';

            var street1 = address.Street1 ? trim(address.Street1) + ', ' : '';
            var suburb = address.SuburbName ? trim(address.SuburbName) : '';
            var state = address.State ? trim(address.State) : '';
            var postCode = address.PostalCode ? trim(address.PostalCode) : '';
            var suburbStatePostcodeText = suburb + ' ' + state + ' ' + postCode;

            return '' + street1 + suburbStatePostcodeText;
        }
    }, {
        key: 'isFulfilmentMethodExisting',
        value: function isFulfilmentMethodExisting(fulfilmentMethod) {
            if (!fulfilmentMethod) return false;
            if (fulfilmentMethod === this.fulfilmentMethodDeliveryType) return true;
            if (fulfilmentMethod === this.fulfilmentMethodPickupType) return true;
            return false;
        }
    }, {
        key: 'getAddressToDisplay',
        value: function getAddressToDisplay(fulfilmentMethod, address) {
            if (!this.isFulfilmentMethodExisting(fulfilmentMethod) || isEmpty(address)) {
                return null;
            }

            var addressText = address.AddressText ? trim(address.AddressText) : '';
            var street1 = address.Street1 ? trim(address.Street1) : '';
            var suburb = address.SuburbName ? trim(address.SuburbName) : '';
            var state = address.State ? trim(address.State) : '';
            var postCode = address.PostalCode ? trim(address.PostalCode) : '';

            return {
                line1: fulfilmentMethod === this.fulfilmentMethodDeliveryType ? street1 : addressText,
                line2: fulfilmentMethod === this.fulfilmentMethodDeliveryType ? suburb + ' ' + state + ' ' + postCode : street1
            };
        }
    }, {
        key: 'setUserPreferenceFulfilmentSelectorStepStartShopping',
        value: function setUserPreferenceFulfilmentSelectorStepStartShopping(newValue) {
            this.userPreferenceService.setFulfilmentSelectorStepStartShopping(newValue);
        }
    }, {
        key: 'setDismissedRegionalNotificationPreference',
        value: function setDismissedRegionalNotificationPreference(newValue) {
            this.userPreferenceService.setDismissedRegionalNotificationPreference(newValue);
        }
    }, {
        key: 'subscribeEscPushAnalytics',
        value: function subscribeEscPushAnalytics(analyticsService, screenName) {
            this.unsubscribeEsc(this.currentlySubscribed);

            $(document).on('keyup', function (evt) {
                if (evt.keyCode === 27) {
                    var event = new TealiumEventBuilder().withScreenName(screenName).withLabel('ESC Button').withEventName('modal_interaction').build();

                    analyticsService.push(event);
                }
            });
            this.currentlySubscribedToEsc = screenName;
        }
    }, {
        key: 'unsubscribeEsc',
        value: function unsubscribeEsc(screenName) {
            if (this.currentlySubscribed === screenName) $(document).off('keyup');
        }
    }]);

    return FulfilmentSelectorService;
}();

FulfilmentSelectorService.$inject = ['Settings', 'BootstrapService', 'UserPreferenceService'];

module.exports = FulfilmentSelectorService;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(1050),
    FulfilmentTimeslotService = _require.FulfilmentTimeslotService;

var _require2 = __webpack_require__(1051),
    fulfilmentTimetableComponentDefinition = _require2.fulfilmentTimetableComponentDefinition;

var _require3 = __webpack_require__(1053),
    timeslotAlertComponentDefinition = _require3.timeslotAlertComponentDefinition;

angular.module('wowApp.fulfilment').service('FulfilmentTimeslotService', FulfilmentTimeslotService).component('wowFulfilmentTimetable', fulfilmentTimetableComponentDefinition).component('wowTimeslotAlert', timeslotAlertComponentDefinition);

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    forEach = _require.forEach;

var FulfilmentTimeslotService = function () {
    function FulfilmentTimeslotService(restangular) {
        _classCallCheck(this, FulfilmentTimeslotService);

        this._api = restangular.all('Timeslots');
    }

    _createClass(FulfilmentTimeslotService, [{
        key: 'listTimeslots',
        value: function listTimeslots(areaId, fulfilmentMethod) {
            var suburbId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var addressId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var getMergedResults = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

            return this._api.getList({
                areaId: areaId, fulfilmentMethod: fulfilmentMethod, suburbId: suburbId, getMergedResults: getMergedResults, addressId: addressId
            });
        }
    }, {
        key: 'findReservedWindow',
        value: function findReservedWindow(timeTable) {
            var reservedWindow = null;

            forEach(timeTable, function (date) {
                forEach(date.Times, function (time) {
                    if (time.IsReserved) {
                        reservedWindow = { date: date, time: time };
                        return false;
                    }

                    return true;
                });
            });

            return reservedWindow;
        }
    }]);

    return FulfilmentTimeslotService;
}();

FulfilmentTimeslotService.$inject = ['Restangular'];

module.exports = { FulfilmentTimeslotService: FulfilmentTimeslotService };

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    findIndex = _require.findIndex;

var FulfilmentTimetableController = function () {
    function FulfilmentTimetableController($filter, moveFocus, addressService, shopperService, settings, deliverySaverConstants, userPreferenceService) {
        _classCallCheck(this, FulfilmentTimetableController);

        this.$filter = $filter;
        this.moveFocus = moveFocus;
        this.addressService = addressService;
        this.shopperService = shopperService;
        this.settings = settings;
        this.deliverySaverConstants = deliverySaverConstants;
        this.userPreferenceService = userPreferenceService;
    }

    _createClass(FulfilmentTimetableController, [{
        key: '$onInit',
        value: function $onInit() {
            this.initialize();
            this.moveFocus('#fulfilmentTimetable');
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changed) {
            if (changed.timeTable) {
                this.selectFirstAvailableDate();
            }
        }
    }, {
        key: 'getFulfilmentMethod',
        value: function getFulfilmentMethod() {
            return this.isDelivery ? 'delivery' : this.settings.fulfilmentMethod.timetablePickupName;
        }
    }, {
        key: 'initialize',
        value: function initialize() {
            var _this = this;

            this.availableTimes = this.availableTimes || [];

            if (this.reservedDate) {
                this.savedTime = {
                    time: this.reservedTime,
                    date: this.reservedDate
                };
            }

            this.IsExpressDeliveryUnavailable = false;
            this.expressDeliveryUnavailableMessage = '';
            this.hasDismissedDeliveryPlusSuspendedNotification = false;
            this.hasDismissedDeliveryPlusDayOfWeekNotification = false;
            this.hasDismissedDeliveryPlusSameDayNotification = false;
            this.hasDismissedDeliveryPlusOptOutNotification = false;
            this.deliveryPlusCancelledNotificationDisabled = false;

            var deliveryPlusSubscriptionEndingDate = this.$filter('date')(this.shopperService.shopper.DeliveryPlusSubscriptionEndingDate, 'd MMMM, yyyy');
            this.optOutNotificationText = this.settings.deliverySaver.optOutNotificationText.replace('{{ EndDate }}', deliveryPlusSubscriptionEndingDate);
            this.cancelledNotificationText = this.settings.deliverySaver.cancelledNotificationText.replace('{{ DiscoverPageUrl }}', this.settings.deliverySaver.discoverPageUrl);

            this.userPreferenceService.getUserPreference().then(function (result) {
                // only show delivery plus cancelled notification once
                _this.deliveryPlusCancelledNotificationDisabled = result.DeliveryPlusCancelledNotificationDisabled;
                if (_this.shouldShowDeliveryPlusCancelledNotification()) {
                    _this.userPreferenceService.SetDeliveryPlusCancelledNotificationDisabled(true);
                }
            });
        }
    }, {
        key: 'selectFirstAvailableDate',
        value: function selectFirstAvailableDate() {
            var _this2 = this;

            if (this.timeTable && this.timeTable.length > 0) {
                this.initialize();

                // get index of first available date
                var index = this.savedDate && this.savedDeliveryWindowId ? findIndex(this.timeTable, function (deliveryWindow) {
                    return deliveryWindow.Date.substring(0, 11) === _this2.savedDate.substring(0, 11);
                }) : findIndex(this.timeTable, function (date) {
                    return date.Available;
                });

                // _.findIndex will return -1 if the date list is unretrievable.
                // This will set index to 0 if no dates are available.
                index = index > 0 ? index : 0;

                // set focus on the first available date or first item
                this.moveFocus('.fulfilmentTimetable-timeSelectorItem.available:first');

                this.selectedDate = this.timeTable[index];
                this.availableTimes = this.selectedDate.Times;

                this.IsExpressDeliveryUnavailable = this.selectedDate.IsExpressDeliveryExhausted;
                this.expressDeliveryUnavailableMessage = this.selectedDate.ExpressWindowClosedText;
            }
        }
    }, {
        key: 'saveSelectedDate',
        value: function saveSelectedDate(selectedDate) {
            if (this.onSetFulfilmentDate) {
                this.onSetFulfilmentDate({ selectedDate: selectedDate });
            }
            this.selectedDate = selectedDate;
            this.availableTimes = this.selectedDate.Times;
        }
    }, {
        key: 'setDate',
        value: function setDate(selectedDate) {
            this.selectedDate = selectedDate;
            this.availableTimes = this.selectedDate.Times;

            this.moveFocus(this.selectedDate.Available ? '#fulfilmentTimetableTime' : '.fulfilmentTimetable ._no-window');
        }
    }, {
        key: 'setTime',
        value: function setTime(fulfilmentTime) {
            this.saveSelectedDate(this.selectedDate);
            this.selectedTime = fulfilmentTime;

            if (this.onSetFulfilmentTime) {
                this.onSetFulfilmentTime({ fulfilmentTime: fulfilmentTime });
            }
        }
    }, {
        key: 'screenReaderLabelForDeliveryTime',
        value: function screenReaderLabelForDeliveryTime(fulfilmentTime) {
            var labelTxt = fulfilmentTime.TimeWindow + '.';
            var priceTxt = '';
            var isSelectedDateEligibleForDeliverySaver = this.selectedDate && this.selectedDate.EligibleForDeliverySaver;
            if (!isSelectedDateEligibleForDeliverySaver && fulfilmentTime.Price !== undefined) {

                if (!(fulfilmentTime.Price > 0) && !(this.selectedDate && this.selectedDate.DeliveryPlus.IsEligible)) {
                    priceTxt = ' free';
                } else {
                    var isDiscountedPrice = fulfilmentTime.SalePrice < fulfilmentTime.Price;
                    if (isDiscountedPrice) {
                        priceTxt = ' Was $' + fulfilmentTime.Price + ' now $' + fulfilmentTime.SalePrice;
                    } else {
                        priceTxt = ' $' + fulfilmentTime.Price;
                    }
                }
            } else {
                priceTxt = ' free';
            }

            if (fulfilmentTime.IsKeptOpenForRewardsPlus) {
                labelTxt = '' + labelTxt + priceTxt + '. Was ' + fulfilmentTime.NormalAllocationStatus + ', ';
                labelTxt = '' + labelTxt + this.settings.delivery.deliveryWindowReservedMessage + '. ';
            } else {
                labelTxt = '' + labelTxt + priceTxt + '. ' + fulfilmentTime.Status;
            }

            if (this.selectedTime === fulfilmentTime) {
                labelTxt += ' selected';
            }

            var needToConfirmReminder = 'Press enter to confirm your selection.';
            if (fulfilmentTime.Status !== 'Closed') {
                labelTxt += needToConfirmReminder;
            }
            return labelTxt;
        }
    }, {
        key: 'moveFocusToFirstTimeslot',
        value: function moveFocusToFirstTimeslot() {
            if (this.availableTimes.length > 0) {
                this.moveFocus('#' + this.availableTimes[0].Id);
            }
        }
    }, {
        key: 'hasTimetable',
        value: function hasTimetable() {
            return this.timeTable && this.timeTable.length > 0;
        }
    }, {
        key: 'shouldShowDeliveryPlusSuspendedNotification',
        value: function shouldShowDeliveryPlusSuspendedNotification() {
            return this.hasTimetable() && this.isDelivery && this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.SUSPENDED && !this.hasDismissedDeliveryPlusSuspendedNotification;
        }
    }, {
        key: 'shouldShowDeliveryPlusDayOfWeekNotification',
        value: function shouldShowDeliveryPlusDayOfWeekNotification() {
            return this.hasTimetable() && this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.ACTIVE && this.selectedDate && this.selectedDate.DeliveryPlus.IsIneligibleBecauseDayOfWeek && !this.hasDismissedDeliveryPlusDayOfWeekNotification;
        }
    }, {
        key: 'shouldShowDeliveryPlusSameDayNotification',
        value: function shouldShowDeliveryPlusSameDayNotification() {
            return this.hasTimetable() && this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.ACTIVE && this.selectedDate && this.selectedDate.DeliveryPlus.IsIneligibleBecauseSameDay && !this.selectedDate.DeliveryPlus.IsIneligibleBecauseDayOfWeek && !this.hasDismissedDeliveryPlusSameDayNotification;
        }
    }, {
        key: 'shouldShowDeliveryPlusOptOutNotification',
        value: function shouldShowDeliveryPlusOptOutNotification() {
            return this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.ACTIVE && this.shopperService.shopper.DeliveryPlusSubscriptionEndingDate && !this.hasDismissedDeliveryPlusOptOutNotification;
        }
    }, {
        key: 'shouldShowDeliveryPlusCancelledNotification',
        value: function shouldShowDeliveryPlusCancelledNotification() {
            return this.shopperService.shopper.DeliveryPlusSubscriptionStatus === this.deliverySaverConstants.SUBSCRIPTION_STATUS.CANCELLED && !this.deliveryPlusCancelledNotificationDisabled;
        }
    }, {
        key: 'onDismissDeliveryPlusSuspendedNotification',
        value: function onDismissDeliveryPlusSuspendedNotification() {
            this.hasDismissedDeliveryPlusSuspendedNotification = true;
        }
    }, {
        key: 'onDismissDeliveryPlusDayOfWeekNotification',
        value: function onDismissDeliveryPlusDayOfWeekNotification() {
            this.hasDismissedDeliveryPlusDayOfWeekNotification = true;
        }
    }, {
        key: 'onDismissDeliveryPlusSameDayNotification',
        value: function onDismissDeliveryPlusSameDayNotification() {
            this.hasDismissedDeliveryPlusSameDayNotification = true;
        }
    }, {
        key: 'onDismissDeliveryPlusOptOutNotification',
        value: function onDismissDeliveryPlusOptOutNotification() {
            this.hasDismissedDeliveryPlusOptOutNotification = true;
        }
    }]);

    return FulfilmentTimetableController;
}();

FulfilmentTimetableController.$inject = ['$filter', 'MoveFocus', 'AddressService', 'ShopperService', 'Settings', 'DeliverySaverConstants', 'UserPreferenceService'];

var fulfilmentTimetableComponentDefinition = {
    bindings: {
        timeTable: '<',
        reservedDate: '<',
        reservedTime: '<',
        onSetFulfilmentDate: '&?',
        onSetFulfilmentTime: '&?',
        savedDate: '@',
        savedDeliveryWindowId: '@',
        isDelivery: '<'
    },
    controller: FulfilmentTimetableController,
    template: __webpack_require__(1052).trim()
};

module.exports = {
    FulfilmentTimetableController: FulfilmentTimetableController,
    fulfilmentTimetableComponentDefinition: fulfilmentTimetableComponentDefinition
};

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fulfilmentTimetable\" id=\"fulfilmentTimetable\">\r\n\r\n    <div class=\"fulfilmentTimetable-error alert alert--info\" ng-if=\"$ctrl.IsExpressDeliveryUnavailable\">\r\n            <img src=\"/images/Checkout/DigitalPay/icon-warning.svg\"\r\n            class=\"fulfilmentTimetable-warning\">\r\n        <wow-setting setting-group=\"Cart\" setting-name=\"expressUnavailableHeader\" class=\"fulfilmentTimetable-warningHeading\"></wow-setting>\r\n        <div class=\"fulfilmentTimetable-warningMessage\">{{ $ctrl.expressDeliveryUnavailableMessage }}</div>\r\n    </div>\r\n\r\n    <p class=\"fulfilmentTimetable-heading heading5\" ng-if=\"$ctrl.timeTable\">Select a date and time for {{ ::$ctrl.getFulfilmentMethod() }}</p>\r\n\r\n    <wow-notification-message\r\n        ng-if=\"$ctrl.shouldShowDeliveryPlusSuspendedNotification()\"\r\n        title=\"{{$ctrl.settings.deliverySaver.suspendedNotificationTitle}}\"\r\n        message=\"{{$ctrl.settings.deliverySaver.suspendedNotificationText}}\"\r\n        container-classes=\"notificationMessage-container--small\"\r\n        type=\"warning\"\r\n        is-dismissible=\"true\"\r\n        on-dismiss=\"$ctrl.onDismissDeliveryPlusSuspendedNotification()\"\r\n    />\r\n    <wow-notification-message\r\n        ng-if=\"$ctrl.shouldShowDeliveryPlusDayOfWeekNotification()\"\r\n        title=\"{{$ctrl.settings.deliverySaver.dayOfWeekNotCoveredNotificationTitle}}\"\r\n        message=\"{{$ctrl.settings.deliverySaver.dayOfWeekNotCoveredNotificationText}}\"\r\n        container-classes=\"notificationMessage-container--small\"\r\n        type=\"warning\"\r\n        is-dismissible=\"true\"\r\n        on-dismiss=\"$ctrl.onDismissDeliveryPlusDayOfWeekNotification()\"\r\n    />\r\n    <wow-notification-message\r\n        ng-if=\"$ctrl.shouldShowDeliveryPlusSameDayNotification()\"\r\n        title=\"{{$ctrl.settings.deliverySaver.sameDayNotCoveredNotificationTitle}}\"\r\n        message=\"{{$ctrl.settings.deliverySaver.sameDayNotCoveredNotificationText}}\"\r\n        container-classes=\"notificationMessage-container--small\"\r\n        type=\"info\"\r\n        is-dismissible=\"true\"\r\n        on-dismiss=\"$ctrl.onDismissDeliveryPlusSameDayNotification()\"\r\n    />\r\n    <wow-notification-message\r\n        ng-if=\"::$ctrl.shouldShowDeliveryPlusOptOutNotification()\"\r\n        title=\"{{$ctrl.settings.deliverySaver.optOutNotificationTitle}}\"\r\n        message=\"{{$ctrl.optOutNotificationText}}\"\r\n        container-classes=\"notificationMessage-container--small\"\r\n        type=\"warning\"\r\n        is-dismissible=\"true\"\r\n        on-dismiss=\"$ctrl.onDismissDeliveryPlusOptOutNotification()\"\r\n    />\r\n    <wow-notification-message\r\n        ng-if=\"::$ctrl.shouldShowDeliveryPlusCancelledNotification()\"\r\n        title=\"{{$ctrl.settings.deliverySaver.cancelledNotificationTitle}}\"\r\n        message=\"{{$ctrl.cancelledNotificationText}}\"\r\n        container-classes=\"notificationMessage-container--small\"\r\n        type=\"error\"\r\n        is-dismissible=\"true\"\r\n    />\r\n\r\n    <wow-loading-spinner ng-if=\"$ctrl.timeTable && $ctrl.timeTable.length === 0 && !$ctrl.addressService.isNonServiced\"></wow-loading-spinner>\r\n\r\n    <div class=\"fulfilmentTimetable-timeSelector\" ng-if=\"$ctrl.timeTable && $ctrl.timeTable.length !== 0\">\r\n        <section class=\"fulfilmentTimetable-timeSelectorDate\" aria-labelledby=\"fulfilmentTimetableDate\" class=\"u-displayInline\">\r\n            <span id=\"fulfilmentTimetableDate\" class=\"sr-only\">Select a {{ ::$ctrl.getFulfilmentMethod() }} date</span>\r\n\r\n            <div class=\"fulfilmentTimetable-timeSelectorItem\"\r\n                ng-repeat=\"fulfilmentDate in $ctrl.timeTable\"\r\n                ng-class=\"{ disabled: !fulfilmentDate.Available, available: fulfilmentDate.Available }\">\r\n                <input type=\"radio\"\r\n                    class=\"wowRadio\"\r\n                    name=\"selectedDate\"\r\n                    id=\"{{ ::fulfilmentDate.Date | date:'yyyy-MM-dd' }}\"\r\n                    value=\"{{ ::fulfilmentDate.Date }}\"\r\n                    ng-click=\"::$ctrl.setDate(fulfilmentDate)\"\r\n                    ng-keydown=\"::($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.moveFocusToFirstTimeslot()\"\r\n                    ng-disabled=\"!fulfilmentDate.Available\"\r\n                    ng-checked=\"$ctrl.selectedDate.Date === fulfilmentDate.Date\">\r\n                <label for=\"{{ ::fulfilmentDate.Date | date:'yyyy-MM-dd' }}\" class=\"fulfilmentTimetable-label\" ng-bind-html=\"fulfilmentDate.DateText | sanitize\"></label>\r\n            </div>\r\n        </section>\r\n\r\n        <section aria-labelledby=\"fulfilmentTimetableTime\" class=\"fulfilmentTimetable-timeSelectorTime\" ng-if=\"$ctrl.selectedDate.Available\">\r\n            <span class=\"sr-only\" id=\"fulfilmentTimetableTime\">Select a {{ ::$ctrl.getFulfilmentMethod() }} time</span>\r\n            <div class=\"fulfilmentTimetable-timeSelectorItem\"\r\n                ng-repeat=\"fulfilmentTime in $ctrl.availableTimes\"\r\n                ng-class=\"{ disabled: !fulfilmentTime.Available }\">\r\n\r\n                <input type=\"radio\"\r\n                    class=\"wowRadio\"\r\n                    name=\"selectedTime\"\r\n                    id=\"{{ ::fulfilmentTime.Id }}\"\r\n                    value=\"{{ ::fulfilmentDate.Date }}\"\r\n                    ng-click=\"$ctrl.setTime(fulfilmentTime)\"\r\n                    ng-keydown=\"::($event.keyCode === 13 || $event.keyCode === 32) && $ctrl.setTime(fulfilmentTime)\"\r\n                    ng-disabled=\"!fulfilmentTime.Available\"\r\n                    ng-checked=\"::fulfilmentTime.Id == $ctrl.savedDeliveryWindowId\">\r\n                <label for=\"{{ ::fulfilmentTime.Id }}\" class=\"fulfilmentTimetable-label\"\r\n                        wow-event-recorder=\"click\"\r\n                        data-er-category=\"Delivery Window\"\r\n                        data-er-label=\"Select a date and time for delivery\"\r\n                        data-er-value=\"{{fulfilmentTime.IsExpress ? 'Express' : 'Standard'}}\">\r\n\r\n                   <span ng-if=\"!fulfilmentTime.IsExpress && $ctrl.isDelivery && fulfilmentTime.TimeWindowDurationHours===5\"\r\n                         ng-class=\"fulfilmentTime.Available ? 'fulfilmentTimetable-5hrWindowTag' : 'fulfilmentTimetable-5hrWindowTag disabled'\">\r\n                            <wow-setting setting-group=\"Delivery\" setting-name=\"FiveHoursWindowText\"></wow-setting>\r\n                   </span>\r\n\r\n                   <span ng-if=\"fulfilmentTime.IsExpress && $ctrl.isDelivery\" class=\"fulfilmentTimetable-DeliveryNowTag\">\r\n                        Delivery Now\r\n                   </span>\r\n\r\n                   <span class=\"sr-only\">{{ ::$ctrl.screenReaderLabelForDeliveryTime(fulfilmentTime) }}</span>\r\n                    {{::fulfilmentTime.TimeWindow}}\r\n                    <div ng-switch=\"::!($ctrl.selectedDate && ($ctrl.selectedDate.EligibleForDeliverySaver || $ctrl.selectedDate.DeliveryPlus.IsEligible) && !fulfilmentTime.IsExpress)\" tabindex=\"-1\" aria-hidden=\"true\">\r\n                        <span ng-switch-when=\"true\" class=\"fulfilmentTimetable-price\" ng-if=\"::(fulfilmentTime.SalePrice <= fulfilmentTime.Price)\" ng-class=\"::{'fulfilmentTimetable-obsoletePrice': fulfilmentTime.SalePrice < fulfilmentTime.Price}\">\r\n                            {{::(fulfilmentTime.Price | wowCurrencyFull)}}\r\n                        </span>\r\n                        <span ng-switch-when=\"true\" class=\"fulfilmentTimetable-saleprice\" ng-if=\"::(fulfilmentTime.SalePrice < fulfilmentTime.Price)\">\r\n                            {{::(fulfilmentTime.SalePrice | wowCurrencyFull)}}\r\n                        </span>\r\n                        <span ng-switch-when=\"true\" class=\"fulfilmentTimetable-premium\" ng-if=\"::(fulfilmentTime.SalePrice > fulfilmentTime.Price)\">\r\n                            {{::(fulfilmentTime.SalePrice | wowCurrencyFull)}}\r\n                        </span>\r\n                        <span ng-switch-when=\"false\" class=\"fulfilmentTimetable-price\" ng-if=\"$ctrl.selectedDate.EligibleForDeliverySaver && !$ctrl.selectedDate.DeliveryPlus.IsEligible\">\r\n                            FREE\r\n                        </span>\r\n                        <span ng-switch-when=\"false\" class=\"fulfilmentTimetable-price\" ng-if=\"$ctrl.selectedDate.DeliveryPlus.IsEligible\">\r\n                            {{::(fulfilmentTime.Price | wowCurrency)}} <!-- $0 -->\r\n                        </span>\r\n                    </div>\r\n\r\n                    <div class=\"fulfilmentTimetable-windowStatus\" tabindex=\"-1\" aria-hidden=\"true\"\r\n                    ng-if=\"!fulfilmentTime.IsKeptOpenForRewardsPlus\">\r\n                        {{::fulfilmentTime.Status}}\r\n                    </div>\r\n\r\n                    <div class=\"fulfilmentTimetable-windowStatus fulfilmentTimetable-strikethroughStatus\"\r\n                    tabindex=\"-1\" aria-hidden=\"true\" ng-if=\"fulfilmentTime.IsKeptOpenForRewardsPlus\">\r\n                        {{::fulfilmentTime.NormalAllocationStatus}}\r\n                    </div>\r\n\r\n                    <div ng-if=\"fulfilmentTime.IsKeptOpenForRewardsPlus\" class=\"fulfilmentTimetable-rewardsPlusMessage\">\r\n                        {{ $ctrl.settings.delivery.deliveryWindowReservedMessage }}\r\n                    </div>\r\n                </label>\r\n            </div>\r\n        </section>\r\n\r\n        <div class=\"fulfilmentTimetable-textOnly _no-window\" tabindex=\"-1\" ng-if=\"$ctrl.timeTable.length !== 0 && !$ctrl.selectedDate.Available\">\r\n            {{ $ctrl.availableTimes.length > 1 ? $ctrl.selectedDate.ClosedText : $ctrl.availableTimes[0].Status }}\r\n        </div>\r\n    </div>\r\n\r\n    <wow-notification-message\r\n        ng-if=\"!$ctrl.timeTable\"\r\n        is-dismissible=\"false\"\r\n        type=\"error\"\r\n        title=\"Unable to deliver\"\r\n        message=\"{{ $ctrl.settings.fulfilmentTimetable.noAvailableTimesMessage }}\"\r\n        class=\"fulfilmentTimetable-error\"\r\n        container-classes=\"notificationMessage-container--small\"\r\n    />\r\n</div>\r\n"

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TimeslotAlertController = function () {
    function TimeslotAlertController($scope, $timeout, settings, shopPageStateService, fulfilmentService) {
        var _this = this;

        _classCallCheck(this, TimeslotAlertController);

        this.$timeout = $timeout;
        this.settings = settings;

        this.shopPageStateService = shopPageStateService;
        this.fulfilmentService = fulfilmentService;

        $scope.$on('http:success', function () {
            return _this.scheduleReservationExpiredAlert();
        });
    }

    _createClass(TimeslotAlertController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.reservedTimeslot && this.reservedTimeslot.TimeWindow) {
                /* Values for debugging */

                // For debugging window cutoffs
                // this.reservedTimeslot.MinutesToCutOff = 15 / 60;
                // this.settings.deliveryWindowAlerts.closingSoonAlertPeriod = 10 / 60;
                // this.settings.deliveryWindowAlerts.closingNowAlertPeriod = 5 / 60;

                // For debugging window reservation expiry
                // this.settings.deliveryWindows.reservationTimeout = 1 / 60;

                /* end debug values */

                this.scheduleReservationExpiredAlert();

                // ORDER MATTERS HERE, if these fire at the same time (e.g. we are in both the closing now and closing soon period)
                this.scheduleTimeslotClosingSoonAlert();
                this.scheduleTimeslotClosingNowAlert();
                this.scheduleTimeslotClosedAlert();
            }
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.unscheduleAlerts();
        }
    }, {
        key: 'scheduleReservationExpiredAlert',
        value: function scheduleReservationExpiredAlert() {
            var _this2 = this;

            this.$timeout.cancel(this.reservationExpiryTimer);

            this.reservationExpiryTimer = this.scheduleAlert(function () {
                _this2.unscheduleAlerts();
                _this2.showAlert(_this2.settings.deliveryWindowAlerts.reservationExpiredAlertMessage);
                _this2.changeTimeslot();
            }, this.settings.deliveryWindows.reservationTimeout);
        }
    }, {
        key: 'scheduleTimeslotClosedAlert',
        value: function scheduleTimeslotClosedAlert() {
            var _this3 = this;

            this.$timeout.cancel(this.closedTimer);

            this.closedTimer = this.scheduleAlert(function () {
                _this3.showAlert(_this3.settings.deliveryWindowAlerts.closedAlertMessage);
                _this3.changeTimeslot();
                if (_this3.isExpress) _this3.isExpressClosed = true;
            }, this.reservedTimeslot.MinutesToCutOff);
        }
    }, {
        key: 'scheduleTimeslotClosingNowAlert',
        value: function scheduleTimeslotClosingNowAlert() {
            var _this4 = this;

            this.$timeout.cancel(this.closedTimer);

            this.closingNowTimer = this.scheduleAlert(function () {
                _this4.showAlert(_this4.settings.deliveryWindowAlerts.closingNowAlertMessage);
            }, this.reservedTimeslot.MinutesToCutOff - this.settings.deliveryWindowAlerts.closingNowAlertPeriod);
        }
    }, {
        key: 'scheduleTimeslotClosingSoonAlert',
        value: function scheduleTimeslotClosingSoonAlert() {
            var _this5 = this;

            this.$timeout.cancel(this.closingSoonTimer);

            this.closingSoonTimer = this.scheduleAlert(function () {
                _this5.showAlert(_this5.settings.deliveryWindowAlerts.closingSoonAlertMessage);
            }, this.reservedTimeslot.MinutesToCutOff - this.settings.deliveryWindowAlerts.closingSoonAlertPeriod);
        }
    }, {
        key: 'scheduleAlert',
        value: function scheduleAlert(callback, minutesFromNow) {
            return this.$timeout(callback, minutesFromNow * 60 * 1000);
        }
    }, {
        key: 'unscheduleAlerts',
        value: function unscheduleAlerts() {
            this.$timeout.cancel(this.reservationExpiryTimer);
            this.$timeout.cancel(this.closingNowTimer);
            this.$timeout.cancel(this.closingSoonTimer);
            this.$timeout.cancel(this.closedTimer);
            this.isExpressClosed = false;
        }
    }, {
        key: 'hideAlert',
        value: function hideAlert() {
            this.alertMessage = null;
        }
    }, {
        key: 'showAlert',
        value: function showAlert(alertMessage) {
            this.alertMessage = alertMessage;
        }
    }, {
        key: 'changeTimeslot',
        value: function changeTimeslot() {
            this.shopPageStateService.isCartOpen = true;
            this.fulfilmentService.changeFulfilmentTimeslot();
        }
    }]);

    return TimeslotAlertController;
}();

TimeslotAlertController.$inject = ['$scope', '$timeout', 'Settings', 'ShopPageStateService', 'FulfilmentService'];

var timeslotAlertComponentDefinition = {
    bindings: {
        reservedTimeslot: '<',
        isExpress: '<'
    },
    controller: TimeslotAlertController,
    template: __webpack_require__(1054).trim()
};

module.exports = {
    TimeslotAlertController: TimeslotAlertController,
    timeslotAlertComponentDefinition: timeslotAlertComponentDefinition
};

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports = "<wow-express-delivery-alert ng-if=\"$ctrl.isExpressClosed\"></wow-express-delivery-alert>\r\n<div class=\"timeslotAlert\"\r\n    ng-if=\"!$ctrl.isExpressClosed\" ng-show=\"$ctrl.alertMessage\" role=\"alert\">\r\n    <h4 class=\"timeslotAlert-heading\">\r\n        {{ ::$ctrl.settings.deliveryWindowAlerts.alertTitle }}\r\n    </h4>\r\n\r\n    <p>{{ $ctrl.alertMessage }}</p>\r\n\r\n    <button class=\"linkButton\" ng-click=\"$ctrl.hideAlert()\" type=\"button\">\r\n        OK, I understand<span class=\"sr-only\">, close message</span>\r\n    </button>\r\n</div>\r\n"

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wowApp = __webpack_require__(1).module('wowApp');

wowApp.config(['RestangularProvider', __webpack_require__(1056)]);
wowApp.config(['$urlMatcherFactoryProvider', __webpack_require__(1057).urlMatcherConfig]);
wowApp.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', __webpack_require__(1059)]);
wowApp.config(['$httpProvider', '$provide', __webpack_require__(1090)]);
wowApp.config(['$provide', __webpack_require__(1091)]);
wowApp.config(['$provide', __webpack_require__(1092)]);
wowApp.config(['$compileProvider', __webpack_require__(1093)]);
wowApp.config(['$ocLazyLoadProvider', __webpack_require__(1094)]);

wowApp.factory('RestangularV3', ['Restangular', __webpack_require__(1095)]);

wowApp.run(['$rootScope', '$state', 'ShopperService', 'LoginService', 'PageMetadataService', 'MemoScrollService', 'MoveFocus', 'AnalyticsService', 'Settings', '$window', __webpack_require__(1096)]);

// Setup Page Analytics.
wowApp.service('PageAnalytics', ['AnalyticsService', '$rootScope', '$location', '$window', '$document', 'BreakpointsService', 'ShopperService', 'ShopperAnalyticsService', __webpack_require__(1105)]);

// Run Initial Page Load Analytics.
wowApp.run(['PageAnalytics', 'Settings', __webpack_require__(1106)]);

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

module.exports = function restAngularConfiguration(RestangularProvider) {
    RestangularProvider.setBaseUrl('/apis/ui');
    RestangularProvider.setRestangularFields({ id: 'Stockcode' });
    RestangularProvider.setDefaultHeaders({ __RequestVerificationToken: angular.element('input[name="__RequestVerificationToken"]').attr('value') || 'no request verification token' });
};

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(1058),
    filterType = _require.filterType;

function urlMatcherConfig($urlMatcherFactoryProvider) {
    $urlMatcherFactoryProvider.caseInsensitive(true);
    $urlMatcherFactoryProvider.strictMode(false);

    $urlMatcherFactoryProvider.type('filter', filterType);
}

module.exports = { urlMatcherConfig: urlMatcherConfig };

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    map = _require.map,
    reduce = _require.reduce,
    isObject = _require.isObject;

var filterType = {

    /**
     * Encodes a filter object into a URL friendly string to be used in query params.
     *
     * @param {object} filter - A filter object for Olympic Search.
     * @returns {string}
     */
    encode: function encode(filter) {
        if (!filter) {
            return '';
        }

        return map(filter.filters, function (_ref) {
            var Key = _ref.Key,
                Items = _ref.Items;
            return Key + '(' + Items.map(function (i) {
                return i.Term;
            }).join(',') + ')';
        }).join(';');
    },


    /**
     * Decodes a filter param from the URL into a filter object for Olympic Search.
     *
     * @param {string} filterParam - Filter parameter of the format 'Key1(Term,Term);Key2(Term,Term)'
     * @returns {object}
     */
    decode: function decode(filterParam) {
        if (!filterParam) {
            return { filters: [] };
        }

        return {
            filters: reduce(filterParam.split(';'), function (filters, filterString) {
                // matches eg 'Category(1_03F7B3C,1_03F7B3C)' -> ['Category(1_03F7B3C,1_03F7B3C)', 'Category', '1_03F7B3C,1_03F7B3C']
                var parts = filterString.match(/([a-z]+)\(([a-z0-9_\-, '&.]+)\)/i);

                if (parts && parts.length === 3) {
                    filters.push({
                        Key: parts[1],
                        Items: parts[2].split(',').map(function (i) {
                            return { Term: i };
                        })
                    });
                }
                return filters;
            }, [])
        };
    },
    is: function is(item) {
        return isObject(item) && 'filters' in item;
    }
};

module.exports = { filterType: filterType };

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var leftPanel = __webpack_require__(1060).trim(),
    centerPanel = __webpack_require__(17).trim(),
    rightPanel = __webpack_require__(20).trim();

module.exports = function ($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.hashPrefix('!');

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });

    // Configuring the stateProvider is actually quite expensive and so in tests, the below feature is 'enabled'
    // This is a HACK, temporary. Should be replaced with mocking stateProvider or switching routing library.
    if (window.wowFeatures.isEnabled('route-config-test-mode')) {
        return;
    }

    // Declares the root state
    __webpack_require__(1061)($stateProvider);

    // If you add a route here that doesn't exist on the old site (ShopController)
    // you must also add it to RouteConfig.cs to prevent errors.
    $stateProvider.state('shop', {
        url: '/shop?accessToken',
        parent: 'root',
        onEnter: ['$stateParams', '$state', function ($stateParams, $state) {
            if ($stateParams.accessToken) {
                $state.go('root');
            }
        }],
        views: {
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-generic-instrumentation></wow-rr-generic-instrumentation>'
            },
            'content@root': {
                template: leftPanel + ' ' + centerPanel + ' ' + rightPanel
            }
        }
    }).state('shop.trackmyorder', {
        url: '/trackmyorder?OrderNumber',
        resolve: {
            authenticationMethod: ['ShopperService', function (shopperService) {
                return shopperService.getAuthenticationMethod();
            }]
        },
        onEnter: ['$state', 'ShopperService', 'authenticationMethod', function ($state, shopperService, authenticationMethod) {
            if (!shopperService.IsGuest && authenticationMethod.AuthenticationMethod !== 'RememberMe') {
                $state.transition.then(function () {
                    return $state.go('shop.myaccount.trackmyorder.orderId', { orderId: $state.params.OrderNumber }, { location: 'replace' });
                });
            }
        }],
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'center-panel@shop.trackmyorder': {
                controller: ['$stateParams', function ($stateParams) {
                    this.orderNumber = parseInt($stateParams.OrderNumber);
                }],
                controllerAs: '$ctrl',
                template: '<wow-trackmyorder-guest-form order-number="$ctrl.orderNumber"></wow-trackmyorder-guest-form>'
            }
        }
    }).state('shop.unsubscribeedm', {
        url: '/unsubscribeedm?shopperID&checksum&documentID',
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'center-panel@shop.unsubscribeedm': {
                template: '<wow-unsubscribe-edm></wow-unsubscribe-edm>'
            }
        }
    });

    // Feature routes
    __webpack_require__(1063)($stateProvider);
    __webpack_require__(1064)($stateProvider);
    __webpack_require__(1065)($stateProvider);
    __webpack_require__(1066)($stateProvider);
    __webpack_require__(1067)($stateProvider);
    __webpack_require__(1068)($stateProvider);
    __webpack_require__(1069)($stateProvider);
    __webpack_require__(1071)($stateProvider);
    __webpack_require__(1072)($stateProvider);
    __webpack_require__(1074)($stateProvider);
    __webpack_require__(1075)($stateProvider);
    __webpack_require__(1076)($stateProvider);
    __webpack_require__(1077)($stateProvider);
    __webpack_require__(1078)($stateProvider);
    __webpack_require__(1079)($stateProvider);
    __webpack_require__(1080)($stateProvider);
    __webpack_require__(1081)($stateProvider);
    __webpack_require__(1082)($stateProvider);
    __webpack_require__(1083)($stateProvider);
    __webpack_require__(1084)($stateProvider);
    __webpack_require__(1085)($stateProvider);
    __webpack_require__(1086)($stateProvider);
    __webpack_require__(1087)($stateProvider);

    // Other states
    __webpack_require__(1089)($stateProvider);

    $urlRouterProvider.otherwise('/resourcenotfound');
};

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports = "<div id=\"left-panel\" class=\"shop-leftPanel\" tabindex=\"-1\" ui-view=\"left-panel\"></div>\r\n"

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var shop = __webpack_require__(1062).trim(),
    centerPanel = __webpack_require__(17).trim(),
    rightPanel = __webpack_require__(20).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('root', {
        url: '',
        data: {
            pageMetadata: ['PageMetadataService', function (pageMetadataService) {
                return pageMetadataService.getMetadata(null, false, null, 'Home');
            }]
        },
        views: {
            '@': {
                template: shop
            },
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'center-panel@root': {
                template: '<wow-rr-carousel placement-id="home_page.carousel" support-compact="false"></wow-rr-carousel>'
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-home-instrumentation page-group="Homepage" placement-ids="home_page.carousel"></wow-rr-home-instrumentation>'
            },
            'notification-panel@root': {
                template: '<wow-notification-panel></wow-notification-panel>'
            }
        }
    });
};

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=\"rr-instrumentation-panel\"></div>\r\n<div ui-view=\"notification-panel\"></div>\r\n\r\n<div id=\"header-panel\" class=\"shop-header\">\r\n    <wow-header></wow-header>\r\n</div>\r\n\r\n<div id=\"content-container\" class=\"shop-content\" ui-view=\"content\"></div>\r\n\r\n<wow-footer></wow-footer>\r\n"

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.support', {
        url: '/support',
        views: {
            'left-panel@shop': {
                template: '<wow-accessibility-nav-links></wow-accessibility-nav-links>'
            }
        },
        data: {
            authenticate: false
        }
    }).state('shop.support.accessibility', {
        url: '/accessibility',
        views: {
            'center-panel@shop': {
                template: '<wow-shopper-accessibility></wow-shopper-accessibility>'
            }
        },
        data: {
            authenticate: false
        },
        onEnter: ['AnalyticsService', function (analyticsService) {
            analyticsService.push({ type: analyticsService.mapperTypes.content.general });
        }]
    });
};

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.addtotrolley', {
        url: '/addtotrolley?{stockcode}&{quantity:int}&{source}',
        onEnter: ['ShelfProductService', '$stateParams', '$state', function (shelfProductService, $stateParams, $state) {
            if ($stateParams.stockcode && $stateParams.quantity) {
                shelfProductService.addItemToTrolley($stateParams.stockcode, $stateParams.quantity, $stateParams.source).then(function () {
                    return $state.go('root');
                });
            } else {
                $state.go('root');
            }
        }]
    });
};

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(17).trim(),
    rightPanel = __webpack_require__(20).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.authentication', {
        abstract: true,
        onExit: ['LoginService', function (loginService) {
            // If the state was navigated to as a result of a prompt for login,
            // we need to reject the promise for the prompt when we exit the login panel.
            // If the login is successful, the promise should already have been resolved and
            // this will do nothing.
            loginService.rejectPromptForLogin();
        }],
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            }
        },
        data: {
            onAuthReturnToState: 'root'
        }
    }).state('shop.authentication.login', {
        url: '/securelogin?redirect',
        params: {
            toState: null,
            toStateParams: null,
            toStateOptions: { reload: false },
            customCallback: null
        },
        onEnter: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
            // When toState is not specified in the stateParams use
            // previous state, if available, for redirection.
            if (!$stateParams.toState && $rootScope.onAuthRedirectedState) {
                $stateParams.toState = $rootScope.onAuthRedirectedState.name;
                $stateParams.toStateParams = $rootScope.onAuthRedirectedStateParams;
            }
        }],
        resolve: {
            authenticationMethod: ['ShopperService', function (shopperService) {
                return shopperService.getAuthenticationMethod().then(function (result) {
                    return result.AuthenticationMethod;
                });
            }]
        },
        views: {
            'center-panel': {
                controller: ['$scope', '$state', '$stateParams', '$timeout', 'authenticationMethod', function ($scope, $state, $stateParams, $timeout, authenticationMethod) {
                    this.authenticationMethod = authenticationMethod;

                    $scope.$on('login:success', function () {
                        if ($stateParams.customCallback) {
                            $stateParams.customCallback();
                        } else {
                            // Redirect with a page load in a timeout to make sure other 'login:success'
                            // handlers also get to run
                            $timeout(function () {
                                // redirect query param will be injected to the user when the user is logged out from SSR pages.
                                window.location.href = $stateParams.redirect || ($stateParams.toState ? $state.href($stateParams.toState, $stateParams.toStateParams, $stateParams.toStateOptions) || '/' : '/');
                            }, 0, false);
                        }
                    });
                }],
                controllerAs: '$ctrl',
                template: '<wow-login-page authentication-method="$ctrl.authenticationMethod"></wow-login-page>'
            }
        },
        data: {
            pageMetadata: {
                title: 'Woolworths Supermarket - Buy Groceries Online',
                metaDescription: 'Woolworths Supermarket - Buy Groceries Online',
                metaRobot: 'noindex'
            }
        }
    }).state('shop.authentication.signup', {
        url: '/signup?id&token',
        params: {
            toState: null,
            toStateParams: null,
            toStateOptions: { reload: false },
            customCallback: null
        },
        views: {
            'center-panel': {
                controller: ['$scope', '$state', '$stateParams', '$timeout', function ($scope, $state, $stateParams, $timeout) {
                    $scope.$on('signup:success', function () {
                        if ($stateParams.customCallback) {
                            $stateParams.customCallback();
                        } else {
                            // Redirect with a page load in a timeout to make sure other 'signup:success'
                            // handlers also get to run
                            $timeout(function () {
                                window.location.href = $stateParams.toState ? $state.href($stateParams.toState.name || $stateParams.toState, $stateParams.toStateParams, $stateParams.toStateOptions) || '/' : '/';
                            }, 0, false);
                        }
                    });
                }],
                template: '<wow-signup-page></wow-signup-page>'
            }
        }
    })
    // Reset password
    .state('shop.authentication.resetpassword', {
        url: '/resetpassword?passwordResetToken',
        views: {
            'center-panel': {
                controller: ['$stateParams', function ($stateParams) {
                    this.passwordResetToken = $stateParams.passwordResetToken;
                }],
                controllerAs: '$ctrl',
                template: '<wow-reset-password password-reset-token="{{::$ctrl.passwordResetToken}}"></wow-reset-password>'
            }
        }
    })
    // Forgot password
    .state('shop.authentication.forgotpassword', {
        url: '/forgotpassword',
        views: {
            'center-panel': {
                template: '<wow-login-forgot-password></wow-login-forgot-password>'
            }
        }
    });
};

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = __webpack_require__(27),
    categoryLevels = _require.categoryLevels,
    _require2 = __webpack_require__(0),
    find = _require2.find;

var browseRouteConfigBuilder = function browseRouteConfigBuilder(level, uriParam, parentParam) {
    var _resolve;

    return {
        url: '/:' + uriParam,
        reloadOnSearch: false,
        resolve: (_resolve = {}, _defineProperty(_resolve, uriParam, ['$stateParams', parentParam, function ($stateParams, parentCategory) {
            // Find the category object matching the url friendly name in the url.
            // Searches all of the states at the given state level (department, category, subcategory).
            // At department level this is the top level categories..
            if (parentCategory && parentCategory.Children) {
                return find(parentCategory.Children, { UrlFriendlyName: $stateParams[uriParam] });
            }
            return undefined;
        }]), _defineProperty(_resolve, 'isRestricted', ['ShopperService', uriParam, function (shopperService, category) {
            return shopperService.IsGuest && category && category.IsRestricted;
        }]), _resolve),
        onEnter: ['$state', 'CategoriesService', 'LoginService', 'ShopperService', 'isRestricted', categoryLevels[0], uriParam, function ($state, categoriesService, loginService, shopperService, isRestricted, department, category) {
            if (shopperService.IsGuest && !category && !department && department.IsSpecial) {
                $state.transition.then(function () {
                    if ($state.includes('**.' + uriParam)) {
                        loginService.promptForLogin(loginService.LoginToViewCategoryMessage);
                    }
                });
            } else if (!category) {
                $state.go('root', null, { location: 'replace' });
            } else if (isRestricted) {
                $state.transition.then(function () {
                    if ($state.includes('**.' + uriParam)) {
                        loginService.promptForLogin(loginService.LoginToViewCategoryMessage);
                    }
                });
            } else {
                categoriesService.currentCategories.pushCategory(category);
            }
        }],
        onExit: ['CategoriesService', function (categoriesService) {
            categoriesService.currentCategories.popCategory();
        }],
        views: {
            'center-panel@shop': {
                controller: [uriParam, 'isRestricted', '$state', 'RichRelevanceService', function (category, isRestricted, $state, richRelevanceService) {
                    this.category = category;
                    this.isRestricted = isRestricted;
                    this.$state = $state;
                    if (category && category.NodeLevel) {
                        if (category.NodeId === richRelevanceService.mySpecialsGroupId) {
                            this.dynamicPlacementId = richRelevanceService.mySpecialsPlacement;
                        } else if (category.RichRelevanceId) {
                            this.dynamicPlacementId = richRelevanceService.specialsGroupPlacement;
                        } else {
                            this.dynamicPlacementId = richRelevanceService.getPlacementByCategoryLevel(category.NodeLevel);
                        }
                    }
                }],
                controllerAs: '$ctrl',
                template: '\n                    <wow-tile-list-with-content>\n                        <wow-browse-tile-list\n                            ng-if="::!$ctrl.isRestricted"\n                            category="$ctrl.category"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy"\n                            filter="$ctrl.$state.params.filter"\n                            token="$ctrl.$state.params.token">\n                        </wow-browse-tile-list>\n\n                        <wow-rr-carousel dynamic-placement-id="$ctrl.dynamicPlacementId"></wow-rr-carousel>\n                    </wow-tile-list-with-content>\n                '
            },
            'left-panel@shop': {
                controller: [categoryLevels[0], parentParam, uriParam, function (departmentCategory, parentCategory, category) {
                    this.departmentCategory = departmentCategory;
                    this.category = category.Children.length ? category : parentCategory;
                    this.isSpecial = category.IsSpecial;
                    this.isBundle = category.IsBundle;
                }],
                controllerAs: '$ctrl',
                template: '<wow-browse-left-panel department-category="$ctrl.departmentCategory" category="$ctrl.category" is-special="$ctrl.isSpecial" is-bundle="$ctrl.isBundle" ng-if="!$breakpoints.isInSmallFormat"></wow-browse-left-panel>'
            },
            'rr-instrumentation-panel@root': {
                controller: [uriParam, '$state', function (category, $state) {
                    this.category = category;
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '<wow-rr-category-instrumentation page-group="Category" page-number="$state.params.pageNumber" current-category="$ctrl.category"></wow-rr-category-instrumentation>'
            }
        }
    };
};

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.browse', {
        url: '/browse?{pageNumber:int}&{sortBy}&{filter:filter}&{filterOpen:bool}&{openFilter:string}&{token}',
        abstract: true,
        resolve: {
            departments: ['CategoriesService', function (categoriesService) {
                return categoriesService.getAll().then(function (categories) {
                    return { Children: categories };
                });
            }]
        }
    }).state('shop.browse.department', browseRouteConfigBuilder(0, categoryLevels[0], 'departments')).state('shop.browse.department.category', browseRouteConfigBuilder(1, categoryLevels[1], categoryLevels[0])).state('shop.browse.department.category.subcategory', browseRouteConfigBuilder(2, categoryLevels[2], categoryLevels[1]));
};

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(17).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.cart', {
        url: '/cart',
        views: {
            'content@root': {
                template: '' + centerPanel
            },
            'center-panel@shop.cart': {
                template: '<wow-cart></wow-cart>'
            }
        },
        data: {
            pageMetadata: {
                title: 'Shopping Cart - Woolworths Online',
                metaDescription: 'Shopping Cart - Woolworths Online',
                metaRobot: 'noindex'
            }
        }
    });
};

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(17).trim(),
    rightPanel = __webpack_require__(20).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.catalogue', {
        url: '/catalogue',
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            }
        },
        data: {
            optOutOfScrollRestore: true
        }
    });
};

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var checkoutTemplate = __webpack_require__(1070).trim(),
    centerPanel = __webpack_require__(17).trim(),
    rightPanel = __webpack_require__(20).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('checkoutroot', {
        abstract: true,
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('checkout');
            }]
        },
        views: {
            '@': {
                template: checkoutTemplate
            }
        },
        data: {
            authenticate: true
        }
    })
    // Have you forgotten
    .state('hyf', {
        url: '^/shop/checkout',
        parent: 'checkoutroot',
        onEnter: ['CheckoutStepService', function (checkoutStepService) {
            checkoutStepService.currentStep = 'hyf';
        }],
        views: {
            'checkout-content@checkoutroot': {
                controller: ['$state', 'HaveYouForgottenService', 'FeatureService', function ($state, haveYouForgottenService, featureService) {
                    if (featureService.isEnabled(featureService.features.rrShowPlacementsInHyfPages)) {
                        this.products = {};
                    } else {
                        haveYouForgottenService.getProducts().then(function (response) {
                            if (!response.length) {
                                $state.go('checkout', null, { location: 'replace' });
                            }
                        });
                    }
                }],
                template: '<wow-have-you-forgotten></wow-have-you-forgotten>',
                resolve: {
                    skipHaveYouForgottenSettings: ['$state', 'SettingsByBreakpointService', function ($state, settingsByBreakpointService) {
                        var shouldSkipHaveYouForgotten = settingsByBreakpointService.getSettingValueByBreakpoint('OneSite', {
                            largeFormat: 'SkipHaveYouForgottenLargeFormatEnabled',
                            mediumFormat: 'SkipHaveYouForgottenMediumFormatEnabled',
                            smallFormat: 'SkipHaveYouForgottenSmallFormatEnabled'
                        });

                        if (shouldSkipHaveYouForgotten) {
                            $state.go('checkout', null, { location: 'replace' });
                        }
                    }]
                }
            },
            'rr-instrumentation-panel@checkoutroot': {
                template: '<wow-rr-generic-instrumentation page-group="Hyf" placement-ids="generic_page.have_you_forgotten"></wow-rr-generic-instrumentation>'
            }
        },
        data: {
            pageMetadata: {
                title: 'Have You Forgotten',
                metaDescription: 'Have You Forgotten',
                metaRobot: 'noindex'
            }
        }
    })
    // Conversational Checkout Wizard routes
    .state('checkout', {
        url: '/checkout',
        parent: 'checkoutroot',
        views: {
            'checkout-content@checkoutroot': {
                template: '<wow-checkout-wizard></wow-checkout-wizard>'
            }
        },
        resolve: {
            useAngular2PlusCheckout: ['$q', '$window', 'Settings', function ($q, $window, settings) {
                if (settings.frontendManagement && settings.frontendManagement.useAngular2PlusCheckout) {
                    $window.location.assign('/checkout'); // Go from this SPA to the Angular2+ SPA
                    return $q.reject(); // Don't continue entering this state
                }
                return $q.resolve();
            }]
        },
        onEnter: ['CheckoutStepService', function (checkoutStepService) {
            if (checkoutStepService.canReviewOrder()) {
                checkoutStepService.setCurrentStep('review');
            } else {
                checkoutStepService.setCurrentStep('delivery');
            }
        }],
        data: {
            pageMetadata: {
                title: 'Checkout - Woolworths Online',
                metaDescription: 'Checkout - Woolworths Online',
                metaRobot: 'noindex'
            }
        }
    }).state('shop.confirmation', {
        url: '/confirmation?orderId&saveCard',
        resolve: {
            orderConfirmation: ['$ocLazyLoad', '$injector', '$stateParams', function ($ocLazyLoad, $injector, $stateParams) {
                return $ocLazyLoad.load('checkout').then(function () {
                    var checkoutService = $injector.get('CheckoutService');
                    return checkoutService.getOrderConfirmation($stateParams.orderId);
                });
            }],
            rewardsActivationGuid: [
            // Needed to load wow-my-rewards-plus-offer-link (dynamic content)
            '$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('myaccount');
            }]
        },
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'rr-instrumentation-panel@root': {
                controller: ['$scope', 'orderConfirmation', function ($scope, orderConfirmation) {
                    $scope.order = orderConfirmation.Order;
                }],
                template: '<wow-rr-purchased-instrumentation order="order"></wow-rr-purchased-instrumentation>'
            },
            'center-panel@shop.confirmation': {
                controller: ['$stateParams', 'orderConfirmation', function ($stateParams, orderConfirmation) {
                    this.orderConfirmation = orderConfirmation;
                    this.isSaveCard = Boolean($stateParams.saveCard);
                }],
                controllerAs: '$ctrl',
                template: '<wow-order-confirmation-panel order="$ctrl.orderConfirmation" save-card="$ctrl.isSaveCard"></wow-order-confirmation-panel>'
            }
        },
        data: {
            authenticate: true
        }
    });
};

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout-base\">\r\n    <h1 class=\"sr-only\">Checkout</h1>\r\n\r\n    <div ui-view=\"rr-instrumentation-panel\"></div>\r\n    <wow-checkout-header></wow-checkout-header>\r\n\r\n    <div ui-view=\"checkout-content\">\r\n    </div>\r\n</div>"

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    var _ = __webpack_require__(0),
        authenticationHandler = __webpack_require__(520),
        checkIfComingSoon = ['$state', 'Settings', function ($state, settings) {
        if (!(settings.deliverySaver && settings.deliverySaver.isEnabled && settings.payment && settings.payment.enableDigitalPay)) {
            $state.go('shop.deliveryplus.comingsoon');
        }
    }];

    $stateProvider.state('shop.deliveryplus', {
        url: '/deliveryplus',
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('deliverysaver');
            }],
            navigationItems: ['InspirationService', function (inspirationService) {
                return inspirationService.getNavigationItems();
            }],
            authMethod: ['ShopperService', function (shopperService) {
                return shopperService.getAuthenticationMethod().then(function (response) {
                    return response.AuthenticationMethod;
                });
            }]
        },
        onEnter: ['$state', '$q', 'LoginService', 'authMethod', _.partialRight(authenticationHandler, 'Please login to continue')],
        views: {
            'left-panel@shop': {
                controller: ['navigationItems', function (navigationItems) {
                    this.menuItems = navigationItems;
                }],
                controllerAs: '$ctrl',
                template: '<wow-inspiration-navigation ng-if="!$breakpoints.isInSmallFormat" menu-items="$ctrl.menuItems"></wow-inspiration-navigation>'
            },
            'center-panel@shop': {
                controller: ['$state', 'Settings', '$location', function ($state, settings, $location) {
                    if (!(settings.deliverySaver && settings.deliverySaver.isEnabled && settings.payment && settings.payment.enableDigitalPay)) {
                        $state.go('shop.deliveryplus.comingsoon');
                    } else {
                        $location.path(settings.deliverySaver.discoverPageUrl);
                    }
                }],
                controllerAs: '$ctrl',
                template: '<wow-delivery-saver-plan-selection class=""></wow-delivery-saver-plan-selection>'
            }
        },
        data: {
            authenticate: true,
            pageMetadata: ['PageMetadataService', function (pageMetadataService) {
                return pageMetadataService.getMetadata({
                    name: 'Delivery Plus | Woolworths'
                });
            }]
        }
    }).state('shop.deliveryplus.comingsoon', {
        url: '/comingsoon',
        onEnter: ['$location', 'Settings', function ($location, settings) {
            if (settings.deliverySaver && settings.deliverySaver.isEnabled && settings.payment && settings.payment.enableDigitalPay) {
                $location.path(settings.deliverySaver.discoverPageUrl);
            }
        }],
        views: {
            'center-panel@shop': {
                template: '<wow-delivery-saver-coming-soon></wow-delivery-saver-coming-soon>'
            }
        }
    }).state('shop.deliveryplus.planselection', {
        url: '/planselection',
        onEnter: checkIfComingSoon,
        views: {
            'center-panel@shop': {
                template: '<wow-delivery-saver-plan-selection class=""></wow-delivery-saver-plan-selection>'
            }
        }
    }).state('shop.deliveryplus.paymentsetup', {
        url: '/paymentsetup?planId',
        onEnter: checkIfComingSoon,
        views: {
            'center-panel@shop': {
                template: '<wow-delivery-saver-payment-setup class=""></wow-delivery-saver-payment-setup>'
            }
        }
    }).state('shop.deliveryplus.confirmation', {
        url: '/confirmation?subscriptionId',
        views: {
            'center-panel@shop': {
                template: '<wow-delivery-saver-confirmation class=""></wow-delivery-saver-confirmation>'
            }
        },
        params: {
            data: {}
        }
    }).state('shop.deliveryplus.paymentupdate', {
        url: '/paymentupdate',
        views: {
            'center-panel@shop': {
                template: '<wow-delivery-saver-payment-update class=""></wow-delivery-saver-payment-update>'
            }
        }
    });
};

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var embeddedBasePageTemplate = __webpack_require__(1073).trim();

module.exports = function ($stateProvider) {
    $stateProvider.state('embedded', {
        abstract: true,
        url: '/embedded',
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('embedded');
            }]
        },
        views: {
            '@': {
                template: embeddedBasePageTemplate
            }
        }
    })
    // login via agent
    .state('embedded.loginviaagent', {
        url: '/loginviaagent?linktoken&uid',
        views: {
            'embedded-base-content@embedded': {
                controller: ['$stateParams', 'EmbeddedService', function ($stateParams, embeddedService) {
                    var _this = this;

                    this.linkToken = $stateParams.linktoken;
                    this.uid = $stateParams.uid;

                    embeddedService.getDetails(this.linkToken).then(function (res) {
                        _this.companyName = res.CompanyName.toLowerCase();
                    });
                }],
                controllerAs: '$ctrl',
                template: '<wow-embedded-login-form link-token="$ctrl.linkToken" uid="$ctrl.uid" template="$ctrl.template" company-name="$ctrl.companyName" ng-if="$ctrl.companyName"></wow-embedded-login-form>'
            }
        }
    })
    // signup via agent
    .state('embedded.registerviaagent', {
        url: '/registerviaagent?linktoken&uid',
        views: {
            'embedded-base-content@embedded': {
                controller: ['$stateParams', 'EmbeddedService', function ($stateParams, embeddedService) {
                    var _this2 = this;

                    this.linkToken = $stateParams.linktoken;
                    this.uid = $stateParams.uid;

                    embeddedService.getDetails(this.linkToken).then(function (res) {
                        _this2.companyName = res.CompanyName.toLowerCase();
                    });
                }],
                controllerAs: '$ctrl',
                template: '<wow-embedded-signup-form link-token="$ctrl.linkToken" uid="$ctrl.uid" company-name="$ctrl.companyName" ng-if="$ctrl.companyName"></wow-embedded-signup-form>'
            }
        }
    })
    // signup via agent confirmation
    .state('embedded.registerviaagent.confirmation', {
        url: '/confirmation?name&email&mobile&birth&work&abn&company&address&shopperid&redirectToAgentUrl',
        views: {
            'embedded-base-content@embedded': {
                controller: ['$stateParams', 'EmbeddedService', function ($stateParams, embeddedService) {
                    var _this3 = this;

                    this.details = {
                        signupName: $stateParams.name,
                        signupEmail: $stateParams.email,
                        signupMobile: $stateParams.mobile,
                        signupWorkPhone: $stateParams.mobile,
                        signupAbn: $stateParams.abn,
                        signupCompanyName: $stateParams.company,
                        signupAddress: $stateParams.address,
                        signupBirth: $stateParams.birth,
                        redirectToAgentUrl: $stateParams.redirectToAgentUrl
                    };

                    this.linkToken = $stateParams.linktoken;

                    embeddedService.getDetails(this.linkToken).then(function (res) {
                        _this3.companyName = res.CompanyName.toLowerCase();
                    });
                }],
                controllerAs: '$ctrl',
                template: '<wow-embedded-signup-confirmation details="$ctrl.details" link-token="$ctrl.linkToken" company-name="$ctrl.companyName" ng-if="$ctrl.companyName"></wow-embedded-signup-confirmation>'
            }
        }
    });
};

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports = "<div ui-view=\"embedded-base-content\"></div>\r\n"

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(17).trim();

module.exports = function ($stateProvider) {
    var rootScopeListener = void 0;

    $stateProvider.state('error', {
        parent: 'root',
        abstract: true,
        views: {
            'content@root': {
                template: '' + centerPanel
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-error-instrumentation></wow-rr-error-instrumentation>'
            }
        },
        onEnter: ['AnalyticsService', '$rootScope', '$state', function (analyticsService, $rootScope, $state) {
            rootScopeListener = $rootScope.$on('$stateChangeSuccess', function () {
                analyticsService.push({
                    data: {
                        state: $state
                    },
                    type: analyticsService.mapperTypes.common.error
                });
            });
        }],
        onExit: [function () {
            rootScopeListener();
        }],
        data: {
            pageMetadata: {
                metaRobot: 'noindex'
            }
        }
    }).state('error.404', {
        url: '/resourcenotfound',
        views: {
            'center-panel': {
                template: '<wow-error-page error-page=\'404\'></wow-error-page>'
            }
        },
        data: {
            pageMetadata: ['PageMetadataService', function (pageMetadataService) {
                var currentMetaData = pageMetadataService.getCurrentMetadata();
                currentMetaData.meta404 = {
                    name: 'prerender-status-code',
                    content: '404'
                };
                currentMetaData.metaRobot = 'noindex';
                return currentMetaData;
            }]
        }
    }).state('error.500', {
        url: '/error',
        views: {
            'center-panel@error': {
                template: '<wow-error-page error-page=\'500\'></wow-error-page>'
            }
        }
    }).state('error.403', {
        url: '/unauthorisederror',
        views: {
            'center-panel@error': {
                template: '<wow-error-page error-page="403"></wow-error-page>'
            }
        }
    });
};

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inspirationRouteConfigBuilder = function inspirationRouteConfigBuilder(param) {
    return {
        url: '/:' + param,
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                <wow-inspiration-detail-tile-list\n                    page-id="$ctrl.$state.params.' + param + '">\n                </wow-inspiration-detail-tile-list>\n            '
            }
        }
    };
};

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.inspiration', {
        url: '/discover?{name}&{cardId:int}',
        resolve: {
            navigationItems: ['InspirationService', function (inspirationService) {
                return inspirationService.getNavigationItems();
            }]
        },
        onEnter: ['$state', '$timeout', 'FeatureService', 'AnalyticsService', 'navigationItems', function ($state, $timeout, featureService, analyticsService, navigationItems) {
            if (featureService.isEnabled(featureService.features.enableDiscoverLandingPage)) {
                analyticsService.push({ type: analyticsService.mapperTypes.content.general });
                return;
            }

            $state.transition.then(function () {
                if ($state.is('shop.inspiration')) {
                    $state.go('shop.inspiration.parent', { parent: navigationItems[0].UrlPart }, { location: 'replace' });
                }
            });
        }],
        views: {
            'left-panel@shop': {
                controller: ['navigationItems', function (navigationItems) {
                    this.menuItems = navigationItems;
                }],
                controllerAs: '$ctrl',
                template: '<wow-inspiration-navigation ng-if="!$breakpoints.isInSmallFormat" menu-items="$ctrl.menuItems"></wow-inspiration-navigation>'
            }
        },
        data: {
            pageMetadata: ['PageMetadataService', function (pageMetadataService) {
                return pageMetadataService.getMetadata({ name: 'Discover - Woolworths Online' });
            }]
        }
    }).state('shop.inspirationcard', {
        url: '/discover/card/{id}?name',
        views: {
            'center-panel@shop': {
                template: '<wow-loading-spinner></wow-loading-spinner>'
            },
            'left-panel@shop': {
                controller: ['$state', '$stateParams', 'InspirationService', function ($state, $stateParams, inspirationService) {
                    inspirationService.getDiscoverPathForCard($stateParams.id).then(function (pathToCard) {
                        if (pathToCard.Page === null || pathToCard.Page.Parent === null) {
                            $state.go('error.404', null, { location: 'replace' });
                        }

                        $state.go('shop.inspiration.parent.child', {
                            parent: pathToCard.Parent.Page.UrlPart,
                            child: pathToCard.Page.UrlPart,
                            cardId: $stateParams.id,
                            name: $stateParams.name
                        }, {
                            location: 'replace'
                        });
                    });
                }]
            }
        }
    }).state('shop.inspiration.parent', inspirationRouteConfigBuilder('parent')).state('shop.inspiration.parent.child', inspirationRouteConfigBuilder('child')).state('shop.inspiration.parent.child.grandchild', inspirationRouteConfigBuilder('grandchild'));
};

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.guestList', {
        url: '/suggestedlists?{pageNumber:int}&{sortBy}',
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('lists');
            }]
        },
        onEnter: ['$state', '$stateParams', 'Settings', 'ShopperService', 'SuggestedListService', function ($state, $stateParams, settings, shopperService, suggestedListService) {
            if (settings.lists.enableListHome || !shopperService.IsGuest) {
                $state.go('shop.list');
                return;
            }
            if ($stateParams.listId) {
                return;
            }
            // Navigate to first suggested list by default
            suggestedListService.listSuggestedLists().then(function () {
                var firstSuggestedList = suggestedListService.suggestedLists[0];
                // Do not keep history (replace) to prevent the user from going back to an empty page
                $state.go('shop.suggestedlists', { listId: firstSuggestedList.ID }, { location: 'replace' });
            });
        }],
        views: {
            'left-panel@shop': {
                template: '<wow-list-sidebar></wow-list-sidebar>'
            }
        },
        data: {
            pageMetadata: {
                title: 'Lists - Woolworths Online',
                metaDescription: 'Lists - Woolworths Online',
                metaRobot: 'noindex'
            }
        }
    }).state('shop.suggestedlists', {
        url: '/suggestedlists/{listId:int}?{pageNumber:int}&{sortBy}',
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('lists');
            }]
        },
        views: {
            'left-panel@shop': {
                template: '<wow-list-sidebar></wow-list-sidebar>'
            },
            'center-panel@shop': {
                controller: ['$stateParams', function ($stateParams) {
                    this.listId = $stateParams.listId;
                    this.pageNumber = $stateParams.pageNumber || 1;
                    this.sortBy = $stateParams.sortBy;
                }],
                controllerAs: '$ctrl',
                template: '<wow-suggested-list-tile-list list-id="$ctrl.listId" page-number="$ctrl.pageNumber" sort-by="$ctrl.sortBy"></wow-suggested-list-tile-list>'
            },
            'rr-instrumentation-panel@root': {
                controller: ['ShopperService', function (shopperService) {
                    this.isGuest = shopperService.IsGuest;
                }],
                controllerAs: '$ctrl',
                template: '<wow-rr-generic-instrumentation ng-if="!$ctrl.isGuest"></wow-rr-generic-instrumentation>'
            }
        }
    }).state('shop.list', {
        url: '/mylists?{pageNumber:int}&{sortBy}&{filter:filter}&{filterOpen:bool}&{openFilter:string}',
        reloadOnSearch: false,
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('lists');
            }]
        },
        onEnter: ['$state', 'Settings', 'ShopperService', '$timeout', function ($state, settings, shopperService, $timeout) {
            if (!settings.lists.enableListHome && shopperService.IsGuest) {
                $timeout(function () {
                    $state.go('shop.guestList');
                }, 50);
            }
        }],
        views: {
            'center-panel@shop': {
                controller: ['$state', 'Settings', function ($state, settings) {
                    this.$state = $state;
                    this.settings = settings;
                }],
                controllerAs: '$ctrl',
                template: '<wow-list-home ng-if="$ctrl.settings.lists.enableListHome"></wow-list-home>\n                        <wow-saved-lists-default-list\n                            ng-if="!$ctrl.settings.lists.enableListHome"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy"\n                            filter="$ctrl.$state.params.filter">\n                        </wow-saved-lists-default-list>'
            },
            'left-panel@shop': {
                controller: ['ShopperService', function (shopperService) {
                    this.shopperService = shopperService;
                }],
                controllerAs: '$ctrl',
                template: '<wow-list-sidebar ng-if="!$ctrl.shopperService.isGuest"></wow-list-sidebar>'
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-wishlist-instrumentation></wow-rr-wishlist-instrumentation>'
            }
        },
        data: {
            pageMetadata: {
                title: 'Lists - Woolworths Online',
                metaDescription: 'Lists - Woolworths Online',
                metaRobot: 'noindex'
            }
        }
    }).state('shop.list.reorder', {
        url: '/reorder',
        views: {
            'center-panel@shop': {
                template: '\n                        <wow-reorder-list></wow-reorder-list>\n                    '
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-generic-instrumentation page-group="reorder" placement-ids="generic_page.quick_reorder"></wow-rr-generic-instrumentation>'
            }
        }
    }).state('shop.list.pastshops', {
        url: '/pastshops/{orderId}',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                    this.orderId = $state.params.orderId === 'everything' ? $state.params.orderId : parseInt($state.params.orderId);
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-tile-list-with-content>\n                            <wow-past-shop-tile-list order-id="$ctrl.orderId"\n                                page-number="$ctrl.$state.params.pageNumber || 1"\n                                sort-by="$ctrl.$state.params.sortBy"\n                                filter="$ctrl.$state.params.filter">\n                            </wow-past-shop-tile-list>\n                        </wow-tile-list-with-content>\n                    '
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-mypage-instrumentation></wow-rr-mypage-instrumentation>'
            }
        }
    }).state('shop.list.edit', {
        url: '/{listId}',
        reloadOnSearch: false,
        resolve: {
            // Needed for Rewards check
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('myaccount');
            }]
        },
        views: {
            'left-panel@shop': {
                controller: ['$stateParams', function ($stateParams) {
                    this.listId = parseInt($stateParams.listId);
                    this.isRewardsList = $stateParams.listId === 'MyWoolworthsRewards';
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-list-edit\n                            list-id="$ctrl.listId"\n                            is-rewards-list="$ctrl.isRewardsList">\n                        </wow-list-edit>\n                    '
            },
            'center-panel@shop': {
                controller: ['$state', 'ShopperService', 'RewardsLoginService', function ($state, shopperService, rewardsLoginService) {
                    this.$state = $state;
                    this.isRewardsList = $state.params.listId === 'MyWoolworthsRewards';

                    // Redirect to Woolworths Rewards in My Account if they don't have one linked yet
                    if (this.isRewardsList && !shopperService.shopper.RewardsCardNumber) {
                        // Shopperservice is not reliable and may not catch some cases, so we need to do a fetch
                        rewardsLoginService.getRewardsCard().then(function (response) {
                            // No response = no card
                            if (!response) {
                                $state.go('shop.myaccount.woolworthsrewards', null, { location: 'replace' });
                            }
                        });
                    }
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-tile-list-with-content>\n                            <wow-saved-list-tile-list\n                                page-number="$ctrl.$state.params.pageNumber || 1"\n                                sort-by="$ctrl.$state.params.sortBy"\n                                list-id="$ctrl.$state.params.listId"\n                                is-rewards-list="$ctrl.isRewardsList"\n                                filter="$ctrl.$state.params.filter">\n                            </wow-saved-list-tile-list>\n                        </wow-tile-list-with-content>\n                    '
            }
        }
    }).state('shop.list.edit.freetext', {
        url: '/products?searchTerm',
        views: {
            'center-panel@shop': {
                controller: ['$stateParams', function ($stateParams) {
                    this.searchTerm = $stateParams.searchTerm;
                    this.pageNumber = $stateParams.pageNumber || 1;
                    this.sortBy = $stateParams.sortBy;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-tile-list-with-content>\n                            <wow-search-product-tile-list\n                                search-term="$ctrl.searchTerm"\n                                is-special="false"\n                                is-list="true"\n                                page-number="$ctrl.pageNumber"\n                                sort-by="$ctrl.sortBy">\n                            </wow-search-product-tile-list>\n                        </wow-tile-list-with-content>\n                    '
            }
        }
    });
};

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0),
    authenticationHandler = __webpack_require__(520);

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.myaccount', {
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load(['myaccount']);
            }],
            authMethod: ['ShopperService', function (shopperService) {
                return shopperService.getAuthenticationMethod().then(function (response) {
                    return response.AuthenticationMethod;
                });
            }]
        },
        url: '/myaccount',
        onEnter: ['$state', '$q', 'LoginService', 'authMethod', _.partialRight(authenticationHandler, 'Please reauthenticate before accessing My Account')],
        views: {
            'left-panel@shop': {
                template: '<wow-my-account-nav-links></wow-my-account-nav-links>'
            },
            'rr-instrumentation-panel@root': {
                template: '<wow-rr-mypage-instrumentation></wow-rr-mypage-instrumentation>'
            }
        },
        data: {
            authenticate: true,
            pageMetadata: {
                title: 'Account Details',
                metaDescription: 'Account Details'
            }
        }
    }).state('shop.myaccount.accessibility', {
        url: '/accessibility',
        views: {
            'center-panel@shop': {
                template: '<wow-shopper-accessibility></wow-shopper-accessibility>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.preferences', {
        url: '/preferences',
        views: {
            'center-panel@shop': {
                template: '<wow-my-account-shopper-preferences></wow-my-account-shopper-preferences>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.deliveryaddresses', {
        url: '/deliveryaddresses',
        views: {
            'center-panel@shop': {
                template: '<wow-my-account-delivery-addresses></wow-my-account-delivery-addresses>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.changepassword', {
        url: '/password',
        views: {
            'center-panel@shop': {
                template: '<wow-change-password></wow-change-password>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.woolworthsrewards', {
        url: '/woolworthsrewards',
        views: {
            'center-panel@shop': {
                template: '<wow-rewards></wow-rewards>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.trackmyorder', {
        url: '/trackmyorder?ordernumber',
        views: {
            'center-panel@shop': {
                controller: ['$stateParams', function ($stateParams) {
                    this.orderNumber = $stateParams.ordernumber;
                }],
                controllerAs: '$ctrl',
                template: '<wow-my-account-track-my-order order-number="$ctrl.orderNumber"></wow-my-account-track-my-order>'
            },
            'left-panel@shop': {
                template: '<wow-my-account-nav-links></wow-my-account-nav-links>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.trackmyorder.orderId', {
        url: '/:orderId'
    }).state('shop.myaccount.details', {
        url: '/details',
        views: {
            'center-panel@shop': {
                template: '<wow-my-account-details></wow-my-account-details>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.deliverysavers', {
        url: '/deliverypasses',
        views: {
            'center-panel@shop': {
                template: '<wow-my-account-delivery-savers></wow-my-account-delivery-savers>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.deliveryplus', {
        url: '/deliveryplus',
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load(['deliverysaver']);
            }]
        },
        views: {
            'center-panel@shop': {
                template: '<wow-my-delivery-saver></wow-my-delivery-saver>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.myorders', {
        url: '/myorders',
        views: {
            'center-panel@shop': {
                template: '<wow-my-orders></wow-my-orders>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.myinvoices', {
        url: '/myinvoices?{pageNumber:int}&{searchInvoice}&{startDate}&{endDate}',
        views: {
            'center-panel@shop': {
                template: '<wow-my-invoices></wow-my-invoices>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.paymentmethods', {
        url: '/paymentmethods',
        views: {
            'center-panel@shop': {
                template: '<wow-payment-methods></wow-payment-methods>'
            }
        },
        data: {
            authenticate: true
        }
    }).state('shop.myaccount.transactionhistory', {
        url: '/transactionhistory',
        views: {
            'center-panel@shop': {
                template: '<wow-transaction-history></wow-transaction-history>'
            }
        },
        data: {
            authenticate: true
        }
    });
};

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.new', {
        url: '/new?{pageNumber:int}&{sortBy}',
        reloadOnSearch: false,
        views: {
            'left-panel@shop': {
                template: '<wow-new-products-nav></wow-new-products-nav>'
            },
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-new-products-tile-list\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-new-products-tile-list>\n                    '
            }
        },
        data: {
            pageMetadata: {
                title: 'Shop New Products',
                metaDescription: 'Shop New Products'
            }
        }
    });
};

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.offergroup', {
        url: '/offergroup/{Id}?{pageNumber:int}&{sortBy}',
        reloadOnSearch: false,
        data: {
            pageMetadata: {
                title: 'Shop Offer Group',
                metaDescription: 'Shop Offer Group',
                metaRobot: 'noindex'
            }
        },
        views: {
            'left-panel@shop': {
                template: '<wow-product-group group-type="\'OfferGroup\'"></wow-product-group>',
                controller: ['$state', '$stateParams', 'OfferGroupService', function ($state, $stateParams, offerGroupService) {
                    return offerGroupService.selectOfferGroup($stateParams.Id).then(function (group) {
                        if (!group) {
                            $state.go('error.404', null, { location: 'replace' });
                        }
                        if (!isNaN($stateParams.Id)) {
                            $state.go('shop.offergroup', {
                                Id: group.Url,
                                name: $stateParams.name
                            }, { location: 'replace' });
                        }
                        return group;
                    });
                }]
            },
            'center-panel@shop': {
                controller: ['$state', 'OfferGroupService', function ($state, offerGroupService) {
                    this.$state = $state;
                    this.offerGroupService = offerGroupService;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-offer-group-tile-list\n                            ng-if="::$ctrl.offerGroupService.selectedGroup"\n                            offer-group-id="$ctrl.$state.params.Id"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-offer-group-tile-list>\n                    '
            }
        }
    });
};

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.page', {
        url: '/page/:scheduleKey'
    }).state('shop.embedded', {
        // this state is used for dynamic content pages which are embedded as iframes
        // in woolworths mobile applications
        url: '/embedded/:scheduleKey',
        views: {
            '@': {
                template: '<div style="height: 100%;" wow-hide-scroll wow-scrollbar><oly-dynamic-content oly-dc-url-schedule></oly-dynamic-content></div>'
            }
        }
    });
};

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(2);

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.partner', {
        url: '/partner/:id',
        views: {
            'left-panel@shop': {
                controller: ['BreakpointsService', '$scope', function (breakpointsService, $scope) {
                    $scope.showLeftPanel = function () {
                        return breakpointsService.isSmallFormat();
                    };
                }],
                template: '<wow-partner-small-format ng-if="showLeftPanel()"><wow-partner></wow-partner></wow-partner-small-format>'
            },
            'center-panel@shop': {
                template: '<wow-partner></wow-partner>'
            }
        },
        onEnter: function onEnter() {
            $('.center-content').css('position', 'relative');
        },
        onExit: function onExit() {
            $('.center-content').css('position', '');
        },

        data: {
            pageMetadata: ['$state', 'PartnerService', function ($state, partnerService) {
                return partnerService.getPartner($state.params.id).then(function (response) {
                    return {
                        title: response.PartnerDto.Name,
                        metaDescription: response.PartnerDto.Name
                    };
                });
            }]
        }
    }).state('shop.partnerbranch', {
        url: '/partnerbranch/:id',
        views: {
            'left-panel@shop': {
                controller: ['BreakpointsService', '$scope', function (breakpointsService, $scope) {
                    $scope.showLeftPanel = function () {
                        return breakpointsService.isSmallFormat();
                    };
                }],
                template: '<wow-partner-small-format ng-if="showLeftPanel()"></wow-partner-small-format>'
            }
        },
        data: {
            pageMetadata: ['$state', 'PartnerService', function ($state, partnerService) {
                return partnerService.getBranch($state.params.id).then(function (response) {
                    return {
                        title: response.PartnerBranchName,
                        metaDescription: response.PartnerBranchName
                    };
                });
            }]
        }
    }).state('shop.conveniencepack', {
        url: '/conveniencepack/:packId?{pageNumber:int}&{sortBy}',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', 'ProductGroupService', function ($state, productGroupService) {
                    this.$state = $state;

                    productGroupService.selectProductGroup($state.params.packId);
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-convenience-pack-tile-list\n                            pack-id="$ctrl.$state.params.packId"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-convenience-pack-tile-list>\n                    '
            }
        }
    });
};

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('print', {
        abstract: true,
        url: '/print',
        parent: 'root',
        views: {
            '@': {
                template: ''
            }
        }
    }).state('print.recipe', {
        url: '^/shop/printrecipe/{recipeId}',
        data: {
            pageMetadata: {
                title: 'Shop Print Recipe - Woolworths Online',
                metaDescription: 'Shop Print Recipe',
                metaRobot: 'noindex'
            }
        },
        resolve: {
            recipe: ['RecipeService', '$stateParams', function (recipeService, $stateParams) {
                return recipeService.getRecipe($stateParams.recipeId).then(function (recipe) {
                    return recipe;
                });
            }]
        },
        views: {
            '@': {
                controller: ['recipe', function (recipe) {
                    this.recipe = recipe;
                }],
                controllerAs: '$ctrl',
                template: '<wow-recipe-print recipe="$ctrl.recipe"></wow-recipe-print>'
            }
        }
    }).state('print.orderconfirmation', {
        url: '^/checkout/printconfirmation?{OrderID}',
        data: {
            pageMetadata: {
                title: 'Print Order Confirmation - Woolworths Online',
                metaDescription: 'Print Order Confirmation',
                metaRobot: 'noindex'
            }
        },
        resolve: {
            orderConfirmation: ['$ocLazyLoad', '$injector', '$stateParams', function ($ocLazyLoad, $injector, $stateParams) {
                return $ocLazyLoad.load('checkout').then(function () {
                    var checkoutService = $injector.get('CheckoutService');
                    return checkoutService.getOrderConfirmation($stateParams.OrderID);
                });
            }]
        },
        views: {
            '@': {
                controller: ['$scope', 'orderConfirmation', function ($scope, orderConfirmation) {
                    $scope.order = orderConfirmation.Order;
                }],
                template: '<wow-order-confirmation-print order="order"></wow-order-confirmation-print>'
            }
        }
    });
};

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(17).trim(),
    rightPanel = __webpack_require__(20).trim(),
    _require = __webpack_require__(0),
    assign = _require.assign,
    isUndefined = _require.isUndefined;


module.exports = function ($stateProvider) {
    var adobeParam = { cmpid: 'smaf014' };

    $stateProvider.state('shop.productdetails', {
        // temporary for old product description popup
        url: '/productdetails/{productId}/{productName}?{googleshop:bool}&{store_code:string}&{cmpid:string}&{reviewPageNumber:int}&{reviewSortBy}&{gclid}&{cvosrc}&{cvo_crid}&{cvo_campaign}',
        params: {
            product: null
        },
        data: {
            pageMetadata: ['DetailProductService', 'PageMetadataService', '$stateParams', 'Settings', 'StoreService', function (detailProductService, pageMetadataService, $stateParams, settings, storeService) {
                var storeCode = void 0;
                if ($stateParams.googleshop) {
                    storeCode = storeService.getStoreCode($stateParams);
                }
                return detailProductService.getProductDetail($stateParams.productId, null, null, null, settings.content.productDetailStoreInfo ? storeCode : null).then(function (details) {
                    return pageMetadataService.getMetadata({
                        name: (details.Product.Name + ' ' + details.Product.PackageSize).trim()
                    }, null, null, 'Product');
                });
            }]
        },
        onEnter: ['$state', '$window', '$timeout', '$stateParams', 'Settings', 'RichRelevanceService', 'ShopperService', 'FulfilmentService', 'StoreService', '$rootScope', '$location', function ($state, $window, $timeout, $stateParams, settings, richRelevanceService, shopperService, fulfilmentService, storeService, $rootScope, $location) {
            if (settings.content.productDetailStoreInfo) {
                if ($stateParams.googleshop) {

                    $rootScope.merchantHostedLocation = $location.path();

                    $rootScope.$watch(function () {
                        return $location.path();
                    }, function (newLocation) {
                        // when using browser back button from store locator, productDetails route is not triggered,
                        // so selected store is not updated. This code is triggered instead on browser back to compensate for this.
                        if ($rootScope.merchantHostedLocation === newLocation) {
                            var _storeCode = storeService.getStoreCode($stateParams);

                            storeService.getStore(_storeCode, 'SUPERMARKETS').then(function (store) {
                                storeService.setSelectedStore(store);
                            });
                        }
                    });
                    /**
                     * Change store location
                     * if store code parameter is supplied, set store to the provided store code
                     * else use the default store code from the setting.
                     */
                    var storeCode = storeService.getStoreCode($stateParams);

                    storeService.getStore(storeCode, 'SUPERMARKETS').then(function (store) {
                        storeService.setSelectedStore(store);
                    });

                    if (!$stateParams.cmpid) {
                        $timeout(function () {
                            return $state.go($state.current, assign($stateParams, adobeParam), { location: 'replace' });
                        });
                    }
                } else {
                    storeService.setSelectedStore(null);
                }
            }

            if ($stateParams.product) {
                richRelevanceService.rrItemDetailsPageRequest($stateParams.product.Stockcode, $stateParams.product.Source);
            }
        }],
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('productdetail');
            }]
        },
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'center-panel@shop.productdetails': {
                controller: ['DetailProductService', 'StoreService', '$stateParams', 'Settings', function (detailProductService, storeService, $stateParams, settings) {
                    var _this = this;

                    if ($stateParams.product) {
                        this.detail = { Product: $stateParams.product };
                    }
                    var storeCode = void 0;
                    if ($stateParams.googleshop) {
                        storeCode = storeService.getStoreCode($stateParams);
                    }

                    detailProductService.getProductDetail($stateParams.productId, null, null, null, settings.content.productDetailStoreInfo ? storeCode : null).then(function (detail) {
                        _this.detail = detail;
                        _this.isLoaded = true;
                        _this.showInstoreProduct = settings.content.productDetailStoreInfo ? !isUndefined($stateParams.googleshop) && $stateParams.googleshop : false;
                    });
                }],
                controllerAs: '$ctrl',
                template: '<wow-product-detail ng-if="$ctrl.detail" detail="$ctrl.detail" is-loaded="$ctrl.isLoaded" show-instore-product="$ctrl.showInstoreProduct"></wow-product-detail>'
            },
            'rr-instrumentation-panel@root': {
                controller: ['$stateParams', 'Settings', 'RichRelevanceService', function ($stateParams, settings, richRelevanceService) {
                    this.removeDuplicatedProducts = settings.richRelevance.removeDuplicatedProducts;
                    this.productId = $stateParams.productId;
                    this.productName = $stateParams.productName;
                    this.placementIds = richRelevanceService.itemPageRankOne + ', ' + richRelevanceService.itemPageRankTwo;
                }],
                controllerAs: '$ctrl',
                template: '<wow-rr-item-instrumentation ng-if="!$ctrl.removeDuplicatedProducts" page-group="Category" item-id="$ctrl.productId" item-name="$ctrl.productName" placement-ids="$ctrl.placementIds"></wow-rr-item-instrumentation>'
            }
        }
    });
};

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('shop.productgroup', {
        url: '/productgroup/{Id}?{pageNumber:int}&{sortBy}&{filter:filter}&{filterOpen:bool}&{openFilter:string}',
        reloadOnSearch: false,
        data: {
            pageMetadata: {
                title: 'Shop Product Group',
                metaDescription: 'Shop Product Group',
                metaRobot: 'noindex'
            }
        },
        views: {
            'left-panel@shop': {
                template: '<wow-product-group></wow-product-group>',
                controller: ['$state', '$stateParams', 'ProductGroupService', 'FeatureService', function ($state, $stateParams, productGroupService) {
                    return productGroupService.selectProductGroup($stateParams.Id).then(function (group) {
                        if (!group) {
                            $state.go('error.404', null, { location: 'replace' });
                        }
                        if (!isNaN($stateParams.Id)) {
                            $state.transitionTo('shop.productgroup', {
                                Id: group.Url,
                                id: $stateParams.id,
                                name: $stateParams.name
                            }, { location: 'replace' });
                        }
                        return group;
                    });
                }]
            },
            'center-panel@shop': {
                controller: ['$state', 'ProductGroupService', function ($state, productGroupService) {
                    this.$state = $state;
                    this.productGroupService = productGroupService;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-product-group-tile-list\n                            ng-if="::$ctrl.productGroupService.selectedGroup"\n                            product-group-id="$ctrl.$state.params.Id"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy"\n                            filter="$ctrl.$state.params.filter">\n                        </wow-product-group-tile-list>\n                    '
            }
        }
    });
};

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var centerPanel = __webpack_require__(17).trim(),
    rightPanel = __webpack_require__(20).trim();

module.exports = function ($stateProvider) {
    var _this = this;

    $stateProvider // Recipes
    .state('shop.recipes', {
        url: '/recipes?{pageNumber:int}&{sortBy}',
        resolve: {
            categories: ['RecipeCategoriesService', function (recipeCategoriesService) {
                return recipeCategoriesService.getAll();
            }]
        },
        views: {
            'left-panel@shop': {
                controller: ['RecipeCategoriesService', function (recipeCategoriesService) {
                    this.recipeCategoriesService = recipeCategoriesService;
                }],
                controllerAs: '$ctrl',
                template: '<wow-recipe-navigation ng-if="!$breakpoints.isInSmallFormat" current-category="$ctrl.recipeCategoriesService.currentCategory"></wow-recipe-navigation>'
            }
        },
        onExit: ['RecipeCategoriesService', function (recipeCategoriesService) {
            recipeCategoriesService.resetCurrentCategory();
        }]
    }).state('shop.recipes.recipenotfound', {
        url: '/recipenotfound',
        views: {
            'center-panel@shop': {
                template: '<wow-error-page error-page="\'recipeNotFound\'"></wow-error-page>'
            }
        },
        data: {
            shouldGetMetadata: false
        }
    }).state('shop.recipes.savedList', {
        url: '/mykeptrecipes',
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-recipe-list-tile-list\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-recipe-list-tile-list>\n                    '
            }
        }
    }).state('shop.recipes.noSavedRecipes', {
        url: '/nokeptrecipes'
    }).state('shop.recipes.category', {
        abstract: true,
        url: '/:category'
    }).state('shop.recipes.category.subCategory', {
        url: '/:subCategory',
        reloadOnSearch: false,
        onEnter: ['$stateParams', 'RecipeCategoriesService', function ($stateParams, recipeCategoriesService) {
            recipeCategoriesService.setCategoryByName($stateParams.category, $stateParams.subCategory);
        }],
        views: {
            'center-panel@shop': {
                controller: ['$state', 'RecipeCategoriesService', function ($state, recipeCategoriesService) {
                    this.$state = $state;
                    this.recipeCategoriesService = recipeCategoriesService;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-recipe-tile-list\n                            current-category="$ctrl.recipeCategoriesService.currentCategory"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-recipe-tile-list>\n                    '
            }
        },
        data: {
            pageMetadata: ['$state', 'PageMetadataService', 'RecipeCategoriesService', function ($state, pageMetadataService, recipeCategoryService) {
                var category = recipeCategoryService.getCategoryByName($state.params.category, $state.params.subCategory);
                return pageMetadataService.getMetadata({ name: category.aisle.Name }, false, '/Shop/Recipes/' + $state.params.category + '/' + $state.params.subCategory, 'RecipeCategory');
            }]
        }
    }).state('shop.recipedetail', {
        url: '/recipedetail/{recipeId}/{recipeTitle}',
        resolve: {
            recipe: ['$stateParams', 'RecipeService', function ($stateParams, recipeService) {
                return recipeService.getRecipe($stateParams.recipeId);
            }]
        },
        onEnter: ['$state', 'recipe', function ($state, recipe) {
            if (!recipe) {
                _this.$state.go('error.404', null, { location: 'replace' });
            }
        }],
        views: {
            'content@root': {
                template: centerPanel + ' ' + rightPanel
            },
            'center-panel@shop.recipedetail': {
                controller: ['recipe', function (recipe) {
                    this.recipe = recipe;
                }],
                controllerAs: '$ctrl',
                template: '<wow-recipe-detail recipe="$ctrl.recipe"></wow-recipe-detail>'
            }
        },
        data: {
            pageMetadata: ['RecipeService', 'PageMetadataService', 'config', '$stateParams', function (recipeService, pageMetadataService, config, $stateParams) {
                if (!$stateParams.recipeId) {
                    return pageMetadataService.getMetadata(null, null, null, 'Recipe');
                }

                return recipeService.getRecipe($stateParams.recipeId).then(function (details) {
                    return details ? pageMetadataService.getMetadata({ name: details.Title, site: config.SiteShortName }, null, '/Shop/Recipe', 'Recipe') : pageMetadataService.getMetadata(null, null, null, 'Recipe');
                });
            }]
        }
    });
};

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function ($stateProvider) {
    $stateProvider.state('shop.search', {
        url: '/search?{searchTerm}&{multisearchItems}&{pageNumber:int}&{sortBy}',
        onEnter: ['$q', '$state', '$stateParams', 'SearchPhraseActionService', 'SearchMultisearchService', 'SearchService', function ($q, $state, $stateParams, searchActionService, searchMultisearchService, searchService) {
            $q.all([searchActionService.getSearchPhraseAction($stateParams.searchTerm || ''), $state.transition, searchService.getSearchCounts($stateParams.searchTerm)]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 1),
                    searchAction = _ref2[0];

                if (searchAction && !searchMultisearchService.isSearchMultisearch()) {
                    return searchActionService.performSearchPhraseAction(searchAction);
                }

                return $q.resolve();
            }).then(function () {
                // If there are no *product* results for the search term but there are *other* results (specials, recipes, articles),
                // this will figure out which state to redirect to. This must be called after getting the search counts
                // in order to know which types of results are available for the search term.
                var nextState = searchService.determineStateToShow($stateParams.searchTerm, $stateParams.multisearchItems);

                if ($state.is('shop.search') && !$state.is(nextState.name)) {
                    $state.go(nextState.name, nextState.params, { location: 'replace' });
                }
            });
        }],
        views: {
            'left-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-navigation\n                            search-term="$ctrl.$state.params.searchTerm"\n                            multisearch-items="$ctrl.$state.params.multisearchItems"\n                            filter="$ctrl.$state.params.filter"\n                            disable-navigation-links="false">\n                        </wow-search-navigation>\n                    '
            },
            'rr-instrumentation-panel@root': {
                controller: ['$stateParams', '$scope', function ($searchParams, $scope) {
                    $scope.searchTerm = $searchParams.searchTerm;
                }],
                template: '<wow-rr-search-instrumentation search-term="searchTerm"></wow-rr-search-instrumentation>'
            }
        },
        data: {
            pageMetadata: ['$state', function ($state) {
                return $state.params.searchTerm ? {
                    title: $state.params.searchTerm + ' - Woolworths Online',
                    metaDescription: $state.params.searchTerm + ' - Woolworths Online',
                    metaRobot: 'noindex'
                } : {
                    title: 'Search - Woolworths Online',
                    metaDescription: 'Search - Woolworths Online',
                    metaRobot: 'noindex'
                };
            }],
            authenticate: ['SearchPhraseActionService', 'SearchMultisearchService', '$q', 'toParams', function (searchActionService, multisearchService, $q, toParams) {
                var isMultisearch = toParams.multisearchItems && multisearchService.isSearchTermPartOfMultisearchList(toParams.searchTerm, toParams.multisearchItems);
                if (toParams && toParams.searchTerm && !isMultisearch) {
                    return searchActionService.searchRequiresLogin(toParams.searchTerm);
                }

                return $q.when(false);
            }]
        }
    }).state('shop.search.products', {
        url: '/products?{filter:filter}&{filterOpen:bool}&{openFilter:string}',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-tile-list-with-content>\n                            <wow-search-product-tile-list\n                                search-term="$ctrl.$state.params.searchTerm"\n                                multisearch-items="$ctrl.$state.params.multisearchItems"\n                                is-special="false"\n                                is-list="false"\n                                page-number="$ctrl.$state.params.pageNumber || 1"\n                                sort-by="$ctrl.$state.params.sortBy"\n                                filter="$ctrl.$state.params.filter">\n                            </wow-search-product-tile-list>\n                        </wow-tile-list-with-content>\n                    '
            }
        }
    }).state('shop.search.specials', {
        url: '/specials?{filter:filter}&{filterOpen:bool}&{openFilter:string}',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-tile-list-with-content>\n                            <wow-search-product-tile-list\n                                search-term="$ctrl.$state.params.searchTerm"\n                                is-special="true"\n                                is-list="false"\n                                page-number="$ctrl.$state.params.pageNumber || 1"\n                                sort-by="$ctrl.$state.params.sortBy"\n                                filter="$ctrl.$state.params.filter">\n                            </wow-search-product-tile-list>\n                        </wow-tile-list-with-content>\n                    '
            }
        }
    }).state('shop.search.recipes', {
        url: '/recipes',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-recipe-tile-list\n                            search-term="$ctrl.$state.params.searchTerm"\n                            page-number="$ctrl.$state.params.pageNumber || 1"\n                            sort-by="$ctrl.$state.params.sortBy">\n                        </wow-search-recipe-tile-list>\n                    '
            }
        }
    }).state('shop.search.articles', {
        url: '/articles',
        reloadOnSearch: false,
        views: {
            'center-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-inspiration-tile-list\n                            search-term="$ctrl.$state.params.searchTerm"\n                            page-number="$ctrl.$state.params.pageNumber || 1">\n                        </wow-search-inspiration-tile-list>\n                    '
            }
        }
    }).state('shop.search.zero-result', {
        url: '/zeroresult',
        views: {
            'left-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-navigation\n                            search-term="$ctrl.$state.params.searchTerm"\n                            multisearch-items="$ctrl.$state.params.multisearchItems"\n                            filter="$ctrl.$state.params.filter"\n                            disable-navigation-links="true">\n                        </wow-search-navigation>\n                    '
            },
            'center-panel@shop': {
                template: '<wow-search-zero-results></wow-search-zero-results>'
            }
        }
    }).state('shop.search.external-result', {
        url: '/externalresult',
        views: {
            'left-panel@shop': {
                controller: ['$state', function ($state) {
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-search-navigation\n                            search-term="$ctrl.$state.params.searchTerm"\n                            multisearch-items="$ctrl.$state.params.multisearchItems"\n                            filter="$ctrl.$state.params.filter"\n                            disable-navigation-links="true">\n                        </wow-search-navigation>\n                    '
            },
            'center-panel@shop': {
                template: '<wow-search-external-result></wow-search-external-result>'
            }
        }
    });
};

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var leftPanel = __webpack_require__(1088).trim(),
    centerPanel = __webpack_require__(17).trim(),
    rightPanel = __webpack_require__(20).trim();

module.exports = function ($stateProvider) {
    var rootScopeListener = void 0;

    $stateProvider.state('shop.stores', {
        resolve: {
            google: ['GoogleMapService', function (googleMapService) {
                return googleMapService.loadMap();
            }],
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('stores');
            }]
        },
        views: {
            'content@root': {
                template: leftPanel + ' ' + centerPanel + ' ' + rightPanel
            }
        }
    }).state('shop.locator', {
        parent: 'shop.stores',
        url: '/storelocator',
        onEnter: ['$rootScope', '$state', 'StoreService', function ($rootScope, $state, storeService) {
            // this is a hack becaues onEnter doesn't fire if you move from
            // a child state to a parent state. Therefore we need to listen for all state changes
            // and unselect a store if we are arriving in this state.
            rootScopeListener = $rootScope.$on('$stateChangeSuccess', function () {
                if ($state.is('shop.locator')) {
                    storeService.setSelectedStore(undefined);
                }
            });
        }],
        onExit: [function () {
            rootScopeListener();
        }],
        views: {
            'left-panel': {
                controller: ['BreakpointsService', 'StoreFilterService', function (breakpointsService, storeFilterService) {
                    this.storeFilterService = storeFilterService;

                    this.showLeftPanel = function () {
                        return breakpointsService.isSmallFormat();
                    };
                }],
                controllerAs: 'storeLocatorLeftCtrl',
                template: '\n                        <wow-store-locator-search\n                            divisions="storeLocatorLeftCtrl.storeFilterService.divisions"\n                            facilities="storeLocatorLeftCtrl.storeFilterService.facilities">\n                        </wow-store-locator-search>\n                    '
            },
            'center-panel': {
                template: '<wow-store-locator-map></wow-store-locator-map>'
            }
        },
        data: {
            pageMetadata: ['PageMetadataService', function (pageMetadataService) {
                return pageMetadataService.getMetadata({ name: 'Stores' });
            }]
        }
    }).state('shop.locator.store', {
        url: '/:store',
        params: {
            storeDetails: null
        },
        onEnter: ['StoreService', '$state', '$stateParams', function (storeService, $state, $stateParams) {
            var storeInfo = storeService.getStoreInfoFromUrlParams($stateParams.store);

            if ($stateParams.storeDetails && storeService.urlParametersValid($stateParams.storeDetails, storeInfo)) {
                storeService.setSelectedStore($stateParams.storeDetails);
            } else if (storeInfo && storeInfo.storeNo) {
                storeService.getStore(storeInfo.storeNo, storeInfo.division).then(function (store) {
                    if (storeService.urlParametersValid(store, storeInfo)) {
                        storeService.setSelectedStore(store);
                    } else {
                        $state.go('error.404', null, { location: 'replace' });
                    }
                });
            } else {
                $state.go('error.404', null, { location: 'replace' });
            }
        }]
    }).state('shop.tripplanner', {
        parent: 'shop.stores',
        url: '/tripplanner?{destination}',
        views: {
            'left-panel': {
                controller: ['StoreFilterService', 'TripPlannerService', '$stateParams', function (storeFilterService, tripPlannerService, $stateParams) {
                    this.storeFilterService = storeFilterService;
                    this.tripPlannerService = tripPlannerService;
                    this.$stateParams = $stateParams;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-trip-planner-search\n                            divisions="$ctrl.storeFilterService.divisions"\n                            facilities="$ctrl.storeFilterService.facilities"\n                            destination="$ctrl.$stateParams.destination">\n                        </wow-trip-planner-search>\n                    '
            },
            'center-panel': {
                controller: ['TripPlannerService', function (tripPlannerService) {
                    this.tripPlannerService = tripPlannerService;
                }],
                controllerAs: '$ctrl',
                template: '\n                        <wow-trip-planner-map\n                            directions="$ctrl.tripPlannerService.directions"\n                            route-index="$ctrl.tripPlannerService.routeIndex"\n                            waypoint-stores="$ctrl.tripPlannerService.waypointStores"\n                            stores="$ctrl.tripPlannerService.stores"\n                            selected-store="$ctrl.tripPlannerService.selectedStore">\n                        </wow-trip-planner-map>\n                    '
            }
        }
    });
};

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports = "<div id=\"left-panel\" class=\"stores-leftPanel\" tabindex=\"-1\" ui-view=\"left-panel\"></div>\r\n"

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($stateProvider) {
    $stateProvider.state('diagnostics', {
        abstract: true,
        resolve: {
            modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                return $ocLazyLoad.load('diagnostics');
            }]
        }
    }).state('diagnostics.styleguide', {
        url: '/styleguide',
        views: {
            '@': {
                template: '<wow-styleguide></<wow-styleguide>'
            }
        },
        data: {
            pageMetadata: ['PageMetadataService', function (pageMetadataService) {
                return pageMetadataService.getMetadata({
                    name: 'Styleguide | Woolworths'
                });
            }]
        }
    }).state('diagnostics.settings', {
        url: '/settingsdiagnostics',
        views: {
            '@': {
                template: '<wow-missing-settings></wow-missing-settings>'
            }
        }
    });
};

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($httpProvider, $provide) {
    $provide.factory('http401Interceptor', ['$q', '$injector', '$window', 'LoadingIndicatorService', function ($q, $injector, $window, loadingIndicator) {
        return {
            responseError: function responseError(rejection) {
                var $rootScope = $injector.get('$rootScope');

                if (rejection.status === 401) {
                    var loginService = $injector.get('LoginService');

                    loginService.invalidateLogin();
                    $rootScope.$broadcast('session:timeout');
                    loadingIndicator.finishLoading();
                    loginService.promptForLogin(loginService.LoginToContinueMessage);
                }
                var $state = $injector.get('$state');
                if (rejection.status === 404) {
                    $rootScope.$broadcast('error');
                    $state.go('error.404', null, { location: 'replace' });
                }
                if (rejection.status === 500) {
                    $rootScope.$broadcast('error');
                    $state.go('error.500');
                }
                if (rejection.status === 403) {
                    $rootScope.$broadcast('error');
                    $state.go('error.403');
                }
                if (rejection.status === -1) {
                    // network error - shouldn't push them to any state.
                    $rootScope.$broadcast('offline');
                }

                return $q.reject(rejection);
            }
        };
    }]);

    $provide.factory('http200Interceptor', ['$rootScope', function ($rootScope) {
        return {
            response: function response(_response) {
                if (_response.status === 200) {
                    // Reset the reservation timer
                    $rootScope.$broadcast('http:success');
                }

                return _response;
            }
        };
    }]);

    $httpProvider.interceptors.push('http401Interceptor');
    $httpProvider.interceptors.push('http200Interceptor');
};

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

module.exports = function ($provide) {
    $provide.decorator('$state', ['$delegate', '$stateParams', '$injector', function ($state, $stateParams, $injector) {
        $state.shouldGetMetaData = function () {
            var toState = $state.current;
            return !toState.data || toState.data && toState.data.shouldGetMetadata !== false;
        };

        $state.getMetadata = function () {
            var toState = $state.current;
            if (toState.data && toState.data.pageMetadata) {
                return angular.isArray(toState.data.pageMetadata) ? $injector.invoke(toState.data.pageMetadata) : toState.data.pageMetadata;
            }

            return {
                title: '',
                metaDescription: ''
            };
        };

        $state.shouldAuthenticate = function (toState, toParams) {
            return $injector.invoke(toState.data.authenticate, undefined, { toParams: toParams });
        };
        return $state;
    }]);
};

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($provide) {
    $provide.decorator('$location', ['$delegate', function ($location) {
        $location.pathAndSearch = function () {
            var url = $location.url();
            if (url) {
                return url.split('#')[0];
            }

            return url;
        };

        return $location;
    }]);
};

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($compileProvider) {
    $compileProvider.debugInfoEnabled('wowIsDebuggingEnabled' in window ? !!window.wowIsDebuggingEnabled : true);
};

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ($ocLazyLoadProvider) {
    $ocLazyLoadProvider.config({
        modules: 'wowModules' in window ? window.wowModules : []
    });
};

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (Restangular) {
    return Restangular.withConfig(function (RestangularConfigurer) {
        return RestangularConfigurer.setBaseUrl('/api/v3/ui');
    });
};

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var angular = __webpack_require__(1);

var _require = __webpack_require__(0),
    some = _require.some,
    startsWith = _require.startsWith;

var SmartBanner = __webpack_require__(1097);

module.exports = function ($rootScope, $state, shopperService, loginService, pageMetadataService, memoScroll, moveFocus, analyticsService, settings, $window) {
    function promptForLogin(event, toState, toParams) {
        event.preventDefault();
        loginService.promptForLogin(loginService.LoginToContinueMessage, toState, toParams);
    }

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

        // this condition does not checkout the direct land on this homepage, Trader is already taking care about that,
        // this is only when the user is navigating with the spa.
        // we should have a checkout to whether the user is logged in to content management, but this flag does not exist on the front end, so
        // we had to add  fromState.name !== '' instead that check if leave to Trader to design which angular version to service for direct landing.
        if (settings.frontendManagement && settings.frontendManagement.useAngular2PlusHomepage && toState.name === 'root' && fromState.name !== '') {
            event.preventDefault();
            $window.location.assign('/'); // Go from this SPA to the Angular2+ SPA
        }

        if (fromState.data && fromState.data.onAuthReturnToState) {
            $rootScope.onAuthRedirectedState = $state.get(fromState.data.onAuthReturnToState);
            $rootScope.onAuthRedirectedStateParams = {};
        } else {
            $rootScope.onAuthRedirectedState = fromState;
            $rootScope.onAuthRedirectedStateParams = fromParams;
        }

        if (toState.data && toState.data.authenticate && shopperService.IsGuest) {
            if (angular.isArray(toState.data.authenticate)) {
                $state.shouldAuthenticate(toState, toParams).then(function (requiresLogin) {
                    if (requiresLogin) {
                        promptForLogin(event, toState, toParams);
                    }
                });
            } else {
                promptForLogin(event, toState, toParams);
            }
        }
    });

    $rootScope.$on('$stateChangeSuccess', function () {
        pageMetadataService.useCurrentStateMetadata();

        moveFocus('#body-container', true);
        moveFocus(function () {
            return $('#center-panel h1').filter(':first');
        }, false);
    });

    $rootScope.$on('$locationChangeStart', function (event, newUrl, oldUrl) {
        memoScroll.rememberScrollPosition(oldUrl);
    });

    $rootScope.$on('$locationChangeSuccess', function (event, newUrl) {
        var oldUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        // Only restore the scroll position if the path has changed. This is to prevent
        // jarring scroll position changes when changing sort by options/product filters.
        var hasPathChanged = newUrl.split('?')[0] !== oldUrl.split('?')[0];

        if (!($state.current && $state.current.data && $state.current.data.optOutOfScrollRestore) && (hasPathChanged || $state.current && $state.current.reloadOnSearch)) {
            memoScroll.restoreScrollPosition(newUrl);
        }
    });

    $rootScope.$on('$stateChangeSuccess', function (event, state) {
        if (state.name === 'root') {
            analyticsService.push({ type: analyticsService.mapperTypes.content.general, data: { page: 'root' } });
        }

        if (state.name === 'shop.page') {
            analyticsService.push({ type: analyticsService.mapperTypes.content.general });
        }

        if (startsWith(state.name, 'shop.authentication')) {
            analyticsService.push({
                data: { 'page.Type': 'account' },
                type: analyticsService.mapperTypes.content.general
            });
        }

        if (state.name === 'shop.recipes') {
            analyticsService.push({
                data: { 'page.Type': 'content' },
                type: analyticsService.mapperTypes.content.general
            });
        }

        if (state.name === 'shop.recipes.noSavedRecipes') {
            analyticsService.push({
                data: { recipes: {} },
                type: analyticsService.mapperTypes.content.recipeCategory
            });
        }

        if (state.name === 'shop.recipes.recipenotfound') {
            analyticsService.push({
                data: { recipes: {} },
                type: analyticsService.mapperTypes.content.recipeCategory
            });
        }

        if (state.name === 'shop.list') {
            analyticsService.push({
                data: {
                    'page.Type': 'content',
                    'page.TypeVariation': shopperService.IsGuest ? 'Guest' : 'Logged in'
                },
                type: analyticsService.mapperTypes.content.general
            });
        }
        // define other page type tealium push on route change for e.g. /shop/embedded/new-app
        if (state.name) {
            var pageTypeExceptions = settings.analytics.tealiumPageTypeExceptions;
            if (!some(pageTypeExceptions, function (ex) {
                return startsWith(state.name, ex);
            })) {
                analyticsService.push({
                    data: { 'page.Type': 'other' },
                    type: analyticsService.mapperTypes.content.general
                });
            }
        }
    });

    if (settings.smartBanner.enableSmartBanner === true) {
        // eslint-disable-next-line no-new
        new SmartBanner({
            daysHidden: settings.smartBanner.daysHiddenAfterClose,
            daysReminder: settings.smartBanner.daysHiddenAfterView,
            title: settings.smartBanner.title,
            appStoreLanguage: 'us',
            author: settings.smartBanner.author,
            button: 'VIEW',
            store: {
                ios: settings.smartBanner.appleStore,
                android: settings.smartBanner.googleStore
            },
            price: {
                ios: 'FREE',
                android: 'FREE'
            }
        });

        $rootScope.$on('$stateChangeSuccess', function () {
            if (document.querySelector("meta[name='apple-itunes-app']") === null) {
                return;
            }

            angular.element(document.querySelector("meta[name='apple-itunes-app']")).attr('app-argument', $state.href($state.current.name, $state.params, { absolute: true }));
        });
    }
};

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extend = __webpack_require__(1098);
var q = __webpack_require__(1099);
var doc = __webpack_require__(1100);
var cookie = __webpack_require__(1102);
var ua = __webpack_require__(1103);

// IE < 11 doesn't support navigator language property.
/* global navigator */
var userLangAttribute = navigator.language || navigator.userLanguage || navigator.browserLanguage;
var userLang = userLangAttribute.slice(-2) || 'us';
var root = doc && doc.documentElement;

// platform dependent functionality
var mixins = {
	ios: {
		appMeta: 'apple-itunes-app',
		iconRels: ['apple-touch-icon-precomposed', 'apple-touch-icon'],
		getStoreLink: function () {
			return 'https://itunes.apple.com/' + this.options.appStoreLanguage + '/app/id' + this.appId + "?mt=8";
		}
	},
	android: {
		appMeta: 'google-play-app',
		iconRels: ['android-touch-icon', 'apple-touch-icon-precomposed', 'apple-touch-icon'],
		getStoreLink: function () {
			return 'http://play.google.com/store/apps/details?id=' + this.appId;
		}
	},
	windows: {
		appMeta: 'msApplication-ID',
		iconRels: ['windows-touch-icon', 'apple-touch-icon-precomposed', 'apple-touch-icon'],
		getStoreLink: function () {
			return 'http://www.windowsphone.com/s?appid=' + this.appId;
		}
	}
};

var SmartBanner = function (options) {
	var agent = ua(navigator.userAgent);
	this.options = extend({}, {
		daysHidden: 15,
		daysReminder: 90,
		appStoreLanguage: userLang, // Language code for App Store
		button: 'OPEN', // Text for the install button
		store: {
			ios: 'On the App Store',
			android: 'In Google Play',
			windows: 'In the Windows Store'
		},
		price: {
			ios: 'FREE',
			android: 'FREE',
			windows: 'FREE'
		},
		theme: '', // put platform type ('ios', 'android', etc.) here to force single theme on all device
		icon: '', // full path to icon image if not using website icon image
		force: '', // put platform type ('ios', 'android', etc.) here for emulation

	}, options || {});

	if (this.options.force) {
		this.type = this.options.force;
	} else if (agent.os.name === 'Windows Phone' || agent.os.name === 'Windows Mobile') {
		this.type = 'windows';
	} else if (agent.os.name === 'iOS') {
		this.type = 'ios';
	} else if (agent.os.name === 'Android') {
		this.type = 'android';
	}

	// Don't show banner on ANY of the following conditions:
	// - device os is not supported,
	// - user is on mobile safari for ios 6 or greater (iOS >= 6 has native support for SmartAppBanner)
	// - running on standalone mode
	// - user dismissed banner
	var unsupported = !this.type || !this.options.store[this.type];
	if (unsupported) {
		return;
	}

	this.appMeta = mixins[this.type].appMeta;
	this.parseAppId();

	var isMobileSafari = (this.type === 'ios' && agent.browser.name === 'Mobile Safari' && parseInt(agent.os.version, 10) >= 6);

	var runningStandAlone = navigator.standalone;
	var userDismissed = cookie.get(this.appId + '-smartbanner-closed');
	var userInstalled = cookie.get(this.appId + '-smartbanner-installed');

	if (isMobileSafari || runningStandAlone || userDismissed || userInstalled) {
		return;
	}

	extend(this, mixins[this.type]);

	// - If we dont have app id in meta, dont display the banner
	// - If opened in safari IOS, dont display the banner
	if (!this.appId && agent.os.name === 'IOS' && agent.browser.name === 'Safari') {
		return;
	}

	this.create();
	this.show();
};

SmartBanner.prototype = {
	constructor: SmartBanner,

	create: function () {
		var link = this.getStoreLink();
		var inStore = this.options.price[this.type] + ' - ' + this.options.store[this.type];
		var icon;

		if (this.options.icon) {
			icon = this.options.icon;
		} else {
			for (var i = 0; i < this.iconRels.length; i++) {
				var rel = q('link[rel="' + this.iconRels[i] + '"]');

				if (rel) {
					icon = rel.getAttribute('href');
					break;
				}
			}
		}

		var sb = doc.createElement('div');
		var theme = this.options.theme || this.type;

		sb.className = 'smartbanner smartbanner-' + theme;
		sb.innerHTML = '<div class="smartbanner-container">' +
							'<a href="javascript:void(0);" class="smartbanner-close">&times;</a>' +
							'<span class="smartbanner-icon" style="background-image: url(' + icon + ')"></span>' +
							'<div class="smartbanner-info">' +
								'<div class="smartbanner-title">' + this.options.title + '</div>' +
								'<div>' + this.options.author + '</div>' +
								'<span>' + inStore + '</span>' +
							'</div>' +
							'<a href="' + link + '" class="smartbanner-button">' +
								'<span class="smartbanner-button-text">' + this.options.button + '</span>' +
							'</a>' +
						'</div>';

		// there isn’t neccessary a body
		if (doc.body) {
			doc.body.appendChild(sb);
		}		else if (doc) {
			doc.addEventListener('DOMContentLoaded', function () {
				doc.body.appendChild(sb);
			});
		}

		q('.smartbanner-button', sb).addEventListener('click', this.install.bind(this), false);
		q('.smartbanner-close', sb).addEventListener('click', this.close.bind(this), false);
	},
	hide: function () {
		root.classList.remove('smartbanner-show');

		if (typeof this.options.close === 'function') {
			return this.options.close();
		}
	},
	show: function () {
		root.classList.add('smartbanner-show');
		if (typeof this.options.show === 'function') {
			return this.options.show();
		}
	},
	close: function () {
		this.hide();
		cookie.set(this.appId + '-smartbanner-closed', 'true', {
			path: '/',
			expires: new Date(Number(new Date()) + (this.options.daysHidden * 1000 * 60 * 60 * 24))
		});
		if (typeof this.options.close === 'function') {
			return this.options.close();
		}
	},
	install: function () {
		this.hide();
		cookie.set(this.appId + '-smartbanner-installed', 'true', {
			path: '/',
			expires: new Date(Number(new Date()) + (this.options.daysReminder * 1000 * 60 * 60 * 24))
		});
		if (typeof this.options.close === 'function') {
			return this.options.close();
		}
	},
	parseAppId: function () {
		var meta = q('meta[name="' + this.appMeta + '"]');
		if (!meta) {
			return;
		}

		if (this.type === 'windows') {
			this.appId = meta.getAttribute('content');
		} else {
			this.appId = /app-id=([^\s,]+)/.exec(meta.getAttribute('content'))[1];
		}

		return this.appId;
	}
};

module.exports = SmartBanner;


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 1099 */
/***/ (function(module, exports) {

function one(selector, el) {
  return el.querySelector(selector);
}

exports = module.exports = function(selector, el){
  el = el || document;
  return one(selector, el);
};

exports.all = function(selector, el){
  el = el || document;
  return el.querySelectorAll(selector);
};

exports.engine = function(obj){
  if (!obj.one) throw new Error('.one callback required');
  if (!obj.all) throw new Error('.all callback required');
  one = obj.one;
  exports.all = obj.all;
  return exports;
};


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @module  get-doc
 */

var hasDom = __webpack_require__(1101);

module.exports = hasDom() ? document : null;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function () {
	return typeof window !== 'undefined'
		&& typeof document !== 'undefined'
		&& typeof document.createElement === 'function';
};


/***/ }),
/* 1102 */
/***/ (function(module, exports) {

var exports = module.exports = function (doc) {
    if (!doc) doc = {};
    if (typeof doc === 'string') doc = { cookie: doc };
    if (doc.cookie === undefined) doc.cookie = '';
    
    var self = {};
    self.get = function (key) {
        var splat = doc.cookie.split(/;\s*/);
        for (var i = 0; i < splat.length; i++) {
            var ps = splat[i].split('=');
            var k = unescape(ps[0]);
            if (k === key) return unescape(ps[1]);
        }
        return undefined;
    };
    
    self.set = function (key, value, opts) {
        if (!opts) opts = {};
        var s = escape(key) + '=' + escape(value);
        if (opts.expires) s += '; expires=' + opts.expires;
        if (opts.path) s += '; path=' + escape(opts.path);
        if (opts.domain) s += '; domain=' + escape(opts.domain);
        if (opts.secure) s += '; secure';
        doc.cookie = s;
        return s;
    };
    return self;
};

if (typeof document !== 'undefined') {
    var cookie = exports(document);
    exports.get = cookie.get;
    exports.set = cookie.set;
}


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.19
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 or MIT
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.19',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            //var result = {},
            var i = 0, j, k, p, q, matches, match;//, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            // console.log(this);
            //return this;
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
            ], [NAME, VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge|edgios|edga)\/((\d+)?[\w\.]+)/i                              // Microsoft Edge
            ], [[NAME, 'Edge'], VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /(focus)\/([\w\.]+)/i                                               // Firefox Focus
            ], [[NAME, 'Firefox Focus'], VERSION], [

            /(opt)\/([\w\.]+)/i                                                 // Opera Touch
            ], [[NAME, 'Opera Touch'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i         // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(brave)\/([\w\.]+)/i                                              // Brave browser
            ], [[NAME, 'Brave'], VERSION], [

            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
            ], [NAME, VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /(BIDUBrowser)[\/\s]?([\w\.]+)/i                                    // Baidu Browser
            ], [NAME, VERSION], [

            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
            ], [NAME, VERSION], [

            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
            ], [NAME], [

            /(LBBROWSER)/i                                      // LieBao Browser
            ], [NAME], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
            /android.+(line)\/([\w\.]+)\/iab/i                                  // Line App for Android
            ], [NAME, VERSION], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]

            /* /////////////////////
            // Media players BEGIN
            ////////////////////////

            , [

            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
            /(coremedia) v((\d+)[\w\._]+)/i
            ], [NAME, VERSION], [

            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
            ], [NAME, VERSION], [

            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
            ], [NAME, VERSION], [

            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
            ], [NAME, VERSION], [
            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
            ], [NAME, VERSION], [

            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
            ], [[NAME, 'Flip Player'], VERSION], [

            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
            ], [NAME], [

            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                // Gstreamer
            ], [NAME, VERSION], [

            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                // Java/urllib/requests/wget/cURL
            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
            ], [NAME, VERSION], [

            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
            ], [[NAME, /_/g, ' '], VERSION], [

            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                // MPlayer SVN
            ], [NAME, VERSION], [

            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
            ], [NAME, VERSION], [

            /(mplayer)/i,                                                       // MPlayer (no other info)
            /(yourmuze)/i,                                                      // YourMuze
            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
            ], [NAME], [

            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
            ], [NAME, VERSION], [

            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
            ], [NAME, VERSION], [

            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
            ], [NAME, VERSION], [

            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
            /(winamp)\s((\d+)[\w\.-]+)/i,
            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
            ], [NAME, VERSION], [

            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                // inlight radio
            ], [NAME], [

            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                // SoundTap/Totem/Stagefright/Streamium
            ], [NAME, VERSION], [

            /(smp)((\d+)[\d\.]+)/i                                              // SMP
            ], [NAME, VERSION], [

            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
            /(vlc)\/((\d+)[\w\.-]+)/i,
            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
            ], [NAME, VERSION], [

            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
            /(windows-media-player)\/((\d+)[\w\.-]+)/i
            ], [[NAME, /-/g, ' '], VERSION], [

            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                // Windows Media Server
            ], [VERSION, [NAME, 'Windows']], [

            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
            ], [NAME, VERSION], [

            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
            ], [[NAME, 'rad.io'], VERSION]

            //////////////////////
            // Media players END
            ////////////////////*/

        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
            /android.+aft([bms])\sbuild/i                                       // Fire TV
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
            /(zte)-(\w*)/i,                                                     // ZTE
            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]*)/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)[\s)]/i                                       // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel( [23])?( xl)?)\s/i                              // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [
            /(mz)-([\w-]{2,})/i                                                 // Meizu Phone
            ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [

            /android.+a000(1)\s+build/i,                                        // OnePlus
            /android.+oneplus\s(a\d{4})\s+build/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+;\s(PH-1)\s/i
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]


        /*//////////////////////////
            // TODO: move to string map
            ////////////////////////////

            /(C6603)/i                                                          // Sony Xperia Z C6603
            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /(C6903)/i                                                          // Sony Xperia Z 1
            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

            /(T3C)/i                                                            // Advan Vandroid T3C
            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

            /(V972M)/i                                                          // ZTE V972M
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

            /////////////
            // END TODO
            ///////////*/

        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i                                              // Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i                                                // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
        //var browser = new Browser();
        //var cpu = new CPU();
        //var device = new Device();
        //var engine = new Engine();
        //var os = new OS();

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };
    //UAParser.Utils = util;

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        // TODO: test!!!!!!!!
        /*
        if (require && require.main === module && process) {
            // cli
            var jsonize = function (arr) {
                var res = [];
                for (var i in arr) {
                    res.push(new UAParser(arr[i]).getResult());
                }
                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
            };
            if (process.stdin.isTTY) {
                // via args
                jsonize(process.argv.slice(2));
            } else {
                // via pipe
                var str = '';
                process.stdin.on('readable', function() {
                    var read = process.stdin.read();
                    if (read !== null) {
                        str += read;
                    }
                });
                process.stdin.on('end', function () {
                    jsonize(str.replace(/\n$/, '').split('\n'));
                });
            }
        }
        */
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(1104)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 1104 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var getSystemEnvironment = function getSystemEnvironment(breakpointsService) {
    if (breakpointsService.isInLargeFormat) {
        return 'Desktop';
    } else if (breakpointsService.isInMediumFormat) {
        return 'Tablet';
    }

    return 'Mobile';
};

var PageAnalytics = function () {
    function PageAnalytics(analytics, $rootScope, $location, $window, $document, breakpointsService, shopperService, shopperAnalytics) {
        _classCallCheck(this, PageAnalytics);

        this.analytics = analytics;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$window = $window;
        this.$document = $document;
        this.breakpointsService = breakpointsService;
        this.shopperService = shopperService;
        this.shopperAnalytics = shopperAnalytics;
    }

    _createClass(PageAnalytics, [{
        key: 'setupPageChangeWatchers',
        value: function setupPageChangeWatchers() {
            var _this = this;

            /**
             * Location Change Success event is fired once on actual page reload.
             */
            this.$rootScope.$on('$locationChangeSuccess', function (e, toUrl, fromUrl) {
                // Update Page Analytics.
                _this.push(toUrl, fromUrl);
            });
        }
    }, {
        key: 'push',
        value: function push(toUrl, fromUrl) {
            var analyticsPageInfoData = {
                sysEnv: getSystemEnvironment(this.breakpointsService),
                variant: this.$window.navigator.userAgent,
                language: this.$window.navigator.language,
                toUrl: toUrl,
                fromUrl: toUrl === fromUrl ? this.$document[0].referrer : fromUrl
            };

            this.analytics.push({ data: analyticsPageInfoData, type: this.analytics.mapperTypes.seo.pageInfo });
        }
    }]);

    return PageAnalytics;
}();

module.exports = PageAnalytics;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (pageAnalytics, settings) {
    if (!settings.analytics || !settings.analytics.useDtm) return;
    pageAnalytics.setupPageChangeWatchers();
    pageAnalytics.push();
};

/***/ })
],[872]);


// WEBPACK FOOTER //
// wowapp.6324d502644ec0daf5a3.bundle.js